import * as React from 'react';
import React__default, { useCallback, useState, useEffect, useMemo, useRef, Fragment, forwardRef, createElement, Suspense, useLayoutEffect } from 'react';
import { P as Panel, S as Skeleton, u as useElementWidth, a as SkeletonContainer, b as Skeleton$1, c as createClassName, T as Text, i as isNumeric, f as faInfoCircleExports, r as requireAssertString, d as alpha$1 } from './chunks/SkeletonContainer-3c6bc430.js';
import { c as classNames, r as resolveProps, P as PropTypes, _ as _extends, T as ThemeContext$2, D as DefaultPropsProvider, u as useStrings, a as useFeatureToggles, g as getOldLookUrl, b as useTypedDispatch, d as useContext, e as useLocation, f as useTypedSelector, s as selectLocale, h as selectIsAuthRevoked, q as queryString, i as clearAuthRevoked, j as setPostAuthRedirectUrl, k as getSsoAuthUrl, l as getAuthUrl, m as useOnlineStatus, n as getRegisterUrl, o as useNavigation, p as selectIsLoggedIn, t as useUpdateUserDetailsMutation, v as useShowLoadingIndicator, w as isPersonalUserDetails, x as isBusinessUserDetails, y as isEmployeeUserDetails, z as getUserDetailsForUserType, A as useChangePasswordMutation, B as useSupportedBaseLanguages, C as useGetUserRolesQuery, E as useUpdatePreferencesMutation, F as defaultTheme, G as THEME_ID, H as _objectWithoutPropertiesLoose, I as selectCurrentUser, J as useGetTwoFactorAuthStatusQuery, K as queryExports, L as useGetUserDetailsQuery, R as Routes, M as Route, N as useResolvedPath, O as Link, Q as FontAwesomeIcon, S as useDeleteUserMutation, U as __awaiter, V as logOut, W as joinPath, X as styled, Y as colorManipulatorExports, Z as useDefaultProps, $ as clsx$1, a0 as composeClasses, a1 as useDeleteTrustedDeviceMutation, a2 as queueNotification, a3 as generateUtilityClass, a4 as generateUtilityClasses, a5 as duration, a6 as useVinResolver, a7 as Link$1, a8 as getVinReference, a9 as filterFalse, aa as useGetUserSubscriptionsQuery, ab as selectCurrentVehicle, ac as getVehicleSpecificity, ad as getGlobalSpecificity, ae as useChangeEmailMutation, af as useChangeEmailSendVerificationMutation, ag as useChangeEmailCancellationMutation, ah as capitalize, ai as useGetUserLegalEmployeesQuery, aj as useEnableUserLegalEmployeeMutation, ak as useDisableUserLegalEmployeeMutation, al as rootShouldForwardProp, am as useSetUserLegalEmployeesMutation, an as useGetPreferencesQuery, ao as Navigate, ap as useRequestSubscriptionPurchaseApprovalMutation, aq as getDefaultExportFromCjs, ar as usePurchaseSubscriptionMutation, as as usePurchaseUserSubscriptionMutation, at as isApiValidationError, au as useParams, av as useGetUserSubscriptionQuery, aw as useGetSubscriptionPriceQuery, ax as useLazyGetVprTokenQuery, ay as useLazyGetTextFromImageQuery, az as getVehicleId, aA as useLazyGetVehiclesByVinQuery, aB as useNavigate, aC as getOptionalLanguageCode, aD as getPrimaryLanguageCode, aE as isFetchBaseQueryError, aF as v4, aG as selectProduct, aH as selectProductChildren, aI as selectProductYears, aJ as selectSelectedProductYear, aK as selectProductLookupPathLoadingIndex, aL as setSelectedYear, aM as selectProductLookupPath, aN as selectSelectableProduct, aO as selectProductLookupType, aP as updateProductLookupPath, aQ as LinkButton, aR as useSetFavouriteVehicleMutation, aS as useDeleteRecentLookupMutation, aT as useLazyGetVehicleHistoryQuery, aU as keyframes, aV as css, aW as showNotice, aX as useGetTopNoticesQuery, aY as UndoActionTypes, aZ as useGetImportantDocumentsQuery, a_ as useGetTopFavouriteContentQuery, a$ as useLazyGetDocumentsQuery, b0 as useGetDocumentGroupsQuery, b1 as clearCurrentVehicle, b2 as useGetFrequentlyUsedDocumentsQuery, b3 as objectEntries, b4 as requirePropTypes, b5 as commonjsGlobal, b6 as requireClassnames, b7 as selectIsBannerHidden, b8 as useGetBannersQuery, b9 as skipToken, ba as hideBanner, bb as createResponsiveValue, bc as MOBILE_BREAKPOINT, bd as useGetSubscriptionPricesQuery, be as useGetDocumentMetadataQuery, bf as getVehicleDisplayName, bg as getDocumentSpecificity, bh as useGetDocumentQuery, bi as hasProperty, bj as selectActiveSearchParams, bk as getBooleanOrDefault, bl as getStringOrDefault, bm as normaliseLocaleCode, bn as useCurrentLanguage, bo as selectSearchOptions, bp as useIsLoadingWithDifferentKey, bq as userApi, br as mergeRefs, bs as useSearchDocumentsQuery, bt as setActiveSearchParams, bu as selectOverridingLocale, bv as getUnionStringOrDefault, bw as updateSearchOptions, bx as clearDocumentSearch, by as embargoFilters, bz as selectMessagesSortOrder, bA as selectMessagesPageNumber, bB as useGetMessagesQuery, bC as useMarkMessagesMutation, bD as useDeleteMessagesMutation, bE as setMessagesPageNumber, bF as setMessagesSortOrder, bG as getProductReference, bH as isObject, bI as useGetMessageQuery, bJ as clearMessagesPage, bK as useGetDocumentsQuery, bL as useGetServiceHistoryQuery, bM as useGetVehicleHistoryQuery, bN as useGetHyperlinksQuery, bO as isSameVehicle, bP as selectFavouriteContentSortOrder, bQ as useGetFavouriteContentQuery, bR as setFavouriteContentSortOrder, bS as useGetVehicleQuery, bT as makeSessionVehicle, bU as matchPath, bV as useGetVehicleByCodeQuery, bW as useGetNoticesQuery, bX as useGetLegalDocumentContentQuery, bY as getLocaleCode, bZ as updateLocale, b_ as getVersionInfo, b$ as focusDocumentSearch, c0 as useGetDocumentSearchSuggestionsQuery, c1 as useGetUserSearchHistoryQuery, c2 as selectFocusDocumentSearch, c3 as clearFocusDocumentSearch, c4 as useGetUserStatusQueryState, c5 as showGlobalIndicator, c6 as hideGlobalIndicator, c7 as showHelp, c8 as useNavigationChangeListener, c9 as logIn, ca as takePostAuthRedirectUrl, cb as isMobile, cc as useGetDocumentHistoryQuery, cd as selectShowDocumentInfoDocument, ce as showDocumentInfo, cf as selectShowNoticeId, cg as useGetNoticeQuery, ch as selectNextNotification, ci as removeNotification, cj as clearTokens, ck as authenticate, cl as loadSessionVehicle, cm as useGetUserStatusQuery, cn as selectCurrentHelpKey, co as selectShowHelp, cp as useHelpStrings, cq as hideHelp, cr as __rest, cs as useLazyGetUserStateTokenQuery, ct as getItisUrl, cu as selectIsFullScreen, cv as changeIsFullScreen, cw as useSetTermsAgreementMutation, cx as useGetTermsAgreementQuery, cy as useGetUserSearchSuggestionQuery, cz as selectShowShareLinkFormParams, cA as useSendShareLinkMutation, cB as useLazyApplicabilityCheckQuery, cC as useDeepLinkUrlProvider, cD as showDocumentShareLinkForm, cE as getDocumentDownloadUrl, cF as selectOverriddenLocale, cG as overrideLocale, cH as restoreLocale, cI as getAccessToken, cJ as showDocumentAttachments, cK as selectShowDocumentAttachmentsDocument, cL as useUpdateAddressCountryMutation, cM as isNonProdEnvironment, cN as createTheme, cO as useGlobalLoadingIndicator, cP as FALLBACK_LOCALE, cQ as DEFAULT_SESSION_LENGTH_MILLIS, cR as updateSessionExpiry, cS as hasSessionExpired, cT as revokeAuth, cU as SESSION_EXPIRY_CHECK_MILLIS, cV as Properties, cW as ItisContextProvider, cX as createStore, cY as StringsProvider, cZ as BrowserRouter, c_ as ExternalContextProvider } from './chunks/responsive-b521ac2b.js';
export { d0 as apiBaseQuery, c$ as useIwaContext, d1 as useModuleContext } from './chunks/responsive-b521ac2b.js';
import { u as usePageTitle, f as faChevronRightExports, N as NotFoundScreen, a as faEditExports } from './chunks/faFile-16ac2d40.js';
import { B as ButtonLink, u as useHelp, a as useCountryNames, b as useTextBox, g as getUserExtendedDisplayName, c as useForm, T as Typography, f as faStarExports, d as useDocumentActions, e as faStarExports$1, D as DocumentLabels, h as DocumentLabel, I as InfoText, i as useDocumentBackUrl, j as useContextVehicle, k as DocumentScreen, l as useLanguageNames, m as usePluralStrings, n as useDebounce, o as ButtonBar, r as require$$2, C as CSSTransition, p as useIsQrCodesEnabled, q as faQrcodeExports, V as VehicleInformationImage, s as VehicleInformationDefinitionList, F as FeaturesTable, Q as QrCodeDialogue, t as VehicleContextProvider, v as useSwipeGesture, S as SidebarToggle, w as faArrowUpExports, x as useDebouncedValue, y as getUserDisplayName, z as screenfull, A as VehiclePopupToggle, E as VehiclePopupDialog, G as useThrottle, H as useTextArea, J as useDocumentViewUrl, K as getProcedureFragment, L as i18nIsoCountriesExports, M as faDownloadExports } from './chunks/DocumentScreen-0d4d5032.js';
export { N as TextArea, O as TextBox } from './chunks/DocumentScreen-0d4d5032.js';
import { D as DateTime, a as DateText, u as useApiErrorMessage, b as apiValidationErrorMessage, S as SwitchBase, c as createSvgIcon, d as useControlled, M as MuiPopper, e as useFormControl, F as FormControlContext, f as useDateText, t as toInt, I as Info } from './chunks/errorMessages-7c43ebaa.js';
import { u as useTheme$1, a as useTheme$2, b as useEnhancedEffect, e as exactProp, R as RtlProvider, I as IconButton$2, f as faTimesExports, T as Transition, c as useTheme$3, d as useTimeout, g as useForkRef, h as elementTypeAcceptingRef, i as getTransitionProps, r as refType, B as ButtonBase, j as useId, k as useEventCallback, s as setRef, l as chainPropTypes, C as CircularProgress, m as useOnMobile, n as useRtl, o as useSlotProps, p as TransitionGroup, q as ownerDocument, t as extractEventHandlers, v as getReactElementRef, w as elementAcceptingRef, G as Grow } from './chunks/mediaQueries-6282b8d3.js';
import { u as useModuleSsoConfig, S as Screen, C as ContentHeader, a as ContentHeaderSkeleton, R as RouteAccess, b as useModuleDocumentActions, T as TableSkeleton, l as loadingToken, c as useModuleDocumentCoverPages, D as DocumentScreenSkeleton, d as useDocumentGroupMatch, e as useModuleVehicleTabs, f as CentredMessage, g as DocumentSkeleton, h as useModuleSidebarItems, i as useModuleVehicleSidebarItems, j as useModuleAccountMenuItems, k as useModuleHeaderItems, m as useModuleDealerName, n as Centred, o as useModuleAuthRevokeStrategy, p as useModuleLogOut, q as useModuleRelayState, r as useModuleVehicleChanged } from './chunks/DocumentScreenSkeleton-1f9d5851.js';
import { P as PanelGrid } from './chunks/PanelGrid-ae2fac5f.js';
import { B as Button$2 } from './chunks/Button-52913e46.js';
import { u as useInput, a as useTickBox, v as validateAll, T as TickBox } from './chunks/TickBox-593521dc.js';
import { i as isNotEmpty, a as isLength, b as isNonRequiredLength, c as isNot, d as isSame, D as DefinitionList, e as isEmail, f as isNumberOrNumberWithSpaces, r as requireMerge, g as isTruthy } from './chunks/DefinitionList-585ed930.js';
import { S as Select, F as FormField, i as inputClasses, a as inputBaseClasses, o as outlinedInputClasses, f as filledInputClasses, A as ArrowDropDownIcon$1, b as formControlState, c as isAdornedStart, d as isFilled, e as Select$1, I as Input, g as FilledInput, O as OutlinedInput, u as useSelect, h as ServiceRecordText, j as faSignOutAltExports } from './chunks/faSignOutAlt-21d4fecc.js';
import { D as Dialogue, g as getDividerUtilityClass, L as ListContext, a as getListItemIconUtilityClass, P as Paper, i as integerPropType, b as Popover, M as Menu, c as MenuItem, F as Fade, d as debounce, o as ownerWindow, r as reactIsExports } from './chunks/MenuItem-5407b5eb.js';
import { T as Table, E as EmptyTableRow, C as ConfirmDialogue, f as faCaretDownExports, a as TableRowSkeleton } from './chunks/ConfirmDialogue-ecdb4852.js';
import { f as faChevronDownExports, u as usePreviousProps, B as Badge, H as HeaderButton } from './chunks/HeaderButton-3bb7c594.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { u as usePaginator, P as Pagination, M as MobileTableCell } from './chunks/MobileTableCell-4356bc12.js';
import { shallowEqual, Provider } from 'react-redux';
import 'react-dom';
import './chunks/faComments-c953b360.js';

const WelcomePanel = ({ title, description, button, className }) => {
    const classes = classNames('WelcomePanel', className);
    return React__default.createElement(Panel, { className: classes },
        React__default.createElement(Panel.Header, { title: title }),
        React__default.createElement(Panel.Content, null,
            React__default.createElement("p", null, description),
            button));
};

const FOREVER = Symbol('FOREVER');
/**
 * Hook to handle the dismissal of UI elements for a specified duration, or forever.
 * If dismissed forever, {@link Dismiss.undismiss} can be used to restore the element.
 *
 * @param key - Key used to store the dismiss date in local storage.
 * @param duration - A {@link luxon.Duration}, number of milliseconds, or {@link FOREVER}.
 * @returns A {@link Dismiss} object.
 */
function useDismiss(key, duration) {
    const getDismissState = useCallback(() => {
        const dismissDateString = localStorage.getItem(key);
        if (dismissDateString) {
            const dismissDate = DateTime.fromISO(dismissDateString);
            if (dismissDate.isValid && (duration === FOREVER || dismissDate.plus(duration) > DateTime.now())) {
                return true;
            }
            localStorage.removeItem(key);
        }
        return false;
    }, [key, duration]);
    const [isDismissed, setIsDismissed] = useState(getDismissState());
    const updateDismissDate = useCallback(() => setIsDismissed(getDismissState), [getDismissState]);
    useEffect(() => {
        updateDismissDate();
    }, [updateDismissDate]);
    return useMemo(() => ({
        isDismissed,
        dismiss: () => {
            localStorage.setItem(key, DateTime.now().toISO());
            updateDismissDate();
        },
        undismiss: () => {
            localStorage.removeItem(key);
            updateDismissDate();
        }
    }), [isDismissed, key, updateDismissDate]);
}

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return resolveProps(theme.components[name].defaultProps, props);
}

function useThemeProps$1({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = useTheme$1(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}

/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const [match, setMatch] = React.useState(() => {
    if (noSsr && matchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }

    // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.
    return defaultMatches;
  });
  useEnhancedEffect(() => {
    let active = true;
    if (!matchMedia) {
      return undefined;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    // TODO: Use `addEventListener` once support for Safari < 14 is dropped
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match;
}

// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = React['useSyncExternalStore' + ''];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const getDefaultSnapshot = React.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = React.useMemo(() => {
    if (noSsr && matchMedia) {
      return () => matchMedia(query).matches;
    }
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  const [getSnapshot, subscribe] = React.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}
function useMediaQuery(queryInput, options = {}) {
  const theme = useTheme$2();
  // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr = false
  } = getThemeProps({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });
  if (process.env.NODE_ENV !== 'production') {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['MUI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }
  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, '');

  // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue({
      query,
      match
    });
  }
  return match;
}

function isMuiElement(element, muiNames) {
  var _muiName, _element$type;
  return /*#__PURE__*/React.isValidElement(element) && muiNames.indexOf( // For server components `muiName` is avaialble in element.type._payload.value.muiName
  // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
  // eslint-disable-next-line no-underscore-dangle
  (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}

// Source from https://github.com/alitaheri/normalize-scroll-left
let cachedType;

/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */
function detectScrollType() {
  if (cachedType) {
    return cachedType;
  }
  const dummy = document.createElement('div');
  const container = document.createElement('div');
  container.style.width = '10px';
  container.style.height = '1px';
  dummy.appendChild(container);
  dummy.dir = 'rtl';
  dummy.style.fontSize = '14px';
  dummy.style.width = '4px';
  dummy.style.height = '1px';
  dummy.style.position = 'absolute';
  dummy.style.top = '-1000px';
  dummy.style.overflow = 'scroll';
  document.body.appendChild(dummy);
  cachedType = 'reverse';
  if (dummy.scrollLeft > 0) {
    cachedType = 'default';
  } else {
    dummy.scrollLeft = 1;
    if (dummy.scrollLeft === 0) {
      cachedType = 'negative';
    }
  }
  document.body.removeChild(dummy);
  return cachedType;
}

// Based on https://stackoverflow.com/a/24394376
function getNormalizedScrollLeft(element, direction) {
  const scrollLeft = element.scrollLeft;

  // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
  if (direction !== 'rtl') {
    return scrollLeft;
  }
  const type = detectScrollType();
  switch (type) {
    case 'negative':
      return element.scrollWidth - element.clientWidth + scrollLeft;
    case 'reverse':
      return element.scrollWidth - element.clientWidth - scrollLeft;
    default:
      return scrollLeft;
  }
}

const ThemeContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}
var ThemeContext$1 = ThemeContext;

function useTheme() {
  const theme = React.useContext(ThemeContext$1);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }
  return theme;
}

const hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    const mergedTheme = localTheme(outerTheme);
    if (process.env.NODE_ENV !== 'production') {
      if (!mergedTheme) {
        console.error(['MUI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }
    return mergedTheme;
  }
  return _extends({}, outerTheme, localTheme);
}

/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
function ThemeProvider$2(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = useTheme();
  if (process.env.NODE_ENV !== 'production') {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }
  const theme = React.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
    if (output != null) {
      output[nested] = outerTheme !== null;
    }
    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/jsx(ThemeContext$1.Provider, {
    value: theme,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes) : void 0;
}

const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
  return React.useMemo(() => {
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    if (typeof localTheme === 'function') {
      const mergedTheme = localTheme(resolvedTheme);
      const result = themeId ? _extends({}, upperTheme, {
        [themeId]: mergedTheme
      }) : mergedTheme;
      // must return a function for the private theme to NOT merge with the upper theme.
      // see the test case "use provided theme from a callback" in ThemeProvider.test.js
      if (isPrivate) {
        return () => result;
      }
      return result;
    }
    return themeId ? _extends({}, upperTheme, {
      [themeId]: localTheme
    }) : _extends({}, upperTheme, localTheme);
  }, [themeId, upperTheme, localTheme, isPrivate]);
}

/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */
function ThemeProvider$1(props) {
  const {
    children,
    theme: localTheme,
    themeId
  } = props;
  const upperTheme = useTheme$2(EMPTY_THEME);
  const upperPrivateTheme = useTheme() || EMPTY_THEME;
  if (process.env.NODE_ENV !== 'production') {
    if (upperTheme === null && typeof localTheme === 'function' || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === 'function') {
      console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }
  const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
  const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
  const rtlValue = engineTheme.direction === 'rtl';
  return /*#__PURE__*/jsx(ThemeProvider$2, {
    theme: privateTheme,
    children: /*#__PURE__*/jsx(ThemeContext$2.Provider, {
      value: engineTheme,
      children: /*#__PURE__*/jsx(RtlProvider, {
        value: rtlValue,
        children: /*#__PURE__*/jsx(DefaultPropsProvider, {
          value: engineTheme == null ? void 0 : engineTheme.components,
          children: children
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: PropTypes.string
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes = exactProp(ThemeProvider$1.propTypes) : void 0;
}

function useNewLookPanelDismiss() {
    return useDismiss('newLookPanelDismissDate', FOREVER);
}
const NewLookPanel = ({ allowDismiss }) => {
    const { welcome: strings, buttons: buttonStrings } = useStrings();
    const isTryingNewLook = useFeatureToggles().isFeatureToggleEnabled('TRY_NEW_LOOK');
    const { isDismissed, dismiss } = useNewLookPanelDismiss();
    if (!isTryingNewLook || (allowDismiss && isDismissed)) {
        return null;
    }
    return React__default.createElement(Panel, { className: "NewLookPanel" },
        React__default.createElement(Panel.Content, null,
            React__default.createElement("div", { className: "NewLookPanel-content" },
                React__default.createElement("div", null,
                    React__default.createElement("h3", null, strings.newLook.title),
                    React__default.createElement("p", null, strings.newLook.description)),
                React__default.createElement(ButtonLink, { href: getOldLookUrl(), preventIfOffline: true }, strings.newLook.button)),
            allowDismiss && React__default.createElement(IconButton$2, { icon: faTimesExports.faTimes, iconSize: "lg", title: buttonStrings.hide, onClick: dismiss })));
};

const ssoAuthUrlError = 'authorisedDealerAccessUrl or ssoUrlResolver is not set';
function useLogin() {
    var _a;
    const dispatch = useTypedDispatch();
    const { auth: strings } = useStrings();
    const { authClientId, basePath, authorisedDealerAccessUrl } = useContext();
    const { search } = useLocation();
    const locale = useTypedSelector(selectLocale);
    const isAuthRevoked = useTypedSelector(selectIsAuthRevoked);
    const ssoUrl = ((_a = useModuleSsoConfig()) === null || _a === void 0 ? void 0 : _a.url) || authorisedDealerAccessUrl;
    const getQueryParam = useCallback((param) => {
        const queryParam = queryString.parse(search)[param];
        return typeof queryParam === 'string' ? queryParam : '';
    }, [search]);
    const redirect = getQueryParam('redirect');
    useEffect(() => {
        return () => {
            dispatch(clearAuthRevoked());
        };
    }, [dispatch]);
    const loginMessage = useMemo(() => {
        const ssoError = getQueryParam('sso-error') === 'true';
        const ssoErrorMessage = getQueryParam('sso-error-message');
        if (ssoErrorMessage) {
            return ssoErrorMessage;
        }
        else if (ssoError) {
            return strings.ssoError;
        }
        else if (isAuthRevoked) {
            return strings.loggedOut;
        }
        else if (redirect) {
            return strings.needLogIn;
        }
        return null;
    }, [isAuthRevoked, strings.loggedOut, strings.needLogIn, strings.ssoError, getQueryParam, redirect]);
    return useMemo(() => ({
        logIn: ({ redirectUrl, sso } = {}) => {
            setPostAuthRedirectUrl(redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : redirect);
            let authUrl;
            if (sso) {
                if (!ssoUrl) {
                    throw new Error(ssoAuthUrlError);
                }
                authUrl = getSsoAuthUrl(ssoUrl, authClientId, redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : redirect);
            }
            else {
                authUrl = getAuthUrl(authClientId, locale, basePath);
            }
            window.location.assign(authUrl);
        },
        loginMessage,
        isSsoEnabled: Boolean(ssoUrl),
        redirectQueryParameter: redirect !== '' ? redirect : undefined
    }), [authClientId, locale, basePath, loginMessage, redirect, ssoUrl]);
}

const LoginButton = ({ sso, title, returnUrl }) => {
    const { welcome: strings, auth: authStrings } = useStrings();
    const { ifOnline } = useOnlineStatus();
    const { logIn, isSsoEnabled } = useLogin();
    const location = useLocation();
    if (sso && !isSsoEnabled) {
        return null;
    }
    const redirectUrl = returnUrl !== null && returnUrl !== void 0 ? returnUrl : location.pathname + location.search + location.hash;
    return React__default.createElement(Button$2, { onClick: () => ifOnline(() => logIn({
            sso,
            redirectUrl
        }), strings.cannotLogInOffline) }, title !== null && title !== void 0 ? title : (sso
        ? strings.authorisedDealers.button
        : isSsoEnabled
            ? strings.independentOperators.button
            : authStrings.logInButton));
};

const RegisterButton = () => {
    const { welcome: strings } = useStrings();
    const locale = useTypedSelector(selectLocale);
    return React__default.createElement(ButtonLink, { href: getRegisterUrl(locale), preventIfOffline: strings.cannotRegisterOffline }, strings.register.button);
};

const WelcomeScreen = () => {
    var _a, _b;
    const { welcome: strings } = useStrings();
    const { auth: authStrings } = useStrings();
    const navigation = useNavigation();
    const { loginMessage, redirectQueryParameter, isSsoEnabled } = useLogin();
    const loginReturnUrl = redirectQueryParameter !== null && redirectQueryParameter !== void 0 ? redirectQueryParameter : navigation.home();
    const mandatoryLogin = useFeatureToggles().isFeatureToggleEnabled('MANDATORY_LOGIN');
    const awsCognitoLogin = useFeatureToggles().isFeatureToggleEnabled('AWS_COGNITO_AUTHENTICATION');
    const ssoConfig = useModuleSsoConfig();
    usePageTitle(strings.title);
    useHelp('home');
    const classes = classNames('WelcomeScreen', {
        'WelcomeScreen-twoColumns': isSsoEnabled || !mandatoryLogin,
        'WelcomeScreen-threeColumns': isSsoEnabled && !mandatoryLogin
    });
    return React__default.createElement(Screen, { className: classes },
        React__default.createElement(PanelGrid, { className: "WelcomeScreen-infoPanelGrid", singleColumn: true },
            loginMessage && React__default.createElement(Panel, { variant: "info" },
                React__default.createElement(Panel.Content, null, loginMessage)),
            React__default.createElement(NewLookPanel, null)),
        awsCognitoLogin && React__default.createElement(PanelGrid, { className: "WelcomeScreen-panelGrid" },
            React__default.createElement(WelcomePanel, { title: authStrings.logInButton, description: authStrings.needLogIn, button: React__default.createElement(LoginButton, { returnUrl: loginReturnUrl }) }),
            !mandatoryLogin && React__default.createElement(WelcomePanel, { title: strings.customerLookup.title, description: strings.customerLookup.description, button: React__default.createElement(ButtonLink, { href: "/lookup" }, strings.customerLookup.button) })),
        !awsCognitoLogin && React__default.createElement(PanelGrid, { className: "WelcomeScreen-panelGrid" },
            isSsoEnabled && React__default.createElement(WelcomePanel, { title: (_a = ssoConfig === null || ssoConfig === void 0 ? void 0 : ssoConfig.panelTitle) !== null && _a !== void 0 ? _a : strings.authorisedDealers.title, description: (_b = ssoConfig === null || ssoConfig === void 0 ? void 0 : ssoConfig.panelText) !== null && _b !== void 0 ? _b : strings.authorisedDealers.description, button: React__default.createElement(LoginButton, { sso: true, title: ssoConfig === null || ssoConfig === void 0 ? void 0 : ssoConfig.buttonTitle, returnUrl: loginReturnUrl }) }),
            React__default.createElement(WelcomePanel, { title: strings.independentOperators.title, description: strings.independentOperators.description, button: React__default.createElement(LoginButton, { returnUrl: loginReturnUrl }) }),
            !mandatoryLogin && React__default.createElement(WelcomePanel, { title: strings.customerLookup.title, description: strings.customerLookup.description, button: React__default.createElement(ButtonLink, { href: "/lookup", preventIfOffline: true }, strings.customerLookup.button) }),
            React__default.createElement(WelcomePanel, { className: "WelcomeScreen-registerPanel", title: strings.register.title, description: strings.register.description, button: React__default.createElement(RegisterButton, null) })));
};

const AccountDisabledScreen = () => {
    const { deleteAccount: strings } = useStrings();
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    usePageTitle(!isLoggedIn ? strings.disabledPageTitle : undefined);
    if (isLoggedIn) {
        return null;
    }
    return React__default.createElement(Screen, { className: "AccountDisabledScreen" },
        React__default.createElement(PanelGrid, null,
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Header, { title: strings.disabledTitle }),
                React__default.createElement(Panel.Content, null,
                    React__default.createElement("p", null, strings.disabledLine1),
                    React__default.createElement("p", null, strings.disabledLine2)))));
};

const Submit = props => {
    return React__default.createElement("div", { className: "Submit" },
        React__default.createElement(Button$2, { onClick: props.onClick }, props.buttonText),
        props.isError && React__default.createElement("div", { className: "Submit_Error" }, props.errorText),
        props.isLoading && !props.isError && React__default.createElement("div", { className: "Submit_Loading" }, props.loadingText),
        props.isSuccess && !props.isLoading && !props.isError && React__default.createElement("div", { className: "Submit_Success" }, props.successText));
};

function useCountrySelect(props) {
    const countries = useCountryNames();
    const [items, setItems] = useState([]);
    useEffect(() => {
        if (countries) {
            setItems(Object.entries(countries).sort((a, b) => a[1].localeCompare(b[1])));
        }
        else {
            setItems([]);
        }
    }, [countries]);
    return useInput(Select, Object.assign(Object.assign({}, props), { items, value: props.value, disabled: props.disabled || items.length === 0 }));
}

const FIRSTNAME_MAX_LENGTH = 32;
const LASTNAME_MAX_LENGTH = 32;
const JOB_TITLE_MAX_LENGTH = 64;
const COMPANY_NAME_MAX_LENGTH = 128;
const VAT_NUMBER_MAX_LENGTH = 32;
const COMPANY_REG_NUMBER_MAX_LENGTH = 128;
const ADDRESS_LINE_1_MAX_LENGTH = 128;
const ADDRESS_LINE_2_MAX_LENGTH = 128;
const ADDRESS_LINE_3_MAX_LENGTH = 128;
const TOWN_MAX_LENGTH = 128;
const REGION_MAX_LENGTH = 128;
const POST_CODE_MAX_LENGTH$1 = 64;
const PHONE_MAX_LENGTH$1 = 128;
const AccountForm = ({ userDetails }) => {
    var _a;
    const { accountDetails: strings } = useStrings();
    const { getOnlineMessage } = useOnlineStatus();
    const [updateUserDetails, { isLoading, isSuccess, isError }] = useUpdateUserDetailsMutation();
    const [allValidate, setAllValidate] = useState(true);
    useShowLoadingIndicator(isLoading);
    const firstName = useTextBox({
        id: 'first-name',
        value: isPersonalUserDetails(userDetails) ? userDetails.firstName : '',
        validators: [
            [isNotEmpty(), strings.firstName.required],
            [isLength(1, FIRSTNAME_MAX_LENGTH), strings.firstName.length(FIRSTNAME_MAX_LENGTH)]
        ]
    });
    const lastName = useTextBox({
        id: 'last-name',
        value: isPersonalUserDetails(userDetails) ? userDetails.lastName : '',
        validators: [
            [isNotEmpty(), strings.lastName.required],
            [isLength(1, LASTNAME_MAX_LENGTH), strings.lastName.length(LASTNAME_MAX_LENGTH)]
        ]
    });
    const jobTitle = useTextBox({
        id: 'job-title',
        value: isPersonalUserDetails(userDetails) ? userDetails.jobTitle : '',
        validators: [
            [isNonRequiredLength(1, JOB_TITLE_MAX_LENGTH), strings.jobTitle.length(JOB_TITLE_MAX_LENGTH)]
        ]
    });
    const isBusiness = useTickBox({
        id: 'is-business',
        label: strings.isBusiness.label,
        value: isBusinessUserDetails(userDetails) || isEmployeeUserDetails(userDetails) ? userDetails.business : false
    });
    const companyName = useTextBox({
        id: 'company-name',
        value: isBusinessUserDetails(userDetails) ? userDetails.companyName : '',
        validators: [
            [isNotEmpty(), strings.companyName.required],
            [isLength(1, COMPANY_NAME_MAX_LENGTH), strings.companyName.length(COMPANY_NAME_MAX_LENGTH)]
        ]
    });
    const vatNumber = useTextBox({
        id: 'vat-number',
        value: isBusinessUserDetails(userDetails) ? userDetails.vatNumber : '',
        validators: [
            [isNonRequiredLength(1, VAT_NUMBER_MAX_LENGTH), strings.vatNumber.length(VAT_NUMBER_MAX_LENGTH)]
        ]
    });
    const companyRegNumber = useTextBox({
        id: 'company-reg-number',
        value: isBusinessUserDetails(userDetails) ? userDetails.companyRegistrationNumber : '',
        validators: [
            [isNonRequiredLength(1, COMPANY_REG_NUMBER_MAX_LENGTH), strings.companyRegNumber.length(COMPANY_REG_NUMBER_MAX_LENGTH)]
        ]
    });
    const dealerNumber = useTextBox({
        id: 'dealer-number',
        value: isBusinessUserDetails(userDetails) ? (_a = userDetails.dealerNumber) !== null && _a !== void 0 ? _a : '' : '',
        disabled: true
    });
    const address1 = useTextBox({
        id: 'address-1',
        value: isPersonalUserDetails(userDetails) ? userDetails.addressLine1 : '',
        validators: [
            [isNotEmpty(), strings.addressLine1.required],
            [isLength(1, ADDRESS_LINE_1_MAX_LENGTH), strings.addressLine1.length(ADDRESS_LINE_1_MAX_LENGTH)]
        ]
    });
    const address2 = useTextBox({
        id: 'address-2',
        value: isPersonalUserDetails(userDetails) ? userDetails.addressLine2 : '',
        validators: [
            [isNonRequiredLength(1, ADDRESS_LINE_2_MAX_LENGTH), strings.addressLine2.length(ADDRESS_LINE_2_MAX_LENGTH)]
        ]
    });
    const address3 = useTextBox({
        id: 'address-3',
        value: isPersonalUserDetails(userDetails) ? userDetails.addressLine3 : '',
        validators: [
            [isNonRequiredLength(1, ADDRESS_LINE_3_MAX_LENGTH), strings.addressLine3.length(ADDRESS_LINE_3_MAX_LENGTH)]
        ]
    });
    const town = useTextBox({
        id: 'town',
        value: isPersonalUserDetails(userDetails) ? userDetails.addressCity : '',
        validators: [
            [isNotEmpty(), strings.town.required],
            [isLength(1, TOWN_MAX_LENGTH), strings.town.length(TOWN_MAX_LENGTH)]
        ]
    });
    const region = useTextBox({
        id: 'region',
        value: isPersonalUserDetails(userDetails) ? userDetails.addressRegion : '',
        validators: [
            [isNonRequiredLength(1, REGION_MAX_LENGTH), strings.region.length(REGION_MAX_LENGTH)]
        ]
    });
    const postCode = useTextBox({
        id: 'postCode',
        value: isPersonalUserDetails(userDetails) ? userDetails.addressPostCode : '',
        validators: [
            [isNotEmpty(), strings.postCode.required],
            [isLength(1, POST_CODE_MAX_LENGTH$1), strings.postCode.length(POST_CODE_MAX_LENGTH$1)]
        ]
    });
    const phone = useTextBox({
        id: 'phone',
        value: isPersonalUserDetails(userDetails) ? userDetails.phone : '',
        validators: [
            [isNonRequiredLength(1, PHONE_MAX_LENGTH$1), strings.phone.length(PHONE_MAX_LENGTH$1)]
        ]
    });
    const country = useCountrySelect({
        id: 'country',
        value: userDetails.addressCountry
    });
    const showPersonalFields = isPersonalUserDetails(userDetails);
    const showBusinessFields = isBusinessUserDetails(userDetails);
    const showIsBusinessField = showBusinessFields || isEmployeeUserDetails(userDetails);
    const allFields = [country];
    if (showPersonalFields) {
        allFields.push(firstName, lastName, jobTitle, address1, address2, address3, town, region, postCode, phone);
    }
    if (showBusinessFields) {
        allFields.push(companyName, vatNumber, companyRegNumber);
    }
    if (showIsBusinessField) {
        allFields.push(isBusiness);
    }
    function submitForm() {
        const allValid = validateAll(...allFields);
        setAllValidate(allValid);
        if (allValid) {
            updateUserDetails(getUserDetailsForUserType(userDetails.userType, {
                firstName: firstName.value,
                lastName: lastName.value,
                jobTitle: jobTitle.value,
                business: isBusiness.value,
                companyName: companyName.value,
                vatNumber: vatNumber.value,
                companyRegistrationNumber: companyRegNumber.value,
                addressLine1: address1.value,
                addressLine2: address2.value,
                addressLine3: address3.value,
                addressCity: town.value,
                addressRegion: region.value,
                addressPostCode: postCode.value,
                addressCountry: country.value,
                phone: phone.value,
                email: '',
                pendingEmailChange: '',
                pendingEmailChangeDate: ''
            }));
        }
    }
    const optional = React__default.createElement("span", { className: "AccountForm_Optional" }, strings.optional);
    const readOnly = React__default.createElement("span", { className: "AccountForm_ReadOnly" }, strings.readOnly);
    return React__default.createElement("form", { className: "AccountForm" },
        React__default.createElement(PanelGrid, { singleColumn: true },
            showPersonalFields && React__default.createElement(Panel, null,
                React__default.createElement(Panel.Header, { title: strings.personalTitle }),
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(FormField, { input: firstName, label: strings.firstName.label }),
                    React__default.createElement(FormField, { input: lastName, label: strings.lastName.label }),
                    React__default.createElement(FormField, { input: jobTitle, label: React__default.createElement(React__default.Fragment, null,
                            strings.jobTitle.label,
                            " ",
                            optional) }))),
            (showIsBusinessField || showBusinessFields) && React__default.createElement(Panel, null,
                React__default.createElement(Panel.Header, { title: strings.businessTitle }),
                React__default.createElement(Panel.Content, null,
                    showIsBusinessField && React__default.createElement(FormField, { input: isBusiness }),
                    showBusinessFields && React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(FormField, { input: companyName, label: strings.companyName.label }),
                        React__default.createElement(FormField, { input: vatNumber, label: React__default.createElement(React__default.Fragment, null,
                                strings.vatNumber.label,
                                " ",
                                optional) }),
                        React__default.createElement(FormField, { input: companyRegNumber, label: React__default.createElement(React__default.Fragment, null,
                                strings.companyRegNumber.label,
                                " ",
                                optional) }),
                        userDetails.dealerNumber && React__default.createElement(FormField, { input: dealerNumber, label: React__default.createElement(React__default.Fragment, null,
                                strings.dealerNumber.label,
                                " ",
                                readOnly) })))),
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Header, { title: strings.addressTitle }),
                React__default.createElement(Panel.Content, null,
                    showPersonalFields && React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(FormField, { input: address1, label: strings.addressLine1.label }),
                        React__default.createElement(FormField, { input: address2, label: React__default.createElement(React__default.Fragment, null,
                                strings.addressLine2.label,
                                " ",
                                optional) }),
                        React__default.createElement(FormField, { input: address3, label: React__default.createElement(React__default.Fragment, null,
                                strings.addressLine3.label,
                                " ",
                                optional) }),
                        React__default.createElement(FormField, { input: town, label: strings.town.label }),
                        React__default.createElement(FormField, { input: region, label: React__default.createElement(React__default.Fragment, null,
                                strings.region.label,
                                " ",
                                optional) }),
                        React__default.createElement(FormField, { input: postCode, label: strings.postCode.label }),
                        React__default.createElement(FormField, { input: phone, label: React__default.createElement(React__default.Fragment, null,
                                strings.phone.label,
                                " ",
                                optional) })),
                    React__default.createElement(FormField, { input: country, label: strings.country.label }))),
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(Submit, { buttonText: strings.submitButton, loadingText: strings.saving, successText: strings.saveSuccess, errorText: !allValidate ? strings.formErrors : getOnlineMessage(strings.saveError), isLoading: isLoading, isSuccess: isSuccess, isError: isError || !allValidate, onClick: submitForm })))));
};

const ChangePasswordForm = () => {
    const { changePassword: strings } = useStrings();
    const { getOnlineMessage } = useOnlineStatus();
    const [changePassword, { isLoading, isSuccess, isError }] = useChangePasswordMutation();
    const [allValidate, setAllValidate] = useState(true);
    useShowLoadingIndicator(isLoading);
    const currentPassword = useTextBox({
        id: 'current-password',
        type: 'password',
        value: '',
        validators: [
            [isNotEmpty(), strings.currentPassword.required],
            [isLength(8, 255), strings.currentPassword.length]
        ]
    });
    const newPassword = useTextBox({
        id: 'new-password',
        type: 'password',
        value: '',
        validators: [
            [isNotEmpty(), strings.newPassword.required],
            [isLength(8, 255), strings.newPassword.length],
            [isNot(isSame(() => currentPassword.value)), strings.newPassword.same]
        ]
    });
    const confirmPassword = useTextBox({
        id: 'confirm-password',
        type: 'password',
        value: '',
        validators: [
            [isSame(() => newPassword.value), strings.confirmPassword.mismatch]
        ]
    });
    function submitForm() {
        const allValid = validateAll(currentPassword, newPassword, confirmPassword);
        setAllValidate(allValid);
        if (allValid) {
            changePassword({
                currentPassword: currentPassword.value,
                newPassword: newPassword.value
            });
        }
    }
    return React__default.createElement("form", { className: "ChangePasswordForm" },
        React__default.createElement(PanelGrid, { singleColumn: true },
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Header, { title: strings.title }),
                React__default.createElement(Panel.Content, null,
                    React__default.createElement("p", null, strings.lengthHint),
                    React__default.createElement(FormField, { input: currentPassword, label: strings.currentPassword.label }),
                    React__default.createElement(FormField, { input: newPassword, label: strings.newPassword.label }),
                    React__default.createElement(FormField, { input: confirmPassword, label: strings.confirmPassword.label }),
                    React__default.createElement(Submit, { buttonText: strings.submitButton, loadingText: strings.saving, successText: strings.saveSuccess, errorText: !allValidate ? strings.formErrors : getOnlineMessage(strings.saveError), isLoading: isLoading, isSuccess: isSuccess, isError: isError || !allValidate, onClick: submitForm })))));
};

function useLanguageSelect(props) {
    const items = useSupportedBaseLanguages().map(({ code, name }) => [code, name]);
    return useInput(Select, Object.assign(Object.assign({}, props), { items, value: props.value, disabled: items.length === 0 }));
}

function useUserRoles() {
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const { data } = useGetUserRolesQuery(undefined, {
        skip: !isLoggedIn,
        refetchOnFocus: true
    });
    return data === null || data === void 0 ? void 0 : data.roles;
}
function useCanChangeOwnCountry() {
    var _a;
    const roles = useUserRoles();
    if (roles) {
        return (_a = roles.includes('CAN_CHANGE_OWN_COUNTRY')) !== null && _a !== void 0 ? _a : false;
    }
    return true;
}
function useCanViewEmbargoedDocuments() {
    const roles = useUserRoles();
    if (roles) {
        return [
            'VIEW_EMBARGO_DOCUMENTS',
            'DOCUMENTS_AUTHOR',
            'DOCUMENTS_REVIEWER',
            'PUBLISHED_INFORMATION_MANAGER'
        ].some(role => roles.includes(role));
    }
    return false;
}

const PreferencesForm = ({ preferences }) => {
    const { preferences: strings } = useStrings();
    const { hidePreferencesEmailSection } = useContext();
    const { getOnlineMessage } = useOnlineStatus();
    const [updatePreferences, { isLoading, isSuccess, isError }] = useUpdatePreferencesMutation();
    const [allValidate, setAllValidate] = useState(true);
    const canChangeOwnCountry = useCanChangeOwnCountry();
    useShowLoadingIndicator(isLoading);
    const inboxEmails = useTickBox({
        id: 'inbox-emails',
        label: strings.inboxEmails.label,
        value: preferences.receiveInboxEmails
    });
    const marketingInfo = useTickBox({
        id: 'marketing-info',
        label: strings.marketingInfo.label,
        value: preferences.receiveMarketingInfo
    });
    const language = useLanguageSelect({
        id: 'language',
        value: preferences.language
    });
    const country = useCountrySelect({
        id: 'country',
        value: preferences.country,
        disabled: !canChangeOwnCountry
    });
    const languageAndCountrySection = [language, country];
    const fieldsToValidate = hidePreferencesEmailSection ? languageAndCountrySection : [inboxEmails, marketingInfo, ...languageAndCountrySection];
    function submitForm() {
        const allValid = validateAll(...fieldsToValidate);
        setAllValidate(allValid);
        if (allValid) {
            updatePreferences({
                receiveInboxEmails: inboxEmails.value,
                receiveMarketingInfo: marketingInfo.value,
                language: language.value,
                country: country.value
            });
        }
    }
    return React__default.createElement("form", { className: "PreferencesForm" },
        React__default.createElement(PanelGrid, { singleColumn: true },
            !hidePreferencesEmailSection &&
                React__default.createElement(Panel, null,
                    React__default.createElement(Panel.Header, { title: strings.emailTitle }),
                    React__default.createElement(Panel.Content, null,
                        React__default.createElement(FormField, { input: inboxEmails }, strings.inboxEmails.description),
                        React__default.createElement(FormField, { input: marketingInfo }))),
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Header, { title: strings.languageTitle }),
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(FormField, { input: language, label: strings.language.label }),
                    React__default.createElement(FormField, { input: country, label: strings.country.label }))),
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(Submit, { buttonText: strings.submitButton, loadingText: strings.saving, successText: strings.saveSuccess, errorText: !allValidate ? strings.formErrors : getOnlineMessage(strings.saveError), isLoading: isLoading, isSuccess: isSuccess, isError: isError || !allValidate, onClick: submitForm })))));
};

function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme,
    themeId: THEME_ID
  });
}

const _excluded$y = ["theme"];
function ThemeProvider(_ref) {
  let {
      theme: themeInput
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$y);
  const scopedTheme = themeInput[THEME_ID];
  return /*#__PURE__*/jsx(ThemeProvider$1, _extends({}, props, {
    themeId: scopedTheme ? THEME_ID : undefined,
    theme: scopedTheme || themeInput
  }));
}
process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

function useAccountTabs() {
    var _a, _b;
    const { account: strings } = useStrings();
    const user = useTypedSelector(selectCurrentUser);
    const { hiddenAccountTabs } = useContext();
    const { data: twoFactorAuthStatus, isError: isTwoFactorAuthStatusError } = useGetTwoFactorAuthStatusQuery((_a = user === null || user === void 0 ? void 0 : user.id) !== null && _a !== void 0 ? _a : queryExports.skipToken);
    const { data: userDetails, isError: isUserDetailsError } = useGetUserDetailsQuery((_b = user === null || user === void 0 ? void 0 : user.type) !== null && _b !== void 0 ? _b : queryExports.skipToken);
    const isTwoFactorAuthenticationShown = twoFactorAuthStatus && Object.keys(twoFactorAuthStatus.methods).length > 0 && !(hiddenAccountTabs === null || hiddenAccountTabs === void 0 ? void 0 : hiddenAccountTabs.twoFactorAuth);
    const isPurchaseSubscriptionShown = useFeatureToggles().isFeatureToggleEnabled('SUBSCRIPTION_PURCHASING') && !(hiddenAccountTabs === null || hiddenAccountTabs === void 0 ? void 0 : hiddenAccountTabs.subscriptions);
    const isEmailShown = userDetails && 'pendingEmailChange' in userDetails && !(hiddenAccountTabs === null || hiddenAccountTabs === void 0 ? void 0 : hiddenAccountTabs.email);
    const isLegalRepresentativeShown = (user === null || user === void 0 ? void 0 : user.type) === 'INDEPENDENT_LEGAL_REPRESENTATIVE' && !(hiddenAccountTabs === null || hiddenAccountTabs === void 0 ? void 0 : hiddenAccountTabs.legalRepresentative);
    if ((!twoFactorAuthStatus && !isTwoFactorAuthStatusError) || (!userDetails && !isUserDetailsError)) {
        return null;
    }
    return {
        details: !(hiddenAccountTabs === null || hiddenAccountTabs === void 0 ? void 0 : hiddenAccountTabs.details)
            ? {
                id: 'account',
                title: strings.accountDetailsTab,
                href: 'details'
            }
            : null,
        preferences: !(hiddenAccountTabs === null || hiddenAccountTabs === void 0 ? void 0 : hiddenAccountTabs.preferences)
            ? {
                id: 'preferences',
                title: strings.preferencesTab,
                href: 'preferences'
            }
            : null,
        subscriptions: isPurchaseSubscriptionShown
            ? {
                id: 'subscriptions',
                title: strings.subscriptionsTab,
                href: 'subscriptions'
            }
            : null,
        twoFactorAuth: isTwoFactorAuthenticationShown
            ? {
                id: 'twoFactorAuth',
                title: strings.twoFactorAuthTab,
                href: '2fa'
            }
            : null,
        password: !(hiddenAccountTabs === null || hiddenAccountTabs === void 0 ? void 0 : hiddenAccountTabs.password)
            ? {
                id: 'password',
                title: strings.changePasswordTab,
                href: 'password' // Changes to the full path (`/account/password`) must be reflected in `change-password.html`.
            }
            : null,
        email: isEmailShown
            ? {
                id: 'email',
                title: strings.changeEmailTab,
                href: 'email'
            }
            : null,
        legalRepresentative: isLegalRepresentativeShown
            ? {
                id: 'legalRepresentative',
                title: strings.legalRepresentativeTab,
                href: 'legal-representative'
            }
            : null,
        deleteAccount: !(hiddenAccountTabs === null || hiddenAccountTabs === void 0 ? void 0 : hiddenAccountTabs.deleteAccount)
            ? {
                id: 'deleteAccount',
                title: strings.deleteAccountTab,
                href: 'delete'
            }
            : null
    };
}

const AccountHeader = ({ userName, alwaysShowUserName, backUrl }) => {
    const tabs = useAccountTabs();
    return React__default.createElement(ContentHeader, { backUrl: backUrl }, alwaysShowUserName
        ? React__default.createElement(ContentHeader.Title, { title: userName })
        : tabs
            ? React__default.createElement(Routes, null,
                Object.values(tabs).map(tab => {
                    return tab && React__default.createElement(Route, { key: tab.id, path: tab.href, element: React__default.createElement(ContentHeader.Title, { title: tab.title }) });
                }),
                React__default.createElement(Route, { path: "*", element: React__default.createElement(ContentHeader.Title, { title: userName }) }))
            : React__default.createElement(Skeleton, { height: 40, width: 150 }));
};

const VerticalTabBar = ({ tabs, className }) => {
    const classes = classNames('VerticalTabBar', className);
    return React__default.createElement("ul", { className: classes }, tabs.map(tab => React__default.createElement(Tab$3, { key: tab.id, id: tab.id, title: tab.title, href: tab.href })));
};
const Tab$3 = ({ id, title, href }) => {
    const location = useLocation();
    const path = useResolvedPath(href);
    const classes = classNames({
        'VerticalTabBar-selected': path.pathname === location.pathname
    });
    return React__default.createElement("li", { key: id, className: classes, role: "tab" },
        React__default.createElement(Link, { to: path },
            React__default.createElement("div", { className: "VerticalTabBar-title" }, title),
            React__default.createElement(FontAwesomeIcon, { icon: faChevronRightExports.faChevronRight })));
};

const DeleteAccountDialogue = ({ isOpen, onClose }) => {
    const dispatch = useTypedDispatch();
    const { basePath } = useContext();
    const { deleteAccount: strings, buttons: buttonStrings } = useStrings();
    const user = useTypedSelector(selectCurrentUser);
    const [deleteUser, { isSuccess, isLoading: isDeleting, error, reset: resetDelete }] = useDeleteUserMutation();
    const userNameOrEmailIncorrect = error && 'status' in error && error.status === 403;
    const userNameOrEmail = useTextBox({
        id: 'userNameOrEmail',
        value: '',
        validators: [[isNotEmpty(), strings.userNameOrEmailRequired]]
    });
    useEffect(() => {
        function logOutAndRedirect() {
            return __awaiter(this, void 0, void 0, function* () {
                yield dispatch(logOut());
                window.location.replace(joinPath(basePath, 'account/disabled'));
            });
        }
        if (isSuccess) {
            logOutAndRedirect();
        }
    }, [isSuccess, basePath, dispatch]);
    if (!user) {
        return null;
    }
    function doDelete() {
        if (user && userNameOrEmail.validate()) {
            deleteUser({
                userId: user.id,
                userNameOrEmail: userNameOrEmail.value
            });
        }
    }
    function resetDialogue() {
        userNameOrEmail.reset();
        resetDelete();
    }
    const buttons = [
        React__default.createElement(Button$2, { key: "cancel", onClick: onClose }, buttonStrings.cancel),
        React__default.createElement(Button$2, { key: "delete", variant: "danger", busy: isDeleting, onClick: doDelete }, strings.deleteButton)
    ];
    return React__default.createElement(Dialogue, { className: "DeleteAccountDialogue", isOpen: isOpen, onClose: onClose, onClosed: resetDialogue },
        React__default.createElement(Dialogue.Header, { title: strings.title }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement("p", null, strings.confirmLine1),
            React__default.createElement("p", null, strings.confirmLine2),
            React__default.createElement("p", null,
                React__default.createElement("strong", null, strings.confirmLine3)),
            React__default.createElement("div", { className: "DeleteAccountDialogue-field" },
                React__default.createElement("label", { htmlFor: userNameOrEmail.id }, strings.userNameOrEmailLabel),
                React__default.createElement("div", { className: "DeleteAccountDialogue-input" },
                    userNameOrEmail.input,
                    (userNameOrEmail.error || userNameOrEmailIncorrect) && React__default.createElement("div", { className: "DeleteAccountDialogue-error" }, userNameOrEmail.error || strings.userNameOrEmailIncorrect)))),
        React__default.createElement(Dialogue.Footer, { buttons: buttons }));
};

const DeleteAccountTab = () => {
    const { deleteAccount: strings } = useStrings();
    const [showDialogue, setShowDialogue] = useState(false);
    return React__default.createElement(PanelGrid, { className: "DeleteAccountTab" },
        React__default.createElement(Panel, null,
            React__default.createElement(Panel.Header, { title: strings.title }),
            React__default.createElement(Panel.Content, null,
                React__default.createElement("p", null,
                    React__default.createElement("strong", null, strings.warning),
                    " ",
                    strings.description),
                React__default.createElement("div", { className: "DeleteAccountTab-buttons" },
                    React__default.createElement(Button$2, { variant: "danger", onClick: () => setShowDialogue(true) }, strings.deleteButton)))),
        React__default.createElement(DeleteAccountDialogue, { isOpen: showDialogue, onClose: () => setShowDialogue(false) }));
};

const TwoFactorAuthMethodItem = ({ name, method, enableTitle }) => {
    const { twoFactorAuth: { methods: strings } } = useStrings();
    const { ref: widthElement, width } = useElementWidth();
    const back = window.location.toString();
    const enableUrl = method.enableUrl
        ? queryString.stringifyUrl({
            url: method.enableUrl,
            query: { back }
        })
        : undefined;
    const disableUrl = method.disableUrl
        ? queryString.stringifyUrl({
            url: method.disableUrl,
            query: { back }
        })
        : undefined;
    const classes = classNames('TwoFactorAuthMethodItem', {
        'TwoFactorAuthMethodItem-enabled': method.enabled,
        'TwoFactorAuthMethodItem-compact': width <= 450
    });
    return React__default.createElement("div", { className: classes, ref: widthElement },
        React__default.createElement("div", null,
            React__default.createElement("h4", null, name),
            React__default.createElement("div", { className: "TwoFactorAuthMethodItem-state" }, method.enabled ? strings.enabled : strings.disabled)),
        React__default.createElement("div", { className: "TwoFactorAuthMethodItem-buttons" },
            enableUrl && React__default.createElement(ButtonLink, { href: enableUrl, preventIfOffline: true }, enableTitle !== null && enableTitle !== void 0 ? enableTitle : strings.enable),
            disableUrl && React__default.createElement(ButtonLink, { href: disableUrl, preventIfOffline: true }, strings.disable)));
};

const TwoFactorAuthPanel = ({ methods }) => {
    const { twoFactorAuth: { methods: strings } } = useStrings();
    if (!methods.totp && !methods.email) {
        return null;
    }
    return React__default.createElement(Panel, { className: "TwoFactorAuthPanel" },
        React__default.createElement(Panel.Header, { title: strings.title }),
        React__default.createElement(Panel.Content, null,
            React__default.createElement("p", null, strings.description),
            methods.totp && React__default.createElement(TwoFactorAuthMethodItem, { name: strings.authenticatorApp, method: methods.totp, enableTitle: methods.totp.enabled ? strings.registerNewApp : undefined }),
            methods.email && React__default.createElement(TwoFactorAuthMethodItem, { name: strings.email, method: methods.email })));
};

const _excluded$x = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"];
const useUtilityClasses$v = ownerState => {
  const {
    absolute,
    children,
    classes,
    flexItem,
    light,
    orientation,
    textAlign,
    variant
  } = ownerState;
  const slots = {
    root: ['root', absolute && 'absolute', variant, light && 'light', orientation === 'vertical' && 'vertical', flexItem && 'flexItem', children && 'withChildren', children && orientation === 'vertical' && 'withChildrenVertical', textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight', textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'],
    wrapper: ['wrapper', orientation === 'vertical' && 'wrapperVertical']
  };
  return composeClasses(slots, getDividerUtilityClass, classes);
};
const DividerRoot = styled('div', {
  name: 'MuiDivider',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.absolute && styles.absolute, styles[ownerState.variant], ownerState.light && styles.light, ownerState.orientation === 'vertical' && styles.vertical, ownerState.flexItem && styles.flexItem, ownerState.children && styles.withChildren, ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft];
  }
})(({
  theme,
  ownerState
}) => _extends({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: 'solid',
  borderColor: (theme.vars || theme).palette.divider,
  borderBottomWidth: 'thin'
}, ownerState.absolute && {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%'
}, ownerState.light && {
  borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : colorManipulatorExports.alpha(theme.palette.divider, 0.08)
}, ownerState.variant === 'inset' && {
  marginLeft: 72
}, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2)
}, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1)
}, ownerState.orientation === 'vertical' && {
  height: '100%',
  borderBottomWidth: 0,
  borderRightWidth: 'thin'
}, ownerState.flexItem && {
  alignSelf: 'stretch',
  height: 'auto'
}), ({
  ownerState
}) => _extends({}, ownerState.children && {
  display: 'flex',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  border: 0,
  borderTopStyle: 'solid',
  borderLeftStyle: 'solid',
  '&::before, &::after': {
    content: '""',
    alignSelf: 'center'
  }
}), ({
  theme,
  ownerState
}) => _extends({}, ownerState.children && ownerState.orientation !== 'vertical' && {
  '&::before, &::after': {
    width: '100%',
    borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
    borderTopStyle: 'inherit'
  }
}), ({
  theme,
  ownerState
}) => _extends({}, ownerState.children && ownerState.orientation === 'vertical' && {
  flexDirection: 'column',
  '&::before, &::after': {
    height: '100%',
    borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
    borderLeftStyle: 'inherit'
  }
}), ({
  ownerState
}) => _extends({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '90%'
  },
  '&::after': {
    width: '10%'
  }
}, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '10%'
  },
  '&::after': {
    width: '90%'
  }
}));
const DividerWrapper = styled('span', {
  name: 'MuiDivider',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.wrapper, ownerState.orientation === 'vertical' && styles.wrapperVertical];
  }
})(({
  theme,
  ownerState
}) => _extends({
  display: 'inline-block',
  paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
  paddingRight: `calc(${theme.spacing(1)} * 1.2)`
}, ownerState.orientation === 'vertical' && {
  paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
}));
const Divider = /*#__PURE__*/React.forwardRef(function Divider(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiDivider'
  });
  const {
      absolute = false,
      children,
      className,
      component = children ? 'div' : 'hr',
      flexItem = false,
      light = false,
      orientation = 'horizontal',
      role = component !== 'hr' ? 'separator' : undefined,
      textAlign = 'center',
      variant = 'fullWidth'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$x);
  const ownerState = _extends({}, props, {
    absolute,
    component,
    flexItem,
    light,
    orientation,
    role,
    textAlign,
    variant
  });
  const classes = useUtilityClasses$v(ownerState);
  return /*#__PURE__*/jsx(DividerRoot, _extends({
    as: component,
    className: clsx$1(classes.root, className),
    role: role,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children ? /*#__PURE__*/jsx(DividerWrapper, {
      className: classes.wrapper,
      ownerState: ownerState,
      children: children
    }) : null
  }));
});

/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */
Divider.muiSkipListHighlight = true;
process.env.NODE_ENV !== "production" ? Divider.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: PropTypes.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  light: PropTypes.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * @ignore
   */
  role: PropTypes /* @typescript-to-proptypes-ignore */.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: PropTypes.oneOf(['center', 'left', 'right']),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['fullWidth', 'inset', 'middle']), PropTypes.string])
} : void 0;
var Divider$1 = Divider;

const _excluded$w = ["className"];
const useUtilityClasses$u = ownerState => {
  const {
    alignItems,
    classes
  } = ownerState;
  const slots = {
    root: ['root', alignItems === 'flex-start' && 'alignItemsFlexStart']
  };
  return composeClasses(slots, getListItemIconUtilityClass, classes);
};
const ListItemIconRoot = styled('div', {
  name: 'MuiListItemIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart];
  }
})(({
  theme,
  ownerState
}) => _extends({
  minWidth: 56,
  color: (theme.vars || theme).palette.action.active,
  flexShrink: 0,
  display: 'inline-flex'
}, ownerState.alignItems === 'flex-start' && {
  marginTop: 8
}));

/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */
const ListItemIcon = /*#__PURE__*/React.forwardRef(function ListItemIcon(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiListItemIcon'
  });
  const {
      className
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$w);
  const context = React.useContext(ListContext);
  const ownerState = _extends({}, props, {
    alignItems: context.alignItems
  });
  const classes = useUtilityClasses$u(ownerState);
  return /*#__PURE__*/jsx(ListItemIconRoot, _extends({
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListItemIcon.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var ListItemIcon$1 = ListItemIcon;

var faTrashAlt = {};

var hasRequiredFaTrashAlt;

function requireFaTrashAlt () {
	if (hasRequiredFaTrashAlt) return faTrashAlt;
	hasRequiredFaTrashAlt = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'trash-alt';
		var width = 448;
		var height = 512;
		var ligatures = [];
		var unicode = 'f2ed';
		var svgPathData = 'M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faTrashAlt = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faTrashAlt));
	return faTrashAlt;
}

var faTrashAltExports = requireFaTrashAlt();

const TrustedDeviceTableRow = ({ rowProps, device, onDelete }) => {
    const { twoFactorAuth: { trustedDevices: strings } } = useStrings();
    return React__default.createElement(Table.Row, { className: "TrustedDeviceTableRow", rowProps: rowProps },
        React__default.createElement(Table.TextCell, { primary: React__default.createElement(DateText, { date: device.lastLoginDate }) }),
        React__default.createElement(Table.TextCell, { primary: React__default.createElement(DateText, { date: device.expiryDate }) }),
        React__default.createElement(Table.ActionCell, null,
            React__default.createElement(IconButton$2, { icon: faTrashAltExports.faTrashAlt, title: strings.deleteButton, variant: "danger", onClick: onDelete })));
};

const TrustedDeviceTable = ({ devices, onDeleteDevice }) => {
    const { twoFactorAuth: { trustedDevices: strings } } = useStrings();
    const columns = useMemo(() => [
        { id: 'lastLogin', title: strings.lastLogin },
        { id: 'trustedUntil', title: strings.trustedUntil },
        { id: 'actions', title: '' }
    ], [strings.lastLogin, strings.trustedUntil]);
    function getRow(rowIndex) {
        const device = devices[rowIndex];
        return {
            id: String(rowIndex),
            component: TrustedDeviceTableRow,
            props: {
                device,
                onDelete: () => onDeleteDevice(device.id)
            }
        };
    }
    return React__default.createElement(Table, { className: "TrustedDeviceTable", columns: columns, rowCount: devices.length, getRow: getRow },
        React__default.createElement(EmptyTableRow, { message: strings.emptyList, size: "sm" }));
};

const TrustedDevicesPanel = ({ devices }) => {
    const dispatch = useTypedDispatch();
    const { twoFactorAuth: { trustedDevices: strings } } = useStrings();
    const user = useTypedSelector(selectCurrentUser);
    const [deleteTrustedDevice, { isLoading: isDeleting }] = useDeleteTrustedDeviceMutation();
    const [deleteDeviceId, setDeleteDeviceId] = useState(null);
    useShowLoadingIndicator(isDeleting);
    function closeDeleteDialogue() {
        setDeleteDeviceId(null);
    }
    const deleteDevice = () => __awaiter(void 0, void 0, void 0, function* () {
        if (user && deleteDeviceId !== null) {
            try {
                yield deleteTrustedDevice({
                    userId: user.id,
                    deviceId: deleteDeviceId
                }).unwrap();
                dispatch(queueNotification(strings.deletedMessage));
            }
            catch (error) {
                dispatch(queueNotification(strings.deleteError));
            }
        }
        closeDeleteDialogue();
    });
    return React__default.createElement(Panel, { className: "TrustedDevicesPanel" },
        React__default.createElement(Panel.Header, { title: strings.title }),
        React__default.createElement(Panel.Content, null,
            React__default.createElement("p", null, strings.description),
            React__default.createElement("div", { className: "TrustedDevicesPanel-table" },
                React__default.createElement(TrustedDeviceTable, { devices: devices, onDeleteDevice: setDeleteDeviceId }))),
        React__default.createElement(ConfirmDialogue, { isOpen: deleteDeviceId !== null, title: strings.deleteTitle, confirmTitle: strings.deleteButton, isDangerous: true, onConfirm: deleteDevice, onCancel: closeDeleteDialogue }, strings.deleteMessage));
};

const TwoFactorAuthTab = ({ twoFactorAuthStatus }) => {
    return React__default.createElement(PanelGrid, { className: "TwoFactorAuthTab", singleColumn: true },
        React__default.createElement(TwoFactorAuthPanel, { methods: twoFactorAuthStatus.methods }),
        React__default.createElement(TrustedDevicesPanel, { devices: twoFactorAuthStatus.trustedDevices }));
};

/**
 * Resets the scroll position of an element to top-left on navigation changes.
 *
 * @param forwardRef - Ref to the element to reset. If not provided the returned ref should be assigned to the element.
 * @returns Ref to assign to the element to reset, or {@link forwardRef} if provided.
 */
function useNavigationScrollReset(forwardRef) {
    const ownRef = useRef(null);
    const ref = forwardRef !== null && forwardRef !== void 0 ? forwardRef : ownRef;
    const location = useLocation();
    const lastLocation = useRef(location.pathname + location.search);
    useEffect(() => {
        const newLocation = location.pathname + location.search;
        if (lastLocation.current !== newLocation) {
            lastLocation.current = newLocation;
            if (ref.current) {
                // Cannot use scrollTo as not supported by IE11.
                ref.current.scrollTop = 0;
                ref.current.scrollLeft = 0;
            }
        }
    }, [location, ref]);
    return ref;
}
/**
 * Resets the scroll position of an element to top-left when the provided token changes.
 *
 * @param token - Scroll position will be reset when this token changes.
 * @param forwardRef - Ref to the element to reset. If not provided the returned ref should be assigned to the element.
 * @returns Ref to assign to the element to reset, or {@link forwardRef} if provided.
 */
function useTokenScrollReset(token, forwardRef) {
    const ownRef = useRef(null);
    const ref = forwardRef !== null && forwardRef !== void 0 ? forwardRef : ownRef;
    const tokenRef = useRef(token);
    useEffect(() => {
        if (tokenRef.current !== token) {
            tokenRef.current = token;
            if (ref.current) {
                // Cannot use scrollTo as not supported by IE11.
                ref.current.scrollTop = 0;
                ref.current.scrollLeft = 0;
            }
        }
    }, [ref, token]);
    return ref;
}

function getCollapseUtilityClass(slot) {
  return generateUtilityClass('MuiCollapse', slot);
}
generateUtilityClasses('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);

const _excluded$v = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"];
const useUtilityClasses$t = ownerState => {
  const {
    orientation,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${orientation}`],
    entered: ['entered'],
    hidden: ['hidden'],
    wrapper: ['wrapper', `${orientation}`],
    wrapperInner: ['wrapperInner', `${orientation}`]
  };
  return composeClasses(slots, getCollapseUtilityClass, classes);
};
const CollapseRoot = styled('div', {
  name: 'MuiCollapse',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.state === 'entered' && styles.entered, ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => _extends({
  height: 0,
  overflow: 'hidden',
  transition: theme.transitions.create('height')
}, ownerState.orientation === 'horizontal' && {
  height: 'auto',
  width: 0,
  transition: theme.transitions.create('width')
}, ownerState.state === 'entered' && _extends({
  height: 'auto',
  overflow: 'visible'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto'
}), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
  visibility: 'hidden'
}));
const CollapseWrapper = styled('div', {
  name: 'MuiCollapse',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => styles.wrapper
})(({
  ownerState
}) => _extends({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: 'flex',
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));
const CollapseWrapperInner = styled('div', {
  name: 'MuiCollapse',
  slot: 'WrapperInner',
  overridesResolver: (props, styles) => styles.wrapperInner
})(({
  ownerState
}) => _extends({
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));

/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Collapse = /*#__PURE__*/React.forwardRef(function Collapse(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiCollapse'
  });
  const {
      addEndListener,
      children,
      className,
      collapsedSize: collapsedSizeProp = '0px',
      component,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      orientation = 'vertical',
      style,
      timeout = duration.standard,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = Transition
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$v);
  const ownerState = _extends({}, props, {
    orientation,
    collapsedSize: collapsedSizeProp
  });
  const classes = useUtilityClasses$t(ownerState);
  const theme = useTheme$3();
  const timer = useTimeout();
  const wrapperRef = React.useRef(null);
  const autoTransitionDuration = React.useRef();
  const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
  const isHorizontal = orientation === 'horizontal';
  const size = isHorizontal ? 'width' : 'height';
  const nodeRef = React.useRef(null);
  const handleRef = useForkRef(ref, nodeRef);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const getWrapperSize = () => wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    if (wrapperRef.current && isHorizontal) {
      // Set absolute position to get the size of collapsed content
      wrapperRef.current.style.position = 'absolute';
    }
    node.style[size] = collapsedSize;
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const wrapperSize = getWrapperSize();
    if (wrapperRef.current && isHorizontal) {
      // After the size is read reset the position back to default
      wrapperRef.current.style.position = '';
    }
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    if (timeout === 'auto') {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style[size] = `${wrapperSize}px`;
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback((node, isAppearing) => {
    node.style[size] = 'auto';
    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  const handleExit = normalizedTransitionCallback(node => {
    node.style[size] = `${getWrapperSize()}px`;
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleExiting = normalizedTransitionCallback(node => {
    const wrapperSize = getWrapperSize();
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    if (timeout === 'auto') {
      // TODO: rename getAutoHeightDuration to something more generic (width support)
      // Actually it just calculates animation duration based on size
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style[size] = collapsedSize;
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onExiting) {
      onExiting(node);
    }
  });
  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.start(autoTransitionDuration.current || 0, next);
    }
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/jsx(TransitionComponent, _extends({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => /*#__PURE__*/jsx(CollapseRoot, _extends({
      as: component,
      className: clsx$1(classes.root, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedSize === '0px' && classes.hidden
      }[state]),
      style: _extends({
        [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
      }, style),
      ref: handleRef
    }, childProps, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: _extends({}, ownerState, {
        state
      }),
      children: /*#__PURE__*/jsx(CollapseWrapper, {
        ownerState: _extends({}, ownerState, {
          state
        }),
        className: classes.wrapper,
        ref: wrapperRef,
        children: /*#__PURE__*/jsx(CollapseWrapperInner, {
          ownerState: _extends({}, ownerState, {
            state
          }),
          className: classes.wrapperInner,
          children: children
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
var Collapse$1 = Collapse;

const Expander = ({ title, subtitle, className, children }) => {
    const { buttons: strings } = useStrings();
    const [expanded, setExpanded] = useState(false);
    const toggleExpanded = () => setExpanded(!expanded);
    const classes = classNames('Expander', className);
    const buttonTitle = expanded ? strings.collapse : strings.expand;
    return React__default.createElement("div", { className: classes },
        React__default.createElement("div", { className: "Expander-header", role: "presentation", onClick: toggleExpanded },
            React__default.createElement("h4", null, title),
            React__default.createElement("div", { className: "Expander-subtitle" }, subtitle),
            React__default.createElement("button", { className: "Expander-expand", "aria-expanded": expanded, title: buttonTitle, "aria-label": buttonTitle, onClick: toggleExpanded },
                React__default.createElement(FontAwesomeIcon, { icon: expanded ? faChevronDownExports.faChevronDown : faChevronRightExports.faChevronRight }))),
        React__default.createElement(Collapse$1, { in: expanded },
            React__default.createElement("div", { className: "Expander-content" }, children)));
};

const SubscriptionLabel = ({ variant, children }) => {
    const classes = classNames('SubscriptionLabel', {
        [`SubscriptionLabel-${variant}`]: variant && variant !== 'default'
    });
    return React__default.createElement("div", { className: classes }, children);
};

const Price = ({ amount, currency }) => {
    const locale = useTypedSelector(selectLocale);
    return React__default.createElement(React__default.Fragment, null, getPriceText(amount, currency, locale));
};
function getPriceText(amount, currency, locale) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
}

const UserSubscriptionInfo = ({ subscription, showName }) => {
    const { subscriptions: strings } = useStrings();
    const vinResolver = useVinResolver();
    const navigation = useNavigation();
    return React__default.createElement("div", { className: "UserSubscriptionInfo" },
        React__default.createElement(DefinitionList, { skipMissingValues: true, definitions: [
                showName && {
                    name: strings.nameLabel,
                    value: subscription.type
                },
                {
                    name: strings.vinLabel,
                    value: subscription.vin && React__default.createElement(Link$1, { href: navigation.vehicle(getVinReference(subscription.vin)) }, vinResolver(subscription.vin))
                },
                subscription.productVariantLabel !== undefined && {
                    name: subscription.productVariantLabel,
                    value: subscription.productVariantName
                },
                {
                    name: strings.productYearLabel,
                    value: subscription.productYear ? String(subscription.productYear) : null
                },
                {
                    name: strings.issuedLabel,
                    value: subscription.issueDate && React__default.createElement(DateText, { date: subscription.issueDate })
                },
                {
                    name: strings.expiresLabel,
                    value: subscription.expiryDate && React__default.createElement(DateText, { date: subscription.expiryDate })
                },
                subscription.priceAmount !== undefined && subscription.priceCurrency !== undefined && {
                    name: strings.priceLabel,
                    value: React__default.createElement(Price, { amount: subscription.priceAmount, currency: subscription.priceCurrency })
                },
                {
                    name: strings.offeredByLabel,
                    value: subscription.offerer
                }
            ].filter(filterFalse) }));
};

const SubscriptionItem = ({ subscription }) => {
    const { subscriptions: strings } = useStrings();
    const label = (() => {
        if (subscription.hasExpired) {
            return React__default.createElement(SubscriptionLabel, { variant: "expired" }, strings.expired);
        }
        else if (subscription.state === 'rejected') {
            return React__default.createElement(SubscriptionLabel, null, strings.rejected);
        }
        else if (subscription.state === 'awaitingApproval') {
            return React__default.createElement(SubscriptionLabel, null, strings.awaitingApproval);
        }
        else if (subscription.state === 'awaitingPayment') {
            return React__default.createElement(SubscriptionLabel, null, strings.awaitingPayment);
        }
        else if (subscription.isEnabled) {
            return React__default.createElement(SubscriptionLabel, { variant: "active" }, strings.active);
        }
        else {
            return React__default.createElement(SubscriptionLabel, null, strings.inactive);
        }
    })();
    return React__default.createElement(Expander, { className: "SubscriptionItem", title: subscription.type, subtitle: label },
        React__default.createElement(UserSubscriptionInfo, { subscription: subscription, showName: false }),
        React__default.createElement("div", { className: "SubscriptionItem-buttons" }, subscription.invoiceUrl && React__default.createElement(ButtonLink, { href: subscription.invoiceUrl }, strings.generateInvoiceButton)));
};

const config = {
    paginationPageSize: 20,
    markMessagesReadTimeout: 1000,
    loadingIndicatorDelay: 100
};

const TableHeader = ({ title, children }) => {
    return React__default.createElement("header", { className: "TableHeader" },
        React__default.createElement("h3", null, title),
        children);
};

const SubscriptionListSkeleton = () => {
    return React__default.createElement(SkeletonContainer, { className: "SubscriptionListSkeleton" },
        React__default.createElement("div", null,
            React__default.createElement(Skeleton$1, { width: "45%" }),
            React__default.createElement(Skeleton$1, { width: "22%", maxWidth: 120 })),
        React__default.createElement("div", null,
            React__default.createElement(Skeleton$1, { width: "60%" }),
            React__default.createElement(Skeleton$1, { width: "15%", maxWidth: 90 })),
        React__default.createElement("div", null,
            React__default.createElement(Skeleton$1, { width: "35%" }),
            React__default.createElement(Skeleton$1, { width: "20%", maxWidth: 110 })));
};

const SubscriptionsTab = () => {
    const { subscriptions: strings } = useStrings();
    const navigation = useNavigation();
    const user = useTypedSelector(selectCurrentUser);
    const [pageNumber, setPageNumber] = useState(0);
    const { data, isLoading, isFetching, error } = useGetUserSubscriptionsQuery(user ? {
        userId: user.id,
        pageNumber,
        pageSize: config.paginationPageSize
    } : queryExports.skipToken, {
        refetchOnMountOrArgChange: true
    });
    useShowLoadingIndicator(isFetching && !isLoading);
    const paginator = usePaginator(data, setPageNumber);
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const subscriptions = data === null || data === void 0 ? void 0 : data.elements;
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const specificity = vehicle ? getVehicleSpecificity(vehicle) : getGlobalSpecificity();
    if (!user) {
        return null;
    }
    return React__default.createElement(PanelGrid, { className: "SubscriptionsTab", singleColumn: true },
        React__default.createElement(Panel, { className: "SubscriptionsTab-subscriptionsPanel" },
            React__default.createElement(Panel.Header, { title: strings.title },
                React__default.createElement(ButtonLink, { href: navigation.subscriptions(specificity) }, strings.purchaseTitle)),
            React__default.createElement(TableHeader, { title: strings.userSubscriptionsTitle },
                React__default.createElement(Pagination, { paginator: paginator })),
            (() => {
                if (errorMessage) {
                    return React__default.createElement(Panel.Message, { text: errorMessage });
                }
                if (!subscriptions) {
                    return React__default.createElement(Panel.Content, null,
                        React__default.createElement(SubscriptionListSkeleton, null));
                }
                if (subscriptions.length === 0) {
                    return React__default.createElement(Panel.Message, { text: strings.noUserSubscriptions });
                }
                return React__default.createElement(Panel.Content, null, subscriptions.map(subscription => React__default.createElement(SubscriptionItem, { key: subscription.id, subscription: subscription })));
            })()),
        React__default.createElement(Pagination, { paginator: paginator, centerHorizontally: true }));
};

const ChangeEmailForm = ({ userDetails }) => {
    const { changeEmail: strings } = useStrings();
    const [changeEmail, { isLoading, isSuccess, isError, error: emailChangeError }] = useChangeEmailMutation();
    const { getOnlineMessage } = useOnlineStatus();
    const [allValidate, setAllValidate] = useState(true);
    const location = useLocation();
    const { error, message } = queryString.parse(location.search);
    const currentEmail = useTextBox({
        id: 'current-email',
        type: 'email',
        value: (userDetails && 'email' in userDetails ? userDetails.email : ''),
        disabled: true
    });
    const newEmail = useTextBox({
        id: 'new-email',
        type: 'email',
        value: '',
        validators: [
            [isNotEmpty(), strings.newEmail.required],
            [isEmail(), strings.newEmail.valid],
            [isNot(isSame(() => currentEmail.value)), strings.newEmail.different]
        ]
    });
    const newEmailConfirmation = useTextBox({
        id: 'new-email-confirmation',
        type: 'email',
        value: '',
        validators: [
            [isNotEmpty(), strings.newEmailConfirmation.required],
            [isEmail(), strings.newEmailConfirmation.valid],
            [isSame(() => newEmail.value), strings.newEmailConfirmation.same]
        ]
    });
    const password = useTextBox({
        id: 'password',
        type: 'password',
        value: '',
        validators: [
            [isNotEmpty(), strings.password.required],
            [isLength(8, 255), strings.password.length]
        ],
        messages: [apiValidationErrorMessage(emailChangeError, 'password')]
    });
    function submitForm() {
        const allValid = validateAll(currentEmail, newEmail, newEmailConfirmation, password);
        setAllValidate(allValid);
        if (allValid) {
            changeEmail({
                email: newEmail.value,
                password: password.value
            });
        }
    }
    return React__default.createElement("form", { className: "ChangeEmailForm" },
        React__default.createElement(PanelGrid, { singleColumn: true },
            error && React__default.createElement(Panel, { variant: "warning" },
                React__default.createElement(Panel.Content, null, Array.isArray(error) ? error.join(' ') : error)),
            message && React__default.createElement(Panel, { variant: "info" },
                React__default.createElement(Panel.Content, null, Array.isArray(message) ? message.join(' ') : message)),
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Header, { title: strings.title }),
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(FormField, { input: currentEmail, label: strings.currentEmail }),
                    React__default.createElement(FormField, { input: newEmail, label: strings.newEmail.label }),
                    React__default.createElement(FormField, { input: newEmailConfirmation, label: strings.newEmailConfirmation.label }),
                    React__default.createElement(FormField, { input: password, label: strings.password.label }),
                    React__default.createElement(Submit, { buttonText: strings.submitButton, loadingText: strings.saving, successText: strings.saveSuccess, errorText: !allValidate ? strings.formErrors : getOnlineMessage(strings.saveError), isLoading: isLoading, isSuccess: isSuccess, isError: isError || !allValidate, onClick: submitForm })))));
};

const ChangeEmailPendingForm = ({ userDetails }) => {
    const { changeEmail: strings } = useStrings();
    const [changeEmailSendVerification, { isLoading: isAnotherVerificationLoading, isSuccess: isAnotherVerificationSuccess, isError: isAnotherVerificationError }] = useChangeEmailSendVerificationMutation();
    const [changeEmailCancellation, { isLoading: isCancellationLoading, isSuccess: isCancellationSuccess, isError: isCancellationError }] = useChangeEmailCancellationMutation();
    const { getOnlineMessage } = useOnlineStatus();
    const location = useLocation();
    const { error, message } = queryString.parse(location.search);
    const currentEmail = useTextBox({
        id: 'current-email',
        type: 'email',
        value: (userDetails && 'email' in userDetails ? userDetails.email : ''),
        disabled: true
    });
    const emailAwaitingVerification = useTextBox({
        id: 'email-awaiting-verification',
        type: 'email',
        value: 'pendingEmailChange' in userDetails && userDetails.pendingEmailChange ? userDetails.pendingEmailChange : '',
        disabled: true
    });
    function submitAnotherVerification() {
        changeEmailSendVerification();
    }
    function submitCancellation() {
        changeEmailCancellation();
    }
    return React__default.createElement("form", { className: "ChangeEmailPendingForm" },
        React__default.createElement(PanelGrid, { singleColumn: true },
            error && React__default.createElement(Panel, { variant: "warning" },
                React__default.createElement(Panel.Content, null, Array.isArray(error) ? error.join(' ') : error)),
            message && React__default.createElement(Panel, { variant: "info" },
                React__default.createElement(Panel.Content, null, Array.isArray(message) ? message.join(' ') : message)),
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Header, { title: strings.title }),
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(FormField, { input: currentEmail, label: strings.currentEmail }),
                    React__default.createElement(FormField, { input: emailAwaitingVerification, label: strings.emailAwaitingVerification.label }),
                    strings.verificationExpectedNotice)),
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(Submit, { buttonText: strings.sendAnotherVerificationButton.text, loadingText: strings.sendAnotherVerificationButton.loadingText, successText: strings.sendAnotherVerificationButton.successText, errorText: getOnlineMessage(strings.sendAnotherVerificationButton.errorText), isLoading: isAnotherVerificationLoading, isSuccess: isAnotherVerificationSuccess, isError: isAnotherVerificationError, onClick: submitAnotherVerification }))),
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(Submit, { buttonText: strings.cancelEmailVerificationButton.text, loadingText: strings.cancelEmailVerificationButton.loadingText, successText: strings.cancelEmailVerificationButton.successText, errorText: getOnlineMessage(strings.cancelEmailVerificationButton.errorText), isLoading: isCancellationLoading, isSuccess: isCancellationSuccess, isError: isCancellationError, onClick: submitCancellation })))));
};

const PanelSkeleton = ({ hasTitle = true, titleWidth = '30%', hasRole, children }) => {
    return React__default.createElement(SkeletonContainer, { hasRole: hasRole },
        React__default.createElement(Panel, null,
            hasTitle && React__default.createElement(Panel.Header, null,
                React__default.createElement(Skeleton, { variant: "rectangular", height: 24, width: titleWidth })),
            children));
};

const FormPanelSkeleton = ({ titleWidth, hasRole }) => {
    const { ref, width } = useElementWidth();
    const classes = classNames(className$I(), {
        [className$I('singleColumn')]: width < 500,
        [className$I('wide')]: width > 800
    });
    return React__default.createElement(PanelSkeleton, { titleWidth: titleWidth, hasRole: hasRole },
        React__default.createElement(Panel.Content, null,
            React__default.createElement("div", { ref: ref, className: classes },
                React__default.createElement(Skeleton, { width: 100, height: 24 }),
                React__default.createElement("div", { className: className$I('input') },
                    React__default.createElement(Skeleton, { width: 100 })),
                React__default.createElement(Skeleton, { width: 60, height: 24 }),
                React__default.createElement("div", { className: className$I('input') },
                    React__default.createElement(Skeleton, { width: 60 })),
                React__default.createElement(Skeleton, { width: 130, height: 24 }),
                React__default.createElement("div", { className: className$I('input') },
                    React__default.createElement(Skeleton, { width: 130 })))));
};
const className$I = createClassName('FormPanelSkeleton');

const AccountTabSkeleton = () => {
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(PanelGrid, null,
            React__default.createElement(FormPanelSkeleton, { hasRole: false }),
            React__default.createElement(FormPanelSkeleton, { hasRole: false })));
};

const textHeight$1 = 24;
const iconSize = 18;
const VerticalTabBarSkeleton = ({ hasRole }) => {
    return React__default.createElement(SkeletonContainer, { className: "VerticalTabBarSkeleton", hasRole: hasRole },
        React__default.createElement(Skeleton, { height: textHeight$1, width: "60%" }),
        React__default.createElement(Skeleton, { variant: "circular", width: iconSize, height: iconSize }),
        React__default.createElement(Skeleton, { height: textHeight$1, width: "40%" }),
        React__default.createElement(Skeleton, { variant: "circular", width: iconSize, height: iconSize }),
        React__default.createElement(Skeleton, { height: textHeight$1, width: "50%" }),
        React__default.createElement(Skeleton, { variant: "circular", width: iconSize, height: iconSize }),
        React__default.createElement(Skeleton, { height: textHeight$1, width: "30%" }),
        React__default.createElement(Skeleton, { variant: "circular", width: iconSize, height: iconSize }),
        React__default.createElement(Skeleton, { height: textHeight$1, width: "70%" }),
        React__default.createElement(Skeleton, { variant: "circular", width: iconSize, height: iconSize }));
};

function getSwitchUtilityClass(slot) {
  return generateUtilityClass('MuiSwitch', slot);
}
const switchClasses = generateUtilityClasses('MuiSwitch', ['root', 'edgeStart', 'edgeEnd', 'switchBase', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium', 'checked', 'disabled', 'input', 'thumb', 'track']);
var switchClasses$1 = switchClasses;

const _excluded$u = ["className", "color", "edge", "size", "sx"];
const useUtilityClasses$s = ownerState => {
  const {
    classes,
    edge,
    size,
    color,
    checked,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', edge && `edge${capitalize(edge)}`, `size${capitalize(size)}`],
    switchBase: ['switchBase', `color${capitalize(color)}`, checked && 'checked', disabled && 'disabled'],
    thumb: ['thumb'],
    track: ['track'],
    input: ['input']
  };
  const composedClasses = composeClasses(slots, getSwitchUtilityClass, classes);
  return _extends({}, classes, composedClasses);
};
const SwitchRoot = styled('span', {
  name: 'MuiSwitch',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.edge && styles[`edge${capitalize(ownerState.edge)}`], styles[`size${capitalize(ownerState.size)}`]];
  }
})({
  display: 'inline-flex',
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: 'hidden',
  padding: 12,
  boxSizing: 'border-box',
  position: 'relative',
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: 'middle',
  // For correct alignment with the text.
  '@media print': {
    colorAdjust: 'exact'
  },
  variants: [{
    props: {
      edge: 'start'
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: 'end'
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: 'small'
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${switchClasses$1.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${switchClasses$1.switchBase}`]: {
        padding: 4,
        [`&.${switchClasses$1.checked}`]: {
          transform: 'translateX(16px)'
        }
      }
    }
  }]
});
const SwitchSwitchBase = styled(SwitchBase, {
  name: 'MuiSwitch',
  slot: 'SwitchBase',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.switchBase, {
      [`& .${switchClasses$1.input}`]: styles.input
    }, ownerState.color !== 'default' && styles[`color${capitalize(ownerState.color)}`]];
  }
})(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
  transition: theme.transitions.create(['left', 'transform'], {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${switchClasses$1.checked}`]: {
    transform: 'translateX(20px)'
  },
  [`&.${switchClasses$1.disabled}`]: {
    color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
  },
  [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
    opacity: 0.5
  },
  [`&.${switchClasses$1.disabled} + .${switchClasses$1.track}`]: {
    opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
  },
  [`& .${switchClasses$1.input}`]: {
    left: '-100%',
    width: '300%'
  }
}), ({
  theme
}) => ({
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : colorManipulatorExports.alpha(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  variants: [...Object.entries(theme.palette).filter(([, value]) => value.main && value.light) // check all the used fields in the style below
  .map(([color]) => ({
    props: {
      color
    },
    style: {
      [`&.${switchClasses$1.checked}`]: {
        color: (theme.vars || theme).palette[color].main,
        '&:hover': {
          backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : colorManipulatorExports.alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        [`&.${switchClasses$1.disabled}`]: {
          color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? colorManipulatorExports.lighten(theme.palette[color].main, 0.62) : colorManipulatorExports.darken(theme.palette[color].main, 0.55)}`
        }
      },
      [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
        backgroundColor: (theme.vars || theme).palette[color].main
      }
    }
  }))]
}));
const SwitchTrack = styled('span', {
  name: 'MuiSwitch',
  slot: 'Track',
  overridesResolver: (props, styles) => styles.track
})(({
  theme
}) => ({
  height: '100%',
  width: '100%',
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: theme.transitions.create(['opacity', 'background-color'], {
    duration: theme.transitions.duration.shortest
  }),
  backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
  opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
}));
const SwitchThumb = styled('span', {
  name: 'MuiSwitch',
  slot: 'Thumb',
  overridesResolver: (props, styles) => styles.thumb
})(({
  theme
}) => ({
  boxShadow: (theme.vars || theme).shadows[1],
  backgroundColor: 'currentColor',
  width: 20,
  height: 20,
  borderRadius: '50%'
}));
const Switch = /*#__PURE__*/React.forwardRef(function Switch(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiSwitch'
  });
  const {
      className,
      color = 'primary',
      edge = false,
      size = 'medium',
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$u);
  const ownerState = _extends({}, props, {
    color,
    edge,
    size
  });
  const classes = useUtilityClasses$s(ownerState);
  const icon = /*#__PURE__*/jsx(SwitchThumb, {
    className: classes.thumb,
    ownerState: ownerState
  });
  return /*#__PURE__*/jsxs(SwitchRoot, {
    className: clsx$1(classes.root, className),
    sx: sx,
    ownerState: ownerState,
    children: [/*#__PURE__*/jsx(SwitchSwitchBase, _extends({
      type: "checkbox",
      icon: icon,
      checkedIcon: icon,
      ref: ref,
      ownerState: ownerState
    }, other, {
      classes: _extends({}, classes, {
        root: classes.switchBase
      })
    })), /*#__PURE__*/jsx(SwitchTrack, {
      className: classes.track,
      ownerState: ownerState
    })]
  });
});
process.env.NODE_ENV !== "production" ? Switch.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(['end', 'start', false]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
var Switch$1 = Switch;

var CancelIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

function getChipUtilityClass(slot) {
  return generateUtilityClass('MuiChip', slot);
}
const chipClasses = generateUtilityClasses('MuiChip', ['root', 'sizeSmall', 'sizeMedium', 'colorError', 'colorInfo', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorWarning', 'disabled', 'clickable', 'clickableColorPrimary', 'clickableColorSecondary', 'deletable', 'deletableColorPrimary', 'deletableColorSecondary', 'outlined', 'filled', 'outlinedPrimary', 'outlinedSecondary', 'filledPrimary', 'filledSecondary', 'avatar', 'avatarSmall', 'avatarMedium', 'avatarColorPrimary', 'avatarColorSecondary', 'icon', 'iconSmall', 'iconMedium', 'iconColorPrimary', 'iconColorSecondary', 'label', 'labelSmall', 'labelMedium', 'deleteIcon', 'deleteIconSmall', 'deleteIconMedium', 'deleteIconColorPrimary', 'deleteIconColorSecondary', 'deleteIconOutlinedColorPrimary', 'deleteIconOutlinedColorSecondary', 'deleteIconFilledColorPrimary', 'deleteIconFilledColorSecondary', 'focusVisible']);
var chipClasses$1 = chipClasses;

const _excluded$t = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"];
const useUtilityClasses$r = ownerState => {
  const {
    classes,
    disabled,
    size,
    color,
    iconColor,
    onDelete,
    clickable,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant, disabled && 'disabled', `size${capitalize(size)}`, `color${capitalize(color)}`, clickable && 'clickable', clickable && `clickableColor${capitalize(color)}`, onDelete && 'deletable', onDelete && `deletableColor${capitalize(color)}`, `${variant}${capitalize(color)}`],
    label: ['label', `label${capitalize(size)}`],
    avatar: ['avatar', `avatar${capitalize(size)}`, `avatarColor${capitalize(color)}`],
    icon: ['icon', `icon${capitalize(size)}`, `iconColor${capitalize(iconColor)}`],
    deleteIcon: ['deleteIcon', `deleteIcon${capitalize(size)}`, `deleteIconColor${capitalize(color)}`, `deleteIcon${capitalize(variant)}Color${capitalize(color)}`]
  };
  return composeClasses(slots, getChipUtilityClass, classes);
};
const ChipRoot = styled('div', {
  name: 'MuiChip',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      color,
      iconColor,
      clickable,
      onDelete,
      size,
      variant
    } = ownerState;
    return [{
      [`& .${chipClasses$1.avatar}`]: styles.avatar
    }, {
      [`& .${chipClasses$1.avatar}`]: styles[`avatar${capitalize(size)}`]
    }, {
      [`& .${chipClasses$1.avatar}`]: styles[`avatarColor${capitalize(color)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: styles.icon
    }, {
      [`& .${chipClasses$1.icon}`]: styles[`icon${capitalize(size)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: styles[`iconColor${capitalize(iconColor)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles.deleteIcon
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIcon${capitalize(size)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIconColor${capitalize(color)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIcon${capitalize(variant)}Color${capitalize(color)}`]
    }, styles.root, styles[`size${capitalize(size)}`], styles[`color${capitalize(color)}`], clickable && styles.clickable, clickable && color !== 'default' && styles[`clickableColor${capitalize(color)})`], onDelete && styles.deletable, onDelete && color !== 'default' && styles[`deletableColor${capitalize(color)}`], styles[variant], styles[`${variant}${capitalize(color)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
  return _extends({
    maxWidth: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    color: (theme.vars || theme).palette.text.primary,
    backgroundColor: (theme.vars || theme).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['background-color', 'box-shadow']),
    // reset cursor explicitly in case ButtonBase is used
    cursor: 'unset',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: 'none',
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    [`&.${chipClasses$1.disabled}`]: {
      opacity: (theme.vars || theme).palette.action.disabledOpacity,
      pointerEvents: 'none'
    },
    [`& .${chipClasses$1.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
      fontSize: theme.typography.pxToRem(12)
    },
    [`& .${chipClasses$1.avatarColorPrimary}`]: {
      color: (theme.vars || theme).palette.primary.contrastText,
      backgroundColor: (theme.vars || theme).palette.primary.dark
    },
    [`& .${chipClasses$1.avatarColorSecondary}`]: {
      color: (theme.vars || theme).palette.secondary.contrastText,
      backgroundColor: (theme.vars || theme).palette.secondary.dark
    },
    [`& .${chipClasses$1.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: theme.typography.pxToRem(10)
    },
    [`& .${chipClasses$1.icon}`]: _extends({
      marginLeft: 5,
      marginRight: -6
    }, ownerState.size === 'small' && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, ownerState.iconColor === ownerState.color && _extends({
      color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
    }, ownerState.color !== 'default' && {
      color: 'inherit'
    })),
    [`& .${chipClasses$1.deleteIcon}`]: _extends({
      WebkitTapHighlightColor: 'transparent',
      color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : colorManipulatorExports.alpha(theme.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : colorManipulatorExports.alpha(theme.palette.text.primary, 0.4)
      }
    }, ownerState.size === 'small' && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, ownerState.color !== 'default' && {
      color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : colorManipulatorExports.alpha(theme.palette[ownerState.color].contrastText, 0.7),
      '&:hover, &:active': {
        color: (theme.vars || theme).palette[ownerState.color].contrastText
      }
    })
  }, ownerState.size === 'small' && {
    height: 24
  }, ownerState.color !== 'default' && {
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
    color: (theme.vars || theme).palette[ownerState.color].contrastText
  }, ownerState.onDelete && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : colorManipulatorExports.alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  }, ownerState.onDelete && ownerState.color !== 'default' && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
    }
  });
}, ({
  theme,
  ownerState
}) => _extends({}, ownerState.clickable && {
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : colorManipulatorExports.alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : colorManipulatorExports.alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
  },
  '&:active': {
    boxShadow: (theme.vars || theme).shadows[1]
  }
}, ownerState.clickable && ownerState.color !== 'default' && {
  [`&:hover, &.${chipClasses$1.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
  }
}), ({
  theme,
  ownerState
}) => _extends({}, ownerState.variant === 'outlined' && {
  backgroundColor: 'transparent',
  border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: (theme.vars || theme).palette.action.hover
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`& .${chipClasses$1.avatar}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.icon}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${chipClasses$1.deleteIconSmall}`]: {
    marginRight: 3
  }
}, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
  color: (theme.vars || theme).palette[ownerState.color].main,
  border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : colorManipulatorExports.alpha(theme.palette[ownerState.color].main, 0.7)}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : colorManipulatorExports.alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : colorManipulatorExports.alpha(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : colorManipulatorExports.alpha(theme.palette[ownerState.color].main, 0.7),
    '&:hover, &:active': {
      color: (theme.vars || theme).palette[ownerState.color].main
    }
  }
}));
const ChipLabel = styled('span', {
  name: 'MuiChip',
  slot: 'Label',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      size
    } = ownerState;
    return [styles.label, styles[`label${capitalize(size)}`]];
  }
})(({
  ownerState
}) => _extends({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: 'nowrap'
}, ownerState.variant === 'outlined' && {
  paddingLeft: 11,
  paddingRight: 11
}, ownerState.size === 'small' && {
  paddingLeft: 8,
  paddingRight: 8
}, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
  paddingLeft: 7,
  paddingRight: 7
}));
function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}

/**
 * Chips represent complex entities in small blocks, such as a contact.
 */
const Chip = /*#__PURE__*/React.forwardRef(function Chip(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiChip'
  });
  const {
      avatar: avatarProp,
      className,
      clickable: clickableProp,
      color = 'default',
      component: ComponentProp,
      deleteIcon: deleteIconProp,
      disabled = false,
      icon: iconProp,
      label,
      onClick,
      onDelete,
      onKeyDown,
      onKeyUp,
      size = 'medium',
      variant = 'filled',
      tabIndex,
      skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$t);
  const chipRef = React.useRef(null);
  const handleRef = useForkRef(chipRef, ref);
  const handleDeleteIconClick = event => {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();
    if (onDelete) {
      onDelete(event);
    }
  };
  const handleKeyDown = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // Will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  const handleKeyUp = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }
    if (onKeyUp) {
      onKeyUp(event);
    }
  };
  const clickable = clickableProp !== false && onClick ? true : clickableProp;
  const component = clickable || onDelete ? ButtonBase : ComponentProp || 'div';
  const ownerState = _extends({}, props, {
    component,
    disabled,
    size,
    color,
    iconColor: /*#__PURE__*/React.isValidElement(iconProp) ? iconProp.props.color || color : color,
    onDelete: !!onDelete,
    clickable,
    variant
  });
  const classes = useUtilityClasses$r(ownerState);
  const moreProps = component === ButtonBase ? _extends({
    component: ComponentProp || 'div',
    focusVisibleClassName: classes.focusVisible
  }, onDelete && {
    disableRipple: true
  }) : {};
  let deleteIcon = null;
  if (onDelete) {
    deleteIcon = deleteIconProp && /*#__PURE__*/React.isValidElement(deleteIconProp) ? ( /*#__PURE__*/React.cloneElement(deleteIconProp, {
      className: clsx$1(deleteIconProp.props.className, classes.deleteIcon),
      onClick: handleDeleteIconClick
    })) : /*#__PURE__*/jsx(CancelIcon, {
      className: clsx$1(classes.deleteIcon),
      onClick: handleDeleteIconClick
    });
  }
  let avatar = null;
  if (avatarProp && /*#__PURE__*/React.isValidElement(avatarProp)) {
    avatar = /*#__PURE__*/React.cloneElement(avatarProp, {
      className: clsx$1(classes.avatar, avatarProp.props.className)
    });
  }
  let icon = null;
  if (iconProp && /*#__PURE__*/React.isValidElement(iconProp)) {
    icon = /*#__PURE__*/React.cloneElement(iconProp, {
      className: clsx$1(classes.icon, iconProp.props.className)
    });
  }
  if (process.env.NODE_ENV !== 'production') {
    if (avatar && icon) {
      console.error('MUI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }
  return /*#__PURE__*/jsxs(ChipRoot, _extends({
    as: component,
    className: clsx$1(classes.root, className),
    disabled: clickable && disabled ? true : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef,
    tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
    ownerState: ownerState
  }, moreProps, other, {
    children: [avatar || icon, /*#__PURE__*/jsx(ChipLabel, {
      className: clsx$1(classes.label),
      ownerState: ownerState,
      children: label
    }), deleteIcon]
  }));
});
process.env.NODE_ENV !== "production" ? Chip.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Icon element.
   */
  icon: PropTypes.element,
  /**
   * The content of the component.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  tabIndex: PropTypes.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['filled', 'outlined']), PropTypes.string])
} : void 0;
var Chip$1 = Chip;

const LegalEmployeesPanel = () => {
    const { legalEmployeesPanel: strings } = useStrings();
    const { getOnlineMessage } = useOnlineStatus();
    const dispatch = useTypedDispatch();
    const { data, isLoading, error } = useGetUserLegalEmployeesQuery();
    const [enableUserLegalEmployee] = useEnableUserLegalEmployeeMutation();
    const [disableUserLegalEmployee] = useDisableUserLegalEmployeeMutation();
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const employeesTable = useMemo(() => { var _a; return (_a = data === null || data === void 0 ? void 0 : data.employees.map(employee => (Object.assign({ id: employee.email }, employee)))) !== null && _a !== void 0 ? _a : []; }, [data === null || data === void 0 ? void 0 : data.employees]);
    function toggleUserLegalEmployeeStatus({ enabled, email }) {
        try {
            if (enabled) {
                disableUserLegalEmployee({ email });
            }
            else {
                enableUserLegalEmployee({ email });
            }
        }
        catch (_a) {
            dispatch(queueNotification(getOnlineMessage(strings.changeStatusError)));
        }
    }
    function getRow(rowIndex) {
        const item = employeesTable[rowIndex];
        const { id, email, enabled } = item;
        return {
            id,
            component: ({ rowProps }) => (React__default.createElement(Table.Row, { rowProps: rowProps },
                React__default.createElement(Table.TextCell, null,
                    email,
                    " ",
                    !enabled && React__default.createElement(Chip$1, { label: strings.disabledStatus, size: "small" })),
                React__default.createElement(Table.ActionCell, null,
                    React__default.createElement(Switch$1, { checked: enabled, role: "switch", "aria-label": strings.employeeStatusSwitch, "aria-checked": enabled, onChange: () => toggleUserLegalEmployeeStatus(item) })))),
            props: { item }
        };
    }
    return React__default.createElement(Panel, null,
        React__default.createElement(Panel.Header, { title: strings.header }),
        React__default.createElement(Panel.Content, null,
            React__default.createElement("p", null, strings.description),
            React__default.createElement(Table, { className: className$H('employeesTable'), title: strings.tableTitle, columns: [
                    { id: 'emailAddress', title: strings.emailAddress, className: className$H('emailAddress') },
                    { id: 'actions', title: '' }
                ], rowCount: employeesTable.length, isLoading: isLoading, getRow: getRow }, (() => {
                if (errorMessage) {
                    return React__default.createElement(Panel.Message, { text: errorMessage });
                }
                if (!employeesTable.length) {
                    return React__default.createElement(EmptyTableRow, { message: strings.empty, size: "sm" });
                }
            })())));
};
const className$H = createClassName('LegalEmployeesPanel');

// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function createFilterOptions(config = {}) {
  const {
    ignoreAccents = true,
    ignoreCase = true,
    limit,
    matchFrom = 'any',
    stringify,
    trim = false
  } = config;
  return (options, {
    inputValue,
    getOptionLabel
  }) => {
    let input = trim ? inputValue.trim() : inputValue;
    if (ignoreCase) {
      input = input.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
    }
    const filteredOptions = !input ? options : options.filter(option => {
      let candidate = (stringify || getOptionLabel)(option);
      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }
      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }
      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  };
}

// To replace with .findIndex() once we stop IE11 support.
function findIndex(array, comp) {
  for (let i = 0; i < array.length; i += 1) {
    if (comp(array[i])) {
      return i;
    }
  }
  return -1;
}
const defaultFilterOptions = createFilterOptions();

// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const pageSize = 5;
const defaultIsActiveElementInListbox = listboxRef => {
  var _listboxRef$current$p;
  return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const MULTIPLE_DEFAULT_VALUE = [];
function useAutocomplete(props) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = defaultIsActiveElementInListbox,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui',
    autoComplete = false,
    autoHighlight = false,
    autoSelect = false,
    blurOnSelect = false,
    clearOnBlur = !props.freeSolo,
    clearOnEscape = false,
    componentName = 'useAutocomplete',
    defaultValue = props.multiple ? MULTIPLE_DEFAULT_VALUE : null,
    disableClearable = false,
    disableCloseOnSelect = false,
    disabled: disabledProp,
    disabledItemsFocusable = false,
    disableListWrap = false,
    filterOptions = defaultFilterOptions,
    filterSelectedOptions = false,
    freeSolo = false,
    getOptionDisabled,
    getOptionKey,
    getOptionLabel: getOptionLabelProp = option => {
      var _option$label;
      return (_option$label = option.label) != null ? _option$label : option;
    },
    groupBy,
    handleHomeEndKeys = !props.freeSolo,
    id: idProp,
    includeInputInList = false,
    inputValue: inputValueProp,
    isOptionEqualToValue = (option, value) => option === value,
    multiple = false,
    onChange,
    onClose,
    onHighlightChange,
    onInputChange,
    onOpen,
    open: openProp,
    openOnFocus = false,
    options,
    readOnly = false,
    selectOnFocus = !props.freeSolo,
    value: valueProp
  } = props;
  const id = useId(idProp);
  let getOptionLabel = getOptionLabelProp;
  getOptionLabel = option => {
    const optionLabel = getOptionLabelProp(option);
    if (typeof optionLabel !== 'string') {
      if (process.env.NODE_ENV !== 'production') {
        const erroneousReturn = optionLabel === undefined ? 'undefined' : `${typeof optionLabel} (${optionLabel})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${componentName} returned ${erroneousReturn} instead of a string for ${JSON.stringify(option)}.`);
      }
      return String(optionLabel);
    }
    return optionLabel;
  };
  const ignoreFocus = React.useRef(false);
  const firstFocus = React.useRef(true);
  const inputRef = React.useRef(null);
  const listboxRef = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [focusedTag, setFocusedTag] = React.useState(-1);
  const defaultHighlighted = autoHighlight ? 0 : -1;
  const highlightedIndexRef = React.useRef(defaultHighlighted);
  const [value, setValueState] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  });
  const [inputValue, setInputValueState] = useControlled({
    controlled: inputValueProp,
    default: '',
    name: componentName,
    state: 'inputValue'
  });
  const [focused, setFocused] = React.useState(false);
  const resetInputValue = React.useCallback((event, newValue) => {
    // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
    // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
    const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
    if (!isOptionSelected && !clearOnBlur) {
      return;
    }
    let newInputValue;
    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      const optionLabel = getOptionLabel(newValue);
      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }
    if (inputValue === newInputValue) {
      return;
    }
    setInputValueState(newInputValue);
    if (onInputChange) {
      onInputChange(event, newInputValue, 'reset');
    }
  }, [getOptionLabel, inputValue, multiple, onInputChange, setInputValueState, clearOnBlur, value]);
  const [open, setOpenState] = useControlled({
    controlled: openProp,
    default: false,
    name: componentName,
    state: 'open'
  });
  const [inputPristine, setInputPristine] = React.useState(true);
  const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  const popupOpen = open && !readOnly;
  const filteredOptions = popupOpen ? filterOptions(options.filter(option => {
    if (filterSelectedOptions && (multiple ? value : [value]).some(value2 => value2 !== null && isOptionEqualToValue(option, value2))) {
      return false;
    }
    return true;
  }),
  // we use the empty string to manipulate `filterOptions` to not filter any options
  // i.e. the filter predicate always returns true
  {
    inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
    getOptionLabel
  }) : [];
  const previousProps = usePreviousProps({
    filteredOptions,
    value,
    inputValue
  });
  React.useEffect(() => {
    const valueChange = value !== previousProps.value;
    if (focused && !valueChange) {
      return;
    }

    // Only reset the input's value when freeSolo if the component's value changes.
    if (freeSolo && !valueChange) {
      return;
    }
    resetInputValue(null, value);
  }, [value, resetInputValue, focused, previousProps.value, freeSolo]);
  const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
  if (process.env.NODE_ENV !== 'production') {
    if (value !== null && !freeSolo && options.length > 0) {
      const missingValue = (multiple ? value : [value]).filter(value2 => !options.some(option => isOptionEqualToValue(option, value2)));
      if (missingValue.length > 0) {
        console.warn([`MUI: The value provided to ${componentName} is invalid.`, `None of the options match with \`${missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0])}\`.`, 'You can use the `isOptionEqualToValue` prop to customize the equality test.'].join('\n'));
      }
    }
  }
  const focusTag = useEventCallback(tagToFocus => {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    }
  });

  // Ensure the focusedTag is never inconsistent
  React.useEffect(() => {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);
  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index < 0 || index >= filteredOptions.length) {
      return -1;
    }
    let nextFocus = index;
    while (true) {
      const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);

      // Same logic as MenuList.js
      const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
      if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) {
        // The next option is available
        return nextFocus;
      }

      // The next option is disabled, move to the next element.
      // with looped index
      if (direction === 'next') {
        nextFocus = (nextFocus + 1) % filteredOptions.length;
      } else {
        nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
      }

      // We end up with initial index, that means we don't have available options.
      // All of them are disabled
      if (nextFocus === index) {
        return -1;
      }
    }
  }
  const setHighlightedIndex = useEventCallback(({
    event,
    index,
    reason = 'auto'
  }) => {
    highlightedIndexRef.current = index;

    // does the index exist?
    if (index === -1) {
      inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
    }
    if (onHighlightChange) {
      onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
    }
    if (!listboxRef.current) {
      return;
    }
    const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
    if (prev) {
      prev.classList.remove(`${unstable_classNamePrefix}-focused`);
      prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
    }
    let listboxNode = listboxRef.current;
    if (listboxRef.current.getAttribute('role') !== 'listbox') {
      listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
    }

    // "No results"
    if (!listboxNode) {
      return;
    }
    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }
    const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
    if (!option) {
      return;
    }
    option.classList.add(`${unstable_classNamePrefix}-focused`);
    if (reason === 'keyboard') {
      option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
    }

    // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
    // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
      const element = option;
      const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      const elementBottom = element.offsetTop + element.offsetHeight;
      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  const changeHighlightedIndex = useEventCallback(({
    event,
    diff,
    direction = 'next',
    reason = 'auto'
  }) => {
    if (!popupOpen) {
      return;
    }
    const getNextIndex = () => {
      const maxIndex = filteredOptions.length - 1;
      if (diff === 'reset') {
        return defaultHighlighted;
      }
      if (diff === 'start') {
        return 0;
      }
      if (diff === 'end') {
        return maxIndex;
      }
      const newIndex = highlightedIndexRef.current + diff;
      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }
        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }
        return maxIndex;
      }
      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }
        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }
        return 0;
      }
      return newIndex;
    };
    const nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex({
      index: nextIndex,
      reason,
      event
    });

    // Sync the content of the input with the highlighted option.
    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        const option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option;

        // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.
        const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  const getPreviousHighlightedOptionIndex = () => {
    const isSameValue = (value1, value2) => {
      const label1 = value1 ? getOptionLabel(value1) : '';
      const label2 = value2 ? getOptionLabel(value2) : '';
      return label1 === label2;
    };
    if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i) => getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
      const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
      if (previousHighlightedOption) {
        return findIndex(filteredOptions, option => {
          return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
        });
      }
    }
    return -1;
  };
  const syncHighlightedIndex = React.useCallback(() => {
    if (!popupOpen) {
      return;
    }

    // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
    // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
    const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
    if (previousHighlightedOptionIndex !== -1) {
      highlightedIndexRef.current = previousHighlightedOptionIndex;
      return;
    }
    const valueItem = multiple ? value[0] : value;

    // The popup is empty, reset
    if (filteredOptions.length === 0 || valueItem == null) {
      changeHighlightedIndex({
        diff: 'reset'
      });
      return;
    }
    if (!listboxRef.current) {
      return;
    }

    // Synchronize the value with the highlighted index
    if (valueItem != null) {
      const currentOption = filteredOptions[highlightedIndexRef.current];

      // Keep the current highlighted index if possible
      if (multiple && currentOption && findIndex(value, val => isOptionEqualToValue(currentOption, val)) !== -1) {
        return;
      }
      const itemIndex = findIndex(filteredOptions, optionItem => isOptionEqualToValue(optionItem, valueItem));
      if (itemIndex === -1) {
        changeHighlightedIndex({
          diff: 'reset'
        });
      } else {
        setHighlightedIndex({
          index: itemIndex
        });
      }
      return;
    }

    // Prevent the highlighted index to leak outside the boundaries.
    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex({
        index: filteredOptions.length - 1
      });
      return;
    }

    // Restore the focus to the previous index.
    setHighlightedIndex({
      index: highlightedIndexRef.current
    });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
  // Only sync the highlighted index when the option switch between empty and not
  filteredOptions.length,
  // Don't sync the highlighted index with the value when multiple
  // eslint-disable-next-line react-hooks/exhaustive-deps
  multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
  const handleListboxRef = useEventCallback(node => {
    setRef(listboxRef, node);
    if (!node) {
      return;
    }
    syncHighlightedIndex();
  });
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => {
      if (!inputRef.current || inputRef.current.nodeName !== 'INPUT') {
        if (inputRef.current && inputRef.current.nodeName === 'TEXTAREA') {
          console.warn([`A textarea element was provided to ${componentName} where input was expected.`, `This is not a supported scenario but it may work under certain conditions.`, `A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).`, `Make sure to test keyboard navigation and add custom event handlers if necessary.`].join('\n'));
        } else {
          console.error([`MUI: Unable to find the input element. It was resolved to ${inputRef.current} while an HTMLInputElement was expected.`, `Instead, ${componentName} expects an input element.`, '', componentName === 'useAutocomplete' ? 'Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed.' : 'Make sure you have customized the input component correctly.'].join('\n'));
        }
      }
    }, [componentName]);
  }
  React.useEffect(() => {
    syncHighlightedIndex();
  }, [syncHighlightedIndex]);
  const handleOpen = event => {
    if (open) {
      return;
    }
    setOpenState(true);
    setInputPristine(true);
    if (onOpen) {
      onOpen(event);
    }
  };
  const handleClose = (event, reason) => {
    if (!open) {
      return;
    }
    setOpenState(false);
    if (onClose) {
      onClose(event, reason);
    }
  };
  const handleValue = (event, newValue, reason, details) => {
    if (multiple) {
      if (value.length === newValue.length && value.every((val, i) => val === newValue[i])) {
        return;
      }
    } else if (value === newValue) {
      return;
    }
    if (onChange) {
      onChange(event, newValue, reason, details);
    }
    setValueState(newValue);
  };
  const isTouch = React.useRef(false);
  const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options') => {
    let reason = reasonProp;
    let newValue = option;
    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      if (process.env.NODE_ENV !== 'production') {
        const matches = newValue.filter(val => isOptionEqualToValue(option, val));
        if (matches.length > 1) {
          console.error([`MUI: The \`isOptionEqualToValue\` method of ${componentName} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${matches.length} matches.`].join('\n'));
        }
      }
      const itemIndex = findIndex(newValue, valueItem => isOptionEqualToValue(option, valueItem));
      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== 'freeSolo') {
        newValue.splice(itemIndex, 1);
        reason = 'removeOption';
      }
    }
    resetInputValue(event, newValue);
    handleValue(event, newValue, reason, {
      option
    });
    if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) {
      handleClose(event, reason);
    }
    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
      inputRef.current.blur();
    }
  };
  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }
    let nextFocus = index;
    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }
      const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);

      // Same logic as MenuList.js
      if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }
  const handleFocusTag = (event, direction) => {
    if (!multiple) {
      return;
    }
    if (inputValue === '') {
      handleClose(event, 'toggleInput');
    }
    let nextTag = focusedTag;
    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;
      if (nextTag < 0) {
        nextTag = 0;
      }
      if (nextTag === value.length) {
        nextTag = -1;
      }
    }
    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };
  const handleClear = event => {
    ignoreFocus.current = true;
    setInputValueState('');
    if (onInputChange) {
      onInputChange(event, '', 'clear');
    }
    handleValue(event, multiple ? [] : null, 'clear');
  };
  const handleKeyDown = other => event => {
    if (other.onKeyDown) {
      other.onKeyDown(event);
    }
    if (event.defaultMuiPrevented) {
      return;
    }
    if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
      setFocusedTag(-1);
      focusTag(-1);
    }

    // Wait until IME is settled.
    if (event.which !== 229) {
      switch (event.key) {
        case 'Home':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'start',
              direction: 'next',
              reason: 'keyboard',
              event
            });
          }
          break;
        case 'End':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'end',
              direction: 'previous',
              reason: 'keyboard',
              event
            });
          }
          break;
        case 'PageUp':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: -pageSize,
            direction: 'previous',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'PageDown':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: pageSize,
            direction: 'next',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'ArrowDown':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: 1,
            direction: 'next',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'ArrowUp':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: -1,
            direction: 'previous',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'ArrowLeft':
          handleFocusTag(event, 'previous');
          break;
        case 'ArrowRight':
          handleFocusTag(event, 'next');
          break;
        case 'Enter':
          if (highlightedIndexRef.current !== -1 && popupOpen) {
            const option = filteredOptions[highlightedIndexRef.current];
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;

            // Avoid early form validation, let the end-users continue filling the form.
            event.preventDefault();
            if (disabled) {
              return;
            }
            selectNewValue(event, option, 'selectOption');

            // Move the selection to the end.
            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
            if (multiple) {
              // Allow people to add new values before they submit the form.
              event.preventDefault();
            }
            selectNewValue(event, inputValue, 'createOption', 'freeSolo');
          }
          break;
        case 'Escape':
          if (popupOpen) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault();
            // Avoid the Modal to handle the event.
            event.stopPropagation();
            handleClose(event, 'escape');
          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault();
            // Avoid the Modal to handle the event.
            event.stopPropagation();
            handleClear(event);
          }
          break;
        case 'Backspace':
          // Remove the value on the left of the "cursor"
          if (multiple && !readOnly && inputValue === '' && value.length > 0) {
            const index = focusedTag === -1 ? value.length - 1 : focusedTag;
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
              option: value[index]
            });
          }
          break;
        case 'Delete':
          // Remove the value on the right of the "cursor"
          if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
            const index = focusedTag;
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
              option: value[index]
            });
          }
          break;
      }
    }
  };
  const handleFocus = event => {
    setFocused(true);
    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };
  const handleBlur = event => {
    // Ignore the event when using the scrollbar with IE11
    if (unstable_isActiveElementInListbox(listboxRef)) {
      inputRef.current.focus();
      return;
    }
    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;
    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
    } else if (autoSelect && freeSolo && inputValue !== '') {
      selectNewValue(event, inputValue, 'blur', 'freeSolo');
    } else if (clearOnBlur) {
      resetInputValue(event, value);
    }
    handleClose(event, 'blur');
  };
  const handleInputChange = event => {
    const newValue = event.target.value;
    if (inputValue !== newValue) {
      setInputValueState(newValue);
      setInputPristine(false);
      if (onInputChange) {
        onInputChange(event, newValue, 'input');
      }
    }
    if (newValue === '') {
      if (!disableClearable && !multiple) {
        handleValue(event, null, 'clear');
      }
    } else {
      handleOpen(event);
    }
  };
  const handleOptionMouseMove = event => {
    const index = Number(event.currentTarget.getAttribute('data-option-index'));
    if (highlightedIndexRef.current !== index) {
      setHighlightedIndex({
        event,
        index,
        reason: 'mouse'
      });
    }
  };
  const handleOptionTouchStart = event => {
    setHighlightedIndex({
      event,
      index: Number(event.currentTarget.getAttribute('data-option-index')),
      reason: 'touch'
    });
    isTouch.current = true;
  };
  const handleOptionClick = event => {
    const index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index], 'selectOption');
    isTouch.current = false;
  };
  const handleTagDelete = index => event => {
    const newValue = value.slice();
    newValue.splice(index, 1);
    handleValue(event, newValue, 'removeOption', {
      option: value[index]
    });
  };
  const handlePopupIndicator = event => {
    if (open) {
      handleClose(event, 'toggleInput');
    } else {
      handleOpen(event);
    }
  };

  // Prevent input blur when interacting with the combobox
  const handleMouseDown = event => {
    // Prevent focusing the input if click is anywhere outside the Autocomplete
    if (!event.currentTarget.contains(event.target)) {
      return;
    }
    if (event.target.getAttribute('id') !== id) {
      event.preventDefault();
    }
  };

  // Focus the input when interacting with the combobox
  const handleClick = event => {
    // Prevent focusing the input if click is anywhere outside the Autocomplete
    if (!event.currentTarget.contains(event.target)) {
      return;
    }
    inputRef.current.focus();
    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }
    firstFocus.current = false;
  };
  const handleInputMouseDown = event => {
    if (!disabledProp && (inputValue === '' || !open)) {
      handlePopupIndicator(event);
    }
  };
  let dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  let groupedOptions = filteredOptions;
  if (groupBy) {
    // used to keep track of key and indexes in the result array
    const indexBy = new Map();
    let warn = false;
    groupedOptions = filteredOptions.reduce((acc, option, index) => {
      const group = groupBy(option);
      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          if (indexBy.get(group) && !warn) {
            console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${componentName} returns duplicated headers.`, 'You can solve the issue by sorting the options with the output of `groupBy`.');
            warn = true;
          }
          indexBy.set(group, true);
        }
        acc.push({
          key: index,
          index,
          group,
          options: [option]
        });
      }
      return acc;
    }, []);
  }
  if (disabledProp && focused) {
    handleBlur();
  }
  return {
    getRootProps: (other = {}) => _extends({
      'aria-owns': listboxAvailable ? `${id}-listbox` : null
    }, other, {
      onKeyDown: handleKeyDown(other),
      onMouseDown: handleMouseDown,
      onClick: handleClick
    }),
    getInputLabelProps: () => ({
      id: `${id}-label`,
      htmlFor: id
    }),
    getInputProps: () => ({
      id,
      value: inputValue,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onChange: handleInputChange,
      onMouseDown: handleInputMouseDown,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      'aria-activedescendant': popupOpen ? '' : null,
      'aria-autocomplete': autoComplete ? 'both' : 'list',
      'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
      'aria-expanded': listboxAvailable,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: 'off',
      ref: inputRef,
      autoCapitalize: 'none',
      spellCheck: 'false',
      role: 'combobox',
      disabled: disabledProp
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: 'button',
      onClick: handleClear
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: 'button',
      onClick: handlePopupIndicator
    }),
    getTagProps: ({
      index
    }) => _extends({
      key: index,
      'data-tag-index': index,
      tabIndex: -1
    }, !readOnly && {
      onDelete: handleTagDelete(index)
    }),
    getListboxProps: () => ({
      role: 'listbox',
      id: `${id}-listbox`,
      'aria-labelledby': `${id}-label`,
      ref: handleListboxRef,
      onMouseDown: event => {
        // Prevent blur
        event.preventDefault();
      }
    }),
    getOptionProps: ({
      index,
      option
    }) => {
      var _getOptionKey;
      const selected = (multiple ? value : [value]).some(value2 => value2 != null && isOptionEqualToValue(option, value2));
      const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
        tabIndex: -1,
        role: 'option',
        id: `${id}-option-${index}`,
        onMouseMove: handleOptionMouseMove,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id,
    inputValue,
    value,
    dirty,
    expanded: popupOpen && anchorEl,
    popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl,
    setAnchorEl,
    focusedTag,
    groupedOptions
  };
}

function getListSubheaderUtilityClass(slot) {
  return generateUtilityClass('MuiListSubheader', slot);
}
generateUtilityClasses('MuiListSubheader', ['root', 'colorPrimary', 'colorInherit', 'gutters', 'inset', 'sticky']);

const _excluded$s = ["className", "color", "component", "disableGutters", "disableSticky", "inset"];
const useUtilityClasses$q = ownerState => {
  const {
    classes,
    color,
    disableGutters,
    inset,
    disableSticky
  } = ownerState;
  const slots = {
    root: ['root', color !== 'default' && `color${capitalize(color)}`, !disableGutters && 'gutters', inset && 'inset', !disableSticky && 'sticky']
  };
  return composeClasses(slots, getListSubheaderUtilityClass, classes);
};
const ListSubheaderRoot = styled('li', {
  name: 'MuiListSubheader',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${capitalize(ownerState.color)}`], !ownerState.disableGutters && styles.gutters, ownerState.inset && styles.inset, !ownerState.disableSticky && styles.sticky];
  }
})(({
  theme,
  ownerState
}) => _extends({
  boxSizing: 'border-box',
  lineHeight: '48px',
  listStyle: 'none',
  color: (theme.vars || theme).palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(14)
}, ownerState.color === 'primary' && {
  color: (theme.vars || theme).palette.primary.main
}, ownerState.color === 'inherit' && {
  color: 'inherit'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.inset && {
  paddingLeft: 72
}, !ownerState.disableSticky && {
  position: 'sticky',
  top: 0,
  zIndex: 1,
  backgroundColor: (theme.vars || theme).palette.background.paper
}));
const ListSubheader = /*#__PURE__*/React.forwardRef(function ListSubheader(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiListSubheader'
  });
  const {
      className,
      color = 'default',
      component = 'li',
      disableGutters = false,
      disableSticky = false,
      inset = false
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$s);
  const ownerState = _extends({}, props, {
    color,
    component,
    disableGutters,
    disableSticky,
    inset
  });
  const classes = useUtilityClasses$q(ownerState);
  return /*#__PURE__*/jsx(ListSubheaderRoot, _extends({
    as: component,
    className: clsx$1(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
ListSubheader.muiSkipListHighlight = true;
process.env.NODE_ENV !== "production" ? ListSubheader.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary']),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: PropTypes.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var ListSubheader$1 = ListSubheader;

function getIconButtonUtilityClass(slot) {
  return generateUtilityClass('MuiIconButton', slot);
}
const iconButtonClasses = generateUtilityClasses('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
var iconButtonClasses$1 = iconButtonClasses;

const _excluded$r = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];
const useUtilityClasses$p = ownerState => {
  const {
    classes,
    disabled,
    color,
    edge,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && `color${capitalize(color)}`, edge && `edge${capitalize(edge)}`, `size${capitalize(size)}`]
  };
  return composeClasses(slots, getIconButtonUtilityClass, classes);
};
const IconButtonRoot = styled(ButtonBase, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${capitalize(ownerState.color)}`], ownerState.edge && styles[`edge${capitalize(ownerState.edge)}`], styles[`size${capitalize(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: (theme.vars || theme).palette.action.active,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  })
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : colorManipulatorExports.alpha(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}), ({
  theme,
  ownerState
}) => {
  var _palette;
  const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
  return _extends({}, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && _extends({
    color: palette == null ? void 0 : palette.main
  }, !ownerState.disableRipple && {
    '&:hover': _extends({}, palette && {
      backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : colorManipulatorExports.alpha(palette.main, theme.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    })
  }), ownerState.size === 'small' && {
    padding: 5,
    fontSize: theme.typography.pxToRem(18)
  }, ownerState.size === 'large' && {
    padding: 12,
    fontSize: theme.typography.pxToRem(28)
  }, {
    [`&.${iconButtonClasses$1.disabled}`]: {
      backgroundColor: 'transparent',
      color: (theme.vars || theme).palette.action.disabled
    }
  });
});

/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */
const IconButton = /*#__PURE__*/React.forwardRef(function IconButton(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiIconButton'
  });
  const {
      edge = false,
      children,
      className,
      color = 'default',
      disabled = false,
      disableFocusRipple = false,
      size = 'medium'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$r);
  const ownerState = _extends({}, props, {
    edge,
    color,
    disabled,
    disableFocusRipple,
    size
  });
  const classes = useUtilityClasses$p(ownerState);
  return /*#__PURE__*/jsx(IconButtonRoot, _extends({
    className: clsx$1(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other, {
    ownerState: ownerState,
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? IconButton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes.node, props => {
    const found = React.Children.toArray(props.children).some(child => /*#__PURE__*/React.isValidElement(child) && child.props.onClick);
    if (found) {
      return new Error(['MUI: You are providing an onClick event listener to a child of a button element.', 'Prefer applying it to the IconButton directly.', 'This guarantees that the whole <button> will be responsive to click events.'].join('\n'));
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(['end', 'start', false]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['small', 'medium', 'large']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var IconButton$1 = IconButton;

var ClearIcon = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

function getAutocompleteUtilityClass(slot) {
  return generateUtilityClass('MuiAutocomplete', slot);
}
const autocompleteClasses = generateUtilityClasses('MuiAutocomplete', ['root', 'expanded', 'fullWidth', 'focused', 'focusVisible', 'tag', 'tagSizeSmall', 'tagSizeMedium', 'hasPopupIcon', 'hasClearIcon', 'inputRoot', 'input', 'inputFocused', 'endAdornment', 'clearIndicator', 'popupIndicator', 'popupIndicatorOpen', 'popper', 'popperDisablePortal', 'paper', 'listbox', 'loading', 'noOptions', 'option', 'groupLabel', 'groupUl']);
var autocompleteClasses$1 = autocompleteClasses;

var _ClearIcon, _ArrowDropDownIcon;
const _excluded$q = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"],
  _excluded2$4 = ["ref"],
  _excluded3$1 = ["key"],
  _excluded4 = ["key"];
const useUtilityClasses$o = ownerState => {
  const {
    classes,
    disablePortal,
    expanded,
    focused,
    fullWidth,
    hasClearIcon,
    hasPopupIcon,
    inputFocused,
    popupOpen,
    size
  } = ownerState;
  const slots = {
    root: ['root', expanded && 'expanded', focused && 'focused', fullWidth && 'fullWidth', hasClearIcon && 'hasClearIcon', hasPopupIcon && 'hasPopupIcon'],
    inputRoot: ['inputRoot'],
    input: ['input', inputFocused && 'inputFocused'],
    tag: ['tag', `tagSize${capitalize(size)}`],
    endAdornment: ['endAdornment'],
    clearIndicator: ['clearIndicator'],
    popupIndicator: ['popupIndicator', popupOpen && 'popupIndicatorOpen'],
    popper: ['popper', disablePortal && 'popperDisablePortal'],
    paper: ['paper'],
    listbox: ['listbox'],
    loading: ['loading'],
    noOptions: ['noOptions'],
    option: ['option'],
    groupLabel: ['groupLabel'],
    groupUl: ['groupUl']
  };
  return composeClasses(slots, getAutocompleteUtilityClass, classes);
};
const AutocompleteRoot = styled('div', {
  name: 'MuiAutocomplete',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      fullWidth,
      hasClearIcon,
      hasPopupIcon,
      inputFocused,
      size
    } = ownerState;
    return [{
      [`& .${autocompleteClasses$1.tag}`]: styles.tag
    }, {
      [`& .${autocompleteClasses$1.tag}`]: styles[`tagSize${capitalize(size)}`]
    }, {
      [`& .${autocompleteClasses$1.inputRoot}`]: styles.inputRoot
    }, {
      [`& .${autocompleteClasses$1.input}`]: styles.input
    }, {
      [`& .${autocompleteClasses$1.input}`]: inputFocused && styles.inputFocused
    }, styles.root, fullWidth && styles.fullWidth, hasPopupIcon && styles.hasPopupIcon, hasClearIcon && styles.hasClearIcon];
  }
})({
  [`&.${autocompleteClasses$1.focused} .${autocompleteClasses$1.clearIndicator}`]: {
    visibility: 'visible'
  },
  /* Avoid double tap issue on iOS */
  '@media (pointer: fine)': {
    [`&:hover .${autocompleteClasses$1.clearIndicator}`]: {
      visibility: 'visible'
    }
  },
  [`& .${autocompleteClasses$1.tag}`]: {
    margin: 3,
    maxWidth: 'calc(100% - 6px)'
  },
  [`& .${autocompleteClasses$1.inputRoot}`]: {
    [`.${autocompleteClasses$1.hasPopupIcon}&, .${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 26 + 4
    },
    [`.${autocompleteClasses$1.hasPopupIcon}.${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 52 + 4
    },
    [`& .${autocompleteClasses$1.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${inputClasses.root}`]: {
    paddingBottom: 1,
    '& .MuiInput-input': {
      padding: '4px 4px 4px 0px'
    }
  },
  [`& .${inputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
    [`& .${inputClasses.input}`]: {
      padding: '2px 4px 3px 0'
    }
  },
  [`& .${outlinedInputClasses.root}`]: {
    padding: 9,
    [`.${autocompleteClasses$1.hasPopupIcon}&, .${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${autocompleteClasses$1.hasPopupIcon}.${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${autocompleteClasses$1.input}`]: {
      padding: '7.5px 4px 7.5px 5px'
    },
    [`& .${autocompleteClasses$1.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${outlinedInputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${autocompleteClasses$1.input}`]: {
      padding: '2.5px 4px 2.5px 8px'
    }
  },
  [`& .${filledInputClasses.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${autocompleteClasses$1.hasPopupIcon}&, .${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${autocompleteClasses$1.hasPopupIcon}.${autocompleteClasses$1.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${filledInputClasses.input}`]: {
      padding: '7px 4px'
    },
    [`& .${autocompleteClasses$1.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${filledInputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${filledInputClasses.input}`]: {
      padding: '2.5px 4px'
    }
  },
  [`& .${inputBaseClasses.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${filledInputClasses.root}.${inputBaseClasses.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${autocompleteClasses$1.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${filledInputClasses.root}.${inputBaseClasses.hiddenLabel}.${inputBaseClasses.sizeSmall}`]: {
    [`& .${autocompleteClasses$1.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${autocompleteClasses$1.input}`]: {
    flexGrow: 1,
    textOverflow: 'ellipsis',
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: true
    },
    style: {
      width: '100%'
    }
  }, {
    props: {
      size: 'small'
    },
    style: {
      [`& .${autocompleteClasses$1.tag}`]: {
        margin: 2,
        maxWidth: 'calc(100% - 4px)'
      }
    }
  }, {
    props: {
      inputFocused: true
    },
    style: {
      [`& .${autocompleteClasses$1.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: true
    },
    style: {
      [`& .${autocompleteClasses$1.inputRoot}`]: {
        flexWrap: 'wrap'
      }
    }
  }]
});
const AutocompleteEndAdornment = styled('div', {
  name: 'MuiAutocomplete',
  slot: 'EndAdornment',
  overridesResolver: (props, styles) => styles.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translate(0, -50%)'
});
const AutocompleteClearIndicator = styled(IconButton$1, {
  name: 'MuiAutocomplete',
  slot: 'ClearIndicator',
  overridesResolver: (props, styles) => styles.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: 'hidden'
});
const AutocompletePopupIndicator = styled(IconButton$1, {
  name: 'MuiAutocomplete',
  slot: 'PopupIndicator',
  overridesResolver: ({
    ownerState
  }, styles) => _extends({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: true
    },
    style: {
      transform: 'rotate(180deg)'
    }
  }]
});
const AutocompletePopper = styled(MuiPopper, {
  name: 'MuiAutocomplete',
  slot: 'Popper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${autocompleteClasses$1.option}`]: styles.option
    }, styles.popper, ownerState.disablePortal && styles.popperDisablePortal];
  }
})(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.modal,
  variants: [{
    props: {
      disablePortal: true
    },
    style: {
      position: 'absolute'
    }
  }]
}));
const AutocompletePaper = styled(Paper, {
  name: 'MuiAutocomplete',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})(({
  theme
}) => _extends({}, theme.typography.body1, {
  overflow: 'auto'
}));
const AutocompleteLoading = styled('div', {
  name: 'MuiAutocomplete',
  slot: 'Loading',
  overridesResolver: (props, styles) => styles.loading
})(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  padding: '14px 16px'
}));
const AutocompleteNoOptions = styled('div', {
  name: 'MuiAutocomplete',
  slot: 'NoOptions',
  overridesResolver: (props, styles) => styles.noOptions
})(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  padding: '14px 16px'
}));
const AutocompleteListbox = styled('div', {
  name: 'MuiAutocomplete',
  slot: 'Listbox',
  overridesResolver: (props, styles) => styles.listbox
})(({
  theme
}) => ({
  listStyle: 'none',
  margin: 0,
  padding: '8px 0',
  maxHeight: '40vh',
  overflow: 'auto',
  position: 'relative',
  [`& .${autocompleteClasses$1.option}`]: {
    minHeight: 48,
    display: 'flex',
    overflow: 'hidden',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    paddingTop: 6,
    boxSizing: 'border-box',
    outline: '0',
    WebkitTapHighlightColor: 'transparent',
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.up('sm')]: {
      minHeight: 'auto'
    },
    [`&.${autocompleteClasses$1.focused}`]: {
      backgroundColor: (theme.vars || theme).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (theme.vars || theme).palette.action.disabledOpacity,
      pointerEvents: 'none'
    },
    [`&.${autocompleteClasses$1.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : colorManipulatorExports.alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      [`&.${autocompleteClasses$1.focused}`]: {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : colorManipulatorExports.alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: (theme.vars || theme).palette.action.selected
        }
      },
      [`&.${autocompleteClasses$1.focusVisible}`]: {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : colorManipulatorExports.alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
      }
    }
  }
}));
const AutocompleteGroupLabel = styled(ListSubheader$1, {
  name: 'MuiAutocomplete',
  slot: 'GroupLabel',
  overridesResolver: (props, styles) => styles.groupLabel
})(({
  theme
}) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  top: -8
}));
const AutocompleteGroupUl = styled('ul', {
  name: 'MuiAutocomplete',
  slot: 'GroupUl',
  overridesResolver: (props, styles) => styles.groupUl
})({
  padding: 0,
  [`& .${autocompleteClasses$1.option}`]: {
    paddingLeft: 24
  }
});
const Autocomplete = /*#__PURE__*/React.forwardRef(function Autocomplete(inProps, ref) {
  var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiAutocomplete'
  });

  /* eslint-disable @typescript-eslint/no-unused-vars */
  const {
      autoComplete = false,
      autoHighlight = false,
      autoSelect = false,
      blurOnSelect = false,
      ChipProps,
      className,
      clearIcon = _ClearIcon || (_ClearIcon = /*#__PURE__*/jsx(ClearIcon, {
        fontSize: "small"
      })),
      clearOnBlur = !props.freeSolo,
      clearOnEscape = false,
      clearText = 'Clear',
      closeText = 'Close',
      componentsProps = {},
      defaultValue = props.multiple ? [] : null,
      disableClearable = false,
      disableCloseOnSelect = false,
      disabled = false,
      disabledItemsFocusable = false,
      disableListWrap = false,
      disablePortal = false,
      filterSelectedOptions = false,
      forcePopupIcon = 'auto',
      freeSolo = false,
      fullWidth = false,
      getLimitTagsText = more => `+${more}`,
      getOptionLabel: getOptionLabelProp,
      groupBy,
      handleHomeEndKeys = !props.freeSolo,
      includeInputInList = false,
      limitTags = -1,
      ListboxComponent = 'ul',
      ListboxProps,
      loading = false,
      loadingText = 'Loading…',
      multiple = false,
      noOptionsText = 'No options',
      openOnFocus = false,
      openText = 'Open',
      PaperComponent = Paper,
      PopperComponent = MuiPopper,
      popupIcon = _ArrowDropDownIcon || (_ArrowDropDownIcon = /*#__PURE__*/jsx(ArrowDropDownIcon$1, {})),
      readOnly = false,
      renderGroup: renderGroupProp,
      renderInput,
      renderOption: renderOptionProp,
      renderTags,
      selectOnFocus = !props.freeSolo,
      size = 'medium',
      slotProps = {}
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$q);
  /* eslint-enable @typescript-eslint/no-unused-vars */

  const {
    getRootProps,
    getInputProps,
    getInputLabelProps,
    getPopupIndicatorProps,
    getClearProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    value,
    dirty,
    expanded,
    id,
    popupOpen,
    focused,
    focusedTag,
    anchorEl,
    setAnchorEl,
    inputValue,
    groupedOptions
  } = useAutocomplete(_extends({}, props, {
    componentName: 'Autocomplete'
  }));
  const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
  const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  const {
    onMouseDown: handleInputMouseDown
  } = getInputProps();
  const {
    ref: externalListboxRef
  } = ListboxProps != null ? ListboxProps : {};
  const _getListboxProps = getListboxProps(),
    {
      ref: listboxRef
    } = _getListboxProps,
    otherListboxProps = _objectWithoutPropertiesLoose(_getListboxProps, _excluded2$4);
  const combinedListboxRef = useForkRef(listboxRef, externalListboxRef);
  const defaultGetOptionLabel = option => {
    var _option$label;
    return (_option$label = option.label) != null ? _option$label : option;
  };
  const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;

  // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
  const ownerState = _extends({}, props, {
    disablePortal,
    expanded,
    focused,
    fullWidth,
    getOptionLabel,
    hasClearIcon,
    hasPopupIcon,
    inputFocused: focusedTag === -1,
    popupOpen,
    size
  });
  const classes = useUtilityClasses$o(ownerState);
  let startAdornment;
  if (multiple && value.length > 0) {
    const getCustomizedTagProps = params => _extends({
      className: classes.tag,
      disabled
    }, getTagProps(params));
    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
    } else {
      startAdornment = value.map((option, index) => {
        const _getCustomizedTagProp = getCustomizedTagProps({
            index
          }),
          {
            key
          } = _getCustomizedTagProp,
          customTagProps = _objectWithoutPropertiesLoose(_getCustomizedTagProp, _excluded3$1);
        return /*#__PURE__*/jsx(Chip$1, _extends({
          label: getOptionLabel(option),
          size: size
        }, customTagProps, ChipProps), key);
      });
    }
  }
  if (limitTags > -1 && Array.isArray(startAdornment)) {
    const more = startAdornment.length - limitTags;
    if (!focused && more > 0) {
      startAdornment = startAdornment.splice(0, limitTags);
      startAdornment.push( /*#__PURE__*/jsx("span", {
        className: classes.tag,
        children: getLimitTagsText(more)
      }, startAdornment.length));
    }
  }
  const defaultRenderGroup = params => /*#__PURE__*/jsxs("li", {
    children: [/*#__PURE__*/jsx(AutocompleteGroupLabel, {
      className: classes.groupLabel,
      ownerState: ownerState,
      component: "div",
      children: params.group
    }), /*#__PURE__*/jsx(AutocompleteGroupUl, {
      className: classes.groupUl,
      ownerState: ownerState,
      children: params.children
    })]
  }, params.key);
  const renderGroup = renderGroupProp || defaultRenderGroup;
  const defaultRenderOption = (props2, option) => {
    // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
    const {
        key
      } = props2,
      otherProps = _objectWithoutPropertiesLoose(props2, _excluded4);
    return /*#__PURE__*/jsx("li", _extends({}, otherProps, {
      children: getOptionLabel(option)
    }), key);
  };
  const renderOption = renderOptionProp || defaultRenderOption;
  const renderListOption = (option, index) => {
    const optionProps = getOptionProps({
      option,
      index
    });
    return renderOption(_extends({}, optionProps, {
      className: classes.option
    }), option, {
      selected: optionProps['aria-selected'],
      index,
      inputValue
    }, ownerState);
  };
  const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
  const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
  const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
  const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
  const renderAutocompletePopperChildren = children => /*#__PURE__*/jsx(AutocompletePopper, _extends({
    as: PopperComponent,
    disablePortal: disablePortal,
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    ownerState: ownerState,
    role: "presentation",
    anchorEl: anchorEl,
    open: popupOpen
  }, popperSlotProps, {
    className: clsx$1(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
    children: /*#__PURE__*/jsx(AutocompletePaper, _extends({
      ownerState: ownerState,
      as: PaperComponent
    }, paperSlotProps, {
      className: clsx$1(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
      children: children
    }))
  }));
  let autocompletePopper = null;
  if (groupedOptions.length > 0) {
    autocompletePopper = renderAutocompletePopperChildren( /*#__PURE__*/jsx(AutocompleteListbox, _extends({
      as: ListboxComponent,
      className: classes.listbox,
      ownerState: ownerState
    }, otherListboxProps, ListboxProps, {
      ref: combinedListboxRef,
      children: groupedOptions.map((option, index) => {
        if (groupBy) {
          return renderGroup({
            key: option.key,
            group: option.group,
            children: option.options.map((option2, index2) => renderListOption(option2, option.index + index2))
          });
        }
        return renderListOption(option, index);
      })
    })));
  } else if (loading && groupedOptions.length === 0) {
    autocompletePopper = renderAutocompletePopperChildren( /*#__PURE__*/jsx(AutocompleteLoading, {
      className: classes.loading,
      ownerState: ownerState,
      children: loadingText
    }));
  } else if (groupedOptions.length === 0 && !freeSolo && !loading) {
    autocompletePopper = renderAutocompletePopperChildren( /*#__PURE__*/jsx(AutocompleteNoOptions, {
      className: classes.noOptions,
      ownerState: ownerState,
      role: "presentation",
      onMouseDown: event => {
        // Prevent input blur when interacting with the "no options" content
        event.preventDefault();
      },
      children: noOptionsText
    }));
  }
  return /*#__PURE__*/jsxs(React.Fragment, {
    children: [/*#__PURE__*/jsx(AutocompleteRoot, _extends({
      ref: ref,
      className: clsx$1(classes.root, className),
      ownerState: ownerState
    }, getRootProps(other), {
      children: renderInput({
        id,
        disabled,
        fullWidth: true,
        size: size === 'small' ? 'small' : undefined,
        InputLabelProps: getInputLabelProps(),
        InputProps: _extends({
          ref: setAnchorEl,
          className: classes.inputRoot,
          startAdornment,
          onClick: event => {
            if (event.target === event.currentTarget) {
              handleInputMouseDown(event);
            }
          }
        }, (hasClearIcon || hasPopupIcon) && {
          endAdornment: /*#__PURE__*/jsxs(AutocompleteEndAdornment, {
            className: classes.endAdornment,
            ownerState: ownerState,
            children: [hasClearIcon ? /*#__PURE__*/jsx(AutocompleteClearIndicator, _extends({}, getClearProps(), {
              "aria-label": clearText,
              title: clearText,
              ownerState: ownerState
            }, clearIndicatorSlotProps, {
              className: clsx$1(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
              children: clearIcon
            })) : null, hasPopupIcon ? /*#__PURE__*/jsx(AutocompletePopupIndicator, _extends({}, getPopupIndicatorProps(), {
              disabled: disabled,
              "aria-label": popupOpen ? closeText : openText,
              title: popupOpen ? closeText : openText,
              ownerState: ownerState
            }, popupIndicatorSlotProps, {
              className: clsx$1(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
              children: popupIcon
            })) : null]
          })
        }),
        inputProps: _extends({
          className: classes.input,
          disabled,
          readOnly
        }, getInputProps())
      })
    })), anchorEl ? autocompletePopper : null]
  });
});
process.env.NODE_ENV !== "production" ? Autocomplete.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: PropTypes.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: PropTypes.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: PropTypes.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: PropTypes.oneOfType([PropTypes.oneOf(['mouse', 'touch']), PropTypes.bool]),
  /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */
  ChipProps: PropTypes.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: PropTypes.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: PropTypes.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: PropTypes.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: PropTypes.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    clearIndicator: PropTypes.object,
    paper: PropTypes.object,
    popper: PropTypes.object,
    popupIndicator: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: chainPropTypes(PropTypes.any, props => {
    if (props.multiple && props.defaultValue !== undefined && !Array.isArray(props.defaultValue)) {
      return new Error(['MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.', `However, ${props.defaultValue} was provided.`].join('\n'));
    }
    return null;
  }),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: PropTypes.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: PropTypes.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: PropTypes.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: PropTypes.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: PropTypes.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: PropTypes.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: PropTypes.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: PropTypes.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: PropTypes.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: PropTypes.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: PropTypes.bool,
  /**
   * The input value.
   */
  inputValue: PropTypes.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: PropTypes.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: integerPropType,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   */
  ListboxComponent: PropTypes.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: PropTypes.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: PropTypes.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: PropTypes.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: PropTypes.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: PropTypes.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: PropTypes.string,
  /**
   * Array of options.
   */
  options: PropTypes.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   */
  PaperComponent: PropTypes.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   */
  PopperComponent: PropTypes.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: PropTypes.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['small', 'medium']), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    clearIndicator: PropTypes.object,
    paper: PropTypes.object,
    popper: PropTypes.object,
    popupIndicator: PropTypes.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: chainPropTypes(PropTypes.any, props => {
    if (props.multiple && props.value !== undefined && !Array.isArray(props.value)) {
      return new Error(['MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.', `However, ${props.value} was provided.`].join('\n'));
    }
    return null;
  })
} : void 0;
var Autocomplete$1 = Autocomplete;

function getFormLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiFormLabel', slot);
}
const formLabelClasses = generateUtilityClasses('MuiFormLabel', ['root', 'colorSecondary', 'focused', 'disabled', 'error', 'filled', 'required', 'asterisk']);
var formLabelClasses$1 = formLabelClasses;

const _excluded$p = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"];
const useUtilityClasses$n = ownerState => {
  const {
    classes,
    color,
    focused,
    disabled,
    error,
    filled,
    required
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize(color)}`, disabled && 'disabled', error && 'error', filled && 'filled', focused && 'focused', required && 'required'],
    asterisk: ['asterisk', error && 'error']
  };
  return composeClasses(slots, getFormLabelUtilityClasses, classes);
};
const FormLabelRoot = styled('label', {
  name: 'MuiFormLabel',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return _extends({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
  }
})(({
  theme,
  ownerState
}) => _extends({
  color: (theme.vars || theme).palette.text.secondary
}, theme.typography.body1, {
  lineHeight: '1.4375em',
  padding: 0,
  position: 'relative',
  [`&.${formLabelClasses$1.focused}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${formLabelClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${formLabelClasses$1.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const AsteriskComponent = styled('span', {
  name: 'MuiFormLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})(({
  theme
}) => ({
  [`&.${formLabelClasses$1.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const FormLabel = /*#__PURE__*/React.forwardRef(function FormLabel(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiFormLabel'
  });
  const {
      children,
      className,
      component = 'label'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$p);
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  const ownerState = _extends({}, props, {
    color: fcs.color || 'primary',
    component,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });
  const classes = useUtilityClasses$n(ownerState);
  return /*#__PURE__*/jsxs(FormLabelRoot, _extends({
    as: component,
    ownerState: ownerState,
    className: clsx$1(classes.root, className),
    ref: ref
  }, other, {
    children: [children, fcs.required && /*#__PURE__*/jsxs(AsteriskComponent, {
      ownerState: ownerState,
      "aria-hidden": true,
      className: classes.asterisk,
      children: ["\u2009", '*']
    })]
  }));
});
process.env.NODE_ENV !== "production" ? FormLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var FormLabel$1 = FormLabel;

function getInputLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiInputLabel', slot);
}
generateUtilityClasses('MuiInputLabel', ['root', 'focused', 'disabled', 'error', 'required', 'asterisk', 'formControl', 'sizeSmall', 'shrink', 'animated', 'standard', 'filled', 'outlined']);

const _excluded$o = ["disableAnimation", "margin", "shrink", "variant", "className"];
const useUtilityClasses$m = ownerState => {
  const {
    classes,
    formControl,
    size,
    shrink,
    disableAnimation,
    variant,
    required
  } = ownerState;
  const slots = {
    root: ['root', formControl && 'formControl', !disableAnimation && 'animated', shrink && 'shrink', size && size !== 'normal' && `size${capitalize(size)}`, variant],
    asterisk: [required && 'asterisk']
  };
  const composedClasses = composeClasses(slots, getInputLabelUtilityClasses, classes);
  return _extends({}, classes, composedClasses);
};
const InputLabelRoot = styled(FormLabel$1, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiInputLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${formLabelClasses$1.asterisk}`]: styles.asterisk
    }, styles.root, ownerState.formControl && styles.formControl, ownerState.size === 'small' && styles.sizeSmall, ownerState.shrink && styles.shrink, !ownerState.disableAnimation && styles.animated, ownerState.focused && styles.focused, styles[ownerState.variant]];
  }
})(({
  theme,
  ownerState
}) => _extends({
  display: 'block',
  transformOrigin: 'top left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%'
}, ownerState.formControl && {
  position: 'absolute',
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: 'translate(0, 20px) scale(1)'
}, ownerState.size === 'small' && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: 'translate(0, 17px) scale(1)'
}, ownerState.shrink && {
  transform: 'translate(0, -1.5px) scale(0.75)',
  transformOrigin: 'top left',
  maxWidth: '133%'
}, !ownerState.disableAnimation && {
  transition: theme.transitions.create(['color', 'transform', 'max-width'], {
    duration: theme.transitions.duration.shorter,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.variant === 'filled' && _extends({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(12px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 13px) scale(1)'
}, ownerState.shrink && _extends({
  userSelect: 'none',
  pointerEvents: 'auto',
  transform: 'translate(12px, 7px) scale(0.75)',
  maxWidth: 'calc(133% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 4px) scale(0.75)'
})), ownerState.variant === 'outlined' && _extends({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(14px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(14px, 9px) scale(1)'
}, ownerState.shrink && {
  userSelect: 'none',
  pointerEvents: 'auto',
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: 'calc(133% - 32px)',
  transform: 'translate(14px, -9px) scale(0.75)'
})));
const InputLabel = /*#__PURE__*/React.forwardRef(function InputLabel(inProps, ref) {
  const props = useDefaultProps({
    name: 'MuiInputLabel',
    props: inProps
  });
  const {
      disableAnimation = false,
      shrink: shrinkProp,
      className
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$o);
  const muiFormControl = useFormControl();
  let shrink = shrinkProp;
  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['size', 'variant', 'required', 'focused']
  });
  const ownerState = _extends({}, props, {
    disableAnimation,
    formControl: muiFormControl,
    shrink,
    size: fcs.size,
    variant: fcs.variant,
    required: fcs.required,
    focused: fcs.focused
  });
  const classes = useUtilityClasses$m(ownerState);
  return /*#__PURE__*/jsx(InputLabelRoot, _extends({
    "data-shrink": shrink,
    ownerState: ownerState,
    ref: ref,
    className: clsx$1(classes.root, className)
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? InputLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']), PropTypes.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['normal', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var InputLabel$1 = InputLabel;

function getFormControlUtilityClasses(slot) {
  return generateUtilityClass('MuiFormControl', slot);
}
generateUtilityClasses('MuiFormControl', ['root', 'marginNone', 'marginNormal', 'marginDense', 'fullWidth', 'disabled']);

const _excluded$n = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"];
const useUtilityClasses$l = ownerState => {
  const {
    classes,
    margin,
    fullWidth
  } = ownerState;
  const slots = {
    root: ['root', margin !== 'none' && `margin${capitalize(margin)}`, fullWidth && 'fullWidth']
  };
  return composeClasses(slots, getFormControlUtilityClasses, classes);
};
const FormControlRoot = styled('div', {
  name: 'MuiFormControl',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return _extends({}, styles.root, styles[`margin${capitalize(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
  }
})(({
  ownerState
}) => _extends({
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: 'top'
}, ownerState.margin === 'normal' && {
  marginTop: 16,
  marginBottom: 8
}, ownerState.margin === 'dense' && {
  marginTop: 8,
  marginBottom: 4
}, ownerState.fullWidth && {
  width: '100%'
}));

/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */
const FormControl = /*#__PURE__*/React.forwardRef(function FormControl(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiFormControl'
  });
  const {
      children,
      className,
      color = 'primary',
      component = 'div',
      disabled = false,
      error = false,
      focused: visuallyFocused,
      fullWidth = false,
      hiddenLabel = false,
      margin = 'none',
      required = false,
      size = 'medium',
      variant = 'outlined'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$n);
  const ownerState = _extends({}, props, {
    color,
    component,
    disabled,
    error,
    fullWidth,
    hiddenLabel,
    margin,
    required,
    size,
    variant
  });
  const classes = useUtilityClasses$l(ownerState);
  const [adornedStart, setAdornedStart] = React.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialAdornedStart = false;
    if (children) {
      React.Children.forEach(children, child => {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }
        const input = isMuiElement(child, ['Select']) ? child.props.input : child;
        if (input && isAdornedStart(input.props)) {
          initialAdornedStart = true;
        }
      });
    }
    return initialAdornedStart;
  });
  const [filled, setFilled] = React.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialFilled = false;
    if (children) {
      React.Children.forEach(children, child => {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }
        if (isFilled(child.props, true) || isFilled(child.props.inputProps, true)) {
          initialFilled = true;
        }
      });
    }
    return initialFilled;
  });
  const [focusedState, setFocused] = React.useState(false);
  if (disabled && focusedState) {
    setFocused(false);
  }
  const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
  let registerEffect;
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const registeredInput = React.useRef(false);
    registerEffect = () => {
      if (registeredInput.current) {
        console.error(['MUI: There are multiple `InputBase` components inside a FormControl.', 'This creates visual inconsistencies, only use one `InputBase`.'].join('\n'));
      }
      registeredInput.current = true;
      return () => {
        registeredInput.current = false;
      };
    };
  }
  const childContext = React.useMemo(() => {
    return {
      adornedStart,
      setAdornedStart,
      color,
      disabled,
      error,
      filled,
      focused,
      fullWidth,
      hiddenLabel,
      size,
      onBlur: () => {
        setFocused(false);
      },
      onEmpty: () => {
        setFilled(false);
      },
      onFilled: () => {
        setFilled(true);
      },
      onFocus: () => {
        setFocused(true);
      },
      registerEffect,
      required,
      variant
    };
  }, [adornedStart, color, disabled, error, filled, focused, fullWidth, hiddenLabel, registerEffect, required, size, variant]);
  return /*#__PURE__*/jsx(FormControlContext.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsx(FormControlRoot, _extends({
      as: component,
      ownerState: ownerState,
      className: clsx$1(classes.root, className),
      ref: ref
    }, other, {
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? FormControl.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var FormControl$1 = FormControl;

function getFormHelperTextUtilityClasses(slot) {
  return generateUtilityClass('MuiFormHelperText', slot);
}
const formHelperTextClasses = generateUtilityClasses('MuiFormHelperText', ['root', 'error', 'disabled', 'sizeSmall', 'sizeMedium', 'contained', 'focused', 'filled', 'required']);
var formHelperTextClasses$1 = formHelperTextClasses;

var _span$1;
const _excluded$m = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"];
const useUtilityClasses$k = ownerState => {
  const {
    classes,
    contained,
    size,
    disabled,
    error,
    filled,
    focused,
    required
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', error && 'error', size && `size${capitalize(size)}`, contained && 'contained', focused && 'focused', filled && 'filled', required && 'required']
  };
  return composeClasses(slots, getFormHelperTextUtilityClasses, classes);
};
const FormHelperTextRoot = styled('p', {
  name: 'MuiFormHelperText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.size && styles[`size${capitalize(ownerState.size)}`], ownerState.contained && styles.contained, ownerState.filled && styles.filled];
  }
})(({
  theme,
  ownerState
}) => _extends({
  color: (theme.vars || theme).palette.text.secondary
}, theme.typography.caption, {
  textAlign: 'left',
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${formHelperTextClasses$1.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}, ownerState.size === 'small' && {
  marginTop: 4
}, ownerState.contained && {
  marginLeft: 14,
  marginRight: 14
}));
const FormHelperText = /*#__PURE__*/React.forwardRef(function FormHelperText(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiFormHelperText'
  });
  const {
      children,
      className,
      component = 'p'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$m);
  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['variant', 'size', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  const ownerState = _extends({}, props, {
    component,
    contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
    variant: fcs.variant,
    size: fcs.size,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });
  const classes = useUtilityClasses$k(ownerState);
  return /*#__PURE__*/jsx(FormHelperTextRoot, _extends({
    as: component,
    ownerState: ownerState,
    className: clsx$1(classes.root, className),
    ref: ref
  }, other, {
    children: children === ' ' ? // notranslate needed while Google Translate will not fix zero-width space issue
    _span$1 || (_span$1 = /*#__PURE__*/jsx("span", {
      className: "notranslate",
      children: "\u200B"
    })) : children
  }));
});
process.env.NODE_ENV !== "production" ? FormHelperText.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['filled', 'outlined', 'standard']), PropTypes.string])
} : void 0;
var FormHelperText$1 = FormHelperText;

function getTextFieldUtilityClass(slot) {
  return generateUtilityClass('MuiTextField', slot);
}
generateUtilityClasses('MuiTextField', ['root']);

const _excluded$l = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"];
const variantComponent = {
  standard: Input,
  filled: FilledInput,
  outlined: OutlinedInput
};
const useUtilityClasses$j = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getTextFieldUtilityClass, classes);
};
const TextFieldRoot = styled(FormControl$1, {
  name: 'MuiTextField',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */
const TextField = /*#__PURE__*/React.forwardRef(function TextField(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTextField'
  });
  const {
      autoComplete,
      autoFocus = false,
      children,
      className,
      color = 'primary',
      defaultValue,
      disabled = false,
      error = false,
      FormHelperTextProps,
      fullWidth = false,
      helperText,
      id: idOverride,
      InputLabelProps,
      inputProps,
      InputProps,
      inputRef,
      label,
      maxRows,
      minRows,
      multiline = false,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      required = false,
      rows,
      select = false,
      SelectProps,
      type,
      value,
      variant = 'outlined'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$l);
  const ownerState = _extends({}, props, {
    autoFocus,
    color,
    disabled,
    error,
    fullWidth,
    multiline,
    required,
    select,
    variant
  });
  const classes = useUtilityClasses$j(ownerState);
  if (process.env.NODE_ENV !== 'production') {
    if (select && !children) {
      console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }
  const InputMore = {};
  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }
    InputMore.label = label;
  }
  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }
    InputMore['aria-describedby'] = undefined;
  }
  const id = useId(idOverride);
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputLabelId = label && id ? `${id}-label` : undefined;
  const InputComponent = variantComponent[variant];
  const InputElement = /*#__PURE__*/jsx(InputComponent, _extends({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/jsxs(TextFieldRoot, _extends({
    className: clsx$1(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    ref: ref,
    required: required,
    color: color,
    variant: variant,
    ownerState: ownerState
  }, other, {
    children: [label != null && label !== '' && /*#__PURE__*/jsx(InputLabel$1, _extends({
      htmlFor: id,
      id: inputLabelId
    }, InputLabelProps, {
      children: label
    })), select ? /*#__PURE__*/jsx(Select$1, _extends({
      "aria-describedby": helperTextId,
      id: id,
      labelId: inputLabelId,
      value: value,
      input: InputElement
    }, SelectProps, {
      children: children
    })) : InputElement, helperText && /*#__PURE__*/jsx(FormHelperText$1, _extends({
      id: helperTextId
    }, FormHelperTextProps, {
      children: helperText
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? TextField.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), PropTypes.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: PropTypes.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: PropTypes.object,
  /**
   * The size of the component.
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes /* @typescript-to-proptypes-ignore */.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var TextField$1 = TextField;

const LegalRepresentativeForm = () => {
    const strings = useStrings();
    const { getOnlineMessage } = useOnlineStatus();
    const dispatch = useTypedDispatch();
    const [formError, setFormError] = useState('');
    const [emailsWithLegalRepresentative, setEmailsWithLegalRepresentative] = useState([]);
    const [emails, setEmails] = useState([]);
    const [currentValue, setCurrentValue] = useState('');
    const [setUserLegalEmployeesMutation, { isLoading }] = useSetUserLegalEmployeesMutation();
    useShowLoadingIndicator(isLoading);
    function clearErrors() {
        setFormError('');
        setEmailsWithLegalRepresentative([]);
    }
    function submitForm(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            clearErrors();
            if (!emails.length) {
                return setFormError(strings.legalRepresentativeForm.email.required);
            }
            const areEmailsValid = emails.every(email => isEmail()(email));
            if (!areEmailsValid) {
                return setFormError(strings.legalRepresentativeForm.email.valid);
            }
            try {
                const { results } = yield setUserLegalEmployeesMutation({ employeeEmails: emails }).unwrap();
                const invalidEmailResults = results.filter(({ result }) => result === 'INVALID_EMAIL');
                const hasLegalRepresentativeResults = results.filter(({ result }) => result === 'HAS_LEGAL_REP');
                if (invalidEmailResults.length) {
                    return setFormError(strings.legalRepresentativeForm.email.valid);
                }
                if (hasLegalRepresentativeResults.length) {
                    setEmailsWithLegalRepresentative(hasLegalRepresentativeResults.map(({ email }) => email));
                    return setFormError(strings.legalRepresentativeForm.email.haveLegalRepresentative);
                }
                setEmails([]);
                dispatch(queueNotification(getOnlineMessage(strings.legalRepresentativeForm.saveSuccess)));
            }
            catch (_a) {
                dispatch(queueNotification(getOnlineMessage(strings.legalRepresentativeForm.saveError)));
            }
        });
    }
    const autoCompleteId = className$G('emailAutocomplete');
    return React__default.createElement("form", { className: className$G(), onSubmit: submitForm },
        React__default.createElement(Panel, null,
            React__default.createElement(Panel.Header, { title: strings.legalRepresentativeForm.title }),
            React__default.createElement(Panel.Content, null,
                React__default.createElement("p", { className: className$G('description') }, strings.legalRepresentativeForm.descriptionLine1),
                React__default.createElement("p", { className: className$G('description') }, strings.legalRepresentativeForm.descriptionLine2),
                React__default.createElement("label", { className: className$G('label'), htmlFor: autoCompleteId }, strings.legalRepresentativeForm.email.label),
                React__default.createElement(Autocomplete$1, { id: autoCompleteId, title: strings.legalRepresentativeForm.email.label, options: [currentValue], multiple: true, value: emails, onChange: (_event, emails) => setEmails(emails), renderInput: params => React__default.createElement(TextField$1, Object.assign({ onChange: e => setCurrentValue(e.target.value) }, params)), disableClearable: true, openOnFocus: true, "aria-label": strings.legalRepresentativeForm.email.label, openText: strings.buttons.open, closeText: strings.buttons.close }),
                formError && React__default.createElement("p", { className: className$G('error') }, formError),
                emailsWithLegalRepresentative.length ? React__default.createElement("ul", { className: className$G('emailsWithLegalRepresentative') }, emailsWithLegalRepresentative.map(email => React__default.createElement("li", { key: email, className: className$G('error') }, email))) : null,
                React__default.createElement(Button$2, { type: "submit", className: className$G('submitButton'), busy: isLoading }, strings.legalRepresentativeForm.submitButton))));
};
const className$G = createClassName('LegalRepresentativeForm');

const LegalRepresentativeTab = () => {
    return React__default.createElement(PanelGrid, { singleColumn: true },
        React__default.createElement(LegalRepresentativeForm, null),
        React__default.createElement(LegalEmployeesPanel, null));
};

function getFirstNotHiddenPath(tabs) {
    for (const value of Object.values(tabs !== null && tabs !== void 0 ? tabs : {})) {
        if (value !== null) {
            return value.href;
        }
    }
    return '/';
}
const AccountScreen = () => {
    var _a, _b, _c, _d;
    const { account: strings } = useStrings();
    const user = useTypedSelector(selectCurrentUser);
    const location = useLocation();
    const matchPath = useResolvedPath('');
    const { ref, width } = useElementWidth();
    const { getOnlineMessage } = useOnlineStatus();
    const { data: details, isError: isDetailsError } = useGetUserDetailsQuery((_a = user === null || user === void 0 ? void 0 : user.type) !== null && _a !== void 0 ? _a : queryExports.skipToken);
    const { data: preferences, isError: isPreferencesError } = useGetPreferencesQuery();
    const { data: twoFactorAuthStatus, isError: isTwoFactorAuthStatusError } = useGetTwoFactorAuthStatusQuery((_b = user === null || user === void 0 ? void 0 : user.id) !== null && _b !== void 0 ? _b : queryExports.skipToken);
    const tabs = useAccountTabs();
    const scrollElement = useNavigationScrollReset();
    usePageTitle(strings.title);
    useHelp('user.updateForm');
    const compactView = width < 800;
    const classes = classNames('AccountScreen', {
        'AccountScreen-compact': compactView
    });
    if (!user || isDetailsError || isPreferencesError || isTwoFactorAuthStatusError) {
        return React__default.createElement(Screen, { ref: ref, errorText: getOnlineMessage(strings.loadError) });
    }
    const backUrl = compactView && location.pathname !== matchPath.pathname ? matchPath.pathname : undefined;
    const header = React__default.createElement(AccountHeader, { userName: getUserExtendedDisplayName(user), alwaysShowUserName: !compactView, backUrl: backUrl });
    const tabBar = tabs
        ? React__default.createElement(VerticalTabBar, { tabs: Object.values(tabs).filter((tab) => Boolean(tab)) })
        : React__default.createElement(VerticalTabBarSkeleton, { hasRole: false });
    return React__default.createElement(Screen, { ref: ref, className: classes, header: header },
        React__default.createElement("div", { className: "AccountScreen-content" },
            !compactView && React__default.createElement("div", { className: "AccountScreen-tabs" }, tabBar),
            React__default.createElement("div", { className: "AccountScreen-section", ref: scrollElement }, tabs ? React__default.createElement(Routes, null,
                React__default.createElement(Route, { path: "/", element: compactView
                        ? React__default.createElement(PanelGrid, null,
                            React__default.createElement(Panel, null, tabBar))
                        : React__default.createElement(Navigate, { to: (_d = (_c = tabs.details) === null || _c === void 0 ? void 0 : _c.href) !== null && _d !== void 0 ? _d : getFirstNotHiddenPath(tabs) }) }),
                tabs.preferences && React__default.createElement(Route, { path: tabs.preferences.href, element: preferences ? React__default.createElement(PreferencesForm, { preferences: preferences }) : React__default.createElement(AccountTabSkeleton, null) }),
                tabs.subscriptions && React__default.createElement(Route, { path: tabs.subscriptions.href, element: React__default.createElement(SubscriptionsTab, null) }),
                tabs.details && React__default.createElement(Route, { path: tabs.details.href, element: details ? React__default.createElement(AccountForm, { userDetails: details }) : React__default.createElement(AccountTabSkeleton, null) }),
                tabs.twoFactorAuth && React__default.createElement(Route, { path: tabs.twoFactorAuth.href, element: twoFactorAuthStatus ? React__default.createElement(TwoFactorAuthTab, { twoFactorAuthStatus: twoFactorAuthStatus }) : React__default.createElement(AccountTabSkeleton, null) }),
                tabs.password && React__default.createElement(Route, { path: tabs.password.href, element: React__default.createElement(ChangePasswordForm, null) }),
                tabs.email && React__default.createElement(Route, { path: tabs.email.href, element: details
                        ? 'pendingEmailChange' in details && details.pendingEmailChange
                            ? React__default.createElement(ChangeEmailPendingForm, { userDetails: details })
                            : React__default.createElement(ChangeEmailForm, { userDetails: details })
                        : React__default.createElement(AccountTabSkeleton, null) }),
                tabs.legalRepresentative && React__default.createElement(Route, { path: tabs.legalRepresentative.href, element: React__default.createElement(LegalRepresentativeTab, null) }),
                tabs.deleteAccount && React__default.createElement(Route, { path: tabs.deleteAccount.href, element: React__default.createElement(DeleteAccountTab, null) }),
                React__default.createElement(Route, { path: "*", element: React__default.createElement(NotFoundScreen, null) })) : compactView ? React__default.createElement(PanelGrid, null,
                React__default.createElement(Panel, null, tabBar)) : React__default.createElement(AccountTabSkeleton, null))));
};

var faAngleRight = {};

var hasRequiredFaAngleRight;

function requireFaAngleRight () {
	if (hasRequiredFaAngleRight) return faAngleRight;
	hasRequiredFaAngleRight = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'angle-right';
		var width = 256;
		var height = 512;
		var ligatures = [];
		var unicode = 'f105';
		var svgPathData = 'M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faAngleRight = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faAngleRight));
	return faAngleRight;
}

var faAngleRightExports = requireFaAngleRight();

const DocumentPaths = ({ paths }) => {
    const separator = React__default.createElement("span", { className: "DocumentPaths-separator", "aria-hidden": "true" },
        React__default.createElement(FontAwesomeIcon, { icon: faAngleRightExports.faAngleRight }));
    return React__default.createElement("div", { className: "DocumentPaths" }, paths.map(path => React__default.createElement("div", { className: "DocumentPaths-path", key: path.map(group => group.id).join('/') },
        React__default.createElement("ol", null, path.map((group, index) => React__default.createElement("li", { key: group.id, title: group.name },
            index === 0 && separator,
            React__default.createElement("span", { className: "DocumentPaths-text" }, group.name),
            index < path.length - 1 && separator))))));
};

const SubscriptionInfo = ({ subscription, showName }) => {
    var _a;
    const { subscriptions: strings } = useStrings();
    const vinResolver = useVinResolver();
    return React__default.createElement("div", { className: "SubscriptionInfo" },
        React__default.createElement(DefinitionList, { definitions: [
                showName && { name: strings.nameLabel, value: subscription.name },
                { name: strings.periodLabel, value: subscription.period },
                { name: strings.priceLabel, value: React__default.createElement(Price, { amount: subscription.price, currency: subscription.currency }) },
                subscription.vin !== undefined && { name: strings.vinLabel, value: vinResolver(subscription.vin) },
                subscription.productVariantName !== undefined && { name: (_a = subscription.productVariantLabel) !== null && _a !== void 0 ? _a : strings.modelNameLabel, value: subscription.productVariantName },
                subscription.productVariantYear !== undefined && { name: strings.productYearLabel, value: subscription.productVariantYear }
            ].filter(filterFalse) }),
        React__default.createElement("h4", null, strings.includedTitle),
        subscription.type === 'document'
            ? subscription.groups && subscription.groups.length > 0
                ? React__default.createElement(DocumentPaths, { paths: subscription.groups.map(({ path }) => path) })
                : strings.includesAllDocuments
            : strings.includesService);
};

const SubscriptionOrderSummaryPanel = ({ subscription }) => {
    const { subscriptions: strings } = useStrings();
    return React__default.createElement(Panel, { className: "SubscriptionOrderSummaryPanel" },
        React__default.createElement(Panel.Header, { title: strings.orderSummaryTitle }),
        React__default.createElement(Panel.Content, null,
            React__default.createElement("p", null, strings.orderSummaryDescription),
            React__default.createElement(Text, null, strings.taxNote),
            React__default.createElement(SubscriptionInfo, { subscription: subscription, showName: true })));
};

const SubscriptionApprovalDialogue = ({ isOpen, onClose }) => {
    const { subscriptions: strings, buttons: buttonStrings } = useStrings();
    return React__default.createElement(Dialogue, { isOpen: isOpen, onClose: onClose },
        React__default.createElement(Dialogue.Header, { title: strings.approvalRequestSentTitle }),
        React__default.createElement(Dialogue.Content, null, strings.approvalRequestSentDescription),
        React__default.createElement(Dialogue.Footer, { buttons: [
                React__default.createElement(Button$2, { key: "close", onClick: onClose }, buttonStrings.close)
            ] }));
};

const SubscriptionApprovalPanel = ({ specificity, subscriptionId, backUrl }) => {
    const { subscriptions: strings, buttons: buttonStrings } = useStrings();
    const dispatch = useTypedDispatch();
    const [requestPurchaseApproval, { isLoading, isSuccess }] = useRequestSubscriptionPurchaseApprovalMutation();
    const [showDialogue, setShowDialogue] = useState(false);
    function requestApproval() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield requestPurchaseApproval({
                    specificity,
                    subscriptionPriceId: subscriptionId
                }).unwrap();
                setShowDialogue(true);
            }
            catch (_a) {
                dispatch(queueNotification(strings.requestApprovalError));
            }
        });
    }
    return React__default.createElement(Panel, { className: "SubscriptionApprovalPanel" },
        React__default.createElement(Panel.Header, { title: strings.approvalRequiredTitle }),
        React__default.createElement(Panel.Content, null,
            strings.approvalRequiredDescription,
            React__default.createElement("div", { className: "SubscriptionApprovalPanel-buttons" },
                React__default.createElement(ButtonLink, { variant: "outlined", href: backUrl }, buttonStrings.back),
                React__default.createElement(Button$2, { busy: isLoading, disabled: isSuccess, onClick: requestApproval }, isSuccess ? strings.approvalRequestSentTitle : strings.requestApprovalButton))),
        React__default.createElement(SubscriptionApprovalDialogue, { isOpen: showDialogue, onClose: () => setShowDialogue(false) }));
};

function useCallingCodeSelect(props) {
    const countries = useCountryNames();
    const [callingCodes, setCallingCodes] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    useEffect(() => {
        function loadCallingCodes() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (countries) {
                        const phoneData = yield import(/* webpackChunkName: 'country-telephone-data' */ './chunks/country_telephone_data-6b6b2af9.js').then(function (n) { return n.c; });
                        const callingCodes = new Map();
                        for (const country of phoneData.allCountries) {
                            const code = Number(country.dialCode);
                            const iso = country.iso2.toUpperCase();
                            const callingCode = (_a = callingCodes.get(code)) !== null && _a !== void 0 ? _a : {
                                code,
                                countries: {}
                            };
                            callingCode.countries[iso] = countries[iso];
                            callingCodes.set(code, callingCode);
                        }
                        setCallingCodes(Array.from(callingCodes.values()).sort((a, b) => {
                            return a.code - b.code;
                        }));
                    }
                    else {
                        setCallingCodes([]);
                    }
                }
                catch (error) {
                    setCallingCodes([]);
                }
            });
        }
        loadCallingCodes();
    }, [countries]);
    useEffect(() => {
        const selectedCode = callingCodes.find(callingCode => {
            return Object.keys(callingCode.countries).includes(props.value);
        });
        setSelectedValue(selectedCode ? String(selectedCode.code) : '');
    }, [props.value, callingCodes]);
    return useInput(Select, Object.assign(Object.assign({}, props), { items: callingCodes.map(({ code, countries }) => {
            return [String(code), `+${code} - ${Object.values(countries).join(', ')}`];
        }), value: selectedValue, disabled: callingCodes.length === 0 }));
}

const SubscriptionPurchaseButtons = ({ isLoading, purchaseSubscription, backUrl }) => {
    const { subscriptions: strings, buttons: buttonStrings } = useStrings();
    return React__default.createElement("div", { className: "SubscriptionPurchaseButtons" },
        React__default.createElement(ButtonLink, { variant: "outlined", href: backUrl }, buttonStrings.back),
        !purchaseSubscription ? (React__default.createElement(Button$2, { type: "submit", busy: isLoading }, strings.continueToPaymentButton)) :
            React__default.createElement(Button$2, { onClick: () => purchaseSubscription({}), busy: isLoading }, strings.continueToPaymentButton));
};

var iso3166_minExports$1 = {};
var iso3166_min = {
  get exports(){ return iso3166_minExports$1; },
  set exports(v){ iso3166_minExports$1 = v; },
};

var hasRequiredIso3166_min;

function requireIso3166_min () {
	if (hasRequiredIso3166_min) return iso3166_minExports$1;
	hasRequiredIso3166_min = 1;
	(function (module) {
(function () {
		var data={BD:{name:"Bangladesh",sub:{"BD-E":{type:"Division",name:"Rajshahi"},"BD-41":{type:"District",name:"Netrakona"},"BD-G":{type:"Division",name:"Sylhet"},"BD-38":{type:"District",name:"Moulvibazar"},"BD-A":{type:"Division",name:"Barisal"},"BD-C":{type:"Division",name:"Dhaka"},"BD-B":{type:"Division",name:"Chittagong"},"BD-D":{type:"Division",name:"Khulna"},"BD-46":{type:"District",name:"Nilphamari"},"BD-59":{type:"District",name:"Sirajganj"},"BD-55":{type:"District",name:"Rangpur"},"BD-47":{type:"District",name:"Noakhali"},"BD-60":{type:"District",name:"Sylhet"},"BD-49":{type:"District",name:"Pabna"},"BD-62":{type:"District",name:"Shariatpur"},"BD-63":{type:"District",name:"Tangail"},"BD-64":{type:"District",name:"Thakurgaon"},"BD-22":{type:"District",name:"Jessore"},"BD-36":{type:"District",name:"Madaripur"},"BD-61":{type:"District",name:"Sunamganj"},"BD-23":{type:"District",name:"Jhenaidah"},"BD-06":{type:"District",name:"Barisal"},"BD-07":{type:"District",name:"Bhola"},"BD-04":{type:"District",name:"Brahmanbaria"},"BD-05":{type:"District",name:"Bagerhat"},"BD-02":{type:"District",name:"Barguna"},"BD-03":{type:"District",name:"Bogra"},"BD-01":{type:"District",name:"Bandarban"},"BD-24":{type:"District",name:"Jaipurhat"},"BD-25":{type:"District",name:"Jhalakati"},"BD-26":{type:"District",name:"Kishoreganj"},"BD-27":{type:"District",name:"Khulna"},"BD-20":{type:"District",name:"Habiganj"},"BD-21":{type:"District",name:"Jamalpur"},"BD-08":{type:"District",name:"Comilla"},"BD-09":{type:"District",name:"Chandpur"},"BD-35":{type:"District",name:"Munshiganj"},"BD-54":{type:"District",name:"Rajshahi"},"BD-33":{type:"District",name:"Manikganj"},"BD-58":{type:"District",name:"Satkhira"},"BD-F":{type:"Division",name:"Rangpur"},"BD-32":{type:"District",name:"Lalmonirhat"},"BD-31":{type:"District",name:"Lakshmipur"},"BD-53":{type:"District",name:"Rajbari"},"BD-30":{type:"District",name:"Kushtia"},"BD-28":{type:"District",name:"Kurigram"},"BD-44":{type:"District",name:"Natore"},"BD-48":{type:"District",name:"Naogaon"},"BD-29":{type:"District",name:"Khagrachari"},"BD-15":{type:"District",name:"Faridpur"},"BD-14":{type:"District",name:"Dinajpur"},"BD-17":{type:"District",name:"Gopalganj"},"BD-16":{type:"District",name:"Feni"},"BD-11":{type:"District",name:"Cox's Bazar"},"BD-10":{type:"District",name:"Chittagong"},"BD-13":{type:"District",name:"Dhaka"},"BD-12":{type:"District",name:"Chuadanga"},"BD-51":{type:"District",name:"Patuakhali"},"BD-50":{type:"District",name:"Pirojpur"},"BD-39":{type:"District",name:"Meherpur"},"BD-34":{type:"District",name:"Mymensingh"},"BD-19":{type:"District",name:"Gaibandha"},"BD-18":{type:"District",name:"Gazipur"},"BD-57":{type:"District",name:"Sherpur"},"BD-52":{type:"District",name:"Panchagarh"},"BD-42":{type:"District",name:"Narsingdi"},"BD-45":{type:"District",name:"Nawabganj"},"BD-43":{type:"District",name:"Narail"},"BD-37":{type:"District",name:"Magura"},"BD-40":{type:"District",name:"Narayanganj"},"BD-56":{type:"District",name:"Rangamati"}}},BE:{name:"Belgium",sub:{"BE-VWV":{type:"Province",name:"West-Vlaanderen"},"BE-VAN":{type:"Province",name:"Antwerpen"},"BE-VLG":{type:"Region",name:"Vlaams Gewest"},"BE-VLI":{type:"Province",name:"Limburg"},"BE-WBR":{type:"Province",name:"Brabant wallon"},"BE-VBR":{type:"Province",name:"Vlaams-Brabant"},"BE-VOV":{type:"Province",name:"Oost-Vlaanderen"},"BE-WLG":{type:"Province",name:"Liège"},"BE-WLX":{type:"Province",name:"Luxembourg"},"BE-WHT":{type:"Province",name:"Hainaut"},"BE-WAL":{type:"Region",name:"wallonne, Région"},"BE-BRU":{type:"Region",name:"Brussels Hoofdstedelijk Gewest"},"BE-WNA":{type:"Province",name:"Namur"}}},BF:{name:"Burkina Faso",sub:{"BF-SEN":{type:"Province",name:"Séno"},"BF-KEN":{type:"Province",name:"Kénédougou"},"BF-BLK":{type:"Province",name:"Boulkiemdé"},"BF-NAM":{type:"Province",name:"Namentenga"},"BF-NAO":{type:"Province",name:"Nahouri"},"BF-BLG":{type:"Province",name:"Boulgou"},"BF-KOP":{type:"Province",name:"Koulpélogo"},"BF-KAD":{type:"Province",name:"Kadiogo"},"BF-01":{type:"Region",name:"Boucle du Mouhoun"},"BF-02":{type:"Region",name:"Cascades"},"BF-03":{type:"Region",name:"Centre"},"BF-04":{type:"Region",name:"Centre-Est"},"BF-05":{type:"Region",name:"Centre-Nord"},"BF-06":{type:"Region",name:"Centre-Ouest"},"BF-07":{type:"Region",name:"Centre-Sud"},"BF-08":{type:"Region",name:"Est"},"BF-09":{type:"Region",name:"Hauts-Bassins"},"BF-YAT":{type:"Province",name:"Yatenga"},"BF-PAS":{type:"Province",name:"Passoré"},"BF-YAG":{type:"Province",name:"Yagha"},"BF-IOB":{type:"Province",name:"Ioba"},"BF-GNA":{type:"Province",name:"Gnagna"},"BF-PON":{type:"Province",name:"Poni"},"BF-HOU":{type:"Province",name:"Houet"},"BF-LER":{type:"Province",name:"Léraba"},"BF-KMD":{type:"Province",name:"Komondjari"},"BF-SMT":{type:"Province",name:"Sanmatenga"},"BF-ZON":{type:"Province",name:"Zondoma"},"BF-MOU":{type:"Province",name:"Mouhoun"},"BF-COM":{type:"Province",name:"Comoé"},"BF-TUI":{type:"Province",name:"Tui"},"BF-SIS":{type:"Province",name:"Sissili"},"BF-GAN":{type:"Province",name:"Ganzourgou"},"BF-BGR":{type:"Province",name:"Bougouriba"},"BF-SOR":{type:"Province",name:"Sourou"},"BF-ZIR":{type:"Province",name:"Ziro"},"BF-KOW":{type:"Province",name:"Kourwéogo"},"BF-SOM":{type:"Province",name:"Soum"},"BF-KOT":{type:"Province",name:"Kouritenga"},"BF-13":{type:"Region",name:"Sud-Ouest"},"BF-12":{type:"Region",name:"Sahel"},"BF-11":{type:"Region",name:"Plateau-Central"},"BF-10":{type:"Region",name:"Nord"},"BF-ZOU":{type:"Province",name:"Zoundwéogo"},"BF-LOR":{type:"Province",name:"Loroum"},"BF-BAL":{type:"Province",name:"Balé"},"BF-BAM":{type:"Province",name:"Bam"},"BF-BAN":{type:"Province",name:"Banwa"},"BF-OUB":{type:"Province",name:"Oubritenga"},"BF-OUD":{type:"Province",name:"Oudalan"},"BF-NAY":{type:"Province",name:"Nayala"},"BF-NOU":{type:"Province",name:"Noumbiel"},"BF-KOS":{type:"Province",name:"Kossi"},"BF-TAP":{type:"Province",name:"Tapoa"},"BF-BAZ":{type:"Province",name:"Bazèga"},"BF-SNG":{type:"Province",name:"Sanguié"},"BF-KMP":{type:"Province",name:"Kompienga"},"BF-GOU":{type:"Province",name:"Gourma"}}},BG:{name:"Bulgaria",sub:{"BG-14":{type:"Region",name:"Pernik"},"BG-15":{type:"Region",name:"Pleven"},"BG-16":{type:"Region",name:"Plovdiv"},"BG-17":{type:"Region",name:"Razgrad"},"BG-10":{type:"Region",name:"Kyustendil"},"BG-11":{type:"Region",name:"Lovech"},"BG-12":{type:"Region",name:"Montana"},"BG-13":{type:"Region",name:"Pazardzhik"},"BG-18":{type:"Region",name:"Ruse"},"BG-19":{type:"Region",name:"Silistra"},"BG-25":{type:"Region",name:"Targovishte"},"BG-24":{type:"Region",name:"Stara Zagora"},"BG-27":{type:"Region",name:"Shumen"},"BG-07":{type:"Region",name:"Gabrovo"},"BG-06":{type:"Region",name:"Vratsa"},"BG-23":{type:"Region",name:"Sofia"},"BG-04":{type:"Region",name:"Veliko Tarnovo"},"BG-09":{type:"Region",name:"Kardzhali"},"BG-08":{type:"Region",name:"Dobrich"},"BG-28":{type:"Region",name:"Yambol"},"BG-03":{type:"Region",name:"Varna"},"BG-02":{type:"Region",name:"Burgas"},"BG-01":{type:"Region",name:"Blagoevgrad"},"BG-26":{type:"Region",name:"Haskovo"},"BG-21":{type:"Region",name:"Smolyan"},"BG-20":{type:"Region",name:"Sliven"},"BG-05":{type:"Region",name:"Vidin"},"BG-22":{type:"Region",name:"Sofia"}}},BA:{name:"Bosnia and Herzegovina",sub:{"BA-BRC":{type:"District with special status",name:"Brčko distrikt"},"BA-10":{type:"Canton",name:"Kanton br. 10"},"BA-BIH":{type:"Entity",name:"Federacija Bosne i Hercegovine"},"BA-09":{type:"Canton",name:"Kanton Sarajevo"},"BA-08":{type:"Canton",name:"Zapadnohercegovačka županija"},"BA-SRP":{type:"Entity",name:"Republika Srpska"},"BA-05":{type:"Canton",name:"Bosansko-podrinjska županija"},"BA-04":{type:"Canton",name:"Zeničko-dobojska županija"},"BA-07":{type:"Canton",name:"Hercegovačko-neretvanska županija"},"BA-06":{type:"Canton",name:"Srednjobosanska županija"},"BA-01":{type:"Canton",name:"Unsko-sanska županija"},"BA-03":{type:"Canton",name:"Tuzlanska županija"},"BA-02":{type:"Canton",name:"Posavska županija"}}},BB:{name:"Barbados",sub:{"BB-11":{type:"Parish",name:"Saint Thomas"},"BB-10":{type:"Parish",name:"Saint Philip"},"BB-08":{type:"Parish",name:"Saint Michael"},"BB-09":{type:"Parish",name:"Saint Peter"},"BB-04":{type:"Parish",name:"Saint James"},"BB-05":{type:"Parish",name:"Saint John"},"BB-06":{type:"Parish",name:"Saint Joseph"},"BB-07":{type:"Parish",name:"Saint Lucy"},"BB-01":{type:"Parish",name:"Christ Church"},"BB-02":{type:"Parish",name:"Saint Andrew"},"BB-03":{type:"Parish",name:"Saint George"}}},WF:{name:"Wallis & Futuna Islands",sub:{"WF-WF":{type:"Country",name:"Wallis & Futuna Islands"}}},BL:{name:"St. Barthélemy",sub:{"BL-BL":{type:"Country",name:"St. Barthélemy"}}},BM:{name:"Bermuda",sub:{"BM-BM":{type:"Country",name:"Bermuda"}}},BN:{name:"Brunei Darussalam",sub:{"BN-TE":{type:"District",name:"Temburong"},"BN-BM":{type:"District",name:"Brunei-Muara"},"BN-TU":{type:"District",name:"Tutong"},"BN-BE":{type:"District",name:"Belait"}}},BO:{name:"Bolivia",sub:{"BO-B":{type:"Department",name:"El Beni"},"BO-C":{type:"Department",name:"Cochabamba"},"BO-N":{type:"Department",name:"Pando"},"BO-O":{type:"Department",name:"Oruro"},"BO-L":{type:"Department",name:"La Paz"},"BO-H":{type:"Department",name:"Chuquisaca"},"BO-T":{type:"Department",name:"Tarija"},"BO-S":{type:"Department",name:"Santa Cruz"},"BO-P":{type:"Department",name:"Potosí"}}},BH:{name:"Bahrain",sub:{"BH-13":{type:"Governorate",name:"Al Manāmah"},"BH-15":{type:"Governorate",name:"Al Muḩarraq"},"BH-14":{type:"Governorate",name:"Al Janūbīyah"},"BH-17":{type:"Governorate",name:"Ash Shamālīyah"},"BH-16":{type:"Governorate",name:"Al Wusţá"}}},BI:{name:"Burundi",sub:{"BI-BB":{type:"Province",name:"Bubanza"},"BI-MA":{type:"Province",name:"Makamba"},"BI-CI":{type:"Province",name:"Cibitoke"},"BI-KR":{type:"Province",name:"Karuzi"},"BI-NG":{type:"Province",name:"Ngozi"},"BI-RY":{type:"Province",name:"Ruyigi"},"BI-RT":{type:"Province",name:"Rutana"},"BI-CA":{type:"Province",name:"Cankuzo"},"BI-BM":{type:"Province",name:"Bujumbura Mairie"},"BI-BL":{type:"Province",name:"Bujumbura Rural"},"BI-BR":{type:"Province",name:"Bururi"},"BI-MW":{type:"Province",name:"Mwaro"},"BI-KI":{type:"Province",name:"Kirundo"},"BI-MU":{type:"Province",name:"Muramvya"},"BI-GI":{type:"Province",name:"Gitega"},"BI-MY":{type:"Province",name:"Muyinga"},"BI-KY":{type:"Province",name:"Kayanza"}}},BJ:{name:"Benin",sub:{"BJ-AK":{type:"Department",name:"Atakora"},"BJ-BO":{type:"Department",name:"Borgou"},"BJ-CO":{type:"Department",name:"Collines"},"BJ-AL":{type:"Department",name:"Alibori"},"BJ-MO":{type:"Department",name:"Mono"},"BJ-LI":{type:"Department",name:"Littoral"},"BJ-ZO":{type:"Department",name:"Zou"},"BJ-OU":{type:"Department",name:"Ouémé"},"BJ-PL":{type:"Department",name:"Plateau"},"BJ-DO":{type:"Department",name:"Donga"},"BJ-AQ":{type:"Department",name:"Atlantique"},"BJ-KO":{type:"Department",name:"Kouffo"}}},BT:{name:"Bhutan",sub:{"BT-33":{type:"District",name:"Bumthang"},"BT-42":{type:"District",name:"Monggar"},"BT-GA":{type:"District",name:"Gasa"},"BT-32":{type:"District",name:"Trongsa"},"BT-34":{type:"District",name:"Zhemgang"},"BT-45":{type:"District",name:"Samdrup Jongkha"},"BT-15":{type:"District",name:"Thimphu"},"BT-14":{type:"District",name:"Samtse"},"BT-31":{type:"District",name:"Sarpang"},"BT-TY":{type:"District",name:"Trashi Yangtse"},"BT-11":{type:"District",name:"Paro"},"BT-44":{type:"District",name:"Lhuentse"},"BT-13":{type:"District",name:"Ha"},"BT-12":{type:"District",name:"Chhukha"},"BT-24":{type:"District",name:"Wangdue Phodrang"},"BT-43":{type:"District",name:"Pemagatshel"},"BT-41":{type:"District",name:"Trashigang"},"BT-21":{type:"District",name:"Tsirang"},"BT-22":{type:"District",name:"Dagana"},"BT-23":{type:"District",name:"Punakha"}}},JM:{name:"Jamaica",sub:{"JM-12":{type:"Parish",name:"Manchester"},"JM-14":{type:"Parish",name:"Saint Catherine"},"JM-11":{type:"Parish",name:"Saint Elizabeth"},"JM-10":{type:"Parish",name:"Westmoreland"},"JM-01":{type:"Parish",name:"Kingston"},"JM-13":{type:"Parish",name:"Clarendon"},"JM-03":{type:"Parish",name:"Saint Thomas"},"JM-02":{type:"Parish",name:"Saint Andrew"},"JM-05":{type:"Parish",name:"Saint Mary"},"JM-04":{type:"Parish",name:"Portland"},"JM-07":{type:"Parish",name:"Trelawny"},"JM-06":{type:"Parish",name:"Saint Ann"},"JM-09":{type:"Parish",name:"Hanover"},"JM-08":{type:"Parish",name:"Saint James"}}},BV:{name:"Bouvet Island",sub:{"BV-BV":{type:"Country",name:"Bouvet Island"}}},BW:{name:"Botswana",sub:{"BW-KW":{type:"District",name:"Kweneng"},"BW-JW":{type:"Town",name:"Jwaneng"},"BW-FR":{type:"City",name:"Francistown"},"BW-CH":{type:"District",name:"Chobe"},"BW-SO":{type:"District",name:"Southern"},"BW-LO":{type:"Town",name:"Lobatse"},"BW-ST":{type:"Town",name:"Sowa Town"},"BW-CE":{type:"District",name:"Central"},"BW-NW":{type:"District",name:"North West"},"BW-KG":{type:"District",name:"Kgalagadi"},"BW-GA":{type:"City",name:"Gaborone"},"BW-SP":{type:"Town",name:"Selibe Phikwe"},"BW-GH":{type:"District",name:"Ghanzi"},"BW-SE":{type:"District",name:"South East"},"BW-NE":{type:"District",name:"North East"},"BW-KL":{type:"District",name:"Kgatleng"}}},WS:{name:"Samoa",sub:{"WS-AA":{type:"District",name:"A'ana"},"WS-VF":{type:"District",name:"Va'a-o-Fonoti"},"WS-SA":{type:"District",name:"Satupa'itea"},"WS-FA":{type:"District",name:"Fa'asaleleaga"},"WS-VS":{type:"District",name:"Vaisigano"},"WS-AL":{type:"District",name:"Aiga-i-le-Tai"},"WS-GI":{type:"District",name:"Gagaifomauga"},"WS-PA":{type:"District",name:"Palauli"},"WS-AT":{type:"District",name:"Atua"},"WS-TU":{type:"District",name:"Tuamasaga"},"WS-GE":{type:"District",name:"Gaga'emauga"}}},BQ:{name:"Bonaire, Sint Eustatius and Saba",sub:{"BQ-SE":{type:"Special municipality",name:"Sint Eustatius"},"BQ-BO":{type:"Special municipality",name:"Bonaire"},"BQ-SA":{type:"Special municipality",name:"Saba"}}},BR:{name:"Brazil",sub:{"BR-RJ":{type:"State",name:"Rio de Janeiro"},"BR-BA":{type:"State",name:"Bahia"},"BR-SE":{type:"State",name:"Sergipe"},"BR-DF":{type:"Federal district",name:"Distrito Federal"},"BR-SP":{type:"State",name:"São Paulo"},"BR-SC":{type:"State",name:"Santa Catarina"},"BR-RR":{type:"State",name:"Roraima"},"BR-RS":{type:"State",name:"Rio Grande do Sul"},"BR-AP":{type:"State",name:"Amapá"},"BR-CE":{type:"State",name:"Ceará"},"BR-GO":{type:"State",name:"Goiás"},"BR-AM":{type:"State",name:"Amazonas"},"BR-AL":{type:"State",name:"Alagoas"},"BR-AC":{type:"State",name:"Acre"},"BR-PI":{type:"State",name:"Piauí"},"BR-RN":{type:"State",name:"Rio Grande do Norte"},"BR-RO":{type:"State",name:"Rondônia"},"BR-MT":{type:"State",name:"Mato Grosso"},"BR-MS":{type:"State",name:"Mato Grosso do Sul"},"BR-PA":{type:"State",name:"Pará"},"BR-PB":{type:"State",name:"Paraíba"},"BR-ES":{type:"State",name:"Espírito Santo"},"BR-PR":{type:"State",name:"Paraná"},"BR-PE":{type:"State",name:"Pernambuco"},"BR-MG":{type:"State",name:"Minas Gerais"},"BR-MA":{type:"State",name:"Maranhão"},"BR-TO":{type:"State",name:"Tocantins"}}},BS:{name:"Bahamas",sub:{"BS-SA":{type:"District",name:"South Andros"},"BS-EX":{type:"District",name:"Exuma"},"BS-CS":{type:"District",name:"Central Andros"},"BS-CK":{type:"District",name:"Crooked Island and Long Cay"},"BS-CI":{type:"District",name:"Cat Island"},"BS-GC":{type:"District",name:"Grand Cay"},"BS-EG":{type:"District",name:"East Grand Bahama"},"BS-CE":{type:"District",name:"Central Eleuthera"},"BS-RI":{type:"District",name:"Ragged Island"},"BS-RC":{type:"District",name:"Rum Cay"},"BS-AK":{type:"District",name:"Acklins"},"BS-MG":{type:"District",name:"Mayaguana"},"BS-IN":{type:"District",name:"Inagua"},"BS-MC":{type:"District",name:"Mangrove Cay"},"BS-MI":{type:"District",name:"Moore's Island"},"BS-BY":{type:"District",name:"Berry Islands"},"BS-FP":{type:"District",name:"City of Freeport"},"BS-BP":{type:"District",name:"Black Point"},"BS-LI":{type:"District",name:"Long Island"},"BS-BI":{type:"District",name:"Bimini"},"BS-WG":{type:"District",name:"West Grand Bahama"},"BS-NO":{type:"District",name:"North Abaco"},"BS-SO":{type:"District",name:"South Abaco"},"BS-NE":{type:"District",name:"North Eleuthera"},"BS-HT":{type:"District",name:"Hope Town"},"BS-SE":{type:"District",name:"South Eleuthera"},"BS-HI":{type:"District",name:"Harbour Island"},"BS-SS":{type:"District",name:"San Salvador"},"BS-SW":{type:"District",name:"Spanish Wells"},"BS-NS":{type:"District",name:"North Andros"},"BS-CO":{type:"District",name:"Central Abaco"}}},JE:{name:"Jersey",sub:{"JE-JE":{type:"Country",name:"Jersey"}}},BY:{name:"Belarus",sub:{"BY-HM":{type:"City",name:"Gorod Minsk"},"BY-BR":{type:"Oblast",name:"Bresckaja voblasć"},"BY-HO":{type:"Oblast",name:"Gomel'skaja oblast'"},"BY-MA":{type:"Oblast",name:"Mahilioŭskaja voblasć"},"BY-MI":{type:"Oblast",name:"Minskaja oblast'"},"BY-VI":{type:"Oblast",name:"Viciebskaja voblasć"},"BY-HR":{type:"Oblast",name:"Grodnenskaja oblast'"}}},BZ:{name:"Belize",sub:{"BZ-CY":{type:"District",name:"Cayo"},"BZ-CZL":{type:"District",name:"Corozal"},"BZ-SC":{type:"District",name:"Stann Creek"},"BZ-BZ":{type:"District",name:"Belize"},"BZ-TOL":{type:"District",name:"Toledo"},"BZ-OW":{type:"District",name:"Orange Walk"}}},RU:{name:"Russia",sub:{"RU-PNZ":{type:"Administrative region",name:"Penzenskaja oblast'"},"RU-KRS":{type:"Administrative region",name:"Kurskaja oblast'"},"RU-ULY":{type:"Administrative region",name:"Ul'janovskaja oblast'"},"RU-BEL":{type:"Administrative region",name:"Belgorodskaja oblast'"},"RU-SAK":{type:"Administrative region",name:"Sahalinskaja oblast'"},"RU-KYA":{type:"Administrative territory",name:"Krasnojarskij kraj"},"RU-STA":{type:"Administrative territory",name:"Stavropol'skij kraj"},"RU-IVA":{type:"Administrative region",name:"Ivanovskaja oblast'"},"RU-LIP":{type:"Administrative region",name:"Lipeckaja oblast'"},"RU-AST":{type:"Administrative region",name:"Astrahanskaja oblast'"},"RU-CE":{type:"Republic",name:"Čečenskaja Respublika"},"RU-KHA":{type:"Administrative territory",name:"Habarovskij kraj"},"RU-ORE":{type:"Administrative region",name:"Orenburgskaja oblast'"},"RU-VLG":{type:"Administrative region",name:"Vologodskaja oblast'"},"RU-YAR":{type:"Administrative region",name:"Jaroslavskaja oblast'"},"RU-NGR":{type:"Administrative region",name:"Novgorodskaja oblast'"},"RU-KLU":{type:"Administrative region",name:"Kaluzhskaya oblast'"},"RU-OMS":{type:"Administrative region",name:"Omskaja oblast'"},"RU-IRK":{type:"Administrative region",name:"Irkutskaja oblast'"},"RU-ORL":{type:"Administrative region",name:"Orlovskaja oblast'"},"RU-DA":{type:"Republic",name:"Dagestan, Respublika"},"RU-PRI":{type:"Administrative territory",name:"Primorskij kraj"},"RU-SAM":{type:"Administrative region",name:"Samarskaja oblast'"},"RU-SAR":{type:"Administrative region",name:"Saratovskaja oblast'"},"RU-KOS":{type:"Administrative region",name:"Kostromskaja oblast'"},"RU-SPE":{type:"Autonomous city",name:"Sankt-Peterburg"},"RU-NIZ":{type:"Administrative region",name:"Nižegorodskaja oblast'"},"RU-SA":{type:"Republic",name:"Saha, Respublika"},"RU-KHM":{type:"Autonomous district",name:"Hanty-Mansijskij avtonomnyj okrug"},"RU-LEN":{type:"Administrative region",name:"Leningradskaja oblast'"},"RU-CHE":{type:"Administrative region",name:"Čeljabinskaja oblast'"},"RU-BA":{type:"Republic",name:"Bashkortostan, Respublika"},"RU-SE":{type:"Republic",name:"Severnaja Osetija, Respublika"},"RU-MOS":{type:"Administrative region",name:"Moskovskaja oblast'"},"RU-YAN":{type:"Autonomous district",name:"Jamalo-Neneckij avtonomnyj okrug"},"RU-KGD":{type:"Administrative region",name:"Kaliningradskaja oblast'"},"RU-MOW":{type:"Autonomous city",name:"Moskva"},"RU-KAM":{type:"Administrative territory",name:"Kamčatskij kraj"},"RU-ARK":{type:"Administrative region",name:"Arhangel'skaja oblast'"},"RU-BU":{type:"Republic",name:"Burjatija, Respublika"},"RU-KEM":{type:"Administrative region",name:"Kemerovskaja oblast'"},"RU-CHU":{type:"Autonomous district",name:"Chukotskiy avtonomnyy okrug"},"RU-UD":{type:"Republic",name:"Udmurtskaja Respublika"},"RU-KGN":{type:"Administrative region",name:"Kurganskaja oblast'"},"RU-TUL":{type:"Administrative region",name:"Tul'skaja oblast'"},"RU-KIR":{type:"Administrative region",name:"Kirovskaja oblast'"},"RU-KR":{type:"Republic",name:"Karelija, Respublika"},"RU-ME":{type:"Republic",name:"Marij Èl, Respublika"},"RU-IN":{type:"Republic",name:"Ingušetija, Respublika"},"RU-MAG":{type:"Administrative region",name:"Magadanskaja oblast'"},"RU-MO":{type:"Republic",name:"Mordovija, Respublika"},"RU-TA":{type:"Republic",name:"Tatarstan, Respublika"},"RU-SVE":{type:"Administrative region",name:"Sverdlovskaja oblast'"},"RU-RYA":{type:"Administrative region",name:"Rjazanskaja oblast'"},"RU-ZAB":{type:"Administrative territory",name:"Zabajkal'skij kraj"},"RU-NEN":{type:"Autonomous district",name:"Neneckij avtonomnyj okrug"},"RU-KB":{type:"Republic",name:"Kabardino-Balkarskaja Respublika"},"RU-ALT":{type:"Administrative territory",name:"Altajskij kraj"},"RU-TY":{type:"Republic",name:"Tyva, Respublika"},"RU-MUR":{type:"Administrative region",name:"Murmanskaja oblast'"},"RU-VOR":{type:"Administrative region",name:"Voronezhskaya oblast'"},"RU-PSK":{type:"Administrative region",name:"Pskovskaja oblast'"},"RU-TVE":{type:"Administrative region",name:"Tverskaja oblast'"},"RU-VGG":{type:"Administrative region",name:"Volgogradskaja oblast'"},"RU-KK":{type:"Republic",name:"Hakasija, Respublika"},"RU-KL":{type:"Republic",name:"Kalmykija, Respublika"},"RU-TOM":{type:"Administrative region",name:"Tomskaja oblast'"},"RU-KO":{type:"Republic",name:"Komi, Respublika"},"RU-TYU":{type:"Administrative region",name:"Tjumenskaja oblast'"},"RU-TAM":{type:"Administrative region",name:"Tambovskaja oblast'"},"RU-NVS":{type:"Administrative region",name:"Novosibirskaja oblast'"},"RU-AD":{type:"Republic",name:"Adygeja, Respublika"},"RU-PER":{type:"Administrative territory",name:"Permskij kraj"},"RU-ROS":{type:"Administrative region",name:"Rostovskaja oblast'"},"RU-AMU":{type:"Administrative region",name:"Amurskaja oblast'"},"RU-AL":{type:"Republic",name:"Altaj, Respublika"},"RU-KC":{type:"Republic",name:"Karačaevo-Čerkesskaja Respublika"},"RU-KDA":{type:"Administrative territory",name:"Krasnodarskij kraj"},"RU-YEV":{type:"Autonomous region",name:"Evrejskaja avtonomnaja oblast'"},"RU-VLA":{type:"Administrative region",name:"Vladimirskaja oblast'"},"RU-BRY":{type:"Administrative region",name:"Brjanskaja oblast'"},"RU-SMO":{type:"Administrative region",name:"Smolenskaja oblast'"},"RU-CU":{type:"Republic",name:"Chuvashskaya Respublika"}}},RW:{name:"Rwanda",sub:{"RW-03":{type:"Province",name:"Nord"},"RW-02":{type:"Province",name:"Est"},"RW-01":{type:"Town council",name:"Ville de Kigal"},"RW-05":{type:"Province",name:"Sud"},"RW-04":{type:"Province",name:"Ouest"}}},RS:{name:"Serbia",sub:{"RS-07":{type:"District",name:"Sremski okrug"},"RS-06":{type:"District",name:"Južnobački okrug"},"RS-05":{type:"District",name:"Zapadnobački okrug"},"RS-04":{type:"District",name:"Južnobanatski okrug"},"RS-03":{type:"District",name:"Severnobanatski okrug"},"RS-02":{type:"District",name:"Srednjebanatski okrug"},"RS-01":{type:"District",name:"Severnobački okrug"},"RS-00":{type:"City",name:"Beograd"},"RS-09":{type:"District",name:"Kolubarski okrug"},"RS-08":{type:"District",name:"Mačvanski okrug"},"RS-29":{type:"District",name:"Kosovsko-Pomoravski okrug"},"RS-28":{type:"District",name:"Kosovsko-Mitrovački okrug"},"RS-21":{type:"District",name:"Toplički okrug"},"RS-20":{type:"District",name:"Nišavski okrug"},"RS-23":{type:"District",name:"Jablanički okrug"},"RS-22":{type:"District",name:"Pirotski okrug"},"RS-25":{type:"District",name:"Kosovski okrug"},"RS-24":{type:"District",name:"Pčinjski okrug"},"RS-27":{type:"District",name:"Prizrenski okrug"},"RS-26":{type:"District",name:"Pećki okrug"},"RS-VO":{type:"Autonomous province",name:"Vojvodina"},"RS-10":{type:"District",name:"Podunavski okrug"},"RS-11":{type:"District",name:"Braničevski okrug"},"RS-12":{type:"District",name:"Šumadijski okrug"},"RS-13":{type:"District",name:"Pomoravski okrug"},"RS-14":{type:"District",name:"Borski okrug"},"RS-15":{type:"District",name:"Zaječarski okrug"},"RS-16":{type:"District",name:"Zlatiborski okrug"},"RS-17":{type:"District",name:"Moravički okrug"},"RS-18":{type:"District",name:"Raški okrug"},"RS-19":{type:"District",name:"Rasinski okrug"},"RS-KM":{type:"Autonomous province",name:"Kosovo-Metohija"}}},TL:{name:"East Timor",sub:{"TL-ER":{type:"District",name:"Ermera"},"TL-LA":{type:"District",name:"Lautém"},"TL-OE":{type:"District",name:"Oecussi"},"TL-AN":{type:"District",name:"Ainaro"},"TL-AL":{type:"District",name:"Aileu"},"TL-MF":{type:"District",name:"Manufahi"},"TL-MT":{type:"District",name:"Manatuto"},"TL-VI":{type:"District",name:"Vikeke"},"TL-BO":{type:"District",name:"Bobonaro"},"TL-CO":{type:"District",name:"Cova Lima"},"TL-BA":{type:"District",name:"Baucau"},"TL-LI":{type:"District",name:"Likisá"},"TL-DI":{type:"District",name:"Díli"}}},RE:{name:"Reunion",sub:{"RE-RE":{type:"Country",name:"Reunion"}}},TM:{name:"Turkmenistan",sub:{"TM-S":{type:"City",name:"Aşgabat"},"TM-L":{type:"Region",name:"Lebap"},"TM-M":{type:"Region",name:"Mary"},"TM-D":{type:"Region",name:"Daşoguz"},"TM-B":{type:"Region",name:"Balkan"},"TM-A":{type:"Region",name:"Ahal"}}},TJ:{name:"Tajikistan",sub:{"TJ-GB":{type:"Autonomous region",name:"Kŭhistoni Badakhshon"},"TJ-SU":{type:"Region",name:"Sughd"},"TJ-DU":{type:"Capital territory",name:"Dushanbe"},"TJ-KT":{type:"Region",name:"Khatlon"}}},RO:{name:"Romania",sub:{"RO-SB":{type:"Department",name:"Sibiu"},"RO-DB":{type:"Department",name:"Dâmboviţa"},"RO-SM":{type:"Department",name:"Satu Mare"},"RO-SJ":{type:"Department",name:"Sălaj"},"RO-DJ":{type:"Department",name:"Dolj"},"RO-HD":{type:"Department",name:"Hunedoara"},"RO-SV":{type:"Department",name:"Suceava"},"RO-B":{type:"Municipality",name:"Bucureşti"},"RO-HR":{type:"Department",name:"Harghita"},"RO-VS":{type:"Department",name:"Vaslui"},"RO-NT":{type:"Department",name:"Neamţ"},"RO-CV":{type:"Department",name:"Covasna"},"RO-CT":{type:"Department",name:"Constanţa"},"RO-CS":{type:"Department",name:"Caraş-Severin"},"RO-GR":{type:"Department",name:"Giurgiu"},"RO-VN":{type:"Department",name:"Vrancea"},"RO-AR":{type:"Department",name:"Arad"},"RO-GJ":{type:"Department",name:"Gorj"},"RO-GL":{type:"Department",name:"Galaţi"},"RO-CL":{type:"Department",name:"Călăraşi"},"RO-AG":{type:"Department",name:"Argeş"},"RO-CJ":{type:"Department",name:"Cluj"},"RO-AB":{type:"Department",name:"Alba"},"RO-PH":{type:"Department",name:"Prahova"},"RO-TR":{type:"Department",name:"Teleorman"},"RO-OT":{type:"Department",name:"Olt"},"RO-IS":{type:"Department",name:"Iaşi"},"RO-VL":{type:"Department",name:"Vâlcea"},"RO-MS":{type:"Department",name:"Mureş"},"RO-MH":{type:"Department",name:"Mehedinţi"},"RO-IF":{type:"Department",name:"Ilfov"},"RO-MM":{type:"Department",name:"Maramureş"},"RO-IL":{type:"Department",name:"Ialomiţa"},"RO-TM":{type:"Department",name:"Timiş"},"RO-TL":{type:"Department",name:"Tulcea"},"RO-BT":{type:"Department",name:"Botoşani"},"RO-BV":{type:"Department",name:"Braşov"},"RO-BR":{type:"Department",name:"Brăila"},"RO-BZ":{type:"Department",name:"Buzău"},"RO-BC":{type:"Department",name:"Bacău"},"RO-BN":{type:"Department",name:"Bistriţa-Năsăud"},"RO-BH":{type:"Department",name:"Bihor"}}},TK:{name:"Tokelau",sub:{"TK-TK":{type:"Country",name:"Tokelau"}}},GW:{name:"Guinea-Bissau",sub:{"GW-BL":{type:"Region",name:"Bolama"},"GW-BM":{type:"Region",name:"Biombo"},"GW-CA":{type:"Region",name:"Cacheu"},"GW-QU":{type:"Region",name:"Quinara"},"GW-S":{type:"Province",name:"Sul"},"GW-OI":{type:"Region",name:"Oio"},"GW-L":{type:"Province",name:"Leste"},"GW-N":{type:"Province",name:"Norte"},"GW-BA":{type:"Region",name:"Bafatá"},"GW-TO":{type:"Region",name:"Tombali"},"GW-GA":{type:"Region",name:"Gabú"},"GW-BS":{type:"Autonomous sector",name:"Bissau"}}},GU:{name:"Guam",sub:{"GU-GU":{type:"Country",name:"Guam"}}},GT:{name:"Guatemala",sub:{"GT-SO":{type:"Department",name:"Sololá"},"GT-SM":{type:"Department",name:"San Marcos"},"GT-JA":{type:"Department",name:"Jalapa"},"GT-BV":{type:"Department",name:"Baja Verapaz"},"GT-QZ":{type:"Department",name:"Quetzaltenango"},"GT-SA":{type:"Department",name:"Sacatepéquez"},"GT-JU":{type:"Department",name:"Jutiapa"},"GT-HU":{type:"Department",name:"Huehuetenango"},"GT-QC":{type:"Department",name:"Quiché"},"GT-SU":{type:"Department",name:"Suchitepéquez"},"GT-SR":{type:"Department",name:"Santa Rosa"},"GT-ZA":{type:"Department",name:"Zacapa"},"GT-RE":{type:"Department",name:"Retalhuleu"},"GT-PE":{type:"Department",name:"Petén"},"GT-CQ":{type:"Department",name:"Chiquimula"},"GT-TO":{type:"Department",name:"Totonicapán"},"GT-CM":{type:"Department",name:"Chimaltenango"},"GT-IZ":{type:"Department",name:"Izabal"},"GT-PR":{type:"Department",name:"El Progreso"},"GT-AV":{type:"Department",name:"Alta Verapaz"},"GT-GU":{type:"Department",name:"Guatemala"},"GT-ES":{type:"Department",name:"Escuintla"}}},GS:{name:"S.Georgia & S.Sandwich Islands",sub:{"GS-GS":{type:"Country",name:"S.Georgia & S.Sandwich Islands"}}},GR:{name:"Greece",sub:{"GR-85":{type:"Department",name:"Chíos"},"GR-84":{type:"Department",name:"Sámos"},"GR-64":{type:"Department",name:"Chalkidikí"},"GR-81":{type:"Department",name:"Dodekánisa"},"GR-83":{type:"Department",name:"Lésvos"},"GR-54":{type:"Department",name:"Thessaloníki"},"GR-A":{type:"Administrative region",name:"Anatolikí Makedonía kai Thráki"},"GR-G":{type:"Administrative region",name:"Dytikí Elláda"},"GR-B":{type:"Administrative region",name:"Kentrikí Makedonía"},"GR-73":{type:"Department",name:"Rodópi"},"GR-J":{type:"Administrative region",name:"Peloponnísos"},"GR-I":{type:"Administrative region",name:"Attikí"},"GR-34":{type:"Department",name:"Préveza"},"GR-53":{type:"Department",name:"Imathía"},"GR-51":{type:"Department",name:"Grevená"},"GR-56":{type:"Department",name:"Kastoriá"},"GR-31":{type:"Department",name:"Árta"},"GR-32":{type:"Department",name:"Thesprotía"},"GR-33":{type:"Department",name:"Ioánnina"},"GR-71":{type:"Department",name:"Évros"},"GR-58":{type:"Department",name:"Kozáni"},"GR-59":{type:"Department",name:"Pélla"},"GR-16":{type:"Department",name:"Lakonía"},"GR-17":{type:"Department",name:"Messinía"},"GR-14":{type:"Department",name:"Ileía"},"GR-15":{type:"Department",name:"Korinthía"},"GR-12":{type:"Department",name:"Arkadía"},"GR-13":{type:"Department",name:"Achaḯa"},"GR-11":{type:"Department",name:"Argolída"},"GR-52":{type:"Department",name:"Dráma"},"GR-94":{type:"Department",name:"Chaniá"},"GR-92":{type:"Department",name:"Lasíthi"},"GR-93":{type:"Department",name:"Rethýmnis"},"GR-91":{type:"Department",name:"Irakleío"},"GR-L":{type:"Administrative region",name:"Notío Aigaío"},"GR-A1":{type:"Department",name:"Attikí"},"GR-05":{type:"Department",name:"Evrytanía"},"GR-04":{type:"Department",name:"Évvoia"},"GR-82":{type:"Department",name:"Kykládes"},"GR-07":{type:"Department",name:"Fokída"},"GR-57":{type:"Department",name:"Kilkís"},"GR-41":{type:"Department",name:"Kardítsa"},"GR-M":{type:"Administrative region",name:"Krítí"},"GR-43":{type:"Department",name:"Magnisía"},"GR-42":{type:"Department",name:"Lárisa"},"GR-H":{type:"Administrative region",name:"Stereá Elláda"},"GR-44":{type:"Department",name:"Tríkala"},"GR-69":{type:"Self-governed part",name:"Ágion Óros"},"GR-K":{type:"Administrative region",name:"Voreío Aigaío"},"GR-D":{type:"Administrative region",name:"Ípeiros"},"GR-E":{type:"Administrative region",name:"Thessalía"},"GR-F":{type:"Administrative region",name:"Ionía Nísia"},"GR-55":{type:"Department",name:"Kavála"},"GR-63":{type:"Department",name:"Flórina"},"GR-62":{type:"Department",name:"Sérres"},"GR-61":{type:"Department",name:"Piería"},"GR-C":{type:"Administrative region",name:"Dytikí Makedonía"},"GR-23":{type:"Department",name:"Kefallinía"},"GR-22":{type:"Department",name:"Kérkyra"},"GR-21":{type:"Department",name:"Zákynthos"},"GR-06":{type:"Department",name:"Fthiótida"},"GR-01":{type:"Department",name:"Aitoloakarnanía"},"GR-72":{
		type:"Department",name:"Xánthi"},"GR-03":{type:"Department",name:"Voiotía"},"GR-24":{type:"Department",name:"Lefkáda"}}},GQ:{name:"Equatorial Guinea",sub:{"GQ-LI":{type:"Province",name:"Litoral"},"GQ-C":{type:"Region",name:"Região Continental"},"GQ-BN":{type:"Province",name:"Bioko Nord"},"GQ-AN":{type:"Province",name:"Annobón"},"GQ-I":{type:"Region",name:"Região Insular"},"GQ-KN":{type:"Province",name:"Kié-Ntem"},"GQ-BS":{type:"Province",name:"Bioko Sud"},"GQ-CS":{type:"Province",name:"Centro Sud"},"GQ-WN":{type:"Province",name:"Wele-Nzas"}}},GP:{name:"Guadeloupe",sub:{"GP-GP":{type:"Country",name:"Guadeloupe"}}},JP:{name:"Japan",sub:{"JP-37":{type:"Prefecture",name:"Kagawa"},"JP-36":{type:"Prefecture",name:"Tokushima"},"JP-35":{type:"Prefecture",name:"Yamaguchi"},"JP-34":{type:"Prefecture",name:"Hiroshima"},"JP-33":{type:"Prefecture",name:"Okayama"},"JP-32":{type:"Prefecture",name:"Shimane"},"JP-31":{type:"Prefecture",name:"Tottori"},"JP-30":{type:"Prefecture",name:"Wakayama"},"JP-39":{type:"Prefecture",name:"Kochi"},"JP-38":{type:"Prefecture",name:"Ehime"},"JP-19":{type:"Prefecture",name:"Yamanashi"},"JP-18":{type:"Prefecture",name:"Fukui"},"JP-11":{type:"Prefecture",name:"Saitama"},"JP-10":{type:"Prefecture",name:"Gunma"},"JP-13":{type:"Prefecture",name:"Tôkyô"},"JP-12":{type:"Prefecture",name:"Chiba"},"JP-15":{type:"Prefecture",name:"Niigata"},"JP-14":{type:"Prefecture",name:"Kanagawa"},"JP-17":{type:"Prefecture",name:"Ishikawa"},"JP-16":{type:"Prefecture",name:"Toyama"},"JP-20":{type:"Prefecture",name:"Nagano"},"JP-21":{type:"Prefecture",name:"Gifu"},"JP-22":{type:"Prefecture",name:"Shizuoka"},"JP-23":{type:"Prefecture",name:"Aichi"},"JP-24":{type:"Prefecture",name:"Mie"},"JP-25":{type:"Prefecture",name:"Shiga"},"JP-26":{type:"Prefecture",name:"Kyoto"},"JP-27":{type:"Prefecture",name:"Osaka"},"JP-28":{type:"Prefecture",name:"Hyogo"},"JP-29":{type:"Prefecture",name:"Nara"},"JP-46":{type:"Prefecture",name:"Kagoshima"},"JP-47":{type:"Prefecture",name:"Okinawa"},"JP-08":{type:"Prefecture",name:"Ibaraki"},"JP-09":{type:"Prefecture",name:"Tochigi"},"JP-42":{type:"Prefecture",name:"Nagasaki"},"JP-43":{type:"Prefecture",name:"Kumamoto"},"JP-40":{type:"Prefecture",name:"Fukuoka"},"JP-41":{type:"Prefecture",name:"Saga"},"JP-02":{type:"Prefecture",name:"Aomori"},"JP-03":{type:"Prefecture",name:"Iwate"},"JP-01":{type:"Prefecture",name:"Hokkaido"},"JP-06":{type:"Prefecture",name:"Yamagata"},"JP-07":{type:"Prefecture",name:"Fukushima"},"JP-04":{type:"Prefecture",name:"Miyagi"},"JP-05":{type:"Prefecture",name:"Akita"},"JP-44":{type:"Prefecture",name:"Oita"},"JP-45":{type:"Prefecture",name:"Miyazaki"}}},GY:{name:"Guyana",sub:{"GY-UT":{type:"Region",name:"Upper Takutu-Upper Essequibo"},"GY-MA":{type:"Region",name:"Mahaica-Berbice"},"GY-PM":{type:"Region",name:"Pomeroon-Supenaam"},"GY-UD":{type:"Region",name:"Upper Demerara-Berbice"},"GY-ES":{type:"Region",name:"Essequibo Islands-West Demerara"},"GY-EB":{type:"Region",name:"East Berbice-Corentyne"},"GY-PT":{type:"Region",name:"Potaro-Siparuni"},"GY-CU":{type:"Region",name:"Cuyuni-Mazaruni"},"GY-BA":{type:"Region",name:"Barima-Waini"},"GY-DE":{type:"Region",name:"Demerara-Mahaica"}}},GG:{name:"Guernsey",sub:{"GG-GG":{type:"Country",name:"Guernsey"}}},GF:{name:"French Guiana",sub:{"GF-GF":{type:"Country",name:"French Guiana"}}},GE:{name:"Georgia",sub:{"GE-GU":{type:"Region",name:"Guria"},"GE-SK":{type:"Region",name:"Shida Kartli"},"GE-SJ":{type:"Region",name:"Samtskhe-Javakheti"},"GE-AB":{type:"Autonomous republic",name:"Abkhazia"},"GE-MM":{type:"Region",name:"Mtskheta-Mtianeti"},"GE-AJ":{type:"Autonomous republic",name:"Ajaria"},"GE-TB":{type:"City",name:"Tbilisi"},"GE-KA":{type:"Region",name:"K'akheti"},"GE-IM":{type:"Region",name:"Imereti"},"GE-SZ":{type:"Region",name:"Samegrelo-Zemo Svaneti"},"GE-KK":{type:"Region",name:"Kvemo Kartli"},"GE-RL":{type:"Region",name:"Rach'a-Lechkhumi-Kvemo Svaneti"}}},GD:{name:"Grenada",sub:{"GD-03":{type:"Parish",name:"Saint George"},"GD-02":{type:"Parish",name:"Saint David"},"GD-01":{type:"Parish",name:"Saint Andrew"},"GD-06":{type:"Parish",name:"Saint Patrick"},"GD-05":{type:"Parish",name:"Saint Mark"},"GD-04":{type:"Parish",name:"Saint John"},"GD-10":{type:"Dependency",name:"Southern Grenadine Islands"}}},GB:{name:"United Kingdom",sub:{"GB-TRF":{type:"Metropolitan district",name:"Trafford"},"GB-WRX":{type:"Unitary authority",name:"Wrexham"},"GB-BEN":{type:"London borough",name:"Brent"},"GB-HRW":{type:"London borough",name:"Harrow"},"GB-WRT":{type:"Unitary authority",name:"Warrington"},"GB-LBH":{type:"London borough",name:"Lambeth"},"GB-DAL":{type:"Unitary authority",name:"Darlington"},"GB-WRL":{type:"Metropolitan district",name:"Wirral"},"GB-MYL":{type:"District council area",name:"Moyle"},"GB-UKM":{type:"Nation",name:"United Kingdom"},"GB-BEX":{type:"London borough",name:"Bexley"},"GB-BUR":{type:"Metropolitan district",name:"Bury"},"GB-KIR":{type:"Metropolitan district",name:"Kirklees"},"GB-FER":{type:"District council area",name:"Fermanagh"},"GB-NBL":{type:"Unitary authority",name:"Northumberland"},"GB-DRY":{type:"District council area",name:"Derry"},"GB-CKF":{type:"District council area",name:"Carrickfergus"},"GB-ERY":{type:"Unitary authority",name:"East Riding of Yorkshire"},"GB-CMA":{type:"Two-tier county",name:"Cumbria"},"GB-HCK":{type:"London borough",name:"Hackney"},"GB-CRY":{type:"London borough",name:"Croydon"},"GB-ABE":{type:"Council area",name:"Aberdeen City"},"GB-ABD":{type:"Council area",name:"Aberdeenshire"},"GB-CKT":{type:"District council area",name:"Cookstown"},"GB-ERW":{type:"Council area",name:"East Renfrewshire"},"GB-HIL":{type:"London borough",name:"Hillingdon"},"GB-NLN":{type:"Unitary authority",name:"North Lincolnshire"},"GB-WSX":{type:"Two-tier county",name:"West Sussex"},"GB-BIR":{type:"Metropolitan district",name:"Birmingham"},"GB-WBK":{type:"Unitary authority",name:"West Berkshire"},"GB-EDU":{type:"Council area",name:"East Dunbartonshire"},"GB-WSM":{type:"London borough",name:"Westminster"},"GB-STS":{type:"Two-tier county",name:"Staffordshire"},"GB-HRT":{type:"Two-tier county",name:"Hertfordshire"},"GB-LSB":{type:"District council area",name:"Lisburn"},"GB-EDH":{type:"Council area",name:"Edinburgh, City of"},"GB-HRY":{type:"London borough",name:"Haringey"},"GB-LAN":{type:"Two-tier county",name:"Lancashire"},"GB-RIC":{type:"London borough",name:"Richmond upon Thames"},"GB-LRN":{type:"District council area",name:"Larne"},"GB-ZET":{type:"Council area",name:"Shetland Islands"},"GB-ELS":{type:"Council area",name:"Eilean Siar"},"GB-NTA":{type:"District council area",name:"Newtownabbey"},"GB-SRY":{type:"Two-tier county",name:"Surrey"},"GB-BMH":{type:"Unitary authority",name:"Bournemouth"},"GB-CHE":{type:"Unitary authority",name:"Cheshire East"},"GB-FLN":{type:"Unitary authority",name:"Flintshire"},"GB-NET":{type:"Metropolitan district",name:"Newcastle upon Tyne"},"GB-NTH":{type:"Two-tier county",name:"Northamptonshire"},"GB-NTT":{type:"Two-tier county",name:"Nottinghamshire"},"GB-NTL":{type:"Unitary authority",name:"Neath Port Talbot"},"GB-ESX":{type:"Two-tier county",name:"East Sussex"},"GB-KTT":{type:"London borough",name:"Kingston upon Thames"},"GB-MRT":{type:"London borough",name:"Merton"},"GB-OXF":{type:"Two-tier county",name:"Oxfordshire"},"GB-MRY":{type:"Council area",name:"Moray"},"GB-ESS":{type:"Two-tier county",name:"Essex"},"GB-CHW":{type:"Unitary authority",name:"Cheshire West and Chester"},"GB-SOS":{type:"Unitary authority",name:"Southend-on-Sea"},"GB-PEM":{type:"Unitary authority",name:"Pembrokeshire"},"GB-NTY":{type:"Metropolitan district",name:"North Tyneside"},"GB-NEL":{type:"Unitary authority",name:"North East Lincolnshire"},"GB-HAL":{type:"Unitary authority",name:"Halton"},"GB-RFW":{type:"Council area",name:"Renfrewshire"},"GB-LUT":{type:"Unitary authority",name:"Luton"},"GB-WOK":{type:"Unitary authority",name:"Wokingham"},"GB-WOR":{type:"Two-tier county",name:"Worcestershire"},"GB-HLD":{type:"Council area",name:"Highland"},"GB-MFT":{type:"District council area",name:"Magherafelt"},"GB-NSM":{type:"Unitary authority",name:"North Somerset"},"GB-LDS":{type:"Metropolitan district",name:"Leeds"},"GB-KWL":{type:"Metropolitan district",name:"Knowsley"},"GB-SOM":{type:"Two-tier county",name:"Somerset"},"GB-DEN":{type:"Unitary authority",name:"Denbighshire"},"GB-BST":{type:"Unitary authority",name:"Bristol, City of"},"GB-EAL":{type:"London borough",name:"Ealing"},"GB-RDB":{type:"London borough",name:"Redbridge"},"GB-CSR":{type:"District council area",name:"Castlereagh"},"GB-RDG":{type:"Unitary authority",name:"Reading"},"GB-EAW":{type:"Nation",name:"England and Wales"},"GB-CMD":{type:"London borough",name:"Camden"},"GB-MON":{type:"Unitary authority",name:"Monmouthshire"},"GB-OLD":{type:"Metropolitan district",name:"Oldham"},"GB-CON":{type:"Unitary authority",name:"Cornwall"},"GB-CMN":{type:"Unitary authority",name:"Carmarthenshire"},"GB-EAY":{type:"Council area",name:"East Ayrshire"},"GB-HEF":{type:"Unitary authority",name:"Herefordshire"},"GB-ROT":{type:"Metropolitan district",name:"Rotherham"},"GB-NAY":{type:"Council area",name:"North Ayrshire"},"GB-BBD":{type:"Unitary authority",name:"Blackburn with Darwen"},"GB-TOF":{type:"Unitary authority",name:"Torfaen"},"GB-WDU":{type:"Council area",name:"West Dunbartonshire"},"GB-WLL":{type:"Metropolitan district",name:"Walsall"},"GB-WLN":{type:"Council area",name:"West Lothian"},"GB-GRE":{type:"London borough",name:"Greenwich"},"GB-MIK":{type:"Unitary authority",name:"Milton Keynes"},"GB-KEC":{type:"London borough",name:"Kensington and Chelsea"},"GB-MAN":{type:"Metropolitan district",name:"Manchester"},"GB-WLV":{type:"Metropolitan district",name:"Wolverhampton"},"GB-WLS":{type:"Country",name:"Wales"},"GB-ELN":{type:"Council area",name:"East Lothian"},"GB-CBF":{type:"Unitary authority",name:"Central Bedfordshire"},"GB-STH":{type:"Unitary authority",name:"Southampton"},"GB-KEN":{type:"Two-tier county",name:"Kent"},"GB-STY":{type:"Metropolitan district",name:"South Tyneside"},"GB-LCE":{type:"Unitary authority",name:"Leicester"},"GB-ARM":{type:"District council area",name:"Armagh"},"GB-BKM":{type:"Two-tier county",name:"Buckinghamshire"},"GB-SLG":{type:"Unitary authority",name:"Slough"},"GB-SLF":{type:"Metropolitan district",name:"Salford"},"GB-ORK":{type:"Council area",name:"Orkney Islands"},"GB-ARD":{type:"District council area",name:"Ards"},"GB-SLK":{type:"Council area",name:"South Lanarkshire"},"GB-BRY":{type:"London borough",name:"Bromley"},"GB-STT":{type:"Unitary authority",name:"Stockton-on-Tees"},"GB-POL":{type:"Unitary authority",name:"Poole"},"GB-BRC":{type:"Unitary authority",name:"Bracknell Forest"},"GB-SHN":{type:"Metropolitan district",name:"St. Helens"},"GB-POW":{type:"Unitary authority",name:"Powys"},"GB-GBN":{type:"Nation",name:"Great Britain"},"GB-BRD":{type:"Metropolitan district",name:"Bradford"},"GB-CRF":{type:"Unitary authority",name:"Cardiff"},"GB-STB":{type:"District council area",name:"Strabane"},"GB-STE":{type:"Unitary authority",name:"Stoke-on-Trent"},"GB-DBY":{type:"Two-tier county",name:"Derbyshire"},"GB-STG":{type:"Council area",name:"Stirling"},"GB-AGB":{type:"Council area",name:"Argyll and Bute"},"GB-DEV":{type:"Two-tier county",name:"Devon"},"GB-WIL":{type:"Unitary authority",name:"Wiltshire"},"GB-DER":{type:"Unitary authority",name:"Derby"},"GB-HNS":{type:"London borough",name:"Hounslow"},"GB-SAW":{type:"Metropolitan district",name:"Sandwell"},"GB-PLY":{type:"Unitary authority",name:"Plymouth"},"GB-NIR":{type:"Province",name:"Northern Ireland"},"GB-THR":{type:"Unitary authority",name:"Thurrock"},"GB-BAS":{type:"Unitary authority",name:"Bath and North East Somerset"},"GB-FIF":{type:"Council area",name:"Fife"},"GB-AGY":{type:"Unitary authority",name:"Isle of Anglesey"},"GB-SAY":{type:"Council area",name:"South Ayrshire"},"GB-NFK":{type:"Two-tier county",name:"Norfolk"},"GB-TFW":{type:"Unitary authority",name:"Telford and Wrekin"},"GB-BNE":{type:"London borough",name:"Barnet"},"GB-BNB":{type:"District council area",name:"Banbridge"},"GB-TOB":{type:"Unitary authority",name:"Torbay"},"GB-CGN":{type:"Unitary authority",name:"Ceredigion"},"GB-BFS":{type:"District council area",name:"Belfast"},"GB-BNH":{type:"Unitary authority",name:"Brighton and Hove"},"GB-WAR":{type:"Two-tier county",name:"Warwickshire"},"GB-CGV":{type:"District council area",name:"Craigavon"},"GB-BNS":{type:"Metropolitan district",name:"Barnsley"},"GB-TWH":{type:"London borough",name:"Tower Hamlets"},"GB-ANS":{type:"Council area",name:"Angus"},"GB-FAL":{type:"Council area",name:"Falkirk"},"GB-NYK":{type:"Two-tier county",name:"North Yorkshire"},"GB-ANT":{type:"District council area",name:"Antrim"},"GB-SWD":{type:"Unitary authority",name:"Swindon"},"GB-IOS":{type:"Unitary authority",name:"Isles of Scilly"},"GB-WNM":{type:"Unitary authority",name:"Windsor and Maidenhead"},"GB-IOW":{type:"Unitary authority",name:"Isle of Wight"},"GB-GLS":{type:"Two-tier county",name:"Gloucestershire"},"GB-SFT":{type:"Metropolitan district",name:"Sefton"},"GB-IVC":{type:"Council area",name:"Inverclyde"},"GB-WND":{type:"London borough",name:"Wandsworth"},"GB-LEC":{type:"Two-tier county",name:"Leicestershire"},"GB-SWK":{type:"London borough",name:"Southwark"},"GB-YOR":{type:"Unitary authority",name:"York"},"GB-GLG":{type:"Council area",name:"Glasgow City"},"GB-RUT":{type:"Unitary authority",name:"Rutland"},"GB-HMF":{type:"London borough",name:"Hammersmith and Fulham"},"GB-SFK":{type:"Two-tier county",name:"Suffolk"},"GB-LEW":{type:"London borough",name:"Lewisham"},"GB-NYM":{type:"District council area",name:"Newry and Mourne"},"GB-DUD":{type:"Metropolitan district",name:"Dudley"},"GB-CLR":{type:"District council area",name:"Coleraine"},"GB-CWY":{type:"Unitary authority",name:"Conwy"},"GB-SND":{type:"Metropolitan district",name:"Sunderland"},"GB-BPL":{type:"Unitary authority",name:"Blackpool"},"GB-VGL":{type:"Unitary authority",name:"Vale of Glamorgan, The"},"GB-WFT":{type:"London borough",name:"Waltham Forest"},"GB-LND":{type:"City corporation",name:"London, City of"},"GB-CLD":{type:"Metropolitan district",name:"Calderdale"},"GB-GWN":{type:"Unitary authority",name:"Gwynedd"},"GB-DUR":{type:"Unitary authority",name:"Durham County"},"GB-SCT":{type:"Country",name:"Scotland"},"GB-CLK":{type:"Council area",name:"Clackmannanshire"},"GB-ENG":{type:"Country",name:"England"},"GB-MDW":{type:"Unitary authority",name:"Medway"},"GB-SCB":{type:"Council area",name:"Scottish Borders, The"},"GB-DNC":{type:"Metropolitan district",name:"Doncaster"},"GB-TAM":{type:"Metropolitan district",name:"Tameside"},"GB-WGN":{type:"Metropolitan district",name:"Wigan"},"GB-DGY":{type:"Council area",name:"Dumfries and Galloway"},"GB-PTE":{type:"Unitary authority",name:"Peterborough"},"GB-SKP":{type:"Metropolitan district",name:"Stockport"},"GB-NWP":{type:"Unitary authority",name:"Newport"},"GB-ISL":{type:"London borough",name:"Islington"},"GB-SGC":{type:"Unitary authority",name:"South Gloucestershire"},"GB-CAY":{type:"Unitary authority",name:"Caerphilly"},"GB-DGN":{type:"District council area",name:"Dungannon and South Tyrone"},"GB-WKF":{type:"Metropolitan district",name:"Wakefield"},"GB-NWM":{type:"London borough",name:"Newham"},"GB-MDB":{type:"Unitary authority",name:"Middlesbrough"},"GB-CAM":{type:"Two-tier county",name:"Cambridgeshire"},"GB-SWA":{type:"Unitary authority",name:"Swansea"},"GB-DOW":{type:"District council area",name:"Down"},"GB-BLA":{type:"District council area",name:"Ballymena"},"GB-HAV":{type:"London borough",name:"Havering"},"GB-DOR":{type:"Two-tier county",name:"Dorset"},"GB-GAT":{type:"Metropolitan district",name:"Gateshead"},"GB-POR":{type:"Unitary authority",name:"Portsmouth"},"GB-NLK":{type:"Council area",name:"North Lanarkshire"},"GB-LIV":{type:"Metropolitan district",name:"Liverpool"},"GB-LIN":{type:"Two-tier county",name:"Lincolnshire"},"GB-HAM":{type:"Two-tier county",name:"Hampshire"},"GB-BLY":{type:"District council area",name:"Ballymoney"},"GB-NDN":{type:"District council area",name:"North Down"},"GB-BDF":{type:"Unitary authority",name:"Bedford"},"GB-BDG":{type:"London borough",name:"Barking and Dagenham"},"GB-SOL":{type:"Metropolitan district",name:"Solihull"},"GB-OMH":{type:"District council area",name:"Omagh"},"GB-HPL":{type:"Unitary authority",name:"Hartlepool"},"GB-COV":{type:"Metropolitan district",name:"Coventry"},"GB-SHR":{type:"Unitary authority",name:"Shropshire"},"GB-PKN":{type:"Council area",name:"Perth and Kinross"},"GB-LMV":{type:"District council area",name:"Limavady"},"GB-RCH":{type:"Metropolitan district",name:"Rochdale"},"GB-SHF":{type:"Metropolitan district",name:"Sheffield"},"GB-NGM":{type:"Unitary authority",name:"Nottingham"},"GB-RCT":{type:"Unitary authority",name:"Rhondda, Cynon, Taff"},"GB-BOL":{type:"Metropolitan district",name:"Bolton"},"GB-BGW":{type:"Unitary authority",name:"Blaenau Gwent"},"GB-ENF":{type:"London borough",name:"Enfield"},"GB-DND":{type:"Council area",name:"Dundee City"},"GB-STN":{type:"London borough",name:"Sutton"},"GB-MLN":{type:"Council area",name:"Midlothian"},"GB-RCC":{type:"Unitary authority",name:"Redcar and Cleveland"},"GB-BGE":{type:"Unitary authority",name:"Bridgend"},"GB-KHL":{type:"Unitary authority",name:"Kingston upon Hull"},"GB-MTY":{type:"Unitary authority",name:"Merthyr Tydfil"}}},GA:{name:"Gabon",sub:{"GA-7":{type:"Province",name:"Ogooué-Lolo"},"GA-6":{type:"Province",name:"Ogooué-Ivindo"},"GA-5":{type:"Province",name:"Nyanga"},"GA-4":{type:"Province",name:"Ngounié"},"GA-3":{type:"Province",name:"Moyen-Ogooué"},"GA-2":{type:"Province",name:"Haut-Ogooué"},"GA-1":{type:"Province",name:"Estuaire"},"GA-9":{type:"Province",name:"Woleu-Ntem"},"GA-8":{type:"Province",name:"Ogooué-Maritime"}}},GN:{name:"Guinea",sub:{"GN-GU":{type:"Prefecture",name:"Guékédou"},"GN-YO":{type:"Prefecture",name:"Yomou"},"GN-TE":{type:"Prefecture",name:"Télimélé"},"GN-GA":{type:"Prefecture",name:"Gaoual"},"GN-PI":{type:"Prefecture",name:"Pita"},"GN-ML":{type:"Prefecture",name:"Mali"},"GN-MM":{type:"Prefecture",name:"Mamou"},"GN-DI":{type:"Prefecture",name:"Dinguiraye"},"GN-MD":{type:"Prefecture",name:"Mandiana"},"GN-KS":{type:"Prefecture",name:"Kissidougou"},"GN-MC":{type:"Prefecture",name:"Macenta"},"GN-CO":{type:"Prefecture",name:"Coyah"},"GN-LA":{type:"Prefecture",name:"Labé"},"GN-B":{type:"Administrative region",name:"Boké"},"GN-C":{type:"Governorate",name:"Conakry"},"GN-D":{type:"Administrative region",name:"Kindia"},"GN-F":{type:"Administrative region",name:"Faranah"},"GN-KO":{type:"Prefecture",name:"Kouroussa"},"GN-KA":{type:"Prefecture",name:"Kankan"},"GN-KB":{type:"Prefecture",name:"Koubia"},"GN-K":{type:"Administrative region",name:"Kankan"},"GN-KD":{type:"Prefecture",name:"Kindia"},"GN-KE":{type:"Prefecture",name:"Kérouané"},"GN-N":{type:"Administrative region",name:"Nzérékoré"},"GN-DU":{type:"Prefecture",name:"Dubréka"},"GN-FR":{type:"Prefecture",name:"Fria"},"GN-KN":{type:"Prefecture",name:"Koundara"},"GN-LO":{type:"Prefecture",name:"Lola"},"GN-FA":{type:"Prefecture",name:"Faranah"},"GN-DB":{type:"Prefecture",name:"Dabola"},"GN-DL":{type:"Prefecture",name:"Dalaba"},"GN-FO":{type:"Prefecture",name:"Forécariah"},"GN-BF":{type:"Prefecture",name:"Boffa"},"GN-BE":{type:"Prefecture",name:"Beyla"},"GN-LE":{type:"Prefecture",name:"Lélouma"},"GN-L":{type:"Administrative region",name:"Labé"},"GN-BK":{type:"Prefecture",name:"Boké"},"GN-M":{type:"Administrative region",name:"Mamou"},"GN-NZ":{type:"Prefecture",name:"Nzérékoré"},"GN-SI":{type:"Prefecture",name:"Siguiri"},"GN-TO":{type:"Prefecture",name:"Tougué"}}},GM:{name:"Gambia",sub:{"GM-N":{type:"Division",name:"North Bank"},"GM-M":{type:"Division",name:"Central River"},"GM-L":{type:"Division",name:"Lower River"},"GM-B":{type:"City",name:"Banjul"},"GM-W":{type:"Division",name:"Western"},"GM-U":{type:"Division",name:"Upper River"}}},GL:{name:"Greenland",sub:{"GL-QE":{type:"Municipality",name:"Qeqqata Kommunia"},"GL-KU":{type:"Municipality",name:"Kommune Kujalleq"},"GL-QA":{type:"Municipality",name:"Qaasuitsup Kommunia"},"GL-SM":{type:"Municipality",name:"Kommuneqarfik Sermersooq"}}},GI:{name:"Gibraltar",sub:{"GI-GI":{type:"Country",name:"Gibraltar"}}},GH:{name:"Ghana",sub:{"GH-AH":{type:"Region",name:"Ashanti"},"GH-BA":{type:"Region",name:"Brong-Ahafo"},"GH-UW":{type:"Region",name:"Upper West"},"GH-AA":{type:"Region",name:"Greater Accra"},"GH-UE":{type:"Region",name:"Upper East"},"GH-CP":{type:"Region",name:"Central"},"GH-EP":{type:"Region",name:"Eastern"},"GH-NP":{type:"Region",name:"Northern"},"GH-TV":{type:"Region",name:"Volta"},"GH-WP":{type:"Region",name:"Western"}}},OM:{name:"Oman",sub:{"OM-WU":{type:"Region",name:"Al Wusţá"},"OM-ZU":{type:"Governorate",name:"Z̧ufār"},"OM-BA":{type:"Region",name:"Al Bāţinah"},"OM-DA":{type:"Region",name:"Ad Dākhilīyah"},"OM-MU":{type:"Governorate",name:"Musandam"},"OM-SH":{type:"Region",name:"Ash Sharqīyah"},"OM-ZA":{type:"Region",name:"Az̧ Z̧āhirah"},"OM-MA":{type:"Governorate",name:"Masqaţ"},"OM-BU":{type:"Governorate",name:"Al Buraymī"}}},TN:{name:"Tunisia",sub:{"TN-61":{type:"Governorate",name:"Sfax"},"TN-14":{type:"Governorate",name:"La Manouba"},"TN-82":{type:"Governorate",name:"Medenine"},"TN-83":{type:"Governorate",name:"Tataouine"},"TN-81":{type:"Governorate",name:"Gabès"},"TN-42":{type:"Governorate",name:"Kasserine"},"TN-43":{type:"Governorate",name:"Sidi Bouzid"},"TN-41":{type:"Governorate",name:"Kairouan"},"TN-21":{type:"Governorate",name:"Nabeul"},"TN-22":{type:"Governorate",name:"Zaghouan"},"TN-23":{type:"Governorate",name:"Bizerte"},"TN-12":{type:"Governorate",name:"Ariana"},"TN-73":{type:"Governorate",name:"Kebili"},"TN-72":{type:"Governorate",name:"Tozeur"},"TN-71":{type:"Governorate",name:"Gafsa"},"TN-33":{type:"Governorate",name:"Le Kef"},"TN-32":{type:"Governorate",name:"Jendouba"},"TN-31":{type:"Governorate",name:"Béja"},"TN-11":{type:"Governorate",name:"Tunis"},"TN-13":{type:"Governorate",name:"Ben Arous"},"TN-34":{type:"Governorate",name:"Siliana"},"TN-51":{type:"Governorate",name:"Sousse"},"TN-53":{type:"Governorate",name:"Mahdia"},"TN-52":{type:"Governorate",name:"Monastir"}}},JO:{name:"Jordan",sub:{"JO-AT":{type:"Governorate",name:"Aţ Ţafīlah"},"JO-MA":{type:"Governorate",name:"Al Mafraq"},"JO-MD":{type:"Governorate",name:"Mādabā"},"JO-AQ":{type:"Governorate",name:"Al ʽAqabah"},"JO-MN":{type:"Governorate",name:"Ma'ān"},"JO-BA":{type:"Governorate",name:"Al Balqā'"},"JO-AZ":{type:"Governorate",name:"Az Zarqā'"},"JO-JA":{type:"Governorate",name:"Jarash"},"JO-IR":{type:"Governorate",name:"Irbid"},"JO-KA":{type:"Governorate",name:"Al Karak"},"JO-AM":{type:"Governorate",name:"‘Ammān"},"JO-AJ":{type:"Governorate",name:"ʽAjlūn"}}},HR:{name:"Croatia",sub:{"HR-16":{type:"County",name:"Vukovarsko-srijemska županija"},"HR-19":{type:"County",name:"Dubrovačko-neretvanska županija"},"HR-18":{type:"County",name:"Istarska županija"},"HR-08":{type:"County",name:"Primorsko-goranska županija"},"HR-09":{type:"County",name:"Ličko-senjska županija"},"HR-06":{type:"County",name:"Koprivničko-križevačka županija"},"HR-07":{type:"County",name:"Bjelovarsko-bilogorska županija"},"HR-04":{type:"County",name:"Karlovačka županija"},"HR-05":{type:"County",name:"Varaždinska županija"},"HR-02":{type:"County",name:"Krapinsko-zagorska županija"},"HR-03":{type:"County",name:"Sisačko-moslavačka županija"},"HR-13":{type:"County",name:"Zadarska županija"},"HR-01":{type:"County",name:"Zagrebačka županija"},"HR-15":{type:"County",name:"Šibensko-kninska županija"},"HR-20":{type:"County",name:"Međimurska županija"},"HR-21":{type:"City",name:"Grad Zagreb"},"HR-14":{type:"County",name:"Osječko-baranjska županija"},"HR-12":{type:"County",name:"Brodsko-posavska županija"},"HR-10":{type:"County",name:"Virovitičko-podravska županija"},"HR-17":{type:"County",name:"Splitsko-dalmatinska županija"},"HR-11":{type:"County",name:"Požeško-slavonska županija"}}},HT:{name:"Haiti",sub:{"HT-CE":{type:"Department",name:"Centre"},"HT-OU":{type:"Department",name:"Lwès"},"HT-GA":{type:"Department",name:"Grandans"},"HT-NI":{type:"Department",name:"Nip"},"HT-NO":{type:"Department",name:"Nòdwès"},"HT-SD":{type:"Department",name:"Sid"},"HT-SE":{type:"Department",name:"Sidès"},"HT-AR":{type:"Department",name:"Artibonite"},"HT-ND":{type:"Department",name:"Nò"},"HT-NE":{type:"Department",name:"Nòdès"}}},HU:{name:"Hungary",sub:{"HU-HE":{type:"County",name:"Heves"},"HU-BU":{type:"Capital city",name:"Budapest"},"HU-HB":{type:"County",name:"Hajdú-Bihar"},"HU-FE":{type:"County",name:"Fejér"},"HU-SN":{type:"City of county right",name:"Sopron"},"HU-BZ":{type:"County",name:"Borsod-Abaúj-Zemplén"},"HU-DE":{type:"City of county right",name:"Debrecen"},"HU-BA":{type:"County",name:"Baranya"},"HU-HV":{type:"City of county right",name:"Hódmezővásárhely"},"HU-BC":{type:"City of county right",name:"Békéscsaba"},"HU-BE":{type:"County",name:"Békés"},"HU-BK":{type:"County",name:"Bács-Kiskun"},"HU-DU":{type:"City of county right",name:"Dunaújváros"},"HU-SF":{type:"City of county right",name:"Székesfehérvár"},"HU-SD":{type:"City of county right",name:"Szeged"},"HU-SK":{type:"City of county right",name:"Szolnok"},"HU-SH":{type:"City of county right",name:"Szombathely"},"HU-KV":{type:"City of county right",name:"Kaposvár"},"HU-SO":{type:"County",name:"Somogy"},"HU-SS":{type:"City of county right",name:"Szekszárd"},"HU-MI":{type:"City of county right",name:"Miskolc"},"HU-ST":{type:"City of county right",name:"Salgótarján"},"HU-KM":{type:"City of county right",name:"Kecskemét"},"HU-SZ":{type:"County",name:"Szabolcs-Szatmár-Bereg"},"HU-KE":{type:"County",name:"Komárom-Esztergom"},"HU-CS":{type:"County",name:"Csongrád"},"HU-ER":{type:"City of county right",name:"Érd"},"HU-ZA":{type:"County",name:"Zala"},"HU-ZE":{type:"City of county right",name:"Zalaegerszeg"},"HU-VM":{type:"City of county right",name:"Veszprém"},"HU-EG":{type:"City of county right",name:"Eger"},"HU-TO":{type:"County",name:"Tolna"},"HU-GY":{type:"City of county right",name:"Győr"},"HU-VE":{type:"County",name:"Veszprém"},"HU-TB":{type:"City of county right",name:"Tatabánya"},"HU-VA":{type:"County",name:"Vas"},"HU-GS":{type:"County",name:"Győr-Moson-Sopron"},"HU-PE":{type:"County",name:"Pest"},"HU-NY":{type:"City of county right",name:"Nyíregyháza"},"HU-JN":{type:"County",name:"Jász-Nagykun-Szolnok"},"HU-NO":{type:"County",name:"Nógrád"},"HU-PS":{type:"City of county right",name:"Pécs"},"HU-NK":{type:"City of county right",name:"Nagykanizsa"}}},HK:{name:"Hong Kong",sub:{"HK-HK":{type:"Country",name:"Hong Kong"}}},HN:{name:"Honduras",sub:{"HN-OC":{type:"Department",name:"Ocotepeque"},"HN-CM":{type:"Department",name:"Comayagua"},"HN-CL":{type:"Department",name:"Colón"},"HN-YO":{type:"Department",name:"Yoro"},"HN-CH":{type:"Department",name:"Choluteca"},"HN-FM":{type:"Department",name:"Francisco Morazán"},"HN-IB":{type:"Department",name:"Islas de la Bahía"},"HN-EP":{type:"Department",name:"El Paraíso"},"HN-OL":{type:"Department",name:"Olancho"},"HN-LE":{type:"Department",name:"Lempira"},"HN-IN":{type:"Department",name:"Intibucá"},"HN-AT":{type:"Department",name:"Atlántida"},"HN-LP":{type:"Department",name:"La Paz"},"HN-VA":{type:"Department",name:"Valle"},"HN-SB":{type:"Department",name:"Santa Bárbara"},"HN-GD":{type:"Department",name:"Gracias a Dios"},"HN-CR":{type:"Department",name:"Cortés"},"HN-CP":{type:"Department",name:"Copán"}}},HM:{name:"Heard & McDonald Islands",sub:{"HM-HM":{type:"Country",name:"Heard & McDonald Islands"}}},VE:{name:"Venezuela",sub:{"VE-L":{type:"State",name:"Mérida"},"VE-M":{type:"State",name:"Miranda"},"VE-N":{type:"State",name:"Monagas"},"VE-O":{type:"State",name:"Nueva Esparta"},"VE-H":{type:"State",name:"Cojedes"},"VE-I":{type:"State",name:"Falcón"},"VE-J":{type:"State",name:"Guárico"},"VE-K":{type:"State",name:"Lara"},"VE-D":{type:"State",name:"Aragua"},"VE-E":{type:"State",name:"Barinas"},"VE-F":{type:"State",name:"Bolívar"},"VE-G":{type:"State",name:"Carabobo"},"VE-A":{type:"Capital district",name:"Distrito Capital"},"VE-B":{type:"State",name:"Anzoátegui"},"VE-C":{type:"State",name:"Apure"},"VE-X":{type:"State",name:"Vargas"},"VE-Y":{type:"State",name:"Delta Amacuro"},"VE-Z":{type:"State",name:"Amazonas"},"VE-T":{type:"State",name:"Trujillo"},"VE-U":{type:"State",name:"Yaracuy"},"VE-V":{type:"State",name:"Zulia"},"VE-W":{type:"Federal dependency",name:"Dependencias Federales"},"VE-P":{type:"State",name:"Portuguesa"},"VE-R":{type:"State",name:"Sucre"},"VE-S":{type:"State",name:"Táchira"}}},PR:{name:"Puerto Rico",sub:{"PR-PR":{type:"Country",name:"Puerto Rico"}}},PS:{name:"Palestine",sub:{"PS-SLT":{type:"Governorate",name:"Salfit"},"PS-HBN":{type:"Governorate",name:"Al Khalīl"},"PS-RBH":{type:"Governorate",name:"Ramallah"},"PS-QQA":{type:"Governorate",name:"Qalqilya"},"PS-TBS":{type:"Governorate",name:"Tubas"},"PS-JEN":{type:"Governorate",name:"Janīn"},"PS-JEM":{type:"Governorate",name:"Al Quds"},"PS-KYS":{type:"Governorate",name:"Khan Yunis"},"PS-DEB":{type:"Governorate",name:"Dayr al Balaḩ"},"PS-BTH":{type:"Governorate",name:"Bayt Laḩm"},"PS-JRH":{type:"Governorate",name:"Arīḩā wa al Aghwār"},"PS-GZA":{type:"Governorate",name:"Gaza"},"PS-NBS":{type:"Governorate",name:"Nablus"},"PS-RFH":{type:"Governorate",name:"Rafah"},"PS-TKM":{type:"Governorate",name:"Tulkarm"},"PS-NGZ":{type:"Governorate",name:"North Gaza"}}},PW:{name:"Palau",sub:{"PW-222":{type:"State",name:"Ngardmau"},"PW-050":{type:"State",name:"Hatobohei"},"PW-218":{type:"State",name:"Ngarchelong"},"PW-226":{type:"State",name:"Ngchesar"},"PW-227":{type:"State",name:"Ngeremlengui"},"PW-224":{type:"State",name:"Ngatpang"},"PW-100":{type:"State",name:"Kayangel"},"PW-212":{type:"State",name:"Melekeok"},"PW-228":{type:"State",name:"Ngiwal"},"PW-150":{type:"State",name:"Koror"},"PW-214":{type:"State",name:"Ngaraard"},"PW-370":{type:"State",name:"Sonsorol"},"PW-004":{type:"State",name:"Airai"},"PW-002":{type:"State",name:"Aimeliik"},"PW-010":{type:"State",name:"Angaur"},"PW-350":{type:"State",name:"Peleliu"}}},PT:{name:"Portugal",sub:{"PT-13":{type:"District",name:"Porto"},"PT-12":{type:"District",name:"Portalegre"},"PT-11":{type:"District",name:"Lisboa"},"PT-10":{type:"District",name:"Leiria"},"PT-08":{type:"District",name:"Faro"},"PT-09":{type:"District",name:"Guarda"},"PT-15":{type:"District",name:"Setúbal"},"PT-14":{type:"District",name:"Santarém"},"PT-04":{type:"District",name:"Bragança"},"PT-05":{type:"District",name:"Castelo Branco"},"PT-06":{type:"District",name:"Coimbra"},"PT-07":{type:"District",name:"Évora"},"PT-01":{type:"District",name:"Aveiro"},"PT-02":{type:"District",name:"Beja"},"PT-03":{type:"District",name:"Braga"},"PT-20":{type:"Autonomous region",name:"Região Autónoma dos Açores"},"PT-18":{type:"District",name:"Viseu"},"PT-17":{type:"District",name:"Vila Real"},"PT-30":{type:"Autonomous region",name:"Região Autónoma da Madeira"},"PT-16":{type:"District",name:"Viana do Castelo"}}},KN:{name:"Saint Kitts And Nevis",sub:{"KN-05":{type:"Parish",name:"Saint James Windward"},"KN-04":{type:"Parish",name:"Saint George Gingerland"},"KN-07":{type:"Parish",name:"Saint John Figtree"},"KN-06":{type:"Parish",name:"Saint John Capisterre"},"KN-01":{type:"Parish",name:"Christ Church Nichola Town"},"KN-10":{type:"Parish",name:"Saint Paul Charlestown"},"KN-03":{type:"Parish",name:"Saint George Basseterre"},"KN-02":{type:"Parish",name:"Saint Anne Sandy Point"},"KN-N":{type:"State",name:"Nevis"},"KN-11":{type:"Parish",name:"Saint Peter Basseterre"},"KN-09":{type:"Parish",name:"Saint Paul Capisterre"},"KN-08":{type:"Parish",name:"Saint Mary Cayon"},"KN-K":{type:"State",name:"Saint Kitts"},"KN-15":{type:"Parish",name:"Trinity Palmetto Point"},"KN-12":{type:"Parish",name:"Saint Thomas Lowland"},"KN-13":{type:"Parish",name:"Saint Thomas Middle Island"}}},PY:{name:"Paraguay",sub:{"PY-19":{type:"Department",name:"Boquerón"},"PY-14":{type:"Department",name:"Canindeyú"},"PY-15":{type:"Department",name:"Presidente Hayes"},"PY-16":{type:"Department",name:"Alto Paraguay"},"PY-10":{type:"Department",name:"Alto Paraná"},"PY-11":{type:"Department",name:"Central"},"PY-12":{type:"Department",
		name:"Ñeembucú"},"PY-13":{type:"Department",name:"Amambay"},"PY-6":{type:"Department",name:"Caazapá"},"PY-7":{type:"Department",name:"Itapúa"},"PY-4":{type:"Department",name:"Guairá"},"PY-5":{type:"Department",name:"Caaguazú"},"PY-2":{type:"Department",name:"San Pedro"},"PY-3":{type:"Department",name:"Cordillera"},"PY-1":{type:"Department",name:"Concepción"},"PY-ASU":{type:"Capital",name:"Asunción"},"PY-8":{type:"Department",name:"Misiones"},"PY-9":{type:"Department",name:"Paraguarí"}}},IQ:{name:"Iraq",sub:{"IQ-NA":{type:"Governorate",name:"An Najaf"},"IQ-AN":{type:"Governorate",name:"Al Anbār"},"IQ-WA":{type:"Governorate",name:"Wāsiţ"},"IQ-SD":{type:"Governorate",name:"Şalāḩ ad Dīn"},"IQ-MU":{type:"Governorate",name:"Al Muthanná"},"IQ-DA":{type:"Governorate",name:"Dahūk"},"IQ-SU":{type:"Governorate",name:"As Sulaymānīyah"},"IQ-KA":{type:"Governorate",name:"Karbalā'"},"IQ-BG":{type:"Governorate",name:"Baghdād"},"IQ-NI":{type:"Governorate",name:"Nīnawá"},"IQ-BA":{type:"Governorate",name:"Al Başrah"},"IQ-BB":{type:"Governorate",name:"Bābil"},"IQ-DQ":{type:"Governorate",name:"Dhī Qār"},"IQ-MA":{type:"Governorate",name:"Maysān"},"IQ-KI":{type:"Governorate",name:"Kirkūk"},"IQ-DI":{type:"Governorate",name:"Diyālá"},"IQ-QA":{type:"Governorate",name:"Al Qādisīyah"},"IQ-AR":{type:"Governorate",name:"Arbīl"}}},PA:{name:"Panama",sub:{"PA-NB":{type:"Indigenous region",name:"Ngöbe-Buglé"},"PA-8":{type:"Province",name:"Panamá"},"PA-9":{type:"Province",name:"Veraguas"},"PA-6":{type:"Province",name:"Herrera"},"PA-7":{type:"Province",name:"Los Santos"},"PA-4":{type:"Province",name:"Chiriquí"},"PA-5":{type:"Province",name:"Darién"},"PA-2":{type:"Province",name:"Coclé"},"PA-3":{type:"Province",name:"Colón"},"PA-1":{type:"Province",name:"Bocas del Toro"},"PA-10":{type:"Province",name:"Panamá Oeste"},"PA-EM":{type:"Indigenous region",name:"Emberá"},"PA-KY":{type:"Indigenous region",name:"Kuna Yala"}}},PF:{name:"French Polynesia",sub:{"PF-PF":{type:"Country",name:"French Polynesia"}}},PG:{name:"Papua New Guinea",sub:{"PG-WBK":{type:"Province",name:"West New Britain"},"PG-NCD":{type:"District",name:"National Capital District"},"PG-MPM":{type:"Province",name:"Madang"},"PG-MPL":{type:"Province",name:"Morobe"},"PG-MRL":{type:"Province",name:"Manus"},"PG-EHG":{type:"Province",name:"Eastern Highlands"},"PG-ESW":{type:"Province",name:"East Sepik"},"PG-SAN":{type:"Province",name:"West Sepik"},"PG-NIK":{type:"Province",name:"New Ireland"},"PG-JWK":{type:"Province",name:"Jiwaka"},"PG-MBA":{type:"Province",name:"Milne Bay"},"PG-HLA":{type:"Province",name:"Hela"},"PG-WPD":{type:"Province",name:"Western"},"PG-NSB":{type:"Autonomous region",name:"Bougainville"},"PG-EPW":{type:"Province",name:"Enga"},"PG-CPM":{type:"Province",name:"Central"},"PG-CPK":{type:"Province",name:"Chimbu"},"PG-NPP":{type:"Province",name:"Northern"},"PG-WHM":{type:"Province",name:"Western Highlands"},"PG-GPK":{type:"Province",name:"Gulf"},"PG-EBR":{type:"Province",name:"East New Britain"},"PG-SHM":{type:"Province",name:"Southern Highlands"}}},PE:{name:"Peru",sub:{"PE-PIU":{type:"Region",name:"Piura"},"PE-ARE":{type:"Region",name:"Arequipa"},"PE-APU":{type:"Region",name:"Apurímac"},"PE-JUN":{type:"Region",name:"Hunin"},"PE-LMA":{type:"Municipality",name:"Lima hatun llaqta"},"PE-LOR":{type:"Region",name:"Loreto"},"PE-LIM":{type:"Region",name:"Lima"},"PE-AMA":{type:"Region",name:"Amarumayu"},"PE-LAM":{type:"Region",name:"Lambayeque"},"PE-LAL":{type:"Region",name:"La Libertad"},"PE-HUC":{type:"Region",name:"Huánuco"},"PE-CUS":{type:"Region",name:"Cusco"},"PE-PUN":{type:"Region",name:"Puno"},"PE-HUV":{type:"Region",name:"Huancavelica"},"PE-MOQ":{type:"Region",name:"Moquegua"},"PE-TAC":{type:"Region",name:"Tacna"},"PE-AYA":{type:"Region",name:"Ayacucho"},"PE-UCA":{type:"Region",name:"Ucayali"},"PE-ICA":{type:"Region",name:"Ica"},"PE-SAM":{type:"Region",name:"San Martin"},"PE-ANC":{type:"Region",name:"Ancash"},"PE-PAS":{type:"Region",name:"Pasco"},"PE-CAL":{type:"Region",name:"El Callao"},"PE-TUM":{type:"Region",name:"Tumbes"},"PE-CAJ":{type:"Region",name:"Cajamarca"},"PE-MDD":{type:"Region",name:"Madre de Dios"}}},PK:{name:"Pakistan",sub:{"PK-IS":{type:"Federal capital territory",name:"Islāmābād"},"PK-TA":{type:"Territory",name:"Federally Administered Tribal Areas"},"PK-BA":{type:"Province",name:"Balochistan"},"PK-KP":{type:"Province",name:"Khaībar Pakhtūnkhwā"},"PK-PB":{type:"Province",name:"Panjāb"},"PK-JK":{type:"Pakistan administered area",name:"Azad Kashmir"},"PK-SD":{type:"Province",name:"Sindh"},"PK-GB":{type:"Pakistan administered area",name:"Gilgit-Baltistān"}}},PH:{name:"Philippines",sub:{"PH-08":{type:"Region",name:"Eastern Visayas"},"PH-09":{type:"Region",name:"Rehiyon ng Tangway ng Sambuwangga"},"PH-00":{type:"Region",name:"National Capital Region"},"PH-01":{type:"Region",name:"Ilocos"},"PH-02":{type:"Region",name:"Cagayan Valley"},"PH-03":{type:"Region",name:"Central Luzon"},"PH-05":{type:"Region",name:"Bicol"},"PH-06":{type:"Region",name:"Rehiyon ng Kanlurang Bisaya"},"PH-07":{type:"Region",name:"Central Visayas"},"PH-SUR":{type:"Province",name:"Surigao del Sur"},"PH-SLU":{type:"Province",name:"Sulu"},"PH-DAV":{type:"Province",name:"Davao del Norte"},"PH-CAM":{type:"Province",name:"Camiguin"},"PH-CAN":{type:"Province",name:"Camarines Norte"},"PH-BUL":{type:"Province",name:"Bulacan"},"PH-CAG":{type:"Province",name:"Cagayan"},"PH-BOH":{type:"Province",name:"Bohol"},"PH-CAP":{type:"Province",name:"Capiz"},"PH-CAS":{type:"Province",name:"Camarines Sur"},"PH-CAT":{type:"Province",name:"Catanduanes"},"PH-CAV":{type:"Province",name:"Cavite"},"PH-BIL":{type:"Province",name:"Biliran"},"PH-SLE":{type:"Province",name:"Katimogang Leyte"},"PH-RIZ":{type:"Province",name:"Risal"},"PH-COM":{type:"Province",name:"Compostela Valley"},"PH-SCO":{type:"Province",name:"South Cotabato"},"PH-ZSI":{type:"Province",name:"Sambuwangga Sibugay"},"PH-ILS":{type:"Province",name:"Ilocos Sur"},"PH-AGS":{type:"Province",name:"Agusan del Sur"},"PH-ILI":{type:"Province",name:"Iloilo"},"PH-WSA":{type:"Province",name:"Samar"},"PH-PLW":{type:"Province",name:"Palawan"},"PH-KAL":{type:"Province",name:"Kalinga"},"PH-ZAS":{type:"Province",name:"Timog Sambuwangga"},"PH-ZAN":{type:"Province",name:"Hilagang Sambuwangga"},"PH-ALB":{type:"Province",name:"Albay"},"PH-NUE":{type:"Province",name:"Nueva Ecija"},"PH-NUV":{type:"Province",name:"Nueva Vizcaya"},"PH-SUK":{type:"Province",name:"Sultan Kudarat"},"PH-TAW":{type:"Province",name:"Tawi-Tawi"},"PH-TAR":{type:"Province",name:"Tarlac"},"PH-AKL":{type:"Province",name:"Aklan"},"PH-BEN":{type:"Province",name:"Benget"},"PH-DIN":{type:"Province",name:"Dinagat Islands"},"PH-DAS":{type:"Province",name:"Davao del Sur"},"PH-ROM":{type:"Province",name:"Romblon"},"PH-ISA":{type:"Province",name:"Isabela"},"PH-NER":{type:"Province",name:"Negros Oriental"},"PH-LAS":{type:"Province",name:"Lanao del Sur"},"PH-LAN":{type:"Province",name:"Hilagang Lanaw"},"PH-NEC":{type:"Province",name:"Kanlurang Negros"},"PH-LAG":{type:"Province",name:"Laguna"},"PH-SUN":{type:"Province",name:"Hilagang Surigaw"},"PH-AUR":{type:"Province",name:"Aurora"},"PH-MSR":{type:"Province",name:"Misamis Oriental"},"PH-ABR":{type:"Province",name:"Abra"},"PH-MSC":{type:"Province",name:"Kanlurang Misamis"},"PH-40":{type:"Region",name:"Calabarzon"},"PH-41":{type:"Region",name:"Mimaropa"},"PH-EAS":{type:"Province",name:"Eastern Samar"},"PH-BTN":{type:"Province",name:"Batanes"},"PH-BTG":{type:"Province",name:"Batangas"},"PH-QUI":{type:"Province",name:"Kirino"},"PH-CEB":{type:"Province",name:"Cebu"},"PH-APA":{type:"Province",name:"Apayao"},"PH-SAR":{type:"Province",name:"Sarangani"},"PH-QUE":{type:"Province",name:"Keson"},"PH-IFU":{type:"Province",name:"Ifugao"},"PH-MAS":{type:"Province",name:"Masbate"},"PH-SOR":{type:"Province",name:"Sorsogon"},"PH-NCO":{type:"Province",name:"Cotabato"},"PH-ZMB":{type:"Province",name:"Sambales"},"PH-MAG":{type:"Province",name:"Magindanaw"},"PH-MAD":{type:"Province",name:"Marinduke"},"PH-BUK":{type:"Province",name:"Bukidnon"},"PH-PAN":{type:"Province",name:"Pangasinan"},"PH-PAM":{type:"Province",name:"Pampanga"},"PH-GUI":{type:"Province",name:"Gimaras"},"PH-NSA":{type:"Province",name:"Hilagang Samar"},"PH-MDC":{type:"Province",name:"Kanlurang Mindoro"},"PH-MDR":{type:"Province",name:"Mindoro Oriental"},"PH-LUN":{type:"Province",name:"La Union"},"PH-BAS":{type:"Province",name:"Basilan"},"PH-BAN":{type:"Province",name:"Bataan"},"PH-MOU":{type:"Province",name:"Lalawigang Bulubundukin"},"PH-15":{type:"Region",name:"Cordillera Administrative Region"},"PH-14":{type:"Region",name:"Autonomous Region in Muslim Mindanao"},"PH-13":{type:"Region",name:"Caraga"},"PH-12":{type:"Region",name:"Rehiyon ng Soccsksargen"},"PH-11":{type:"Region",name:"Davao"},"PH-10":{type:"Region",name:"Northern Mindanao"},"PH-SIG":{type:"Province",name:"Sikihor"},"PH-AGN":{type:"Province",name:"Agusan del Norte"},"PH-ILN":{type:"Province",name:"Hilagang Iloko"},"PH-DAO":{type:"Province",name:"Davao Oriental"},"PH-LEY":{type:"Province",name:"Leyte"},"PH-ANT":{type:"Province",name:"Antike"}}},PN:{name:"Pitcairn",sub:{"PN-PN":{type:"Country",name:"Pitcairn"}}},PL:{name:"Poland",sub:{"PL-SL":{type:"Province",name:"Śląskie"},"PL-LU":{type:"Province",name:"Lubelskie"},"PL-SK":{type:"Province",name:"Świętokrzyskie"},"PL-WP":{type:"Province",name:"Wielkopolskie"},"PL-ZP":{type:"Province",name:"Zachodniopomorskie"},"PL-MZ":{type:"Province",name:"Mazowieckie"},"PL-PD":{type:"Province",name:"Podlaskie"},"PL-LB":{type:"Province",name:"Lubuskie"},"PL-LD":{type:"Province",name:"Łódzkie"},"PL-KP":{type:"Province",name:"Kujawsko-pomorskie"},"PL-MA":{type:"Province",name:"Małopolskie"},"PL-PM":{type:"Province",name:"Pomorskie"},"PL-OP":{type:"Province",name:"Opolskie"},"PL-DS":{type:"Province",name:"Dolnośląskie"},"PL-WN":{type:"Province",name:"Warmińsko-mazurskie"},"PL-PK":{type:"Province",name:"Podkarpackie"}}},PM:{name:"St. Pierre & Miquelon",sub:{"PM-PM":{type:"Country",name:"St. Pierre & Miquelon"}}},ZM:{name:"Zambia",sub:{"ZM-01":{type:"Province",name:"Western"},"ZM-03":{type:"Province",name:"Eastern"},"ZM-02":{type:"Province",name:"Central"},"ZM-05":{type:"Province",name:"Northern"},"ZM-04":{type:"Province",name:"Luapula"},"ZM-07":{type:"Province",name:"Southern"},"ZM-06":{type:"Province",name:"North-Western"},"ZM-09":{type:"Province",name:"Lusaka"},"ZM-08":{type:"Province",name:"Copperbelt"},"ZM-10":{type:"Province",name:"Muchinga"}}},EH:{name:"Western Sahara",sub:{"EH-EH":{type:"Country",name:"Western Sahara"}}},EE:{name:"Estonia",sub:{"EE-86":{type:"County",name:"Võrumaa"},"EE-39":{type:"County",name:"Hiiumaa"},"EE-74":{type:"County",name:"Saaremaa"},"EE-44":{type:"County",name:"Ida-Virumaa"},"EE-70":{type:"County",name:"Raplamaa"},"EE-37":{type:"County",name:"Harjumaa"},"EE-51":{type:"County",name:"Järvamaa"},"EE-84":{type:"County",name:"Viljandimaa"},"EE-82":{type:"County",name:"Valgamaa"},"EE-57":{type:"County",name:"Läänemaa"},"EE-78":{type:"County",name:"Tartumaa"},"EE-59":{type:"County",name:"Lääne-Virumaa"},"EE-49":{type:"County",name:"Jõgevamaa"},"EE-65":{type:"County",name:"Põlvamaa"},"EE-67":{type:"County",name:"Pärnumaa"}}},EG:{name:"Egypt",sub:{"EG-DT":{type:"Governorate",name:"Dumyāţ"},"EG-SIN":{type:"Governorate",name:"Shamāl Sīnā'"},"EG-BA":{type:"Governorate",name:"Al Baḩr al Aḩmar"},"EG-BH":{type:"Governorate",name:"Al Buḩayrah"},"EG-DK":{type:"Governorate",name:"Ad Daqahlīyah"},"EG-SHG":{type:"Governorate",name:"Sūhāj"},"EG-MT":{type:"Governorate",name:"Maţrūḩ"},"EG-KN":{type:"Governorate",name:"Qinā"},"EG-KB":{type:"Governorate",name:"Al Qalyūbīyah"},"EG-MN":{type:"Governorate",name:"Al Minyā"},"EG-GH":{type:"Governorate",name:"Al Gharbīyah"},"EG-AST":{type:"Governorate",name:"Asyūţ"},"EG-SHR":{type:"Governorate",name:"Ash Sharqīyah"},"EG-ASN":{type:"Governorate",name:"Aswān"},"EG-IS":{type:"Governorate",name:"Al Ismā'īlīyah"},"EG-GZ":{type:"Governorate",name:"Al Jīzah"},"EG-C":{type:"Governorate",name:"Al Qāhirah"},"EG-SUZ":{type:"Governorate",name:"As Suways"},"EG-ALX":{type:"Governorate",name:"Al Iskandarīyah"},"EG-BNS":{type:"Governorate",name:"Banī Suwayf"},"EG-LX":{type:"Governorate",name:"Al Uqşur"},"EG-MNF":{type:"Governorate",name:"Al Minūfīyah"},"EG-JS":{type:"Governorate",name:"Janūb Sīnā'"},"EG-WAD":{type:"Governorate",name:"Al Wādī al Jadīd"},"EG-KFS":{type:"Governorate",name:"Kafr ash Shaykh"},"EG-FYM":{type:"Governorate",name:"Al Fayyūm"},"EG-PTS":{type:"Governorate",name:"Būr Sa‘īd"}}},ZA:{name:"South Africa",sub:{"ZA-NL":{type:"Province",name:"GaZulu-Natala"},"ZA-GT":{type:"Province",name:"Gauteng"},"ZA-EC":{type:"Province",name:"Eastern Cape"},"ZA-NC":{type:"Province",name:"iTlhagwini-Kapa"},"ZA-LP":{type:"Province",name:"Limpopo"},"ZA-MP":{type:"Province",name:"iMpumalanga"},"ZA-WC":{type:"Province",name:"iTjhingalanga-Kapa"},"ZA-NW":{type:"Province",name:"Bokone Bophirima"},"ZA-FS":{type:"Province",name:"Foreisetata"}}},EC:{name:"Ecuador",sub:{"EC-SE":{type:"Province",name:"Santa Elena"},"EC-SD":{type:"Province",name:"Santo Domingo de los Tsáchilas"},"EC-Z":{type:"Province",name:"Zamora-Chinchipe"},"EC-Y":{type:"Province",name:"Pastaza"},"EC-X":{type:"Province",name:"Cotopaxi"},"EC-W":{type:"Province",name:"Galápagos"},"EC-U":{type:"Province",name:"Sucumbíos"},"EC-T":{type:"Province",name:"Tungurahua"},"EC-S":{type:"Province",name:"Morona-Santiago"},"EC-R":{type:"Province",name:"Los Ríos"},"EC-P":{type:"Province",name:"Pichincha"},"EC-O":{type:"Province",name:"El Oro"},"EC-N":{type:"Province",name:"Napo"},"EC-M":{type:"Province",name:"Manabí"},"EC-L":{type:"Province",name:"Loja"},"EC-I":{type:"Province",name:"Imbabura"},"EC-H":{type:"Province",name:"Chimborazo"},"EC-G":{type:"Province",name:"Guayas"},"EC-F":{type:"Province",name:"Cañar"},"EC-E":{type:"Province",name:"Esmeraldas"},"EC-D":{type:"Province",name:"Orellana"},"EC-C":{type:"Province",name:"Carchi"},"EC-B":{type:"Province",name:"Bolívar"},"EC-A":{type:"Province",name:"Azuay"}}},IT:{name:"Italy",sub:{"IT-BA":{type:"Province",name:"Bari"},"IT-TR":{type:"Province",name:"Terni"},"IT-BG":{type:"Province",name:"Bergamo"},"IT-BI":{type:"Province",name:"Biella"},"IT-BO":{type:"Province",name:"Bologna"},"IT-BN":{type:"Province",name:"Benevento"},"IT-BL":{type:"Province",name:"Belluno"},"IT-BS":{type:"Province",name:"Brescia"},"IT-BR":{type:"Province",name:"Brindisi"},"IT-BT":{type:"Province",name:"Barletta-Andria-Trani"},"IT-BZ":{type:"Province",name:"Bolzano"},"IT-23":{type:"Region",name:"Val d'Aoste"},"IT-21":{type:"Region",name:"Piemonte"},"IT-25":{type:"Region",name:"Lombardia"},"IT-RC":{type:"Province",name:"Reggio Calabria"},"IT-RA":{type:"Province",name:"Ravenna"},"IT-RG":{type:"Province",name:"Ragusa"},"IT-RE":{type:"Province",name:"Reggio Emilia"},"IT-RI":{type:"Province",name:"Rieti"},"IT-RO":{type:"Province",name:"Rovigo"},"IT-RN":{type:"Province",name:"Rimini"},"IT-RM":{type:"Province",name:"Roma"},"IT-AG":{type:"Province",name:"Agrigento"},"IT-AN":{type:"Province",name:"Ancona"},"IT-AO":{type:"Province",name:"Aosta"},"IT-AL":{type:"Province",name:"Alessandria"},"IT-IS":{type:"Province",name:"Isernia"},"IT-AV":{type:"Province",name:"Avellino"},"IT-AT":{type:"Province",name:"Asti"},"IT-IM":{type:"Province",name:"Imperia"},"IT-AR":{type:"Province",name:"Arezzo"},"IT-AP":{type:"Province",name:"Ascoli Piceno"},"IT-AQ":{type:"Province",name:"L'Aquila"},"IT-FG":{type:"Province",name:"Foggia"},"IT-34":{type:"Region",name:"Veneto"},"IT-36":{type:"Region",name:"Friuli-Venezia Giulia"},"IT-FE":{type:"Province",name:"Ferrara"},"IT-32":{type:"Region",name:"Trentino-Alto Adige"},"IT-VE":{type:"Province",name:"Venezia"},"IT-LC":{type:"Province",name:"Lecco"},"IT-LE":{type:"Province",name:"Lecce"},"IT-LI":{type:"Province",name:"Livorno"},"IT-TP":{type:"Province",name:"Trapani"},"IT-TS":{type:"Province",name:"Trieste"},"IT-42":{type:"Region",name:"Liguria"},"IT-45":{type:"Region",name:"Emilia-Romagna"},"IT-LO":{type:"Province",name:"Lodi"},"IT-TV":{type:"Province",name:"Treviso"},"IT-LU":{type:"Province",name:"Lucca"},"IT-LT":{type:"Province",name:"Latina"},"IT-TO":{type:"Province",name:"Torino"},"IT-TN":{type:"Province",name:"Trento"},"IT-TA":{type:"Province",name:"Taranto"},"IT-TE":{type:"Province",name:"Teramo"},"IT-CL":{type:"Province",name:"Caltanissetta"},"IT-CN":{type:"Province",name:"Cuneo"},"IT-CO":{type:"Province",name:"Como"},"IT-CH":{type:"Province",name:"Chieti"},"IT-CI":{type:"Province",name:"Carbonia-Iglesias"},"IT-CE":{type:"Province",name:"Caserta"},"IT-CA":{type:"Province",name:"Cagliari"},"IT-CB":{type:"Province",name:"Campobasso"},"IT-CZ":{type:"Province",name:"Catanzaro"},"IT-CT":{type:"Province",name:"Catania"},"IT-CR":{type:"Province",name:"Cremona"},"IT-CS":{type:"Province",name:"Cosenza"},"IT-52":{type:"Region",name:"Toscana"},"IT-SV":{type:"Province",name:"Savona"},"IT-SP":{type:"Province",name:"La Spezia"},"IT-57":{type:"Region",name:"Marche"},"IT-SR":{type:"Province",name:"Siracusa"},"IT-55":{type:"Region",name:"Umbria"},"IT-SO":{type:"Province",name:"Sondrio"},"IT-SI":{type:"Province",name:"Siena"},"IT-KR":{type:"Province",name:"Crotone"},"IT-SA":{type:"Province",name:"Salerno"},"IT-VR":{type:"Province",name:"Verona"},"IT-FR":{type:"Province",name:"Frosinone"},"IT-67":{type:"Region",name:"Molise"},"IT-65":{type:"Region",name:"Abruzzo"},"IT-FC":{type:"Province",name:"Forlì-Cesena"},"IT-62":{type:"Region",name:"Lazio"},"IT-FM":{type:"Province",name:"Fermo"},"IT-FI":{type:"Province",name:"Firenze"},"IT-NO":{type:"Province",name:"Novara"},"IT-NA":{type:"Province",name:"Napoli"},"IT-NU":{type:"Province",name:"Nuoro"},"IT-EN":{type:"Province",name:"Enna"},"IT-72":{type:"Region",name:"Campania"},"IT-75":{type:"Region",name:"Puglia"},"IT-77":{type:"Region",name:"Basilicata"},"IT-78":{type:"Region",name:"Calabria"},"IT-MB":{type:"Province",name:"Monza e Brianza"},"IT-MC":{type:"Province",name:"Macerata"},"IT-ME":{type:"Province",name:"Messina"},"IT-MI":{type:"Province",name:"Milano"},"IT-MN":{type:"Province",name:"Mantova"},"IT-MO":{type:"Province",name:"Modena"},"IT-MS":{type:"Province",name:"Massa-Carrara"},"IT-MT":{type:"Province",name:"Matera"},"IT-UD":{type:"Province",name:"Udine"},"IT-88":{type:"Region",name:"Sardegna"},"IT-SS":{type:"Province",name:"Sassari"},"IT-82":{type:"Region",name:"Sicilia"},"IT-PU":{type:"Province",name:"Pesaro e Urbino"},"IT-PT":{type:"Province",name:"Pistoia"},"IT-PV":{type:"Province",name:"Pavia"},"IT-PR":{type:"Province",name:"Parma"},"IT-PZ":{type:"Province",name:"Potenza"},"IT-PE":{type:"Province",name:"Pescara"},"IT-PD":{type:"Province",name:"Padova"},"IT-PG":{type:"Province",name:"Perugia"},"IT-PA":{type:"Province",name:"Palermo"},"IT-PC":{type:"Province",name:"Piacenza"},"IT-PO":{type:"Province",name:"Prato"},"IT-PN":{type:"Province",name:"Pordenone"},"IT-PI":{type:"Province",name:"Pisa"},"IT-GR":{type:"Province",name:"Grosseto"},"IT-VC":{type:"Province",name:"Vercelli"},"IT-VB":{type:"Province",name:"Verbano-Cusio-Ossola"},"IT-VA":{type:"Province",name:"Varese"},"IT-VI":{type:"Province",name:"Vicenza"},"IT-VV":{type:"Province",name:"Vibo Valentia"},"IT-VT":{type:"Province",name:"Viterbo"},"IT-VS":{type:"Province",name:"Medio Campidano"},"IT-GE":{type:"Province",name:"Genova"},"IT-GO":{type:"Province",name:"Gorizia"},"IT-OG":{type:"Province",name:"Ogliastra"},"IT-OR":{type:"Province",name:"Oristano"},"IT-OT":{type:"Province",name:"Olbia-Tempio"}}},VN:{name:"Viet Nam",sub:{"VN-28":{type:"Province",name:"Kon Tum"},"VN-29":{type:"Province",name:"Quảng Ngãi"},"VN-26":{type:"Province",name:"Thừa Thiên-Huế"},"VN-27":{type:"Province",name:"Quảng Nam"},"VN-24":{type:"Province",name:"Quảng Bình"},"VN-25":{type:"Province",name:"Quảng Trị"},"VN-22":{type:"Province",name:"Nghệ An"},"VN-23":{type:"Province",name:"Hà Tĩnh"},"VN-20":{type:"Province",name:"Thái Bình"},"VN-21":{type:"Province",name:"Thanh Hóa"},"VN-72":{type:"Province",name:"Đắk Nông"},"VN-DN":{type:"Municipality",name:"Da Nang"},"VN-SG":{type:"Municipality",name:"Ho Chi Minh"},"VN-70":{type:"Province",name:"Vĩnh Phúc"},"VN-67":{type:"Province",name:"Nam Ðịnh"},"VN-49":{type:"Province",name:"Vĩnh Long"},"VN-63":{type:"Province",name:"Hà Nam"},"VN-HN":{type:"Municipality",name:"Ha Noi"},"VN-71":{type:"Province",name:"Điện Biên"},"VN-35":{type:"Province",name:"Lâm Ðồng"},"VN-73":{type:"Province",name:"Hậu Giang"},"VN-61":{type:"Province",name:"Hải Dương"},"VN-59":{type:"Province",name:"Cà Mau"},"VN-58":{type:"Province",name:"Bình Phước"},"VN-57":{type:"Province",name:"Bình Dương"},"VN-56":{type:"Province",name:"Bắc Ninh"},"VN-55":{type:"Province",name:"Bạc Liêu"},"VN-54":{type:"Province",name:"Bắc Giang"},"VN-53":{type:"Province",name:"Bắc Kạn"},"VN-52":{type:"Province",name:"Sóc Trăng"},"VN-51":{type:"Province",name:"Trà Vinh"},"VN-50":{type:"Province",name:"Bến Tre"},"VN-18":{type:"Province",name:"Ninh Bình"},"VN-39":{type:"Province",name:"Ðồng Nai"},"VN-13":{type:"Province",name:"Quảng Ninh"},"VN-34":{type:"Province",name:"Khánh Hòa"},"VN-37":{type:"Province",name:"Tây Ninh"},"VN-36":{type:"Province",name:"Ninh Thuận"},"VN-31":{type:"Province",name:"Bình Định"},"VN-30":{type:"Province",name:"Gia Lai"},"VN-33":{type:"Province",name:"Đắk Lắk"},"VN-14":{type:"Province",name:"Hòa Bình"},"VN-CT":{type:"Municipality",name:"Can Tho"},"VN-32":{type:"Province",name:"Phú Yên"},"VN-69":{type:"Province",name:"Thái Nguyên"},"VN-HP":{type:"Municipality",name:"Hai Phong"},"VN-45":{type:"Province",name:"Ðồng Tháp"},"VN-04":{type:"Province",name:"Cao Bằng"},"VN-05":{type:"Province",name:"Sơn La"},"VN-06":{type:"Province",name:"Yên Bái"},"VN-07":{type:"Province",name:"Tuyên Quang"},"VN-66":{type:"Province",name:"Hưng Yên"},"VN-01":{type:"Province",name:"Lai Châu"},"VN-02":{type:"Province",name:"Lào Cai"},"VN-03":{type:"Province",name:"Hà Giang"},"VN-40":{type:"Province",name:"Bình Thuận"},"VN-41":{type:"Province",name:"Long An"},"VN-68":{type:"Province",name:"Phú Thọ"},"VN-43":{type:"Province",name:"Bà Rịa - Vũng Tàu"},"VN-44":{type:"Province",name:"An Giang"},"VN-09":{type:"Province",name:"Lạng Sơn"},"VN-46":{type:"Province",name:"Tiền Giang"},"VN-47":{type:"Province",name:"Kiến Giang"}}},SB:{name:"Solomon Islands",sub:{"SB-TE":{type:"Province",name:"Temotu"},"SB-IS":{type:"Province",name:"Isabel"},"SB-ML":{type:"Province",name:"Malaita"},"SB-MK":{type:"Province",name:"Makira-Ulawa"},"SB-CH":{type:"Province",name:"Choiseul"},"SB-GU":{type:"Province",name:"Guadalcanal"},"SB-CT":{type:"Capital territory",name:"Capital Territory"},"SB-RB":{type:"Province",name:"Rennell and Bellona"},"SB-WE":{type:"Province",name:"Western"},"SB-CE":{type:"Province",name:"Central"}}},ET:{name:"Ethiopia",sub:{"ET-BE":{type:"State",name:"Benshangul-Gumaz"},"ET-OR":{type:"State",name:"Oromia"},"ET-TI":{type:"State",name:"Tigrai"},"ET-HA":{type:"State",name:"Harari People"},"ET-DD":{type:"Administration",name:"Dire Dawa"},"ET-AM":{type:"State",name:"Amara"},"ET-AA":{type:"Administration",name:"Addis Ababa"},"ET-AF":{type:"State",name:"Afar"},"ET-GA":{type:"State",name:"Gambēla Hizboch"},"ET-SN":{type:"State",name:"Southern Nations, Nationalities and Peoples"},"ET-SO":{type:"State",name:"Somali"}}},SO:{name:"Somalia",sub:{"SO-SO":{type:"Region",name:"Sool"},"SO-BK":{type:"Region",name:"Bakool"},"SO-WO":{type:"Region",name:"Woqooyi Galbeed"},"SO-BN":{type:"Region",name:"Banaadir"},"SO-TO":{type:"Region",name:"Togdheer"},"SO-MU":{type:"Region",name:"Mudug"},"SO-BY":{type:"Region",name:"Bay"},"SO-HI":{type:"Region",name:"Hiiraan"},"SO-JD":{type:"Region",name:"Jubbada Dhexe"},"SO-SA":{type:"Region",name:"Sanaag"},"SO-AW":{type:"Region",name:"Awdal"},"SO-SH":{type:"Region",name:"Shabeellaha Hoose"},"SO-JH":{type:"Region",name:"Jubbada Hoose"},"SO-NU":{type:"Region",name:"Nugaal"},"SO-GA":{type:"Region",name:"Galguduud"},"SO-SD":{type:"Region",name:"Shabeellaha Dhexe"},"SO-BR":{type:"Region",name:"Bari"},"SO-GE":{type:"Region",name:"Gedo"}}},ZW:{name:"Zimbabwe",sub:{"ZW-BU":{type:"Province",name:"Bulawayo"},"ZW-HA":{type:"Province",name:"Harare"},"ZW-MS":{type:"Province",name:"Matabeleland South"},"ZW-MV":{type:"Province",name:"Masvingo"},"ZW-MW":{type:"Province",name:"Mashonaland West"},"ZW-MI":{type:"Province",name:"Midlands"},"ZW-MN":{type:"Province",name:"Matabeleland North"},"ZW-MA":{type:"Province",name:"Manicaland"},"ZW-MC":{type:"Province",name:"Mashonaland Central"},"ZW-ME":{type:"Province",name:"Mashonaland East"}}},SA:{name:"Saudi Arabia",sub:{"SA-08":{type:"Province",name:"Al Ḩudūd ash Shamālīyah"},"SA-09":{type:"Province",name:"Jāzān"},"SA-14":{type:"Province",name:"'Asīr"},"SA-01":{type:"Province",name:"Ar Riyāḑ"},"SA-02":{type:"Province",name:"Makkah al Mukarramah"},"SA-03":{type:"Province",name:"Al Madīnah al Munawwarah"},"SA-04":{type:"Province",name:"Ash Sharqīyah"},"SA-05":{type:"Province",name:"Al Qaşīm"},"SA-06":{type:"Province",name:"Ḩā'il"},"SA-07":{type:"Province",name:"Tabūk"},"SA-11":{type:"Province",name:"Al Bāḩah"},"SA-10":{type:"Province",name:"Najrān"},"SA-12":{type:"Province",name:"Al Jawf"}}},ES:{name:"Spain",sub:{"ES-NA":{type:"Province",name:"Nafarroa*"},"ES-PM":{type:"Province",name:"Balears"},"ES-TF":{type:"Province",name:"Santa Cruz de Tenerife"},"ES-B":{type:"Province",name:"Barcelona"},"ES-A":{type:"Province",name:"Alacant*"},"ES-ZA":{type:"Province",name:"Zamora"},"ES-MU":{type:"Province",name:"Murcia"},"ES-VI":{type:"Province",name:"Álava"},"ES-Z":{type:"Province",name:"Zaragoza"},"ES-O":{type:"Province",name:"Asturias"},"ES-IB":{type:"Autonomous community",name:"Illes Balears"},"ES-M":{type:"Province",name:"Madrid"},"ES-L":{type:"Province",name:"Lleida"},"ES-J":{type:"Province",name:"Jaén"},"ES-H":{type:"Province",name:"Huelva"},"ES-AS":{type:"Autonomous community",name:"Asturias, Principado de"},"ES-AR":{type:"Autonomous community",name:"Aragón"},"ES-C":{type:"Province",name:"A Coruña"},"ES-AV":{type:"Province",name:"Ávila"},"ES-CS":{type:"Province",name:"Castelló*"},"ES-CR":{type:"Province",name:"Ciudad Real"},"ES-CM":{type:"Autonomous community",name:"Castilla-La Mancha"},"ES-CL":{type:"Autonomous community",name:"Castilla y León"},"ES-CO":{type:"Province",name:"Córdoba"},"ES-CN":{type:"Autonomous community",name:"Canarias"},"ES-MC":{type:"Autonomous community",name:"Murcia, Región de"},"ES-AN":{type:"Autonomous community",name:"Andalucía"},"ES-MA":{type:"Province",name:"Málaga"},"ES-AL":{type:"Province",name:"Almería"},"ES-CE":{type:"Autonomous city in north africa",name:"Ceuta"},"ES-AB":{type:"Province",name:"Albacete"},"ES-T":{type:"Province",name:"Tarragona"},"ES-ML":{type:"Autonomous city in north africa",name:"Melilla"},"ES-CA":{type:"Province",name:"Cádiz"},"ES-TE":{type:"Province",name:"Teruel"},"ES-CC":{type:"Province",name:"Cáceres"},"ES-CB":{type:"Autonomous community",name:"Cantabria"},"ES-GA":{type:"Autonomous community",name:"Galicia"},"ES-PO":{type:"Province",name:"Pontevedra"},"ES-GC":{type:"Province",name:"Las Palmas"},"ES-RI":{type:"Autonomous community",name:"La Rioja"},"ES-S":{type:"Province",name:"Cantabria"},"ES-GI":{type:"Province",name:"Girona"},"ES-TO":{type:"Province",name:"Toledo"},"ES-CT":{type:"Autonomous community",name:"Catalunya"},"ES-GR":{type:"Province",name:"Granada"},"ES-GU":{type:"Province",name:"Guadalajara"},"ES-MD":{type:"Autonomous community",name:"Madrid, Comunidad de"},"ES-EX":{type:"Autonomous community",name:"Extremadura"},"ES-PV":{type:"Autonomous community",name:"Euskal Herria"},"ES-V":{type:"Province",name:"Valencia"},"ES-VC":{type:"Autonomous community",name:"Valenciana, Comunidad"},"ES-SO":{type:"Province",name:"Soria"},"ES-OR":{type:"Province",name:"Ourense"},"ES-LU":{type:"Province",name:"Lugo"},"ES-SE":{type:"Province",name:"Sevilla"},"ES-NC":{type:"Autonomous community",name:"Nafarroako Foru Komunitatea*"},"ES-SG":{type:"Province",name:"Segovia"},"ES-BU":{type:"Province",name:"Burgos"},"ES-SA":{type:"Province",name:"Salamanca"},"ES-VA":{type:"Province",name:"Valladolid"},"ES-CU":{type:"Province",name:"Cuenca"},"ES-P":{type:"Province",name:"Palencia"},"ES-LE":{type:"Province",name:"León"},"ES-BI":{type:"Province",name:"Bizkaia*"},"ES-HU":{type:"Province",name:"Huesca"},"ES-LO":{type:"Province",name:"La Rioja"},"ES-SS":{type:"Province",name:"Gipuzkoa*"},"ES-BA":{type:"Province",name:"Badajoz"}}},ER:{name:"Eritrea",sub:{"ER-AN":{type:"Region",name:"Ansabā"},"ER-MA":{type:"Region",name:"Al Awsaţ"},"ER-DU":{type:"Region",name:"Al Janūbī"},"ER-DK":{type:"Region",name:"Debubawi K’eyyĭḥ Baḥri"},"ER-SK":{type:"Region",name:"Semienawi K’eyyĭḥ Baḥri"},"ER-GB":{type:"Region",name:"Gash-Barka"}}},ME:{name:"Montenegro",sub:{"ME-06":{type:"Municipality",name:"Cetinje"},"ME-07":{type:"Municipality",name:"Danilovgrad"},"ME-04":{type:"Municipality",name:"Bijelo Polje"},"ME-05":{type:"Municipality",name:"Budva"},"ME-02":{type:"Municipality",name:"Bar"},"ME-03":{type:"Municipality",name:"Berane"},"ME-01":{type:"Municipality",name:"Andrijevica"},"ME-20":{type:"Municipality",name:"Ulcinj"},"ME-21":{type:"Municipality",name:"Žabljak"},"ME-08":{type:"Municipality",name:"Herceg-Novi"},"ME-09":{type:"Municipality",name:"Kolašin"},"ME-15":{type:"Municipality",name:"Plužine"},"ME-14":{type:"Municipality",name:"Pljevlja"},"ME-17":{type:"Municipality",name:"Rožaje"},"ME-16":{type:"Municipality",name:"Podgorica"},"ME-11":{type:"Municipality",name:"Mojkovac"},"ME-10":{type:"Municipality",name:"Kotor"},"ME-13":{type:"Municipality",name:"Plav"},"ME-12":{type:"Municipality",name:"Nikšić"},"ME-19":{type:"Municipality",name:"Tivat"},"ME-18":{type:"Municipality",name:"Šavnik"},"ME-22":{type:"Municipality",name:"Gusinje"},"ME-23":{type:"Municipality",name:"Petnjica"}}},MD:{name:"Moldova",sub:{"MD-LE":{type:"District",name:"Leova"},"MD-SO":{type:"District",name:"Soroca"},"MD-TE":{type:"District",name:"Teleneşti"},"MD-IA":{type:"District",name:"Ialoveni"},"MD-TA":{type:"District",name:"Taraclia"},"MD-OC":{type:"District",name:"Ocniţa"},"MD-RI":{type:"District",name:"Rîşcani"},"MD-ED":{type:"District",name:"Edineţ"},"MD-RE":{type:"District",name:"Rezina"},"MD-OR":{type:"District",name:"Orhei"},"MD-CL":{type:"District",name:"Călăraşi"},"MD-CM":{type:"District",name:"Cimişlia"},"MD-GL":{type:"District",name:"Glodeni"},"MD-CA":{type:"District",name:"Cahul"},"MD-AN":{type:"District",name:"Anenii Noi"},"MD-UN":{type:"District",name:"Ungheni"},"MD-CR":{type:"District",name:"Criuleni"},"MD-CS":{type:"District",name:"Căuşeni"},"MD-CT":{type:"District",name:"Cantemir"},"MD-CU":{type:"City",name:"Chişinău"},"MD-HI":{type:"District",name:"Hînceşti"},"MD-DU":{type:"District",name:"Dubăsari"},"MD-NI":{type:"District",name:"Nisporeni"},"MD-ST":{type:"District",name:"Străşeni"},"MD-SV":{type:"District",name:"Ştefan Vodă"},"MD-DR":{type:"District",name:"Drochia"},"MD-SI":{type:"District",name:"Sîngerei"},"MD-DO":{type:"District",name:"Donduşeni"},"MD-SN":{type:"Territorial unit",name:"Stînga Nistrului, unitatea teritorială din"},"MD-FL":{type:"District",name:"Floreşti"},"MD-FA":{type:"District",name:"Făleşti"},"MD-SD":{type:"District",name:"Şoldăneşti"},"MD-GA":{type:"Autonomous territorial unit",name:"Găgăuzia, Unitatea teritorială autonomă"},"MD-BD":{type:"City",name:"Bender"},"MD-BA":{type:"City",name:"Bălţi"},"MD-BS":{type:"District",name:"Basarabeasca"},"MD-BR":{type:"District",name:"Briceni"}}},MG:{name:"Madagascar",sub:{"MG-A":{type:"Province",name:"Toamasina"},"MG-F":{type:"Province",name:"Fianarantsoa"},"MG-D":{type:"Province",name:"Antsiranana"},"MG-M":{type:"Province",name:"Mahajanga"},"MG-U":{type:"Province",name:"Toliara"},"MG-T":{type:"Province",name:"Antananarivo"}}},MF:{name:"St. Martin",sub:{"MF-MF":{type:"Country",name:"St. Martin"}}},MA:{name:"Morocco",sub:{"MA-RAB":{type:"Prefecture",name:"Rabat"},"MA-MMD":{type:"Prefecture",name:"Marrakech-Medina"},"MA-AOU":{type:"Prefecture",name:"Aousserd"},"MA-BEM":{type:"Province",name:"Beni Mellal"},"MA-CAS":{type:"Prefecture",name:"Casablanca"},"MA-TIZ":{type:"Province",name:"Tiznit"},"MA-SAF":{type:"Province",name:"Safi"},"MA-FIG":{type:"Province",name:"Figuig"},"MA-SAL":{type:"Prefecture",name:"Salé"},"MA-JDI":{type:"Province",name:"El Jadida"
		},"MA-LAR":{type:"Province",name:"Larache"},"MA-SKH":{type:"Prefecture",name:"Skhirate-Témara"},"MA-KHE":{type:"Province",name:"Khemisset"},"MA-LAA":{type:"Province",name:"Laâyoune"},"MA-GUE":{type:"Province",name:"Guelmim"},"MA-HAO":{type:"Province",name:"Al Haouz"},"MA-KHN":{type:"Province",name:"Khenifra"},"MA-KHO":{type:"Province",name:"Khouribga"},"MA-TAR":{type:"Province",name:"Taroudant"},"MA-ESM":{type:"Province",name:"Es Smara"},"MA-BER":{type:"Province",name:"Berkane"},"MA-BES":{type:"Province",name:"Ben Slimane"},"MA-ESI":{type:"Province",name:"Essaouira"},"MA-SET":{type:"Province",name:"Settat"},"MA-CHT":{type:"Province",name:"Chtouka-Ait Baha"},"MA-AZI":{type:"Province",name:"Azilal"},"MA-NOU":{type:"Province",name:"Nouaceur"},"MA-MOH":{type:"Prefecture",name:"Mohammadia"},"MA-MOU":{type:"Province",name:"Moulay Yacoub"},"MA-KEN":{type:"Province",name:"Kénitra"},"MA-11":{type:"Region",name:"Marrakech-Tensift-Al Haouz"},"MA-10":{type:"Region",name:"Doukkala-Abda"},"MA-13":{type:"Region",name:"Sous-Massa-Draa"},"MA-12":{type:"Region",name:"Tadla-Azilal"},"MA-15":{type:"Region",name:"Laâyoune-Boujdour-Sakia el Hamra"},"MA-14":{type:"Region",name:"Guelmim-Es Semara"},"MA-HAJ":{type:"Province",name:"El Hajeb"},"MA-16":{type:"Region",name:"Oued ed Dahab-Lagouira"},"MA-BOD":{type:"Province",name:"Boujdour"},"MA-SYB":{type:"Prefecture",name:"Sidi Youssef Ben Ali"},"MA-ZAG":{type:"Province",name:"Zagora"},"MA-CHE":{type:"Province",name:"Chefchaouen"},"MA-KES":{type:"Province",name:"Kelaat es Sraghna"},"MA-TAI":{type:"Province",name:"Taourirt"},"MA-JRA":{type:"Province",name:"Jrada"},"MA-MED":{type:"Province",name:"Médiouna"},"MA-TAO":{type:"Province",name:"Taounate"},"MA-TET":{type:"Prefecture",name:"Tétouan"},"MA-ASZ":{type:"Province",name:"Assa-Zag"},"MA-TNG":{type:"Prefecture",name:"Tanger-Assilah"},"MA-SEF":{type:"Province",name:"Sefrou"},"MA-MMN":{type:"Prefecture",name:"Marrakech-Menara"},"MA-TAZ":{type:"Province",name:"Taza"},"MA-INE":{type:"Prefecture",name:"Inezgane-Ait Melloul"},"MA-NAD":{type:"Province",name:"Nador"},"MA-CHI":{type:"Province",name:"Chichaoua"},"MA-ERR":{type:"Province",name:"Errachidia"},"MA-TNT":{type:"Province",name:"Tan-Tan"},"MA-TAT":{type:"Province",name:"Tata"},"MA-IFR":{type:"Province",name:"Ifrane"},"MA-09":{type:"Region",name:"Chaouia-Ouardigha"},"MA-SIK":{type:"Province",name:"Sidi Kacem"},"MA-OUJ":{type:"Prefecture",name:"Oujda-Angad"},"MA-FES":{type:"Prefecture",name:"Fès-Dar-Dbibegh"},"MA-OUD":{type:"Province",name:"Oued ed Dahab"},"MA-MEK":{type:"Prefecture",name:"Meknès"},"MA-OUA":{type:"Province",name:"Ouarzazate"},"MA-02":{type:"Region",name:"Gharb-Chrarda-Beni Hssen"},"MA-03":{type:"Region",name:"Taza-Al Hoceima-Taounate"},"MA-01":{type:"Region",name:"Tanger-Tétouan"},"MA-06":{type:"Region",name:"Meknès-Tafilalet"},"MA-07":{type:"Region",name:"Rabat-Salé-Zemmour-Zaer"},"MA-04":{type:"Region",name:"L'Oriental"},"MA-05":{type:"Region",name:"Fès-Boulemane"},"MA-08":{type:"Region",name:"Grand Casablanca"},"MA-AGD":{type:"Prefecture",name:"Agadir-Ida-Outanane"},"MA-BOM":{type:"Province",name:"Boulemane"},"MA-FAH":{type:"Prefecture",name:"Fahs-Beni Makada"},"MA-HOC":{type:"Province",name:"Al Hoceïma"}}},MC:{name:"Monaco",sub:{"MC-MO":{type:"Quarter",name:"Monaco-Ville"},"MC-VR":{type:"Quarter",name:"Vallon de la Rousse"},"MC-FO":{type:"Quarter",name:"Fontvieille"},"MC-SD":{type:"Quarter",name:"Sainte-Dévote"},"MC-GA":{type:"Quarter",name:"La Gare"},"MC-CL":{type:"Quarter",name:"La Colle"},"MC-CO":{type:"Quarter",name:"La Condamine"},"MC-SR":{type:"Quarter",name:"Saint-Roman"},"MC-MC":{type:"Quarter",name:"Monte-Carlo"},"MC-MA":{type:"Quarter",name:"Malbousquet"},"MC-MG":{type:"Quarter",name:"Moneghetti"},"MC-PH":{type:"Quarter",name:"Port-Hercule"},"MC-LA":{type:"Quarter",name:"Larvotto"},"MC-MU":{type:"Quarter",name:"Moulins"},"MC-JE":{type:"Quarter",name:"Jardin Exotique"},"MC-SO":{type:"Quarter",name:"La Source"},"MC-SP":{type:"Quarter",name:"Spélugues"}}},UZ:{name:"Uzbekistan",sub:{"UZ-QA":{type:"Region",name:"Qashqadaryo"},"UZ-FA":{type:"Region",name:"Farg‘ona"},"UZ-JI":{type:"Region",name:"Jizzax"},"UZ-TO":{type:"Region",name:"Toshkent"},"UZ-NW":{type:"Region",name:"Navoiy"},"UZ-SU":{type:"Region",name:"Surxondaryo"},"UZ-XO":{type:"Region",name:"Xorazm"},"UZ-QR":{type:"Republic",name:"Qoraqalpog‘iston Respublikasi"},"UZ-SI":{type:"Region",name:"Sirdaryo"},"UZ-TK":{type:"City",name:"Toshkent"},"UZ-NG":{type:"Region",name:"Namangan"},"UZ-SA":{type:"Region",name:"Samarqand"},"UZ-BU":{type:"Region",name:"Buxoro"},"UZ-AN":{type:"Region",name:"Andijon"}}},MM:{name:"Myanmar",sub:{"MM-16":{type:"State",name:"Rakhine"},"MM-18":{type:"Union territory",name:"Nay Pyi Taw"},"MM-06":{type:"Region",name:"Yangon"},"MM-07":{type:"Region",name:"Ayeyawady"},"MM-04":{type:"Region",name:"Mandalay"},"MM-05":{type:"Region",name:"Taninthayi"},"MM-02":{type:"Region",name:"Bago"},"MM-03":{type:"Region",name:"Magway"},"MM-13":{type:"State",name:"Kayin"},"MM-01":{type:"Region",name:"Sagaing"},"MM-15":{type:"State",name:"Mon"},"MM-14":{type:"State",name:"Chin"},"MM-11":{type:"State",name:"Kachin"},"MM-12":{type:"State",name:"Kayah"},"MM-17":{type:"State",name:"Shan"}}},ML:{name:"Mali",sub:{"ML-BKO":{type:"District",name:"Bamako"},"ML-1":{type:"Region",name:"Kayes"},"ML-2":{type:"Region",name:"Koulikoro"},"ML-3":{type:"Region",name:"Sikasso"},"ML-4":{type:"Region",name:"Ségou"},"ML-5":{type:"Region",name:"Mopti"},"ML-6":{type:"Region",name:"Tombouctou"},"ML-7":{type:"Region",name:"Gao"},"ML-8":{type:"Region",name:"Kidal"}}},MO:{name:"Macau",sub:{"MO-MO":{type:"Country",name:"Macau"}}},MN:{name:"Mongolia",sub:{"MN-073":{type:"Province",name:"Arhangay"},"MN-047":{type:"Province",name:"Töv"},"MN-039":{type:"Province",name:"Hentiy"},"MN-071":{type:"Province",name:"Bayan-Ölgiy"},"MN-059":{type:"Province",name:"Dundgovĭ"},"MN-057":{type:"Province",name:"Dzavhan"},"MN-055":{type:"Province",name:"Övörhangay"},"MN-053":{type:"Province",name:"Ömnögovĭ"},"MN-051":{type:"Province",name:"Sühbaatar"},"MN-035":{type:"Province",name:"Orhon"},"MN-037":{type:"Province",name:"Darhan uul"},"MN-1":{type:"Capital city",name:"Ulaanbaatar"},"MN-067":{type:"Province",name:"Bulgan"},"MN-064":{type:"Province",name:"Govĭ-Sümber"},"MN-065":{type:"Province",name:"Govĭ-Altay"},"MN-063":{type:"Province",name:"Dornogovĭ"},"MN-046":{type:"Province",name:"Uvs"},"MN-061":{type:"Province",name:"Dornod"},"MN-049":{type:"Province",name:"Selenge"},"MN-069":{type:"Province",name:"Bayanhongor"},"MN-041":{type:"Province",name:"Hövsgöl"},"MN-043":{type:"Province",name:"Hovd"}}},MH:{name:"Marshall Islands",sub:{"MH-RON":{type:"Municipality",name:"Rongelap"},"MH-KWA":{type:"Municipality",name:"Kwajalein"},"MH-MAL":{type:"Municipality",name:"Maloelap"},"MH-WTH":{type:"Municipality",name:"Wotho"},"MH-WTJ":{type:"Municipality",name:"Wotje"},"MH-L":{type:"Chain",name:"Ralik chain"},"MH-ENI":{type:"Municipality",name:"Enewetak and Ujelang"},"MH-UTI":{type:"Municipality",name:"Utrik"},"MH-T":{type:"Chain",name:"Ratak chain"},"MH-AUR":{type:"Municipality",name:"Aur"},"MH-JAL":{type:"Municipality",name:"Jaluit"},"MH-UJA":{type:"Municipality",name:"Ujae"},"MH-JAB":{type:"Municipality",name:"Jabat"},"MH-ALK":{type:"Municipality",name:"Ailuk"},"MH-NMU":{type:"Municipality",name:"Namu"},"MH-ALL":{type:"Municipality",name:"Ailinglaplap"},"MH-MEJ":{type:"Municipality",name:"Mejit"},"MH-LAE":{type:"Municipality",name:"Lae"},"MH-EBO":{type:"Municipality",name:"Ebon"},"MH-KIL":{type:"Municipality",name:"Bikini and Kili"},"MH-NMK":{type:"Municipality",name:"Namdrik"},"MH-ARN":{type:"Municipality",name:"Arno"},"MH-MAJ":{type:"Municipality",name:"Majuro"},"MH-MIL":{type:"Municipality",name:"Mili"},"MH-LIB":{type:"Municipality",name:"Lib"},"MH-LIK":{type:"Municipality",name:"Likiep"}}},MK:{name:"Macedonia, the Former Yugoslav Republic Of",sub:{"MK-36":{type:"Municipality",name:"Kavadarci"},"MK-45":{type:"Municipality",name:"Krivogaštani"},"MK-33":{type:"Municipality",name:"Zrnovci"},"MK-68":{type:"Municipality",name:"Saraj †"},"MK-31":{type:"Municipality",name:"Zajas"},"MK-65":{type:"Municipality",name:"Rankovce"},"MK-64":{type:"Municipality",name:"Radoviš"},"MK-30":{type:"Municipality",name:"Želino"},"MK-04":{type:"Municipality",name:"Bitola"},"MK-05":{type:"Municipality",name:"Bogdanci"},"MK-06":{type:"Municipality",name:"Bogovinje"},"MK-07":{type:"Municipality",name:"Bosilovo"},"MK-66":{type:"Municipality",name:"Resen"},"MK-01":{type:"Municipality",name:"Aerodrom †"},"MK-02":{type:"Municipality",name:"Aračinovo"},"MK-03":{type:"Municipality",name:"Berovo"},"MK-40":{type:"Municipality",name:"Kičevo"},"MK-41":{type:"Municipality",name:"Konče"},"MK-42":{type:"Municipality",name:"Kočani"},"MK-32":{type:"Municipality",name:"Zelenikovo"},"MK-08":{type:"Municipality",name:"Brvenica"},"MK-09":{type:"Municipality",name:"Butel †"},"MK-46":{type:"Municipality",name:"Kruševo"},"MK-47":{type:"Municipality",name:"Kumanovo"},"MK-43":{type:"Municipality",name:"Kratovo"},"MK-69":{type:"Municipality",name:"Sveti Nikole"},"MK-28":{type:"Municipality",name:"Drugovo"},"MK-29":{type:"Municipality",name:"Gjorče Petrov †"},"MK-26":{type:"Municipality",name:"Dojran"},"MK-27":{type:"Municipality",name:"Dolneni"},"MK-24":{type:"Municipality",name:"Demir Kapija"},"MK-25":{type:"Municipality",name:"Demir Hisar"},"MK-22":{type:"Municipality",name:"Debarca"},"MK-23":{type:"Municipality",name:"Delčevo"},"MK-20":{type:"Municipality",name:"Gradsko"},"MK-21":{type:"Municipality",name:"Debar"},"MK-62":{type:"Municipality",name:"Prilep"},"MK-74":{type:"Municipality",name:"Studeničani"},"MK-80":{type:"Municipality",name:"Čaška"},"MK-81":{type:"Municipality",name:"Češinovo-Obleševo"},"MK-82":{type:"Municipality",name:"Čučer Sandevo"},"MK-83":{type:"Municipality",name:"Štip"},"MK-78":{type:"Municipality",name:"Centar Župa"},"MK-71":{type:"Municipality",name:"Staro Nagoričane"},"MK-70":{type:"Municipality",name:"Sopište"},"MK-60":{type:"Municipality",name:"Pehčevo"},"MK-72":{type:"Municipality",name:"Struga"},"MK-75":{type:"Municipality",name:"Tearce"},"MK-73":{type:"Municipality",name:"Strumica"},"MK-59":{type:"Municipality",name:"Petrovec"},"MK-58":{type:"Municipality",name:"Ohrid"},"MK-57":{type:"Municipality",name:"Oslomej"},"MK-56":{type:"Municipality",name:"Novo Selo"},"MK-55":{type:"Municipality",name:"Novaci"},"MK-54":{type:"Municipality",name:"Negotino"},"MK-53":{type:"Municipality",name:"Mogila"},"MK-52":{type:"Municipality",name:"Makedonski Brod"},"MK-51":{type:"Municipality",name:"Makedonska Kamenica"},"MK-50":{type:"Municipality",name:"Mavrovo i Rostuša"},"MK-48":{type:"Municipality",name:"Lipkovo"},"MK-19":{type:"Municipality",name:"Gostivar"},"MK-18":{type:"Municipality",name:"Gevgelija"},"MK-39":{type:"Municipality",name:"Kisela Voda †"},"MK-38":{type:"Municipality",name:"Karpoš †"},"MK-44":{type:"Municipality",name:"Kriva Palanka"},"MK-49":{type:"Municipality",name:"Lozovo"},"MK-13":{type:"Municipality",name:"Veles"},"MK-12":{type:"Municipality",name:"Vevčani"},"MK-11":{type:"Municipality",name:"Vasilevo"},"MK-10":{type:"Municipality",name:"Valandovo"},"MK-17":{type:"Municipality",name:"Gazi Baba †"},"MK-16":{type:"Municipality",name:"Vrapčište"},"MK-15":{type:"Municipality",name:"Vraneštica"},"MK-14":{type:"Municipality",name:"Vinica"},"MK-35":{type:"Municipality",name:"Jegunovce"},"MK-84":{type:"Municipality",name:"Šuto Orizari †"},"MK-61":{type:"Municipality",name:"Plasnica"},"MK-79":{type:"Municipality",name:"Čair †"},"MK-34":{type:"Municipality",name:"Ilinden"},"MK-63":{type:"Municipality",name:"Probištip"},"MK-76":{type:"Municipality",name:"Tetovo"},"MK-77":{type:"Municipality",name:"Centar †"},"MK-37":{type:"Municipality",name:"Karbinci"},"MK-67":{type:"Municipality",name:"Rosoman"}}},MU:{name:"Mauritius",sub:{"MU-VP":{type:"City",name:"Vacoas-Phoenix"},"MU-CC":{type:"Dependency",name:"Cargados Carajos Shoals"},"MU-SA":{type:"District",name:"Savanne"},"MU-RO":{type:"Dependency",name:"Rodrigues Island"},"MU-CU":{type:"City",name:"Curepipe"},"MU-PA":{type:"District",name:"Pamplemousses"},"MU-PL":{type:"District",name:"Port Louis"},"MU-QB":{type:"City",name:"Quatre Bornes"},"MU-FL":{type:"District",name:"Flacq"},"MU-BR":{type:"City",name:"Beau Bassin-Rose Hill"},"MU-BL":{type:"District",name:"Black River"},"MU-PW":{type:"District",name:"Plaines Wilhems"},"MU-AG":{type:"Dependency",name:"Agalega Islands"},"MU-PU":{type:"City",name:"Port Louis"},"MU-RR":{type:"District",name:"Rivière du Rempart"},"MU-GP":{type:"District",name:"Grand Port"},"MU-MO":{type:"District",name:"Moka"}}},MT:{name:"Malta",sub:{"MT-58":{type:"Local council",name:"Ta’ Xbiex"},"MT-59":{type:"Local council",name:"Tarxien"},"MT-56":{type:"Local council",name:"Sliema"},"MT-57":{type:"Local council",name:"Swieqi"},"MT-54":{type:"Local council",name:"Santa Venera"},"MT-55":{type:"Local council",name:"Siġġiewi"},"MT-52":{type:"Local council",name:"Sannat"},"MT-53":{type:"Local council",name:"Saint Lucia’s"},"MT-50":{type:"Local council",name:"Saint Lawrence"},"MT-51":{type:"Local council",name:"Saint Paul’s Bay"},"MT-68":{type:"Local council",name:"Żurrieq"},"MT-60":{type:"Local council",name:"Valletta"},"MT-48":{type:"Local council",name:"Saint Julian’s"},"MT-38":{type:"Local council",name:"Naxxar"},"MT-67":{type:"Local council",name:"Żejtun"},"MT-39":{type:"Local council",name:"Paola"},"MT-01":{type:"Local council",name:"Attard"},"MT-63":{type:"Local council",name:"Xgħajra"},"MT-03":{type:"Local council",name:"Birgu"},"MT-02":{type:"Local council",name:"Balzan"},"MT-05":{type:"Local council",name:"Birżebbuġa"},"MT-04":{type:"Local council",name:"Birkirkara"},"MT-07":{type:"Local council",name:"Dingli"},"MT-06":{type:"Local council",name:"Bormla"},"MT-09":{type:"Local council",name:"Floriana"},"MT-08":{type:"Local council",name:"Fgura"},"MT-25":{type:"Local council",name:"Luqa"},"MT-24":{type:"Local council",name:"Lija"},"MT-23":{type:"Local council",name:"Kirkop"},"MT-22":{type:"Local council",name:"Kerċem"},"MT-21":{type:"Local council",name:"Kalkara"},"MT-20":{type:"Local council",name:"Isla"},"MT-46":{type:"Local council",name:"Rabat Malta"},"MT-49":{type:"Local council",name:"Saint John"},"MT-29":{type:"Local council",name:"Mdina"},"MT-45":{type:"Local council",name:"Rabat Gozo"},"MT-44":{type:"Local council",name:"Qrendi"},"MT-47":{type:"Local council",name:"Safi"},"MT-28":{type:"Local council",name:"Marsaxlokk"},"MT-41":{type:"Local council",name:"Pietà"},"MT-40":{type:"Local council",name:"Pembroke"},"MT-43":{type:"Local council",name:"Qormi"},"MT-42":{type:"Local council",name:"Qala"},"MT-27":{type:"Local council",name:"Marsaskala"},"MT-66":{type:"Local council",name:"Żebbuġ Malta"},"MT-65":{type:"Local council",name:"Żebbuġ Gozo"},"MT-26":{type:"Local council",name:"Marsa"},"MT-61":{type:"Local council",name:"Xagħra"},"MT-62":{type:"Local council",name:"Xewkija"},"MT-64":{type:"Local council",name:"Żabbar"},"MT-32":{type:"Local council",name:"Mosta"},"MT-33":{type:"Local council",name:"Mqabba"},"MT-12":{type:"Local council",name:"Gżira"},"MT-13":{type:"Local council",name:"Għajnsielem"},"MT-10":{type:"Local council",name:"Fontana"},"MT-11":{type:"Local council",name:"Gudja"},"MT-16":{type:"Local council",name:"Għasri"},"MT-17":{type:"Local council",name:"Għaxaq"},"MT-14":{type:"Local council",name:"Għarb"},"MT-15":{type:"Local council",name:"Għargħur"},"MT-30":{type:"Local council",name:"Mellieħa"},"MT-31":{type:"Local council",name:"Mġarr"},"MT-18":{type:"Local council",name:"Ħamrun"},"MT-19":{type:"Local council",name:"Iklin"},"MT-34":{type:"Local council",name:"Msida"},"MT-35":{type:"Local council",name:"Mtarfa"},"MT-36":{type:"Local council",name:"Munxar"},"MT-37":{type:"Local council",name:"Nadur"}}},MW:{name:"Malawi",sub:{"MW-CR":{type:"District",name:"Chiradzulu"},"MW-CT":{type:"District",name:"Chitipa"},"MW-CK":{type:"District",name:"Chikwawa"},"MW-KS":{type:"District",name:"Kasungu"},"MW-KR":{type:"District",name:"Karonga"},"MW-TH":{type:"District",name:"Thyolo"},"MW-NS":{type:"District",name:"Nsanje"},"MW-MC":{type:"District",name:"Mchinji"},"MW-MG":{type:"District",name:"Mangochi"},"MW-MZ":{type:"District",name:"Mzimba"},"MW-PH":{type:"District",name:"Phalombe"},"MW-MW":{type:"District",name:"Mwanza"},"MW-MU":{type:"District",name:"Mulanje"},"MW-RU":{type:"District",name:"Rumphi"},"MW-ZO":{type:"District",name:"Zomba"},"MW-DO":{type:"District",name:"Dowa"},"MW-BL":{type:"District",name:"Blantyre"},"MW-DE":{type:"District",name:"Dedza"},"MW-BA":{type:"District",name:"Balaka"},"MW-S":{type:"Region",name:"Chakumwera"},"MW-NK":{type:"District",name:"Nkhotakota"},"MW-NI":{type:"District",name:"Ntchisi"},"MW-SA":{type:"District",name:"Salima"},"MW-NE":{type:"District",name:"Neno"},"MW-NB":{type:"District",name:"Nkhata Bay"},"MW-LI":{type:"District",name:"Lilongwe"},"MW-C":{type:"Region",name:"Central Region"},"MW-MH":{type:"District",name:"Machinga"},"MW-NU":{type:"District",name:"Ntcheu"},"MW-N":{type:"Region",name:"Chakumpoto"},"MW-LK":{type:"District",name:"Likoma"}}},MV:{name:"Maldives",sub:{"MV-00":{type:"Administrative atoll",name:"Alifu Dhaalu"},"MV-23":{type:"Administrative atoll",name:"Haa Dhaalu"},"MV-NO":{type:"Province",name:"North"},"MV-NC":{type:"Province",name:"Medhu-Uthuru"},"MV-SU":{type:"Province",name:"Dhekunu"},"MV-08":{type:"Administrative atoll",name:"Kolhumadulu"},"MV-29":{type:"Administrative atoll",name:"Fuvammulah"},"MV-28":{type:"Administrative atoll",name:"Gaafu Dhaalu"},"MV-03":{type:"Administrative atoll",name:"Faadhippolhu"},"MV-02":{type:"Administrative atoll",name:"Alifu Alifu"},"MV-01":{type:"Administrative atoll",name:"Addu Atholhu"},"MV-26":{type:"Administrative atoll",name:"Kaafu"},"MV-07":{type:"Administrative atoll",name:"Haa Alifu"},"MV-20":{type:"Administrative atoll",name:"Baa"},"MV-05":{type:"Administrative atoll",name:"Hadhdhunmathi"},"MV-04":{type:"Administrative atoll",name:"Felidhu Atholhu"},"MV-MLE":{type:"Capital",name:"Maale"},"MV-SC":{type:"Province",name:"Medhu-Dhekunu"},"MV-UN":{type:"Province",name:"Mathi-Uthuru"},"MV-14":{type:"Administrative atoll",name:"Faafu"},"MV-17":{type:"Administrative atoll",name:"Dhaalu"},"MV-12":{type:"Administrative atoll",name:"Meemu"},"MV-13":{type:"Administrative atoll",name:"Maalhosmadulu Uthuruburi"},"MV-US":{type:"Province",name:"Mathi-Dhekunu"},"MV-CE":{type:"Province",name:"Central"},"MV-25":{type:"Administrative atoll",name:"Miladhunmadulu Dhekunuburi"},"MV-24":{type:"Administrative atoll",name:"Miladhunmadulu Uthuruburi"},"MV-27":{type:"Administrative atoll",name:"Gaafu Alifu"}}},MQ:{name:"Martinique",sub:{"MQ-MQ":{type:"Country",name:"Martinique"}}},MP:{name:"Northern Mariana Islands",sub:{"MP-MP":{type:"Country",name:"Northern Mariana Islands"}}},MS:{name:"Montserrat",sub:{"MS-MS":{type:"Country",name:"Montserrat"}}},MR:{name:"Mauritania",sub:{"MR-07":{type:"Region",name:"Adrar"},"MR-06":{type:"Region",name:"Trarza"},"MR-05":{type:"Region",name:"Brakna"},"MR-04":{type:"Region",name:"Gorgol"},"MR-03":{type:"Region",name:"Assaba"},"MR-02":{type:"Region",name:"Hodh el Gharbi"},"MR-01":{type:"Region",name:"Hodh ech Chargui"},"MR-11":{type:"Region",name:"Tiris Zemmour"},"MR-NKC":{type:"District",name:"Nouakchott"},"MR-12":{type:"Region",name:"Inchiri"},"MR-09":{type:"Region",name:"Tagant"},"MR-08":{type:"Region",name:"Dakhlet Nouâdhibou"},"MR-10":{type:"Region",name:"Guidimaka"}}},IM:{name:"Isle of Man",sub:{"IM-IM":{type:"Country",name:"Isle of Main"}}},UG:{name:"Uganda",sub:{"UG-328":{type:"District",name:"Napak"},"UG-329":{type:"District",name:"Nwoya"},"UG-108":{type:"District",name:"Mukono"},"UG-109":{type:"District",name:"Nakasongola"},"UG-101":{type:"District",name:"Kalangala"},"UG-102":{type:"City",name:"Kampala"},"UG-103":{type:"District",name:"Kiboga"},"UG-104":{type:"District",name:"Luwero"},"UG-105":{type:"District",name:"Masaka"},"UG-106":{type:"District",name:"Mpigi"},"UG-107":{type:"District",name:"Mubende"},"UG-229":{type:"District",name:"Luuka"},"UG-228":{type:"District",name:"Kween"},"UG-221":{type:"District",name:"Manafwa"},"UG-220":{type:"District",name:"Kaliro"},"UG-223":{type:"District",name:"Bududa"},"UG-222":{type:"District",name:"Namutumba"},"UG-225":{type:"District",name:"Bulambuli"},"UG-224":{type:"District",name:"Bukedea"},"UG-227":{type:"District",name:"Kibuku"},"UG-226":{type:"District",name:"Buyende"},"UG-117":{type:"District",name:"Buikwe"},"UG-116":{type:"District",name:"Lyantonde"},"UG-115":{type:"District",name:"Nakaseke"},"UG-114":{type:"District",name:"Mityana"},"UG-113":{type:"District",name:"Wakiso"},"UG-112":{type:"District",name:"Kayunga"},"UG-111":{type:"District",name:"Sembabule"},"UG-110":{type:"District",name:"Rakai"},"UG-119":{type:"District",name:"Butambala"},"UG-118":{type:"District",name:"Bukomansibi"},"UG-214":{type:"District",name:"Mayuge"},"UG-215":{type:"District",name:"Sironko"},"UG-216":{type:"District",name:"Amuria"},"UG-217":{type:"District",name:"Budaka"},"UG-210":{type:"District",name:"Pallisa"},"UG-211":{type:"District",name:"Soroti"},"UG-212":{type:"District",name:"Tororo"},"UG-213":{type:"District",name:"Kaberamaido"},"UG-218":{type:"District",name:"Bukwa"},"UG-219":{type:"District",name:"Butaleja"},"UG-421":{type:"District",name:"Kyegegwa"},"UG-203":{type:"District",name:"Iganga"},"UG-202":{type:"District",name:"Busia"},"UG-201":{type:"District",name:"Bugiri"},"UG-207":{type:"District",name:"Katakwi"},"UG-206":{type:"District",name:"Kapchorwa"},"UG-205":{type:"District",name:"Kamuli"},"UG-204":{type:"District",name:"Jinja"},"UG-209":{type:"District",name:"Mbale"},"UG-208":{type:"District",name:"Kumi"},"UG-416":{type:"District",name:"Ibanda"},"UG-418":{type:"District",name:"Kiruhura"},"UG-419":{type:"District",name:"Buliisa"},"UG-417":{type:"District",name:"Isingiro"},"UG-308":{type:"District",name:"Moroto"},"UG-309":{type:"District",name:"Moyo"},"UG-302":{type:"District",name:"Apac"},"UG-303":{type:"District",name:"Arua"},"UG-301":{type:"District",name:"Adjumani"},"UG-306":{type:"District",name:"Kotido"},"UG-307":{type:"District",name:"Lira"},"UG-304":{type:"District",name:"Gulu"},"UG-305":{type:"District",name:"Kitgum"},"UG-420":{type:"District",name:"Kiryandongo"},"UG-425":{type:"District",name:"Sheema"},"UG-424":{type:"District",name:"Rubirizi"},"UG-423":{type:"District",name:"Ntoroko"},"UG-422":{type:"District",name:"Mitooma"},"UG-319":{type:"District",name:"Amuru"},"UG-318":{type:"District",name:"Dokolo"},"UG-414":{type:"District",name:"Kanungu"},"UG-415":{type:"District",name:"Kyenjojo"},"UG-412":{type:"District",name:"Rukungiri"},"UG-413":{type:"District",name:"Kamwenge"},"UG-410":{type:"District",name:"Mbarara"},"UG-411":{type:"District",name:"Ntungamo"},"UG-311":{type:"District",name:"Nakapiripirit"},"UG-310":{type:"District",name:"Nebbi"},"UG-313":{type:"District",name:"Yumbe"},"UG-312":{type:"District",name:"Pader"},"UG-315":{type:"District",name:"Kaabong"},"UG-314":{type:"District",name:"Amolatar"},"UG-317":{type:"District",name:"Abim"},"UG-316":{type:"District",name:"Koboko"},"UG-324":{type:"District",name:"Amudat"},"UG-325":{type:"District",name:"Buhweju"},"UG-326":{type:"District",name:"Kole"},"UG-327":{type:"District",name:"Lamwo"},"UG-320":{type:"District",name:"Maracha"},"UG-321":{type:"District",name:"Oyam"},"UG-322":{type:"District",name:"Agago"},"UG-323":{type:"District",name:"Alebtong"},"UG-124":{type:"District",name:"Lwengo"},"UG-122":{type:"District",name:"Kalungu"},"UG-123":{type:"District",name:"Kyankwanzi"},"UG-120":{type:"District",name:"Buvuma"},"UG-121":{type:"District",name:"Gomba"},"UG-405":{type:"District",name:"Kabarole"},"UG-404":{type:"District",name:"Kabale"},"UG-407":{type:"District",name:"Kibaale"},"UG-406":{type:"District",name:"Kasese"},"UG-401":{type:"District",name:"Bundibugyo"},"UG-403":{type:"District",name:"Hoima"},"UG-402":{type:"District",name:"Bushenyi"},"UG-409":{type:"District",name:"Masindi"},"UG-408":{type:"District",name:"Kisoro"},"UG-N":{type:"Geographical region",name:"Northern"},"UG-C":{type:"Geographical region",name:"Central"},"UG-E":{type:"Geographical region",name:"Eastern"},"UG-W":{type:"Geographical region",name:"Western"},"UG-331":{type:"District",name:"Zombo"},"UG-330":{type:"District",name:"Otuke"},"UG-232":{type:"District",name:"Serere"},"UG-230":{type:"District",name:"Namayingo"},"UG-231":{type:"District",name:"Ngora"}}},TZ:{name:"Tanzania",sub:{"TZ-28":{type:"Region",name:"Katavi"},"TZ-29":{type:"Region",name:"Njombe"},"TZ-02":{type:"Region",name:"Dar es Salaam"},"TZ-03":{type:"Region",name:"Dodoma"},"TZ-01":{type:"Region",name:"Arusha"},"TZ-06":{type:"Region",name:"Kaskazini Pemba"},"TZ-07":{type:"Region",name:"Kaskazini Unguja"},"TZ-04":{type:"Region",name:"Iringa"},"TZ-05":{type:"Region",name:"Kagera"},"TZ-20":{type:"Region",name:"Rukwa"},"TZ-21":{type:"Region",name:"Ruvuma"},"TZ-08":{type:"Region",name:"Kigoma"},"TZ-09":{type:"Region",name:"Kilimanjaro"},"TZ-24":{type:"Region",name:"Tabora"},"TZ-25":{type:"Region",name:"Tanga"},"TZ-26":{type:"Region",name:"Manyara"},"TZ-27":{type:"Region",name:"Geita"},"TZ-22":{type:"Region",name:"Shinyanga"},"TZ-23":{type:"Region",name:"Singida"},"TZ-11":{type:"Region",name:"Kusini Unguja"},"TZ-10":{type:"Region",name:"Kusini Pemba"},"TZ-13":{type:"Region",name:"Mara"},"TZ-12":{type:"Region",name:"Lindi"},"TZ-15":{type:"Region",name:"Mjini Magharibi"},"TZ-14":{type:"Region",name:"Mbeya"},"TZ-17":{type:"Region",name:"Mtwara"},"TZ-16":{type:"Region",name:"Morogoro"},"TZ-19":{type:"Region",name:"Coast"},"TZ-18":{type:"Region",name:"Mwanza"},"TZ-30":{type:"Region",name:"Simiyu"}}},MY:{name:"Malaysia",sub:{"MY-08":{type:"State",name:"Perak"},"MY-09":{type:"State",name:"Perlis"},"MY-16":{type:"Federal territory",name:"Wilayah Persekutuan Putrajaya"},"MY-02":{type:"State",name:"Kedah"},"MY-03":{type:"State",name:"Kelantan"},"MY-13":{type:"State",name:"Sarawak"},"MY-01":{type:"State",name:"Johor"},"MY-06":{type:"State",name:"Pahang"},"MY-07":{type:"State",name:"Pulau Pinang"},"MY-04":{type:"State",name:"Melaka"},"MY-05":{type:"State",name:"Negeri Sembilan"},"MY-11":{type:"State",name:"Terengganu"},"MY-10":{type:"State",name:"Selangor"},"MY-14":{type:"Federal territory",name:"Wilayah Persekutuan Kuala Lumpur"},"MY-15":{type:"Federal territory",name:"Wilayah Persekutuan Labuan"},"MY-12":{type:"State",name:"Sabah"}}},MX:{name:"Mexico",sub:{"MX-JAL":{type:"State",name:"Jalisco"},"MX-MEX":{type:"State",name:"México"},"MX-DUR":{type:"State",name:"Durango"},"MX-TAB":{type:"State",name:"Tabasco"},"MX-GUA":{type:"State",name:"Guanajuato"},"MX-CMX":{type:"Federal District",name:"Ciudad de México"},"MX-SIN":{type:"State",name:"Sinaloa"},"MX-BCS":{type:"State",name:"Baja California Sur"},"MX-NAY":{type:"State",name:"Nayarit"},"MX-AGU":{type:"State",name:"Aguascalientes"},"MX-ROO":{type:"State",name:"Quintana Roo"},"MX-NLE":{type:"State",name:"Nuevo León"},"MX-BCN":{type:"State",name:"Baja California"},"MX-SON":{type:"State",name:"Sonora"},"MX-MOR":{type:"State",name:"Morelos"},"MX-MIC":{type:"State",name:"Michoacán de Ocampo"},"MX-CAM":{type:"State",name:"Campeche"},"MX-COA":{type:"State",name:"Coahuila de Zaragoza"},"MX-QUE":{type:"State",name:"Querétaro"},"MX-COL":{type:"State",name:"Colima"},"MX-TAM":{type:"State",name:"Tamaulipas"},"MX-YUC":{type:"State",name:"Yucatán"},"MX-PUE":{type:"State",name:"Puebla"},"MX-HID":{type:"State",name:"Hidalgo"},"MX-CHP":{type:"State",name:"Chiapas"},"MX-TLA":{type:"State",name:"Tlaxcala"},"MX-GRO":{type:"State",name:"Guerrero"},"MX-CHH":{type:"State",name:"Chihuahua"},"MX-VER":{type:"State",name:"Veracruz de Ignacio de la Llave"},"MX-ZAC":{type:"State",name:"Zacatecas"},"MX-SLP":{type:"State",name:"San Luis Potosí"},"MX-OAX":{type:"State",name:"Oaxaca"}}},IL:{name:"Israel",sub:{"IL-TA":{type:"District",name:"Tel Aviv"},"IL-Z":{type:"District",name:"Northern District"},"IL-M":{type:"District",name:"Central District"},"IL-HA":{type:"District",name:"Haifa"},"IL-D":{type:"District",name:"Southern District"},"IL-JM":{type:"District",name:"Jerusalem"}}},FR:{name:"France",sub:{"FR-28":{type:"Metropolitan department",name:"Eure-et-Loir"},"FR-29":{type:"Metropolitan department",name:"Finistère"},"FR-22":{type:"Metropolitan department",name:"Côtes-d'Armor"},"FR-23":{type:"Metropolitan department",name:"Creuse"},"FR-21":{type:"Metropolitan department",name:"Côte-d'Or"},"FR-26":{type:"Metropolitan department",name:"Drôme"},"FR-27":{type:"Metropolitan department",name:"Eure"},"FR-24":{type:"Metropolitan department",name:"Dordogne"},"FR-25":{type:"Metropolitan department",name:"Doubs"},"FR-TF":{type:"Overseas territorial collectivity",name:"Terres australes françaises"},"FR-95":{type:"Metropolitan department",name:"Val-d'Oise"},"FR-94":{type:"Metropolitan department",name:"Val-de-Marne"},"FR-93":{type:"Metropolitan department",name:"Seine-Saint-Denis"},"FR-92":{type:"Metropolitan department",name:"Hauts-de-Seine"},"FR-91":{type:"Metropolitan department",name:"Essonne"},"FR-90":{type:"Metropolitan department",name:"Territoire de Belfort"},"FR-17":{type:"Metropolitan department",name:"Charente-Maritime"},"FR-16":{type:"Metropolitan department",name:"Charente"},"FR-15":{type:"Metropolitan department",name:"Cantal"},"FR-14":{type:"Metropolitan department",name:"Calvados"},"FR-13":{type:"Metropolitan department",name:"Bouches-du-Rhône"},"FR-12":{type:"Metropolitan department",name:"Aveyron"},"FR-11":{type:"Metropolitan department",name:"Aude"},"FR-10":{type:"Metropolitan department",name:"Aube"},"FR-2B":{type:"Metropolitan department",name:"Haute-Corse"},"FR-2A":{type:"Metropolitan department",name:"Corse-du-Sud"},"FR-MF":{type:"Overseas territorial collectivity",name:"Saint-Martin"},"FR-19":{type:"Metropolitan department",name:"Corrèze"},"FR-18":{type:"Metropolitan department",name:"Cher"},"FR-88":{type:"Metropolitan department",name:"Vosges"},"FR-89":{type:"Metropolitan department",name:"Yonne"},"FR-A":{type:"Metropolitan region",name:"Alsace"},"FR-G":{type:"Metropolitan region",name:"Champagne-Ardenne"},"FR-F":{type:"Metropolitan region",name:"Centre"},"FR-BL":{type:"Overseas territorial collectivity",name:"Saint-Barthélemy"},"FR-D":{type:"Metropolitan region",name:"Bourgogne"},"FR-80":{type:"Metropolitan department",name:"Somme"},"FR-81":{type:"Metropolitan department",name:"Tarn"},"FR-82":{type:"Metropolitan department",name:"Tarn-et-Garonne"},"FR-83":{type:"Metropolitan department",name:"Var"},"FR-84":{type:"Metropolitan department",name:"Vaucluse"},"FR-85":{type:"Metropolitan department",name:"Vendée"},"FR-86":{type:"Metropolitan department",name:"Vienne"},"FR-87":{type:"Metropolitan department",name:"Haute-Vienne"},"FR-S":{type:"Metropolitan region",name:"Picardie"},"FR-01":{type:"Metropolitan department",name:"Ain"},"FR-02":{type:"Metropolitan department",name:"Aisne"},"FR-03":{type:"Metropolitan department",name:"Allier"},"FR-04":{type:"Metropolitan department",name:"Alpes-de-Haute-Provence"},"FR-05":{type:"Metropolitan department",name:"Hautes-Alpes"},"FR-06":{type:"Metropolitan department",name:"Alpes-Maritimes"},"FR-07":{type:"Metropolitan department",name:"Ardèche"},"FR-08":{type:"Metropolitan department",name:"Ardennes"},"FR-09":{type:"Metropolitan department",name:"Ariège"},"FR-RE":{type:"Overseas department",name:"La Réunion"},"FR-E":{type:"Metropolitan region",name:"Bretagne"},"FR-CP":{type:"Dependency",name:"Clipperton"},"FR-75":{type:"Metropolitan department",name:"Paris"},"FR-74":{type:"Metropolitan department",name:"Haute-Savoie"},"FR-77":{type:"Metropolitan department",name:"Seine-et-Marne"},"FR-76":{type:"Metropolitan department",name:"Seine-Maritime"},"FR-71":{type:"Metropolitan department",name:"Saône-et-Loire"},"FR-70":{type:"Metropolitan department",name:"Haute-Saône"},"FR-73":{type:"Metropolitan department",name:"Savoie"},"FR-72":{type:"Metropolitan department",name:"Sarthe"},"FR-79":{type:"Metropolitan department",name:"Deux-Sèvres"},"FR-78":{type:"Metropolitan department",name:"Yvelines"},"FR-C":{type:"Metropolitan region",name:"Auvergne"},"FR-B":{type:"Metropolitan region",name:"Aquitaine"
		},"FR-YT":{type:"Overseas department",name:"Mayotte"},"FR-66":{type:"Metropolitan department",name:"Pyrénées-Orientales"},"FR-67":{type:"Metropolitan department",name:"Bas-Rhin"},"FR-64":{type:"Metropolitan department",name:"Pyrénées-Atlantiques"},"FR-65":{type:"Metropolitan department",name:"Hautes-Pyrénées"},"FR-62":{type:"Metropolitan department",name:"Pas-de-Calais"},"FR-63":{type:"Metropolitan department",name:"Puy-de-Dôme"},"FR-60":{type:"Metropolitan department",name:"Oise"},"FR-61":{type:"Metropolitan department",name:"Orne"},"FR-68":{type:"Metropolitan department",name:"Haut-Rhin"},"FR-69":{type:"Metropolitan department",name:"Rhône"},"FR-K":{type:"Metropolitan region",name:"Languedoc-Roussillon"},"FR-J":{type:"Metropolitan region",name:"Île-de-France"},"FR-R":{type:"Metropolitan region",name:"Pays-de-la-Loire"},"FR-I":{type:"Metropolitan region",name:"Franche-Comté"},"FR-H":{type:"Metropolitan region",name:"Corse"},"FR-O":{type:"Metropolitan region",name:"Nord-Pas-de-Calais"},"FR-N":{type:"Metropolitan region",name:"Midi-Pyrénées"},"FR-M":{type:"Metropolitan region",name:"Lorraine"},"FR-L":{type:"Metropolitan region",name:"Limousin"},"FR-53":{type:"Metropolitan department",name:"Mayenne"},"FR-52":{type:"Metropolitan department",name:"Haute-Marne"},"FR-51":{type:"Metropolitan department",name:"Marne"},"FR-50":{type:"Metropolitan department",name:"Manche"},"FR-57":{type:"Metropolitan department",name:"Moselle"},"FR-56":{type:"Metropolitan department",name:"Morbihan"},"FR-55":{type:"Metropolitan department",name:"Meuse"},"FR-54":{type:"Metropolitan department",name:"Meurthe-et-Moselle"},"FR-59":{type:"Metropolitan department",name:"Nord"},"FR-58":{type:"Metropolitan department",name:"Nièvre"},"FR-Q":{type:"Metropolitan region",name:"Haute-Normandie"},"FR-P":{type:"Metropolitan region",name:"Basse-Normandie"},"FR-V":{type:"Metropolitan region",name:"Rhône-Alpes"},"FR-U":{type:"Metropolitan region",name:"Provence-Alpes-Côte-d'Azur"},"FR-T":{type:"Metropolitan region",name:"Poitou-Charentes"},"FR-NC":{type:"Overseas territorial collectivity",name:"Nouvelle-Calédonie"},"FR-48":{type:"Metropolitan department",name:"Lozère"},"FR-49":{type:"Metropolitan department",name:"Maine-et-Loire"},"FR-44":{type:"Metropolitan department",name:"Loire-Atlantique"},"FR-45":{type:"Metropolitan department",name:"Loiret"},"FR-46":{type:"Metropolitan department",name:"Lot"},"FR-47":{type:"Metropolitan department",name:"Lot-et-Garonne"},"FR-40":{type:"Metropolitan department",name:"Landes"},"FR-41":{type:"Metropolitan department",name:"Loir-et-Cher"},"FR-42":{type:"Metropolitan department",name:"Loire"},"FR-43":{type:"Metropolitan department",name:"Haute-Loire"},"FR-MQ":{type:"Overseas department",name:"Martinique"},"FR-GF":{type:"Overseas department",name:"Guyane"},"FR-PF":{type:"Overseas territorial collectivity",name:"Polynésie française"},"FR-PM":{type:"Overseas territorial collectivity",name:"Saint-Pierre-et-Miquelon"},"FR-GP":{type:"Overseas department",name:"Guadeloupe"},"FR-39":{type:"Metropolitan department",name:"Jura"},"FR-38":{type:"Metropolitan department",name:"Isère"},"FR-31":{type:"Metropolitan department",name:"Haute-Garonne"},"FR-30":{type:"Metropolitan department",name:"Gard"},"FR-33":{type:"Metropolitan department",name:"Gironde"},"FR-32":{type:"Metropolitan department",name:"Gers"},"FR-35":{type:"Metropolitan department",name:"Ille-et-Vilaine"},"FR-34":{type:"Metropolitan department",name:"Hérault"},"FR-37":{type:"Metropolitan department",name:"Indre-et-Loire"},"FR-36":{type:"Metropolitan department",name:"Indre"},"FR-WF":{type:"Overseas territorial collectivity",name:"Wallis-et-Futuna"}}},AW:{name:"Aruba",sub:{"AW-AW":{type:"Country",name:"Aruba"}}},SH:{name:"Saint Helena, Ascension and Tristan Da Cunha",sub:{"SH-HL":{type:"Geographical entity",name:"Saint Helena"},"SH-TA":{type:"Geographical entity",name:"Tristan da Cunha"},"SH-AC":{type:"Geographical entity",name:"Ascension"}}},SJ:{name:"Svalbard & Jan Mayen Islands",sub:{"SJ-SJ":{type:"Country",name:"Svalbard & Jan Mayen Islands"}}},FI:{name:"Finland",sub:{"FI-10":{type:"Region",name:"Lappi"},"FI-11":{type:"Region",name:"Birkaland"},"FI-12":{type:"Region",name:"Österbotten"},"FI-16":{type:"Region",name:"Päijänne-Tavastland"},"FI-17":{type:"Region",name:"Satakunda"},"FI-09":{type:"Region",name:"Kymenlaakso"},"FI-08":{type:"Region",name:"Keski-Suomi"},"FI-18":{type:"Region",name:"Nyland"},"FI-19":{type:"Region",name:"Egentliga Finland"},"FI-14":{type:"Region",name:"Norra Österbotten"},"FI-15":{type:"Region",name:"Norra Savolax"},"FI-01":{type:"Region",name:"Ahvenanmaan maakunta"},"FI-13":{type:"Region",name:"Norra Karelen"},"FI-03":{type:"Region",name:"Etelä-Pohjanmaa"},"FI-02":{type:"Region",name:"Etelä-Karjala"},"FI-05":{type:"Region",name:"Kainuu"},"FI-04":{type:"Region",name:"Etelä-Savo"},"FI-07":{type:"Region",name:"Keski-Pohjanmaa"},"FI-06":{type:"Region",name:"Egentliga Tavastland"}}},FJ:{name:"Fiji",sub:{"FJ-08":{type:"Province",name:"Nadroga and Navosa"},"FJ-09":{type:"Province",name:"Naitasiri"},"FJ-14":{type:"Province",name:"Tailevu"},"FJ-N":{type:"Division",name:"Northern"},"FJ-C":{type:"Division",name:"Central"},"FJ-01":{type:"Province",name:"Ba"},"FJ-02":{type:"Province",name:"Bua"},"FJ-03":{type:"Province",name:"Cakaudrove"},"FJ-04":{type:"Province",name:"Kadavu"},"FJ-05":{type:"Province",name:"Lau"},"FJ-06":{type:"Province",name:"Lomaiviti"},"FJ-07":{type:"Province",name:"Macuata"},"FJ-11":{type:"Province",name:"Ra"},"FJ-R":{type:"Dependency",name:"Rotuma"},"FJ-12":{type:"Province",name:"Rewa"},"FJ-13":{type:"Province",name:"Serua"},"FJ-10":{type:"Province",name:"Namosi"},"FJ-W":{type:"Division",name:"Western"},"FJ-E":{type:"Division",name:"Eastern"}}},FK:{name:"Falkland Islands",sub:{"FK-FK":{type:"Country",name:"Falkland Islands"}}},FM:{name:"Micronesia, Federated States Of",sub:{"FM-YAP":{type:"State",name:"Yap"},"FM-KSA":{type:"State",name:"Kosrae"},"FM-PNI":{type:"State",name:"Pohnpei"},"FM-TRK":{type:"State",name:"Chuuk"}}},FO:{name:"Faroe Islands",sub:{"FO-FO":{type:"Country",name:"Faroe Islands"}}},NI:{name:"Nicaragua",sub:{"NI-BO":{type:"Department",name:"Boaco"},"NI-CI":{type:"Department",name:"Chinandega"},"NI-LE":{type:"Department",name:"León"},"NI-RI":{type:"Department",name:"Rivas"},"NI-CO":{type:"Department",name:"Chontales"},"NI-MN":{type:"Department",name:"Managua"},"NI-CA":{type:"Department",name:"Carazo"},"NI-AN":{type:"Autonomous region",name:"Atlántico Norte"},"NI-ES":{type:"Department",name:"Estelí"},"NI-SJ":{type:"Department",name:"Río San Juan"},"NI-NS":{type:"Department",name:"Nueva Segovia"},"NI-AS":{type:"Autonomous region",name:"Atlántico Sur"},"NI-MT":{type:"Department",name:"Matagalpa"},"NI-MD":{type:"Department",name:"Madriz"},"NI-MS":{type:"Department",name:"Masaya"},"NI-GR":{type:"Department",name:"Granada"},"NI-JI":{type:"Department",name:"Jinotega"}}},NL:{name:"Netherlands",sub:{"NL-ZH":{type:"Province",name:"Zuid-Holland"},"NL-FR":{type:"Province",name:"Fryslân"},"NL-AW":{type:"Country",name:"Aruba"},"NL-CW":{type:"Country",name:"Curaçao"},"NL-UT":{type:"Province",name:"Utrecht"},"NL-OV":{type:"Province",name:"Overijssel"},"NL-GE":{type:"Province",name:"Gelderland"},"NL-BQ2":{type:"Special municipality",name:"Saba"},"NL-BQ3":{type:"Special municipality",name:"Sint Eustatius"},"NL-BQ1":{type:"Special municipality",name:"Bonaire"},"NL-NH":{type:"Province",name:"Noord-Holland"},"NL-ZE":{type:"Province",name:"Zeeland"},"NL-SX":{type:"Country",name:"Sint Maarten"},"NL-FL":{type:"Province",name:"Flevoland"},"NL-GR":{type:"Province",name:"Groningen"},"NL-DR":{type:"Province",name:"Drenthe"},"NL-NB":{type:"Province",name:"Noord-Brabant"},"NL-LI":{type:"Province",name:"Limburg"}}},NO:{name:"Norway",sub:{"NO-10":{type:"County",name:"Vest-Agder"},"NO-16":{type:"County",name:"Sør-Trøndelag"},"NO-19":{type:"County",name:"Romsa"},"NO-11":{type:"County",name:"Rogaland"},"NO-21":{type:"Arctic region",name:"Svalbard"},"NO-20":{type:"County",name:"Finnmark"},"NO-22":{type:"Arctic region",name:"Jan Mayen"},"NO-12":{type:"County",name:"Hordaland"},"NO-15":{type:"County",name:"Møre og Romsdal"},"NO-07":{type:"County",name:"Vestfold"},"NO-06":{type:"County",name:"Buskerud"},"NO-05":{type:"County",name:"Oppland"},"NO-04":{type:"County",name:"Hedmark"},"NO-03":{type:"County",name:"Oslo"},"NO-02":{type:"County",name:"Akershus"},"NO-01":{type:"County",name:"Østfold"},"NO-17":{type:"County",name:"Nord-Trøndelag"},"NO-18":{type:"County",name:"Nordland"},"NO-14":{type:"County",name:"Sogn og Fjordane"},"NO-09":{type:"County",name:"Aust-Agder"},"NO-08":{type:"County",name:"Telemark"}}},NA:{name:"Namibia",sub:{"NA-HA":{type:"Region",name:"Hardap"},"NA-KH":{type:"Region",name:"Khomas"},"NA-KA":{type:"Region",name:"Karas"},"NA-ON":{type:"Region",name:"Oshana"},"NA-OH":{type:"Region",name:"Omaheke"},"NA-KE":{type:"Region",name:"Kavango East"},"NA-OT":{type:"Region",name:"Oshikoto"},"NA-CA":{type:"Region",name:"Zambezi"},"NA-OW":{type:"Region",name:"Ohangwena"},"NA-ER":{type:"Region",name:"Erongo"},"NA-OS":{type:"Region",name:"Omusati"},"NA-OD":{type:"Region",name:"Otjozondjupa"},"NA-KU":{type:"Region",name:"Kunene"},"NA-KW":{type:"Region",name:"Kavango West"}}},VU:{name:"Vanuatu",sub:{"VU-PAM":{type:"Province",name:"Pénama"},"VU-TOB":{type:"Province",name:"Torba"},"VU-MAP":{type:"Province",name:"Malampa"},"VU-SAM":{type:"Province",name:"Sanma"},"VU-TAE":{type:"Province",name:"Taféa"},"VU-SEE":{type:"Province",name:"Shéfa"}}},NC:{name:"New Caledonia",sub:{"NC-NC":{type:"Country",name:"New Caledonia"}}},NE:{name:"Niger",sub:{"NE-4":{type:"Region",name:"Maradi"},"NE-5":{type:"Region",name:"Tahoua"},"NE-6":{type:"Region",name:"Tillabéri"},"NE-7":{type:"Region",name:"Zinder"},"NE-1":{type:"Region",name:"Agadez"},"NE-2":{type:"Region",name:"Diffa"},"NE-3":{type:"Region",name:"Dosso"},"NE-8":{type:"Urban community",name:"Niamey"}}},NF:{name:"Norfolk Island",sub:{"NF-NF":{type:"Country",name:"Norfolk Island"}}},NG:{name:"Nigeria",sub:{"NG-PL":{type:"State",name:"Plateau"},"NG-RI":{type:"State",name:"Rivers"},"NG-JI":{type:"State",name:"Jigawa"},"NG-LA":{type:"State",name:"Lagos"},"NG-NA":{type:"State",name:"Nasarawa"},"NG-FC":{type:"Capital territory",name:"Abuja Federal Capital Territory"},"NG-NI":{type:"State",name:"Niger"},"NG-OS":{type:"State",name:"Osun"},"NG-BY":{type:"State",name:"Bayelsa"},"NG-DE":{type:"State",name:"Delta"},"NG-BA":{type:"State",name:"Bauchi"},"NG-BE":{type:"State",name:"Benue"},"NG-BO":{type:"State",name:"Borno"},"NG-YO":{type:"State",name:"Yobe"},"NG-AN":{type:"State",name:"Anambra"},"NG-KW":{type:"State",name:"Kwara"},"NG-KT":{type:"State",name:"Katsina"},"NG-OY":{type:"State",name:"Oyo"},"NG-OG":{type:"State",name:"Ogun"},"NG-KN":{type:"State",name:"Kano"},"NG-KO":{type:"State",name:"Kogi"},"NG-ON":{type:"State",name:"Ondo"},"NG-EN":{type:"State",name:"Enugu"},"NG-KD":{type:"State",name:"Kaduna"},"NG-KE":{type:"State",name:"Kebbi"},"NG-CR":{type:"State",name:"Cross River"},"NG-GO":{type:"State",name:"Gombe"},"NG-ZA":{type:"State",name:"Zamfara"},"NG-SO":{type:"State",name:"Sokoto"},"NG-IM":{type:"State",name:"Imo"},"NG-ED":{type:"State",name:"Edo"},"NG-AK":{type:"State",name:"Akwa Ibom"},"NG-EB":{type:"State",name:"Ebonyi"},"NG-TA":{type:"State",name:"Taraba"},"NG-AB":{type:"State",name:"Abia"},"NG-AD":{type:"State",name:"Adamawa"},"NG-EK":{type:"State",name:"Ekiti"}}},NZ:{name:"New Zealand",sub:{"NZ-NSN":{type:"Unitary authority",name:"Nelson City"},"NZ-S":{type:"Island",name:"South Island"},"NZ-STL":{type:"Regional council",name:"Southland"},"NZ-BOP":{type:"Regional council",name:"Bay of Plenty"},"NZ-HKB":{type:"Regional council",name:"Hawke's Bay"},"NZ-AUK":{type:"Unitary authority",name:"Auckland"},"NZ-TKI":{type:"Regional council",name:"Taranaki"},"NZ-MBH":{type:"Unitary authority",name:"Marlborough District"},"NZ-CIT":{type:"Special island authority",name:"Chatham Islands Territory"},"NZ-WKO":{type:"Regional council",name:"Waikato"},"NZ-TAS":{type:"Unitary authority",name:"Tasman District"},"NZ-WGN":{type:"Regional council",name:"Wellington"},"NZ-WTC":{type:"Regional council",name:"West Coast"},"NZ-OTA":{type:"Regional council",name:"Otago"},"NZ-NTL":{type:"Regional council",name:"Northland"},"NZ-MWT":{type:"Regional council",name:"Manawatu-Wanganui"},"NZ-N":{type:"Island",name:"North Island"},"NZ-GIS":{type:"Unitary authority",name:"Gisborne District"},"NZ-CAN":{type:"Regional council",name:"Canterbury"}}},NP:{name:"Nepal",sub:{"NP-KA":{type:"Zone",name:"Karnali"},"NP-BA":{type:"Zone",name:"Bagmati"},"NP-MA":{type:"Zone",name:"Mahakali"},"NP-KO":{type:"Zone",name:"Kosi"},"NP-DH":{type:"Zone",name:"Dhawalagiri"},"NP-BH":{type:"Zone",name:"Bheri"},"NP-JA":{type:"Zone",name:"Janakpur"},"NP-GA":{type:"Zone",name:"Gandaki"},"NP-NA":{type:"Zone",name:"Narayani"},"NP-ME":{type:"Zone",name:"Mechi"},"NP-RA":{type:"Zone",name:"Rapti"},"NP-5":{type:"Development region",name:"Far Western"},"NP-4":{type:"Development region",name:"Eastern"},"NP-SE":{type:"Zone",name:"Seti"},"NP-LU":{type:"Zone",name:"Lumbini"},"NP-1":{type:"Development region",name:"Central"},"NP-SA":{type:"Zone",name:"Sagarmatha"},"NP-3":{type:"Development region",name:"Pashchimanchal"},"NP-2":{type:"Development region",name:"Madhya Pashchimanchal"}}},NR:{name:"Nauru",sub:{"NR-08":{type:"District",name:"Denigomodu"},"NR-09":{type:"District",name:"Ewa"},"NR-14":{type:"District",name:"Yaren"},"NR-01":{type:"District",name:"Aiwo"},"NR-02":{type:"District",name:"Anabar"},"NR-03":{type:"District",name:"Anetan"},"NR-04":{type:"District",name:"Anibare"},"NR-05":{type:"District",name:"Baiti"},"NR-06":{type:"District",name:"Boe"},"NR-07":{type:"District",name:"Buada"},"NR-11":{type:"District",name:"Meneng"},"NR-12":{type:"District",name:"Nibok"},"NR-13":{type:"District",name:"Uaboe"},"NR-10":{type:"District",name:"Ijuw"}}},NU:{name:"Niue",sub:{"NU-NU":{type:"Country",name:"Niue"}}},CK:{name:"Cook Islands",sub:{"CK-CK":{type:"Country",name:"Cook Islands"}}},CI:{name:"Côte D'Ivoire",sub:{"CI-11":{type:"Region",name:"Nzi-Comoé"},"CI-13":{type:"Region",name:"Sud-Comoé"},"CI-16":{type:"Region",name:"Agnébi"},"CI-14":{type:"Region",name:"Worodougou"},"CI-10":{type:"Region",name:"Denguélé"},"CI-15":{type:"Region",name:"Sud-Bandama"},"CI-17":{type:"Region",name:"Bafing"},"CI-01":{type:"Region",name:"Lagunes"},"CI-02":{type:"Region",name:"Haut-Sassandra"},"CI-03":{type:"Region",name:"Savanes"},"CI-04":{type:"Region",name:"Vallée du Bandama"},"CI-05":{type:"Region",name:"Moyen-Comoé"},"CI-06":{type:"Region",name:"18 Montagnes"},"CI-07":{type:"Region",name:"Lacs"},"CI-08":{type:"Region",name:"Zanzan"},"CI-09":{type:"Region",name:"Bas-Sassandra"},"CI-18":{type:"Region",name:"Fromager"},"CI-19":{type:"Region",name:"Moyen-Cavally"},"CI-12":{type:"Region",name:"Marahoué"}}},CH:{name:"Switzerland",sub:{"CH-SO":{type:"Canton",name:"Solothurn"},"CH-LU":{type:"Canton",name:"Luzern"},"CH-SH":{type:"Canton",name:"Schaffhausen"},"CH-SG":{type:"Canton",name:"Sankt Gallen"},"CH-UR":{type:"Canton",name:"Uri"},"CH-NE":{type:"Canton",name:"Neuchâtel"},"CH-BS":{type:"Canton",name:"Basel-Stadt"},"CH-JU":{type:"Canton",name:"Jura"},"CH-BL":{type:"Canton",name:"Basel-Landschaft"},"CH-SZ":{type:"Canton",name:"Schwyz"},"CH-BE":{type:"Canton",name:"Bern"},"CH-NW":{type:"Canton",name:"Nidwalden"},"CH-ZG":{type:"Canton",name:"Zug"},"CH-FR":{type:"Canton",name:"Freiburg"},"CH-ZH":{type:"Canton",name:"Zürich"},"CH-VS":{type:"Canton",name:"Valais"},"CH-VD":{type:"Canton",name:"Vaud"},"CH-TI":{type:"Canton",name:"Ticino"},"CH-TG":{type:"Canton",name:"Thurgau"},"CH-OW":{type:"Canton",name:"Obwalden"},"CH-AG":{type:"Canton",name:"Aargau"},"CH-GE":{type:"Canton",name:"Genève"},"CH-AI":{type:"Canton",name:"Appenzell Innerrhoden"},"CH-GL":{type:"Canton",name:"Glarus"},"CH-GR":{type:"Canton",name:"Graubünden"},"CH-AR":{type:"Canton",name:"Appenzell Ausserrhoden"}}},CO:{name:"Colombia",sub:{"CO-CUN":{type:"Department",name:"Cundinamarca"},"CO-BOY":{type:"Department",name:"Boyacá"},"CO-COR":{type:"Department",name:"Córdoba"},"CO-HUI":{type:"Department",name:"Huila"},"CO-VAU":{type:"Department",name:"Vaupés"},"CO-RIS":{type:"Department",name:"Risaralda"},"CO-NSA":{type:"Department",name:"Norte de Santander"},"CO-VID":{type:"Department",name:"Vichada"},"CO-BOL":{type:"Department",name:"Bolívar"},"CO-VAC":{type:"Department",name:"Valle del Cauca"},"CO-GUV":{type:"Department",name:"Guaviare"},"CO-CAU":{type:"Department",name:"Cauca"},"CO-CAS":{type:"Department",name:"Casanare"},"CO-CAQ":{type:"Department",name:"Caquetá"},"CO-CES":{type:"Department",name:"Cesar"},"CO-SAN":{type:"Department",name:"Santander"},"CO-ATL":{type:"Department",name:"Atlántico"},"CO-AMA":{type:"Department",name:"Amazonas"},"CO-MET":{type:"Department",name:"Meta"},"CO-MAG":{type:"Department",name:"Magdalena"},"CO-ARA":{type:"Department",name:"Arauca"},"CO-GUA":{type:"Department",name:"Guainía"},"CO-LAG":{type:"Department",name:"La Guajira"},"CO-CAL":{type:"Department",name:"Caldas"},"CO-QUI":{type:"Department",name:"Quindío"},"CO-SAP":{type:"Department",name:"San Andrés, Providencia y Santa Catalina"},"CO-TOL":{type:"Department",name:"Tolima"},"CO-SUC":{type:"Department",name:"Sucre"},"CO-PUT":{type:"Department",name:"Putumayo"},"CO-NAR":{type:"Department",name:"Nariño"},"CO-CHO":{type:"Department",name:"Chocó"},"CO-DC":{type:"Capital district",name:"Distrito Capital de Bogotá"},"CO-ANT":{type:"Department",name:"Antioquia"}}},CN:{name:"China",sub:{"CN-54":{type:"Autonomous region",name:"Xizang"},"CN-34":{type:"Province",name:"Anhui"},"CN-35":{type:"Province",name:"Fujian"},"CN-36":{type:"Province",name:"Jiangxi"},"CN-37":{type:"Province",name:"Shandong"},"CN-31":{type:"Municipality",name:"Shanghai"},"CN-32":{type:"Province",name:"Jiangsu"},"CN-33":{type:"Province",name:"Zhejiang"},"CN-71":{type:"Province",name:"Taiwan"},"CN-91":{type:"Special administrative region",name:"Hong Kong"},"CN-14":{type:"Province",name:"Shanxi"},"CN-15":{type:"Autonomous region",name:"Nei Mongol"},"CN-12":{type:"Municipality",name:"Tianjin"},"CN-13":{type:"Province",name:"Hebei"},"CN-11":{type:"Municipality",name:"Beijing"},"CN-52":{type:"Province",name:"Guizhou"},"CN-92":{type:"Special administrative region",name:"Aomen"},"CN-53":{type:"Province",name:"Yunnan"},"CN-50":{type:"Municipality",name:"Chongqing"},"CN-51":{type:"Province",name:"Sichuan"},"CN-41":{type:"Province",name:"Henan"},"CN-43":{type:"Province",name:"Hunan"},"CN-42":{type:"Province",name:"Hubei"},"CN-45":{type:"Autonomous region",name:"Guangxi"},"CN-44":{type:"Province",name:"Guangdong"},"CN-46":{type:"Province",name:"Hainan"},"CN-65":{type:"Autonomous region",name:"Xinjiang"},"CN-64":{type:"Autonomous region",name:"Ningxia"},"CN-63":{type:"Province",name:"Qinghai"},"CN-62":{type:"Province",name:"Gansu"},"CN-61":{type:"Province",name:"Shaanxi"},"CN-23":{type:"Province",name:"Heilongjiang"},"CN-22":{type:"Province",name:"Jilin"},"CN-21":{type:"Province",name:"Liaoning"}}},CM:{name:"Cameroon",sub:{"CM-CE":{type:"Region",name:"Centre"},"CM-SU":{type:"Region",name:"South"},"CM-SW":{type:"Region",name:"South-West"},"CM-ES":{type:"Region",name:"East"},"CM-AD":{type:"Region",name:"Adamaoua"},"CM-NO":{type:"Region",name:"Nord"},"CM-OU":{type:"Region",name:"Ouest"},"CM-NW":{type:"Region",name:"Nord-Ouest"},"CM-EN":{type:"Region",name:"Extrême-Nord"},"CM-LT":{type:"Region",name:"Littoral"}}},CL:{name:"Chile",sub:{"CL-AP":{type:"Region",name:"Arica y Parinacota"},"CL-BI":{type:"Region",name:"Biobío"},"CL-AR":{type:"Region",name:"Araucanía"},"CL-AT":{type:"Region",name:"Atacama"},"CL-CO":{type:"Region",name:"Coquimbo"},"CL-VS":{type:"Region",name:"Valparaíso"},"CL-ML":{type:"Region",name:"Maule"},"CL-LR":{type:"Region",name:"Los Ríos"},"CL-TA":{type:"Region",name:"Tarapacá"},"CL-LI":{type:"Region",name:"Libertador General Bernardo O'Higgins"},"CL-RM":{type:"Region",name:"Región Metropolitana de Santiago"},"CL-LL":{type:"Region",name:"Los Lagos"},"CL-AI":{type:"Region",name:"Aysén"},"CL-AN":{type:"Region",name:"Antofagasta"},"CL-MA":{type:"Region",name:"Magallanes"}}},CC:{name:"Cocos  Islands",sub:{"CC-CC":{type:"Country",name:"Cocos  Islands"}}},CA:{name:"Canada",sub:{"CA-NT":{type:"Territory",name:"Northwest Territories"},"CA-NU":{type:"Territory",name:"Nunavut"},"CA-NS":{type:"Province",name:"Nova Scotia"},"CA-MB":{type:"Province",name:"Manitoba"},"CA-SK":{type:"Province",name:"Saskatchewan"},"CA-QC":{type:"Province",name:"Quebec"},"CA-PE":{type:"Province",name:"Prince Edward Island"},"CA-BC":{type:"Province",name:"British Columbia"},"CA-YT":{type:"Territory",name:"Yukon"},"CA-NB":{type:"Province",name:"New Brunswick"},"CA-NL":{type:"Province",name:"Newfoundland and Labrador"},"CA-ON":{type:"Province",name:"Ontario"},"CA-AB":{type:"Province",name:"Alberta"}}},CG:{name:"Congo",sub:{"CG-2":{type:"Department",name:"Lékoumou"},"CG-5":{type:"Department",name:"Kouilou"},"CG-7":{type:"Department",name:"Likouala"},"CG-9":{type:"Department",name:"Niari"},"CG-8":{type:"Department",name:"Cuvette"},"CG-BZV":{type:"Department",name:"Brazzaville"},"CG-11":{type:"Department",name:"Bouenza"},"CG-13":{type:"Department",name:"Sangha"},"CG-12":{type:"Department",name:"Pool"},"CG-15":{type:"Department",name:"Cuvette-Ouest"},"CG-14":{type:"Department",name:"Plateaux"},"CG-16":{type:"Department",name:"Pointe-Noire"}}},CF:{name:"Central African Republic",sub:{"CF-MB":{type:"Prefecture",name:"Mbomou"},"CF-BB":{type:"Prefecture",name:"Bamïngï-Bangoran"},"CF-NM":{type:"Prefecture",name:"Nana-Mambéré"},"CF-BGF":{type:"Commune",name:"Bangî"},"CF-AC":{type:"Prefecture",name:"Ouham"},"CF-KB":{type:"Economic prefecture",name:"Gïrïbïngï"},"CF-BK":{type:"Prefecture",name:"Basse-Kotto"},"CF-LB":{type:"Prefecture",name:"Lobaye"},"CF-VK":{type:"Prefecture",name:"Vakaga"},"CF-HS":{type:"Prefecture",name:"Haute-Sangha / Mambéré-Kadéï"},"CF-HM":{type:"Prefecture",name:"Haut-Mbomou"},"CF-UK":{type:"Prefecture",name:"Ouaka"},"CF-MP":{type:"Prefecture",name:"Ömbëlä-Pökö"},"CF-KG":{type:"Prefecture",name:"Kemö-Gïrïbïngï"},"CF-HK":{type:"Prefecture",name:"Haute-Kotto"},"CF-OP":{type:"Prefecture",name:"Ouham-Pendé"},"CF-SE":{type:"Economic prefecture",name:"Sangä"}}},CD:{name:"Congo, The Democratic Republic Of The",sub:{"CD-OR":{type:"Province",name:"Orientale"},"CD-EQ":{type:"Province",name:"Équateur"},"CD-SK":{type:"Province",name:"Sud-Kivu"},"CD-KW":{type:"Province",name:"Kasai-Occidental"},"CD-BN":{type:"Province",name:"Bandundu"},"CD-BC":{type:"Province",name:"Bas-Congo"},"CD-KN":{type:"City",name:"Kinshasa"},"CD-KA":{type:"Province",name:"Katanga"},"CD-MA":{type:"Province",name:"Maniema"},"CD-NK":{type:"Province",name:"Nord-Kivu"},"CD-KE":{type:"Province",name:"Kasai-Oriental"}}},CZ:{name:"Czech Republic",sub:{"CZ-10C":{type:"District",name:"Praha 12"},"CZ-10B":{type:"District",name:"Praha 11"},"CZ-10A":{type:"District",name:"Praha 10"},"CZ-10F":{type:"District",name:"Praha 15"},"CZ-10E":{type:"District",name:"Praha 14"},"CZ-10D":{type:"District",name:"Praha 13"},"CZ-511":{type:"District",name:"Česká Lípa"},"CZ-512":{type:"District",name:"Jablonec nad Nisou"},"CZ-513":{type:"District",name:"Liberec"},"CZ-514":{type:"District",name:"Semily"},"CZ-JC":{type:"Region",name:"Jihočeský kraj"},"CZ-JM":{type:"Region",name:"Jihomoravský kraj"},"CZ-103":{type:"District",name:"Praha 3"},"CZ-102":{type:"District",name:"Praha 2"},"CZ-101":{type:"District",name:"Praha 1"},"CZ-107":{type:"District",name:"Praha 7"},"CZ-106":{type:"District",name:"Praha 6"},"CZ-105":{type:"District",name:"Praha 5"},"CZ-104":{type:"District",name:"Praha 4"},"CZ-613":{type:"District",name:"Pelhřimov"},"CZ-612":{type:"District",name:"Jihlava"},"CZ-611":{type:"District",name:"Havlíčkův Brod"},"CZ-108":{type:"District",name:"Praha 8"},"CZ-615":{type:"District",name:"Žd'ár nad Sázavou"},"CZ-614":{type:"District",name:"Třebíč"},"CZ-LI":{type:"Region",name:"Liberecký kraj"},"CZ-US":{type:"Region",name:"Ústecký kraj"},"CZ-714":{type:"District",name:"Přerov"},"CZ-715":{type:"District",name:"Šumperk"},"CZ-712":{type:"District",name:"Olomouc"},"CZ-713":{type:"District",name:"Prostĕjov"},"CZ-711":{type:"District",name:"Jeseník"},"CZ-ST":{type:"Region",name:"Středočeský kraj"},"CZ-109":{type:"District",name:"Praha 9"},"CZ-KA":{type:"Region",name:"Karlovarský kraj"},"CZ-ZL":{type:"Region",name:"Zlínský kraj"},"CZ-KR":{type:"Region",name:"Královéhradecký kraj"},"CZ-802":{type:"District",name:"Frýdek Místek"},"CZ-803":{type:"District",name:"Karviná"},"CZ-801":{type:"District",name:"Bruntál"},"CZ-806":{type:"District",name:"Ostrava město"},"CZ-804":{type:"District",name:"Nový Jičín"},"CZ-805":{type:"District",name:"Opava"},"CZ-411":{type:"District",name:"Cheb"},"CZ-413":{type:"District",name:"Sokolov"},"CZ-412":{type:"District",name:"Karlovy Vary"},"CZ-312":{type:"District",name:"Český Krumlov"},"CZ-313":{type:"District",name:"Jindřichův Hradec"},"CZ-311":{type:"District",name:"České Budějovice"},"CZ-316":{type:"District",name:"Strakonice"},"CZ-317":{type:"District",name:"Tábor"},"CZ-314":{type:"District",name:"Písek"},"CZ-315":{type:"District",name:"Prachatice"},"CZ-534":{type:"District",name:"Ústí nad Orlicí"},"CZ-724":{type:"District",name:"Zlín"},"CZ-532":{type:"District",name:"Pardubice"},"CZ-422":{type:"District",name:"Chomutov"},"CZ-423":{type:"District",name:"Litoměřice"},"CZ-424":{type:"District",name:"Louny"},"CZ-425":{type:"District",name:"Most"},"CZ-426":{type:"District",name:"Teplice"},"CZ-722":{type:"District",name:"Uherské Hradištĕ"},"CZ-PL":{type:"Region",name:"Plzeňský kraj"},"CZ-MO":{type:"Region",name:"Moravskoslezský kraj"},"CZ-VY":{type:"Region",name:"Vysočina"},"CZ-PA":{type:"Region",name:"Pardubický kraj"},"CZ-20A":{type:"District",name:"Praha-západ"},"CZ-20B":{type:"District",name:"Příbram"},"CZ-20C":{type:"District",name:"Rakovník"},"CZ-723":{type:"District",name:"Vsetín"},"CZ-533":{type:"District",name:"Svitavy"},"CZ-721":{type:"District",name:"Kromĕříž"},"CZ-531":{type:"District",name:"Chrudim"},"CZ-PR":{type:"Region",name:"Praha, hlavní mešto"},"CZ-622":{type:"District",name:"Brno-město"},"CZ-623":{type:"District",name:"Brno-venkov"},"CZ-621":{type:"District",name:"Blansko"},"CZ-626":{type:"District",name:"Vyškov"},"CZ-627":{type:"District",name:"Znojmo"},"CZ-624":{type:"District",name:"Břeclav"},"CZ-625":{type:"District",name:"Hodonín"},"CZ-421":{type:"District",name:"Děčín"},"CZ-525":{type:"District",name:"Trutnov"},"CZ-524":{type:"District",name:"Rychnov nad Kněžnou"},"CZ-521":{type:"District",name:"Hradec Králové"},"CZ-523":{type:"District",name:"Náchod"},"CZ-522":{type:"District",name:"Jičín"},"CZ-OL":{type:"Region",name:"Olomoucký kraj"},"CZ-427":{type:"District",name:"Ústí nad Labem"},"CZ-323":{type:"District",name:"Plzeň-město"},"CZ-322":{type:"District",name:"Klatovy"},"CZ-321":{type:"District",name:"Domažlice"},"CZ-327":{type:"District",name:"Tachov"},"CZ-326":{type:"District",name:"Rokycany"},"CZ-325":{type:"District",name:"Plzeň-sever"},"CZ-324":{type:"District",name:"Plzeň-jih"},"CZ-208":{type:"District",name:"Nymburk"},"CZ-209":{type:"District",name:"Praha-východ"},"CZ-201":{type:"District",name:"Benešov"},"CZ-202":{type:"District",name:"Beroun"},"CZ-203":{type:"District",name:"Kladno"},"CZ-204":{type:"District",name:"Kolín"},"CZ-205":{type:"District",name:"Kutná Hora"},"CZ-206":{type:"District",name:"Mělník"},"CZ-207":{type:"District",name:"Mladá Boleslav"}}},CY:{name:"Cyprus",sub:{"CY-01":{type:"District",name:"Lefkoşa"},"CY-02":{type:"District",name:"Lemesos"},"CY-03":{type:"District",name:"Larnaka"},"CY-04":{type:"District",name:"Ammochostos"},"CY-05":{type:"District",name:"Baf"},"CY-06":{type:"District",name:"Girne"}}},CX:{name:"Christmas Island",sub:{"CX-CX":{type:"Country",name:"Christmas Island"}}},CR:{name:"Costa Rica",sub:{"CR-P":{type:"Province",name:"Puntarenas"},"CR-A":{type:"Province",name:"Alajuela"},"CR-C":{type:"Province",name:"Cartago"},"CR-G":{type:"Province",name:"Guanacaste"},"CR-H":{type:"Province",name:"Heredia"},"CR-SJ":{type:"Province",name:"San José"},"CR-L":{type:"Province",name:"Limón"}}},CW:{name:"Curaçao",sub:{"CW-CW":{type:"Country",name:"Curaçao"}}},CV:{name:"Cape Verde",sub:{"CV-SL":{type:"Municipality",name:"Sal"},"CV-SM":{type:"Municipality",name:"São Miguel"},"CV-SO":{type:"Municipality",name:"São Lourenço dos Órgãos"},"CV-S":{type:"Geographical region",name:"Ilhas de Sotavento"},"CV-SD":{type:"Municipality",name:"São Domingos"},"CV-SF":{type:"Municipality",name:"São Filipe"},"CV-B":{type:"Geographical region",name:"Ilhas de Barlavento"},"CV-RG":{type:"Municipality",name:"Ribeira Grande"},"CV-SV":{type:"Municipality",name:"São Vicente"},"CV-SS":{type:"Municipality",name:"São Salvador do Mundo"},"CV-CR":{type:"Municipality",name:"Santa Cruz"},"CV-CF":{type:"Municipality",name:"Santa Catarina do Fogo"},"CV-CA":{type:"Municipality",name:"Santa Catarina"},"CV-RB":{type:"Municipality",name:"Ribeira Brava"},"CV-PA":{type:"Municipality",name:"Paul"},"CV-TA":{type:"Municipality",name:"Tarrafal"},"CV-PN":{type:"Municipality",name:"Porto Novo"},"CV-RS":{type:"Municipality",name:"Ribeira Grande de Santiago"},"CV-MA":{type:"Municipality",name:"Maio"},"CV-PR":{type:"Municipality",name:"Praia"},"CV-TS":{type:"Municipality",name:"Tarrafal de São Nicolau"},"CV-MO":{type:"Municipality",name:"Mosteiros"},"CV-BR":{type:"Municipality",name:"Brava"},"CV-BV":{type:"Municipality",name:"Boa Vista"}}},CU:{name:"Cuba",sub:{"CU-04":{type:"Province",name:"Matanzas"},"CU-05":{type:"Province",name:"Villa Clara"},"CU-06":{type:"Province",name:"Cienfuegos"},"CU-07":{type:"Province",name:"Sancti Spíritus"},"CU-01":{type:"Province",name:"Pinar del Río"},"CU-03":{type:"Province",name:"La Habana"},"CU-99":{type:"Special municipality",name:"Isla de la Juventud"},"CU-08":{type:"Province",name:"Ciego de Ávila"},"CU-09":{type:"Province",name:"Camagüey"},"CU-13":{type:"Province",name:"Santiago de Cuba"},"CU-12":{type:"Province",name:"Granma"},"CU-11":{type:"Province",name:"Holguín"},"CU-10":{type:"Province",name:"Las Tunas"},"CU-16":{type:"Province",name:"Mayabeque"},"CU-15":{type:"Province",name:"Artemisa"},"CU-14":{type:"Province",name:"Guantánamo"}}},SZ:{name:"Swaziland",sub:{"SZ-LU":{type:"District",name:"Lubombo"},"SZ-HH":{type:"District",name:"Hhohho"},"SZ-SH":{type:"District",name:"Shiselweni"},"SZ-MA":{type:"District",name:"Manzini"}}},SY:{name:"Syria",sub:{"SY-HI":{type:"Province",name:"Ḩimş"},"SY-HL":{type:"Province",name:"Ḩalab"},"SY-DI":{type:"Province",name:"Dimashq"},"SY-HA":{type:"Province",name:"Al Ḩasakah"},"SY-ID":{type:"Province",name:"Idlib"},"SY-SU":{type:"Province",name:"As Suwaydā'"},"SY-TA":{type:"Province",name:"Ţarţūs"},"SY-QU":{type:"Province",name:"Al Qunayţirah"},"SY-DY":{type:"Province",name:"Dayr az Zawr"},"SY-RA":{type:"Province",name:"Ar Raqqah"},"SY-LA":{type:"Province",name:"Al Lādhiqīyah"},"SY-RD":{type:"Province",name:"Rīf Dimashq"},"SY-DR":{type:"Province",name:"Dar'ā"},"SY-HM":{type:"Province",name:"Ḩamāh"}}},SX:{name:"St. Maarten",sub:{"SX-SX":{type:"Country",name:"St. Maarten"}}},KG:{name:"Kyrgyzstan",sub:{"KG-Y":{type:"Region",name:"Issyk-Kul'skaja oblast'"},"KG-GO":{type:"City",name:"Gorod Oš"},"KG-GB":{type:"City",name:"Bishkek"},"KG-T":{type:"Region",name:"Talas"},"KG-J":{type:"Region",name:"Džalal-Abadskaja oblast'"},"KG-O":{type:"Region",name:"Osh"},"KG-N":{type:"Region",name:"Naryn"},"KG-C":{type:"Region",name:"Chü"},"KG-B":{type:"Region",name:"Batken"}}},KE:{name:"Kenya",sub:{"KE-32":{type:"County",name:"Nandi"},"KE-38":{type:"County",name:"Siaya"},"KE-40":{type:"County",name:"Tana River"},"KE-41":{type:"County",name:"Tharaka-Nithi"},"KE-42":{type:"County",name:"Trans Nzoia"},"KE-43":{type:"County",name:"Turkana"},"KE-44":{type:"County",name:"Uasin Gishu"},"KE-28":{type:"County",name:"Mombasa"},"KE-46":{type:"County",name:"Wajir"},"KE-47":{type:"County",name:"West Pokot"},"KE-29":{type:"County",name:"Murang'a"},"KE-26":{type:"County",name:"Meru"},"KE-27":{type:"County",name:"Migori"},"KE-24":{type:"County",name:"Mandera"},"KE-25":{type:"County",name:"Marsabit"},"KE-08":{type:"County",name:"Homa Bay"
		},"KE-09":{type:"County",name:"Isiolo"},"KE-20":{type:"County",name:"Laikipia"},"KE-21":{type:"County",name:"Lamu"},"KE-04":{type:"County",name:"Busia"},"KE-05":{type:"County",name:"Elgeyo/Marakwet"},"KE-06":{type:"County",name:"Embu"},"KE-07":{type:"County",name:"Garissa"},"KE-01":{type:"County",name:"Baringo"},"KE-02":{type:"County",name:"Bomet"},"KE-03":{type:"County",name:"Bungoma"},"KE-31":{type:"County",name:"Nakuru"},"KE-35":{type:"County",name:"Nyandarua"},"KE-34":{type:"County",name:"Nyamira"},"KE-37":{type:"County",name:"Samburu"},"KE-30":{type:"County",name:"Nairobi City"},"KE-36":{type:"County",name:"Nyeri"},"KE-22":{type:"County",name:"Machakos"},"KE-23":{type:"County",name:"Makueni"},"KE-13":{type:"County",name:"Kiambu"},"KE-12":{type:"County",name:"Kericho"},"KE-11":{type:"County",name:"Kakamega"},"KE-10":{type:"County",name:"Kajiado"},"KE-17":{type:"County",name:"Kisumu"},"KE-16":{type:"County",name:"Kisii"},"KE-15":{type:"County",name:"Kirinyaga"},"KE-14":{type:"County",name:"Kilifi"},"KE-19":{type:"County",name:"Kwale"},"KE-18":{type:"County",name:"Kitui"},"KE-39":{type:"County",name:"Taita/Taveta"},"KE-33":{type:"County",name:"Narok"},"KE-45":{type:"County",name:"Vihiga"}}},SS:{name:"South Sudan",sub:{"SS-BW":{type:"State",name:"Western Bahr el Ghazal"},"SS-EW":{type:"State",name:"Western Equatoria"},"SS-LK":{type:"State",name:"Lakes"},"SS-EC":{type:"State",name:"Central Equatoria"},"SS-EE":{type:"State",name:"Eastern Equatoria"},"SS-NU":{type:"State",name:"Upper Nile"},"SS-UY":{type:"State",name:"Unity"},"SS-BN":{type:"State",name:"Northern Bahr el Ghazal"},"SS-JG":{type:"State",name:"Jonglei"},"SS-WR":{type:"State",name:"Warrap"}}},SR:{name:"Suriname",sub:{"SR-SA":{type:"District",name:"Saramacca"},"SR-CR":{type:"District",name:"Coronie"},"SR-BR":{type:"District",name:"Brokopondo"},"SR-SI":{type:"District",name:"Sipaliwini"},"SR-PR":{type:"District",name:"Para"},"SR-WA":{type:"District",name:"Wanica"},"SR-NI":{type:"District",name:"Nickerie"},"SR-PM":{type:"District",name:"Paramaribo"},"SR-CM":{type:"District",name:"Commewijne"},"SR-MA":{type:"District",name:"Marowijne"}}},KI:{name:"Kiribati",sub:{"KI-P":{type:"Group of islands",name:"Phoenix Islands"},"KI-G":{type:"Group of islands",name:"Gilbert Islands"},"KI-L":{type:"Group of islands",name:"Line Islands"}}},KH:{name:"Cambodia",sub:{"KH-24":{type:"Autonomous municipality",name:"Krŏng Pailĭn"},"KH-21":{type:"Province",name:"Taakaev"},"KH-20":{type:"Province",name:"Svaay Rieng"},"KH-23":{type:"Autonomous municipality",name:"Krong Kaeb"},"KH-22":{type:"Province",name:"Ŏtdâr Méanchey"},"KH-6":{type:"Province",name:"Kâmpóng Thum"},"KH-7":{type:"Province",name:"Kampot"},"KH-4":{type:"Province",name:"Kampong Chhnang"},"KH-5":{type:"Province",name:"Kâmpóng Spœ"},"KH-2":{type:"Province",name:"Baat Dambang"},"KH-3":{type:"Province",name:"Kampong Chaam"},"KH-1":{type:"Province",name:"Bântéay Méanchey"},"KH-8":{type:"Province",name:"Kandaal"},"KH-9":{type:"Province",name:"Kaoh Kong"},"KH-18":{type:"Autonomous municipality",name:"Krŏng Preăh Sihanouk"},"KH-19":{type:"Province",name:"Stoĕng Trêng"},"KH-14":{type:"Province",name:"Prey Veaeng"},"KH-15":{type:"Province",name:"Pousaat"},"KH-16":{type:"Province",name:"Rotanak Kiri"},"KH-17":{type:"Province",name:"Siem Reab"},"KH-10":{type:"Province",name:"Krâchéh"},"KH-11":{type:"Province",name:"Môndól Kiri"},"KH-12":{type:"Autonomous municipality",name:"Phnom Penh"},"KH-13":{type:"Province",name:"Preăh Vihéar"}}},SV:{name:"El Salvador",sub:{"SV-CH":{type:"Department",name:"Chalatenango"},"SV-LI":{type:"Department",name:"La Libertad"},"SV-US":{type:"Department",name:"Usulután"},"SV-SV":{type:"Department",name:"San Vicente"},"SV-CA":{type:"Department",name:"Cabañas"},"SV-AH":{type:"Department",name:"Ahuachapán"},"SV-MO":{type:"Department",name:"Morazán"},"SV-SM":{type:"Department",name:"San Miguel"},"SV-SO":{type:"Department",name:"Sonsonate"},"SV-PA":{type:"Department",name:"La Paz"},"SV-UN":{type:"Department",name:"La Unión"},"SV-CU":{type:"Department",name:"Cuscatlán"},"SV-SS":{type:"Department",name:"San Salvador"},"SV-SA":{type:"Department",name:"Santa Ana"}}},KM:{name:"Comoros",sub:{"KM-G":{type:"Island",name:"Andjazîdja"},"KM-M":{type:"Island",name:"Mohéli"},"KM-A":{type:"Island",name:"Andjouân"}}},ST:{name:"Sao Tome and Principe",sub:{"ST-S":{type:"Province",name:"São Tomé"},"ST-P":{type:"Province",name:"Príncipe"}}},SK:{name:"Slovakia",sub:{"SK-PV":{type:"Region",name:"Prešovský kraj"},"SK-KI":{type:"Region",name:"Košický kraj"},"SK-TC":{type:"Region",name:"Trenčiansky kraj"},"SK-TA":{type:"Region",name:"Trnavský kraj"},"SK-ZI":{type:"Region",name:"Žilinský kraj"},"SK-BL":{type:"Region",name:"Bratislavský kraj"},"SK-NI":{type:"Region",name:"Nitriansky kraj"},"SK-BC":{type:"Region",name:"Banskobystrický kraj"}}},KR:{name:"Korea, Republic of",sub:{"KR-31":{type:"Metropolitan city",name:"Ulsan Gwang'yeogsi"},"KR-49":{type:"Special self-governing province",name:"Cheju-do"},"KR-48":{type:"Province",name:"Gyeongsangnamdo"},"KR-45":{type:"Province",name:"Chǒllabuk-do"},"KR-44":{type:"Province",name:"Ch'ungch'ǒngnam-do"},"KR-47":{type:"Province",name:"Gyeongsangbugdo"},"KR-46":{type:"Province",name:"Chǒllanam-do"},"KR-41":{type:"Province",name:"Gyeonggido"},"KR-43":{type:"Province",name:"Ch'ungch'ǒngbuk-do"},"KR-42":{type:"Province",name:"Gang'weondo"},"KR-30":{type:"Metropolitan city",name:"Daejeon Gwang'yeogsi"},"KR-11":{type:"Special city",name:"Seoul-T'ǔkpyǒlshi"},"KR-50":{type:"Special self-governing city",name:"Sejong"},"KR-29":{type:"Metropolitan city",name:"Gwangju Gwang'yeogsi"},"KR-28":{type:"Metropolitan city",name:"Inch'ǒn-Kwangyǒkshi"},"KR-27":{type:"Metropolitan city",name:"Daegu Gwang'yeogsi"},"KR-26":{type:"Metropolitan city",name:"Busan Gwang'yeogsi"}}},SI:{name:"Slovenia",sub:{"SI-056":{type:"Commune",name:"Kuzma"},"SI-057":{type:"Commune",name:"Laško"},"SI-054":{type:"Commune",name:"Krško"},"SI-055":{type:"Commune",name:"Kungota"},"SI-052":{type:"Commune",name:"Kranj"},"SI-053":{type:"Commune",name:"Kranjska Gora"},"SI-050":{type:"Commune",name:"Koper"},"SI-051":{type:"Commune",name:"Kozje"},"SI-117":{type:"Commune",name:"Šenčur"},"SI-116":{type:"Commune",name:"Sveti Jurij"},"SI-115":{type:"Commune",name:"Starše"},"SI-114":{type:"Commune",name:"Slovenske Konjice"},"SI-113":{type:"Commune",name:"Slovenska Bistrica"},"SI-112":{type:"Commune",name:"Slovenj Gradec"},"SI-058":{type:"Commune",name:"Lenart"},"SI-059":{type:"Commune",name:"Lendava"},"SI-166":{type:"Commune",name:"Križevci"},"SI-167":{type:"Commune",name:"Lovrenc na Pohorju"},"SI-128":{type:"Commune",name:"Tolmin"},"SI-129":{type:"Commune",name:"Trbovlje"},"SI-210":{type:"Commune",name:"Sveti Jurij v Slovenskih Goricah"},"SI-211":{type:"Commune",name:"Šentrupert"},"SI-212":{type:"Commune",name:"Mirna"},"SI-045":{type:"Commune",name:"Kidričevo"},"SI-044":{type:"Commune",name:"Kanal"},"SI-047":{type:"Commune",name:"Kobilje"},"SI-046":{type:"Commune",name:"Kobarid"},"SI-041":{type:"Commune",name:"Jesenice"},"SI-040":{type:"Commune",name:"Izola"},"SI-043":{type:"Commune",name:"Kamnik"},"SI-042":{type:"Commune",name:"Juršinci"},"SI-162":{type:"Commune",name:"Horjul"},"SI-163":{type:"Commune",name:"Jezersko"},"SI-160":{type:"Commune",name:"Hoče-Slivnica"},"SI-161":{type:"Commune",name:"Hodoš"},"SI-049":{type:"Commune",name:"Komen"},"SI-048":{type:"Commune",name:"Kočevje"},"SI-164":{type:"Commune",name:"Komenda"},"SI-165":{type:"Commune",name:"Kostel"},"SI-197":{type:"Commune",name:"Kosanjevica na Krki"},"SI-196":{type:"Commune",name:"Cirkulane"},"SI-195":{type:"Commune",name:"Apače"},"SI-194":{type:"Commune",name:"Šmartno pri Litiji"},"SI-193":{type:"Commune",name:"Žužemberk"},"SI-192":{type:"Commune",name:"Žirovnica"},"SI-191":{type:"Commune",name:"Žetale"},"SI-190":{type:"Commune",name:"Žalec"},"SI-199":{type:"Commune",name:"Mokronog-Trebelno"},"SI-198":{type:"Commune",name:"Makole"},"SI-188":{type:"Commune",name:"Veržej"},"SI-209":{type:"Commune",name:"Rečica ob Savinji"},"SI-208":{type:"Commune",name:"Log-Dragomer"},"SI-119":{type:"Commune",name:"Šentjernej"},"SI-189":{type:"Commune",name:"Vransko"},"SI-203":{type:"Commune",name:"Straža"},"SI-202":{type:"Commune",name:"Središče ob Dravi"},"SI-201":{type:"Commune",name:"Renče-Vogrsko"},"SI-118":{type:"Commune",name:"Šentilj"},"SI-207":{type:"Commune",name:"Gorje"},"SI-206":{type:"Commune",name:"Šmarješke Toplice"},"SI-205":{type:"Commune",name:"Sveti Tomaž"},"SI-204":{type:"Commune",name:"Sveta Trojica v Slovenskih Goricah"},"SI-070":{type:"Commune",name:"Maribor"},"SI-071":{type:"Commune",name:"Medvode"},"SI-072":{type:"Commune",name:"Mengeš"},"SI-073":{type:"Commune",name:"Metlika"},"SI-074":{type:"Commune",name:"Mežica"},"SI-075":{type:"Commune",name:"Miren-Kostanjevica"},"SI-076":{type:"Commune",name:"Mislinja"},"SI-077":{type:"Commune",name:"Moravče"},"SI-078":{type:"Commune",name:"Moravske Toplice"},"SI-079":{type:"Commune",name:"Mozirje"},"SI-173":{type:"Commune",name:"Polzela"},"SI-172":{type:"Commune",name:"Podlehnik"},"SI-175":{type:"Commune",name:"Prevalje"},"SI-174":{type:"Commune",name:"Prebold"},"SI-177":{type:"Commune",name:"Ribnica na Pohorju"},"SI-176":{type:"Commune",name:"Razkrižje"},"SI-180":{type:"Commune",name:"Solčava"},"SI-111":{type:"Commune",name:"Sežana"},"SI-110":{type:"Commune",name:"Sevnica"},"SI-182":{type:"Commune",name:"Sveti Andraž v Slovenskih Goricah"},"SI-144":{type:"Commune",name:"Zreče"},"SI-146":{type:"Commune",name:"Železniki"},"SI-147":{type:"Commune",name:"Žiri"},"SI-140":{type:"Commune",name:"Vrhnika"},"SI-141":{type:"Commune",name:"Vuzenica"},"SI-142":{type:"Commune",name:"Zagorje ob Savi"},"SI-143":{type:"Commune",name:"Zavrč"},"SI-148":{type:"Commune",name:"Benedikt"},"SI-149":{type:"Commune",name:"Bistrica ob Sotli"},"SI-069":{type:"Commune",name:"Majšperk"},"SI-068":{type:"Commune",name:"Lukovica"},"SI-067":{type:"Commune",name:"Luče"},"SI-066":{type:"Commune",name:"Loški Potok"},"SI-065":{type:"Commune",name:"Loška Dolina"},"SI-064":{type:"Commune",name:"Logatec"},"SI-063":{type:"Commune",name:"Ljutomer"},"SI-062":{type:"Commune",name:"Ljubno"},"SI-061":{type:"Commune",name:"Ljubljana"},"SI-060":{type:"Commune",name:"Litija"},"SI-153":{type:"Commune",name:"Cerkvenjak"},"SI-152":{type:"Commune",name:"Cankova"},"SI-151":{type:"Commune",name:"Braslovče"},"SI-150":{type:"Commune",name:"Bloke"},"SI-157":{type:"Commune",name:"Dolenjske Toplice"},"SI-156":{type:"Commune",name:"Dobrovnik"},"SI-155":{type:"Commune",name:"Dobrna"},"SI-154":{type:"Commune",name:"Dobje"},"SI-159":{type:"Commune",name:"Hajdina"},"SI-158":{type:"Commune",name:"Grad"},"SI-018":{type:"Commune",name:"Destrnik"},"SI-019":{type:"Commune",name:"Divača"},"SI-012":{type:"Commune",name:"Cerklje na Gorenjskem"},"SI-013":{type:"Commune",name:"Cerknica"},"SI-010":{type:"Commune",name:"Tišina"},"SI-011":{type:"Commune",name:"Celje"},"SI-016":{type:"Commune",name:"Črna na Koroškem"},"SI-017":{type:"Commune",name:"Črnomelj"},"SI-014":{type:"Commune",name:"Cerkno"},"SI-015":{type:"Commune",name:"Črenšovci"},"SI-200":{type:"Commune",name:"Poljčane"},"SI-009":{type:"Commune",name:"Brežice"},"SI-008":{type:"Commune",name:"Brezovica"},"SI-124":{type:"Commune",name:"Šmarje pri Jelšah"},"SI-125":{type:"Commune",name:"Šmartno ob Paki"},"SI-122":{type:"Commune",name:"Škofja Loka"},"SI-123":{type:"Commune",name:"Škofljica"},"SI-120":{type:"Commune",name:"Šentjur"},"SI-121":{type:"Commune",name:"Škocjan"},"SI-001":{type:"Commune",name:"Ajdovščina"},"SI-003":{type:"Commune",name:"Bled"},"SI-002":{type:"Commune",name:"Beltinci"},"SI-005":{type:"Commune",name:"Borovnica"},"SI-004":{type:"Commune",name:"Bohinj"},"SI-007":{type:"Commune",name:"Brda"},"SI-006":{type:"Commune",name:"Bovec"},"SI-179":{type:"Commune",name:"Sodražica"},"SI-178":{type:"Commune",name:"Selnica ob Dravi"},"SI-092":{type:"Commune",name:"Podčetrtek"},"SI-093":{type:"Commune",name:"Podvelka"},"SI-090":{type:"Commune",name:"Piran"},"SI-091":{type:"Commune",name:"Pivka"},"SI-096":{type:"Commune",name:"Ptuj"},"SI-097":{type:"Commune",name:"Puconci"},"SI-094":{type:"Commune",name:"Postojna"},"SI-095":{type:"Commune",name:"Preddvor"},"SI-098":{type:"Commune",name:"Rače-Fram"},"SI-099":{type:"Commune",name:"Radeče"},"SI-034":{type:"Commune",name:"Hrastnik"},"SI-035":{type:"Commune",name:"Hrpelje-Kozina"},"SI-036":{type:"Commune",name:"Idrija"},"SI-037":{type:"Commune",name:"Ig"},"SI-030":{type:"Commune",name:"Gornji Grad"},"SI-031":{type:"Commune",name:"Gornji Petrovci"},"SI-032":{type:"Commune",name:"Grosuplje"},"SI-033":{type:"Commune",name:"Šalovci"},"SI-038":{type:"Commune",name:"Ilirska Bistrica"},"SI-039":{type:"Commune",name:"Ivančna Gorica"},"SI-135":{type:"Commune",name:"Videm"},"SI-134":{type:"Commune",name:"Velike Lašče"},"SI-137":{type:"Commune",name:"Vitanje"},"SI-136":{type:"Commune",name:"Vipava"},"SI-131":{type:"Commune",name:"Tržič"},"SI-130":{type:"Commune",name:"Trebnje"},"SI-133":{type:"Commune",name:"Velenje"},"SI-132":{type:"Commune",name:"Turnišče"},"SI-139":{type:"Commune",name:"Vojnik"},"SI-138":{type:"Commune",name:"Vodice"},"SI-171":{type:"Commune",name:"Oplotnica"},"SI-081":{type:"Commune",name:"Muta"},"SI-080":{type:"Commune",name:"Murska Sobota"},"SI-083":{type:"Commune",name:"Nazarje"},"SI-082":{type:"Commune",name:"Naklo"},"SI-085":{type:"Commune",name:"Novo Mesto"},"SI-084":{type:"Commune",name:"Nova Gorica"},"SI-087":{type:"Commune",name:"Ormož"},"SI-086":{type:"Commune",name:"Odranci"},"SI-089":{type:"Commune",name:"Pesnica"},"SI-088":{type:"Commune",name:"Osilnica"},"SI-023":{type:"Commune",name:"Domžale"},"SI-022":{type:"Commune",name:"Dol pri Ljubljani"},"SI-021":{type:"Commune",name:"Dobrova-Polhov Gradec"},"SI-020":{type:"Commune",name:"Dobrepolje"},"SI-027":{type:"Commune",name:"Gorenja vas-Poljane"},"SI-026":{type:"Commune",name:"Duplek"},"SI-025":{type:"Commune",name:"Dravograd"},"SI-024":{type:"Commune",name:"Dornava"},"SI-170":{type:"Commune",name:"Mirna Peč"},"SI-181":{type:"Commune",name:"Sveta Ana"},"SI-029":{type:"Commune",name:"Gornja Radgona"},"SI-028":{type:"Commune",name:"Gorišnica"},"SI-184":{type:"Commune",name:"Tabor"},"SI-185":{type:"Commune",name:"Trnovska Vas"},"SI-186":{type:"Commune",name:"Trzin"},"SI-187":{type:"Commune",name:"Velika Polana"},"SI-100":{type:"Commune",name:"Radenci"},"SI-101":{type:"Commune",name:"Radlje ob Dravi"},"SI-102":{type:"Commune",name:"Radovljica"},"SI-103":{type:"Commune",name:"Ravne na Koroškem"},"SI-104":{type:"Commune",name:"Ribnica"},"SI-105":{type:"Commune",name:"Rogašovci"},"SI-106":{type:"Commune",name:"Rogaška Slatina"},"SI-107":{type:"Commune",name:"Rogatec"},"SI-108":{type:"Commune",name:"Ruše"},"SI-109":{type:"Commune",name:"Semič"},"SI-126":{type:"Commune",name:"Šoštanj"},"SI-127":{type:"Commune",name:"Štore"},"SI-168":{type:"Commune",name:"Markovci"},"SI-169":{type:"Commune",name:"Miklavž na Dravskem Polju"},"SI-183":{type:"Commune",name:"Šempeter-Vrtojba"}}},KP:{name:"Korea, Democratic People's Republic Of",sub:{"KP-09":{type:"Province",name:"Hamgyǒng-bukto"},"KP-08":{type:"Province",name:"Hamgyǒng-namdo"},"KP-03":{type:"Province",name:"P'yǒngan-bukto"},"KP-02":{type:"Province",name:"P'yǒngan-namdo"},"KP-01":{type:"Capital city",name:"P'yǒngyang"},"KP-07":{type:"Province",name:"Kangweonto"},"KP-06":{type:"Province",name:"Hwanghae-bukto"},"KP-05":{type:"Province",name:"Hwanghae-namdo"},"KP-04":{type:"Province",name:"Chagang-do"},"KP-10":{type:"Province",name:"Ryangkangto"},"KP-13":{type:"Special city",name:"Nasǒn"}}},KW:{name:"Kuwait",sub:{"KW-KU":{type:"Governorate",name:"Al Kuwayt"},"KW-FA":{type:"Governorate",name:"Al Farwānīyah"},"KW-AH":{type:"Governorate",name:"Al Aḩmadī"},"KW-HA":{type:"Governorate",name:"Ḩawallī"},"KW-MU":{type:"Governorate",name:"Mubārak al Kabīr"},"KW-JA":{type:"Governorate",name:"Al Jahrā’"}}},SN:{name:"Senegal",sub:{"SN-SE":{type:"Region",name:"Sédhiou"},"SN-TC":{type:"Region",name:"Tambacounda"},"SN-ZG":{type:"Region",name:"Ziguinchor"},"SN-SL":{type:"Region",name:"Saint-Louis"},"SN-TH":{type:"Region",name:"Thiès"},"SN-MT":{type:"Region",name:"Matam"},"SN-KL":{type:"Region",name:"Kaolack"},"SN-DB":{type:"Region",name:"Diourbel"},"SN-FK":{type:"Region",name:"Fatick"},"SN-KD":{type:"Region",name:"Kolda"},"SN-KE":{type:"Region",name:"Kédougou"},"SN-DK":{type:"Region",name:"Dakar"},"SN-KA":{type:"Region",name:"Kaffrine"},"SN-LG":{type:"Region",name:"Louga"}}},SM:{name:"San Marino",sub:{"SM-08":{type:"Municipality",name:"Montegiardino"},"SM-09":{type:"Municipality",name:"Serravalle"},"SM-04":{type:"Municipality",name:"Faetano"},"SM-05":{type:"Municipality",name:"Fiorentino"},"SM-06":{type:"Municipality",name:"Borgo Maggiore"},"SM-07":{type:"Municipality",name:"San Marino"},"SM-01":{type:"Municipality",name:"Acquaviva"},"SM-02":{type:"Municipality",name:"Chiesanuova"},"SM-03":{type:"Municipality",name:"Domagnano"}}},SL:{name:"Sierra Leone",sub:{"SL-S":{type:"Province",name:"Southern"},"SL-N":{type:"Province",name:"Northern"},"SL-W":{type:"Area",name:"Western Area"},"SL-E":{type:"Province",name:"Eastern"}}},SC:{name:"Seychelles",sub:{"SC-19":{type:"District",name:"Plaisance"},"SC-18":{type:"District",name:"Mon Fleri"},"SC-15":{type:"District",name:"Ladig"},"SC-14":{type:"District",name:"Grand'Anse Praslin"},"SC-17":{type:"District",name:"Mon Bikston"},"SC-16":{type:"District",name:"English River"},"SC-11":{type:"District",name:"Cascade"},"SC-10":{type:"District",name:"Bel Ombre"},"SC-13":{type:"District",name:"Grand'Anse Mahé"},"SC-12":{type:"District",name:"Glacis"},"SC-24":{type:"District",name:"Lemamel"},"SC-25":{type:"District",name:"Roche Caïman"},"SC-20":{type:"District",name:"Pointe La Rue"},"SC-21":{type:"District",name:"Porglo"},"SC-22":{type:"District",name:"Saint Louis"},"SC-23":{type:"District",name:"Takamaka"},"SC-08":{type:"District",name:"Beau Vallon"},"SC-09":{type:"District",name:"Bel Air"},"SC-06":{type:"District",name:"Baie Lazare"},"SC-07":{type:"District",name:"Baie Sainte-Anne"},"SC-04":{type:"District",name:"Au Cap"},"SC-05":{type:"District",name:"Anse Royale"},"SC-02":{type:"District",name:"Ans Bwalo"},"SC-03":{type:"District",name:"Anse Etoile"},"SC-01":{type:"District",name:"Anse aux Pins"}}},KZ:{name:"Kazakhstan",sub:{"KZ-KAR":{type:"Region",name:"Karagandinskaja oblast'"},"KZ-SEV":{type:"Region",name:"Severo-Kazahstanskaja oblast'"},"KZ-MAN":{type:"Region",name:"Mangghystaū oblysy"},"KZ-VOS":{type:"Region",name:"Shyghys Qazaqstan oblysy"},"KZ-KZY":{type:"Region",name:"Kyzylordinskaja oblast'"},"KZ-PAV":{type:"Region",name:"Pavlodar oblysy"},"KZ-KUS":{type:"Region",name:"Kostanajskaja oblast'"},"KZ-AKT":{type:"Region",name:"Aktjubinskaja oblast'"},"KZ-ALM":{type:"Region",name:"Almatinskaja oblast'"},"KZ-ALA":{type:"City",name:"Almaty"},"KZ-AST":{type:"City",name:"Astana"},"KZ-AKM":{type:"Region",name:"Akmolinskaja oblast'"},"KZ-ZHA":{type:"Region",name:"Žambylskaja oblast'"},"KZ-ZAP":{type:"Region",name:"Batys Qazaqstan oblysy"},"KZ-YUZ":{type:"Region",name:"Južno-Kazahstanskaja oblast'"},"KZ-ATY":{type:"Region",name:"Atyraū oblysy"}}},KY:{name:"Cayman Islands",sub:{"KY-KY":{type:"Country",name:"Cayman Islands"}}},SG:{name:"Singapore",sub:{"SG-02":{type:"District",name:"North East"},"SG-03":{type:"District",name:"North West"},"SG-01":{type:"District",name:"Central Singapore"},"SG-04":{type:"District",name:"South East"},"SG-05":{type:"District",name:"South West"}}},SE:{name:"Sweden",sub:{"SE-O":{type:"County",name:"Västra Götalands län"},"SE-N":{type:"County",name:"Hallands län"},"SE-M":{type:"County",name:"Skåne län"},"SE-K":{type:"County",name:"Blekinge län"},"SE-I":{type:"County",name:"Gotlands län"},"SE-H":{type:"County",name:"Kalmar län"},"SE-G":{type:"County",name:"Kronobergs län"},"SE-F":{type:"County",name:"Jönköpings län"},"SE-E":{type:"County",name:"Östergötlands län"},"SE-D":{type:"County",name:"Södermanlands län"},"SE-C":{type:"County",name:"Uppsala län"},"SE-W":{type:"County",name:"Dalarnas län"},"SE-Z":{type:"County",name:"Jämtlands län"},"SE-Y":{type:"County",name:"Västernorrlands län"},"SE-X":{type:"County",name:"Gävleborgs län"},"SE-AC":{type:"County",name:"Västerbottens län"},"SE-AB":{type:"County",name:"Stockholms län"},"SE-BD":{type:"County",name:"Norrbottens län"},"SE-T":{type:"County",name:"Örebro län"},"SE-S":{type:"County",name:"Värmlands län"},"SE-U":{type:"County",name:"Västmanlands län"}}},SD:{name:"Sudan",sub:{"SD-KH":{type:"State",name:"Al Kharţūm"},"SD-GZ":{type:"State",name:"Al Jazīrah"},"SD-NB":{type:"State",name:"An Nīl al Azraq"},"SD-DS":{type:"State",name:"Janūb Dārfūr"},"SD-NR":{type:"State",name:"An Nīl"},"SD-NO":{type:"State",name:"Ash Shamālīyah"},"SD-KA":{type:"State",name:"Kassala"},"SD-DW":{type:"State",name:"Gharb Dārfūr"},"SD-RS":{type:"State",name:"Al Baḩr al Aḩmar"},"SD-NW":{type:"State",name:"An Nīl al Abyaḑ"},"SD-DN":{type:"State",name:"North Darfur"},"SD-KS":{type:"State",name:"Janūb Kurdufān"},"SD-DC":{type:"State",name:"Central Darfur"},"SD-KN":{type:"State",name:"North Kordofan"},"SD-GD":{type:"State",name:"Al Qaḑārif"},"SD-SI":{type:"State",name:"Sennar"},"SD-DE":{type:"State",name:"East Darfur"}}},DO:{name:"Dominican Republic",sub:{"DO-33":{type:"Region",name:"Cibao Nordeste"},"DO-40":{type:"Region",name:"Ozama"},"DO-12":{type:"Province",name:"La Romana"},"DO-13":{type:"Province",name:"La Vega"},"DO-10":{type:"Province",name:"Independencia"},"DO-11":{type:"Province",name:"La Altagracia"},"DO-16":{type:"Province",name:"Pedernales"},"DO-17":{type:"Province",name:"Peravia"},"DO-14":{type:"Province",name:"María Trinidad Sánchez"},"DO-15":{type:"Province",name:"Monte Cristi"},"DO-30":{type:"Province",name:"Hato Mayor"},"DO-31":{type:"Province",name:"San José de Ocoa"},"DO-18":{type:"Province",name:"Puerto Plata"},"DO-19":{type:"Province",name:"Hermanas Mirabal"},"DO-34":{type:"Region",name:"Cibao Noroeste"},"DO-35":{type:"Region",name:"Cibao Norte"},"DO-36":{type:"Region",name:"Cibao Sur"},"DO-37":{type:"Region",name:"El Valle"},"DO-38":{type:"Region",name:"Enriquillo"},"DO-39":{type:"Region",name:"Higuamo"},"DO-29":{type:"Province",name:"Monte Plata"},"DO-28":{type:"Province",name:"Monseñor Nouel"},"DO-01":{type:"District",name:"Distrito Nacional"},"DO-03":{type:"Province",name:"Baoruco"},"DO-02":{type:"Province",name:"Azua"},"DO-05":{type:"Province",name:"Dajabón"},"DO-04":{type:"Province",name:"Barahona"},"DO-07":{type:"Province",name:"La Estrelleta"},"DO-06":{type:"Province",name:"Duarte"},"DO-09":{type:"Province",name:"Espaillat"},"DO-08":{type:"Province",name:"El Seibo"},"DO-25":{type:"Province",name:"Santiago"},"DO-24":{type:"Province",name:"Sánchez Ramírez"},"DO-23":{type:"Province",name:"San Pedro de Macorís"},"DO-22":{type:"Province",name:"San Juan"},"DO-21":{type:"Province",name:"San Cristóbal"},"DO-20":{type:"Province",name:"Samaná"},"DO-27":{type:"Province",name:"Valverde"},"DO-26":{type:"Province",name:"Santiago Rodríguez"},"DO-41":{type:"Region",name:"Valdesia"},"DO-32":{type:"Province",name:"Santo Domingo"},"DO-42":{type:"Region",name:"Yuma"}}},DM:{name:"Dominica",sub:{"DM-10":{type:"Parish",name:"Saint Paul"},"DM-11":{type:"Parish",name:"Saint Peter"},"DM-09":{type:"Parish",name:"Saint Patrick"},"DM-08":{type:"Parish",name:"Saint Mark"},"DM-03":{type:"Parish",name:"Saint David"},"DM-02":{type:"Parish",name:"Saint Andrew"},"DM-07":{type:"Parish",name:"Saint Luke"},"DM-06":{type:"Parish",name:"Saint Joseph"},"DM-05":{type:"Parish",name:"Saint John"},"DM-04":{type:"Parish",name:"Saint George"}}},DJ:{name:"Djibouti",sub:{"DJ-AS":{type:"Region",name:"Ali Sabieh"},"DJ-AR":{type:"Region",name:"Arta"},"DJ-DJ":{type:"City",name:"Djibouti"},"DJ-DI":{type:"Region",name:"Dikhīl"},"DJ-OB":{type:"Region",name:"Obock"},"DJ-TA":{type:"Region",name:"Tadjourah"}}},DK:{name:"Denmark",sub:{"DK-85":{type:"Region",name:"Sjælland"},"DK-84":{type:"Region",name:"Hovedstaden"},"DK-81":{type:"Region",name:"Nordjylland"},"DK-83":{type:"Region",name:"Syddanmark"},"DK-82":{type:"Region",name:"Midtjylland"}}},VG:{name:"Virgin Islands",sub:{"VG-VG":{type:"Country",name:"Virgin Islands"}}},DE:{name:"Germany",sub:{"DE-BE":{type:"Länder",name:"Berlin"},"DE-ST":{type:"Länder",name:"Sachsen-Anhalt"},"DE-RP":{type:"Länder",name:"Rheinland-Pfalz"},"DE-BB":{type:"Länder",name:"Brandenburg"},"DE-NI":{type:"Länder",name:"Niedersachsen"},"DE-SH":{type:"Länder",name:"Schleswig-Holstein"},"DE-TH":{type:"Länder",name:"Thüringen"},"DE-BW":{type:"Länder",name:"Baden-Württemberg"},"DE-HH":{type:"Länder",name:"Hamburg"},"DE-MV":{type:"Länder",name:"Mecklenburg-Vorpommern"},"DE-NW":{type:"Länder",name:"Nordrhein-Westfalen"},"DE-SN":{type:"Länder",name:"Sachsen"},"DE-HB":{type:"Länder",name:"Bremen"},"DE-SL":{type:"Länder",name:"Saarland"},"DE-BY":{type:"Länder",name:"Bayern"},"DE-HE":{type:"Länder",name:"Hessen"}}},YE:{name:"Yemen",sub:{"YE-BA":{type:"Governorate",name:"Al Bayḑā'"},"YE-SD":{type:"Governorate",name:"Şāʻdah"},"YE-SA":{type:"Municipality",name:"Amānat al ‘Āşimah"},"YE-HU":{type:"Governorate",name:"Al Ḩudaydah"},"YE-SN":{type:"Governorate",name:"Şanʻā'"},"YE-SH":{type:"Governorate",name:"Shabwah"},"YE-TA":{type:"Governorate",name:"Tāʻizz"},"YE-MA":{type:"Governorate",name:"Ma'rib"},"YE-LA":{type:"Governorate",name:"Laḩij"},"YE-RA":{type:"Governorate",name:"Raymah"},"YE-IB":{type:"Governorate",name:"Ibb"},"YE-AM":{type:"Governorate",name:"'Amrān"},"YE-HD":{type:"Governorate",name:"Ḩaḑramawt"},"YE-DA":{type:"Governorate",name:"Aḑ Ḑāli'"},"YE-HJ":{type:"Governorate",name:"Ḩajjah"},"YE-JA":{type:"Governorate",name:"Al Jawf"},"YE-MW":{type:"Governorate",name:"Al Maḩwīt"},"YE-AB":{type:"Governorate",name:"Abyān"},"YE-AD":{type:"Governorate",name:"'Adan"},"YE-DH":{type:"Governorate",name:"Dhamār"},"YE-MR":{type:"Governorate",name:"Al Mahrah"}}},DZ:{name:"Algeria",sub:{"DZ-11":{type:"Province",name:"Tamanrasset"},"DZ-10":{type:"Province",name:"Bouira"},"DZ-13":{type:"Province",name:"Tlemcen"},"DZ-12":{type:"Province",name:"Tébessa"},"DZ-15":{type:"Province",name:"Tizi Ouzou"},"DZ-14":{type:"Province",name:"Tiaret"},"DZ-17":{type:"Province",name:"Djelfa"},"DZ-16":{type:"Province",name:"Alger"},"DZ-19":{type:"Province",name:"Sétif"},"DZ-18":{type:"Province",name:"Jijel"},"DZ-35":{type:"Province",name:"Boumerdès"},"DZ-34":{type:"Province",name:"Bordj Bou Arréridj"},"DZ-33":{type:"Province",name:"Illizi"},"DZ-32":{type:"Province",name:"El Bayadh"},"DZ-31":{type:"Province",name:"Oran"},"DZ-30":{type:"Province",name:"Ouargla"},"DZ-28":{type:"Province",name:"Msila"},"DZ-39":{type:"Province",name:"El Oued"},"DZ-38":{type:"Province",name:"Tissemsilt"},"DZ-37":{type:"Province",name:"Tindouf"},"DZ-36":{type:"Province",name:"El Tarf"},"DZ-22":{type:"Province",name:"Sidi Bel Abbès"},"DZ-29":{type:"Province",name:"Mascara"},"DZ-02":{type:"Province",name:"Chlef"},"DZ-03":{type:"Province",name:"Laghouat"},"DZ-01":{type:"Province",name:"Adrar"},"DZ-06":{type:"Province",name:"Béjaïa"},"DZ-07":{type:"Province",name:"Biskra"},"DZ-04":{type:"Province",name:"Oum el Bouaghi"},"DZ-05":{type:"Province",name:"Batna"},"DZ-20":{type:"Province",name:"Saïda"},"DZ-21":{type:"Province",name:"Skikda"},"DZ-08":{type:"Province",name:"Béchar"},"DZ-09":{type:"Province",name:"Blida"},"DZ-24":{type:"Province",name:"Guelma"},"DZ-25":{type:"Province",name:"Constantine"},"DZ-26":{type:"Province",name:"Médéa"},"DZ-27":{type:"Province",name:"Mostaganem"},"DZ-48":{type:"Province",name:"Relizane"},"DZ-46":{type:"Province",name:"Aïn Témouchent"},"DZ-47":{type:"Province",name:"Ghardaïa"},"DZ-44":{type:"Province",name:"Aïn Defla"},"DZ-45":{type:"Province",name:"Naama"},"DZ-42":{type:"Province",name:"Tipaza"},"DZ-43":{type:"Province",name:"Mila"},"DZ-40":{type:"Province",name:"Khenchela"},"DZ-41":{type:"Province",name:"Souk Ahras"},"DZ-23":{type:"Province",name:"Annaba"}}},US:{name:"United States",sub:{"US-NY":{type:"State",name:"New York"},"US-PA":{type:"State",name:"Pennsylvania"},"US-TN":{type:"State",name:"Tennessee"},"US-VI":{type:"Outlying area",name:"Virgin Islands, U.S."},"US-NV":{type:"State",name:"Nevada"},"US-NJ":{type:"State",name:"New Jersey"},"US-NH":{type:"State",name:"New Hampshire"},"US-VA":{type:"State",name:"Virginia"},"US-HI":{type:"State",name:"Hawaii"},"US-PR":{type:"Outlying area",name:"Puerto Rico"},"US-NM":{type:"State",name:"New Mexico"},"US-NC":{type:"State",name:"North Carolina"},"US-ND":{type:"State",name:"North Dakota"},"US-NE":{type:"State",name:"Nebraska"},"US-LA":{type:"State",name:"Louisiana"},"US-UT":{type:"State",name:"Utah"},"US-SD":{type:"State",name:"South Dakota"},"US-DC":{type:"District",name:"District of Columbia"},"US-DE":{type:"State",name:"Delaware"},"US-FL":{type:"State",name:"Florida"},"US-WA":{type:"State",name:"Washington"},"US-UM":{type:"Outlying area",name:"United States Minor Outlying Islands"},"US-KS":{type:"State",name:"Kansas"},"US-WI":{type:"State",name:"Wisconsin"},"US-OR":{type:"State",name:"Oregon"},"US-KY":{type:"State",name:"Kentucky"},"US-ME":{type:"State",name:"Maine"},"US-OH":{type:"State",name:"Ohio"},"US-IA":{type:"State",name:"Iowa"},"US-MD":{type:"State",name:"Maryland"},"US-ID":{type:"State",name:"Idaho"},"US-WY":{type:"State",name:"Wyoming"},"US-VT":{type:"State",name:"Vermont"},"US-RI":{type:"State",name:"Rhode Island"},"US-IN":{type:"State",name:"Indiana"},"US-IL":{type:"State",name:"Illinois"},"US-AK":{type:"State",name:"Alaska"},"US-TX":{type:"State",name:"Texas"},"US-CO":{type:"State",name:"Colorado"},"US-AR":{type:"State",name:"Arkansas"},"US-GU":{type:"Outlying area",name:"Guam"},"US-MA":{type:"State",name:"Massachusetts"},"US-AL":{type:"State",name:"Alabama"},"US-MO":{type:"State",name:"Missouri"},"US-MN":{type:"State",name:"Minnesota"},"US-WV":{type:"State",name:"West Virginia"},"US-CA":{type:"State",name:"California"},"US-OK":{type:"State",name:"Oklahoma"},"US-MI":{type:"State",name:"Michigan"},"US-GA":{type:"State",name:"Georgia"},"US-AZ":{type:"State",name:"Arizona"},"US-MT":{type:"State",name:"Montana"},"US-MS":{type:"State",name:"Mississippi"},"US-SC":{type:"State",name:"South Carolina"},"US-MP":{type:"Outlying area",name:"Northern Mariana Islands"},"US-AS":{type:"Outlying area",name:"American Samoa"},"US-CT":{type:"State",name:"Connecticut"}}},UY:{name:"Uruguay",sub:{"UY-SO":{type:"Department",name:"Soriano"},"UY-FD":{type:"Department",name:"Florida"},"UY-AR":{type:"Department",name:"Artigas"},"UY-SJ":{type:"Department",name:"San José"},"UY-RN":{type:"Department",name:"Río Negro"},"UY-FS":{type:"Department",name:"Flores"},"UY-PA":{type:"Department",name:"Paysandú"},"UY-TT":{type:"Department",name:"Treinta y Tres"},"UY-RO":{type:"Department",name:"Rocha"},"UY-SA":{type:"Department",name:"Salto"},"UY-CO":{type:"Department",name:"Colonia"},"UY-CL":{type:"Department",name:"Cerro Largo"},"UY-MA":{type:"Department",name:"Maldonado"},"UY-RV":{type:"Department",name:"Rivera"},"UY-LA":{type:"Department",name:"Lavalleja"},"UY-MO":{type:"Department",name:"Montevideo"},"UY-DU":{type:"Department",name:"Durazno"},"UY-CA":{type:"Department",name:"Canelones"},"UY-TA":{type:"Department",name:"Tacuarembó"}}},YT:{name:"Mayotte",sub:{"YT-YT":{type:"Country",name:"Mayotte"}}},UM:{name:"United States Minor Outlying Islands",sub:{"UM-76":{type:"Islands, groups of islands",name:"Navassa Island"},"UM-71":{type:"Islands, groups of islands",name:"Midway Islands"},"UM-67":{type:"Islands, groups of islands",name:"Johnston Atoll"},"UM-86":{type:"Islands, groups of islands",name:"Jarvis Island"},"UM-84":{type:"Islands, groups of islands",name:"Howland Island"},"UM-89":{type:"Islands, groups of islands",name:"Kingman Reef"},"UM-79":{type:"Islands, groups of islands",name:"Wake Island"},"UM-81":{type:"Islands, groups of islands",name:"Baker Island"},"UM-95":{type:"Islands, groups of islands",name:"Palmyra Atoll"}}},LB:{name:"Lebanon",sub:{"LB-JA":{type:"Governorate",name:"Al Janūb"},"LB-AS":{type:"Governorate",name:"Ash Shimāl"},"LB-JL":{type:"Governorate",name:"Jabal Lubnān"},"LB-BH":{type:"Governorate",name:"Baalbek-Hermel"},"LB-BI":{type:"Governorate",name:"Al Biqā‘"},"LB-BA":{type:"Governorate",name:"Bayrūt"},"LB-AK":{type:"Governorate",
		name:"Aakkâr"},"LB-NA":{type:"Governorate",name:"An Nabaţīyah"}}},LC:{name:"Saint Lucia",sub:{"LC-11":{type:"District",name:"Vieux Fort"},"LC-12":{type:"District",name:"Canaries"},"LC-10":{type:"District",name:"Soufrière"},"LC-08":{type:"District",name:"Micoud"},"LC-05":{type:"District",name:"Dennery"},"LC-07":{type:"District",name:"Laborie"},"LC-06":{type:"District",name:"Gros Islet"},"LC-01":{type:"District",name:"Anse la Raye"},"LC-03":{type:"District",name:"Choiseul"},"LC-02":{type:"District",name:"Castries"}}},LA:{name:"Laos",sub:{"LA-HO":{type:"Province",name:"Houaphan"},"LA-VT":{type:"Prefecture",name:"Vientiane"},"LA-CH":{type:"Province",name:"Champasak"},"LA-OU":{type:"Province",name:"Oudomsai"},"LA-AT":{type:"Province",name:"Attapu"},"LA-BL":{type:"Province",name:"Bolikhamxai"},"LA-SL":{type:"Province",name:"Salavan"},"LA-KH":{type:"Province",name:"Khammouan"},"LA-LP":{type:"Province",name:"Louangphabang"},"LA-SV":{type:"Province",name:"Savannakhét"},"LA-BK":{type:"Province",name:"Bokèo"},"LA-PH":{type:"Province",name:"Phôngsali"},"LA-XN":{type:"Special zone",name:"Xaisômboun"},"LA-LM":{type:"Province",name:"Louang Namtha"},"LA-XI":{type:"Province",name:"Xiangkhouang"},"LA-XE":{type:"Province",name:"Sékong"},"LA-VI":{type:"Province",name:"Vientiane"},"LA-XA":{type:"Province",name:"Sayaboury"}}},TV:{name:"Tuvalu",sub:{"TV-NKL":{type:"Island council",name:"Nukulaelae"},"TV-NKF":{type:"Island council",name:"Nukufetau"},"TV-VAI":{type:"Island council",name:"Vaitupu"},"TV-FUN":{type:"Town council",name:"Funafuti"},"TV-NIT":{type:"Island council",name:"Niutao"},"TV-NMG":{type:"Island council",name:"Nanumanga"},"TV-NUI":{type:"Island council",name:"Nui"},"TV-NMA":{type:"Island council",name:"Nanumea"}}},TW:{name:"Taiwan",sub:{"TW-ILA":{type:"District",name:"Ilan"},"TW-YUN":{type:"District",name:"Yunlin"},"TW-NAN":{type:"District",name:"Nantou"},"TW-TNQ":{type:"District",name:"Tainan"},"TW-TNN":{type:"Municipality",name:"Tainan"},"TW-KEE":{type:"Municipality",name:"Keelung"},"TW-CHA":{type:"District",name:"Changhua"},"TW-TPE":{type:"Special municipality",name:"Taipei"},"TW-HUA":{type:"District",name:"Hualien"},"TW-TXG":{type:"Municipality",name:"Taichung"},"TW-TAO":{type:"District",name:"Taoyuan"},"TW-PIF":{type:"District",name:"Pingtung"},"TW-KHH":{type:"Special municipality",name:"Kaohsiung"},"TW-PEN":{type:"District",name:"Penghu"},"TW-CYI":{type:"Municipality",name:"Chiayi"},"TW-TXQ":{type:"District",name:"Taichung"},"TW-MIA":{type:"District",name:"Miaoli"},"TW-HSQ":{type:"District",name:"Hsinchu"},"TW-CYQ":{type:"District",name:"Chiayi"},"TW-TPQ":{type:"District",name:"Taipei"},"TW-KHQ":{type:"District",name:"Kaohsiung"},"TW-HSZ":{type:"Municipality",name:"Hsinchu"},"TW-TTT":{type:"District",name:"Taitung"}}},TT:{name:"Trinidad and Tobago",sub:{"TT-SJL":{type:"Region",name:"San Juan-Laventille"},"TT-ETO":{type:"Region",name:"Eastern Tobago"},"TT-SGE":{type:"Region",name:"Sangre Grande"},"TT-PTF":{type:"Municipality",name:"Point Fortin"},"TT-RCM":{type:"Region",name:"Rio Claro-Mayaro"},"TT-WTO":{type:"Region",name:"Western Tobago"},"TT-PRT":{type:"Region",name:"Princes Town"},"TT-POS":{type:"Municipality",name:"Port of Spain"},"TT-CTT":{type:"Region",name:"Couva-Tabaquite-Talparo"},"TT-CHA":{type:"Municipality",name:"Chaguanas"},"TT-ARI":{type:"Municipality",name:"Arima"},"TT-SIP":{type:"Region",name:"Siparia"},"TT-PED":{type:"Region",name:"Penal-Debe"},"TT-SFO":{type:"Municipality",name:"San Fernando"},"TT-DMN":{type:"Region",name:"Diego Martin"},"TT-TUP":{type:"Region",name:"Tunapuna-Piarco"}}},TR:{name:"Turkey",sub:{"TR-61":{type:"Province",name:"Trabzon"},"TR-73":{type:"Province",name:"Şırnak"},"TR-62":{type:"Province",name:"Tunceli"},"TR-77":{type:"Province",name:"Yalova"},"TR-54":{type:"Province",name:"Sakarya"},"TR-60":{type:"Province",name:"Tokat"},"TR-37":{type:"Province",name:"Kastamonu"},"TR-36":{type:"Province",name:"Kars"},"TR-35":{type:"Province",name:"İzmir"},"TR-34":{type:"Province",name:"İstanbul"},"TR-33":{type:"Province",name:"Mersin"},"TR-32":{type:"Province",name:"Isparta"},"TR-31":{type:"Province",name:"Hatay"},"TR-30":{type:"Province",name:"Hakkâri"},"TR-68":{type:"Province",name:"Aksaray"},"TR-55":{type:"Province",name:"Samsun"},"TR-63":{type:"Province",name:"Şanlıurfa"},"TR-44":{type:"Province",name:"Malatya"},"TR-39":{type:"Province",name:"Kırklareli"},"TR-38":{type:"Province",name:"Kayseri"},"TR-19":{type:"Province",name:"Çorum"},"TR-18":{type:"Province",name:"Çankırı"},"TR-57":{type:"Province",name:"Sinop"},"TR-45":{type:"Province",name:"Manisa"},"TR-51":{type:"Province",name:"Niğde"},"TR-50":{type:"Province",name:"Nevşehir"},"TR-53":{type:"Province",name:"Rize"},"TR-52":{type:"Province",name:"Ordu"},"TR-11":{type:"Province",name:"Bilecik"},"TR-10":{type:"Province",name:"Balıkesir"},"TR-13":{type:"Province",name:"Bitlis"},"TR-12":{type:"Province",name:"Bingöl"},"TR-15":{type:"Province",name:"Burdur"},"TR-14":{type:"Province",name:"Bolu"},"TR-17":{type:"Province",name:"Çanakkale"},"TR-16":{type:"Province",name:"Bursa"},"TR-48":{type:"Province",name:"Muğla"},"TR-75":{type:"Province",name:"Ardahan"},"TR-76":{type:"Province",name:"Iğdır"},"TR-69":{type:"Province",name:"Bayburt"},"TR-78":{type:"Province",name:"Karabük"},"TR-74":{type:"Province",name:"Bartın"},"TR-72":{type:"Province",name:"Batman"},"TR-49":{type:"Province",name:"Muş"},"TR-64":{type:"Province",name:"Uşak"},"TR-80":{type:"Province",name:"Osmaniye"},"TR-81":{type:"Province",name:"Düzce"},"TR-67":{type:"Province",name:"Zonguldak"},"TR-56":{type:"Province",name:"Siirt"},"TR-65":{type:"Province",name:"Van"},"TR-70":{type:"Province",name:"Karaman"},"TR-71":{type:"Province",name:"Kırıkkale"},"TR-79":{type:"Province",name:"Kilis"},"TR-20":{type:"Province",name:"Denizli"},"TR-21":{type:"Province",name:"Diyarbakır"},"TR-22":{type:"Province",name:"Edirne"},"TR-23":{type:"Province",name:"Elazığ"},"TR-24":{type:"Province",name:"Erzincan"},"TR-25":{type:"Province",name:"Erzurum"},"TR-26":{type:"Province",name:"Eskişehir"},"TR-27":{type:"Province",name:"Gaziantep"},"TR-28":{type:"Province",name:"Giresun"},"TR-29":{type:"Province",name:"Gümüşhane"},"TR-59":{type:"Province",name:"Tekirdağ"},"TR-58":{type:"Province",name:"Sivas"},"TR-46":{type:"Province",name:"Kahramanmaraş"},"TR-47":{type:"Province",name:"Mardin"},"TR-08":{type:"Province",name:"Artvin"},"TR-09":{type:"Province",name:"Aydın"},"TR-42":{type:"Province",name:"Konya"},"TR-43":{type:"Province",name:"Kütahya"},"TR-40":{type:"Province",name:"Kırşehir"},"TR-41":{type:"Province",name:"Kocaeli"},"TR-02":{type:"Province",name:"Adıyaman"},"TR-03":{type:"Province",name:"Afyonkarahisar"},"TR-66":{type:"Province",name:"Yozgat"},"TR-01":{type:"Province",name:"Adana"},"TR-06":{type:"Province",name:"Ankara"},"TR-07":{type:"Province",name:"Antalya"},"TR-04":{type:"Province",name:"Ağrı"},"TR-05":{type:"Province",name:"Amasya"}}},LK:{name:"Sri Lanka",sub:{"LK-23":{type:"District",name:"Nuvara Ĕliya"},"LK-22":{type:"District",name:"Matale"},"LK-21":{type:"District",name:"Kandy"},"LK-41":{type:"District",name:"Jaffna"},"LK-43":{type:"District",name:"Mannar"},"LK-42":{type:"District",name:"Kilinochchi"},"LK-45":{type:"District",name:"Mulativ"},"LK-44":{type:"District",name:"Vavuniya"},"LK-4":{type:"Province",name:"Northern Province"},"LK-5":{type:"Province",name:"Eastern Province"},"LK-6":{type:"Province",name:"North Western Province"},"LK-7":{type:"Province",name:"North Central Province"},"LK-1":{type:"Province",name:"Basnāhira paḷāta"},"LK-2":{type:"Province",name:"Central Province"},"LK-3":{type:"Province",name:"Dakuṇu paḷāta"},"LK-8":{type:"Province",name:"Ūvā mākāṇam"},"LK-9":{type:"Province",name:"Chappirakamuva mākāṇam"},"LK-71":{type:"District",name:"Anuradhapura"},"LK-72":{type:"District",name:"Pŏlaṉṉaṛuvai"},"LK-92":{type:"District",name:"Kægalla"},"LK-91":{type:"District",name:"Irattiṉapuri"},"LK-12":{type:"District",name:"Gampaha"},"LK-13":{type:"District",name:"Kalutara"},"LK-11":{type:"District",name:"Colombo"},"LK-52":{type:"District",name:"Ampara"},"LK-53":{type:"District",name:"Tirukŏṇamalai"},"LK-51":{type:"District",name:"Batticaloa"},"LK-31":{type:"District",name:"Gālla"},"LK-32":{type:"District",name:"Matara"},"LK-33":{type:"District",name:"Ampāntōṭṭai"},"LK-62":{type:"District",name:"Puttalam"},"LK-61":{type:"District",name:"Kuruṇægala"},"LK-81":{type:"District",name:"Badulla"},"LK-82":{type:"District",name:"Monaragala"}}},LI:{name:"Liechtenstein",sub:{"LI-11":{type:"Commune",name:"Vaduz"},"LI-10":{type:"Commune",name:"Triesenberg"},"LI-09":{type:"Commune",name:"Triesen"},"LI-08":{type:"Commune",name:"Schellenberg"},"LI-07":{type:"Commune",name:"Schaan"},"LI-06":{type:"Commune",name:"Ruggell"},"LI-05":{type:"Commune",name:"Planken"},"LI-04":{type:"Commune",name:"Mauren"},"LI-03":{type:"Commune",name:"Gamprin"},"LI-02":{type:"Commune",name:"Eschen"},"LI-01":{type:"Commune",name:"Balzers"}}},LV:{name:"Latvia",sub:{"LV-DGV":{type:"Republican city",name:"Daugavpils"},"LV-078":{type:"Municipality",name:"Riebiņu novads"},"LV-079":{type:"Municipality",name:"Rojas novads"},"LV-072":{type:"Municipality",name:"Pļaviņu novads"},"LV-073":{type:"Municipality",name:"Preiļu novads"},"LV-070":{type:"Municipality",name:"Pārgaujas novads"},"LV-071":{type:"Municipality",name:"Pāvilostas novads"},"LV-076":{type:"Municipality",name:"Raunas novads"},"LV-077":{type:"Municipality",name:"Rēzeknes novads"},"LV-074":{type:"Municipality",name:"Priekules novads"},"LV-075":{type:"Municipality",name:"Priekuļu novads"},"LV-106":{type:"Municipality",name:"Ventspils novads"},"LV-107":{type:"Municipality",name:"Viesītes novads"},"LV-JEL":{type:"Republican city",name:"Jelgava"},"LV-069":{type:"Municipality",name:"Ozolnieku novads"},"LV-068":{type:"Municipality",name:"Olaines novads"},"LV-104":{type:"Municipality",name:"Vecpiebalgas novads"},"LV-105":{type:"Municipality",name:"Vecumnieku novads"},"LV-102":{type:"Municipality",name:"Varakļānu novads"},"LV-103":{type:"Municipality",name:"Vārkavas novads"},"LV-100":{type:"Municipality",name:"Vaiņodes novads"},"LV-101":{type:"Municipality",name:"Valkas novads"},"LV-061":{type:"Municipality",name:"Mālpils novads"},"LV-060":{type:"Municipality",name:"Mazsalacas novads"},"LV-063":{type:"Municipality",name:"Mērsraga novads"},"LV-062":{type:"Municipality",name:"Mārupes novads"},"LV-065":{type:"Municipality",name:"Neretas novads"},"LV-064":{type:"Municipality",name:"Naukšēnu novads"},"LV-067":{type:"Municipality",name:"Ogres novads"},"LV-066":{type:"Municipality",name:"Nīcas novads"},"LV-LPX":{type:"Republican city",name:"Liepāja"},"LV-VEN":{type:"Republican city",name:"Ventspils"},"LV-054":{type:"Municipality",name:"Limbažu novads"},"LV-055":{type:"Municipality",name:"Līgatnes novads"},"LV-056":{type:"Municipality",name:"Līvānu novads"},"LV-057":{type:"Municipality",name:"Lubānas novads"},"LV-050":{type:"Municipality",name:"Kuldīgas novads"},"LV-051":{type:"Municipality",name:"Ķeguma novads"},"LV-052":{type:"Municipality",name:"Ķekavas novads"},"LV-053":{type:"Municipality",name:"Lielvārdes novads"},"LV-REZ":{type:"Republican city",name:"Rēzekne"},"LV-109":{type:"Municipality",name:"Viļānu novads"},"LV-058":{type:"Municipality",name:"Ludzas novads"},"LV-059":{type:"Municipality",name:"Madonas novads"},"LV-110":{type:"Municipality",name:"Zilupes novads"},"LV-VMR":{type:"Republican city",name:"Valmiera"},"LV-043":{type:"Municipality",name:"Kandavas novads"},"LV-042":{type:"Municipality",name:"Jēkabpils novads"},"LV-041":{type:"Municipality",name:"Jelgavas novads"},"LV-040":{type:"Municipality",name:"Jaunpils novads"},"LV-047":{type:"Municipality",name:"Krāslavas novads"},"LV-046":{type:"Municipality",name:"Kokneses novads"},"LV-045":{type:"Municipality",name:"Kocēnu novads"},"LV-044":{type:"Municipality",name:"Kārsavas novads"},"LV-049":{type:"Municipality",name:"Krustpils novads"},"LV-048":{type:"Municipality",name:"Krimuldas novads"},"LV-036":{type:"Municipality",name:"Ilūkstes novads"},"LV-037":{type:"Municipality",name:"Inčukalna novads"},"LV-034":{type:"Municipality",name:"Iecavas novads"},"LV-035":{type:"Municipality",name:"Ikšķiles novads"},"LV-032":{type:"Municipality",name:"Grobiņas novads"},"LV-033":{type:"Municipality",name:"Gulbenes novads"},"LV-030":{type:"Municipality",name:"Ērgļu novads"},"LV-031":{type:"Municipality",name:"Garkalnes novads"},"LV-038":{type:"Municipality",name:"Jaunjelgavas novads"},"LV-039":{type:"Municipality",name:"Jaunpiebalgas novads"},"LV-025":{type:"Municipality",name:"Daugavpils novads"},"LV-024":{type:"Municipality",name:"Dagdas novads"},"LV-027":{type:"Municipality",name:"Dundagas novads"},"LV-026":{type:"Municipality",name:"Dobeles novads"},"LV-021":{type:"Municipality",name:"Cesvaines novads"},"LV-020":{type:"Municipality",name:"Carnikavas novads"},"LV-023":{type:"Municipality",name:"Ciblas novads"},"LV-022":{type:"Municipality",name:"Cēsu novads"},"LV-029":{type:"Municipality",name:"Engures novads"},"LV-028":{type:"Municipality",name:"Durbes novads"},"LV-108":{type:"Municipality",name:"Viļakas novads"},"LV-JKB":{type:"Republican city",name:"Jēkabpils"},"LV-098":{type:"Municipality",name:"Tērvetes novads"},"LV-099":{type:"Municipality",name:"Tukuma novads"},"LV-090":{type:"Municipality",name:"Sējas novads"},"LV-091":{type:"Municipality",name:"Siguldas novads"},"LV-092":{type:"Municipality",name:"Skrīveru novads"},"LV-093":{type:"Municipality",name:"Skrundas novads"},"LV-094":{type:"Municipality",name:"Smiltenes novads"},"LV-095":{type:"Municipality",name:"Stopiņu novads"},"LV-096":{type:"Municipality",name:"Strenču novads"},"LV-097":{type:"Municipality",name:"Talsu novads"},"LV-010":{type:"Municipality",name:"Auces novads"},"LV-011":{type:"Municipality",name:"Ādažu novads"},"LV-012":{type:"Municipality",name:"Babītes novads"},"LV-013":{type:"Municipality",name:"Baldones novads"},"LV-014":{type:"Municipality",name:"Baltinavas novads"},"LV-015":{type:"Municipality",name:"Balvu novads"},"LV-016":{type:"Municipality",name:"Bauskas novads"},"LV-017":{type:"Municipality",name:"Beverīnas novads"},"LV-018":{type:"Municipality",name:"Brocēnu novads"},"LV-019":{type:"Municipality",name:"Burtnieku novads"},"LV-JUR":{type:"Republican city",name:"Jūrmala"},"LV-087":{type:"Municipality",name:"Salaspils novads"},"LV-086":{type:"Municipality",name:"Salacgrīvas novads"},"LV-085":{type:"Municipality",name:"Salas novads"},"LV-084":{type:"Municipality",name:"Rūjienas novads"},"LV-083":{type:"Municipality",name:"Rundāles novads"},"LV-082":{type:"Municipality",name:"Rugāju novads"},"LV-081":{type:"Municipality",name:"Rucavas novads"},"LV-080":{type:"Municipality",name:"Ropažu novads"},"LV-089":{type:"Municipality",name:"Saulkrastu novads"},"LV-088":{type:"Municipality",name:"Saldus novads"},"LV-009":{type:"Municipality",name:"Apes novads"},"LV-008":{type:"Municipality",name:"Amatas novads"},"LV-007":{type:"Municipality",name:"Alūksnes novads"},"LV-006":{type:"Municipality",name:"Alsungas novads"},"LV-005":{type:"Municipality",name:"Alojas novads"},"LV-004":{type:"Municipality",name:"Aknīstes novads"},"LV-003":{type:"Municipality",name:"Aizputes novads"},"LV-002":{type:"Municipality",name:"Aizkraukles novads"},"LV-001":{type:"Municipality",name:"Aglonas novads"},"LV-RIX":{type:"Republican city",name:"Rīga"}}},TO:{name:"Tonga",sub:{"TO-01":{type:"Division",name:"'Eua"},"TO-03":{type:"Division",name:"Niuas"},"TO-02":{type:"Division",name:"Ha'apai"},"TO-05":{type:"Division",name:"Vava'u"},"TO-04":{type:"Division",name:"Tongatapu"}}},LT:{name:"Lithuania",sub:{"LT-MR":{type:"County",name:"Marijampolės apskritis"},"LT-TA":{type:"County",name:"Tauragės apskritis"},"LT-56":{type:"District municipality",name:"Vilkaviškis"},"LT-41":{type:"District municipality",name:"Šakiai"},"LT-KL":{type:"County",name:"Klaipėdos apskritis"},"LT-52":{type:"District municipality",name:"Trakai"},"LT-53":{type:"District municipality",name:"Ukmergė"},"LT-01":{type:"District municipality",name:"Akmenė"},"LT-02":{type:"City municipality",name:"Alytaus miestas"},"LT-03":{type:"District municipality",name:"Alytus"},"LT-04":{type:"District municipality",name:"Anykščiai"},"LT-05":{type:"Municipality",name:"Birštono"},"LT-06":{type:"District municipality",name:"Biržai"},"LT-07":{type:"Municipality",name:"Druskininkai"},"LT-08":{type:"Municipality",name:"Elektrénai"},"LT-09":{type:"District municipality",name:"Ignalina"},"LT-KU":{type:"County",name:"Kauno apskritis"},"LT-28":{type:"Municipality",name:"Neringa"},"LT-29":{type:"Municipality",name:"Pagégiai"},"LT-48":{type:"District municipality",name:"Skuodas"},"LT-49":{type:"District municipality",name:"Švenčionys"},"LT-60":{type:"District municipality",name:"Zarasai"},"LT-UT":{type:"County",name:"Utenos apskritis"},"LT-22":{type:"District municipality",name:"Kretinga"},"LT-23":{type:"District municipality",name:"Kupiškis"},"LT-20":{type:"City municipality",name:"Klaipėdos miestas"},"LT-21":{type:"District municipality",name:"Klaipėda"},"LT-26":{type:"District municipality",name:"Mažeikiai"},"LT-27":{type:"District municipality",name:"Molėtai"},"LT-24":{type:"District municipality",name:"Lazdijai"},"LT-25":{type:"District municipality",name:"Marijampolė"},"LT-58":{type:"District municipality",name:"Vilnius"},"LT-PN":{type:"County",name:"Panevėžio apskritis"},"LT-54":{type:"District municipality",name:"Utena"},"LT-43":{type:"City municipality",name:"Šiaulių miestas"},"LT-59":{type:"Municipality",name:"Visaginas"},"LT-45":{type:"District municipality",name:"Šilalė"},"LT-47":{type:"District municipality",name:"Širvintos"},"LT-46":{type:"District municipality",name:"Šilutė"},"LT-17":{type:"Municipality",name:"Kazlų Rūdos"},"LT-16":{type:"District municipality",name:"Kaunas"},"LT-15":{type:"City municipality",name:"Kauno miestas"},"LT-14":{type:"Municipality",name:"Kalvarijos"},"LT-13":{type:"District municipality",name:"Kaišiadorys"},"LT-12":{type:"District municipality",name:"Jurbarkas"},"LT-11":{type:"District municipality",name:"Joniškis"},"LT-10":{type:"District municipality",name:"Jonava"},"LT-TE":{type:"County",name:"Telšių apskritis"},"LT-40":{type:"District municipality",name:"Rokiškis"},"LT-VL":{type:"County",name:"Vilniaus apskritis"},"LT-AL":{type:"County",name:"Alytaus apskritis"},"LT-SA":{type:"County",name:"Šiaulių apskritis"},"LT-19":{type:"District municipality",name:"Kelmė"},"LT-18":{type:"District municipality",name:"Kėdainiai"},"LT-39":{type:"Municipality",name:"Rietavo"},"LT-38":{type:"District municipality",name:"Raseiniai"},"LT-51":{type:"District municipality",name:"Telšiai"},"LT-50":{type:"District municipality",name:"Tauragė"},"LT-57":{type:"City municipality",name:"Vilniaus miestas"},"LT-42":{type:"District municipality",name:"Šalčininkai"},"LT-55":{type:"District municipality",name:"Varėna"},"LT-44":{type:"District municipality",name:"Šiauliai"},"LT-31":{type:"City municipality",name:"Palangos miestas"},"LT-30":{type:"District municipality",name:"Pakruojis"},"LT-33":{type:"District municipality",name:"Panevėžys"},"LT-32":{type:"City municipality",name:"Panevėžio miestas"},"LT-35":{type:"District municipality",name:"Plungė"},"LT-34":{type:"District municipality",name:"Pasvalys"},"LT-37":{type:"District municipality",name:"Radviliškis"},"LT-36":{type:"District municipality",name:"Prienai"}}},LU:{name:"Luxembourg",sub:{"LU-G":{type:"District",name:"Grevenmacher"},"LU-D":{type:"District",name:"Diekirch"},"LU-L":{type:"District",name:"Lëtzebuerg"}}},LR:{name:"Liberia",sub:{"LR-CM":{type:"County",name:"Grand Cape Mount"},"LR-BM":{type:"County",name:"Bomi"},"LR-MY":{type:"County",name:"Maryland"},"LR-LO":{type:"County",name:"Lofa"},"LR-MO":{type:"County",name:"Montserrado"},"LR-GP":{type:"County",name:"Gbarpolu"},"LR-MG":{type:"County",name:"Margibi"},"LR-BG":{type:"County",name:"Bong"},"LR-GK":{type:"County",name:"Grand Kru"},"LR-RI":{type:"County",name:"Rivercess"},"LR-SI":{type:"County",name:"Sinoe"},"LR-GB":{type:"County",name:"Grand Bassa"},"LR-RG":{type:"County",name:"River Gee"},"LR-GG":{type:"County",name:"Grand Gedeh"},"LR-NI":{type:"County",name:"Nimba"}}},LS:{name:"Lesotho",sub:{"LS-H":{type:"District",name:"Qacha's Nek"},"LS-J":{type:"District",name:"Mokhotlong"},"LS-K":{type:"District",name:"Thaba-Tseka"},"LS-D":{type:"District",name:"Berea"},"LS-E":{type:"District",name:"Mafeteng"},"LS-F":{type:"District",name:"Mohale's Hoek"},"LS-G":{type:"District",name:"Quthing"},"LS-A":{type:"District",name:"Maseru"},"LS-B":{type:"District",name:"Butha-Buthe"},"LS-C":{type:"District",name:"Leribe"}}},TH:{name:"Thailand",sub:{"TH-57":{type:"Province",name:"Chiang Rai"},"TH-56":{type:"Province",name:"Phayao"},"TH-55":{type:"Province",name:"Nan"},"TH-54":{type:"Province",name:"Phrae"},"TH-53":{type:"Province",name:"Uttaradit"},"TH-33":{type:"Province",name:"Si Sa Ket"},"TH-51":{type:"Province",name:"Lamphun"},"TH-50":{type:"Province",name:"Chiang Mai"},"TH-90":{type:"Province",name:"Songkhla"},"TH-92":{type:"Province",name:"Trang"},"TH-91":{type:"Province",name:"Satun"},"TH-32":{type:"Province",name:"Surin"},"TH-96":{type:"Province",name:"Narathiwat"},"TH-95":{type:"Province",name:"Yala"},"TH-58":{type:"Province",name:"Mae Hong Son"},"TH-13":{type:"Province",name:"Pathum Thani"},"TH-12":{type:"Province",name:"Nonthaburi"},"TH-11":{type:"Province",name:"Samut Prakan"},"TH-10":{type:"Metropolitan administration",name:"Krung Thep Maha Nakhon"},"TH-31":{type:"Province",name:"Buri Ram"},"TH-30":{type:"Province",name:"Nakhon Ratchasima"},"TH-15":{type:"Province",name:"Ang Thong"},"TH-14":{type:"Province",name:"Phra Nakhon Si Ayutthaya"},"TH-71":{type:"Province",name:"Kanchanaburi"},"TH-70":{type:"Province",name:"Ratchaburi"},"TH-19":{type:"Province",name:"Saraburi"},"TH-18":{type:"Province",name:"Chai Nat"},"TH-39":{type:"Province",name:"Nong Bua Lam Phu"},"TH-38":{type:"Province",name:"Bueng Kan"},"TH-77":{type:"Province",name:"Prachuap Khiri Khan"},"TH-52":{type:"Province",name:"Lampang"},"TH-72":{type:"Province",name:"Suphan Buri"},"TH-75":{type:"Province",name:"Samut Songkhram"},"TH-93":{type:"Province",name:"Phatthalung"},"TH-74":{type:"Province",name:"Samut Sakhon"},"TH-84":{type:"Province",name:"Surat Thani"},"TH-85":{type:"Province",name:"Ranong"},"TH-86":{type:"Province",name:"Chumphon"},"TH-S":{type:"Special administrative city",name:"Phatthaya"},"TH-80":{type:"Province",name:"Nakhon Si Thammarat"},"TH-81":{type:"Province",name:"Krabi"},"TH-82":{type:"Province",name:"Phangnga"},"TH-83":{type:"Province",name:"Phuket"},"TH-76":{type:"Province",name:"Phetchaburi"},"TH-40":{type:"Province",name:"Khon Kaen"},"TH-41":{type:"Province",name:"Udon Thani"},"TH-42":{type:"Province",name:"Loei"},"TH-43":{type:"Province",name:"Nong Khai"},"TH-44":{type:"Province",name:"Maha Sarakham"},"TH-45":{type:"Province",name:"Roi Et"},"TH-46":{type:"Province",name:"Kalasin"},"TH-47":{type:"Province",name:"Sakon Nakhon"},"TH-48":{type:"Province",name:"Nakhon Phanom"},"TH-49":{type:"Province",name:"Mukdahan"},"TH-26":{type:"Province",name:"Nakhon Nayok"},"TH-27":{type:"Province",name:"Sa Kaeo"},"TH-24":{type:"Province",name:"Chachoengsao"},"TH-25":{type:"Province",name:"Prachin Buri"},"TH-22":{type:"Province",name:"Chanthaburi"},"TH-23":{type:"Province",name:"Trat"},"TH-20":{type:"Province",name:"Chon Buri"},"TH-21":{type:"Province",name:"Rayong"},"TH-62":{type:"Province",name:"Kamphaeng Phet"},"TH-63":{type:"Province",name:"Tak"},"TH-60":{type:"Province",name:"Nakhon Sawan"},"TH-61":{type:"Province",name:"Uthai Thani"},"TH-66":{type:"Province",name:"Phichit"},"TH-67":{type:"Province",name:"Phetchabun"},"TH-64":{type:"Province",name:"Sukhothai"},"TH-65":{type:"Province",name:"Phitsanulok"},"TH-35":{type:"Province",name:"Yasothon"},"TH-34":{type:"Province",name:"Ubon Ratchathani"},"TH-37":{type:"Province",name:"Amnat Charoen"},"TH-73":{type:"Province",name:"Nakhon Pathom"},"TH-36":{type:"Province",name:"Chaiyaphum"},"TH-17":{type:"Province",name:"Sing Buri"},"TH-94":{type:"Province",name:"Pattani"},"TH-16":{type:"Province",name:"Lop Buri"}}},TF:{name:"French Southern Territories",sub:{"TF-TF":{type:"Country",name:"French Southern Territories"}}},TG:{name:"Togo",sub:{"TG-P":{type:"Region",name:"Plateaux"},"TG-S":{type:"Region",name:"Savannes"},"TG-C":{type:"Region",name:"Centre"},"TG-M":{type:"Region",name:"Maritime"},"TG-K":{type:"Region",name:"Kara"}}},TD:{name:"Chad",sub:{"TD-ND":{type:"Region",name:"Madīnat Injamīnā"},"TD-LO":{type:"Region",name:"Logone-Occidental"},"TD-WF":{type:"Region",name:"Wadi Fira"},"TD-LC":{type:"Region",name:"Al Buḩayrah"},"TD-SA":{type:"Region",name:"Salamat"},"TD-SI":{type:"Region",name:"Sila"},"TD-HL":{type:"Region",name:"Hadjer Lamis"},"TD-LR":{type:"Region",name:"Logone-Oriental"},"TD-BA":{type:"Region",name:"Al Baţḩah"},"TD-BG":{type:"Region",name:"Baḩr al Ghazāl"},"TD-BO":{type:"Region",name:"Borkou"},"TD-MC":{type:"Region",name:"Moyen-Chari"},"TD-OD":{type:"Region",name:"Ouaddaï"},"TD-MA":{type:"Region",name:"Mandoul"},"TD-ME":{type:"Region",name:"Mayo-Kebbi-Est"},"TD-KA":{type:"Region",name:"Kanem"},"TD-MO":{type:"Region",name:"Mayo-Kebbi-Ouest"},"TD-GR":{type:"Region",name:"Guéra"},"TD-EO":{type:"Region",name:"Ennedi-Ouest"},"TD-TA":{type:"Region",name:"Tandjilé"},"TD-TI":{type:"Region",name:"Tibastī"},"TD-EE":{type:"Region",name:"Ennedi-Est"},"TD-CB":{type:"Region",name:"Chari-Baguirmi"}}},TC:{name:"Turks & Caicos Islands",sub:{"TC-TC":{type:"Country",name:"Turks & Caicos Islands"}}},LY:{name:"Libya",sub:{"LY-JI":{type:"Popularate",name:"Al Jifārah"},"LY-SR":{type:"Popularate",name:"Surt"},"LY-JA":{type:"Popularate",name:"Al Jabal al Akhḑar"},"LY-DR":{type:"Popularate",name:"Darnah"},"LY-WD":{type:"Popularate",name:"Wādī al Ḩayāt"},"LY-JG":{type:"Popularate",name:"Al Jabal al Gharbī"},"LY-WA":{type:"Popularate",name:"Al Wāḩāt"},"LY-SB":{type:"Popularate",name:"Sabhā"},"LY-NQ":{type:"Popularate",name:"An Nuqāţ al Khams"},"LY-JU":{type:"Popularate",name:"Al Jufrah"},"LY-WS":{type:"Popularate",name:"Wādī ash Shāţi’"},"LY-BA":{type:"Popularate",name:"Banghāzī"},"LY-BU":{type:"Popularate",name:"Al Buţnān"},"LY-NL":{type:"Popularate",name:"Nālūt"},"LY-ZA":{type:"Popularate",name:"Az Zāwiyah"},"LY-MI":{type:"Popularate",name:"Mişrātah"},"LY-MJ":{type:"Popularate",name:"Al Marj"},"LY-TB":{type:"Popularate",name:"Ţarābulus"},"LY-GT":{type:"Popularate",name:"Ghāt"},"LY-KF":{type:"Popularate",name:"Al Kufrah"},"LY-MB":{type:"Popularate",name:"Al Marqab"},"LY-MQ":{type:"Popularate",name:"Murzuq"}}},VA:{name:"Vatican City",sub:{"VA-VA":{type:"Country",name:"Vatican City"}}},VC:{name:"Saint Vincent And The Grenadines",sub:{"VC-03":{type:"Parish",name:"Saint David"},"VC-02":{type:"Parish",name:"Saint Andrew"},"VC-01":{type:"Parish",name:"Charlotte"},"VC-06":{type:"Parish",name:"Grenadines"},"VC-05":{type:"Parish",name:"Saint Patrick"},"VC-04":{type:"Parish",name:"Saint George"}}},AE:{name:"United Arab Emirates",sub:{"AE-FU":{type:"Emirate",name:"Al Fujayrah"},"AE-AJ":{type:"Emirate",name:"'Ajmān"},"AE-SH":{type:"Emirate",name:"Ash Shāriqah"},"AE-AZ":{type:"Emirate",name:"Abū Z̧aby"},"AE-UQ":{type:"Emirate",name:"Umm al Qaywayn"},"AE-RK":{type:"Emirate",name:"Ra's al Khaymah"},"AE-DU":{type:"Emirate",name:"Dubayy"}}},AD:{name:"Andorra",sub:{"AD-08":{type:"Parish",name:"Escaldes-Engordany"},"AD-05":{type:"Parish",name:"Ordino"},"AD-04":{type:"Parish",name:"La Massana"},"AD-07":{type:"Parish",name:"Andorra la Vella"},"AD-06":{type:"Parish",name:"Sant Julià de Lòria"},"AD-03":{type:"Parish",name:"Encamp"},"AD-02":{type:"Parish",name:"Canillo"}}},AG:{name:"Antigua and Barbuda",sub:{"AG-11":{type:"Dependency",name:"Redonda"},"AG-10":{type:"Dependency",name:"Barbuda"},"AG-08":{type:"Parish",name:"Saint Philip"},"AG-04":{type:"Parish",name:"Saint John"},"AG-05":{type:"Parish",name:"Saint Mary"},"AG-06":{type:"Parish",name:"Saint Paul"},"AG-07":{type:"Parish",name:"Saint Peter"},"AG-03":{type:"Parish",name:"Saint George"}}},AF:{name:"Afghanistan",sub:{"AF-TAK":{type:"Province",name:"Takhār"},"AF-BGL":{type:"Province",name:"Baghlān"},"AF-BAM":{type:"Province",name:"Bāmyān"},"AF-BAL":{type:"Province",name:"Balkh"},"AF-SAR":{type:"Province",name:"Sar-e Pul"},"AF-KNR":{type:"Province",name:"Kunar"},"AF-SAM":{type:"Province",name:"Samangān"},"AF-LOG":{type:"Province",name:"Lōgar"},"AF-NUR":{type:"Province",name:"Nūristān"},"AF-KDZ":{type:"Province",name:"Kunduz"},"AF-NIM":{type:"Province",name:"Nīmrōz"},"AF-PAN":{type:"Province",name:"Panjshayr"},"AF-NAN":{type:"Province",name:"Nangarhār"},"AF-KHO":{type:"Province",name:"Khōst"},"AF-PIA":{type:"Province",name:"Paktiyā"},"AF-BDS":{type:"Province",name:"Badakhshān"},"AF-FYB":{type:"Province",name:"Fāryāb"},"AF-URU":{type:"Province",name:"Uruzgān"},"AF-BDG":{type:"Province",name:"Bādghīs"},"AF-LAG":{type:"Province",name:"Laghmān"},"AF-PAR":{type:"Province",name:"Parwān"},"AF-KAP":{type:"Province",name:"Kāpīsā"},"AF-GHA":{type:"Province",name:"Ghaznī"},"AF-GHO":{type:"Province",name:"Ghōr"},"AF-FRA":{type:"Province",name:"Farāh"},"AF-KAB":{type:"Province",name:"Kābul"},"AF-KAN":{type:"Province",name:"Kandahār"},"AF-ZAB":{type:"Province",name:"Zābul"},"AF-WAR":{type:"Province",name:"Wardak"},"AF-HEL":{type:"Province",name:"Helmand"},"AF-PKA":{type:"Province",name:"Paktīkā"},"AF-DAY":{type:"Province",name:"Dāykundī"},"AF-JOW":{type:"Province",name:"Jowzjān"},"AF-HER":{type:"Province",name:"Herāt"}}},AI:{name:"Anguilla",sub:{"AI-AI":{type:"Country",name:"Anguilla"}}},VI:{name:"Virgin Islands",sub:{"VI-VI":{type:"Country",name:"Virgin Islands"}}},IS:{name:"Iceland",sub:{"IS-8":{type:"Region",name:"Suðurland"},"IS-3":{type:"Region",name:"Vesturland"},"IS-2":{type:"Region",name:"Suðurnes"},"IS-1":{type:"Region",name:"Höfuðborgarsvæði utan Reykjavíkur"},"IS-0":{type:"Region",name:"Reykjavík"},"IS-7":{type:"Region",name:"Austurland"},"IS-6":{type:"Region",name:"Norðurland eystra"},"IS-5":{type:"Region",name:"Norðurland vestra"},"IS-4":{type:"Region",name:"Vestfirðir"}}},IR:{name:"Iran",sub:{"IR-03":{type:"Province",name:"Ardabīl"},"IR-02":{type:"Province",name:"Āz̄arbāyjān-e Gharbī"},"IR-01":{type:"Province",name:"Āz̄arbāyjān-e Sharqī"},"IR-26":{type:"Province",name:"Qom"},"IR-07":{type:"Province",name:"Tehrān"},"IR-06":{type:"Province",name:"Būshehr"},"IR-05":{type:"Province",name:"Īlām"},"IR-04":{type:"Province",name:"Eşfahān"},"IR-08":{type:"Province",name:"Chahār Maḩāll va Bakhtīārī"},"IR-29":{type:"Province",name:"Khorāsān-e Janūbī"},"IR-27":{type:"Province",name:"Golestān"},"IR-21":{type:"Province",name:"Māzandarān"},"IR-20":{type:"Province",name:"Lorestān"},"IR-23":{type:"Province",name:"Hormozgān"},"IR-22":{type:"Province",name:"Markazī"},"IR-18":{type:"Province",name:"Kohgīlūyeh va Būyer Aḩmad"},"IR-19":{type:"Province",name:"Gīlān"},"IR-30":{type:"Province",name:"Khorāsān-e Razavī"},"IR-31":{type:"Province",name:"Khorāsān-e Shemālī"},"IR-14":{type:"Province",name:"Fārs"},"IR-15":{type:"Province",name:"Kermān"},"IR-16":{type:"Province",name:"Kordestān"},"IR-17":{type:"Province",name:"Kermānshāh"},"IR-10":{type:"Province",name:"Khūzestān"},"IR-11":{type:"Province",name:"Zanjān"},"IR-12":{type:"Province",name:"Semnān"},"IR-13":{type:"Province",name:"Sīstān va Balūchestān"},"IR-24":{type:"Province",name:"Hamadān"},"IR-25":{type:"Province",name:"Yazd"},"IR-28":{type:"Province",name:"Qazvīn"},"IR-32":{type:"Province",name:"Alborz"}}},AM:{name:"Armenia",sub:{"AM-GR":{type:"Region",name:"Geġark'unik'"},"AM-SU":{type:"Region",name:"Syunik'"},"AM-AR":{type:"Region",name:"Ararat"},"AM-ER":{type:"City",name:"Erevan"},"AM-VD":{type:"Region",name:"Vayoć Jor"},"AM-KT":{type:"Region",name:"Kotayk'"},"AM-LO":{type:"Region",name:"Loṙi"},"AM-AV":{type:"Region",name:"Armavir"},"AM-TV":{type:"Region",name:"Tavuš"},"AM-AG":{type:"Region",name:"Aragac̣otn"},"AM-SH":{type:"Region",name:"Širak"}}},AL:{name:"Albania",sub:{"AL-DI":{type:"District",name:"Dibër"},"AL-KO":{type:"District",name:"Korçë"},"AL-FR":{type:"District",name:"Fier"},"AL-BR":{type:"District",name:"Berat"},"AL-BU":{type:"District",name:"Bulqizë"},"AL-MR":{type:"District",name:"Mirditë"},"AL-DR":{type:"District",
		name:"Durrës"},"AL-HA":{type:"District",name:"Has"},"AL-DV":{type:"District",name:"Devoll"},"AL-05":{type:"County",name:"Gjirokastër"},"AL-04":{type:"County",name:"Fier"},"AL-07":{type:"County",name:"Kukës"},"AL-06":{type:"County",name:"Korçë"},"AL-01":{type:"County",name:"Berat"},"AL-03":{type:"County",name:"Elbasan"},"AL-02":{type:"County",name:"Durrës"},"AL-TP":{type:"District",name:"Tropojë"},"AL-TR":{type:"District",name:"Tiranë"},"AL-09":{type:"County",name:"Dibër"},"AL-08":{type:"County",name:"Lezhë"},"AL-PG":{type:"District",name:"Pogradec"},"AL-LU":{type:"District",name:"Lushnjë"},"AL-PR":{type:"District",name:"Përmet"},"AL-TE":{type:"District",name:"Tepelenë"},"AL-PU":{type:"District",name:"Pukë"},"AL-GR":{type:"District",name:"Gramsh"},"AL-MT":{type:"District",name:"Mat"},"AL-EL":{type:"District",name:"Elbasan"},"AL-VL":{type:"District",name:"Vlorë"},"AL-KB":{type:"District",name:"Kurbin"},"AL-LB":{type:"District",name:"Librazhd"},"AL-ER":{type:"District",name:"Kolonjë"},"AL-LE":{type:"District",name:"Lezhë"},"AL-GJ":{type:"District",name:"Gjirokastër"},"AL-12":{type:"County",name:"Vlorë"},"AL-KA":{type:"District",name:"Kavajë"},"AL-10":{type:"County",name:"Shkodër"},"AL-11":{type:"County",name:"Tiranë"},"AL-MK":{type:"District",name:"Mallakastër"},"AL-KC":{type:"District",name:"Kuçovë"},"AL-SR":{type:"District",name:"Sarandë"},"AL-MM":{type:"District",name:"Malësi e Madhe"},"AL-DL":{type:"District",name:"Delvinë"},"AL-KU":{type:"District",name:"Kukës"},"AL-SH":{type:"District",name:"Shkodër"},"AL-PQ":{type:"District",name:"Peqin"},"AL-KR":{type:"District",name:"Krujë"},"AL-SK":{type:"District",name:"Skrapar"}}},AO:{name:"Angola",sub:{"AO-CUS":{type:"Province",name:"Kwanza Sul"},"AO-HUA":{type:"Province",name:"Huambo"},"AO-BIE":{type:"Province",name:"Bié"},"AO-NAM":{type:"Province",name:"Namibe"},"AO-LNO":{type:"Province",name:"Lunda Norte"},"AO-UIG":{type:"Province",name:"Uíge"},"AO-HUI":{type:"Province",name:"Huíla"},"AO-BGO":{type:"Province",name:"Bengo"},"AO-LUA":{type:"Province",name:"Luanda"},"AO-LSU":{type:"Province",name:"Lunda Sul"},"AO-CCU":{type:"Province",name:"Kuando Kubango"},"AO-MAL":{type:"Province",name:"Malange"},"AO-BGU":{type:"Province",name:"Benguela"},"AO-MOX":{type:"Province",name:"Moxico"},"AO-CNN":{type:"Province",name:"Cunene"},"AO-CNO":{type:"Province",name:"Kwanza Norte"},"AO-ZAI":{type:"Province",name:"Zaire"},"AO-CAB":{type:"Province",name:"Cabinda"}}},AQ:{name:"Antarctica",sub:{"AQ-AQ":{type:"Country",name:"Antarctica"}}},AS:{name:"American Samoa",sub:{"AS-AS":{type:"Country",name:"American Samoa"}}},AR:{name:"Argentina",sub:{"AR-Z":{type:"Province",name:"Santa Cruz"},"AR-X":{type:"Province",name:"Córdoba"},"AR-Y":{type:"Province",name:"Jujuy"},"AR-V":{type:"Province",name:"Tierra del Fuego"},"AR-W":{type:"Province",name:"Corrientes"},"AR-T":{type:"Province",name:"Tucumán"},"AR-U":{type:"Province",name:"Chubut"},"AR-R":{type:"Province",name:"Río Negro"},"AR-S":{type:"Province",name:"Santa Fe"},"AR-P":{type:"Province",name:"Formosa"},"AR-Q":{type:"Province",name:"Neuquén"},"AR-N":{type:"Province",name:"Misiones"},"AR-L":{type:"Province",name:"La Pampa"},"AR-M":{type:"Province",name:"Mendoza"},"AR-J":{type:"Province",name:"San Juan"},"AR-K":{type:"Province",name:"Catamarca"},"AR-H":{type:"Province",name:"Chaco"},"AR-F":{type:"Province",name:"La Rioja"},"AR-G":{type:"Province",name:"Santiago del Estero"},"AR-D":{type:"Province",name:"San Luis"},"AR-E":{type:"Province",name:"Entre Ríos"},"AR-B":{type:"Province",name:"Buenos Aires"},"AR-C":{type:"City",name:"Ciudad Autónoma de Buenos Aires"},"AR-A":{type:"Province",name:"Salta"}}},AU:{name:"Australia",sub:{"AU-ACT":{type:"Territory",name:"Australian Capital Territory"},"AU-QLD":{type:"State",name:"Queensland"},"AU-TAS":{type:"State",name:"Tasmania"},"AU-VIC":{type:"State",name:"Victoria"},"AU-NT":{type:"Territory",name:"Northern Territory"},"AU-WA":{type:"State",name:"Western Australia"},"AU-SA":{type:"State",name:"South Australia"},"AU-NSW":{type:"State",name:"New South Wales"}}},AT:{name:"Austria",sub:{"AT-8":{type:"Federal länder",name:"Vorarlberg"},"AT-9":{type:"Federal länder",name:"Wien"},"AT-4":{type:"Federal länder",name:"Oberösterreich"},"AT-5":{type:"Federal länder",name:"Salzburg"},"AT-6":{type:"Federal länder",name:"Steiermark"},"AT-7":{type:"Federal länder",name:"Tirol"},"AT-1":{type:"Federal länder",name:"Burgenland"},"AT-2":{type:"Federal länder",name:"Kärnten"},"AT-3":{type:"Federal länder",name:"Niederösterreich"}}},IO:{name:"British Indian Ocean Territory",sub:{"IO-IO":{type:"Country",name:"British Indian Ocean Territory"}}},IN:{name:"India",sub:{"IN-BR":{type:"State",name:"Bihar"},"IN-MZ":{type:"State",name:"Mizoram"},"IN-DD":{type:"Union territory",name:"Daman and Diu"},"IN-LD":{type:"Union territory",name:"Lakshadweep"},"IN-DN":{type:"Union territory",name:"Dadra and Nagar Haveli"},"IN-DL":{type:"Union territory",name:"Delhi"},"IN-NL":{type:"State",name:"Nagaland"},"IN-WB":{type:"State",name:"West Bengal"},"IN-HR":{type:"State",name:"Haryana"},"IN-HP":{type:"State",name:"Himachal Pradesh"},"IN-AS":{type:"State",name:"Assam"},"IN-UT":{type:"State",name:"Uttarakhand"},"IN-JH":{type:"State",name:"Jharkhand"},"IN-JK":{type:"State",name:"Jammu and Kashmir"},"IN-UP":{type:"State",name:"Uttar Pradesh"},"IN-SK":{type:"State",name:"Sikkim"},"IN-CT":{type:"State",name:"Chhattisgarh"},"IN-PY":{type:"Union territory",name:"Puducherry"},"IN-CH":{type:"Union territory",name:"Chandigarh"},"IN-GA":{type:"State",name:"Goa"},"IN-TG":{type:"State",name:"Telangana"},"IN-GJ":{type:"State",name:"Gujarat"},"IN-RJ":{type:"State",name:"Rajasthan"},"IN-MP":{type:"State",name:"Madhya Pradesh"},"IN-OR":{type:"State",name:"Odisha"},"IN-TN":{type:"State",name:"Tamil Nadu"},"IN-AN":{type:"Union territory",name:"Andaman and Nicobar Islands"},"IN-AP":{type:"State",name:"Andhra Pradesh"},"IN-TR":{type:"State",name:"Tripura"},"IN-AR":{type:"State",name:"Arunachal Pradesh"},"IN-KA":{type:"State",name:"Karnataka"},"IN-PB":{type:"State",name:"Punjab"},"IN-ML":{type:"State",name:"Meghalaya"},"IN-MN":{type:"State",name:"Manipur"},"IN-MH":{type:"State",name:"Maharashtra"},"IN-KL":{type:"State",name:"Kerala"}}},AX:{name:"Åland Islands",sub:{"AX-AX":{type:"Country",name:"Åland Islands"}}},AZ:{name:"Azerbaijan",sub:{"AZ-SBN":{type:"Rayon",name:"Şabran"},"AZ-OGU":{type:"Rayon",name:"Oğuz"},"AZ-ABS":{type:"Rayon",name:"Abşeron"},"AZ-QBA":{type:"Rayon",name:"Quba"},"AZ-FUZ":{type:"Rayon",name:"Füzuli"},"AZ-HAC":{type:"Rayon",name:"Hacıqabul"},"AZ-SKR":{type:"Rayon",name:"Şәmkir"},"AZ-AST":{type:"Rayon",name:"Astara"},"AZ-ZAQ":{type:"Rayon",name:"Zaqatala"},"AZ-QBI":{type:"Rayon",name:"Qubadlı"},"AZ-XCI":{type:"Rayon",name:"Xocalı"},"AZ-GYG":{type:"Rayon",name:"Göygöl"},"AZ-BA":{type:"Municipality",name:"Bakı"},"AZ-CUL":{type:"Rayon",name:"Culfa"},"AZ-YEV":{type:"Rayon",name:"Yevlax"},"AZ-BEY":{type:"Rayon",name:"Beyləqan"},"AZ-MAS":{type:"Rayon",name:"Masallı"},"AZ-SAB":{type:"Rayon",name:"Sabirabad"},"AZ-GOR":{type:"Rayon",name:"Goranboy"},"AZ-QAX":{type:"Rayon",name:"Qax"},"AZ-BAR":{type:"Rayon",name:"Bərdə"},"AZ-SAH":{type:"Rayon",name:"Şahbuz"},"AZ-LER":{type:"Rayon",name:"Lerik"},"AZ-SAK":{type:"Rayon",name:"Şәki"},"AZ-SAL":{type:"Rayon",name:"Salyan"},"AZ-ORD":{type:"Rayon",name:"Ordubad"},"AZ-KUR":{type:"Rayon",name:"Kürdəmir"},"AZ-GOY":{type:"Rayon",name:"Göyçay"},"AZ-NA":{type:"Municipality",name:"Naftalan"},"AZ-CAB":{type:"Rayon",name:"Cəbrayıl"},"AZ-XVD":{type:"Rayon",name:"Xocavәnd"},"AZ-LAC":{type:"Rayon",name:"Laçın"},"AZ-QOB":{type:"Rayon",name:"Qobustan"},"AZ-BAB":{type:"Rayon",name:"Babək"},"AZ-YE":{type:"Municipality",name:"Yevlax"},"AZ-BAL":{type:"Rayon",name:"Balakən"},"AZ-IMI":{type:"Rayon",name:"İmişli"},"AZ-CAL":{type:"Rayon",name:"Cəlilabad"},"AZ-LA":{type:"Municipality",name:"Lәnkәran"},"AZ-BIL":{type:"Rayon",name:"Biləsuvar"},"AZ-SMI":{type:"Rayon",name:"Şamaxı"},"AZ-SIY":{type:"Rayon",name:"Siyәzәn"},"AZ-AGU":{type:"Rayon",name:"Ağsu"},"AZ-SUS":{type:"Rayon",name:"Şuşa"},"AZ-TAR":{type:"Rayon",name:"Tәrtәr"},"AZ-AGS":{type:"Rayon",name:"Ağdaş"},"AZ-AGM":{type:"Rayon",name:"Ağdam"},"AZ-YAR":{type:"Rayon",name:"Yardımlı"},"AZ-SM":{type:"Municipality",name:"Sumqayıt"},"AZ-SA":{type:"Municipality",name:"Şәki"},"AZ-LAN":{type:"Rayon",name:"Lənkəran"},"AZ-GAD":{type:"Rayon",name:"Gədəbəy"},"AZ-QAZ":{type:"Rayon",name:"Qazax"},"AZ-GA":{type:"Municipality",name:"Gәncә"},"AZ-AGA":{type:"Rayon",name:"Ağstafa"},"AZ-SAT":{type:"Rayon",name:"Saatlı"},"AZ-AGC":{type:"Rayon",name:"Ağcabәdi"},"AZ-QUS":{type:"Rayon",name:"Qusar"},"AZ-ZAN":{type:"Rayon",name:"Zәngilan"},"AZ-SAR":{type:"Rayon",name:"Şәrur"},"AZ-UCA":{type:"Rayon",name:"Ucar"},"AZ-TOV":{type:"Rayon",name:"Tovuz"},"AZ-QAB":{type:"Rayon",name:"Qәbәlә"},"AZ-NV":{type:"Municipality",name:"Naxçıvan"},"AZ-ISM":{type:"Rayon",name:"İsmayıllı"},"AZ-SR":{type:"Municipality",name:"Şirvan"},"AZ-MI":{type:"Municipality",name:"Mingәçevir"},"AZ-NEF":{type:"Rayon",name:"Neftçala"},"AZ-KAL":{type:"Rayon",name:"Kəlbəcər"},"AZ-KAN":{type:"Rayon",name:"Kǝngǝrli"},"AZ-NX":{type:"Autonomous republic",name:"Naxçıvan"},"AZ-XAC":{type:"Rayon",name:"Xaçmaz"},"AZ-SMX":{type:"Rayon",name:"Samux"},"AZ-XA":{type:"Municipality",name:"Xankәndi"},"AZ-XIZ":{type:"Rayon",name:"Xızı"},"AZ-DAS":{type:"Rayon",name:"Daşkəsən"},"AZ-SAD":{type:"Rayon",name:"Sәdәrәk"},"AZ-ZAR":{type:"Rayon",name:"Zәrdab"}}},IE:{name:"Ireland",sub:{"IE-WD":{type:"County",name:"Port Láirge"},"IE-TA":{type:"County",name:"Tiobraid Árann"},"IE-WW":{type:"County",name:"Cill Mhantáin"},"IE-CW":{type:"County",name:"Carlow"},"IE-C":{type:"Province",name:"Connacht"},"IE-D":{type:"County",name:"Baile Átha Cliath"},"IE-G":{type:"County",name:"Gaillimh"},"IE-M":{type:"Province",name:"An Mhumhain"},"IE-L":{type:"Province",name:"Laighin"},"IE-RN":{type:"County",name:"Ros Comáin"},"IE-MO":{type:"County",name:"Maigh Eo"},"IE-MN":{type:"County",name:"Monaghan"},"IE-U":{type:"Province",name:"Ulaidh"},"IE-MH":{type:"County",name:"An Mhí"},"IE-CO":{type:"County",name:"Corcaigh"},"IE-CN":{type:"County",name:"An Cabhán"},"IE-KK":{type:"County",name:"Cill Chainnigh"},"IE-KE":{type:"County",name:"Cill Dara"},"IE-WX":{type:"County",name:"Loch Garman"},"IE-OY":{type:"County",name:"Offaly"},"IE-KY":{type:"County",name:"Ciarraí"},"IE-CE":{type:"County",name:"An Clár"},"IE-WH":{type:"County",name:"An Iarmhí"},"IE-SO":{type:"County",name:"Sligeach"},"IE-DL":{type:"County",name:"Donegal"},"IE-LS":{type:"County",name:"Laois"},"IE-LM":{type:"County",name:"Leitrim"},"IE-LK":{type:"County",name:"Limerick"},"IE-LH":{type:"County",name:"Louth"},"IE-LD":{type:"County",name:"An Longfort"}}},ID:{name:"Indonesia",sub:{"ID-JK":{type:"Special district",name:"Jakarta Raya"},"ID-SL":{type:"Geographical unit",name:"Sulawesi"},"ID-JI":{type:"Province",name:"Jawa Timur"},"ID-SM":{type:"Geographical unit",name:"Sumatera"},"ID-JB":{type:"Province",name:"Jawa Barat"},"ID-JA":{type:"Province",name:"Jambi"},"ID-NT":{type:"Province",name:"Nusa Tenggara Timur"},"ID-SA":{type:"Province",name:"Sulawesi Utara"},"ID-SB":{type:"Province",name:"Sumatera Barat"},"ID-LA":{type:"Province",name:"Lampung"},"ID-YO":{type:"Special region",name:"Yogyakarta"},"ID-ST":{type:"Province",name:"Sulawesi Tengah"},"ID-SU":{type:"Province",name:"Sumatera Utara"},"ID-JW":{type:"Geographical unit",name:"Jawa"},"ID-NB":{type:"Province",name:"Nusa Tenggara Barat"},"ID-SR":{type:"Province",name:"Sulawesi Barat"},"ID-JT":{type:"Province",name:"Jawa Tengah"},"ID-MU":{type:"Province",name:"Maluku Utara"},"ID-AC":{type:"Autonomous province",name:"Aceh"},"ID-SS":{type:"Province",name:"Sumatera Selatan"},"ID-NU":{type:"Geographical unit",name:"Nusa Tenggara"},"ID-KT":{type:"Province",name:"Kalimantan Tengah"},"ID-KU":{type:"Province",name:"Kalimantan Utara"},"ID-SG":{type:"Province",name:"Sulawesi Tenggara"},"ID-PA":{type:"Province",name:"Papua"},"ID-KR":{type:"Province",name:"Kepulauan Riau"},"ID-KS":{type:"Province",name:"Kalimantan Selatan"},"ID-RI":{type:"Province",name:"Riau"},"ID-PB":{type:"Province",name:"Papua Barat"},"ID-GO":{type:"Province",name:"Gorontalo"},"ID-MA":{type:"Province",name:"Maluku"},"ID-KA":{type:"Geographical unit",name:"Kalimantan"},"ID-KB":{type:"Province",name:"Kalimantan Barat"},"ID-KI":{type:"Province",name:"Kalimantan Timur"},"ID-ML":{type:"Geographical unit",name:"Maluku"},"ID-SN":{type:"Province",name:"Sulawesi Selatan"},"ID-BT":{type:"Province",name:"Banten"},"ID-BB":{type:"Province",name:"Bangka Belitung"},"ID-BA":{type:"Province",name:"Bali"},"ID-BE":{type:"Province",name:"Bengkulu"},"ID-PP":{type:"Geographical unit",name:"Papua"}}},UA:{name:"Ukraine",sub:{"UA-61":{type:"Region",name:"Ternopilska oblast"},"UA-21":{type:"Region",name:"Zakarpatska oblast"},"UA-23":{type:"Region",name:"Zaporizka oblast"},"UA-26":{type:"Region",name:"Ivano-Frankivska oblast"},"UA-05":{type:"Region",name:"Vinnytska oblast"},"UA-46":{type:"Region",name:"Lvivska oblast"},"UA-09":{type:"Region",name:"Luhanska oblast"},"UA-68":{type:"Region",name:"Khmelnytska oblast"},"UA-43":{type:"Republic",name:"Avtonomna Respublika Krym"},"UA-40":{type:"City",name:"Sevastopol"},"UA-65":{type:"Region",name:"Khersonska oblast"},"UA-07":{type:"Region",name:"Volynska oblast"},"UA-48":{type:"Region",name:"Mykolaivska oblast"},"UA-63":{type:"Region",name:"Kharkivska oblast"},"UA-35":{type:"Region",name:"Kirovohradska oblast"},"UA-32":{type:"Region",name:"Kyivska oblast"},"UA-30":{type:"City",name:"Kyiv"},"UA-77":{type:"Region",name:"Chernivetska oblast"},"UA-18":{type:"Region",name:"Zhytomyrska oblast"},"UA-71":{type:"Region",name:"Cherkaska oblast"},"UA-56":{type:"Region",name:"Rivnenska oblast"},"UA-51":{type:"Region",name:"Odeska oblast"},"UA-53":{type:"Region",name:"Poltavska oblast"},"UA-74":{type:"Region",name:"Chernihivska oblast"},"UA-12":{type:"Region",name:"Dnipropetrovska oblast"},"UA-59":{type:"Region",name:"Sumska oblast"},"UA-14":{type:"Region",name:"Donetska oblast"}}},QA:{name:"Qatar",sub:{"QA-MS":{type:"Municipality",name:"Ash Shamāl"},"QA-KH":{type:"Municipality",name:"Al Khawr wa adh Dhakhīrah"},"QA-ZA":{type:"Municipality",name:"Az̧ Z̧a‘āyin"},"QA-RA":{type:"Municipality",name:"Ar Rayyān"},"QA-WA":{type:"Municipality",name:"Al Wakrah"},"QA-US":{type:"Municipality",name:"Umm Şalāl"},"QA-DA":{type:"Municipality",name:"Ad Dawḩah"}}},MZ:{name:"Mozambique",sub:{"MZ-MPM":{type:"City",name:"Maputo"},"MZ-I":{type:"Province",name:"Inhambane"},"MZ-N":{type:"Province",name:"Nampula"},"MZ-L":{type:"Province",name:"Maputo"},"MZ-B":{type:"Province",name:"Manica"},"MZ-A":{type:"Province",name:"Niassa"},"MZ-G":{type:"Province",name:"Gaza"},"MZ-S":{type:"Province",name:"Sofala"},"MZ-P":{type:"Province",name:"Cabo Delgado"},"MZ-Q":{type:"Province",name:"Zambézia"},"MZ-T":{type:"Province",name:"Tete"}}}},codes={AGO:"AO",DZA:"DZ",EGY:"EG",BGD:"BD",NER:"NE",LIE:"LI",NAM:"NA",BGR:"BG",BOL:"BO",GHA:"GH",CCK:"CC",PAK:"PK",CPV:"CV",JOR:"JO",LBR:"LR",LBY:"LY",MYS:"MY",DOM:"DO",PRI:"PR",SXM:"SX",PRK:"KP",PSE:"PS",TZA:"TZ",BWA:"BW",KHM:"KH",UMI:"UM",NIC:"NI",TTO:"TT",ETH:"ET",PRY:"PY",HKG:"HK",SAU:"SA",LBN:"LB",SVN:"SI",BFA:"BF",CHE:"CH",MRT:"MR",HRV:"HR",CHL:"CL",CHN:"CN",KNA:"KN",SLE:"SL",JAM:"JM",SMR:"SM",GIB:"GI",DJI:"DJ",GIN:"GN",FIN:"FI",URY:"UY",THA:"TH",STP:"ST",SYC:"SC",NPL:"NP",CXR:"CX",LAO:"LA",YEM:"YE",BVT:"BV",ZAF:"ZA",KIR:"KI",PHL:"PH",ROU:"RO",VIR:"VI",SYR:"SY",MAC:"MO",MAF:"MF",MLT:"MT",KAZ:"KZ",TCA:"TC",PYF:"PF",NIU:"NU",DMA:"DM",BEN:"BJ",GUF:"GF",BEL:"BE",MSR:"MS",TGO:"TG",DEU:"DE",GUM:"GU",LKA:"LK",SSD:"SS",FLK:"FK",GBR:"GB",BES:"BQ",GUY:"GY",CRI:"CR",CMR:"CM",MAR:"MA",MNP:"MP",LSO:"LS",HUN:"HU",TKM:"TM",SUR:"SR",NLD:"NL",BMU:"BM",HMD:"HM",TCD:"TD",GEO:"GE",MNE:"ME",MNG:"MN",MHL:"MH",MTQ:"MQ",BLZ:"BZ",NFK:"NF",MMR:"MM",AFG:"AF",BDI:"BI",VGB:"VG",BLR:"BY",BLM:"BL",GRD:"GD",TKL:"TK",GRC:"GR",RUS:"RU",GRL:"GL",SHN:"SH",AND:"AD",MOZ:"MZ",TJK:"TJ",HTI:"HT",MEX:"MX",ZWE:"ZW",LCA:"LC",IND:"IN",LVA:"LV",BTN:"BT",VCT:"VC",VNM:"VN",NOR:"NO",CZE:"CZ",ATF:"TF",ATG:"AG",FJI:"FJ",IOT:"IO",HND:"HN",MUS:"MU",ATA:"AQ",LUX:"LU",ISR:"IL",FSM:"FM",PER:"PE",REU:"RE",IDN:"ID",VUT:"VU",MKD:"MK",COD:"CD",COG:"CG",ISL:"IS",GLP:"GP",COK:"CK",COM:"KM",COL:"CO",NGA:"NG",TLS:"TL",TWN:"TW",PRT:"PT",MDA:"MD",GGY:"GG",MDG:"MG",ECU:"EC",SEN:"SN",NZL:"NZ",MDV:"MV",ASM:"AS",SPM:"PM",CUW:"CW",FRA:"FR",LTU:"LT",RWA:"RW",ZMB:"ZM",GMB:"GM",WLF:"WF",JEY:"JE",FRO:"FO",GTM:"GT",DNK:"DK",IMN:"IM",AUS:"AU",AUT:"AT",SJM:"SJ",VEN:"VE",PLW:"PW",KEN:"KE",MYT:"YT",WSM:"WS",TUR:"TR",ALB:"AL",OMN:"OM",TUV:"TV",ALA:"AX",BRN:"BN",TUN:"TN",PCN:"PN",BRB:"BB",BRA:"BR",CIV:"CI",SRB:"RS",GNQ:"GQ",USA:"US",QAT:"QA",SWE:"SE",AZE:"AZ",GNB:"GW",SWZ:"SZ",TON:"TO",CAN:"CA",UKR:"UA",KOR:"KR",AIA:"AI",CAF:"CF",SVK:"SK",CYP:"CY",BIH:"BA",SGP:"SG",SGS:"GS",SOM:"SO",UZB:"UZ",ERI:"ER",POL:"PL",KWT:"KW",GAB:"GA",CYM:"KY",VAT:"VA",EST:"EE",MWI:"MW",ESP:"ES",IRQ:"IQ",SLV:"SV",MLI:"ML",IRL:"IE",IRN:"IR",ABW:"AW",PNG:"PG",PAN:"PA",SDN:"SD",SLB:"SB",ESH:"EH",MCO:"MC",ITA:"IT",JPN:"JP",KGZ:"KG",UGA:"UG",NCL:"NC",ARE:"AE",ARG:"AR",BHS:"BS",BHR:"BH",ARM:"AM",NRU:"NR",CUB:"CU"},functions={subdivision:function(e,a){if("undefined"==typeof a){a=e.trim().toUpperCase();var n=a.split("-");if(2!==n.length)return {};e=n[0],a=n[1];}3===e.length&&(e=codes[e]);var t=e+"-"+a;if(!(e in data))return null;var i=data[e].sub,m=i[t];if("undefined"==typeof m){for(var o in i)if(i.hasOwnProperty(o)&&i[o].name.toUpperCase()===a.toUpperCase()){m=i[o],t=o;break}if("undefined"==typeof m)return null}return m.countryName=data[e].name,m.countryCode=e,m.code=t,m.regionCode=2===t.split("-").length?t.split("-")[1]:"",m},country:function(e){if(e=e.trim().toUpperCase(),3===e.length&&(e=codes[e]),e in data){var a=data[e];return a.code=e,a}for(var n in data)if(data.hasOwnProperty(n)&&data[n].name.toUpperCase()===e.toUpperCase()){a=data[n],a.code=n;break}return "undefined"==typeof a?null:a},data:data,codes:codes};null!==module?module.exports=functions:window.iso3166=functions;})();
} (iso3166_min));
	return iso3166_minExports$1;
}

var iso3166_minExports = requireIso3166_min();
var iso3166 = /*@__PURE__*/getDefaultExportFromCjs(iso3166_minExports);

function parseOptions(regions) {
    return Object.entries(regions !== null && regions !== void 0 ? regions : [])
        .map(([id, value]) => [id === null || id === void 0 ? void 0 : id.split('-')[1], value.name])
        .sort((a, b) => { var _a; return (_a = a[1]) === null || _a === void 0 ? void 0 : _a.localeCompare(b[1]); });
}
function useRegions(country) {
    const regions = iso3166.country(country);
    const options = useMemo(() => {
        return parseOptions(regions === null || regions === void 0 ? void 0 : regions.sub);
    }, [regions === null || regions === void 0 ? void 0 : regions.sub]);
    return { options };
}

function useRegionSelect(props) {
    const { misc: strings } = useStrings();
    const { options: items } = useRegions(props.country);
    const [value, setValue] = useState(props.value);
    useEffect(() => {
        setValue('');
    }, [props.country]);
    return useInput(Select, Object.assign(Object.assign({}, props), { items,
        value, disabled: props.disabled || items.length === 0, placeholder: strings.chooseRegionOrState }));
}

const ADDRESS_MAX_LENGTH = 50;
const POST_CODE_MAX_LENGTH = 16;
const PHONE_MAX_LENGTH = 15;
const SubscriptionPurchasePanel = ({ userDetails, backUrl, purchaseSubscription, isLoading, error }) => {
    const { subscriptions: strings, accountDetails: formStrings } = useStrings();
    const address1 = useTextBox({
        id: 'address1',
        value: userDetails.userType !== 'INDEPENDENT_EMPLOYEE' ? userDetails.addressLine1 : '',
        validators: [
            [isNotEmpty(), formStrings.addressLine1.required],
            [isLength(1, ADDRESS_MAX_LENGTH), strings.addressLength(ADDRESS_MAX_LENGTH)]
        ],
        messages: [apiValidationErrorMessage(error, 'address.firstLine')]
    });
    const address2 = useTextBox({
        id: 'address2',
        value: userDetails.userType !== 'INDEPENDENT_EMPLOYEE' ? userDetails.addressLine2 : '',
        validators: [[isLength(0, ADDRESS_MAX_LENGTH), strings.addressLength(ADDRESS_MAX_LENGTH)]],
        messages: [apiValidationErrorMessage(error, 'address.secondLine')]
    });
    const address3 = useTextBox({
        id: 'address3',
        value: userDetails.userType !== 'INDEPENDENT_EMPLOYEE' ? userDetails.addressLine3 : '',
        validators: [[isLength(0, ADDRESS_MAX_LENGTH), strings.addressLength(ADDRESS_MAX_LENGTH)]],
        messages: [apiValidationErrorMessage(error, 'address.thirdLine')]
    });
    const town = useTextBox({
        id: 'town',
        value: userDetails.userType !== 'INDEPENDENT_EMPLOYEE' ? userDetails.addressCity : '',
        validators: [
            [isNotEmpty(), formStrings.town.required],
            [isLength(1, ADDRESS_MAX_LENGTH), strings.townLength(ADDRESS_MAX_LENGTH)]
        ],
        messages: [apiValidationErrorMessage(error, 'address.city')]
    });
    const postCode = useTextBox({
        id: 'postCode',
        value: userDetails.userType !== 'INDEPENDENT_EMPLOYEE' ? userDetails.addressPostCode : '',
        validators: [
            [isNotEmpty(), formStrings.postCode.required],
            [isLength(1, POST_CODE_MAX_LENGTH), strings.postCodeLength(POST_CODE_MAX_LENGTH)]
        ],
        messages: [apiValidationErrorMessage(error, 'address.postCode')]
    });
    const country = useCountrySelect({
        id: 'country',
        value: userDetails.addressCountry
    });
    const region = useRegionSelect({
        id: 'region',
        value: '',
        country: country.value,
        messages: [apiValidationErrorMessage(error, 'address.region')],
        validators: [[isNotEmpty(), formStrings.region.required]]
    });
    const callingCode = useCallingCodeSelect({
        id: 'callingCode',
        value: userDetails.addressCountry,
        validators: [[isNotEmpty(), strings.callingCodeRequired]]
    });
    const phone = useTextBox({
        id: 'phone',
        value: userDetails.userType !== 'INDEPENDENT_EMPLOYEE' ? userDetails.phone : '',
        validators: [
            [isNotEmpty(), formStrings.phone.required],
            [isNumberOrNumberWithSpaces(), formStrings.phone.numbersOnly],
            [isLength(1, PHONE_MAX_LENGTH), strings.phoneLength(PHONE_MAX_LENGTH)]
        ],
        messages: [apiValidationErrorMessage(error, 'phoneNumber')]
    });
    const form = useForm(address1, address2, address3, town, region, postCode, country, callingCode, phone);
    function submitForm(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (form.validate()) {
                purchaseSubscription({
                    addressLine1: address1.value,
                    addressLine2: address2.value,
                    addressLine3: address3.value,
                    addressCity: town.value,
                    addressRegion: region.value,
                    addressPostCode: postCode.value,
                    addressCountry: country.value,
                    countryCallingCode: callingCode.value,
                    phone: phone.value
                });
            }
        });
    }
    return React__default.createElement(Panel, { className: "SubscriptionPurchasePanel" },
        React__default.createElement(Panel.Header, { title: strings.billingInfoTitle }),
        React__default.createElement(Panel.Content, null,
            React__default.createElement("p", null, strings.billingInfoDescription),
            React__default.createElement("form", { onSubmit: submitForm },
                React__default.createElement(FormField, { input: address1, label: formStrings.addressLine1.label }),
                React__default.createElement(FormField, { input: address2, label: formStrings.addressLine2.label }),
                React__default.createElement(FormField, { input: address3, label: formStrings.addressLine3.label }),
                React__default.createElement(FormField, { input: town, label: formStrings.town.label }),
                React__default.createElement(FormField, { input: postCode, label: formStrings.postCode.label }),
                React__default.createElement(FormField, { input: country, label: formStrings.country.label }),
                React__default.createElement(FormField, { input: region, label: formStrings.region.label }),
                React__default.createElement(FormField, { input: callingCode, label: strings.callingCodeLabel }),
                React__default.createElement(FormField, { input: phone, label: formStrings.phone.label }),
                React__default.createElement(SubscriptionPurchaseButtons, { isLoading: isLoading, backUrl: backUrl }))));
};

const SubscriptionInfoPanelSkeleton = ({ hasRole }) => {
    return React__default.createElement(SkeletonContainer, { hasRole: hasRole },
        React__default.createElement(PanelSkeleton, { titleWidth: 200, hasRole: false },
            React__default.createElement(Panel.Content, null,
                React__default.createElement("div", { className: "SubscriptionInfoPanelSkeleton-text" },
                    React__default.createElement(Skeleton, { width: "50%" }),
                    React__default.createElement(Skeleton, { width: "80%" })),
                React__default.createElement(DefinitionList, { definitions: [
                        { name: React__default.createElement(Skeleton, { width: 50 }), value: React__default.createElement(Skeleton, { width: "50%" }) },
                        { name: React__default.createElement(Skeleton, { width: 100 }), value: React__default.createElement(Skeleton, { width: "90%" }) },
                        { name: React__default.createElement(Skeleton, { width: 70 }), value: React__default.createElement(Skeleton, { width: "60%" }) }
                    ] }))));
};

const SubscriptionSummaryScreenSkeleton = () => {
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(Screen, { header: React__default.createElement(ContentHeaderSkeleton, { hasRole: false }) },
            React__default.createElement(PanelGrid, null,
                React__default.createElement(SubscriptionInfoPanelSkeleton, { hasRole: false }),
                React__default.createElement(FormPanelSkeleton, { hasRole: false }))));
};

const removeWhiteSpaces = (value) => value === null || value === void 0 ? void 0 : value.replace(/\s/g, '');
function useSubscriptionPurchase(payment, errorMessage) {
    const { basePath } = useContext();
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const dispatch = useTypedDispatch();
    const navigation = useNavigation();
    const returnUrl = joinPath(window.location.origin, basePath, navigation.subscriptionPayment());
    const [purchaseSubscription, { data: pricePaymentData, isLoading: isPricePurchaseLoading, error: pricePurchaseError, reset: resetPricePurchase }] = usePurchaseSubscriptionMutation();
    const [purchaseUserSubscription, { data: userPaymentData, isLoading: isUserPurchaseLoading, error: userPurchaseError, reset: resetUserPurchase }] = usePurchaseUserSubscriptionMutation();
    return {
        purchaseSubscription: (params) => __awaiter(this, void 0, void 0, function* () {
            try {
                if (payment.type === 'price') {
                    yield purchaseSubscription(Object.assign(Object.assign({}, params), { specificity: payment.specificity, subscriptionPriceId: payment.priceId, vehicle,
                        returnUrl, phone: removeWhiteSpaces(params.phone) })).unwrap();
                }
                else {
                    yield purchaseUserSubscription(Object.assign(Object.assign({}, params), { userId: payment.userId, subscriptionId: payment.subscriptionId, returnUrl, phone: removeWhiteSpaces(params.phone) })).unwrap();
                }
            }
            catch (error) {
                if (!isApiValidationError(error)) {
                    dispatch(queueNotification(errorMessage));
                }
            }
        }),
        isLoading: isUserPurchaseLoading || isPricePurchaseLoading,
        resetPurchase: () => payment.type === 'price' ? resetPricePurchase() : resetUserPurchase(),
        paymentData: pricePaymentData !== null && pricePaymentData !== void 0 ? pricePaymentData : userPaymentData,
        error: pricePurchaseError !== null && pricePurchaseError !== void 0 ? pricePurchaseError : userPurchaseError
    };
}

const SubscriptionPaymentForm = ({ paymentData }) => {
    const formRef = useRef(null);
    const featureToggles = useFeatureToggles();
    const isGPAddressCapturePaymentsEnabled = featureToggles.isFeatureToggleEnabled('ENABLE_ADDRESS_CAPTURE_PAYMENTS');
    useEffect(() => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.submit();
    }, []);
    return React__default.createElement("form", { ref: formRef, method: "post", action: paymentData.paymentUrl },
        React__default.createElement("input", { type: "hidden", name: "AUTO_SETTLE_FLAG", value: "1" }),
        React__default.createElement("input", { type: "hidden", name: "MERCHANT_ID", value: paymentData.merchantId }),
        React__default.createElement("input", { type: "hidden", name: "ORDER_ID", value: paymentData.orderId }),
        React__default.createElement("input", { type: "hidden", name: "ACCOUNT", value: paymentData.account }),
        React__default.createElement("input", { type: "hidden", name: "AMOUNT", value: paymentData.amount }),
        React__default.createElement("input", { type: "hidden", name: "CURRENCY", value: paymentData.currency }),
        React__default.createElement("input", { type: "hidden", name: "TIMESTAMP", value: paymentData.timestamp }),
        React__default.createElement("input", { type: "hidden", name: "SHA1HASH", value: paymentData.sha1Hash }),
        React__default.createElement("input", { type: "hidden", name: "MERCHANT_RESPONSE_URL", value: paymentData.merchantResponseUrl }),
        React__default.createElement("input", { type: "hidden", name: "COMMENT1", value: paymentData.comment }),
        React__default.createElement("input", { type: "hidden", name: "HPP_CUSTOMER_EMAIL", value: paymentData.customerEmail }),
        isGPAddressCapturePaymentsEnabled ? (React__default.createElement("input", { type: "hidden", name: "HPP_CAPTURE_ADDRESS", value: "true" })) : React__default.createElement(React__default.Fragment, null,
            React__default.createElement("input", { type: "hidden", name: "HPP_CUSTOMER_PHONENUMBER_MOBILE", value: paymentData.customerPhone }),
            React__default.createElement("input", { type: "hidden", name: "HPP_CUSTOMER_PHONENUMBER_WORK", value: paymentData.customerPhone }),
            React__default.createElement("input", { type: "hidden", name: "HPP_BILLING_STREET1", value: paymentData.billingStreet1 }),
            React__default.createElement("input", { type: "hidden", name: "HPP_BILLING_STREET2", value: paymentData.billingStreet2 }),
            React__default.createElement("input", { type: "hidden", name: "HPP_BILLING_STREET3", value: paymentData.billingStreet3 }),
            React__default.createElement("input", { type: "hidden", name: "HPP_BILLING_CITY", value: paymentData.billingCity }),
            React__default.createElement("input", { type: "hidden", name: "HPP_BILLING_STATE", value: paymentData.billingState }),
            React__default.createElement("input", { type: "hidden", name: "HPP_BILLING_POSTALCODE", value: paymentData.billingPostCode }),
            React__default.createElement("input", { type: "hidden", name: "HPP_BILLING_COUNTRY", value: paymentData.billingCountry }),
            React__default.createElement("input", { type: "hidden", name: "HPP_CAPTURE_ADDRESS", value: "false" })),
        React__default.createElement("input", { type: "hidden", name: "HPP_CHALLENGE_REQUEST_INDICATOR", value: "NO_PREFERENCE" }),
        React__default.createElement("input", { type: "hidden", name: "HPP_VERSION", value: "2" }),
        React__default.createElement("input", { type: "hidden", name: "HPP_DO_NOT_RETURN_ADDRESS", value: "true" }),
        React__default.createElement("input", { type: "hidden", name: "HPP_REMOVE_SHIPPING", value: "true" }));
};

const SubscriptionPaymentRedirectDialogue = ({ paymentData, onCancel }) => {
    const { subscriptions: strings, buttons: buttonStrings } = useStrings();
    const [redirect, setRedirect] = useState(false);
    return React__default.createElement(ConfirmDialogue, { isOpen: paymentData !== undefined, title: strings.continueToPaymentTitle, confirmTitle: buttonStrings.continue, onConfirm: () => setRedirect(true), onCancel: onCancel },
        strings.continueToPaymentDescription,
        redirect && paymentData && React__default.createElement(SubscriptionPaymentForm, { paymentData: paymentData }));
};

const SubscriptionSummaryScreen = ({ specificity, subscription, payment, backUrl }) => {
    const { subscriptions: strings, account: accountStrings } = useStrings();
    const user = useTypedSelector(selectCurrentUser);
    const { data: userDetails, error } = useGetUserDetailsQuery(user ? user.type : queryExports.skipToken);
    const errorMessage = useApiErrorMessage(accountStrings.loadError, error);
    const featureToggles = useFeatureToggles();
    const showBillingInfoForm = !featureToggles.isFeatureToggleEnabled('ENABLE_ADDRESS_CAPTURE_PAYMENTS');
    usePageTitle(strings.purchaseSummaryTitle(subscription.name));
    const { purchaseSubscription, resetPurchase, paymentData, isLoading, error: purchaseSubscriptionError } = useSubscriptionPurchase(payment, strings.purchaseError);
    if (!user) {
        return null;
    }
    else if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!userDetails) {
        return React__default.createElement(SubscriptionSummaryScreenSkeleton, null);
    }
    const header = React__default.createElement(ContentHeader, { backUrl: backUrl },
        React__default.createElement(ContentHeader.Title, { title: strings.purchaseSummaryTitle(subscription.name) }));
    return React__default.createElement(Screen, { className: "SubscriptionSummaryScreen", header: header },
        React__default.createElement(PanelGrid, { singleColumn: true },
            React__default.createElement(SubscriptionOrderSummaryPanel, { subscription: subscription }),
            (() => {
                if (payment.type === 'price' && subscription.approvalRequired) {
                    return React__default.createElement(SubscriptionApprovalPanel, { specificity: specificity, subscriptionId: subscription.id, backUrl: backUrl });
                }
                if (showBillingInfoForm) {
                    return React__default.createElement(SubscriptionPurchasePanel, { userDetails: userDetails, backUrl: backUrl, isLoading: isLoading, error: purchaseSubscriptionError, purchaseSubscription: purchaseSubscription });
                }
                return React__default.createElement(SubscriptionPurchaseButtons, { purchaseSubscription: purchaseSubscription, isLoading: isLoading, backUrl: backUrl });
            })(),
            React__default.createElement(SubscriptionPaymentRedirectDialogue, { paymentData: paymentData, onCancel: resetPurchase })));
};

function getPricePayment(specificity, priceId) {
    return {
        type: 'price',
        specificity,
        priceId
    };
}
function getUserPayment(userId, subscriptionId) {
    return {
        type: 'user',
        userId,
        subscriptionId
    };
}

const UserSubscriptionPaymentScreen = () => {
    const { subscription: strings } = useStrings();
    const navigation = useNavigation();
    const user = useTypedSelector(selectCurrentUser);
    const { subscriptionId } = useParams();
    const isValidRequest = user && subscriptionId && isNumeric(subscriptionId);
    const { data: subscription, error: subscriptionError } = useGetUserSubscriptionQuery(isValidRequest ? {
        userId: user.id,
        subscriptionId
    } : queryExports.skipToken);
    const { data: price, error: priceError } = useGetSubscriptionPriceQuery((subscription === null || subscription === void 0 ? void 0 : subscription.priceId) ? { subscriptionPriceId: subscription === null || subscription === void 0 ? void 0 : subscription.priceId } : queryExports.skipToken);
    const subscriptionErrorMessage = useApiErrorMessage(strings.loadError, subscriptionError, {
        404: strings.notFound
    });
    const priceErrorMessage = useApiErrorMessage(strings.loadError, priceError);
    const errorMessage = subscriptionErrorMessage !== null && subscriptionErrorMessage !== void 0 ? subscriptionErrorMessage : priceErrorMessage;
    if (!isValidRequest) {
        return React__default.createElement(NotFoundScreen, null);
    }
    else if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!subscription) {
        return React__default.createElement(SubscriptionSummaryScreenSkeleton, null);
    }
    else if (subscription.hasExpired) {
        return React__default.createElement(Screen, { errorText: strings.cannotPurchase });
    }
    else if (subscription.isEnabled) {
        return React__default.createElement(Screen, { errorText: strings.alreadyPurchased });
    }
    else if (subscription.priceId === undefined) {
        return React__default.createElement(Screen, { errorText: strings.cannotPurchase });
    }
    else if (!price) {
        return React__default.createElement(SubscriptionSummaryScreenSkeleton, null);
    }
    return React__default.createElement(SubscriptionSummaryScreen, { specificity: getGlobalSpecificity(), subscription: price, payment: getUserPayment(user.id, subscription.id), backUrl: navigation.userSubscriptions() });
};

const SubscriptionPaymentReturnScreenSkeleton = () => {
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(Screen, { header: React__default.createElement(ContentHeaderSkeleton, { hasRole: false }) },
            React__default.createElement(PanelGrid, null,
                React__default.createElement(SubscriptionInfoPanelSkeleton, { hasRole: false }),
                React__default.createElement(FormPanelSkeleton, { hasRole: false }))));
};

const PAYMENT_SUCCESS = 0;
const SubscriptionPaymentReturnScreen = () => {
    const { subscriptions: strings, subscription: subscriptionStrings } = useStrings();
    const navigation = useNavigation();
    const user = useTypedSelector(selectCurrentUser);
    const location = useLocation();
    const { paymentId, subscriptionId, resultCode: queryResultCode } = queryString.parse(location.search);
    const resultCode = typeof queryResultCode === 'string' && parseInt(queryResultCode);
    const isValidRequest = user &&
        typeof paymentId === 'string' && isNumeric(paymentId) &&
        typeof subscriptionId === 'string' && isNumeric(subscriptionId) &&
        typeof resultCode === 'number' && !isNaN(resultCode);
    const success = isValidRequest && resultCode === PAYMENT_SUCCESS;
    const message = isValidRequest ? getResultMessage(resultCode, strings) : strings.payment.invalidConfiguration;
    const title = success ? strings.purchaseSuccessful : strings.purchaseFailed;
    usePageTitle(title);
    const { data: subscription, error: subscriptionError } = useGetUserSubscriptionQuery(isValidRequest ? {
        userId: user.id,
        subscriptionId: subscriptionId
    } : queryExports.skipToken);
    const { data: price, error: priceError } = useGetSubscriptionPriceQuery((subscription === null || subscription === void 0 ? void 0 : subscription.priceId) ? { subscriptionPriceId: subscription === null || subscription === void 0 ? void 0 : subscription.priceId } : queryExports.skipToken);
    const subscriptionErrorMessage = useApiErrorMessage(subscriptionStrings.loadError, subscriptionError, {
        404: subscriptionStrings.notFound
    });
    const priceErrorMessage = useApiErrorMessage(subscriptionStrings.loadError, priceError);
    const errorMessage = subscriptionErrorMessage !== null && subscriptionErrorMessage !== void 0 ? subscriptionErrorMessage : priceErrorMessage;
    if (!isValidRequest) {
        return React__default.createElement(NotFoundScreen, null);
    }
    else if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!subscription || (subscription.priceId && !price)) {
        return React__default.createElement(SubscriptionPaymentReturnScreenSkeleton, null);
    }
    const header = React__default.createElement(ContentHeader, null,
        React__default.createElement(ContentHeader.Title, { title: title }));
    return React__default.createElement(Screen, { className: "SubscriptionPaymentReturnScreen", header: header },
        React__default.createElement(PanelGrid, null,
            React__default.createElement(Panel, { variant: success ? 'info' : 'warning' },
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(Text, null, message))),
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Header, { title: strings.orderDetails }, subscription.invoiceUrl && React__default.createElement(ButtonLink, { href: subscription.invoiceUrl }, strings.generateInvoiceButton)),
                React__default.createElement(Panel.Content, null,
                    price ? React__default.createElement(SubscriptionInfo, { subscription: price, showName: true })
                        : React__default.createElement(UserSubscriptionInfo, { subscription: subscription, showName: true }),
                    React__default.createElement("h4", null, strings.orderHelpTitle),
                    React__default.createElement(Text, null, success ? strings.successfulOrderHelpText(navigation.contact(), paymentId)
                        : strings.failedOrderHelpText(navigation.contact(), paymentId, String(resultCode)))))));
};
function getResultMessage(resultCode, strings) {
    const messages = new Map();
    messages.set(PAYMENT_SUCCESS, strings.payment.approved);
    messages.set(101, strings.payment.declined);
    messages.set(102, strings.payment.referral);
    messages.set(103, strings.payment.cardLostOrStolen);
    messages.set(107, strings.payment.rejected);
    messages.set(110, strings.payment.notPermitted3dSecure);
    messages.set(508, strings.payment.invalidConfiguration);
    const message = messages.get(resultCode);
    if (message) {
        return message;
    }
    else if (resultCode >= 100 && resultCode < 200) {
        return strings.payment.declined;
    }
    else {
        return strings.payment.invalidConfiguration;
    }
}

const AccountRouter = () => {
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { path: "disabled", element: isLoggedIn ? React__default.createElement(NotFoundScreen, null) : React__default.createElement(AccountDisabledScreen, null) }),
        React__default.createElement(Route, { element: React__default.createElement(RouteAccess, { access: "users" }) },
            React__default.createElement(Route, { path: "subscriptions/:subscriptionId", element: React__default.createElement(UserSubscriptionPaymentScreen, null) }),
            React__default.createElement(Route, { path: "subscription-payment", element: React__default.createElement(SubscriptionPaymentReturnScreen, null) }),
            React__default.createElement(Route, { path: "*", element: React__default.createElement(AccountScreen, null) })));
};

function getInputAdornmentUtilityClass(slot) {
  return generateUtilityClass('MuiInputAdornment', slot);
}
const inputAdornmentClasses = generateUtilityClasses('MuiInputAdornment', ['root', 'filled', 'standard', 'outlined', 'positionStart', 'positionEnd', 'disablePointerEvents', 'hiddenLabel', 'sizeSmall']);
var inputAdornmentClasses$1 = inputAdornmentClasses;

var _span;
const _excluded$k = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];
const overridesResolver$1 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, styles[`position${capitalize(ownerState.position)}`], ownerState.disablePointerEvents === true && styles.disablePointerEvents, styles[ownerState.variant]];
};
const useUtilityClasses$i = ownerState => {
  const {
    classes,
    disablePointerEvents,
    hiddenLabel,
    position,
    size,
    variant
  } = ownerState;
  const slots = {
    root: ['root', disablePointerEvents && 'disablePointerEvents', position && `position${capitalize(position)}`, variant, hiddenLabel && 'hiddenLabel', size && `size${capitalize(size)}`]
  };
  return composeClasses(slots, getInputAdornmentUtilityClass, classes);
};
const InputAdornmentRoot = styled('div', {
  name: 'MuiInputAdornment',
  slot: 'Root',
  overridesResolver: overridesResolver$1
})(({
  theme,
  ownerState
}) => _extends({
  display: 'flex',
  height: '0.01em',
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: '2em',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  color: (theme.vars || theme).palette.action.active
}, ownerState.variant === 'filled' && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${inputAdornmentClasses$1.positionStart}&:not(.${inputAdornmentClasses$1.hiddenLabel})`]: {
    marginTop: 16
  }
}, ownerState.position === 'start' && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, ownerState.position === 'end' && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, ownerState.disablePointerEvents === true && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: 'none'
}));
const InputAdornment = /*#__PURE__*/React.forwardRef(function InputAdornment(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiInputAdornment'
  });
  const {
      children,
      className,
      component = 'div',
      disablePointerEvents = false,
      disableTypography = false,
      position,
      variant: variantProp
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$k);
  const muiFormControl = useFormControl() || {};
  let variant = variantProp;
  if (variantProp && muiFormControl.variant) {
    if (process.env.NODE_ENV !== 'production') {
      if (variantProp === muiFormControl.variant) {
        console.error('MUI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }
  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }
  const ownerState = _extends({}, props, {
    hiddenLabel: muiFormControl.hiddenLabel,
    size: muiFormControl.size,
    disablePointerEvents,
    position,
    variant
  });
  const classes = useUtilityClasses$i(ownerState);
  return /*#__PURE__*/jsx(FormControlContext.Provider, {
    value: null,
    children: /*#__PURE__*/jsx(InputAdornmentRoot, _extends({
      as: component,
      ownerState: ownerState,
      className: clsx$1(classes.root, className),
      ref: ref
    }, other, {
      children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/jsx(Typography, {
        color: "text.secondary",
        children: children
      }) : /*#__PURE__*/jsxs(React.Fragment, {
        children: [position === 'start' ? ( /* notranslate needed while Google Translate will not fix zero-width space issue */_span || (_span = /*#__PURE__*/jsx("span", {
          className: "notranslate",
          children: "\u200B"
        }))) : null, children]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" ? InputAdornment.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: PropTypes.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(['end', 'start']).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var MuiInputAdornment = InputAdornment;

var faCamera = {};

var hasRequiredFaCamera;

function requireFaCamera () {
	if (hasRequiredFaCamera) return faCamera;
	hasRequiredFaCamera = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'camera';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f030';
		var svgPathData = 'M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faCamera = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faCamera));
	return faCamera;
}

var faCameraExports = requireFaCamera();

const acceptedImageTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/jpg'];
const imageType = 'image/jpeg';
const vprErrorTypes = {
    notRecognised: 'notRecognised',
    wrongFileFormat: 'wrongFileFormat',
    serviceError: 'serviceError'
};
function processFile(file, imageType, token, vprUrl) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        if (!token || !vprUrl) {
            return {
                error: vprErrorTypes.serviceError
            };
        }
        if (file && acceptedImageTypes.includes(file.type)) {
            const readFileEvent = yield readFileProcess(file);
            if (!((_a = readFileEvent.target) === null || _a === void 0 ? void 0 : _a.result)) {
                return {
                    error: vprErrorTypes.serviceError
                };
            }
            const blob = new Blob([readFileEvent.target.result]);
            window.URL = window.URL || window.webkitURL;
            const blobURL = window.URL.createObjectURL(blob);
            const image = yield addImageProcess(blobURL);
            const compressed = compressImage(image, imageType, () => {
                return {
                    error: vprErrorTypes.serviceError
                };
            });
            if (!compressed) {
                return {
                    error: vprErrorTypes.serviceError
                };
            }
            const compressedBlob = dataURItoBlob(compressed);
            const { target: compressedFile } = yield readFileProcess(compressedBlob, true);
            if (!(compressedFile === null || compressedFile === void 0 ? void 0 : compressedFile.result)) {
                return {
                    error: vprErrorTypes.serviceError
                };
            }
            const encoded = compressedFile.result
                .toString()
                .replace(/^data:(.*,)?/, '');
            return encoded;
        }
        return {
            error: vprErrorTypes.wrongFileFormat
        };
    });
}
function readFileProcess(file, isBlob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        if (isBlob) {
            reader.readAsDataURL(file);
        }
        else {
            reader.readAsArrayBuffer(file);
        }
        reader.onerror = reject;
        reader.onload = resolve;
    });
}
function addImageProcess(src) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = src;
    });
}
function compressImage(img, imageType, onError) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    if (ctx) {
        ctx.drawImage(img, 0, 0, img.width, img.height);
        return canvas.toDataURL(imageType, 0.7);
    }
    else {
        onError();
    }
}
function dataURItoBlob(dataURI) {
    // Decoding Base64 string extracted from the supplied data URI
    const byteString = atob(dataURI.split(',')[1]);
    // Pull mime type from data URI
    const mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split('')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
}

const VehiclePlateRecognition = ({ onVinResult, vprUrl }) => {
    const { vehiclePlateRecognition: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const fileInputRef = useRef(null);
    const [getVprToken, { isFetching: isFetchingToken }] = useLazyGetVprTokenQuery();
    const [getTextFromImage, { isFetching: isFetchingVin }] = useLazyGetTextFromImageQuery();
    const loading = isFetchingToken || isFetchingVin;
    const handleResetInput = () => {
        var _a;
        if ((_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.value) {
            fileInputRef.current.value = '';
        }
    };
    function loadVinFromImage(file) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { token } = yield getVprToken().unwrap();
                const base64String = yield processFile(file, imageType, token, vprUrl);
                if (typeof base64String !== 'string') {
                    return dispatch(queueNotification(strings.wrongFileFormat));
                }
                const result = yield getTextFromImage({
                    base64String,
                    fileType: imageType,
                    token,
                    vprUrl
                }).unwrap();
                if ('vin' in result) {
                    onVinResult(result.vin);
                }
                else {
                    dispatch(queueNotification(strings.notRecognised));
                }
            }
            catch (_a) {
                dispatch(queueNotification(strings.serviceError));
            }
            finally {
                handleResetInput();
            }
        });
    }
    return (React__default.createElement("div", { className: "VehiclePlateRecognition" },
        React__default.createElement(IconButton$2, { className: "VehiclePlateRecognition-button", loading: loading, icon: faCameraExports.faCamera, title: strings.title, iconSize: "lg", onClick: () => { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }),
        React__default.createElement("input", { className: "VehiclePlateRecognition-input", type: "file", accept: "image/*", ref: fileInputRef, onChange: event => {
                event.target.files && loadVinFromImage(event.target.files[0]);
            } })));
};

const VinSelectDialogue = ({ vehicles, onClose }) => {
    const { vehicleLookup: strings } = useStrings();
    const vinResolver = useVinResolver();
    const navigation = useNavigation();
    const [isOpen, setIsOpen] = useState(vehicles.length > 0);
    useEffect(() => {
        setIsOpen(vehicles.length > 0);
    }, [vehicles]);
    return React__default.createElement(Dialogue, { className: className$F(), ariaLabel: strings.selectVinTitle, isOpen: isOpen, onClose: () => setIsOpen(false), onClosed: onClose },
        React__default.createElement(Dialogue.Header, { title: strings.selectVinTitle, onClose: () => setIsOpen(false) },
            React__default.createElement("p", null, strings.selectVinMessage)),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement("ul", null, vehicles.map(vehicle => React__default.createElement("li", { key: getVehicleId(vehicle) },
                React__default.createElement(Link$1, { href: navigation.vehicle(vehicle), ariaLabel: vehicle.name, onClick: onClose },
                    vehicle.imageUrl && React__default.createElement("img", { src: vehicle.imageUrl, alt: vehicle.name }),
                    React__default.createElement("div", { className: className$F('text') },
                        React__default.createElement("div", { className: className$F('title') },
                            vehicle.name,
                            " ",
                            vehicle.year && `(${vehicle.year})`),
                        vehicle.code && React__default.createElement("div", { className: className$F('subtitle') }, vehicle.code),
                        React__default.createElement("div", { className: className$F('subtitle') }, vinResolver(vehicle.vin)))))))));
};
const className$F = createClassName('VinSelectDialogue');

const IncorrectVinDialogue = ({ isOpen, onClose }) => {
    const { vehicleLookup: strings, buttons } = useStrings();
    const dialogueButtons = [React__default.createElement(Button$2, { key: "close-search-dialogue", onClick: onClose }, buttons.close)];
    return React__default.createElement(Dialogue, { ariaLabel: strings.incorrectVinDialogueTitle, isOpen: isOpen },
        React__default.createElement(Dialogue.Header, { title: strings.incorrectVinDialogueTitle }),
        React__default.createElement(Dialogue.Content, null, strings.incorrectVinDialogueMessage),
        React__default.createElement(Dialogue.Footer, { buttons: dialogueButtons }));
};

const VinSearch = ({ inputRef, showModelSelection }) => {
    const { vehicleLookup: strings } = useStrings();
    const [getVehicles, { isLoading }] = useLazyGetVehiclesByVinQuery();
    const navigation = useNavigation();
    const navigate = useNavigate();
    const [vin, setVin] = useState('');
    const [showIncorrectVinDialog, setShowIncorrectVinDialog] = useState(false);
    const { vehiclePlateRecognitionEndpoint, allowExactVehicleSelectionForSerialLookups, showModelSelectionWhenVinNotFound, japaneseVin } = useContext();
    const country = getOptionalLanguageCode(useTypedSelector(selectLocale));
    const language = getPrimaryLanguageCode(useTypedSelector(selectLocale));
    const shouldValidateVin = country === 'JP' && Boolean(japaneseVin === null || japaneseVin === void 0 ? void 0 : japaneseVin.pattern);
    const isVprEnabled = useFeatureToggles().isFeatureToggleEnabled('VEHICLE_PLATE_RECOGNITION');
    const isUserLoggedIn = useTypedSelector(selectIsLoggedIn);
    const isVprUiEnabled = isUserLoggedIn && isVprEnabled && vehiclePlateRecognitionEndpoint && !isLoading && !showIncorrectVinDialog;
    const [vehicles, setVehicles] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    function onChange(event) {
        setErrorMessage('');
        setVin(event.target.value);
    }
    function onKeyDown(event) {
        if (event.key === 'Enter') {
            checkVin();
        }
    }
    function findVehicle(value = vin) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!value) {
                return;
            }
            try {
                const vehicles = yield getVehicles(value).unwrap();
                if (vehicles.length === 0) {
                    return setErrorMessage(strings.vinNotFound);
                }
                if (vehicles.length === 1) {
                    return navigate(navigation.vehicle(vehicles[0]));
                }
                if (allowExactVehicleSelectionForSerialLookups) {
                    return setVehicles(vehicles);
                }
                setErrorMessage(strings.multipleVinMatch);
            }
            catch (error) {
                if (isFetchBaseQueryError(error) && error.status === 404) {
                    if (showModelSelectionWhenVinNotFound && showModelSelection) {
                        setErrorMessage(strings.vinNotFoundTryModelSelection);
                        return showModelSelection();
                    }
                    return setErrorMessage(strings.vinNotFound);
                }
                setErrorMessage(strings.findError);
            }
        });
    }
    function checkVin() {
        if (vin === '') {
            return;
        }
        if (shouldValidateVin && japaneseVin && !japaneseVin.pattern.test(vin)) {
            setShowIncorrectVinDialog(true);
        }
        else {
            findVehicle(vin);
        }
    }
    function closeIncorrectVinDialog() {
        setShowIncorrectVinDialog(false);
    }
    function getLabel() {
        var _a;
        if (shouldValidateVin && (japaneseVin === null || japaneseVin === void 0 ? void 0 : japaneseVin.label)) {
            const langObj = japaneseVin.label;
            if (Object.keys(langObj).includes(language)) {
                const labels = (_a = japaneseVin.label[language]) !== null && _a !== void 0 ? _a : [];
                return labels.map(item => React__default.createElement("div", { key: v4() }, item));
            }
        }
        return isUserLoggedIn ? strings.enterVin : strings.enterVinAsGuest;
    }
    return React__default.createElement("div", { className: "VinSearch" },
        React__default.createElement("label", { htmlFor: "VinSearch-input" }, getLabel()),
        React__default.createElement(TextField$1, { id: "VinSearch-input", inputRef: inputRef, variant: "outlined", value: vin, onChange: onChange, onKeyDown: onKeyDown, fullWidth: true, error: Boolean(errorMessage), InputProps: {
                endAdornment: React__default.createElement(MuiInputAdornment, { position: "end" },
                    isLoading && React__default.createElement(CircularProgress, { size: 20, className: "VinSearch-loading" }),
                    isVprUiEnabled &&
                        React__default.createElement(VehiclePlateRecognition, { onVinResult: vin => {
                                setVin(vin);
                                findVehicle(vin);
                            }, vprUrl: vehiclePlateRecognitionEndpoint }))
            }, inputProps: {
                maxLength: 17
            } }),
        React__default.createElement("div", { className: "VinSearch-footer" },
            React__default.createElement("div", { className: "VinSearch-error" },
                React__default.createElement(Text, null, errorMessage)),
            React__default.createElement(Button$2, { disabled: vin === '' || isLoading, onClick: () => checkVin() }, strings.findButton)),
        shouldValidateVin && React__default.createElement(IncorrectVinDialogue, { isOpen: showIncorrectVinDialog, onClose: closeIncorrectVinDialog }),
        allowExactVehicleSelectionForSerialLookups && React__default.createElement(VinSelectDialogue, { vehicles: vehicles, onClose: () => setVehicles([]) }));
};

const LookupSelect = ({ id, value, placeholder, loading, disabled, readOnly, className, disableClearable = true, onChange, options }) => {
    const classes = classNames('LookupSelect', className);
    const { buttons: strings } = useStrings();
    return (React__default.createElement(FormControl$1, { className: classes, variant: "outlined", fullWidth: true, size: "small" },
        React__default.createElement(Autocomplete$1, { id: id, value: options.find(({ id }) => id === value), options: options, loading: loading, disabled: disabled, readOnly: readOnly, clearOnBlur: true, clearText: strings.clear, disableClearable: disableClearable, autoHighlight: true, isOptionEqualToValue: (option, value) => (option === null || option === void 0 ? void 0 : option.id) === (value === null || value === void 0 ? void 0 : value.id), onChange: (_event, value) => onChange(value === null || value === void 0 ? void 0 : value.id), renderInput: params => (React__default.createElement(TextField$1, Object.assign({}, params, { InputProps: Object.assign(Object.assign({}, params.InputProps), { placeholder, className: readOnly ? 'Mui-disabled' : undefined, endAdornment: (React__default.createElement(React__default.Fragment, null,
                        loading && (React__default.createElement(MuiInputAdornment, { position: "end" },
                            React__default.createElement(CircularProgress, { size: 16 }))),
                        params.InputProps.endAdornment)) }) }))), classes: { endAdornment: readOnly ? 'Mui-disabled LookupSelect-endAdornment' : undefined }, openOnFocus: true, size: "small", openText: strings.open, closeText: strings.close })));
};

const ProductSelect = ({ id, productId, selectedId, isLoading, isDisabled, onSelect }) => {
    const { vehicleLookup: strings } = useStrings();
    const product = useTypedSelector(selectProduct(productId));
    const children = useTypedSelector(state => selectProductChildren(state, productId));
    const isOptional = product === null || product === void 0 ? void 0 : product.actions.includes('LOOKUP_TARGET');
    const initialOptionValue = '-1';
    if (!children || children.length === 0) {
        return null;
    }
    function onChange(value) {
        onSelect(value && value !== initialOptionValue ? value : null);
    }
    const hasSingleChild = children.length === 1;
    const selectedValue = hasSingleChild ? children[0].id : selectedId !== null && selectedId !== void 0 ? selectedId : initialOptionValue;
    const options = children.map(child => ({ id: child.id, label: child.name }));
    return (React__default.createElement(LookupSelect, { id: id, className: "ProductSelect", value: selectedValue, loading: isLoading, disabled: isDisabled, readOnly: hasSingleChild, onChange: onChange, options: options, placeholder: isOptional ? strings.selectOptionalProduct : strings.selectProduct, disableClearable: !isOptional }));
};

const ProductYearSelect = ({ productId, selectedYear, isDisabled, onSelect }) => {
    const { vehicleLookup: strings } = useStrings();
    const years = useTypedSelector(selectProductYears(productId));
    const initialOptionValue = '-1';
    function onChange(value) {
        const year = parseInt(value);
        onSelect(value !== initialOptionValue && !isNaN(year) ? year : null);
    }
    if (!years || years.length === 0) {
        return null;
    }
    const hasSingleYear = years.length === 1;
    const selectedValue = hasSingleYear ? years[0] : selectedYear !== null && selectedYear !== void 0 ? selectedYear : initialOptionValue;
    const options = years.map(year => ({ id: year.toString(), label: year.toString() }));
    return (React__default.createElement(LookupSelect, { id: "ProductYearSelect", className: "ProductYearSelect", value: String(selectedValue), disabled: isDisabled, readOnly: hasSingleYear, onChange: onChange, options: options, placeholder: strings.selectYear, disableClearable: false }));
};

const ProductLookupForm = ({ lookupPath, selectableProduct, onUpdatePath, onChooseProduct }) => {
    const { vehicleLookup: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const rootElement = useRef(null);
    const year = useTypedSelector(selectSelectedProductYear);
    const loadingIndex = useTypedSelector(selectProductLookupPathLoadingIndex);
    const canSelectYear = useFeatureToggles().isFeatureToggleEnabled('ENABLE_PRODUCT_LOOKUP_YEAR');
    function selectProduct(index, productId) {
        onUpdatePath(index, productId);
    }
    return React__default.createElement("div", { className: "ProductLookupForm", ref: rootElement },
        lookupPath.map((productId, index) => React__default.createElement(Fragment, { key: productId },
            index === 0 && React__default.createElement("label", { htmlFor: `ProductLookupForm-${index}` }, strings.chooseVehicle),
            React__default.createElement(ProductSelect, { id: `ProductLookupForm-${index}`, productId: productId, selectedId: lookupPath[index + 1], isLoading: index === loadingIndex, isDisabled: loadingIndex !== null && index > loadingIndex, onSelect: selectedId => selectProduct(index, selectedId) }))),
        canSelectYear && selectableProduct && React__default.createElement(ProductYearSelect, { productId: selectableProduct.id, selectedYear: year, isDisabled: loadingIndex !== null, onSelect: year => dispatch(setSelectedYear(year)) }),
        React__default.createElement("div", { className: "ProductLookupForm-footer" },
            React__default.createElement(Button$2, { disabled: !selectableProduct, onClick: () => onChooseProduct(year) }, strings.chooseButton)));
};

const ProductLookup = ({ show, onLookupPathUpdate }) => {
    const dispatch = useTypedDispatch();
    const { vehicleLookup: strings } = useStrings();
    const navigation = useNavigation();
    const navigate = useNavigate();
    const [updateLookupPathStatus, setUpdateLookupPathStatus] = useState('pending');
    const lookupPath = useTypedSelector(selectProductLookupPath);
    const selectableProduct = useTypedSelector(selectSelectableProduct);
    const lookupType = useTypedSelector(selectProductLookupType);
    const doUpdateProductLookupPath = useCallback((arg) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setUpdateLookupPathStatus('pending');
            yield dispatch(updateProductLookupPath(arg)).unwrap();
            setUpdateLookupPathStatus('fulfilled');
        }
        catch (_a) {
            setUpdateLookupPathStatus('rejected');
        }
    }), [dispatch]);
    useEffect(() => {
        doUpdateProductLookupPath(null);
    }, [doUpdateProductLookupPath]);
    useEffect(() => {
        onLookupPathUpdate(updateLookupPathStatus);
    }, [updateLookupPathStatus, onLookupPathUpdate]);
    function updatePath(fromIndex, productId) {
        doUpdateProductLookupPath({
            fromIndex,
            productId
        });
    }
    function chooseProduct(year) {
        if (selectableProduct) {
            navigate(navigation.vehicle({
                ref: 'product',
                productVariantId: selectableProduct.id,
                year: year !== null && year !== void 0 ? year : undefined
            }));
        }
    }
    if (updateLookupPathStatus !== 'rejected' && (!show || lookupType === 'noProducts' || lookupPath.length === 0)) {
        return null;
    }
    return React__default.createElement("div", { className: "ProductLookup" }, (() => {
        if (updateLookupPathStatus === 'rejected') {
            return React__default.createElement("div", { className: "ProductLookup-error" }, strings.loadProductsError);
        }
        else {
            return React__default.createElement(ProductLookupForm, { lookupPath: lookupPath, selectableProduct: selectableProduct, onUpdatePath: updatePath, onChooseProduct: chooseProduct });
        }
    })());
};

var faClock = {};

var hasRequiredFaClock;

function requireFaClock () {
	if (hasRequiredFaClock) return faClock;
	hasRequiredFaClock = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'clock';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f017';
		var svgPathData = 'M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faClock = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faClock));
	return faClock;
}

var faClockExports = requireFaClock();

const VehicleHistoryList = ({ removeButtonTitle, vehicles, emptyText, removeRecord }) => {
    const vinResolver = useVinResolver();
    const navigation = useNavigation();
    if (vehicles.length === 0) {
        return React__default.createElement("div", { className: className$E('empty') }, emptyText);
    }
    return React__default.createElement("ul", { className: className$E() }, vehicles.map(vehicle => React__default.createElement("li", { key: getVehicleId(vehicle) },
        React__default.createElement(Link, { to: navigation.vehicle(vehicle), "aria-label": vehicle.name },
            vehicle.imageUrl && React__default.createElement("img", { src: vehicle.imageUrl, alt: vehicle.name }),
            React__default.createElement("div", { className: vehicle.imageUrl ? undefined : className$E('noImage') },
                React__default.createElement("div", { className: className$E('title') },
                    vehicle.name,
                    " ",
                    vehicle.year && `(${vehicle.year})`),
                vehicle.code && React__default.createElement("div", { className: className$E('code') }, vehicle.code),
                vehicle.ref === 'vin' && React__default.createElement("div", { className: className$E('vin') }, vinResolver(vehicle.vin)))),
        React__default.createElement(IconButton$2, { className: className$E('removeFavouriteButton'), icon: faTimesExports.faTimes, iconSize: "lg", variant: "danger", onClick: () => removeRecord(vehicle), "aria-label": removeButtonTitle, title: removeButtonTitle }))));
};
const className$E = createClassName('VehicleHistoryList');

const VehicleHistoryDialogue = props => {
    return React__default.createElement(Dialogue, { isOpen: props.isOpen, onClose: props.onClose },
        React__default.createElement(Dialogue.Header, { title: props.title, onClose: props.onClose }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement(VehicleHistoryList, { vehicles: props.list.vehicles, emptyText: props.list.emptyText, removeButtonTitle: props.list.removeButtonTitle, removeRecord: props.list.removeRecord })));
};

const VehicleHistoryPopover = props => {
    return React__default.createElement(Popover, { PaperProps: { className: 'VehicleHistoryPopover' }, open: props.isOpen, onClose: props.onClose, anchorEl: props.anchor, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, elevation: 3 },
        React__default.createElement("h4", null, props.title),
        React__default.createElement(VehicleHistoryList, { vehicles: props.list.vehicles, emptyText: props.list.emptyText, removeButtonTitle: props.list.removeButtonTitle, removeRecord: props.list.removeRecord }),
        props.showShowAll && React__default.createElement(LinkButton, { className: "VehicleHistoryPopover-showAll", variant: "title", onClick: props.onShowAll }, props.showAllText));
};

const VehicleHistoryButton = props => {
    const onMobile = useOnMobile();
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [showDialogue, setShowDialogue] = useState(false);
    function onClose() {
        setShowDialogue(false);
        props.onClose();
    }
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button$2, { ref: setPopoverAnchor, className: "VehicleHistoryButton", title: props.title, ariaLabel: props.title, onClick: props.onOpen },
            React__default.createElement(FontAwesomeIcon, { icon: props.icon })),
        popoverAnchor && React__default.createElement(VehicleHistoryPopover, { anchor: popoverAnchor, isOpen: props.isOpen && !onMobile && !showDialogue, title: props.title, list: Object.assign(Object.assign({}, props.list), { vehicles: props.list.vehicles.slice(0, props.maxPopoverVehicles) }), showAllText: props.showAllText, showShowAll: props.list.vehicles.length > props.maxPopoverVehicles, onShowAll: () => setShowDialogue(true), onClose: onClose }),
        React__default.createElement(VehicleHistoryDialogue, { isOpen: props.isOpen && (onMobile || showDialogue), title: props.title, list: props.list, onClose: onClose }));
};

function useVehicleActions() {
    const { vehicle: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const { getOnlineMessage } = useOnlineStatus();
    const [setFavouriteVehicle, { isLoading: isLoadingFavourite }] = useSetFavouriteVehicleMutation();
    const [deleteRecentLookup, { isLoading: isLoadingRecentLookup }] = useDeleteRecentLookupMutation();
    useShowLoadingIndicator(isLoadingFavourite || isLoadingRecentLookup);
    return {
        favourite: (vehicle, favourite) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield setFavouriteVehicle({
                    vehicle,
                    favourite
                }).unwrap();
                dispatch(queueNotification(favourite ? strings.addedFavourite : strings.removedFavourite));
            }
            catch (_a) {
                dispatch(queueNotification(favourite ? getOnlineMessage(strings.errorAddingFavourite) : getOnlineMessage(strings.errorRemovingFavourite)));
            }
        }),
        removeRecentLookup: (vehicle) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield deleteRecentLookup(vehicle).unwrap();
                dispatch(queueNotification(strings.removedRecentLookup));
            }
            catch (_b) {
                dispatch(queueNotification(getOnlineMessage(strings.errorRemovingRecentLookup)));
            }
        })
    };
}

const MAX_POPOVER_VEHICLES = 4;
const VehicleHistoryButtons = () => {
    var _a, _b;
    const { vehicleHistory: strings, vehicle: vehicleStrings } = useStrings();
    const dispatch = useTypedDispatch();
    const [getVehicleHistory, { data: history, isLoading, error }] = useLazyGetVehicleHistoryQuery();
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const [showFavourites, setShowFavourites] = useState(false);
    const [showRecent, setShowRecent] = useState(false);
    const { favourite, removeRecentLookup } = useVehicleActions();
    useShowLoadingIndicator(isLoading);
    function openHistory(setShow) {
        return __awaiter(this, void 0, void 0, function* () {
            if (history || (yield getVehicleHistory()).isSuccess) {
                setShow(true);
            }
        });
    }
    useEffect(() => {
        if (errorMessage) {
            dispatch(queueNotification(errorMessage));
        }
    }, [errorMessage, dispatch]);
    return React__default.createElement("div", { className: "VehicleHistoryButtons" },
        React__default.createElement(VehicleHistoryButton, { title: strings.favouritesTitle, icon: faStarExports.faStar, list: {
                vehicles: (_a = history === null || history === void 0 ? void 0 : history.favouriteVehicles) !== null && _a !== void 0 ? _a : [],
                emptyText: strings.noFavourites,
                removeButtonTitle: vehicleStrings.removeFavouriteButton,
                removeRecord: vehicle => vehicle.ref === 'vin' && favourite(vehicle, false)
            }, showAllText: strings.showAllFavourites, maxPopoverVehicles: MAX_POPOVER_VEHICLES, isOpen: showFavourites, onOpen: () => openHistory(setShowFavourites), onClose: () => setShowFavourites(false) }),
        React__default.createElement(VehicleHistoryButton, { title: strings.recentsTitle, icon: faClockExports.faClock, list: {
                vehicles: (_b = history === null || history === void 0 ? void 0 : history.recentVehicles) !== null && _b !== void 0 ? _b : [],
                emptyText: strings.noRecents,
                removeButtonTitle: vehicleStrings.removeRecentLookupButton,
                removeRecord: vehicle => vehicle.ref === 'vin' && removeRecentLookup(vehicle)
            }, showAllText: strings.showAllRecents, maxPopoverVehicles: MAX_POPOVER_VEHICLES, isOpen: showRecent, onOpen: () => openHistory(setShowRecent), onClose: () => setShowRecent(false) }));
};

function getLinearProgressUtilityClass(slot) {
  return generateUtilityClass('MuiLinearProgress', slot);
}
generateUtilityClasses('MuiLinearProgress', ['root', 'colorPrimary', 'colorSecondary', 'determinate', 'indeterminate', 'buffer', 'query', 'dashed', 'dashedColorPrimary', 'dashedColorSecondary', 'bar', 'barColorPrimary', 'barColorSecondary', 'bar1Indeterminate', 'bar1Determinate', 'bar1Buffer', 'bar2Indeterminate', 'bar2Buffer']);

const _excluded$j = ["className", "color", "value", "valueBuffer", "variant"];
let _$1 = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;
const TRANSITION_DURATION = 4; // seconds
const indeterminate1Keyframe = keyframes(_t || (_t = _$1`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const indeterminate2Keyframe = keyframes(_t2 || (_t2 = _$1`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const bufferKeyframe = keyframes(_t3 || (_t3 = _$1`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const useUtilityClasses$h = ownerState => {
  const {
    classes,
    variant,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize(color)}`, variant],
    dashed: ['dashed', `dashedColor${capitalize(color)}`],
    bar1: ['bar', `barColor${capitalize(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate', variant === 'determinate' && 'bar1Determinate', variant === 'buffer' && 'bar1Buffer'],
    bar2: ['bar', variant !== 'buffer' && `barColor${capitalize(color)}`, variant === 'buffer' && `color${capitalize(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate', variant === 'buffer' && 'bar2Buffer']
  };
  return composeClasses(slots, getLinearProgressUtilityClass, classes);
};
const getColorShade = (theme, color) => {
  if (color === 'inherit') {
    return 'currentColor';
  }
  if (theme.vars) {
    return theme.vars.palette.LinearProgress[`${color}Bg`];
  }
  return theme.palette.mode === 'light' ? colorManipulatorExports.lighten(theme.palette[color].main, 0.62) : colorManipulatorExports.darken(theme.palette[color].main, 0.5);
};
const LinearProgressRoot = styled('span', {
  name: 'MuiLinearProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${capitalize(ownerState.color)}`], styles[ownerState.variant]];
  }
})(({
  ownerState,
  theme
}) => _extends({
  position: 'relative',
  overflow: 'hidden',
  display: 'block',
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  '@media print': {
    colorAdjust: 'exact'
  },
  backgroundColor: getColorShade(theme, ownerState.color)
}, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
  backgroundColor: 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'currentColor',
    opacity: 0.3
  }
}, ownerState.variant === 'buffer' && {
  backgroundColor: 'transparent'
}, ownerState.variant === 'query' && {
  transform: 'rotate(180deg)'
}));
const LinearProgressDashed = styled('span', {
  name: 'MuiLinearProgress',
  slot: 'Dashed',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.dashed, styles[`dashedColor${capitalize(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => {
  const backgroundColor = getColorShade(theme, ownerState.color);
  return _extends({
    position: 'absolute',
    marginTop: 0,
    height: '100%',
    width: '100%'
  }, ownerState.color === 'inherit' && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
    backgroundSize: '10px 10px',
    backgroundPosition: '0 -23px'
  });
}, css(_t4 || (_t4 = _$1`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe));
const LinearProgressBar1 = styled('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar1',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${capitalize(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate, ownerState.variant === 'determinate' && styles.bar1Determinate, ownerState.variant === 'buffer' && styles.bar1Buffer];
  }
})(({
  ownerState,
  theme
}) => _extends({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left',
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
}, ownerState.variant === 'determinate' && {
  transition: `transform .${TRANSITION_DURATION}s linear`
}, ownerState.variant === 'buffer' && {
  zIndex: 1,
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && css(_t5 || (_t5 = _$1`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe));
const LinearProgressBar2 = styled('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar2',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${capitalize(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate, ownerState.variant === 'buffer' && styles.bar2Buffer];
  }
})(({
  ownerState,
  theme
}) => _extends({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left'
}, ownerState.variant !== 'buffer' && {
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
}, ownerState.color === 'inherit' && {
  opacity: 0.3
}, ownerState.variant === 'buffer' && {
  backgroundColor: getColorShade(theme, ownerState.color),
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && css(_t6 || (_t6 = _$1`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const LinearProgress = /*#__PURE__*/React.forwardRef(function LinearProgress(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiLinearProgress'
  });
  const {
      className,
      color = 'primary',
      value,
      valueBuffer,
      variant = 'indeterminate'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$j);
  const ownerState = _extends({}, props, {
    color,
    variant
  });
  const classes = useUtilityClasses$h(ownerState);
  const isRtl = useRtl();
  const rootProps = {};
  const inlineStyles = {
    bar1: {},
    bar2: {}
  };
  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      let transform = value - 100;
      if (isRtl) {
        transform = -transform;
      }
      inlineStyles.bar1.transform = `translateX(${transform}%)`;
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }
  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      let transform = (valueBuffer || 0) - 100;
      if (isRtl) {
        transform = -transform;
      }
      inlineStyles.bar2.transform = `translateX(${transform}%)`;
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }
  return /*#__PURE__*/jsxs(LinearProgressRoot, _extends({
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other, {
    children: [variant === 'buffer' ? /*#__PURE__*/jsx(LinearProgressDashed, {
      className: classes.dashed,
      ownerState: ownerState
    }) : null, /*#__PURE__*/jsx(LinearProgressBar1, {
      className: classes.bar1,
      ownerState: ownerState,
      style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/jsx(LinearProgressBar2, {
      className: classes.bar2,
      ownerState: ownerState,
      style: inlineStyles.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" ? LinearProgress.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'primary', 'secondary']), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
var LinearProgress$1 = LinearProgress;

const VIN_LOOKUP_DISMISS_DATE_KEY = 'vinLookupPromptDismissDate';
const VIN_LOOKUP_DISMISS_DURATION = { days: 1 };
const ChooseVehiclePanel = () => {
    const { hideModelSelectionByDefault } = useContext();
    const vinSearchRef = useRef(null);
    const initialLoad = useRef(true);
    const suggestVinLookupToggle = useFeatureToggles().isFeatureToggleEnabled('SUGGEST_VIN_LOOKUP');
    const { isDismissed, dismiss } = useDismiss(VIN_LOOKUP_DISMISS_DATE_KEY, VIN_LOOKUP_DISMISS_DURATION);
    const { vehicleLookup: strings, suggestVinLookup: suggestVinLookupStrings } = useStrings();
    const [lookupPathUpdateStatus, setLookupPathUpdateStatus] = useState();
    const [showModelSelection, setShowModelSelection] = useState(!hideModelSelectionByDefault);
    const [showSuggestVinLookupPrompt, setShowSuggestVinLookupPrompt] = useState(false);
    const allowProductLookup = useTypedSelector(selectProductLookupType) !== 'noProducts';
    const haveUpdatedLookupPath = useTypedSelector(selectProductLookupPath).length > 0;
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    useEffect(() => {
        if (!initialLoad.current && vinSearchRef.current && !showSuggestVinLookupPrompt && !showModelSelection) {
            vinSearchRef.current.focus();
        }
        initialLoad.current = false;
    }, [showSuggestVinLookupPrompt, showModelSelection]);
    const onAcknowledge = () => {
        dismiss();
        setShowSuggestVinLookupPrompt(false);
        setShowModelSelection(true);
    };
    const onClose = () => {
        setShowSuggestVinLookupPrompt(false);
    };
    function handleSuggestVinLookup() {
        if (suggestVinLookupToggle && !isDismissed) {
            setShowSuggestVinLookupPrompt(true);
        }
        else {
            setShowModelSelection(true);
        }
    }
    return React__default.createElement(Panel, { className: "ChooseVehiclePanel" },
        React__default.createElement(Panel.Header, { title: strings.findVehicleTitle }, isLoggedIn && React__default.createElement(VehicleHistoryButtons, null)),
        React__default.createElement(Panel.Content, null,
            React__default.createElement(VinSearch, { inputRef: vinSearchRef, showModelSelection: onAcknowledge }),
            React__default.createElement(ProductLookup, { show: allowProductLookup && showModelSelection, onLookupPathUpdate: setLookupPathUpdateStatus }),
            suggestVinLookupToggle && showSuggestVinLookupPrompt &&
                React__default.createElement(ConfirmDialogue, { isOpen: showSuggestVinLookupPrompt, title: suggestVinLookupStrings.title, cancelTitle: suggestVinLookupStrings.searchByVinButton, confirmTitle: suggestVinLookupStrings.acknowledgeButton, onCancel: onClose, onConfirm: onAcknowledge }, suggestVinLookupStrings.content)),
        allowProductLookup && !showModelSelection && lookupPathUpdateStatus !== 'rejected' && React__default.createElement(Panel.BottomLink, { onClick: () => handleSuggestVinLookup() }, strings.showProductSelect),
        !haveUpdatedLookupPath && lookupPathUpdateStatus === 'pending' && React__default.createElement(LinearProgress$1, { className: "ChooseVehiclePanel-productsLoading" }));
};

const NoticeItem = ({ notice }) => {
    const dispatch = useTypedDispatch();
    return React__default.createElement("li", { className: "NoticeItem" },
        React__default.createElement("h4", null,
            React__default.createElement(LinkButton, { variant: "title", onClick: () => dispatch(showNotice(notice.id)) }, notice.title)),
        React__default.createElement("p", null, notice.body));
};

const NoticeList = ({ notices }) => {
    const { notices: strings } = useStrings();
    return React__default.createElement("ul", { className: "NoticeList", "aria-label": strings.title }, notices.map(notice => React__default.createElement(NoticeItem, { key: notice.id, notice: notice })));
};

const NoticeListSkeleton = () => {
    return React__default.createElement(SkeletonContainer, { className: "NoticeListSkeleton" },
        React__default.createElement(Skeleton, { width: "40%" }),
        React__default.createElement(Skeleton, { width: "60%" }),
        React__default.createElement(Skeleton, { width: "30%" }),
        React__default.createElement(Skeleton, { width: "80%" }),
        React__default.createElement(Skeleton, { width: "50%" }),
        React__default.createElement(Skeleton, { width: "70%" }));
};

const NoticePanel = () => {
    const { notices: strings } = useStrings();
    const { data, error } = useGetTopNoticesQuery();
    const displayShowAllLink = data && data.resultCount > data.pageSize;
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const notices = data === null || data === void 0 ? void 0 : data.elements;
    return React__default.createElement(Panel, { className: "NoticePanel" },
        React__default.createElement(Panel.Header, { title: strings.title }),
        (() => {
            if (!notices) {
                if (errorMessage) {
                    return React__default.createElement(Panel.Message, { text: errorMessage });
                }
                return React__default.createElement(Panel.Content, null,
                    React__default.createElement(NoticeListSkeleton, null));
            }
            if (notices.length === 0) {
                return React__default.createElement(Panel.Message, { text: strings.emptyList });
            }
            return React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Panel.Content, null,
                    React__default.createElement(NoticeList, { notices: notices })),
                displayShowAllLink && React__default.createElement(Panel.BottomLink, { href: "/notices" }, strings.showAll));
        })());
};

const DocumentLink = forwardRef(({ document, className, variant, onClick }, ref) => {
    const { document: strings } = useStrings();
    const navigation = useNavigation();
    return React__default.createElement(Link$1, { ref: ref, href: navigation.document(document), className: className, variant: variant, preventIfOffline: strings.cannotOpenOffline, onClick: onClick }, document.title);
});
DocumentLink.displayName = 'DocumentLink';

const DocumentActionButtons = ({ document, showFavourite, buttonSize, isFavourite }) => {
    const { document: strings, buttons: buttonStrings } = useStrings();
    const actions = useDocumentActions();
    const moduleActions = useModuleDocumentActions(document);
    const undoActionData = {
        type: UndoActionTypes.UndoRemoveFavouriteContentItemAction,
        documentId: document.id,
        buttonTitle: buttonStrings.undo
    };
    return React__default.createElement("div", { className: "DocumentActionButtons" },
        showFavourite && React__default.createElement(IconButton$2, { icon: isFavourite ? faStarExports.faStar : faStarExports$1.faStar, size: buttonSize, title: isFavourite ? strings.removeFavouriteButton : strings.addFavouriteButton, onClick: isFavourite ? () => actions.favouriteWithUndo({ documentId: document.id, favourite: !isFavourite, undoActionData }) : () => actions.favourite({ documentId: document.id, favourite: true }) }),
        moduleActions.map(action => React__default.createElement(IconButton$2, { key: action.title, icon: action.icon, size: buttonSize, title: action.title, href: action.href, onClick: action.onClick })),
        document.links.edit && React__default.createElement(IconButton$2, { icon: faEditExports.faEdit, size: buttonSize, title: strings.editButton, onClick: () => actions.showEditor(document) }),
        React__default.createElement(IconButton$2, { icon: faInfoCircleExports.faInfoCircle, size: buttonSize, title: strings.infoButton, onClick: () => actions.showInfo(document) }));
};

/**
 * Component that appends document labels to its content.
 */
const DocumentLabelAdornment = ({ document, children }) => {
    if (document.labels.length === 0) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    return React__default.createElement("span", { className: "DocumentLabelAdornment" },
        children,
        React__default.createElement(DocumentLabels, { document: document }));
};

function useStorageSet(key, options) {
    var _a;
    const storage = (_a = options === null || options === void 0 ? void 0 : options.storage) !== null && _a !== void 0 ? _a : localStorage;
    const [items, setItems] = useState(() => {
        const json = storage.getItem(key);
        if (json) {
            try {
                const items = JSON.parse(json);
                if (Array.isArray(items)) {
                    return items;
                }
            }
            catch (_a) {
                return [];
            }
        }
        return [];
    });
    return useMemo(() => {
        function updateItems(items) {
            if (options === null || options === void 0 ? void 0 : options.maxSize) {
                items = items.slice(items.length - options.maxSize);
            }
            storage.setItem(key, JSON.stringify(items));
            setItems(items);
        }
        return {
            add(value) {
                updateItems(items.filter(item => item !== value).concat(value));
            },
            delete(value) {
                if (items.includes(value)) {
                    updateItems(items.filter(item => item !== value));
                }
            },
            has(value) {
                return items.includes(value);
            }
        };
    }, [items, key, options === null || options === void 0 ? void 0 : options.maxSize, storage]);
}

const ImportantDocumentItem = ({ document }) => {
    const { document: strings } = useStrings();
    const [viewed, setViewed] = useDocumentViewedState(document.id);
    const classes = classNames(className$D(), {
        [className$D('viewed')]: viewed
    });
    const newLabel = {
        id: 'new',
        name: strings.labels.new
    };
    return React__default.createElement("li", { className: classes, "aria-label": document.title },
        React__default.createElement(DocumentLabelAdornment, { document: document },
            React__default.createElement("div", { className: className$D('title') },
                React__default.createElement(DocumentLink, { document: document, variant: "title", onClick: setViewed }),
                !viewed && React__default.createElement(DocumentLabel, { label: newLabel, document: document }))),
        React__default.createElement(DocumentActionButtons, { document: document, showFavourite: false }));
};
const className$D = createClassName('ImportantDocumentItem');
function useDocumentViewedState(documentId) {
    const user = useTypedSelector(selectCurrentUser);
    const key = user ? `viewedDocuments-${user.id}` : 'viewedDocuments';
    const set = useStorageSet(key, { maxSize: 1000 });
    return [set.has(documentId), () => set.add(documentId)];
}

const ImportantDocumentList = props => {
    return React__default.createElement("ul", { className: "ImportantDocumentList" }, props.documents.map(document => React__default.createElement(ImportantDocumentItem, { key: document.id, document: document })));
};

const DocumentListSkeleton = ({ hasRole }) => {
    return React__default.createElement(SkeletonContainer, { hasRole: hasRole },
        React__default.createElement(ItemSkeleton, { width: "30%" }),
        React__default.createElement(ItemSkeleton, { width: "50%" }),
        React__default.createElement(ItemSkeleton, { width: "40%" }));
};
const ItemSkeleton = ({ width }) => {
    return React__default.createElement("div", { className: className$C('item') },
        React__default.createElement(Skeleton, { width: width, height: 24 }),
        React__default.createElement("div", { className: className$C('actions') },
            React__default.createElement(Skeleton, { variant: "circular", width: 20, height: 20 }),
            React__default.createElement(Skeleton, { variant: "circular", width: 20, height: 20 })));
};
const className$C = createClassName('DocumentListSkeleton');

const ImportantDocumentPanel = ({ forCurrentVehicle }) => {
    const { importantDocuments: strings, auth: authStrings } = useStrings();
    const location = useLocation();
    const navigation = useNavigation();
    const currentVehicle = useTypedSelector(selectCurrentVehicle);
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const { data, error } = useGetImportantDocumentsQuery(forCurrentVehicle ? currentVehicle : null, {
        skip: !isLoggedIn || (forCurrentVehicle && !currentVehicle)
    });
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const documents = data === null || data === void 0 ? void 0 : data.documents.map(document => document.match).filter((document) => document !== null);
    return React__default.createElement(Panel, { className: "ImportantDocumentPanel" },
        React__default.createElement(Panel.Header, { title: strings.title }),
        (() => {
            if (!isLoggedIn) {
                return React__default.createElement(Panel.Content, { className: "ImportantDocumentPanel-logIn" },
                    React__default.createElement("p", null, strings.notLoggedIn),
                    React__default.createElement(ButtonLink, { href: navigation.login(location) }, authStrings.logInButton));
            }
            if (!documents) {
                if (errorMessage) {
                    return React__default.createElement(Panel.Message, { text: errorMessage });
                }
                return React__default.createElement(Panel.Content, null,
                    React__default.createElement(DocumentListSkeleton, null));
            }
            if (documents.length === 0) {
                return React__default.createElement(Panel.Message, { text: strings.emptyList });
            }
            return React__default.createElement(Panel.Content, null,
                React__default.createElement(ImportantDocumentList, { documents: documents }));
        })());
};

const FavouriteDocumentPages = ({ document }) => {
    const isFavouriteContentEnabled = useFeatureToggles().isFeatureToggleEnabled('BOOKMARK_DOCUMENT_PAGES');
    const { document: strings } = useStrings();
    const favouriteDocumentPages = document.favouriteDocumentPages;
    const navigation = useNavigation();
    const actions = useDocumentActions();
    if (!favouriteDocumentPages || favouriteDocumentPages.length === 0 || !isFavouriteContentEnabled) {
        return null;
    }
    return (React__default.createElement("ul", { className: "FavouriteDocumentPages" }, favouriteDocumentPages.map(page => {
        return (React__default.createElement("li", { key: page.pageId, className: "FavouriteDocumentPages-item" },
            React__default.createElement(Link$1, { href: navigation.document(document, { fragment: page.pageId }), preventIfOffline: strings.cannotOpenOffline }, page.pageTitle),
            React__default.createElement(IconButton$2, { icon: faStarExports.faStar, title: strings.removeFavouriteButton, onClick: () => actions.favourite({ documentId: document.id, pageId: page.pageId, favourite: false }) })));
    })));
};

const FavouriteContentItem = ({ document, isFavourite }) => {
    return (React__default.createElement("li", { className: "FavouriteContentItem" },
        React__default.createElement("div", { className: "FavouriteContentItem-document" },
            React__default.createElement(DocumentLabelAdornment, { document: document },
                React__default.createElement(DocumentLink, { document: document, variant: "title" })),
            React__default.createElement(DocumentActionButtons, { document: document, showFavourite: true, isFavourite: isFavourite })),
        React__default.createElement(FavouriteDocumentPages, { document: document })));
};

const defaultDocumentLimit = 10;
const FavouriteContentPanel = ({ forCurrentVehicle }) => {
    const isFavouriteContentEnabled = useFeatureToggles().isFeatureToggleEnabled('BOOKMARK_DOCUMENT_PAGES');
    const { favouriteContent, favouriteDocuments } = useStrings();
    const strings = isFavouriteContentEnabled ? favouriteContent : favouriteDocuments;
    const { favouriteContentPanelDocumentLimit } = useContext();
    const navigation = useNavigation();
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const currentVehicle = useTypedSelector(selectCurrentVehicle);
    const { data, error } = useGetTopFavouriteContentQuery({
        vehicle: forCurrentVehicle ? currentVehicle : null,
        limit: favouriteContentPanelDocumentLimit !== null && favouriteContentPanelDocumentLimit !== void 0 ? favouriteContentPanelDocumentLimit : defaultDocumentLimit
    }, {
        skip: !isLoggedIn || (forCurrentVehicle && !currentVehicle),
        refetchOnMountOrArgChange: true
    });
    const displayShowAllLink = data && data.resultCount > data.pageSize;
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const documents = data === null || data === void 0 ? void 0 : data.elements;
    if (!isLoggedIn || (forCurrentVehicle && currentVehicle === null)) {
        return null;
    }
    return React__default.createElement(Panel, { className: "FavouriteContentPanel" },
        React__default.createElement(Panel.Header, { title: strings.title }),
        (() => {
            if (!documents) {
                if (errorMessage) {
                    return React__default.createElement(Panel.Message, { text: errorMessage });
                }
                return React__default.createElement(Panel.Content, null,
                    React__default.createElement(DocumentListSkeleton, null));
            }
            if (documents.length === 0) {
                return React__default.createElement(Panel.Message, { text: strings.emptyList });
            }
            return React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Panel.Content, null,
                    React__default.createElement("ul", null, documents.map(document => React__default.createElement(FavouriteContentItem, { key: document.id, document: document, isFavourite: document.favourite === undefined ? true : document.favourite })))),
                displayShowAllLink && React__default.createElement(Panel.BottomLink, { href: navigation.favouriteContent(forCurrentVehicle ? currentVehicle : null) }, strings.showAll));
        })());
};

function transformGroupName(documentGroup) {
    const paths = documentGroup === null || documentGroup === void 0 ? void 0 : documentGroup.path;
    if (!paths || paths.length === 1) {
        return documentGroup.name;
    }
    return paths.reduce((acc, path) => {
        const separator = !acc ? '' : ' | ';
        return acc + separator + path.name;
    }, '');
}
const DocumentGroupLookup = ({ groups }) => {
    const { documentGroupLookup: strings, documentGroup: groupStrings } = useStrings();
    const dispatch = useTypedDispatch();
    const { isSearchViaDocumentGroupDetailedSelectOptionShown: isDetailedOptionShown } = useContext();
    const [getDocuments, { isFetching }] = useLazyGetDocumentsQuery();
    const navigation = useNavigation();
    const navigate = useNavigate();
    const [selectedGroup, setSelectedGroup] = useState();
    const initialOptionValue = '-1';
    function onChange(event) {
        setSelectedGroup(getDocumentGroupFromId(event.target.value));
    }
    function getDocumentGroupFromId(id) {
        if (id === initialOptionValue) {
            return undefined;
        }
        return groups === null || groups === void 0 ? void 0 : groups.find((group) => {
            return group.id === id;
        });
    }
    function openGroup() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!selectedGroup) {
                return;
            }
            if (selectedGroup.documentCount !== 1 || !selectedGroup.shortcutSingleDocument) {
                return navigate(navigation.documentGroup(selectedGroup.id));
            }
            try {
                const documents = yield getDocuments({
                    groupId: selectedGroup.id,
                    vehicle: null,
                    filter: '',
                    pageNumber: 0,
                    pageSize: 1,
                    sortKey: 'title',
                    sortDirection: 'ascending'
                }).unwrap();
                if (documents.resultCount === 1) {
                    const document = (_a = documents.elements[0].match) !== null && _a !== void 0 ? _a : documents.elements[0].translations[0];
                    navigate(navigation.document({
                        id: document.id,
                        documentTypeContentType: document.documentTypeContentType,
                        groupId: selectedGroup.id,
                        search: null,
                        vehicle: null
                    }));
                }
                else {
                    dispatch(queueNotification(groupStrings.loadError));
                }
            }
            catch (_b) {
                dispatch(queueNotification(groupStrings.loadError));
            }
        });
    }
    function DocumentGroupLookupForm() {
        return React__default.createElement(FormControl$1, { variant: "outlined", fullWidth: true, size: "small" },
            React__default.createElement("label", { htmlFor: className$B('select') }, strings.helpText),
            React__default.createElement(Select$1, { id: className$B('select'), native: true, onChange: onChange, value: selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.id },
                React__default.createElement("option", { value: initialOptionValue }, strings.selectDocumentGroupItem),
                groups.map(documentGroup => React__default.createElement("option", { value: documentGroup.id, key: documentGroup.id }, isDetailedOptionShown ? transformGroupName(documentGroup) : documentGroup.name))),
            React__default.createElement("div", { className: className$B('footer') },
                React__default.createElement(Button$2, { disabled: selectedGroup === undefined, busy: isFetching, onClick: openGroup }, strings.selectButton)));
    }
    return React__default.createElement("div", { className: className$B() }, groups.length > 0 ? React__default.createElement(DocumentGroupLookupForm, null) : React__default.createElement(Panel.Message, { text: strings.emptyList }));
};
const className$B = createClassName('DocumentGroupLookup');

const DocumentGroupLookupListSkeleton = () => {
    return React__default.createElement(SkeletonContainer, { className: className$A() },
        React__default.createElement(Skeleton$1, { height: 24, width: "30%" }),
        React__default.createElement(Skeleton$1, { variant: "rectangular", height: 40 }),
        React__default.createElement("div", { className: className$A('button') },
            React__default.createElement(Skeleton$1, { variant: "rectangular", height: 30, width: 70 })));
};
const className$A = createClassName('DocumentGroupLookupListSkeleton');

const DocumentGroupLookupPanel = () => {
    const { documentGroupLookup: strings } = useStrings();
    const { data, error } = useGetDocumentGroupsQuery({ vehicle: null });
    const groups = data === null || data === void 0 ? void 0 : data.groups;
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    return React__default.createElement(Panel, { className: "DocumentGroupLookupPanel" },
        React__default.createElement(Panel.Header, { title: strings.title }),
        React__default.createElement(Panel.Content, null, (() => {
            if (errorMessage) {
                return React__default.createElement(Panel.Message, { text: errorMessage });
            }
            if (!groups) {
                return React__default.createElement(DocumentGroupLookupListSkeleton, null);
            }
            if (groups.length === 0) {
                return React__default.createElement(Panel.Message, { text: strings.emptyList });
            }
            return React__default.createElement(DocumentGroupLookup, { groups: groups });
        })()));
};

const ModuleVehicleLookupPanels = () => {
    const { modules } = useContext();
    const panels = useMemo(() => {
        return modules === null || modules === void 0 ? void 0 : modules.flatMap(({ id, layouts }) => {
            if (layouts === null || layouts === void 0 ? void 0 : layouts.vehicleLookupPanel) {
                return [React__default.createElement(Fragment, { key: String(id) }, layouts.vehicleLookupPanel())];
            }
            return [];
        });
    }, [modules]);
    return panels ? React__default.createElement(React__default.Fragment, null, panels) : null;
};

var faExternalLinkAlt = {};

var hasRequiredFaExternalLinkAlt;

function requireFaExternalLinkAlt () {
	if (hasRequiredFaExternalLinkAlt) return faExternalLinkAlt;
	hasRequiredFaExternalLinkAlt = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'external-link-alt';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f35d';
		var svgPathData = 'M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faExternalLinkAlt = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faExternalLinkAlt));
	return faExternalLinkAlt;
}

var faExternalLinkAltExports = requireFaExternalLinkAlt();

const VinControlPanel = () => {
    const { vehicle: strings } = useStrings();
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const dispatch = useTypedDispatch();
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const vinResolver = useVinResolver();
    const isProductVariant = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.ref) === 'product';
    const changeButtonString = isProductVariant ? strings.changeVehicleButton : strings.changeVinButton;
    const additionalButtonString = isProductVariant ? strings.additionalVehicleButton : strings.additionalVinButton;
    const titleString = isProductVariant ? strings.currentModelTitle : strings.currentVinTitle;
    let titleValueString;
    if ((vehicle === null || vehicle === void 0 ? void 0 : vehicle.ref) === 'vin') {
        titleValueString = vinResolver(vehicle.vin);
    }
    else if (isProductVariant) {
        titleValueString = vehicle.code;
    }
    const handleChangeVin = () => {
        dispatch(clearCurrentVehicle());
    };
    return React__default.createElement(Panel, { className: "VinControlPanel" },
        React__default.createElement("h4", null, titleString),
        React__default.createElement(Panel.Header, { className: "VinControlPanel-header", title: titleValueString }, isLoggedIn && React__default.createElement(VehicleHistoryButtons, null)),
        React__default.createElement(Panel.Content, null,
            React__default.createElement("div", { className: "VinControlPanel-buttons" },
                React__default.createElement(Button$2, { title: changeButtonString, onClick: handleChangeVin }, changeButtonString),
                React__default.createElement(ButtonLink, { href: "/lookup", openInNewTab: true, title: additionalButtonString },
                    additionalButtonString,
                    React__default.createElement(FontAwesomeIcon, { icon: faExternalLinkAltExports.faExternalLinkAlt, size: "1x" })))));
};

const DocumentList = ({ documents }) => {
    return React__default.createElement("ul", { className: "DocumentList" }, documents.map(document => React__default.createElement("li", { key: document.id },
        React__default.createElement(DocumentLabelAdornment, { document: document },
            React__default.createElement(DocumentLink, { document: document, variant: "title" })),
        React__default.createElement(DocumentActionButtons, { document: document, showFavourite: false }))));
};

const FrequentlyUsedDocumentsPanel = ({ vehicle }) => {
    const { frequentlyUsedDocuments: strings } = useStrings();
    const { data, error } = useGetFrequentlyUsedDocumentsQuery(vehicle);
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const documents = data === null || data === void 0 ? void 0 : data.map(document => document.match).filter((document) => document !== null);
    return React__default.createElement(Panel, { className: "FrequentlyUsedDocumentsPanel" },
        React__default.createElement(Panel.Header, { title: strings.title }),
        (() => {
            if (errorMessage) {
                return React__default.createElement(Panel.Message, { text: errorMessage });
            }
            if (!documents) {
                return React__default.createElement(Panel.Content, null,
                    React__default.createElement(DocumentListSkeleton, null));
            }
            if (documents.length === 0) {
                return React__default.createElement(Panel.Message, { text: strings.emptyList });
            }
            return React__default.createElement(Panel.Content, null,
                React__default.createElement(DocumentList, { documents: documents }));
        })());
};

function useVehiclePanelLayout(customLayout, getDefaultLayout) {
    const { vehiclePanelOrder } = useContext();
    return useMemo(() => {
        function getLegacyPanelOrder(panel, startOrder, defaultOrder) {
            var _a;
            const index = (_a = vehiclePanelOrder === null || vehiclePanelOrder === void 0 ? void 0 : vehiclePanelOrder.indexOf(panel)) !== null && _a !== void 0 ? _a : -1;
            return (index === -1 ? defaultOrder : startOrder + index);
        }
        const defaultLayout = getDefaultLayout(getLegacyPanelOrder);
        for (const key in defaultLayout) {
            defaultLayout[key].order += 1000; // Offset to keep default ordering after custom ordering.
        }
        const layout = Object.assign(defaultLayout, customLayout);
        return {
            getColumnPanels: (panels, column) => {
                return objectEntries(layout)
                    .filter(([, value]) => value.column === column)
                    .sort(([, a], [, b]) => a.order - b.order)
                    .map(([key]) => panels[key]);
            }
        };
    }, [customLayout, getDefaultLayout, vehiclePanelOrder]);
}
function useVehicleLookupPanelLayout() {
    const { vehicleLookupScreenLayout } = useContext();
    return useVehiclePanelLayout(vehicleLookupScreenLayout, getLegacyPanelOrder => ({
        lookup: {
            column: 'left',
            order: 1
        },
        modules: {
            column: 'left',
            order: 2
        },
        notices: {
            column: 'right',
            order: getLegacyPanelOrder('notices', 1, 1)
        },
        importantDocuments: {
            column: 'right',
            order: getLegacyPanelOrder('importantDocuments', 1, 2)
        },
        favouriteContent: {
            column: 'right',
            order: getLegacyPanelOrder('favouriteContent', 1, 3)
        },
        documentGroupLookup: {
            column: 'right',
            order: getLegacyPanelOrder('documentGroupLookup', 1, 4)
        },
        frequentlyUsedDocuments: {
            column: 'right',
            order: getLegacyPanelOrder('frequentlyUsedDocuments', 1, 5)
        }
    }));
}
function useVehicleOverviewPanelLayout() {
    const { vehicleOverviewScreenLayout, showVehiclePurchaseSubscriptionPanelLeft } = useContext();
    return useVehiclePanelLayout(vehicleOverviewScreenLayout, getLegacyPanelOrder => ({
        info: {
            column: 'left',
            order: 1
        },
        serviceHistory: {
            column: 'left',
            order: showVehiclePurchaseSubscriptionPanelLeft ? 3 : 2
        },
        purchaseSubscriptions: {
            column: showVehiclePurchaseSubscriptionPanelLeft ? 'left' : 'right',
            order: showVehiclePurchaseSubscriptionPanelLeft ? 2 : 1
        },
        modules: {
            column: 'right',
            order: 2
        },
        importantDocuments: {
            column: 'right',
            order: getLegacyPanelOrder('importantDocuments', 3, 3)
        },
        favouriteContent: {
            column: 'right',
            order: getLegacyPanelOrder('favouriteContent', 3, 4)
        },
        frequentlyUsedDocuments: {
            column: 'right',
            order: getLegacyPanelOrder('frequentlyUsedDocuments', 3, 5)
        }
    }));
}

var js = {};

var Carousel = {};

var lib$6 = {};

var reactSwipe = {};

var hasRequiredReactSwipe;

function requireReactSwipe () {
	if (hasRequiredReactSwipe) return reactSwipe;
	hasRequiredReactSwipe = 1;
	(function (exports) {
		(function (global, factory) {
		  {
		    factory(exports, React__default, requirePropTypes());
		  }
		})(commonjsGlobal, function (exports, _react, _propTypes) {

		  Object.defineProperty(exports, "__esModule", {
		    value: true
		  });
		  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;

		  var _react2 = _interopRequireDefault(_react);

		  var _propTypes2 = _interopRequireDefault(_propTypes);

		  function _interopRequireDefault(obj) {
		    return obj && obj.__esModule ? obj : {
		      default: obj
		    };
		  }

		  var _extends = Object.assign || function (target) {
		    for (var i = 1; i < arguments.length; i++) {
		      var source = arguments[i];

		      for (var key in source) {
		        if (Object.prototype.hasOwnProperty.call(source, key)) {
		          target[key] = source[key];
		        }
		      }
		    }

		    return target;
		  };

		  function _objectWithoutProperties(obj, keys) {
		    var target = {};

		    for (var i in obj) {
		      if (keys.indexOf(i) >= 0) continue;
		      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
		      target[i] = obj[i];
		    }

		    return target;
		  }

		  function _classCallCheck(instance, Constructor) {
		    if (!(instance instanceof Constructor)) {
		      throw new TypeError("Cannot call a class as a function");
		    }
		  }

		  var _createClass = function () {
		    function defineProperties(target, props) {
		      for (var i = 0; i < props.length; i++) {
		        var descriptor = props[i];
		        descriptor.enumerable = descriptor.enumerable || false;
		        descriptor.configurable = true;
		        if ("value" in descriptor) descriptor.writable = true;
		        Object.defineProperty(target, descriptor.key, descriptor);
		      }
		    }

		    return function (Constructor, protoProps, staticProps) {
		      if (protoProps) defineProperties(Constructor.prototype, protoProps);
		      if (staticProps) defineProperties(Constructor, staticProps);
		      return Constructor;
		    };
		  }();

		  function _possibleConstructorReturn(self, call) {
		    if (!self) {
		      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		    }

		    return call && (typeof call === "object" || typeof call === "function") ? call : self;
		  }

		  function _inherits(subClass, superClass) {
		    if (typeof superClass !== "function" && superClass !== null) {
		      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		    }

		    subClass.prototype = Object.create(superClass && superClass.prototype, {
		      constructor: {
		        value: subClass,
		        enumerable: false,
		        writable: true,
		        configurable: true
		      }
		    });
		    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		  }

		  var supportsCaptureOption = false;
		  function setHasSupportToCaptureOption(hasSupport) {
		    supportsCaptureOption = hasSupport;
		  }

		  try {
		    addEventListener('test', null, Object.defineProperty({}, 'capture', { get: function get() {
		        setHasSupportToCaptureOption(true);
		      } }));
		  } catch (e) {} // eslint-disable-line no-empty

		  function getSafeEventHandlerOpts() {
		    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };

		    return supportsCaptureOption ? options : options.capture;
		  }

		  /**
		   * [getPosition returns a position element that works for mouse or touch events]
		   * @param  {[Event]} event [the received event]
		   * @return {[Object]}      [x and y coords]
		   */
		  function getPosition(event) {
		    if ('touches' in event) {
		      var _event$touches$ = event.touches[0],
		          pageX = _event$touches$.pageX,
		          pageY = _event$touches$.pageY;

		      return { x: pageX, y: pageY };
		    }

		    var screenX = event.screenX,
		        screenY = event.screenY;

		    return { x: screenX, y: screenY };
		  }

		  var ReactSwipe = function (_Component) {
		    _inherits(ReactSwipe, _Component);

		    function ReactSwipe() {
		      var _ref;

		      _classCallCheck(this, ReactSwipe);

		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }

		      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));

		      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
		      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
		      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);

		      _this._onMouseDown = _this._onMouseDown.bind(_this);
		      _this._onMouseMove = _this._onMouseMove.bind(_this);
		      _this._onMouseUp = _this._onMouseUp.bind(_this);

		      _this._setSwiperRef = _this._setSwiperRef.bind(_this);
		      return _this;
		    }

		    _createClass(ReactSwipe, [{
		      key: 'componentDidMount',
		      value: function componentDidMount() {
		        if (this.swiper) {
		          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
		            capture: true,
		            passive: false
		          }));
		        }
		      }
		    }, {
		      key: 'componentWillUnmount',
		      value: function componentWillUnmount() {
		        if (this.swiper) {
		          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
		            capture: true,
		            passive: false
		          }));
		        }
		      }
		    }, {
		      key: '_onMouseDown',
		      value: function _onMouseDown(event) {
		        if (!this.props.allowMouseEvents) {
		          return;
		        }

		        this.mouseDown = true;

		        document.addEventListener('mouseup', this._onMouseUp);
		        document.addEventListener('mousemove', this._onMouseMove);

		        this._handleSwipeStart(event);
		      }
		    }, {
		      key: '_onMouseMove',
		      value: function _onMouseMove(event) {
		        if (!this.mouseDown) {
		          return;
		        }

		        this._handleSwipeMove(event);
		      }
		    }, {
		      key: '_onMouseUp',
		      value: function _onMouseUp(event) {
		        this.mouseDown = false;

		        document.removeEventListener('mouseup', this._onMouseUp);
		        document.removeEventListener('mousemove', this._onMouseMove);

		        this._handleSwipeEnd(event);
		      }
		    }, {
		      key: '_handleSwipeStart',
		      value: function _handleSwipeStart(event) {
		        var _getPosition = getPosition(event),
		            x = _getPosition.x,
		            y = _getPosition.y;

		        this.moveStart = { x: x, y: y };
		        this.props.onSwipeStart(event);
		      }
		    }, {
		      key: '_handleSwipeMove',
		      value: function _handleSwipeMove(event) {
		        if (!this.moveStart) {
		          return;
		        }

		        var _getPosition2 = getPosition(event),
		            x = _getPosition2.x,
		            y = _getPosition2.y;

		        var deltaX = x - this.moveStart.x;
		        var deltaY = y - this.moveStart.y;
		        this.moving = true;

		        // handling the responsability of cancelling the scroll to
		        // the component handling the event
		        var shouldPreventDefault = this.props.onSwipeMove({
		          x: deltaX,
		          y: deltaY
		        }, event);

		        if (shouldPreventDefault && event.cancelable) {
		          event.preventDefault();
		        }

		        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
		      }
		    }, {
		      key: '_handleSwipeEnd',
		      value: function _handleSwipeEnd(event) {
		        this.props.onSwipeEnd(event);

		        var tolerance = this.props.tolerance;


		        if (this.moving && this.movePosition) {
		          if (this.movePosition.deltaX < -tolerance) {
		            this.props.onSwipeLeft(1, event);
		          } else if (this.movePosition.deltaX > tolerance) {
		            this.props.onSwipeRight(1, event);
		          }
		          if (this.movePosition.deltaY < -tolerance) {
		            this.props.onSwipeUp(1, event);
		          } else if (this.movePosition.deltaY > tolerance) {
		            this.props.onSwipeDown(1, event);
		          }
		        }

		        this.moveStart = null;
		        this.moving = false;
		        this.movePosition = null;
		      }
		    }, {
		      key: '_setSwiperRef',
		      value: function _setSwiperRef(node) {
		        this.swiper = node;
		        this.props.innerRef(node);
		      }
		    }, {
		      key: 'render',
		      value: function render() {
		        var _props = this.props;
		            _props.tagName;
		            var className = _props.className,
		            style = _props.style,
		            children = _props.children;
		            _props.allowMouseEvents;
		            _props.onSwipeUp;
		            _props.onSwipeDown;
		            _props.onSwipeLeft;
		            _props.onSwipeRight;
		            _props.onSwipeStart;
		            _props.onSwipeMove;
		            _props.onSwipeEnd;
		            _props.innerRef;
		            _props.tolerance;
		            var props = _objectWithoutProperties(_props, ['tagName', 'className', 'style', 'children', 'allowMouseEvents', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight', 'onSwipeStart', 'onSwipeMove', 'onSwipeEnd', 'innerRef', 'tolerance']);

		        return _react2.default.createElement(
		          this.props.tagName,
		          _extends({
		            ref: this._setSwiperRef,
		            onMouseDown: this._onMouseDown,
		            onTouchStart: this._handleSwipeStart,
		            onTouchEnd: this._handleSwipeEnd,
		            className: className,
		            style: style
		          }, props),
		          children
		        );
		      }
		    }]);

		    return ReactSwipe;
		  }(_react.Component);

		  ReactSwipe.displayName = 'ReactSwipe';
		  ReactSwipe.propTypes = {
		    tagName: _propTypes2.default.string,
		    className: _propTypes2.default.string,
		    style: _propTypes2.default.object,
		    children: _propTypes2.default.node,
		    allowMouseEvents: _propTypes2.default.bool,
		    onSwipeUp: _propTypes2.default.func,
		    onSwipeDown: _propTypes2.default.func,
		    onSwipeLeft: _propTypes2.default.func,
		    onSwipeRight: _propTypes2.default.func,
		    onSwipeStart: _propTypes2.default.func,
		    onSwipeMove: _propTypes2.default.func,
		    onSwipeEnd: _propTypes2.default.func,
		    innerRef: _propTypes2.default.func,
		    tolerance: _propTypes2.default.number.isRequired
		  };
		  ReactSwipe.defaultProps = {
		    tagName: 'div',
		    allowMouseEvents: false,
		    onSwipeUp: function onSwipeUp() {},
		    onSwipeDown: function onSwipeDown() {},
		    onSwipeLeft: function onSwipeLeft() {},
		    onSwipeRight: function onSwipeRight() {},
		    onSwipeStart: function onSwipeStart() {},
		    onSwipeMove: function onSwipeMove() {},
		    onSwipeEnd: function onSwipeEnd() {},
		    innerRef: function innerRef() {},

		    tolerance: 0
		  };
		  exports.default = ReactSwipe;
		});
} (reactSwipe));
	return reactSwipe;
}

var hasRequiredLib$6;

function requireLib$6 () {
	if (hasRequiredLib$6) return lib$6;
	hasRequiredLib$6 = 1;
	(function (exports) {
		(function (global, factory) {
		  {
		    factory(exports, requireReactSwipe());
		  }
		})(commonjsGlobal, function (exports, _reactSwipe) {

		  Object.defineProperty(exports, "__esModule", {
		    value: true
		  });

		  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

		  function _interopRequireDefault(obj) {
		    return obj && obj.__esModule ? obj : {
		      default: obj
		    };
		  }

		  exports.default = _reactSwipe2.default;
		});
} (lib$6));
	return lib$6;
}

var cssClasses = {};

var hasRequiredCssClasses;

function requireCssClasses () {
	if (hasRequiredCssClasses) return cssClasses;
	hasRequiredCssClasses = 1;

	Object.defineProperty(cssClasses, "__esModule", {
	  value: true
	});
	cssClasses.default = void 0;

	var _classnames = _interopRequireDefault(requireClassnames());

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var _default = {
	  ROOT: function ROOT(customClassName) {
	    return (0, _classnames.default)(_defineProperty({
	      'carousel-root': true
	    }, customClassName || '', !!customClassName));
	  },
	  CAROUSEL: function CAROUSEL(isSlider) {
	    return (0, _classnames.default)({
	      carousel: true,
	      'carousel-slider': isSlider
	    });
	  },
	  WRAPPER: function WRAPPER(isSlider, axis) {
	    return (0, _classnames.default)({
	      'thumbs-wrapper': !isSlider,
	      'slider-wrapper': isSlider,
	      'axis-horizontal': axis === 'horizontal',
	      'axis-vertical': axis !== 'horizontal'
	    });
	  },
	  SLIDER: function SLIDER(isSlider, isSwiping) {
	    return (0, _classnames.default)({
	      thumbs: !isSlider,
	      slider: isSlider,
	      animated: !isSwiping
	    });
	  },
	  ITEM: function ITEM(isSlider, selected, previous) {
	    return (0, _classnames.default)({
	      thumb: !isSlider,
	      slide: isSlider,
	      selected: selected,
	      previous: previous
	    });
	  },
	  ARROW_PREV: function ARROW_PREV(disabled) {
	    return (0, _classnames.default)({
	      'control-arrow control-prev': true,
	      'control-disabled': disabled
	    });
	  },
	  ARROW_NEXT: function ARROW_NEXT(disabled) {
	    return (0, _classnames.default)({
	      'control-arrow control-next': true,
	      'control-disabled': disabled
	    });
	  },
	  DOT: function DOT(selected) {
	    return (0, _classnames.default)({
	      dot: true,
	      selected: selected
	    });
	  }
	};
	cssClasses.default = _default;
	return cssClasses;
}

var Thumbs = {};

var dimensions = {};

var hasRequiredDimensions;

function requireDimensions () {
	if (hasRequiredDimensions) return dimensions;
	hasRequiredDimensions = 1;

	Object.defineProperty(dimensions, "__esModule", {
	  value: true
	});
	dimensions.outerWidth = void 0;

	var outerWidth = function outerWidth(el) {
	  var width = el.offsetWidth;
	  var style = getComputedStyle(el);
	  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
	  return width;
	};

	dimensions.outerWidth = outerWidth;
	return dimensions;
}

var CSSTranslate = {};

var hasRequiredCSSTranslate;

function requireCSSTranslate () {
	if (hasRequiredCSSTranslate) return CSSTranslate;
	hasRequiredCSSTranslate = 1;

	Object.defineProperty(CSSTranslate, "__esModule", {
	  value: true
	});
	CSSTranslate.default = void 0;

	var _default = function _default(position, metric, axis) {
	  var positionPercent = position === 0 ? position : position + metric;
	  var positionCss = axis === 'horizontal' ? [positionPercent, 0, 0] : [0, positionPercent, 0];
	  var transitionProp = 'translate3d';
	  var translatedPosition = '(' + positionCss.join(',') + ')';
	  return transitionProp + translatedPosition;
	};

	CSSTranslate.default = _default;
	return CSSTranslate;
}

var window$1 = {};

var hasRequiredWindow;

function requireWindow () {
	if (hasRequiredWindow) return window$1;
	hasRequiredWindow = 1;

	Object.defineProperty(window$1, "__esModule", {
	  value: true
	});
	window$1.default = void 0;

	var _default = function _default() {
	  return window;
	};

	window$1.default = _default;
	return window$1;
}

var hasRequiredThumbs;

function requireThumbs () {
	if (hasRequiredThumbs) return Thumbs;
	hasRequiredThumbs = 1;

	Object.defineProperty(Thumbs, "__esModule", {
	  value: true
	});
	Thumbs.default = void 0;

	var _react = _interopRequireWildcard(React__default);

	var _cssClasses = _interopRequireDefault(requireCssClasses());

	var _dimensions = requireDimensions();

	var _CSSTranslate = _interopRequireDefault(requireCSSTranslate());

	var _reactEasySwipe = _interopRequireDefault(requireLib$6());

	var _window = _interopRequireDefault(requireWindow());

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var isKeyboardEvent = function isKeyboardEvent(e) {
	  return e.hasOwnProperty('key');
	};

	var Thumbs$1 = /*#__PURE__*/function (_Component) {
	  _inherits(Thumbs, _Component);

	  var _super = _createSuper(Thumbs);

	  function Thumbs(_props) {
	    var _this;

	    _classCallCheck(this, Thumbs);

	    _this = _super.call(this, _props);

	    _defineProperty(_assertThisInitialized(_this), "itemsWrapperRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "itemsListRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "setItemsWrapperRef", function (node) {
	      _this.itemsWrapperRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setItemsListRef", function (node) {
	      _this.itemsListRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node, index) {
	      if (!_this.thumbsRef) {
	        _this.thumbsRef = [];
	      }

	      _this.thumbsRef[index] = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
	      if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) {
	        return;
	      }

	      var total = _react.Children.count(_this.props.children);

	      var wrapperSize = _this.itemsWrapperRef.clientWidth;
	      var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
	      var visibleItems = Math.floor(wrapperSize / itemSize);
	      var showArrows = visibleItems < total;
	      var lastPosition = showArrows ? total - visibleItems : 0;

	      _this.setState(function (_state, props) {
	        return {
	          itemSize: itemSize,
	          visibleItems: visibleItems,
	          firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
	          lastPosition: lastPosition,
	          showArrows: showArrows
	        };
	      });
	    });

	    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item, e) {
	      if (!isKeyboardEvent(e) || e.key === 'Enter') {
	        var handler = _this.props.onSelectItem;

	        if (typeof handler === 'function') {
	          handler(index, item);
	        }
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function () {
	      _this.setState({
	        swiping: true
	      });
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function () {
	      _this.setState({
	        swiping: false
	      });
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta) {
	      var deltaX = delta.x;

	      if (!_this.state.itemSize || !_this.itemsWrapperRef || !_this.state.visibleItems) {
	        return false;
	      }

	      var leftBoundary = 0;

	      var childrenLength = _react.Children.count(_this.props.children);

	      var currentPosition = -(_this.state.firstItem * 100) / _this.state.visibleItems;
	      var lastLeftItem = Math.max(childrenLength - _this.state.visibleItems, 0);
	      var lastLeftBoundary = -lastLeftItem * 100 / _this.state.visibleItems; // prevent user from swiping left out of boundaries

	      if (currentPosition === leftBoundary && deltaX > 0) {
	        deltaX = 0;
	      } // prevent user from swiping right out of boundaries


	      if (currentPosition === lastLeftBoundary && deltaX < 0) {
	        deltaX = 0;
	      }

	      var wrapperSize = _this.itemsWrapperRef.clientWidth;
	      var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move

	      if (_this.itemsListRef) {
	        ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	          _this.itemsListRef.style[prop] = (0, _CSSTranslate.default)(position, '%', _this.props.axis);
	        });
	      }

	      return true;
	    });

	    _defineProperty(_assertThisInitialized(_this), "slideRight", function (positions) {
	      _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
	    });

	    _defineProperty(_assertThisInitialized(_this), "slideLeft", function (positions) {
	      _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
	    });

	    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
	      // position can't be lower than 0
	      position = position < 0 ? 0 : position; // position can't be higher than last postion

	      position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;

	      _this.setState({
	        firstItem: position
	      });
	    });

	    _this.state = {
	      selectedItem: _props.selectedItem,
	      swiping: false,
	      showArrows: false,
	      firstItem: 0,
	      visibleItems: 0,
	      lastPosition: 0
	    };
	    return _this;
	  }

	  _createClass(Thumbs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setupThumbs();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.selectedItem !== this.state.selectedItem) {
	        this.setState({
	          selectedItem: this.props.selectedItem,
	          firstItem: this.getFirstItem(this.props.selectedItem)
	        });
	      }

	      if (this.props.children === prevProps.children) {
	        return;
	      } // This will capture any size changes for arrow adjustments etc.
	      // usually in the same render cycle so we don't see any flickers


	      this.updateSizes();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyThumbs();
	    }
	  }, {
	    key: "setupThumbs",
	    value: function setupThumbs() {
	      // as the widths are calculated, we need to resize
	      // the carousel when the window is resized
	      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

	      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes); // when the component is rendered we need to calculate
	      // the container size to adjust the responsive behaviour

	      this.updateSizes();
	    }
	  }, {
	    key: "destroyThumbs",
	    value: function destroyThumbs() {
	      // removing listeners
	      (0, _window.default)().removeEventListener('resize', this.updateSizes);
	      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
	    }
	  }, {
	    key: "getFirstItem",
	    value: function getFirstItem(selectedItem) {
	      var firstItem = selectedItem;

	      if (selectedItem >= this.state.lastPosition) {
	        firstItem = this.state.lastPosition;
	      }

	      if (selectedItem < this.state.firstItem + this.state.visibleItems) {
	        firstItem = this.state.firstItem;
	      }

	      if (selectedItem < this.state.firstItem) {
	        firstItem = selectedItem;
	      }

	      return firstItem;
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this2 = this;

	      return this.props.children.map(function (img, index) {
	        var itemClass = _cssClasses.default.ITEM(false, index === _this2.state.selectedItem);

	        var thumbProps = {
	          key: index,
	          ref: function ref(e) {
	            return _this2.setThumbsRef(e, index);
	          },
	          className: itemClass,
	          onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
	          onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
	          'aria-label': "".concat(_this2.props.labels.item, " ").concat(index + 1),
	          style: {
	            width: _this2.props.thumbWidth
	          }
	        };
	        return /*#__PURE__*/_react.default.createElement("li", _extends({}, thumbProps, {
	          role: "button",
	          tabIndex: 0
	        }), img);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;

	      if (!this.props.children) {
	        return null;
	      }

	      var isSwipeable = _react.Children.count(this.props.children) > 1; // show left arrow?

	      var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow

	      var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles

	      var itemListStyles = {};
	      var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
	      var transformProp = (0, _CSSTranslate.default)(currentPosition, 'px', this.props.axis);
	      var transitionTime = this.props.transitionTime + 'ms';
	      itemListStyles = {
	        WebkitTransform: transformProp,
	        MozTransform: transformProp,
	        MsTransform: transformProp,
	        OTransform: transformProp,
	        transform: transformProp,
	        msTransform: transformProp,
	        WebkitTransitionDuration: transitionTime,
	        MozTransitionDuration: transitionTime,
	        MsTransitionDuration: transitionTime,
	        OTransitionDuration: transitionTime,
	        transitionDuration: transitionTime,
	        msTransitionDuration: transitionTime
	      };
	      return /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.CAROUSEL(false)
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.WRAPPER(false),
	        ref: this.setItemsWrapperRef
	      }, /*#__PURE__*/_react.default.createElement("button", {
	        type: "button",
	        className: _cssClasses.default.ARROW_PREV(!hasPrev),
	        onClick: function onClick() {
	          return _this3.slideRight();
	        },
	        "aria-label": this.props.labels.leftArrow
	      }), isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, {
	        tagName: "ul",
	        className: _cssClasses.default.SLIDER(false, this.state.swiping),
	        onSwipeLeft: this.slideLeft,
	        onSwipeRight: this.slideRight,
	        onSwipeMove: this.onSwipeMove,
	        onSwipeStart: this.onSwipeStart,
	        onSwipeEnd: this.onSwipeEnd,
	        style: itemListStyles,
	        innerRef: this.setItemsListRef,
	        allowMouseEvents: this.props.emulateTouch
	      }, this.renderItems()) : /*#__PURE__*/_react.default.createElement("ul", {
	        className: _cssClasses.default.SLIDER(false, this.state.swiping),
	        ref: function ref(node) {
	          return _this3.setItemsListRef(node);
	        },
	        style: itemListStyles
	      }, this.renderItems()), /*#__PURE__*/_react.default.createElement("button", {
	        type: "button",
	        className: _cssClasses.default.ARROW_NEXT(!hasNext),
	        onClick: function onClick() {
	          return _this3.slideLeft();
	        },
	        "aria-label": this.props.labels.rightArrow
	      })));
	    }
	  }]);

	  return Thumbs;
	}(_react.Component);

	Thumbs.default = Thumbs$1;

	_defineProperty(Thumbs$1, "displayName", 'Thumbs');

	_defineProperty(Thumbs$1, "defaultProps", {
	  axis: 'horizontal',
	  labels: {
	    leftArrow: 'previous slide / item',
	    rightArrow: 'next slide / item',
	    item: 'slide item'
	  },
	  selectedItem: 0,
	  thumbWidth: 80,
	  transitionTime: 350
	});
	return Thumbs;
}

var document$2 = {};

var hasRequiredDocument$1;

function requireDocument$1 () {
	if (hasRequiredDocument$1) return document$2;
	hasRequiredDocument$1 = 1;

	Object.defineProperty(document$2, "__esModule", {
	  value: true
	});
	document$2.default = void 0;

	var _default = function _default() {
	  return document;
	};

	document$2.default = _default;
	return document$2;
}

var utils = {};

var hasRequiredUtils;

function requireUtils () {
	if (hasRequiredUtils) return utils;
	hasRequiredUtils = 1;

	Object.defineProperty(utils, "__esModule", {
	  value: true
	});
	utils.setPosition = utils.getPosition = utils.isKeyboardEvent = utils.defaultStatusFormatter = utils.noop = void 0;

	var _react = React__default;

	var _CSSTranslate = _interopRequireDefault(requireCSSTranslate());

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var noop = function noop() {};

	utils.noop = noop;

	var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
	  return "".concat(current, " of ").concat(total);
	};

	utils.defaultStatusFormatter = defaultStatusFormatter;

	var isKeyboardEvent = function isKeyboardEvent(e) {
	  return e ? e.hasOwnProperty('key') : false;
	};
	/**
	 * Gets the list 'position' relative to a current index
	 * @param index
	 */


	utils.isKeyboardEvent = isKeyboardEvent;

	var getPosition = function getPosition(index, props) {
	  if (props.infiniteLoop) {
	    // index has to be added by 1 because of the first cloned slide
	    ++index;
	  }

	  if (index === 0) {
	    return 0;
	  }

	  var childrenLength = _react.Children.count(props.children);

	  if (props.centerMode && props.axis === 'horizontal') {
	    var currentPosition = -index * props.centerSlidePercentage;
	    var lastPosition = childrenLength - 1;

	    if (index && (index !== lastPosition || props.infiniteLoop)) {
	      currentPosition += (100 - props.centerSlidePercentage) / 2;
	    } else if (index === lastPosition) {
	      currentPosition += 100 - props.centerSlidePercentage;
	    }

	    return currentPosition;
	  }

	  return -index * 100;
	};
	/**
	 * Sets the 'position' transform for sliding animations
	 * @param position
	 * @param forceReflow
	 */


	utils.getPosition = getPosition;

	var setPosition = function setPosition(position, axis) {
	  var style = {};
	  ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	    // @ts-ignore
	    style[prop] = (0, _CSSTranslate.default)(position, '%', axis);
	  });
	  return style;
	};

	utils.setPosition = setPosition;
	return utils;
}

var animations = {};

var hasRequiredAnimations;

function requireAnimations () {
	if (hasRequiredAnimations) return animations;
	hasRequiredAnimations = 1;

	Object.defineProperty(animations, "__esModule", {
	  value: true
	});
	animations.fadeAnimationHandler = animations.slideStopSwipingHandler = animations.slideSwipeAnimationHandler = animations.slideAnimationHandler = void 0;

	var _react = React__default;

	var _CSSTranslate = _interopRequireDefault(requireCSSTranslate());

	var _utils = requireUtils();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	/**
	 * Main animation handler for the default 'sliding' style animation
	 * @param props
	 * @param state
	 */
	var slideAnimationHandler = function slideAnimationHandler(props, state) {
	  var returnStyles = {};
	  var selectedItem = state.selectedItem;
	  var previousItem = selectedItem;
	  var lastPosition = _react.Children.count(props.children) - 1;
	  var needClonedSlide = props.infiniteLoop && (selectedItem < 0 || selectedItem > lastPosition); // Handle list position if it needs a clone

	  if (needClonedSlide) {
	    if (previousItem < 0) {
	      if (props.centerMode && props.centerSlidePercentage && props.axis === 'horizontal') {
	        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * props.centerSlidePercentage - (100 - props.centerSlidePercentage) / 2, props.axis);
	      } else {
	        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * 100, props.axis);
	      }
	    } else if (previousItem > lastPosition) {
	      returnStyles.itemListStyle = (0, _utils.setPosition)(0, props.axis);
	    }

	    return returnStyles;
	  }

	  var currentPosition = (0, _utils.getPosition)(selectedItem, props); // if 3d is available, let's take advantage of the performance of transform

	  var transformProp = (0, _CSSTranslate.default)(currentPosition, '%', props.axis);
	  var transitionTime = props.transitionTime + 'ms';
	  returnStyles.itemListStyle = {
	    WebkitTransform: transformProp,
	    msTransform: transformProp,
	    OTransform: transformProp,
	    transform: transformProp
	  };

	  if (!state.swiping) {
	    returnStyles.itemListStyle = _objectSpread(_objectSpread({}, returnStyles.itemListStyle), {}, {
	      WebkitTransitionDuration: transitionTime,
	      MozTransitionDuration: transitionTime,
	      OTransitionDuration: transitionTime,
	      transitionDuration: transitionTime,
	      msTransitionDuration: transitionTime
	    });
	  }

	  return returnStyles;
	};
	/**
	 * Swiping animation handler for the default 'sliding' style animation
	 * @param delta
	 * @param props
	 * @param state
	 * @param setState
	 */


	animations.slideAnimationHandler = slideAnimationHandler;

	var slideSwipeAnimationHandler = function slideSwipeAnimationHandler(delta, props, state, setState) {
	  var returnStyles = {};
	  var isHorizontal = props.axis === 'horizontal';

	  var childrenLength = _react.Children.count(props.children);

	  var initialBoundry = 0;
	  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
	  var finalBoundry = props.infiniteLoop ? (0, _utils.getPosition)(childrenLength - 1, props) - 100 : (0, _utils.getPosition)(childrenLength - 1, props);
	  var axisDelta = isHorizontal ? delta.x : delta.y;
	  var handledDelta = axisDelta; // prevent user from swiping left out of boundaries

	  if (currentPosition === initialBoundry && axisDelta > 0) {
	    handledDelta = 0;
	  } // prevent user from swiping right out of boundaries


	  if (currentPosition === finalBoundry && axisDelta < 0) {
	    handledDelta = 0;
	  }

	  var position = currentPosition + 100 / (state.itemSize / handledDelta);
	  var hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;

	  if (props.infiniteLoop && hasMoved) {
	    // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
	    // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
	    if (state.selectedItem === 0 && position > -100) {
	      position -= childrenLength * 100;
	    } else if (state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) {
	      position += childrenLength * 100;
	    }
	  }

	  if (!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
	    if (!state.swipeMovementStarted) {
	      setState({
	        swipeMovementStarted: true
	      });
	    }

	    returnStyles.itemListStyle = (0, _utils.setPosition)(position, props.axis);
	  } //allows scroll if the swipe was within the tolerance


	  if (hasMoved && !state.cancelClick) {
	    setState({
	      cancelClick: true
	    });
	  }

	  return returnStyles;
	};
	/**
	 * Default 'sliding' style animination handler for when a swipe action stops.
	 * @param props
	 * @param state
	 */


	animations.slideSwipeAnimationHandler = slideSwipeAnimationHandler;

	var slideStopSwipingHandler = function slideStopSwipingHandler(props, state) {
	  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
	  var itemListStyle = (0, _utils.setPosition)(currentPosition, props.axis);
	  return {
	    itemListStyle: itemListStyle
	  };
	};
	/**
	 * Main animation handler for the default 'fade' style animation
	 * @param props
	 * @param state
	 */


	animations.slideStopSwipingHandler = slideStopSwipingHandler;

	var fadeAnimationHandler = function fadeAnimationHandler(props, state) {
	  var transitionTime = props.transitionTime + 'ms';
	  var transitionTimingFunction = 'ease-in-out';
	  var slideStyle = {
	    position: 'absolute',
	    display: 'block',
	    zIndex: -2,
	    minHeight: '100%',
	    opacity: 0,
	    top: 0,
	    right: 0,
	    left: 0,
	    bottom: 0,
	    transitionTimingFunction: transitionTimingFunction,
	    msTransitionTimingFunction: transitionTimingFunction,
	    MozTransitionTimingFunction: transitionTimingFunction,
	    WebkitTransitionTimingFunction: transitionTimingFunction,
	    OTransitionTimingFunction: transitionTimingFunction
	  };

	  if (!state.swiping) {
	    slideStyle = _objectSpread(_objectSpread({}, slideStyle), {}, {
	      WebkitTransitionDuration: transitionTime,
	      MozTransitionDuration: transitionTime,
	      OTransitionDuration: transitionTime,
	      transitionDuration: transitionTime,
	      msTransitionDuration: transitionTime
	    });
	  }

	  return {
	    slideStyle: slideStyle,
	    selectedStyle: _objectSpread(_objectSpread({}, slideStyle), {}, {
	      opacity: 1,
	      position: 'relative'
	    }),
	    prevStyle: _objectSpread({}, slideStyle)
	  };
	};

	animations.fadeAnimationHandler = fadeAnimationHandler;
	return animations;
}

var hasRequiredCarousel;

function requireCarousel () {
	if (hasRequiredCarousel) return Carousel;
	hasRequiredCarousel = 1;

	Object.defineProperty(Carousel, "__esModule", {
	  value: true
	});
	Carousel.default = void 0;

	var _react = _interopRequireWildcard(React__default);

	var _reactEasySwipe = _interopRequireDefault(requireLib$6());

	var _cssClasses = _interopRequireDefault(requireCssClasses());

	var _Thumbs = _interopRequireDefault(requireThumbs());

	var _document = _interopRequireDefault(requireDocument$1());

	var _window = _interopRequireDefault(requireWindow());

	var _utils = requireUtils();

	var _animations = requireAnimations();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var Carousel$1 = /*#__PURE__*/function (_React$Component) {
	  _inherits(Carousel, _React$Component);

	  var _super = _createSuper(Carousel);

	  // @ts-ignore
	  function Carousel(props) {
	    var _this;

	    _classCallCheck(this, Carousel);

	    _this = _super.call(this, props);

	    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "carouselWrapperRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "listRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "itemsRef", void 0);

	    _defineProperty(_assertThisInitialized(_this), "timer", void 0);

	    _defineProperty(_assertThisInitialized(_this), "animationHandler", void 0);

	    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node) {
	      _this.thumbsRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setCarouselWrapperRef", function (node) {
	      _this.carouselWrapperRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setListRef", function (node) {
	      _this.listRef = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "setItemsRef", function (node, index) {
	      if (!_this.itemsRef) {
	        _this.itemsRef = [];
	      }

	      _this.itemsRef[index] = node;
	    });

	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function () {
	      if (_react.Children.count(_this.props.children) <= 1) {
	        return;
	      }

	      _this.clearAutoPlay();

	      if (!_this.props.autoPlay) {
	        return;
	      }

	      _this.timer = setTimeout(function () {
	        _this.increment();
	      }, _this.props.interval);
	    });

	    _defineProperty(_assertThisInitialized(_this), "clearAutoPlay", function () {
	      if (_this.timer) clearTimeout(_this.timer);
	    });

	    _defineProperty(_assertThisInitialized(_this), "resetAutoPlay", function () {
	      _this.clearAutoPlay();

	      _this.autoPlay();
	    });

	    _defineProperty(_assertThisInitialized(_this), "stopOnHover", function () {
	      _this.setState({
	        isMouseEntered: true
	      }, _this.clearAutoPlay);
	    });

	    _defineProperty(_assertThisInitialized(_this), "startOnLeave", function () {
	      _this.setState({
	        isMouseEntered: false
	      }, _this.autoPlay);
	    });

	    _defineProperty(_assertThisInitialized(_this), "isFocusWithinTheCarousel", function () {
	      if (!_this.carouselWrapperRef) {
	        return false;
	      }

	      if ((0, _document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, _document.default)().activeElement)) {
	        return true;
	      }

	      return false;
	    });

	    _defineProperty(_assertThisInitialized(_this), "navigateWithKeyboard", function (e) {
	      if (!_this.isFocusWithinTheCarousel()) {
	        return;
	      }

	      var axis = _this.props.axis;
	      var isHorizontal = axis === 'horizontal';
	      var keyNames = {
	        ArrowUp: 38,
	        ArrowRight: 39,
	        ArrowDown: 40,
	        ArrowLeft: 37
	      };
	      var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
	      var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;

	      if (nextKey === e.keyCode) {
	        _this.increment();
	      } else if (prevKey === e.keyCode) {
	        _this.decrement();
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
	      if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) {
	        return;
	      }

	      var isHorizontal = _this.props.axis === 'horizontal';
	      var firstItem = _this.itemsRef[0];

	      if (!firstItem) {
	        return;
	      }

	      var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;

	      _this.setState({
	        itemSize: itemSize
	      });

	      if (_this.thumbsRef) {
	        _this.thumbsRef.updateSizes();
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "setMountState", function () {
	      _this.setState({
	        hasMount: true
	      });

	      _this.updateSizes();
	    });

	    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item) {
	      if (_react.Children.count(_this.props.children) === 0) {
	        return;
	      }

	      if (_this.state.cancelClick) {
	        _this.setState({
	          cancelClick: false
	        });

	        return;
	      }

	      _this.props.onClickItem(index, item);

	      if (index !== _this.state.selectedItem) {
	        _this.setState({
	          selectedItem: index
	        });
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (index, item) {
	      if (_react.Children.count(_this.props.children) <= 1) {
	        return;
	      }

	      _this.props.onChange(index, item);
	    });

	    _defineProperty(_assertThisInitialized(_this), "handleClickThumb", function (index, item) {
	      _this.props.onClickThumb(index, item);

	      _this.moveTo(index);
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function (event) {
	      _this.setState({
	        swiping: true
	      });

	      _this.props.onSwipeStart(event);
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function (event) {
	      _this.setState({
	        swiping: false,
	        cancelClick: false,
	        swipeMovementStarted: false
	      });

	      _this.props.onSwipeEnd(event);

	      _this.clearAutoPlay();

	      if (_this.state.autoPlay) {
	        _this.autoPlay();
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta, event) {
	      _this.props.onSwipeMove(event);

	      var animationHandlerResponse = _this.props.swipeAnimationHandler(delta, _this.props, _this.state, _this.setState.bind(_assertThisInitialized(_this)));

	      _this.setState(_objectSpread({}, animationHandlerResponse)); // If we have not moved, we should have an empty object returned
	      // Return false to allow scrolling when not swiping


	      return !!Object.keys(animationHandlerResponse).length;
	    });

	    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
	      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	      _this.moveTo(_this.state.selectedItem - (typeof positions === 'number' ? positions : 1));
	    });

	    _defineProperty(_assertThisInitialized(_this), "increment", function () {
	      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	      _this.moveTo(_this.state.selectedItem + (typeof positions === 'number' ? positions : 1));
	    });

	    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
	      if (typeof position !== 'number') {
	        return;
	      }

	      var lastPosition = _react.Children.count(_this.props.children) - 1;

	      if (position < 0) {
	        position = _this.props.infiniteLoop ? lastPosition : 0;
	      }

	      if (position > lastPosition) {
	        position = _this.props.infiniteLoop ? 0 : lastPosition;
	      }

	      _this.selectItem({
	        // if it's not a slider, we don't need to set position here
	        selectedItem: position
	      }); // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
	      // and will result in the interval function not being cleared correctly.


	      if (_this.state.autoPlay && _this.state.isMouseEntered === false) {
	        _this.resetAutoPlay();
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "onClickNext", function () {
	      _this.increment(1);
	    });

	    _defineProperty(_assertThisInitialized(_this), "onClickPrev", function () {
	      _this.decrement(1);
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeForward", function () {
	      _this.increment(1);

	      if (_this.props.emulateTouch) {
	        _this.setState({
	          cancelClick: true
	        });
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "onSwipeBackwards", function () {
	      _this.decrement(1);

	      if (_this.props.emulateTouch) {
	        _this.setState({
	          cancelClick: true
	        });
	      }
	    });

	    _defineProperty(_assertThisInitialized(_this), "changeItem", function (newIndex) {
	      return function (e) {
	        if (!(0, _utils.isKeyboardEvent)(e) || e.key === 'Enter') {
	          _this.moveTo(newIndex);
	        }
	      };
	    });

	    _defineProperty(_assertThisInitialized(_this), "selectItem", function (state) {
	      // Merge in the new state while updating updating previous item
	      _this.setState(_objectSpread({
	        previousItem: _this.state.selectedItem
	      }, state), function () {
	        // Run animation handler and update styles based on it
	        _this.setState(_this.animationHandler(_this.props, _this.state));
	      });

	      _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
	    });

	    _defineProperty(_assertThisInitialized(_this), "getInitialImage", function () {
	      var selectedItem = _this.props.selectedItem;
	      var item = _this.itemsRef && _this.itemsRef[selectedItem];
	      var images = item && item.getElementsByTagName('img') || [];
	      return images[0];
	    });

	    _defineProperty(_assertThisInitialized(_this), "getVariableItemHeight", function (position) {
	      var item = _this.itemsRef && _this.itemsRef[position];

	      if (_this.state.hasMount && item && item.children.length) {
	        var slideImages = item.children[0].getElementsByTagName('img') || [];

	        if (slideImages.length > 0) {
	          var image = slideImages[0];

	          if (!image.complete) {
	            // if the image is still loading, the size won't be available so we trigger a new render after it's done
	            var onImageLoad = function onImageLoad() {
	              _this.forceUpdate();

	              image.removeEventListener('load', onImageLoad);
	            };

	            image.addEventListener('load', onImageLoad);
	          }
	        } // try to get img first, if img not there find first display tag


	        var displayItem = slideImages[0] || item.children[0];
	        var height = displayItem.clientHeight;
	        return height > 0 ? height : null;
	      }

	      return null;
	    });

	    var initState = {
	      initialized: false,
	      previousItem: props.selectedItem,
	      selectedItem: props.selectedItem,
	      hasMount: false,
	      isMouseEntered: false,
	      autoPlay: props.autoPlay,
	      swiping: false,
	      swipeMovementStarted: false,
	      cancelClick: false,
	      itemSize: 1,
	      itemListStyle: {},
	      slideStyle: {},
	      selectedStyle: {},
	      prevStyle: {}
	    };
	    _this.animationHandler = typeof props.animationHandler === 'function' && props.animationHandler || props.animationHandler === 'fade' && _animations.fadeAnimationHandler || _animations.slideAnimationHandler;
	    _this.state = _objectSpread(_objectSpread({}, initState), _this.animationHandler(props, initState));
	    return _this;
	  }

	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!this.props.children) {
	        return;
	      }

	      this.setupCarousel();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!prevProps.children && this.props.children && !this.state.initialized) {
	        this.setupCarousel();
	      }

	      if (!prevProps.autoFocus && this.props.autoFocus) {
	        this.forceFocus();
	      }

	      if (prevState.swiping && !this.state.swiping) {
	        // We stopped swiping, ensure we are heading to the new/current slide and not stuck
	        this.setState(_objectSpread({}, this.props.stopSwipingHandler(this.props, this.state)));
	      }

	      if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
	        this.updateSizes();
	        this.moveTo(this.props.selectedItem);
	      }

	      if (prevProps.autoPlay !== this.props.autoPlay) {
	        if (this.props.autoPlay) {
	          this.setupAutoPlay();
	        } else {
	          this.destroyAutoPlay();
	        }

	        this.setState({
	          autoPlay: this.props.autoPlay
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyCarousel();
	    }
	  }, {
	    key: "setupCarousel",
	    value: function setupCarousel() {
	      var _this2 = this;

	      this.bindEvents();

	      if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) {
	        this.setupAutoPlay();
	      }

	      if (this.props.autoFocus) {
	        this.forceFocus();
	      }

	      this.setState({
	        initialized: true
	      }, function () {
	        var initialImage = _this2.getInitialImage();

	        if (initialImage && !initialImage.complete) {
	          // if it's a carousel of images, we set the mount state after the first image is loaded
	          initialImage.addEventListener('load', _this2.setMountState);
	        } else {
	          _this2.setMountState();
	        }
	      });
	    }
	  }, {
	    key: "destroyCarousel",
	    value: function destroyCarousel() {
	      if (this.state.initialized) {
	        this.unbindEvents();
	        this.destroyAutoPlay();
	      }
	    }
	  }, {
	    key: "setupAutoPlay",
	    value: function setupAutoPlay() {
	      this.autoPlay();
	      var carouselWrapper = this.carouselWrapperRef;

	      if (this.props.stopOnHover && carouselWrapper) {
	        carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
	        carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
	      }
	    }
	  }, {
	    key: "destroyAutoPlay",
	    value: function destroyAutoPlay() {
	      this.clearAutoPlay();
	      var carouselWrapper = this.carouselWrapperRef;

	      if (this.props.stopOnHover && carouselWrapper) {
	        carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
	        carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
	      }
	    }
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      // as the widths are calculated, we need to resize
	      // the carousel when the window is resized
	      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

	      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes);

	      if (this.props.useKeyboardArrows) {
	        (0, _document.default)().addEventListener('keydown', this.navigateWithKeyboard);
	      }
	    }
	  }, {
	    key: "unbindEvents",
	    value: function unbindEvents() {
	      // removing listeners
	      (0, _window.default)().removeEventListener('resize', this.updateSizes);
	      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
	      var initialImage = this.getInitialImage();

	      if (initialImage) {
	        initialImage.removeEventListener('load', this.setMountState);
	      }

	      if (this.props.useKeyboardArrows) {
	        (0, _document.default)().removeEventListener('keydown', this.navigateWithKeyboard);
	      }
	    }
	  }, {
	    key: "forceFocus",
	    value: function forceFocus() {
	      var _this$carouselWrapper;

	      (_this$carouselWrapper = this.carouselWrapperRef) === null || _this$carouselWrapper === void 0 ? void 0 : _this$carouselWrapper.focus();
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems(isClone) {
	      var _this3 = this;

	      if (!this.props.children) {
	        return [];
	      }

	      return _react.Children.map(this.props.children, function (item, index) {
	        var isSelected = index === _this3.state.selectedItem;
	        var isPrevious = index === _this3.state.previousItem;
	        var style = isSelected && _this3.state.selectedStyle || isPrevious && _this3.state.prevStyle || _this3.state.slideStyle || {};

	        if (_this3.props.centerMode && _this3.props.axis === 'horizontal') {
	          style = _objectSpread(_objectSpread({}, style), {}, {
	            minWidth: _this3.props.centerSlidePercentage + '%'
	          });
	        }

	        if (_this3.state.swiping && _this3.state.swipeMovementStarted) {
	          style = _objectSpread(_objectSpread({}, style), {}, {
	            pointerEvents: 'none'
	          });
	        }

	        var slideProps = {
	          ref: function ref(e) {
	            return _this3.setItemsRef(e, index);
	          },
	          key: 'itemKey' + index + (isClone ? 'clone' : ''),
	          className: _cssClasses.default.ITEM(true, index === _this3.state.selectedItem, index === _this3.state.previousItem),
	          onClick: _this3.handleClickItem.bind(_this3, index, item),
	          style: style
	        };
	        return /*#__PURE__*/_react.default.createElement("li", slideProps, _this3.props.renderItem(item, {
	          isSelected: index === _this3.state.selectedItem,
	          isPrevious: index === _this3.state.previousItem
	        }));
	      });
	    }
	  }, {
	    key: "renderControls",
	    value: function renderControls() {
	      var _this4 = this;

	      var _this$props = this.props,
	          showIndicators = _this$props.showIndicators,
	          labels = _this$props.labels,
	          renderIndicator = _this$props.renderIndicator,
	          children = _this$props.children;

	      if (!showIndicators) {
	        return null;
	      }

	      return /*#__PURE__*/_react.default.createElement("ul", {
	        className: "control-dots"
	      }, _react.Children.map(children, function (_, index) {
	        return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
	      }));
	    }
	  }, {
	    key: "renderStatus",
	    value: function renderStatus() {
	      if (!this.props.showStatus) {
	        return null;
	      }

	      return /*#__PURE__*/_react.default.createElement("p", {
	        className: "carousel-status"
	      }, this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children)));
	    }
	  }, {
	    key: "renderThumbs",
	    value: function renderThumbs() {
	      if (!this.props.showThumbs || !this.props.children || _react.Children.count(this.props.children) === 0) {
	        return null;
	      }

	      return /*#__PURE__*/_react.default.createElement(_Thumbs.default, {
	        ref: this.setThumbsRef,
	        onSelectItem: this.handleClickThumb,
	        selectedItem: this.state.selectedItem,
	        transitionTime: this.props.transitionTime,
	        thumbWidth: this.props.thumbWidth,
	        labels: this.props.labels,
	        emulateTouch: this.props.emulateTouch
	      }, this.props.renderThumbs(this.props.children));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;

	      if (!this.props.children || _react.Children.count(this.props.children) === 0) {
	        return null;
	      }

	      var isSwipeable = this.props.swipeable && _react.Children.count(this.props.children) > 1;
	      var isHorizontal = this.props.axis === 'horizontal';
	      var canShowArrows = this.props.showArrows && _react.Children.count(this.props.children) > 1; // show left arrow?

	      var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow

	      var hasNext = canShowArrows && (this.state.selectedItem < _react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false;
	      var itemsClone = this.renderItems(true);
	      var firstClone = itemsClone.shift();
	      var lastClone = itemsClone.pop();
	      var swiperProps = {
	        className: _cssClasses.default.SLIDER(true, this.state.swiping),
	        onSwipeMove: this.onSwipeMove,
	        onSwipeStart: this.onSwipeStart,
	        onSwipeEnd: this.onSwipeEnd,
	        style: this.state.itemListStyle,
	        tolerance: this.props.swipeScrollTolerance
	      };
	      var containerStyles = {};

	      if (isHorizontal) {
	        swiperProps.onSwipeLeft = this.onSwipeForward;
	        swiperProps.onSwipeRight = this.onSwipeBackwards;

	        if (this.props.dynamicHeight) {
	          var itemHeight = this.getVariableItemHeight(this.state.selectedItem); // swiperProps.style.height = itemHeight || 'auto';

	          containerStyles.height = itemHeight || 'auto';
	        }
	      } else {
	        swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.onSwipeBackwards : this.onSwipeForward;
	        swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.onSwipeForward : this.onSwipeBackwards;
	        swiperProps.style = _objectSpread(_objectSpread({}, swiperProps.style), {}, {
	          height: this.state.itemSize
	        });
	        containerStyles.height = this.state.itemSize;
	      }

	      return /*#__PURE__*/_react.default.createElement("div", {
	        "aria-label": this.props.ariaLabel,
	        className: _cssClasses.default.ROOT(this.props.className),
	        ref: this.setCarouselWrapperRef,
	        tabIndex: this.props.useKeyboardArrows ? 0 : undefined
	      }, /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.CAROUSEL(true),
	        style: {
	          width: this.props.width
	        }
	      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/_react.default.createElement("div", {
	        className: _cssClasses.default.WRAPPER(true, this.props.axis),
	        style: containerStyles
	      }, isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, _extends({
	        tagName: "ul",
	        innerRef: this.setListRef
	      }, swiperProps, {
	        allowMouseEvents: this.props.emulateTouch
	      }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/_react.default.createElement("ul", {
	        className: _cssClasses.default.SLIDER(true, this.state.swiping),
	        ref: function ref(node) {
	          return _this5.setListRef(node);
	        },
	        style: this.state.itemListStyle || {}
	      }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
	    }
	  }]);

	  return Carousel;
	}(_react.default.Component);

	Carousel.default = Carousel$1;

	_defineProperty(Carousel$1, "displayName", 'Carousel');

	_defineProperty(Carousel$1, "defaultProps", {
	  ariaLabel: undefined,
	  axis: 'horizontal',
	  centerSlidePercentage: 80,
	  interval: 3000,
	  labels: {
	    leftArrow: 'previous slide / item',
	    rightArrow: 'next slide / item',
	    item: 'slide item'
	  },
	  onClickItem: _utils.noop,
	  onClickThumb: _utils.noop,
	  onChange: _utils.noop,
	  onSwipeStart: function onSwipeStart() {},
	  onSwipeEnd: function onSwipeEnd() {},
	  onSwipeMove: function onSwipeMove() {
	    return false;
	  },
	  preventMovementUntilSwipeScrollTolerance: false,
	  renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
	    return /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      "aria-label": label,
	      className: _cssClasses.default.ARROW_PREV(!hasPrev),
	      onClick: onClickHandler
	    });
	  },
	  renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
	    return /*#__PURE__*/_react.default.createElement("button", {
	      type: "button",
	      "aria-label": label,
	      className: _cssClasses.default.ARROW_NEXT(!hasNext),
	      onClick: onClickHandler
	    });
	  },
	  renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
	    return /*#__PURE__*/_react.default.createElement("li", {
	      className: _cssClasses.default.DOT(isSelected),
	      onClick: onClickHandler,
	      onKeyDown: onClickHandler,
	      value: index,
	      key: index,
	      role: "button",
	      tabIndex: 0,
	      "aria-label": "".concat(label, " ").concat(index + 1)
	    });
	  },
	  renderItem: function renderItem(item) {
	    return item;
	  },
	  renderThumbs: function renderThumbs(children) {
	    var images = _react.Children.map(children, function (item) {
	      var img = item; // if the item is not an image, try to find the first image in the item's children.

	      if (item.type !== 'img') {
	        img = _react.Children.toArray(item.props.children).find(function (children) {
	          return children.type === 'img';
	        });
	      }

	      if (!img) {
	        return undefined;
	      }

	      return img;
	    });

	    if (images.filter(function (image) {
	      return image;
	    }).length === 0) {
	      console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
	      return [];
	    }

	    return images;
	  },
	  statusFormatter: _utils.defaultStatusFormatter,
	  selectedItem: 0,
	  showArrows: true,
	  showIndicators: true,
	  showStatus: true,
	  showThumbs: true,
	  stopOnHover: true,
	  swipeScrollTolerance: 5,
	  swipeable: true,
	  transitionTime: 350,
	  verticalSwipe: 'standard',
	  width: '100%',
	  animationHandler: 'slide',
	  swipeAnimationHandler: _animations.slideSwipeAnimationHandler,
	  stopSwipingHandler: _animations.slideStopSwipingHandler
	});
	return Carousel;
}

var types = {};

var hasRequiredTypes;

function requireTypes () {
	if (hasRequiredTypes) return types;
	hasRequiredTypes = 1;
	return types;
}

var hasRequiredJs;

function requireJs () {
	if (hasRequiredJs) return js;
	hasRequiredJs = 1;
	(function (exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		Object.defineProperty(exports, "Carousel", {
		  enumerable: true,
		  get: function get() {
		    return _Carousel.default;
		  }
		});
		Object.defineProperty(exports, "CarouselProps", {
		  enumerable: true,
		  get: function get() {
		    return _types.CarouselProps;
		  }
		});
		Object.defineProperty(exports, "Thumbs", {
		  enumerable: true,
		  get: function get() {
		    return _Thumbs.default;
		  }
		});

		var _Carousel = _interopRequireDefault(requireCarousel());

		var _types = requireTypes();

		var _Thumbs = _interopRequireDefault(requireThumbs());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
} (js));
	return js;
}

var jsExports = requireJs();

var faCircle$1 = {};

var hasRequiredFaCircle$1;

function requireFaCircle$1 () {
	if (hasRequiredFaCircle$1) return faCircle$1;
	hasRequiredFaCircle$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'far';
		var iconName = 'circle';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f111';
		var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faCircle = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faCircle$1));
	return faCircle$1;
}

var faCircleExports$1 = requireFaCircle$1();

var faCircle = {};

var hasRequiredFaCircle;

function requireFaCircle () {
	if (hasRequiredFaCircle) return faCircle;
	hasRequiredFaCircle = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'circle';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f111';
		var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faCircle = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faCircle));
	return faCircle;
}

var faCircleExports = requireFaCircle();

const BannerPanel = () => {
    const strings = useStrings();
    const { brand } = useContext();
    const dispatch = useTypedDispatch();
    const isBannerEnabled = useFeatureToggles().isFeatureToggleEnabled('DISPLAY_BANNER_ADVERTS');
    const isBannerHidden = useTypedSelector(selectIsBannerHidden);
    const canShowBanner = brand && isBannerEnabled && !isBannerHidden;
    const { ref, width } = useElementWidth();
    const { data: banners } = useGetBannersQuery(canShowBanner ? { brand } : skipToken, {
        refetchOnMountOrArgChange: 1000 * 60 * 60 * 5 // Image URLs are only valid for 5 hours.
    });
    if (!canShowBanner || !banners || banners.length === 0) {
        return null;
    }
    function getBestFitImage({ image, smallImage, largeImage }) {
        var _a, _b;
        return (_b = (_a = [smallImage, image, largeImage]
            .filter((image) => image !== undefined)
            .sort((a, b) => Number(a.imageWidth) - Number(b.imageWidth))
            .find(image => Number(image.imageWidth) >= width)) !== null && _a !== void 0 ? _a : largeImage) !== null && _b !== void 0 ? _b : image;
    }
    // Set a minimum height to push page content down as soon as possible and before images have loaded.
    const tallestImage = banners
        .map(getBestFitImage)
        .sort((a, b) => Number(b.imageHeight) - Number(a.imageHeight))[0];
    const minHeight = Math.round(Number(tallestImage.imageHeight) * (width / Number(tallestImage.imageWidth)));
    return React__default.createElement(Panel, { className: className$z() },
        React__default.createElement("div", { ref: ref, style: { minHeight } },
            React__default.createElement("button", { className: className$z('hide'), title: strings.buttons.hide, "aria-label": strings.buttons.hide, onClick: () => dispatch(hideBanner()) },
                React__default.createElement(FontAwesomeIcon, { icon: faTimesExports.faTimes, size: "1x" })),
            React__default.createElement(jsExports.Carousel, { autoPlay: true, infiniteLoop: true, interval: 5000, showIndicators: banners.length > 1, showArrows: false, showThumbs: false, showStatus: false, renderIndicator: (click, selected, index) => (React__default.createElement("button", { role: "radio", className: className$z('indicator'), "aria-label": banners[index].alt, "aria-checked": selected, onClick: click },
                    React__default.createElement(FontAwesomeIcon, { icon: selected ? faCircleExports.faCircle : faCircleExports$1.faCircle, size: "xs" }))) }, banners.map(banner => (React__default.createElement(Link$1, { key: banner.id, className: className$z('banner'), href: banner.link, openInNewTab: true },
                React__default.createElement("img", { src: getBestFitImage(banner).imageUrl, alt: banner.alt })))))));
};
const className$z = createClassName('BannerPanel');

const VehicleLookupScreen = () => {
    const { vehicleLookup: strings } = useStrings();
    const { showNewVehicleLookupWorkflow } = useContext();
    const showFrequentlyUsedDocuments = useFeatureToggles().isFeatureToggleEnabled('SHOW_FREQUENTLY_USED_DOCUMENTS');
    const showImportantDocuments = useFeatureToggles().isFeatureToggleEnabled('RECENT_IMPORTANT_DOCUMENTS');
    const dispatch = useTypedDispatch();
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const vinResolver = useVinResolver();
    usePageTitle(strings.title, showNewVehicleLookupWorkflow && vehicle && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.ref) === 'vin' ? vinResolver(vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin) : vehicle === null || vehicle === void 0 ? void 0 : vehicle.name);
    useHelp('vehicle.lookupForm');
    const isDocumentGroupSearchEnabled = useFeatureToggles().isFeatureToggleEnabled('SEARCH_VIA_DOCUMENT_GROUP');
    const { getColumnPanels } = useVehicleLookupPanelLayout();
    useEffect(() => {
        if (!showNewVehicleLookupWorkflow) {
            dispatch(clearCurrentVehicle());
        }
    }, [dispatch, showNewVehicleLookupWorkflow]);
    const panels = {
        lookup: React__default.createElement(Fragment, { key: "lookup" }, (vehicle && showNewVehicleLookupWorkflow) ? React__default.createElement(VinControlPanel, null) : React__default.createElement(ChooseVehiclePanel, null)),
        modules: React__default.createElement(ModuleVehicleLookupPanels, { key: "modules" }),
        notices: React__default.createElement(NoticePanel, { key: "notices" }),
        documentGroupLookup: isDocumentGroupSearchEnabled && React__default.createElement(DocumentGroupLookupPanel, { key: "documentGroupLookup" }),
        importantDocuments: showImportantDocuments && React__default.createElement(ImportantDocumentPanel, { key: "importantDocuments", forCurrentVehicle: false }),
        favouriteContent: React__default.createElement(FavouriteContentPanel, { key: "favouriteContent", forCurrentVehicle: false }),
        frequentlyUsedDocuments: showFrequentlyUsedDocuments && React__default.createElement(FrequentlyUsedDocumentsPanel, { key: "frequentlyUsedDocuments", vehicle: null })
    };
    return React__default.createElement(Screen, { className: "VehicleLookupScreen" },
        React__default.createElement(PanelGrid, { singleColumn: true, className: "VehicleLookupScreen-newLookPanel" },
            React__default.createElement(BannerPanel, null),
            React__default.createElement(NewLookPanel, { allowDismiss: true })),
        React__default.createElement(PanelGrid, { className: "VehicleLookupScreen-panelGrid" },
            React__default.createElement(PanelGrid.Column, null, getColumnPanels(panels, 'left')),
            React__default.createElement(PanelGrid.Column, null, getColumnPanels(panels, 'right'))));
};

var faShoppingCart = {};

var hasRequiredFaShoppingCart;

function requireFaShoppingCart () {
	if (hasRequiredFaShoppingCart) return faShoppingCart;
	hasRequiredFaShoppingCart = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'shopping-cart';
		var width = 576;
		var height = 512;
		var ligatures = [];
		var unicode = 'f07a';
		var svgPathData = 'M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faShoppingCart = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faShoppingCart));
	return faShoppingCart;
}

var faShoppingCartExports = requireFaShoppingCart();

const InfoButton = ({ title, showTitle, href, onClick }) => {
    const linkTitle = showTitle ? undefined : title;
    const content = React__default.createElement(InfoText, null, showTitle && title);
    if (href) {
        return React__default.createElement("a", { className: "InfoButton", href: href, title: linkTitle, "aria-label": linkTitle }, content);
    }
    else {
        return React__default.createElement("button", { className: "InfoButton", title: linkTitle, "aria-label": linkTitle, onClick: onClick }, content);
    }
};

const SubscriptionInfoDialogue = ({ isOpen, specificity, subscription, onClose }) => {
    const { subscription: strings, buttons: buttonStrings } = useStrings();
    const navigation = useNavigation();
    return React__default.createElement(Dialogue, { className: "SubscriptionInfoDialogue", isOpen: isOpen, onClose: onClose },
        React__default.createElement(Dialogue.Header, { title: subscription.name, onClose: onClose }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement(SubscriptionInfo, { subscription: subscription, showName: false })),
        React__default.createElement(Dialogue.Footer, { buttons: [
                React__default.createElement(Button$2, { key: "cancel", variant: "outlined", onClick: onClose }, buttonStrings.cancel),
                React__default.createElement(ButtonLink, { key: "purchase", href: navigation.subscription(specificity, subscription.id) }, strings.purchaseButton)
            ] }));
};

const InlineList = ({ children }) => {
    return React__default.createElement("div", { className: "InlineList" }, children
        .filter((item) => Boolean(item))
        // eslint-disable-next-line react/no-array-index-key
        .map((item, index, array) => React__default.createElement(React__default.Fragment, { key: index },
        React__default.createElement("span", null, item),
        index < array.length - 1 && React__default.createElement("span", { className: "InlineList-separator" }, "\u00B7"))));
};

const SubscriptionsTableRow = ({ specificity, subscription, showScope, bypassVehicleSpecificSearch, rowProps, isCompactTable }) => {
    const { subscriptions: strings } = useStrings();
    const navigation = useNavigation();
    const [showInfoDialogue, setShowInfoDialogue] = useState(false);
    const whatsIncludedLink = React__default.createElement(InfoButton, { title: strings.whatsIncluded, showTitle: true, onClick: () => setShowInfoDialogue(true) });
    const purchaseButton = React__default.createElement(ButtonLink, { href: navigation.subscription(specificity, subscription.id, bypassVehicleSpecificSearch) },
        React__default.createElement(FontAwesomeIcon, { icon: faShoppingCartExports.faShoppingCart }),
        " ",
        strings.purchaseButton);
    return React__default.createElement(Table.Row, { className: "SubscriptionsTableRow", rowProps: rowProps },
        (() => {
            if (isCompactTable) {
                return React__default.createElement(MobileTableCell, null,
                    React__default.createElement("div", { className: "SubscriptionsTableRow-compact" },
                        React__default.createElement("div", { className: "SubscriptionsTableRow-info" },
                            React__default.createElement("div", null, subscription.name),
                            React__default.createElement(InlineList, null,
                                showScope && subscription.scope,
                                subscription.period),
                            whatsIncludedLink),
                        React__default.createElement("div", { className: "SubscriptionsTableRow-price" },
                            React__default.createElement(Price, { amount: subscription.price, currency: subscription.currency }),
                            purchaseButton)));
            }
            else {
                return React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Table.TextCell, null,
                        subscription.name,
                        whatsIncludedLink),
                    showScope && React__default.createElement(Table.TextCell, { wrap: false }, subscription.scope),
                    React__default.createElement(Table.TextCell, { wrap: false }, subscription.period),
                    React__default.createElement(Table.TextCell, { wrap: false },
                        React__default.createElement(Price, { amount: subscription.price, currency: subscription.currency })),
                    React__default.createElement(Table.ActionCell, null, purchaseButton));
            }
        })(),
        React__default.createElement(SubscriptionInfoDialogue, { isOpen: showInfoDialogue, specificity: specificity, subscription: subscription, onClose: () => setShowInfoDialogue(false) }));
};

const SubscriptionsTable = ({ specificity, subscriptions, bypassVehicleSpecificSearch }) => {
    const { subscriptions: strings } = useStrings();
    const showScope = specificity.specificity === 'vehicle' && specificity.vehicle.ref !== 'vin';
    const columns = [
        { id: 'name', title: strings.nameLabel, className: 'SubscriptionsTable-name' },
        showScope && { id: 'scope', title: strings.scopeLabel },
        { id: 'period', title: strings.periodLabel },
        { id: 'price', title: strings.priceLabel },
        { id: 'actions', title: '' }
    ].filter(filterFalse);
    function getRow(rowIndex) {
        const subscription = subscriptions[rowIndex];
        return {
            id: subscription.id,
            component: SubscriptionsTableRow,
            props: {
                specificity,
                subscription,
                showScope,
                bypassVehicleSpecificSearch
            }
        };
    }
    return React__default.createElement(Table, { className: "SubscriptionsTable", title: strings.availableSubscriptions, columns: columns, compactHeader: createResponsiveValue(false).maxWidth(MOBILE_BREAKPOINT, true), rowCount: subscriptions.length, getRow: getRow },
        React__default.createElement(EmptyTableRow, { message: strings.emptyList, size: "lg" }));
};

const SubscriptionsTablePanel = ({ specificity, scope, period, bypassVehicleSpecificSearch }) => {
    const { subscriptions: strings } = useStrings();
    const navigation = useNavigation();
    const [pageNumber, setPageNumber] = useState(0);
    const { data, error, isLoading, isFetching } = useGetSubscriptionPricesQuery({
        specificity,
        scope,
        period,
        pageNumber,
        pageSize: config.paginationPageSize,
        bypassVehicleSpecificSearch
    });
    useShowLoadingIndicator(isFetching && !isLoading);
    const paginator = usePaginator(data, setPageNumber, `${scope}-${period}`);
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const subscriptions = data === null || data === void 0 ? void 0 : data.elements;
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Panel, { className: "SubscriptionsTablePanel" },
            React__default.createElement(TableHeader, { title: strings.availableSubscriptions },
                React__default.createElement(Pagination, { paginator: paginator })),
            (() => {
                if (errorMessage) {
                    return React__default.createElement(Panel.Message, { text: errorMessage });
                }
                if (!subscriptions || (bypassVehicleSpecificSearch && isFetching)) {
                    return React__default.createElement(TableSkeleton, null);
                }
                if (subscriptions.length === 0 && !bypassVehicleSpecificSearch && specificity.specificity === 'vehicle' && specificity.vehicle.ref === 'vin') {
                    return React__default.createElement("div", { className: "SubscriptionsTablePanel-bypassPanel" },
                        React__default.createElement(Panel, { variant: "info" },
                            React__default.createElement(Panel.Content, null,
                                React__default.createElement(Text, null, strings.noSingleVehicleSubscriptions(navigation.subscriptions(specificity, true))))));
                }
                return React__default.createElement(SubscriptionsTable, { specificity: specificity, subscriptions: subscriptions, bypassVehicleSpecificSearch: bypassVehicleSpecificSearch });
            })()),
        React__default.createElement(Pagination, { paginator: paginator, centerHorizontally: true }));
};

const SubscriptionFilterPanel = ({ specificity, scope, period, bypassVehicleSpecificSearch, onScopeChange, onPeriodChange }) => {
    const { subscriptions: strings } = useStrings();
    const navigation = useNavigation();
    const { ref: widthElement, width } = useElementWidth();
    const vinResolver = useVinResolver();
    const scopeSelect = useSelect({
        id: 'scope',
        items: [
            ['all', strings.scopes.all],
            ['model', strings.scopes.model],
            ['singleModelYear', strings.scopes.singleModelYear]
        ],
        value: scope,
        onChange: onScopeChange
    });
    const periodSelect = useSelect({
        id: 'period',
        items: [
            ['all', strings.periods.all],
            ['1hour', strings.periods.oneHour],
            ['1day', strings.periods.oneDay],
            ['1week', strings.periods.oneWeek],
            ['30days', strings.periods.thirtyDays],
            ['1year', strings.periods.oneYear],
            ['indefinite', strings.periods.indefinite]
        ],
        value: period,
        onChange: onPeriodChange
    });
    const classes = classNames('SubscriptionFilterPanel', {
        'SubscriptionFilterPanel-compact': width < 600
    });
    const vehicle = (specificity.specificity === 'vehicle' && specificity.vehicle) ||
        (specificity.specificity === 'document' && specificity.document.vehicle);
    return React__default.createElement(Panel, { className: classes },
        React__default.createElement(Panel.Content, null,
            React__default.createElement("div", { className: "SubscriptionFilterPanel-content", ref: widthElement },
                React__default.createElement("div", { className: "SubscriptionFilterPanel-filter" },
                    React__default.createElement("label", { htmlFor: periodSelect.id }, strings.periodLabel),
                    periodSelect.input),
                React__default.createElement("div", { className: "SubscriptionFilterPanel-filter" }, (() => {
                    if (vehicle) {
                        if (vehicle.ref === 'vin' && !bypassVehicleSpecificSearch) {
                            return React__default.createElement(Text, null, strings.viewingVinOnly(vinResolver(vehicle.vin), navigation.vehicle(vehicle)));
                        }
                        else {
                            return React__default.createElement(React__default.Fragment, null,
                                React__default.createElement("label", { htmlFor: scopeSelect.id }, strings.scopeLabel),
                                scopeSelect.input);
                        }
                    }
                    else {
                        return React__default.createElement(Text, null, strings.vehicleLookup(navigation.home()));
                    }
                })()))));
};

const SubscriptionsScreen = ({ specificity, bypassVehicleSpecificSearch }) => {
    const { subscriptions: strings } = useStrings();
    const [scope, setScope] = useState('all');
    const [period, setPeriod] = useState('all');
    usePageTitle(strings.purchaseTitle);
    const vinResolver = useVinResolver();
    const { data: document, isError: isDocumentError } = useGetDocumentMetadataQuery(specificity.specificity === 'document' ? specificity.document.id : skipToken);
    const subtitle = useMemo(() => {
        if (specificity.specificity === 'vehicle') {
            return strings.subscriptionsFor(getVehicleDisplayName(specificity.vehicle, vinResolver));
        }
        else if (specificity.specificity === 'document' && !isDocumentError) {
            return document ? strings.subscriptionsFor(document.title) : loadingToken;
        }
    }, [specificity, strings, vinResolver, document, isDocumentError]);
    const header = React__default.createElement(ContentHeader, { columns: 2 },
        React__default.createElement(ContentHeader.Title, { title: strings.purchaseTitle, subtitle: subtitle }));
    return React__default.createElement(Screen, { className: "SubscriptionsScreen", header: header },
        React__default.createElement(PanelGrid, { singleColumn: true },
            React__default.createElement(SubscriptionFilterPanel, { specificity: specificity, scope: scope, period: period, bypassVehicleSpecificSearch: bypassVehicleSpecificSearch, onScopeChange: setScope, onPeriodChange: setPeriod }),
            React__default.createElement("div", { className: "SubscriptionsScreen-taxNote" },
                React__default.createElement(Text, null, strings.taxNote)),
            React__default.createElement(SubscriptionsTablePanel, { specificity: specificity, scope: scope, period: period, bypassVehicleSpecificSearch: bypassVehicleSpecificSearch })));
};

const SubscriptionRouter = ({ specificity, bypassVehicleSpecificSearch }) => {
    const { subscription: strings } = useStrings();
    const navigation = useNavigation();
    const { subscriptionPriceId } = useParams();
    const isValidRequest = subscriptionPriceId && isNumeric(subscriptionPriceId);
    const { data: subscription, error } = useGetSubscriptionPriceQuery(isValidRequest
        ? { subscriptionPriceId, specificity }
        : queryExports.skipToken);
    const errorMessage = useApiErrorMessage(strings.loadError, error, {
        404: strings.notFound
    });
    if (!isValidRequest) {
        return React__default.createElement(NotFoundScreen, null);
    }
    else if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!subscription) {
        return React__default.createElement(SubscriptionSummaryScreenSkeleton, null);
    }
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { element: React__default.createElement(RouteAccess, { access: "users" }) },
            React__default.createElement(Route, { path: "/", element: React__default.createElement(SubscriptionSummaryScreen, { specificity: specificity, subscription: subscription, payment: getPricePayment(specificity, subscription.id), backUrl: navigation.subscriptions(specificity, bypassVehicleSpecificSearch) }) })),
        React__default.createElement(Route, { path: "*", element: React__default.createElement(NotFoundScreen, null) }));
};

const SubscriptionsRouter = ({ specificity }) => {
    const { alwaysBypassVehicleSpecificSubscriptionSearch } = useContext();
    const { search } = useLocation();
    const query = queryString.parse(search);
    const bypassVehicleSpecificSearch = alwaysBypassVehicleSpecificSubscriptionSearch || query.bypassVehicleSpecificSearch === 'true';
    const isPurchaseSubscriptionShown = useFeatureToggles().isFeatureToggleEnabled('SUBSCRIPTION_PURCHASING');
    if (!isPurchaseSubscriptionShown) {
        return React__default.createElement(NotFoundScreen, null);
    }
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { element: React__default.createElement(RouteAccess, { access: "users" }) },
            React__default.createElement(Route, { path: "/", element: React__default.createElement(SubscriptionsScreen, { specificity: specificity, bypassVehicleSpecificSearch: bypassVehicleSpecificSearch }) }),
            React__default.createElement(Route, { path: ":subscriptionPriceId/*", element: React__default.createElement(SubscriptionRouter, { specificity: specificity, bypassVehicleSpecificSearch: bypassVehicleSpecificSearch }) })),
        React__default.createElement(Route, { path: "*", element: React__default.createElement(NotFoundScreen, null) }));
};

const MessageWithButtonsScreen = ({ title, heading, text, header, buttons }) => {
    const { ref: widthElement, width } = useElementWidth();
    usePageTitle(title);
    const classes = classNames(className$y(), {
        [className$y('compact')]: width < 600
    });
    return React__default.createElement(Screen, { className: classes, header: header },
        React__default.createElement("div", { ref: widthElement, className: className$y('container') },
            React__default.createElement("div", { className: className$y('content') },
                React__default.createElement("h3", null, heading),
                React__default.createElement("p", null, text),
                buttons && React__default.createElement("div", { className: className$y('buttons') }, buttons))));
};
const className$y = createClassName('MessageWithButtonsScreen');

const DocumentMessageScreen = ({ title, heading, text, buttons }) => {
    const backUrl = useDocumentBackUrl(null);
    const header = React__default.createElement(ContentHeader, { backUrl: backUrl },
        React__default.createElement(ContentHeader.Title, { title: title }));
    return React__default.createElement(MessageWithButtonsScreen, { title: title, heading: heading, text: text, header: header, buttons: buttons });
};

const DocumentLoginScreen = ({ title, heading, text }) => {
    return React__default.createElement(DocumentMessageScreen, { title: title, heading: heading, text: text, buttons: [
            React__default.createElement(LoginButton, { key: "sso", sso: true }),
            React__default.createElement(LoginButton, { key: "login" }),
            React__default.createElement(RegisterButton, { key: "register" })
        ] });
};

const DocumentSubscribeScreen = ({ document, title }) => {
    const { document: strings, subscriptions: subscriptionStrings } = useStrings();
    const navigation = useNavigation();
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const displayTitle = title !== null && title !== void 0 ? title : strings.subscriptionRequiredTitle;
    if (isLoggedIn) {
        return React__default.createElement(DocumentMessageScreen, { title: displayTitle, heading: strings.subscriptionRequiredTitle, text: strings.subscriptionRequired, buttons: React__default.createElement(ButtonLink, { href: navigation.subscriptions(getDocumentSpecificity(document)) }, subscriptionStrings.purchaseTitle) });
    }
    return React__default.createElement(DocumentLoginScreen, { title: displayTitle, heading: strings.subscriptionRequiredTitle, text: strings.notAuthenticatedText });
};

function useDocumentCoverPages(document) {
    const { document: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const moduleCoverPages = useModuleDocumentCoverPages();
    const [currentCoverPage, setCurrentCoverPage] = useState(null);
    const [currentDocumentId, setCurrentDocumentId] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [isDocumentViewPrevented, setIsDocumentViewPrevented] = useState(false);
    const showCoverPages = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        if (!document) {
            return;
        }
        function showCoverPage(coverPages, pageIndex) {
            const coverPage = coverPages[pageIndex];
            if (!coverPage) {
                setCurrentCoverPage(null);
                return;
            }
            const showNextCoverPage = () => showCoverPage(coverPages, pageIndex + 1);
            if (coverPage.status === 'rejected') {
                dispatch(queueNotification(strings.coverPageError));
                showNextCoverPage();
                return;
            }
            setCurrentCoverPage(coverPage.value(preventDocumentView => {
                if (preventDocumentView) {
                    setIsDocumentViewPrevented(true);
                }
                else {
                    showNextCoverPage();
                }
            }));
        }
        setCurrentDocumentId(document.id);
        setIsLoading(true);
        try {
            showCoverPage(yield moduleCoverPages(document), 0);
        }
        catch (_a) {
            dispatch(queueNotification(strings.coverPageError));
        }
        finally {
            setIsLoading(false);
        }
    }), [dispatch, document, moduleCoverPages, strings.coverPageError]);
    useEffect(() => {
        if ((document === null || document === void 0 ? void 0 : document.id) === currentDocumentId) {
            return;
        }
        setCurrentCoverPage(null);
        setIsLoading(true);
        setIsDocumentViewPrevented(false);
        showCoverPages();
    }, [document, moduleCoverPages, dispatch, strings.coverPageError, currentDocumentId, showCoverPages]);
    return {
        coverPage: currentCoverPage,
        isLoading,
        isDocumentViewPrevented
    };
}

const DocumentCoverPageScreen = ({ title, backUrl, children }) => {
    const header = React__default.createElement(ContentHeader, { backUrl: backUrl },
        React__default.createElement(ContentHeader.Title, { title: title }));
    return React__default.createElement(Screen, { className: className$x(), header: header },
        React__default.createElement("div", { className: className$x('content') }, children));
};
const className$x = createClassName('DocumentCoverPageScreen');

const DocumentLoader = props => {
    const { document: strings } = useStrings();
    const backUrl = useDocumentBackUrl(props.document);
    const navigation = useNavigation();
    const navigate = useNavigate();
    const location = useLocation();
    const { data: document, error } = useGetDocumentQuery({
        documentId: props.document.id,
        vehicle: props.document.vehicle,
        search: props.document.search,
        nid: props.nodeId,
        vid: props.videoId,
        fullscreen: props.fullscreen,
        excludeDocumentTree: props.excludeDocumentTree
    });
    const { coverPage, isLoading: isCoverPageLoading, isDocumentViewPrevented } = useDocumentCoverPages(document);
    const isPurchaseSubscriptionShown = useFeatureToggles().isFeatureToggleEnabled('SUBSCRIPTION_PURCHASING');
    const errorMessage = useApiErrorMessage(strings.loadError, error, {
        402: strings.subscriptionRequiredTitle,
        404: strings.notFound
    });
    if (error && 'status' in error) {
        if (error.status === 303) {
            if (error.data && typeof error.data === 'object' && hasProperty(error.data, 'supersedingDocumentId')) {
                const { vehicle, groupId, search } = props.document;
                const newPath = navigation.document({
                    id: String(error.data.supersedingDocumentId),
                    documentTypeContentType: null,
                    vehicle,
                    groupId,
                    search
                });
                if (newPath !== location.pathname) {
                    navigate(newPath);
                }
            }
            else {
                return React__default.createElement(Screen, { errorText: strings.notFound });
            }
        }
        if (error.status === 401) {
            return React__default.createElement(DocumentLoginScreen, { title: strings.notAuthenticated, heading: strings.notAuthenticated, text: `${strings.notAuthorisedTitle} ${strings.notAuthenticatedText}` });
        }
        if (error.status === 402) {
            if (!props.checkSubscription) {
                return props.children(null);
            }
            return isPurchaseSubscriptionShown ?
                React__default.createElement(DocumentSubscribeScreen, { document: props.document }) :
                React__default.createElement(Screen, { errorText: strings.notFound });
        }
        if (error.status === 403) {
            return isPurchaseSubscriptionShown && props.checkSubscription ?
                React__default.createElement(DocumentSubscribeScreen, { document: props.document }) :
                React__default.createElement(DocumentLoginScreen, { title: strings.notAuthorised, heading: strings.notAuthorised, text: `${strings.notAuthorisedTitle} ${strings.notAuthenticatedText}` });
        }
        if (error.status === 428 && props.checkSubscription) {
            return React__default.createElement(DocumentMessageScreen, { title: strings.notIndexed, heading: strings.notIndexed, text: `${strings.notIndexedTitle} ${strings.notIndexedText}` });
        }
    }
    if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    if (!document || isCoverPageLoading) {
        return React__default.createElement(DocumentScreenSkeleton, null);
    }
    if (isDocumentViewPrevented) {
        return React__default.createElement(Navigate, { to: backUrl !== null && backUrl !== void 0 ? backUrl : '/', replace: true });
    }
    if (coverPage) {
        return React__default.createElement(DocumentCoverPageScreen, { title: document.title, backUrl: backUrl }, coverPage);
    }
    return props.children(document);
};

const DocumentRouter = () => {
    const params = useParams();
    const documentId = params.documentId && isNumeric(params.documentId) ? params.documentId : null;
    const vehicle = useContextVehicle();
    const groupId = useDocumentGroupMatch();
    const search = useTypedSelector(selectActiveSearchParams);
    const location = useLocation();
    const query = queryString.parse(location.search, { parseBooleans: true });
    const hideTree = getBooleanOrDefault(query.hideTree);
    const nodeId = getStringOrDefault(query.nid);
    const videoId = getStringOrDefault(query.vid);
    const format = getStringOrDefault(query.format);
    if (!documentId) {
        return React__default.createElement(NotFoundScreen, null);
    }
    const documentReference = {
        id: documentId,
        documentTypeContentType: null,
        vehicle,
        groupId,
        search
    };
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { path: "/", element: React__default.createElement(DocumentLoader, { document: documentReference, checkSubscription: true, nodeId: nodeId, videoId: videoId }, (document) => React__default.createElement(DocumentScreen, { document: document, hideTree: hideTree, format: format })) }),
        React__default.createElement(Route, { element: React__default.createElement(RouteAccess, { access: "users" }) },
            React__default.createElement(Route, { path: "subscriptions/*", element: React__default.createElement(DocumentLoader, { document: documentReference, checkSubscription: false }, () => React__default.createElement(SubscriptionsRouter, { specificity: getDocumentSpecificity(documentReference) })) })),
        React__default.createElement(Route, { path: "*", element: React__default.createElement(NotFoundScreen, null) }));
};

var isEmptyExports$1 = {};
var isEmpty$1 = {
  get exports(){ return isEmptyExports$1; },
  set exports(v){ isEmptyExports$1 = v; },
};

var hasRequiredIsEmpty;

function requireIsEmpty () {
	if (hasRequiredIsEmpty) return isEmptyExports$1;
	hasRequiredIsEmpty = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isEmpty;

		var _assertString = _interopRequireDefault(requireAssertString());

		var _merge = _interopRequireDefault(requireMerge());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var default_is_empty_options = {
		  ignore_whitespace: false
		};

		function isEmpty(str, options) {
		  (0, _assertString.default)(str);
		  options = (0, _merge.default)(options, default_is_empty_options);
		  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
} (isEmpty$1, isEmptyExports$1));
	return isEmptyExports$1;
}

var isEmptyExports = requireIsEmpty();
var isEmpty = /*@__PURE__*/getDefaultExportFromCjs(isEmptyExports);

var faGlobe = {};

var hasRequiredFaGlobe;

function requireFaGlobe () {
	if (hasRequiredFaGlobe) return faGlobe;
	hasRequiredFaGlobe = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'globe';
		var width = 496;
		var height = 512;
		var ligatures = [];
		var unicode = 'f0ac';
		var svgPathData = 'M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faGlobe = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faGlobe));
	return faGlobe;
}

var faGlobeExports = requireFaGlobe();

const LocalisedDocumentSelect = ({ document }) => {
    const { documentGroup: strings } = useStrings();
    const languageNames = useLanguageNames();
    const { getPluralString } = usePluralStrings();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuAnchor = useRef(null);
    const translations = (document.match ? [document.match] : []).concat(document.translations);
    return React__default.createElement("div", { className: className$w(), ref: menuAnchor },
        React__default.createElement("button", { onClick: event => {
                event.stopPropagation();
                event.preventDefault();
                setIsMenuOpen(true);
            } },
            React__default.createElement(FontAwesomeIcon, { icon: faGlobeExports.faGlobe, size: "sm" }),
            document.match
                ? getPluralString(strings.availableInLanguages, translations.length)
                : getPluralString(strings.availableInOtherLanguages, translations.length),
            React__default.createElement(FontAwesomeIcon, { icon: faCaretDownExports.faCaretDown, size: "1x" })),
        React__default.createElement(Menu, { open: isMenuOpen, onClose: () => setIsMenuOpen(false), anchorEl: menuAnchor.current, onClick: event => event.stopPropagation(), anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' } }, translations.map(document => React__default.createElement(MenuItem, { key: document.id },
            React__default.createElement("div", { className: className$w('item') },
                React__default.createElement(DocumentLabelAdornment, { document: document },
                    React__default.createElement(DocumentLink, { className: className$w('title'), document: document })),
                languageNames && React__default.createElement("div", { className: className$w('subtitle') }, languageNames.getLanguageName(document.language) || normaliseLocaleCode(document.language)))))));
};
const className$w = createClassName('LocalisedDocumentSelect');

const InnerDocumentsRow = ({ document, page, isCompactTable }) => {
    const navigation = useNavigation();
    const { document: strings } = useStrings();
    const linkRef = useRef(null);
    const [clipText, setClipText] = useState(true);
    const [isTextClipped, setIsTextClipped] = useState(false);
    const textClasses = classNames('InnerDocumentsRow-link', { 'InnerDocumentsRow-text': clipText });
    const textClipButton = isTextClipped && (React__default.createElement("button", { className: "InnerDocumentsRow-button", onClick: e => {
            e.preventDefault();
            e.stopPropagation();
            setClipText(!clipText);
        } }, clipText ? strings.showMoreText : strings.showLessText));
    const linkToPage = (React__default.createElement("div", { className: "InnerDocumentsRow-textCell" },
        React__default.createElement(Link$1, { className: textClasses, ref: linkRef, variant: "title", href: navigation.document(document, { fragment: page.innerDocSourceId }), preventIfOffline: strings.cannotOpenOffline, onClick: event => event.stopPropagation() }, page.text),
        textClipButton));
    useEffect(() => {
        var _a, _b;
        if (((_a = linkRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== ((_b = linkRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight)) {
            setIsTextClipped(true);
        }
    }, []);
    return (React__default.createElement(Table.Row, { className: "InnerDocumentsRow", onClick: () => { var _a; return (_a = linkRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, rowProps: { id: page.innerDocSourceId } }, (() => {
        if (isCompactTable) {
            return (React__default.createElement(MobileTableCell, null,
                React__default.createElement(DocumentLabelAdornment, { document: document }, linkToPage)));
        }
        else {
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Table.ActionCell, null),
                React__default.createElement(Table.TextCell, { primary: linkToPage }),
                React__default.createElement(Table.TextCell, null),
                React__default.createElement(Table.TextCell, null),
                React__default.createElement(Table.ActionCell, null)));
        }
    })()));
};

function isInnerDocumentsFeatureEnabled(documents) {
    return documents.some(document => { var _a, _b; return ((_b = (_a = document.match) === null || _a === void 0 ? void 0 : _a.innerDocuments) === null || _b === void 0 ? void 0 : _b.length) || document.translations.some(document => { var _a; return (_a = document.innerDocuments) === null || _a === void 0 ? void 0 : _a.length; }); });
}
const InnerDocumentsRows = ({ document, pages, isCompactTable }) => {
    return (React__default.createElement(React__default.Fragment, null, pages.slice(0, 10).map((page, idx) => (React__default.createElement(InnerDocumentsRow
    // eslint-disable-next-line react/no-array-index-key
    , { 
        // eslint-disable-next-line react/no-array-index-key
        key: page.innerDocSourceId + idx, document: document, page: page, isCompactTable: isCompactTable })))));
};

const DocumentTableRow = ({ rowProps, isCompactTable, master, document, isGlobalReferenceShown, isPublicationDateShown }) => {
    var _a, _b, _c, _d;
    const { documentGroup: strings, documentInfo: infoStrings, favouriteContent: pagesStrings } = useStrings();
    const currentLanguage = useCurrentLanguage();
    const linkRef = useRef(null);
    const [showInnerDocuments, setShowInnerDocuments] = useState(false);
    const content = document.match ? React__default.createElement(React__default.Fragment, null,
        React__default.createElement(DocumentLabelAdornment, { document: document.match },
            React__default.createElement(DocumentLink, { document: document.match, className: "DocumentTableRow-title", variant: "title", onClick: event => event.stopPropagation(), ref: linkRef })),
        document.match.description && React__default.createElement("div", { className: "DocumentTableRow-description" }, document.match.description),
        document.translations.length > 0 && React__default.createElement(LocalisedDocumentSelect, { document: document })) : React__default.createElement(React__default.Fragment, null,
        React__default.createElement("span", { className: "DocumentTableRow-unavailable" }, strings.notInLanguage(currentLanguage.name)),
        React__default.createElement(LocalisedDocumentSelect, { document: document }));
    const date = master.publicationDate ? React__default.createElement(DateText, { date: master.publicationDate, format: DateText.DATE_SHORT }) : infoStrings.notPublished;
    const hasInnerDocuments = Boolean((_b = (_a = document.match) === null || _a === void 0 ? void 0 : _a.innerDocuments) === null || _b === void 0 ? void 0 : _b.length) || document.translations.some(document => { var _a; return (_a = document.innerDocuments) === null || _a === void 0 ? void 0 : _a.length; });
    const toggleButtonTitle = showInnerDocuments ? pagesStrings.hidePages : pagesStrings.showPages;
    const isInnerDocumentsEnabled = useMemo(() => isInnerDocumentsFeatureEnabled([document]), [document]);
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Table.Row, { className: "DocumentTableRow", rowProps: rowProps, onClick: () => { var _a; return (_a = linkRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, (() => {
            if (isCompactTable) {
                return React__default.createElement(MobileTableCell, { before: isInnerDocumentsEnabled ? (React__default.createElement("div", { className: "DocumentTableRow-mobileButtonContainer" }, hasInnerDocuments && React__default.createElement(IconButton$2, { title: toggleButtonTitle, icon: faCaretDownExports.faCaretDown, onClick: () => setShowInnerDocuments(visible => !visible) }))) : undefined, actions: React__default.createElement(DocumentActionButtons, { document: master, showFavourite: false, buttonSize: "large" }) },
                    content,
                    React__default.createElement(InlineList, null,
                        isGlobalReferenceShown && master.reference,
                        isPublicationDateShown && date));
            }
            else {
                return React__default.createElement(React__default.Fragment, null,
                    isInnerDocumentsEnabled && (React__default.createElement(Table.ActionCell, null, hasInnerDocuments && React__default.createElement(IconButton$2, { title: toggleButtonTitle, icon: faCaretDownExports.faCaretDown, onClick: () => setShowInnerDocuments(visible => !visible) }))),
                    React__default.createElement(Table.TextCell, null, content),
                    isGlobalReferenceShown && React__default.createElement(Table.TextCell, { primary: master.reference }),
                    isPublicationDateShown && React__default.createElement(Table.TextCell, { wrap: false }, date),
                    React__default.createElement(Table.ActionCell, null,
                        React__default.createElement(DocumentActionButtons, { document: master, showFavourite: false })));
            }
        })()),
        showInnerDocuments && hasInnerDocuments && document.match && (React__default.createElement(InnerDocumentsRows, { isCompactTable: isCompactTable, document: document.match, pages: (_d = (_c = document.match) === null || _c === void 0 ? void 0 : _c.innerDocuments) !== null && _d !== void 0 ? _d : [] })),
        showInnerDocuments &&
            hasInnerDocuments &&
            document.translations.map(translation => {
                var _a;
                return (React__default.createElement(InnerDocumentsRows, { key: translation.id, isCompactTable: isCompactTable, document: translation, pages: (_a = translation === null || translation === void 0 ? void 0 : translation.innerDocuments) !== null && _a !== void 0 ? _a : [] }));
            }));
};

const DocumentTable = ({ documents, sort, emptyText, isPublicationDateShown, isLoading }) => {
    const { documentGroup: strings } = useStrings();
    const { hideDocumentGlobalReferenceColumn, showTableClearSortButton } = useContext();
    const isGlobalReferenceShown = !hideDocumentGlobalReferenceColumn;
    const isInnerDocumentsEnabled = useMemo(() => isInnerDocumentsFeatureEnabled(documents), [documents]);
    const columns = useMemo(() => {
        const columns = [
            isInnerDocumentsEnabled && { id: 'collapse', title: '' },
            {
                id: 'title',
                title: strings.titleColumn,
                sortKey: 'title',
                className: className$v('title')
            },
            isGlobalReferenceShown && {
                id: 'reference',
                title: strings.referenceColumn,
                sortKey: 'reference',
                className: className$v('reference')
            },
            isPublicationDateShown && {
                id: 'publicationDate',
                title: strings.publicationDateColumn,
                sortKey: 'publicationDate',
                className: className$v('publicationDate')
            },
            {
                id: 'actions',
                title: ''
            }
        ];
        return columns.filter(filterFalse);
    }, [
        strings.titleColumn,
        strings.referenceColumn,
        strings.publicationDateColumn,
        isGlobalReferenceShown,
        isPublicationDateShown,
        isInnerDocumentsEnabled
    ]);
    const getRow = useCallback((rowIndex) => {
        var _a;
        const document = documents[rowIndex];
        const master = (_a = document.match) !== null && _a !== void 0 ? _a : document.translations[0];
        return {
            id: master.id,
            component: DocumentTableRow,
            props: {
                master,
                document,
                isGlobalReferenceShown,
                isPublicationDateShown
            }
        };
    }, [documents, isGlobalReferenceShown, isPublicationDateShown]);
    const classes = classNames(className$v(), {
        [className$v('withReference')]: isGlobalReferenceShown,
        [className$v('withClearSortButton')]: showTableClearSortButton
    });
    const rowFallback = useCallback((isCompactTable) => {
        return React__default.createElement(TableRowSkeleton, { isCompactTable: isCompactTable, columnCount: columns.length - 1, actionCount: 1 });
    }, [columns.length]);
    return React__default.createElement(Table, { className: classes, columns: columns, rowCount: documents.length, sort: Object.assign(Object.assign({}, sort), { canClear: true }), compactHeader: createResponsiveValue(false).maxWidth(MOBILE_BREAKPOINT, true), showTableClearSortButton: showTableClearSortButton, isLoading: isLoading, getRow: getRow, getRowFallback: rowFallback },
        React__default.createElement(EmptyTableRow, { size: "lg", message: emptyText !== null && emptyText !== void 0 ? emptyText : strings.emptyList }));
};
const className$v = createClassName('DocumentTable');

const SearchSuggestionPanel = ({ suggestion, searchParams }) => {
    const { documentSearch: strings } = useStrings();
    const navigation = useNavigation();
    if (!suggestion) {
        return null;
    }
    const url = navigation.documentSearch(Object.assign(Object.assign({}, searchParams), { query: suggestion }), searchParams.vehicle);
    return React__default.createElement(Panel, { className: "SearchSuggestionPanel", variant: "info" },
        React__default.createElement(Panel.Content, null,
            React__default.createElement(Text, null, strings.querySuggestion(suggestion, url))));
};

function useDocumentSearch() {
    var _a;
    const navigation = useNavigation();
    const navigate = useNavigate();
    const options = useTypedSelector(selectSearchOptions);
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const searchVehicle = options.searchVehicle ? vehicle : null;
    const groupId = (_a = useDocumentGroupMatch()) !== null && _a !== void 0 ? _a : null;
    return useMemo(() => ({
        options,
        search: newOptions => {
            var _a, _b;
            const query = (_b = ((_a = newOptions === null || newOptions === void 0 ? void 0 : newOptions.query) !== null && _a !== void 0 ? _a : options.query)) === null || _b === void 0 ? void 0 : _b.trim();
            if (query) {
                const searchOptions = Object.assign(Object.assign(Object.assign({}, options), newOptions), { query,
                    groupId, inSourceId: true, inGlobalReferenceNumber: true, tags: undefined });
                navigate(navigation.documentSearch(searchOptions, searchVehicle));
                return true;
            }
            return false;
        }
    }), [navigation, navigate, options, searchVehicle, groupId]);
}

var faCheck = {};

var hasRequiredFaCheck;

function requireFaCheck () {
	if (hasRequiredFaCheck) return faCheck;
	hasRequiredFaCheck = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'check';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f00c';
		var svgPathData = 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faCheck = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faCheck));
	return faCheck;
}

var faCheckExports = requireFaCheck();

const DocumentSearchFilter = ({ shortLabels }) => {
    const { documentFilter: strings } = useStrings();
    const { search, options } = useDocumentSearch();
    const { hideDocumentSearchFilter } = useContext();
    const canViewEmbargoedDocuments = useCanViewEmbargoedDocuments();
    if (!canViewEmbargoedDocuments || hideDocumentSearchFilter) {
        return null;
    }
    function renderValue(embargoed) {
        switch (embargoed) {
            case 'show':
                return React__default.createElement("span", { role: "button", className: className$u('default') }, shortLabels ? strings.filter : strings.filterResults);
            case 'only':
                return React__default.createElement("span", { role: "button" }, shortLabels ? strings.onlyEmbargoed : strings.onlyShowEmbargoedDocuments);
            case 'hide':
                return React__default.createElement("span", { role: "button" }, shortLabels ? strings.hideEmbargoed : strings.hideEmbargoedDocuments);
        }
    }
    return React__default.createElement(Select$1, { "aria-label": strings.filterResults, value: options.embargoed, className: className$u(), fullWidth: true, renderValue: renderValue },
        React__default.createElement(MenuItem, { value: "only", onClick: () => search({ embargoed: 'only' }) },
            React__default.createElement(ListItemIcon$1, null, options.embargoed === 'only' && React__default.createElement(FontAwesomeIcon, { icon: faCheckExports.faCheck })),
            strings.onlyShowEmbargoedDocuments),
        React__default.createElement(MenuItem, { value: "hide", onClick: () => search({ embargoed: 'hide' }) },
            React__default.createElement(ListItemIcon$1, null, options.embargoed === 'hide' && React__default.createElement(FontAwesomeIcon, { icon: faCheckExports.faCheck })),
            strings.hideEmbargoedDocuments),
        React__default.createElement(Divider$1, { "aria-hidden": true }),
        React__default.createElement(MenuItem, { value: "show", disabled: options.embargoed === 'show', onClick: () => search({ embargoed: 'show' }) },
            React__default.createElement(ListItemIcon$1, null),
            strings.clearFilter));
};
const className$u = createClassName('DocumentSearchFilter');

const ModuleDocumentSearchPanels = props => {
    const { modules } = useContext();
    const panels = useMemo(() => {
        return modules === null || modules === void 0 ? void 0 : modules.flatMap(({ id, layouts }) => {
            if (layouts === null || layouts === void 0 ? void 0 : layouts.documentSearchPanel) {
                return [React__default.createElement(Fragment, { key: String(id) }, layouts.documentSearchPanel(props))];
            }
            return [];
        });
    }, [modules, props]);
    return panels ? React__default.createElement(React__default.Fragment, null, panels) : null;
};

const FILTER_BREAKPOINT = 600;
const SearchScreen = ({ params, result, isLoading, onPageChange, onSort }) => {
    var _a, _b, _c, _d;
    const { documentSearch: strings } = useStrings();
    usePageTitle(params.query ? strings.pageTitle(params.query) : strings.title);
    useHelp('search.search');
    const paginator = usePaginator(result, onPageChange, [(_a = params.groupId) !== null && _a !== void 0 ? _a : '', (_b = params.query) !== null && _b !== void 0 ? _b : '', params.sortKey, params.sortDirection]);
    const scrollElement = useTokenScrollReset(String(result.pageNumber));
    const vinResolver = useVinResolver();
    const columns = createResponsiveValue(3);
    const { ref: widthRef, width } = useElementWidth();
    const isLoadingNewQuery = useIsLoadingWithDifferentKey(isLoading, (_c = params.query) !== null && _c !== void 0 ? _c : '');
    const isLoadingNewGroup = useIsLoadingWithDifferentKey(isLoading, (_d = params.groupId) !== null && _d !== void 0 ? _d : '');
    const dispatch = useTypedDispatch();
    useEffect(() => {
        if (isLoadingNewQuery === false) {
            dispatch(userApi.util.invalidateTags(['UserSearchHistory']));
        }
    }, [isLoadingNewQuery, dispatch]);
    const sortProps = useMemo(() => ({
        sortKey: params.sortKey,
        sortDirection: params.sortDirection,
        onSort: (sortKey, sortDirection) => onSort({ sortKey, sortDirection })
    }), [params.sortKey, params.sortDirection, onSort]);
    const subtitle = params.query && (params.vehicle ?
        strings.searchedVehicle(params.query, getVehicleDisplayName(params.vehicle, vinResolver)) :
        strings.searchedAll(params.query));
    const header = React__default.createElement(ContentHeader, { columns: columns.maxWidth(FILTER_BREAKPOINT, 2) },
        React__default.createElement(ContentHeader.Title, { title: strings.title, subtitle: isLoadingNewQuery ? loadingToken : subtitle }),
        React__default.createElement(Pagination, { paginator: paginator, isLoading: isLoadingNewQuery || isLoadingNewGroup }),
        width > FILTER_BREAKPOINT && React__default.createElement(DocumentSearchFilter, { shortLabels: true }));
    return React__default.createElement(Screen, { className: className$t(), header: header, bottomPagination: React__default.createElement(Pagination, { paginator: paginator, isLoading: isLoadingNewQuery || isLoadingNewGroup, centerHorizontally: true }), contentRef: mergeRefs(scrollElement, widthRef) },
        width <= FILTER_BREAKPOINT && React__default.createElement("div", { className: className$t('filter') },
            React__default.createElement(DocumentSearchFilter, null)),
        React__default.createElement(PanelGrid, null,
            result.invalidQuery && !isLoadingNewQuery && React__default.createElement(Panel, { variant: "warning" },
                React__default.createElement(Panel.Content, null, strings.invalidQuery)),
            params.pageNumber === 0 && result.querySuggestion && !isLoadingNewQuery && React__default.createElement(SearchSuggestionPanel, { suggestion: result.querySuggestion, searchParams: params }),
            params.query && React__default.createElement(ModuleDocumentSearchPanels, { page: params.pageNumber, query: params.query, searchTitles: params.searchTitles, searchDescriptions: params.searchDescriptions, searchContents: params.searchContents, showEmbargoed: params.embargoed !== 'hide', groupId: params.groupId, vehicle: params.vehicle }),
            React__default.createElement(Panel, null,
                React__default.createElement(DocumentTable, { documents: result.elements, sort: sortProps, emptyText: strings.noResults, isPublicationDateShown: true, isLoading: isLoading }))));
};
const className$t = createClassName('SearchScreen');

const TableScreenSkeleton = ({ hasActions }) => {
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(Screen, { header: React__default.createElement(ContentHeaderSkeleton, { hasRole: false }) },
            React__default.createElement(PanelGrid, null,
                React__default.createElement(Panel, null,
                    React__default.createElement(TableSkeleton, { hasActions: hasActions, hasRole: false })))));
};

const SearchLoader = ({ params, vehicle, children }) => {
    const { documentSearch: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const [pageNumber, setPageNumber] = useState(0);
    const { documentSearchResultsSortOrder } = useContext();
    const [{ sortKey, sortDirection }, setSortOrder] = useState(documentSearchResultsSortOrder !== null && documentSearchResultsSortOrder !== void 0 ? documentSearchResultsSortOrder : {
        sortKey: 'title',
        sortDirection: 'none'
    });
    const searchParams = useMemo(() => (Object.assign(Object.assign({}, params), { vehicle,
        pageNumber, pageSize: config.paginationPageSize, sortKey,
        sortDirection })), [params, vehicle, pageNumber, sortKey, sortDirection]);
    const { data, isFetching, error } = useSearchDocumentsQuery(searchParams);
    const errorMessage = useApiErrorMessage(strings.searchError, error);
    useEffect(() => {
        if (searchParams) {
            dispatch(setActiveSearchParams(searchParams));
        }
        return () => {
            dispatch(setActiveSearchParams(null));
        };
    }, [data, dispatch, searchParams]);
    if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!data) {
        return React__default.createElement(TableScreenSkeleton, null);
    }
    return children({
        params: searchParams,
        result: data,
        isLoading: isFetching,
        onPageChange: setPageNumber,
        onSort: setSortOrder
    });
};

const SearchRouter = ({ vehicle }) => {
    var _a, _b;
    const dispatch = useTypedDispatch();
    const locale = (_a = useTypedSelector(selectOverridingLocale)) !== null && _a !== void 0 ? _a : undefined;
    const { search } = useLocation();
    const params = queryString.parse(search, { parseBooleans: true });
    const query = typeof params.query === 'string' && !isEmpty(params.query, { ignore_whitespace: true }) ? params.query.trim() : undefined;
    const searchTitles = getBooleanOrDefault(params.searchTitles, false);
    const searchDescriptions = getBooleanOrDefault(params.searchDescriptions, false);
    const searchContents = getBooleanOrDefault(params.searchContents, false);
    const inSourceId = getBooleanOrDefault(params.inSourceId, true);
    const inGlobalReferenceNumber = getBooleanOrDefault(params.inGlobalReferenceNumber, true);
    const tags = (_b = getStringOrDefault(params.tags)) === null || _b === void 0 ? void 0 : _b.split(',').filter(tag => tag !== '');
    const groupId = typeof params.group === 'string' && isNumeric(params.group) ? params.group : null;
    const embargoed = getUnionStringOrDefault(params.embargoed, embargoFilters, 'show');
    const searchParams = useMemo(() => {
        if (query || tags && tags.length > 0) {
            return {
                query,
                searchTitles,
                searchDescriptions,
                searchContents,
                inSourceId,
                inGlobalReferenceNumber,
                tags,
                groupId,
                embargoed,
                locale
            };
        }
    }, [
        query,
        searchTitles,
        searchDescriptions,
        searchContents,
        inSourceId,
        inGlobalReferenceNumber,
        tags,
        groupId,
        embargoed,
        locale
    ]);
    useEffect(() => {
        if (searchParams) {
            dispatch(updateSearchOptions(Object.assign(Object.assign({}, searchParams), { searchVehicle: vehicle !== null })));
        }
    }, [dispatch, searchParams, vehicle]);
    // Clear search when this component is unmounted.
    useEffect(() => {
        return () => {
            dispatch(clearDocumentSearch());
        };
    }, [dispatch]);
    if (!searchParams) {
        return React__default.createElement(NotFoundScreen, null);
    }
    return React__default.createElement(SearchLoader, { params: searchParams, vehicle: vehicle }, ({ params, result, isLoading, onPageChange, onSort }) => React__default.createElement(Routes, null,
        React__default.createElement(Route, { path: "/", element: React__default.createElement(SearchScreen, { params: params, result: result, isLoading: isLoading, onPageChange: onPageChange, onSort: onSort }) }),
        React__default.createElement(Route, { path: "documents/:documentId/*", element: React__default.createElement(DocumentRouter, null) })));
};

var faSearch = {};

var hasRequiredFaSearch;

function requireFaSearch () {
	if (hasRequiredFaSearch) return faSearch;
	hasRequiredFaSearch = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'search';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f002';
		var svgPathData = 'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faSearch = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faSearch));
	return faSearch;
}

var faSearchExports = requireFaSearch();

const SearchBox = React__default.forwardRef((props, ref) => {
    var _a, _b, _c, _d;
    const ownInputRef = React__default.useRef(null);
    const inputRef = (_a = props.inputRef) !== null && _a !== void 0 ? _a : ownInputRef;
    const [debounceValue, setDebounceValue] = React__default.useState();
    const { searchBox: strings } = useStrings();
    const size = (_b = props.size) !== null && _b !== void 0 ? _b : 'small';
    const icon = (_c = props.icon) !== null && _c !== void 0 ? _c : faSearchExports.faSearch;
    const placeholder = (_d = props.placeholder) !== null && _d !== void 0 ? _d : 'Search';
    const iconSize = size === 'large' ? 'lg' : '1x';
    const showClear = props.value !== '';
    useDebounce(debounceValue, 500, value => {
        var _a;
        if (value !== undefined) {
            setDebounceValue(undefined);
            (_a = props.onDebouncedChange) === null || _a === void 0 ? void 0 : _a.call(props, value);
        }
    });
    function onChange(event) {
        var _a;
        const value = event.currentTarget.value;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, value);
        if (props.onDebouncedChange) {
            setDebounceValue(value);
        }
    }
    function onKeyDown(event) {
        var _a;
        if (event.key === 'Enter') {
            (_a = props.onEnterPress) === null || _a === void 0 ? void 0 : _a.call(props, event.currentTarget.value, event);
        }
    }
    function clearValue() {
        var _a, _b, _c, _d;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, '');
        (_b = props.onDebouncedChange) === null || _b === void 0 ? void 0 : _b.call(props, '');
        (_c = props.onClear) === null || _c === void 0 ? void 0 : _c.call(props);
        setDebounceValue('');
        (_d = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _d === void 0 ? void 0 : _d.focus();
    }
    function dropdownClick() {
        var _a, _b;
        (_b = (_a = props.dropdown) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    const classes = classNames('SearchBox', {
        'SearchBox-large': props.size === 'large',
        [`SearchBox-${props.variant}`]: props.variant && props.variant !== 'default'
    });
    return React__default.createElement("div", { className: classes, ref: ref },
        icon !== null && React__default.createElement(FontAwesomeIcon, { icon: icon, size: iconSize, className: "SearchBox-icon" }),
        React__default.createElement("input", { id: "SearchBox", ref: inputRef, type: "text", autoComplete: "off", placeholder: placeholder, value: props.value, onChange: onChange, onKeyDown: onKeyDown, onFocus: props.onFocus, onBlur: props.onBlur }),
        React__default.createElement("div", { className: "SearchBox-right" },
            showClear && React__default.createElement("button", { className: "SearchBox-clear", title: strings.clear, "aria-label": strings.clear, onClick: clearValue },
                React__default.createElement(FontAwesomeIcon, { icon: faTimesExports.faTimes, size: iconSize })),
            props.dropdown && React__default.createElement("button", { className: "SearchBox-dropdown", ref: props.dropdown.menuRef, onClick: dropdownClick },
                React__default.createElement("span", { className: "SearchBox-dropdownText" }, props.dropdown.text),
                React__default.createElement(FontAwesomeIcon, { icon: faChevronDownExports.faChevronDown, size: "1x" }))));
});
SearchBox.displayName = 'SearchBox';

var faEnvelope = {};

var hasRequiredFaEnvelope;

function requireFaEnvelope () {
	if (hasRequiredFaEnvelope) return faEnvelope;
	hasRequiredFaEnvelope = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'envelope';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f0e0';
		var svgPathData = 'M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faEnvelope = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faEnvelope));
	return faEnvelope;
}

var faEnvelopeExports = requireFaEnvelope();

var faEnvelopeOpen = {};

var hasRequiredFaEnvelopeOpen;

function requireFaEnvelopeOpen () {
	if (hasRequiredFaEnvelopeOpen) return faEnvelopeOpen;
	hasRequiredFaEnvelopeOpen = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'envelope-open';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f2b6';
		var svgPathData = 'M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faEnvelopeOpen = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faEnvelopeOpen));
	return faEnvelopeOpen;
}

var faEnvelopeOpenExports = requireFaEnvelopeOpen();

var faEnvelopeOpenText = {};

var hasRequiredFaEnvelopeOpenText;

function requireFaEnvelopeOpenText () {
	if (hasRequiredFaEnvelopeOpenText) return faEnvelopeOpenText;
	hasRequiredFaEnvelopeOpenText = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'envelope-open-text';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f658';
		var svgPathData = 'M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faEnvelopeOpenText = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faEnvelopeOpenText));
	return faEnvelopeOpenText;
}

var faEnvelopeOpenTextExports = requireFaEnvelopeOpenText();

const MessagesHeader = ({ selectedIds, paginator, onMarkRead, onMarkUnread, onDelete, onMarkAllAsRead, onFilter }) => {
    const { messages: strings } = useStrings();
    const [filterInputValue, setFilterInputValue] = useState('');
    const columns = createResponsiveValue(3);
    const { ref, width } = useElementWidth();
    const isMarkAllAsReadEnabled = useFeatureToggles().isFeatureToggleEnabled('MARK_ALL_AS_READ');
    const classes = classNames('MessagesHeader', {
        'MessagesHeader-compact': width <= 600
    });
    const buttons = [{
            id: 'markRead',
            icon: faEnvelopeOpenExports.faEnvelopeOpen,
            title: strings.markAsReadButton,
            onClick: onMarkRead
        },
        {
            id: 'markUnread',
            icon: faEnvelopeExports.faEnvelope,
            title: strings.markAsUnreadButton,
            onClick: onMarkUnread
        },
        {
            id: 'delete',
            icon: faTrashAltExports.faTrashAlt,
            title: strings.deleteButton,
            onClick: onDelete
        },
        {
            id: 'markAllAsRead',
            icon: faEnvelopeOpenTextExports.faEnvelopeOpenText,
            title: strings.markAllAsReadButton,
            visible: isMarkAllAsReadEnabled ? 'inOverflow' : 'never',
            onClick: onMarkAllAsRead
        }];
    return React__default.createElement("div", { ref: ref, className: classes }, (() => {
        if (selectedIds.length > 0) {
            return React__default.createElement(ContentHeader, { columns: columns.default(2) },
                React__default.createElement(ContentHeader.Title, { title: strings.selectedCount(selectedIds.length) }),
                React__default.createElement(ButtonBar, { buttons: buttons }));
        }
        else {
            return React__default.createElement(ContentHeader, { columns: columns.maxWidth(600, 2) },
                React__default.createElement(ContentHeader.Title, { title: strings.title }),
                React__default.createElement(Pagination, { paginator: paginator }),
                React__default.createElement(SearchBox, { value: filterInputValue, placeholder: strings.filterPlaceholder, onChange: setFilterInputValue, onDebouncedChange: onFilter }));
        }
    })());
};

const MessageTableRow = ({ rowProps, isCompactTable, message }) => {
    const navigation = useNavigation();
    const link = React__default.createElement(Link$1, { href: navigation.message(message), variant: "title", onClick: event => event.stopPropagation() }, message.subject);
    const classes = classNames('MessageTableRow', {
        'MessageTableRow-read': message.read
    });
    return React__default.createElement(Table.Row, { className: classes, rowProps: rowProps }, (() => {
        if (isCompactTable) {
            return React__default.createElement(MobileTableCell, { primary: link, secondary: message.from, date: React__default.createElement(DateText, { date: message.date, dynamicFormat: DateText.DYNAMIC_SHORT, showTooltip: true }) });
        }
        else {
            return React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Table.TextCell, { primary: link }),
                React__default.createElement(Table.TextCell, { primary: message.from }),
                React__default.createElement(Table.TextCell, { wrap: false },
                    React__default.createElement(DateText, { date: message.date })));
        }
    })());
};

const MessageTable = props => {
    const { messages: strings } = useStrings();
    const navigate = useNavigate();
    const columns = useMemo(() => ([
        { id: 'subject', title: strings.subjectColumn, sortKey: 'subject', className: 'MessageTable-subject' },
        { id: 'from', title: strings.fromColumn, sortKey: 'from', className: 'MessageTable-from' },
        { id: 'date', title: strings.dateColumn, sortKey: 'date' }
    ]), [strings.fromColumn, strings.subjectColumn, strings.dateColumn]);
    function getRow(index) {
        const message = props.messages[index];
        return {
            id: message.id,
            component: MessageTableRow,
            props: {
                message
            }
        };
    }
    function onClick(rowIndex) {
        const message = props.messages[rowIndex];
        navigate(`/messages/${message.id}`);
    }
    function onKeyPress(rowIndex, key) {
        const message = props.messages[rowIndex];
        switch (key) {
            case 'Enter':
                onClick(rowIndex);
                return true;
            case 'Delete':
                props.onDelete(message.id);
                return true;
        }
        return false;
    }
    return React__default.createElement(Table, { className: "MessageTable", columns: columns, rowCount: props.messages.length, sort: props.sort, selectedIds: props.selectedIds, onSelectionChange: props.onSelectionChange, selection: "multi", compactHeader: createResponsiveValue(false).maxWidth(MOBILE_BREAKPOINT, true), getRow: getRow, onClick: onClick, onKeyPress: onKeyPress },
        React__default.createElement(EmptyTableRow, { message: strings.emptyList, size: "lg" }));
};

const MessagesScreen = () => {
    const { messages: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const [selectedIds, setSelectedIds] = useState([]);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [showMarkAllAsReadConfirmation, setShowMarkAllAsReadConfirmation] = useState(false);
    const user = useTypedSelector(selectCurrentUser);
    const [filter, setFilter] = useState('');
    const { sortKey, sortDirection } = useTypedSelector(selectMessagesSortOrder);
    const pageNumber = useTypedSelector(selectMessagesPageNumber);
    const { getPluralString } = usePluralStrings();
    const { data, isFetching, error } = useGetMessagesQuery(user ? {
        userId: user.id,
        filter,
        pageNumber,
        pageSize: config.paginationPageSize,
        sortKey,
        sortDirection
    } : queryExports.skipToken, {
        refetchOnMountOrArgChange: true
    });
    const [markMessages, { isLoading: isMarking }] = useMarkMessagesMutation();
    const [deleteMessages, { isLoading: isDeleting }] = useDeleteMessagesMutation();
    const isWorking = isMarking || isDeleting;
    useShowLoadingIndicator(isFetching || isWorking);
    const paginator = usePaginator(data, pageNumber => dispatch(setMessagesPageNumber(pageNumber)), filter);
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const scrollElement = useTokenScrollReset(String(pageNumber));
    usePageTitle(strings.title);
    const sortProps = useMemo(() => ({
        sortKey,
        sortDirection,
        onSort: (key, direction) => dispatch(setMessagesSortOrder({
            sortKey: key,
            sortDirection: direction
        }))
    }), [dispatch, sortKey, sortDirection]);
    if (!user) {
        return null;
    }
    const doMark = (action) => __awaiter(void 0, void 0, void 0, function* () {
        if (!isWorking) {
            try {
                if (action === 'readAll') {
                    setShowMarkAllAsReadConfirmation(false);
                    yield markMessages({ userId: user.id }).unwrap();
                }
                else {
                    const markReadIds = selectedIds.map(id => ({ id, read: action === 'read' }));
                    yield markMessages({ userId: user.id, markReadIds }).unwrap();
                }
                setSelectedIds([]);
            }
            catch (_a) {
                const errorNotifications = {
                    'read': strings.markAsReadError,
                    'unread': strings.markAsUnreadError,
                    'readAll': strings.markAllAsReadError
                };
                dispatch(queueNotification(errorNotifications[action]));
            }
        }
    });
    function confirmDelete() {
        if (!isWorking) {
            setShowDeleteConfirmation(true);
        }
    }
    const doDelete = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!isWorking) {
            setShowDeleteConfirmation(false);
            try {
                yield deleteMessages({ userId: user.id, deleteIds: selectedIds }).unwrap();
                dispatch(queueNotification(getPluralString(strings.deletedMessages, selectedIds.length)));
                setSelectedIds([]);
            }
            catch (_b) {
                dispatch(queueNotification(strings.deleteError));
            }
        }
    });
    function confirmMarkAllAsRead() {
        if (!isWorking) {
            setShowMarkAllAsReadConfirmation(true);
        }
    }
    const messages = data === null || data === void 0 ? void 0 : data.elements;
    if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!messages) {
        return React__default.createElement(TableScreenSkeleton, null);
    }
    const header = React__default.createElement(MessagesHeader, { selectedIds: selectedIds, paginator: paginator, onMarkRead: () => doMark('read'), onMarkUnread: () => doMark('unread'), onDelete: confirmDelete, onMarkAllAsRead: confirmMarkAllAsRead, onFilter: setFilter });
    return React__default.createElement(Screen, { className: "MessagesScreen", header: header, bottomPagination: React__default.createElement(Pagination, { paginator: paginator, centerHorizontally: true }), contentRef: scrollElement },
        React__default.createElement(PanelGrid, null,
            React__default.createElement(Panel, null,
                React__default.createElement(MessageTable, { messages: messages, sort: sortProps, selectedIds: selectedIds, onSelectionChange: setSelectedIds, onDelete: confirmDelete }))),
        React__default.createElement(ConfirmDialogue, { isOpen: showDeleteConfirmation, title: strings.deleteConfirmationTitle, confirmTitle: strings.deleteButton, isDangerous: true, onConfirm: doDelete, onCancel: () => setShowDeleteConfirmation(false) }, getPluralString(strings.deleteConfirmationMessage, selectedIds.length)),
        React__default.createElement(ConfirmDialogue, { isOpen: showMarkAllAsReadConfirmation, title: strings.markAllAsReadConfirmationTitle, confirmTitle: strings.markAllAsReadButton, isDangerous: true, onConfirm: () => doMark('readAll'), onCancel: () => setShowMarkAllAsReadConfirmation(false) }, strings.markAllAsReadConfirmationMessage));
};

function isRoute(value, type) {
    return isObject(value) && hasProperty(value, 'type') && value.type === type;
}
function getExternalRouteUrl(route, navigation) {
    const routeUrls = {
        approvedSubscriptionPayment: route => {
            if (isRoute(route, 'approvedSubscriptionPayment') && typeof route.subscriptionId === 'string') {
                return navigation.userSubscription(route.subscriptionId);
            }
        },
        vehicleLookup: route => {
            var _a;
            if (isRoute(route, 'vehicleLookup')) {
                let reference;
                if (typeof route.vin === 'string') {
                    reference = getVinReference(route.vin);
                }
                else if ((typeof route.year === 'number' || route.year === undefined) && typeof route.productVariantId === 'string') {
                    reference = getProductReference(route.productVariantId, (_a = route.year) !== null && _a !== void 0 ? _a : null);
                }
                if (reference !== undefined) {
                    if (typeof route.groupId === 'string') {
                        return navigation.vehicleDocumentGroup(reference, route.groupId);
                    }
                    else {
                        return navigation.vehicle(reference);
                    }
                }
                return navigation.home();
            }
        }
    };
    for (const getUrl of Object.values(routeUrls)) {
        const url = getUrl(route);
        if (url) {
            return url;
        }
    }
}
const linkDataAttributeName = 'data-iwa-route';
function useExternalRouteLinks(rootElement) {
    const navigate = useNavigate();
    const navigation = useNavigation();
    useEffect(() => {
        if (rootElement.current === null) {
            return;
        }
        const removeListeners = [];
        for (const link of Array.from(rootElement.current.querySelectorAll(`a[${linkDataAttributeName}]`))) {
            const attribute = link.getAttribute(linkDataAttributeName);
            link.removeAttribute(linkDataAttributeName);
            if (attribute) {
                let data;
                try {
                    data = JSON.parse(attribute);
                }
                catch (_a) {
                    continue;
                }
                const url = getExternalRouteUrl(data, navigation);
                if (url) {
                    link.setAttribute('href', url);
                    const listener = event => {
                        event.preventDefault();
                        navigate(url);
                    };
                    link.addEventListener('click', listener);
                    removeListeners.push(() => {
                        link.removeEventListener('click', listener);
                    });
                }
            }
        }
        return () => {
            removeListeners.forEach(removeListener => removeListener());
        };
    }, [rootElement, navigate, navigation]);
}

var lib$5 = {};

var Parser = {};

var Tokenizer = {};

var decode_codepoint = {};

var require$$0$1 = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

var hasRequiredDecode_codepoint;

function requireDecode_codepoint () {
	if (hasRequiredDecode_codepoint) return decode_codepoint;
	hasRequiredDecode_codepoint = 1;
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(decode_codepoint, "__esModule", { value: true });
	var decode_json_1 = __importDefault(require$$0$1);
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint) {
	    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
	        return "\uFFFD";
	    }
	    if (codePoint in decode_json_1.default) {
	        codePoint = decode_json_1.default[codePoint];
	    }
	    var output = "";
	    if (codePoint > 0xffff) {
	        codePoint -= 0x10000;
	        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
	        codePoint = 0xdc00 | (codePoint & 0x3ff);
	    }
	    output += String.fromCharCode(codePoint);
	    return output;
	}
	decode_codepoint.default = decodeCodePoint;
	return decode_codepoint;
}

var Aacute$1 = "Á";
var aacute$1 = "á";
var Abreve = "Ă";
var abreve = "ă";
var ac = "∾";
var acd = "∿";
var acE = "∾̳";
var Acirc$1 = "Â";
var acirc$1 = "â";
var acute$1 = "´";
var Acy = "А";
var acy = "а";
var AElig$1 = "Æ";
var aelig$1 = "æ";
var af = "⁡";
var Afr = "𝔄";
var afr = "𝔞";
var Agrave$1 = "À";
var agrave$1 = "à";
var alefsym = "ℵ";
var aleph = "ℵ";
var Alpha = "Α";
var alpha = "α";
var Amacr = "Ā";
var amacr = "ā";
var amalg = "⨿";
var amp$2 = "&";
var AMP$1 = "&";
var andand = "⩕";
var And = "⩓";
var and = "∧";
var andd = "⩜";
var andslope = "⩘";
var andv = "⩚";
var ang = "∠";
var ange = "⦤";
var angle = "∠";
var angmsdaa = "⦨";
var angmsdab = "⦩";
var angmsdac = "⦪";
var angmsdad = "⦫";
var angmsdae = "⦬";
var angmsdaf = "⦭";
var angmsdag = "⦮";
var angmsdah = "⦯";
var angmsd = "∡";
var angrt = "∟";
var angrtvb = "⊾";
var angrtvbd = "⦝";
var angsph = "∢";
var angst = "Å";
var angzarr = "⍼";
var Aogon = "Ą";
var aogon = "ą";
var Aopf = "𝔸";
var aopf = "𝕒";
var apacir = "⩯";
var ap = "≈";
var apE = "⩰";
var ape = "≊";
var apid = "≋";
var apos$1 = "'";
var ApplyFunction = "⁡";
var approx = "≈";
var approxeq = "≊";
var Aring$1 = "Å";
var aring$1 = "å";
var Ascr = "𝒜";
var ascr = "𝒶";
var Assign = "≔";
var ast = "*";
var asymp = "≈";
var asympeq = "≍";
var Atilde$1 = "Ã";
var atilde$1 = "ã";
var Auml$1 = "Ä";
var auml$1 = "ä";
var awconint = "∳";
var awint = "⨑";
var backcong = "≌";
var backepsilon = "϶";
var backprime = "‵";
var backsim = "∽";
var backsimeq = "⋍";
var Backslash = "∖";
var Barv = "⫧";
var barvee = "⊽";
var barwed = "⌅";
var Barwed = "⌆";
var barwedge = "⌅";
var bbrk = "⎵";
var bbrktbrk = "⎶";
var bcong = "≌";
var Bcy = "Б";
var bcy = "б";
var bdquo = "„";
var becaus = "∵";
var because = "∵";
var Because = "∵";
var bemptyv = "⦰";
var bepsi = "϶";
var bernou = "ℬ";
var Bernoullis = "ℬ";
var Beta = "Β";
var beta = "β";
var beth = "ℶ";
var between = "≬";
var Bfr = "𝔅";
var bfr = "𝔟";
var bigcap = "⋂";
var bigcirc = "◯";
var bigcup = "⋃";
var bigodot = "⨀";
var bigoplus = "⨁";
var bigotimes = "⨂";
var bigsqcup = "⨆";
var bigstar = "★";
var bigtriangledown = "▽";
var bigtriangleup = "△";
var biguplus = "⨄";
var bigvee = "⋁";
var bigwedge = "⋀";
var bkarow = "⤍";
var blacklozenge = "⧫";
var blacksquare = "▪";
var blacktriangle = "▴";
var blacktriangledown = "▾";
var blacktriangleleft = "◂";
var blacktriangleright = "▸";
var blank = "␣";
var blk12 = "▒";
var blk14 = "░";
var blk34 = "▓";
var block = "█";
var bne = "=⃥";
var bnequiv = "≡⃥";
var bNot = "⫭";
var bnot = "⌐";
var Bopf = "𝔹";
var bopf = "𝕓";
var bot = "⊥";
var bottom = "⊥";
var bowtie = "⋈";
var boxbox = "⧉";
var boxdl = "┐";
var boxdL = "╕";
var boxDl = "╖";
var boxDL = "╗";
var boxdr = "┌";
var boxdR = "╒";
var boxDr = "╓";
var boxDR = "╔";
var boxh = "─";
var boxH = "═";
var boxhd = "┬";
var boxHd = "╤";
var boxhD = "╥";
var boxHD = "╦";
var boxhu = "┴";
var boxHu = "╧";
var boxhU = "╨";
var boxHU = "╩";
var boxminus = "⊟";
var boxplus = "⊞";
var boxtimes = "⊠";
var boxul = "┘";
var boxuL = "╛";
var boxUl = "╜";
var boxUL = "╝";
var boxur = "└";
var boxuR = "╘";
var boxUr = "╙";
var boxUR = "╚";
var boxv = "│";
var boxV = "║";
var boxvh = "┼";
var boxvH = "╪";
var boxVh = "╫";
var boxVH = "╬";
var boxvl = "┤";
var boxvL = "╡";
var boxVl = "╢";
var boxVL = "╣";
var boxvr = "├";
var boxvR = "╞";
var boxVr = "╟";
var boxVR = "╠";
var bprime = "‵";
var breve = "˘";
var Breve = "˘";
var brvbar$1 = "¦";
var bscr = "𝒷";
var Bscr = "ℬ";
var bsemi = "⁏";
var bsim = "∽";
var bsime = "⋍";
var bsolb = "⧅";
var bsol = "\\";
var bsolhsub = "⟈";
var bull = "•";
var bullet = "•";
var bump = "≎";
var bumpE = "⪮";
var bumpe = "≏";
var Bumpeq = "≎";
var bumpeq = "≏";
var Cacute = "Ć";
var cacute = "ć";
var capand = "⩄";
var capbrcup = "⩉";
var capcap = "⩋";
var cap = "∩";
var Cap = "⋒";
var capcup = "⩇";
var capdot = "⩀";
var CapitalDifferentialD = "ⅅ";
var caps = "∩︀";
var caret = "⁁";
var caron = "ˇ";
var Cayleys = "ℭ";
var ccaps = "⩍";
var Ccaron = "Č";
var ccaron = "č";
var Ccedil$1 = "Ç";
var ccedil$1 = "ç";
var Ccirc = "Ĉ";
var ccirc = "ĉ";
var Cconint = "∰";
var ccups = "⩌";
var ccupssm = "⩐";
var Cdot = "Ċ";
var cdot = "ċ";
var cedil$1 = "¸";
var Cedilla = "¸";
var cemptyv = "⦲";
var cent$1 = "¢";
var centerdot = "·";
var CenterDot = "·";
var cfr = "𝔠";
var Cfr = "ℭ";
var CHcy = "Ч";
var chcy = "ч";
var check = "✓";
var checkmark = "✓";
var Chi = "Χ";
var chi = "χ";
var circ = "ˆ";
var circeq = "≗";
var circlearrowleft = "↺";
var circlearrowright = "↻";
var circledast = "⊛";
var circledcirc = "⊚";
var circleddash = "⊝";
var CircleDot = "⊙";
var circledR = "®";
var circledS = "Ⓢ";
var CircleMinus = "⊖";
var CirclePlus = "⊕";
var CircleTimes = "⊗";
var cir = "○";
var cirE = "⧃";
var cire = "≗";
var cirfnint = "⨐";
var cirmid = "⫯";
var cirscir = "⧂";
var ClockwiseContourIntegral = "∲";
var CloseCurlyDoubleQuote = "”";
var CloseCurlyQuote = "’";
var clubs = "♣";
var clubsuit = "♣";
var colon = ":";
var Colon = "∷";
var Colone = "⩴";
var colone = "≔";
var coloneq = "≔";
var comma = ",";
var commat = "@";
var comp = "∁";
var compfn = "∘";
var complement = "∁";
var complexes = "ℂ";
var cong = "≅";
var congdot = "⩭";
var Congruent = "≡";
var conint = "∮";
var Conint = "∯";
var ContourIntegral = "∮";
var copf = "𝕔";
var Copf = "ℂ";
var coprod = "∐";
var Coproduct = "∐";
var copy$1 = "©";
var COPY$1 = "©";
var copysr = "℗";
var CounterClockwiseContourIntegral = "∳";
var crarr = "↵";
var cross = "✗";
var Cross = "⨯";
var Cscr = "𝒞";
var cscr = "𝒸";
var csub = "⫏";
var csube = "⫑";
var csup = "⫐";
var csupe = "⫒";
var ctdot = "⋯";
var cudarrl = "⤸";
var cudarrr = "⤵";
var cuepr = "⋞";
var cuesc = "⋟";
var cularr = "↶";
var cularrp = "⤽";
var cupbrcap = "⩈";
var cupcap = "⩆";
var CupCap = "≍";
var cup = "∪";
var Cup = "⋓";
var cupcup = "⩊";
var cupdot = "⊍";
var cupor = "⩅";
var cups = "∪︀";
var curarr = "↷";
var curarrm = "⤼";
var curlyeqprec = "⋞";
var curlyeqsucc = "⋟";
var curlyvee = "⋎";
var curlywedge = "⋏";
var curren$1 = "¤";
var curvearrowleft = "↶";
var curvearrowright = "↷";
var cuvee = "⋎";
var cuwed = "⋏";
var cwconint = "∲";
var cwint = "∱";
var cylcty = "⌭";
var dagger = "†";
var Dagger = "‡";
var daleth = "ℸ";
var darr = "↓";
var Darr = "↡";
var dArr = "⇓";
var dash = "‐";
var Dashv = "⫤";
var dashv = "⊣";
var dbkarow = "⤏";
var dblac = "˝";
var Dcaron = "Ď";
var dcaron = "ď";
var Dcy = "Д";
var dcy = "д";
var ddagger = "‡";
var ddarr = "⇊";
var DD = "ⅅ";
var dd = "ⅆ";
var DDotrahd = "⤑";
var ddotseq = "⩷";
var deg$1 = "°";
var Del = "∇";
var Delta = "Δ";
var delta = "δ";
var demptyv = "⦱";
var dfisht = "⥿";
var Dfr = "𝔇";
var dfr = "𝔡";
var dHar = "⥥";
var dharl = "⇃";
var dharr = "⇂";
var DiacriticalAcute = "´";
var DiacriticalDot = "˙";
var DiacriticalDoubleAcute = "˝";
var DiacriticalGrave = "`";
var DiacriticalTilde = "˜";
var diam = "⋄";
var diamond = "⋄";
var Diamond = "⋄";
var diamondsuit = "♦";
var diams = "♦";
var die = "¨";
var DifferentialD = "ⅆ";
var digamma = "ϝ";
var disin = "⋲";
var div = "÷";
var divide$1 = "÷";
var divideontimes = "⋇";
var divonx = "⋇";
var DJcy = "Ђ";
var djcy = "ђ";
var dlcorn = "⌞";
var dlcrop = "⌍";
var dollar = "$";
var Dopf = "𝔻";
var dopf = "𝕕";
var Dot = "¨";
var dot = "˙";
var DotDot = "⃜";
var doteq = "≐";
var doteqdot = "≑";
var DotEqual = "≐";
var dotminus = "∸";
var dotplus = "∔";
var dotsquare = "⊡";
var doublebarwedge = "⌆";
var DoubleContourIntegral = "∯";
var DoubleDot = "¨";
var DoubleDownArrow = "⇓";
var DoubleLeftArrow = "⇐";
var DoubleLeftRightArrow = "⇔";
var DoubleLeftTee = "⫤";
var DoubleLongLeftArrow = "⟸";
var DoubleLongLeftRightArrow = "⟺";
var DoubleLongRightArrow = "⟹";
var DoubleRightArrow = "⇒";
var DoubleRightTee = "⊨";
var DoubleUpArrow = "⇑";
var DoubleUpDownArrow = "⇕";
var DoubleVerticalBar = "∥";
var DownArrowBar = "⤓";
var downarrow = "↓";
var DownArrow = "↓";
var Downarrow = "⇓";
var DownArrowUpArrow = "⇵";
var DownBreve = "̑";
var downdownarrows = "⇊";
var downharpoonleft = "⇃";
var downharpoonright = "⇂";
var DownLeftRightVector = "⥐";
var DownLeftTeeVector = "⥞";
var DownLeftVectorBar = "⥖";
var DownLeftVector = "↽";
var DownRightTeeVector = "⥟";
var DownRightVectorBar = "⥗";
var DownRightVector = "⇁";
var DownTeeArrow = "↧";
var DownTee = "⊤";
var drbkarow = "⤐";
var drcorn = "⌟";
var drcrop = "⌌";
var Dscr = "𝒟";
var dscr = "𝒹";
var DScy = "Ѕ";
var dscy = "ѕ";
var dsol = "⧶";
var Dstrok = "Đ";
var dstrok = "đ";
var dtdot = "⋱";
var dtri = "▿";
var dtrif = "▾";
var duarr = "⇵";
var duhar = "⥯";
var dwangle = "⦦";
var DZcy = "Џ";
var dzcy = "џ";
var dzigrarr = "⟿";
var Eacute$1 = "É";
var eacute$1 = "é";
var easter = "⩮";
var Ecaron = "Ě";
var ecaron = "ě";
var Ecirc$1 = "Ê";
var ecirc$1 = "ê";
var ecir = "≖";
var ecolon = "≕";
var Ecy = "Э";
var ecy = "э";
var eDDot = "⩷";
var Edot = "Ė";
var edot = "ė";
var eDot = "≑";
var ee = "ⅇ";
var efDot = "≒";
var Efr = "𝔈";
var efr = "𝔢";
var eg = "⪚";
var Egrave$1 = "È";
var egrave$1 = "è";
var egs = "⪖";
var egsdot = "⪘";
var el = "⪙";
var Element = "∈";
var elinters = "⏧";
var ell = "ℓ";
var els = "⪕";
var elsdot = "⪗";
var Emacr = "Ē";
var emacr = "ē";
var empty = "∅";
var emptyset = "∅";
var EmptySmallSquare = "◻";
var emptyv = "∅";
var EmptyVerySmallSquare = "▫";
var emsp13 = " ";
var emsp14 = " ";
var emsp = " ";
var ENG = "Ŋ";
var eng = "ŋ";
var ensp = " ";
var Eogon = "Ę";
var eogon = "ę";
var Eopf = "𝔼";
var eopf = "𝕖";
var epar = "⋕";
var eparsl = "⧣";
var eplus = "⩱";
var epsi = "ε";
var Epsilon = "Ε";
var epsilon = "ε";
var epsiv = "ϵ";
var eqcirc = "≖";
var eqcolon = "≕";
var eqsim = "≂";
var eqslantgtr = "⪖";
var eqslantless = "⪕";
var Equal = "⩵";
var equals = "=";
var EqualTilde = "≂";
var equest = "≟";
var Equilibrium = "⇌";
var equiv = "≡";
var equivDD = "⩸";
var eqvparsl = "⧥";
var erarr = "⥱";
var erDot = "≓";
var escr = "ℯ";
var Escr = "ℰ";
var esdot = "≐";
var Esim = "⩳";
var esim = "≂";
var Eta = "Η";
var eta = "η";
var ETH$1 = "Ð";
var eth$1 = "ð";
var Euml$1 = "Ë";
var euml$1 = "ë";
var euro = "€";
var excl = "!";
var exist = "∃";
var Exists = "∃";
var expectation = "ℰ";
var exponentiale = "ⅇ";
var ExponentialE = "ⅇ";
var fallingdotseq = "≒";
var Fcy = "Ф";
var fcy = "ф";
var female = "♀";
var ffilig = "ﬃ";
var fflig = "ﬀ";
var ffllig = "ﬄ";
var Ffr = "𝔉";
var ffr = "𝔣";
var filig = "ﬁ";
var FilledSmallSquare = "◼";
var FilledVerySmallSquare = "▪";
var fjlig = "fj";
var flat = "♭";
var fllig = "ﬂ";
var fltns = "▱";
var fnof = "ƒ";
var Fopf = "𝔽";
var fopf = "𝕗";
var forall = "∀";
var ForAll = "∀";
var fork = "⋔";
var forkv = "⫙";
var Fouriertrf = "ℱ";
var fpartint = "⨍";
var frac12$1 = "½";
var frac13 = "⅓";
var frac14$1 = "¼";
var frac15 = "⅕";
var frac16 = "⅙";
var frac18 = "⅛";
var frac23 = "⅔";
var frac25 = "⅖";
var frac34$1 = "¾";
var frac35 = "⅗";
var frac38 = "⅜";
var frac45 = "⅘";
var frac56 = "⅚";
var frac58 = "⅝";
var frac78 = "⅞";
var frasl = "⁄";
var frown = "⌢";
var fscr = "𝒻";
var Fscr = "ℱ";
var gacute = "ǵ";
var Gamma = "Γ";
var gamma = "γ";
var Gammad = "Ϝ";
var gammad = "ϝ";
var gap = "⪆";
var Gbreve = "Ğ";
var gbreve = "ğ";
var Gcedil = "Ģ";
var Gcirc = "Ĝ";
var gcirc = "ĝ";
var Gcy = "Г";
var gcy = "г";
var Gdot = "Ġ";
var gdot = "ġ";
var ge = "≥";
var gE = "≧";
var gEl = "⪌";
var gel = "⋛";
var geq = "≥";
var geqq = "≧";
var geqslant = "⩾";
var gescc = "⪩";
var ges = "⩾";
var gesdot = "⪀";
var gesdoto = "⪂";
var gesdotol = "⪄";
var gesl = "⋛︀";
var gesles = "⪔";
var Gfr = "𝔊";
var gfr = "𝔤";
var gg = "≫";
var Gg = "⋙";
var ggg = "⋙";
var gimel = "ℷ";
var GJcy = "Ѓ";
var gjcy = "ѓ";
var gla = "⪥";
var gl = "≷";
var glE = "⪒";
var glj = "⪤";
var gnap = "⪊";
var gnapprox = "⪊";
var gne = "⪈";
var gnE = "≩";
var gneq = "⪈";
var gneqq = "≩";
var gnsim = "⋧";
var Gopf = "𝔾";
var gopf = "𝕘";
var grave = "`";
var GreaterEqual = "≥";
var GreaterEqualLess = "⋛";
var GreaterFullEqual = "≧";
var GreaterGreater = "⪢";
var GreaterLess = "≷";
var GreaterSlantEqual = "⩾";
var GreaterTilde = "≳";
var Gscr = "𝒢";
var gscr = "ℊ";
var gsim = "≳";
var gsime = "⪎";
var gsiml = "⪐";
var gtcc = "⪧";
var gtcir = "⩺";
var gt$2 = ">";
var GT$1 = ">";
var Gt = "≫";
var gtdot = "⋗";
var gtlPar = "⦕";
var gtquest = "⩼";
var gtrapprox = "⪆";
var gtrarr = "⥸";
var gtrdot = "⋗";
var gtreqless = "⋛";
var gtreqqless = "⪌";
var gtrless = "≷";
var gtrsim = "≳";
var gvertneqq = "≩︀";
var gvnE = "≩︀";
var Hacek = "ˇ";
var hairsp = " ";
var half = "½";
var hamilt = "ℋ";
var HARDcy = "Ъ";
var hardcy = "ъ";
var harrcir = "⥈";
var harr = "↔";
var hArr = "⇔";
var harrw = "↭";
var Hat = "^";
var hbar = "ℏ";
var Hcirc = "Ĥ";
var hcirc = "ĥ";
var hearts = "♥";
var heartsuit = "♥";
var hellip = "…";
var hercon = "⊹";
var hfr = "𝔥";
var Hfr = "ℌ";
var HilbertSpace = "ℋ";
var hksearow = "⤥";
var hkswarow = "⤦";
var hoarr = "⇿";
var homtht = "∻";
var hookleftarrow = "↩";
var hookrightarrow = "↪";
var hopf = "𝕙";
var Hopf = "ℍ";
var horbar = "―";
var HorizontalLine = "─";
var hscr = "𝒽";
var Hscr = "ℋ";
var hslash = "ℏ";
var Hstrok = "Ħ";
var hstrok = "ħ";
var HumpDownHump = "≎";
var HumpEqual = "≏";
var hybull = "⁃";
var hyphen = "‐";
var Iacute$1 = "Í";
var iacute$1 = "í";
var ic = "⁣";
var Icirc$1 = "Î";
var icirc$1 = "î";
var Icy = "И";
var icy = "и";
var Idot = "İ";
var IEcy = "Е";
var iecy = "е";
var iexcl$1 = "¡";
var iff = "⇔";
var ifr = "𝔦";
var Ifr = "ℑ";
var Igrave$1 = "Ì";
var igrave$1 = "ì";
var ii = "ⅈ";
var iiiint = "⨌";
var iiint = "∭";
var iinfin = "⧜";
var iiota = "℩";
var IJlig = "Ĳ";
var ijlig = "ĳ";
var Imacr = "Ī";
var imacr = "ī";
var image = "ℑ";
var ImaginaryI = "ⅈ";
var imagline = "ℐ";
var imagpart = "ℑ";
var imath = "ı";
var Im = "ℑ";
var imof = "⊷";
var imped = "Ƶ";
var Implies = "⇒";
var incare = "℅";
var infin = "∞";
var infintie = "⧝";
var inodot = "ı";
var intcal = "⊺";
var int = "∫";
var Int = "∬";
var integers = "ℤ";
var Integral = "∫";
var intercal = "⊺";
var Intersection = "⋂";
var intlarhk = "⨗";
var intprod = "⨼";
var InvisibleComma = "⁣";
var InvisibleTimes = "⁢";
var IOcy = "Ё";
var iocy = "ё";
var Iogon = "Į";
var iogon = "į";
var Iopf = "𝕀";
var iopf = "𝕚";
var Iota = "Ι";
var iota = "ι";
var iprod = "⨼";
var iquest$1 = "¿";
var iscr = "𝒾";
var Iscr = "ℐ";
var isin = "∈";
var isindot = "⋵";
var isinE = "⋹";
var isins = "⋴";
var isinsv = "⋳";
var isinv = "∈";
var it = "⁢";
var Itilde = "Ĩ";
var itilde = "ĩ";
var Iukcy = "І";
var iukcy = "і";
var Iuml$1 = "Ï";
var iuml$1 = "ï";
var Jcirc = "Ĵ";
var jcirc = "ĵ";
var Jcy = "Й";
var jcy = "й";
var Jfr = "𝔍";
var jfr = "𝔧";
var jmath = "ȷ";
var Jopf = "𝕁";
var jopf = "𝕛";
var Jscr = "𝒥";
var jscr = "𝒿";
var Jsercy = "Ј";
var jsercy = "ј";
var Jukcy = "Є";
var jukcy = "є";
var Kappa = "Κ";
var kappa = "κ";
var kappav = "ϰ";
var Kcedil = "Ķ";
var kcedil = "ķ";
var Kcy = "К";
var kcy = "к";
var Kfr = "𝔎";
var kfr = "𝔨";
var kgreen = "ĸ";
var KHcy = "Х";
var khcy = "х";
var KJcy = "Ќ";
var kjcy = "ќ";
var Kopf = "𝕂";
var kopf = "𝕜";
var Kscr = "𝒦";
var kscr = "𝓀";
var lAarr = "⇚";
var Lacute = "Ĺ";
var lacute = "ĺ";
var laemptyv = "⦴";
var lagran = "ℒ";
var Lambda = "Λ";
var lambda = "λ";
var lang = "⟨";
var Lang = "⟪";
var langd = "⦑";
var langle = "⟨";
var lap = "⪅";
var Laplacetrf = "ℒ";
var laquo$1 = "«";
var larrb = "⇤";
var larrbfs = "⤟";
var larr = "←";
var Larr = "↞";
var lArr = "⇐";
var larrfs = "⤝";
var larrhk = "↩";
var larrlp = "↫";
var larrpl = "⤹";
var larrsim = "⥳";
var larrtl = "↢";
var latail = "⤙";
var lAtail = "⤛";
var lat = "⪫";
var late = "⪭";
var lates = "⪭︀";
var lbarr = "⤌";
var lBarr = "⤎";
var lbbrk = "❲";
var lbrace = "{";
var lbrack = "[";
var lbrke = "⦋";
var lbrksld = "⦏";
var lbrkslu = "⦍";
var Lcaron = "Ľ";
var lcaron = "ľ";
var Lcedil = "Ļ";
var lcedil = "ļ";
var lceil = "⌈";
var lcub = "{";
var Lcy = "Л";
var lcy = "л";
var ldca = "⤶";
var ldquo = "“";
var ldquor = "„";
var ldrdhar = "⥧";
var ldrushar = "⥋";
var ldsh = "↲";
var le = "≤";
var lE = "≦";
var LeftAngleBracket = "⟨";
var LeftArrowBar = "⇤";
var leftarrow = "←";
var LeftArrow = "←";
var Leftarrow = "⇐";
var LeftArrowRightArrow = "⇆";
var leftarrowtail = "↢";
var LeftCeiling = "⌈";
var LeftDoubleBracket = "⟦";
var LeftDownTeeVector = "⥡";
var LeftDownVectorBar = "⥙";
var LeftDownVector = "⇃";
var LeftFloor = "⌊";
var leftharpoondown = "↽";
var leftharpoonup = "↼";
var leftleftarrows = "⇇";
var leftrightarrow = "↔";
var LeftRightArrow = "↔";
var Leftrightarrow = "⇔";
var leftrightarrows = "⇆";
var leftrightharpoons = "⇋";
var leftrightsquigarrow = "↭";
var LeftRightVector = "⥎";
var LeftTeeArrow = "↤";
var LeftTee = "⊣";
var LeftTeeVector = "⥚";
var leftthreetimes = "⋋";
var LeftTriangleBar = "⧏";
var LeftTriangle = "⊲";
var LeftTriangleEqual = "⊴";
var LeftUpDownVector = "⥑";
var LeftUpTeeVector = "⥠";
var LeftUpVectorBar = "⥘";
var LeftUpVector = "↿";
var LeftVectorBar = "⥒";
var LeftVector = "↼";
var lEg = "⪋";
var leg = "⋚";
var leq = "≤";
var leqq = "≦";
var leqslant = "⩽";
var lescc = "⪨";
var les = "⩽";
var lesdot = "⩿";
var lesdoto = "⪁";
var lesdotor = "⪃";
var lesg = "⋚︀";
var lesges = "⪓";
var lessapprox = "⪅";
var lessdot = "⋖";
var lesseqgtr = "⋚";
var lesseqqgtr = "⪋";
var LessEqualGreater = "⋚";
var LessFullEqual = "≦";
var LessGreater = "≶";
var lessgtr = "≶";
var LessLess = "⪡";
var lesssim = "≲";
var LessSlantEqual = "⩽";
var LessTilde = "≲";
var lfisht = "⥼";
var lfloor = "⌊";
var Lfr = "𝔏";
var lfr = "𝔩";
var lg = "≶";
var lgE = "⪑";
var lHar = "⥢";
var lhard = "↽";
var lharu = "↼";
var lharul = "⥪";
var lhblk = "▄";
var LJcy = "Љ";
var ljcy = "љ";
var llarr = "⇇";
var ll = "≪";
var Ll = "⋘";
var llcorner = "⌞";
var Lleftarrow = "⇚";
var llhard = "⥫";
var lltri = "◺";
var Lmidot = "Ŀ";
var lmidot = "ŀ";
var lmoustache = "⎰";
var lmoust = "⎰";
var lnap = "⪉";
var lnapprox = "⪉";
var lne = "⪇";
var lnE = "≨";
var lneq = "⪇";
var lneqq = "≨";
var lnsim = "⋦";
var loang = "⟬";
var loarr = "⇽";
var lobrk = "⟦";
var longleftarrow = "⟵";
var LongLeftArrow = "⟵";
var Longleftarrow = "⟸";
var longleftrightarrow = "⟷";
var LongLeftRightArrow = "⟷";
var Longleftrightarrow = "⟺";
var longmapsto = "⟼";
var longrightarrow = "⟶";
var LongRightArrow = "⟶";
var Longrightarrow = "⟹";
var looparrowleft = "↫";
var looparrowright = "↬";
var lopar = "⦅";
var Lopf = "𝕃";
var lopf = "𝕝";
var loplus = "⨭";
var lotimes = "⨴";
var lowast = "∗";
var lowbar = "_";
var LowerLeftArrow = "↙";
var LowerRightArrow = "↘";
var loz = "◊";
var lozenge = "◊";
var lozf = "⧫";
var lpar = "(";
var lparlt = "⦓";
var lrarr = "⇆";
var lrcorner = "⌟";
var lrhar = "⇋";
var lrhard = "⥭";
var lrm = "‎";
var lrtri = "⊿";
var lsaquo = "‹";
var lscr = "𝓁";
var Lscr = "ℒ";
var lsh = "↰";
var Lsh = "↰";
var lsim = "≲";
var lsime = "⪍";
var lsimg = "⪏";
var lsqb = "[";
var lsquo = "‘";
var lsquor = "‚";
var Lstrok = "Ł";
var lstrok = "ł";
var ltcc = "⪦";
var ltcir = "⩹";
var lt$2 = "<";
var LT$1 = "<";
var Lt = "≪";
var ltdot = "⋖";
var lthree = "⋋";
var ltimes = "⋉";
var ltlarr = "⥶";
var ltquest = "⩻";
var ltri = "◃";
var ltrie = "⊴";
var ltrif = "◂";
var ltrPar = "⦖";
var lurdshar = "⥊";
var luruhar = "⥦";
var lvertneqq = "≨︀";
var lvnE = "≨︀";
var macr$1 = "¯";
var male = "♂";
var malt = "✠";
var maltese = "✠";
var map = "↦";
var mapsto = "↦";
var mapstodown = "↧";
var mapstoleft = "↤";
var mapstoup = "↥";
var marker = "▮";
var mcomma = "⨩";
var Mcy = "М";
var mcy = "м";
var mdash = "—";
var mDDot = "∺";
var measuredangle = "∡";
var MediumSpace = " ";
var Mellintrf = "ℳ";
var Mfr = "𝔐";
var mfr = "𝔪";
var mho = "℧";
var micro$1 = "µ";
var midast = "*";
var midcir = "⫰";
var mid = "∣";
var middot$1 = "·";
var minusb = "⊟";
var minus = "−";
var minusd = "∸";
var minusdu = "⨪";
var MinusPlus = "∓";
var mlcp = "⫛";
var mldr = "…";
var mnplus = "∓";
var models = "⊧";
var Mopf = "𝕄";
var mopf = "𝕞";
var mp = "∓";
var mscr = "𝓂";
var Mscr = "ℳ";
var mstpos = "∾";
var Mu = "Μ";
var mu = "μ";
var multimap = "⊸";
var mumap = "⊸";
var nabla = "∇";
var Nacute = "Ń";
var nacute = "ń";
var nang = "∠⃒";
var nap = "≉";
var napE = "⩰̸";
var napid = "≋̸";
var napos = "ŉ";
var napprox = "≉";
var natural = "♮";
var naturals = "ℕ";
var natur = "♮";
var nbsp$1 = " ";
var nbump = "≎̸";
var nbumpe = "≏̸";
var ncap = "⩃";
var Ncaron = "Ň";
var ncaron = "ň";
var Ncedil = "Ņ";
var ncedil = "ņ";
var ncong = "≇";
var ncongdot = "⩭̸";
var ncup = "⩂";
var Ncy = "Н";
var ncy = "н";
var ndash = "–";
var nearhk = "⤤";
var nearr = "↗";
var neArr = "⇗";
var nearrow = "↗";
var ne = "≠";
var nedot = "≐̸";
var NegativeMediumSpace = "​";
var NegativeThickSpace = "​";
var NegativeThinSpace = "​";
var NegativeVeryThinSpace = "​";
var nequiv = "≢";
var nesear = "⤨";
var nesim = "≂̸";
var NestedGreaterGreater = "≫";
var NestedLessLess = "≪";
var NewLine = "\n";
var nexist = "∄";
var nexists = "∄";
var Nfr = "𝔑";
var nfr = "𝔫";
var ngE = "≧̸";
var nge = "≱";
var ngeq = "≱";
var ngeqq = "≧̸";
var ngeqslant = "⩾̸";
var nges = "⩾̸";
var nGg = "⋙̸";
var ngsim = "≵";
var nGt = "≫⃒";
var ngt = "≯";
var ngtr = "≯";
var nGtv = "≫̸";
var nharr = "↮";
var nhArr = "⇎";
var nhpar = "⫲";
var ni = "∋";
var nis = "⋼";
var nisd = "⋺";
var niv = "∋";
var NJcy = "Њ";
var njcy = "њ";
var nlarr = "↚";
var nlArr = "⇍";
var nldr = "‥";
var nlE = "≦̸";
var nle = "≰";
var nleftarrow = "↚";
var nLeftarrow = "⇍";
var nleftrightarrow = "↮";
var nLeftrightarrow = "⇎";
var nleq = "≰";
var nleqq = "≦̸";
var nleqslant = "⩽̸";
var nles = "⩽̸";
var nless = "≮";
var nLl = "⋘̸";
var nlsim = "≴";
var nLt = "≪⃒";
var nlt = "≮";
var nltri = "⋪";
var nltrie = "⋬";
var nLtv = "≪̸";
var nmid = "∤";
var NoBreak = "⁠";
var NonBreakingSpace = " ";
var nopf = "𝕟";
var Nopf = "ℕ";
var Not = "⫬";
var not$1 = "¬";
var NotCongruent = "≢";
var NotCupCap = "≭";
var NotDoubleVerticalBar = "∦";
var NotElement = "∉";
var NotEqual = "≠";
var NotEqualTilde = "≂̸";
var NotExists = "∄";
var NotGreater = "≯";
var NotGreaterEqual = "≱";
var NotGreaterFullEqual = "≧̸";
var NotGreaterGreater = "≫̸";
var NotGreaterLess = "≹";
var NotGreaterSlantEqual = "⩾̸";
var NotGreaterTilde = "≵";
var NotHumpDownHump = "≎̸";
var NotHumpEqual = "≏̸";
var notin = "∉";
var notindot = "⋵̸";
var notinE = "⋹̸";
var notinva = "∉";
var notinvb = "⋷";
var notinvc = "⋶";
var NotLeftTriangleBar = "⧏̸";
var NotLeftTriangle = "⋪";
var NotLeftTriangleEqual = "⋬";
var NotLess = "≮";
var NotLessEqual = "≰";
var NotLessGreater = "≸";
var NotLessLess = "≪̸";
var NotLessSlantEqual = "⩽̸";
var NotLessTilde = "≴";
var NotNestedGreaterGreater = "⪢̸";
var NotNestedLessLess = "⪡̸";
var notni = "∌";
var notniva = "∌";
var notnivb = "⋾";
var notnivc = "⋽";
var NotPrecedes = "⊀";
var NotPrecedesEqual = "⪯̸";
var NotPrecedesSlantEqual = "⋠";
var NotReverseElement = "∌";
var NotRightTriangleBar = "⧐̸";
var NotRightTriangle = "⋫";
var NotRightTriangleEqual = "⋭";
var NotSquareSubset = "⊏̸";
var NotSquareSubsetEqual = "⋢";
var NotSquareSuperset = "⊐̸";
var NotSquareSupersetEqual = "⋣";
var NotSubset = "⊂⃒";
var NotSubsetEqual = "⊈";
var NotSucceeds = "⊁";
var NotSucceedsEqual = "⪰̸";
var NotSucceedsSlantEqual = "⋡";
var NotSucceedsTilde = "≿̸";
var NotSuperset = "⊃⃒";
var NotSupersetEqual = "⊉";
var NotTilde = "≁";
var NotTildeEqual = "≄";
var NotTildeFullEqual = "≇";
var NotTildeTilde = "≉";
var NotVerticalBar = "∤";
var nparallel = "∦";
var npar = "∦";
var nparsl = "⫽⃥";
var npart = "∂̸";
var npolint = "⨔";
var npr = "⊀";
var nprcue = "⋠";
var nprec = "⊀";
var npreceq = "⪯̸";
var npre = "⪯̸";
var nrarrc = "⤳̸";
var nrarr = "↛";
var nrArr = "⇏";
var nrarrw = "↝̸";
var nrightarrow = "↛";
var nRightarrow = "⇏";
var nrtri = "⋫";
var nrtrie = "⋭";
var nsc = "⊁";
var nsccue = "⋡";
var nsce = "⪰̸";
var Nscr = "𝒩";
var nscr = "𝓃";
var nshortmid = "∤";
var nshortparallel = "∦";
var nsim = "≁";
var nsime = "≄";
var nsimeq = "≄";
var nsmid = "∤";
var nspar = "∦";
var nsqsube = "⋢";
var nsqsupe = "⋣";
var nsub = "⊄";
var nsubE = "⫅̸";
var nsube = "⊈";
var nsubset = "⊂⃒";
var nsubseteq = "⊈";
var nsubseteqq = "⫅̸";
var nsucc = "⊁";
var nsucceq = "⪰̸";
var nsup = "⊅";
var nsupE = "⫆̸";
var nsupe = "⊉";
var nsupset = "⊃⃒";
var nsupseteq = "⊉";
var nsupseteqq = "⫆̸";
var ntgl = "≹";
var Ntilde$1 = "Ñ";
var ntilde$1 = "ñ";
var ntlg = "≸";
var ntriangleleft = "⋪";
var ntrianglelefteq = "⋬";
var ntriangleright = "⋫";
var ntrianglerighteq = "⋭";
var Nu = "Ν";
var nu = "ν";
var num = "#";
var numero = "№";
var numsp = " ";
var nvap = "≍⃒";
var nvdash = "⊬";
var nvDash = "⊭";
var nVdash = "⊮";
var nVDash = "⊯";
var nvge = "≥⃒";
var nvgt = ">⃒";
var nvHarr = "⤄";
var nvinfin = "⧞";
var nvlArr = "⤂";
var nvle = "≤⃒";
var nvlt = "<⃒";
var nvltrie = "⊴⃒";
var nvrArr = "⤃";
var nvrtrie = "⊵⃒";
var nvsim = "∼⃒";
var nwarhk = "⤣";
var nwarr = "↖";
var nwArr = "⇖";
var nwarrow = "↖";
var nwnear = "⤧";
var Oacute$1 = "Ó";
var oacute$1 = "ó";
var oast = "⊛";
var Ocirc$1 = "Ô";
var ocirc$1 = "ô";
var ocir = "⊚";
var Ocy = "О";
var ocy = "о";
var odash = "⊝";
var Odblac = "Ő";
var odblac = "ő";
var odiv = "⨸";
var odot = "⊙";
var odsold = "⦼";
var OElig = "Œ";
var oelig = "œ";
var ofcir = "⦿";
var Ofr = "𝔒";
var ofr = "𝔬";
var ogon = "˛";
var Ograve$1 = "Ò";
var ograve$1 = "ò";
var ogt = "⧁";
var ohbar = "⦵";
var ohm = "Ω";
var oint = "∮";
var olarr = "↺";
var olcir = "⦾";
var olcross = "⦻";
var oline = "‾";
var olt = "⧀";
var Omacr = "Ō";
var omacr = "ō";
var Omega = "Ω";
var omega = "ω";
var Omicron = "Ο";
var omicron = "ο";
var omid = "⦶";
var ominus = "⊖";
var Oopf = "𝕆";
var oopf = "𝕠";
var opar = "⦷";
var OpenCurlyDoubleQuote = "“";
var OpenCurlyQuote = "‘";
var operp = "⦹";
var oplus = "⊕";
var orarr = "↻";
var Or = "⩔";
var or = "∨";
var ord = "⩝";
var order = "ℴ";
var orderof = "ℴ";
var ordf$1 = "ª";
var ordm$1 = "º";
var origof = "⊶";
var oror = "⩖";
var orslope = "⩗";
var orv = "⩛";
var oS = "Ⓢ";
var Oscr = "𝒪";
var oscr = "ℴ";
var Oslash$1 = "Ø";
var oslash$1 = "ø";
var osol = "⊘";
var Otilde$1 = "Õ";
var otilde$1 = "õ";
var otimesas = "⨶";
var Otimes = "⨷";
var otimes = "⊗";
var Ouml$1 = "Ö";
var ouml$1 = "ö";
var ovbar = "⌽";
var OverBar = "‾";
var OverBrace = "⏞";
var OverBracket = "⎴";
var OverParenthesis = "⏜";
var para$1 = "¶";
var parallel = "∥";
var par = "∥";
var parsim = "⫳";
var parsl = "⫽";
var part = "∂";
var PartialD = "∂";
var Pcy = "П";
var pcy = "п";
var percnt = "%";
var period = ".";
var permil = "‰";
var perp = "⊥";
var pertenk = "‱";
var Pfr = "𝔓";
var pfr = "𝔭";
var Phi = "Φ";
var phi = "φ";
var phiv = "ϕ";
var phmmat = "ℳ";
var phone = "☎";
var Pi = "Π";
var pi = "π";
var pitchfork = "⋔";
var piv = "ϖ";
var planck = "ℏ";
var planckh = "ℎ";
var plankv = "ℏ";
var plusacir = "⨣";
var plusb = "⊞";
var pluscir = "⨢";
var plus = "+";
var plusdo = "∔";
var plusdu = "⨥";
var pluse = "⩲";
var PlusMinus = "±";
var plusmn$1 = "±";
var plussim = "⨦";
var plustwo = "⨧";
var pm = "±";
var Poincareplane = "ℌ";
var pointint = "⨕";
var popf = "𝕡";
var Popf = "ℙ";
var pound$1 = "£";
var prap = "⪷";
var Pr = "⪻";
var pr = "≺";
var prcue = "≼";
var precapprox = "⪷";
var prec = "≺";
var preccurlyeq = "≼";
var Precedes = "≺";
var PrecedesEqual = "⪯";
var PrecedesSlantEqual = "≼";
var PrecedesTilde = "≾";
var preceq = "⪯";
var precnapprox = "⪹";
var precneqq = "⪵";
var precnsim = "⋨";
var pre = "⪯";
var prE = "⪳";
var precsim = "≾";
var prime = "′";
var Prime = "″";
var primes = "ℙ";
var prnap = "⪹";
var prnE = "⪵";
var prnsim = "⋨";
var prod = "∏";
var Product = "∏";
var profalar = "⌮";
var profline = "⌒";
var profsurf = "⌓";
var prop = "∝";
var Proportional = "∝";
var Proportion = "∷";
var propto = "∝";
var prsim = "≾";
var prurel = "⊰";
var Pscr = "𝒫";
var pscr = "𝓅";
var Psi = "Ψ";
var psi = "ψ";
var puncsp = " ";
var Qfr = "𝔔";
var qfr = "𝔮";
var qint = "⨌";
var qopf = "𝕢";
var Qopf = "ℚ";
var qprime = "⁗";
var Qscr = "𝒬";
var qscr = "𝓆";
var quaternions = "ℍ";
var quatint = "⨖";
var quest = "?";
var questeq = "≟";
var quot$2 = "\"";
var QUOT$1 = "\"";
var rAarr = "⇛";
var race = "∽̱";
var Racute = "Ŕ";
var racute = "ŕ";
var radic = "√";
var raemptyv = "⦳";
var rang = "⟩";
var Rang = "⟫";
var rangd = "⦒";
var range = "⦥";
var rangle = "⟩";
var raquo$1 = "»";
var rarrap = "⥵";
var rarrb = "⇥";
var rarrbfs = "⤠";
var rarrc = "⤳";
var rarr = "→";
var Rarr = "↠";
var rArr = "⇒";
var rarrfs = "⤞";
var rarrhk = "↪";
var rarrlp = "↬";
var rarrpl = "⥅";
var rarrsim = "⥴";
var Rarrtl = "⤖";
var rarrtl = "↣";
var rarrw = "↝";
var ratail = "⤚";
var rAtail = "⤜";
var ratio = "∶";
var rationals = "ℚ";
var rbarr = "⤍";
var rBarr = "⤏";
var RBarr = "⤐";
var rbbrk = "❳";
var rbrace = "}";
var rbrack = "]";
var rbrke = "⦌";
var rbrksld = "⦎";
var rbrkslu = "⦐";
var Rcaron = "Ř";
var rcaron = "ř";
var Rcedil = "Ŗ";
var rcedil = "ŗ";
var rceil = "⌉";
var rcub = "}";
var Rcy = "Р";
var rcy = "р";
var rdca = "⤷";
var rdldhar = "⥩";
var rdquo = "”";
var rdquor = "”";
var rdsh = "↳";
var real = "ℜ";
var realine = "ℛ";
var realpart = "ℜ";
var reals = "ℝ";
var Re = "ℜ";
var rect = "▭";
var reg$1 = "®";
var REG$1 = "®";
var ReverseElement = "∋";
var ReverseEquilibrium = "⇋";
var ReverseUpEquilibrium = "⥯";
var rfisht = "⥽";
var rfloor = "⌋";
var rfr = "𝔯";
var Rfr = "ℜ";
var rHar = "⥤";
var rhard = "⇁";
var rharu = "⇀";
var rharul = "⥬";
var Rho = "Ρ";
var rho = "ρ";
var rhov = "ϱ";
var RightAngleBracket = "⟩";
var RightArrowBar = "⇥";
var rightarrow = "→";
var RightArrow = "→";
var Rightarrow = "⇒";
var RightArrowLeftArrow = "⇄";
var rightarrowtail = "↣";
var RightCeiling = "⌉";
var RightDoubleBracket = "⟧";
var RightDownTeeVector = "⥝";
var RightDownVectorBar = "⥕";
var RightDownVector = "⇂";
var RightFloor = "⌋";
var rightharpoondown = "⇁";
var rightharpoonup = "⇀";
var rightleftarrows = "⇄";
var rightleftharpoons = "⇌";
var rightrightarrows = "⇉";
var rightsquigarrow = "↝";
var RightTeeArrow = "↦";
var RightTee = "⊢";
var RightTeeVector = "⥛";
var rightthreetimes = "⋌";
var RightTriangleBar = "⧐";
var RightTriangle = "⊳";
var RightTriangleEqual = "⊵";
var RightUpDownVector = "⥏";
var RightUpTeeVector = "⥜";
var RightUpVectorBar = "⥔";
var RightUpVector = "↾";
var RightVectorBar = "⥓";
var RightVector = "⇀";
var ring = "˚";
var risingdotseq = "≓";
var rlarr = "⇄";
var rlhar = "⇌";
var rlm = "‏";
var rmoustache = "⎱";
var rmoust = "⎱";
var rnmid = "⫮";
var roang = "⟭";
var roarr = "⇾";
var robrk = "⟧";
var ropar = "⦆";
var ropf = "𝕣";
var Ropf = "ℝ";
var roplus = "⨮";
var rotimes = "⨵";
var RoundImplies = "⥰";
var rpar = ")";
var rpargt = "⦔";
var rppolint = "⨒";
var rrarr = "⇉";
var Rrightarrow = "⇛";
var rsaquo = "›";
var rscr = "𝓇";
var Rscr = "ℛ";
var rsh = "↱";
var Rsh = "↱";
var rsqb = "]";
var rsquo = "’";
var rsquor = "’";
var rthree = "⋌";
var rtimes = "⋊";
var rtri = "▹";
var rtrie = "⊵";
var rtrif = "▸";
var rtriltri = "⧎";
var RuleDelayed = "⧴";
var ruluhar = "⥨";
var rx = "℞";
var Sacute = "Ś";
var sacute = "ś";
var sbquo = "‚";
var scap = "⪸";
var Scaron = "Š";
var scaron = "š";
var Sc = "⪼";
var sc = "≻";
var sccue = "≽";
var sce = "⪰";
var scE = "⪴";
var Scedil = "Ş";
var scedil = "ş";
var Scirc = "Ŝ";
var scirc = "ŝ";
var scnap = "⪺";
var scnE = "⪶";
var scnsim = "⋩";
var scpolint = "⨓";
var scsim = "≿";
var Scy = "С";
var scy = "с";
var sdotb = "⊡";
var sdot = "⋅";
var sdote = "⩦";
var searhk = "⤥";
var searr = "↘";
var seArr = "⇘";
var searrow = "↘";
var sect$1 = "§";
var semi = ";";
var seswar = "⤩";
var setminus = "∖";
var setmn = "∖";
var sext = "✶";
var Sfr = "𝔖";
var sfr = "𝔰";
var sfrown = "⌢";
var sharp = "♯";
var SHCHcy = "Щ";
var shchcy = "щ";
var SHcy = "Ш";
var shcy = "ш";
var ShortDownArrow = "↓";
var ShortLeftArrow = "←";
var shortmid = "∣";
var shortparallel = "∥";
var ShortRightArrow = "→";
var ShortUpArrow = "↑";
var shy$1 = "­";
var Sigma = "Σ";
var sigma = "σ";
var sigmaf = "ς";
var sigmav = "ς";
var sim = "∼";
var simdot = "⩪";
var sime = "≃";
var simeq = "≃";
var simg = "⪞";
var simgE = "⪠";
var siml = "⪝";
var simlE = "⪟";
var simne = "≆";
var simplus = "⨤";
var simrarr = "⥲";
var slarr = "←";
var SmallCircle = "∘";
var smallsetminus = "∖";
var smashp = "⨳";
var smeparsl = "⧤";
var smid = "∣";
var smile = "⌣";
var smt = "⪪";
var smte = "⪬";
var smtes = "⪬︀";
var SOFTcy = "Ь";
var softcy = "ь";
var solbar = "⌿";
var solb = "⧄";
var sol = "/";
var Sopf = "𝕊";
var sopf = "𝕤";
var spades = "♠";
var spadesuit = "♠";
var spar = "∥";
var sqcap = "⊓";
var sqcaps = "⊓︀";
var sqcup = "⊔";
var sqcups = "⊔︀";
var Sqrt = "√";
var sqsub = "⊏";
var sqsube = "⊑";
var sqsubset = "⊏";
var sqsubseteq = "⊑";
var sqsup = "⊐";
var sqsupe = "⊒";
var sqsupset = "⊐";
var sqsupseteq = "⊒";
var square = "□";
var Square = "□";
var SquareIntersection = "⊓";
var SquareSubset = "⊏";
var SquareSubsetEqual = "⊑";
var SquareSuperset = "⊐";
var SquareSupersetEqual = "⊒";
var SquareUnion = "⊔";
var squarf = "▪";
var squ = "□";
var squf = "▪";
var srarr = "→";
var Sscr = "𝒮";
var sscr = "𝓈";
var ssetmn = "∖";
var ssmile = "⌣";
var sstarf = "⋆";
var Star = "⋆";
var star = "☆";
var starf = "★";
var straightepsilon = "ϵ";
var straightphi = "ϕ";
var strns = "¯";
var sub = "⊂";
var Sub = "⋐";
var subdot = "⪽";
var subE = "⫅";
var sube = "⊆";
var subedot = "⫃";
var submult = "⫁";
var subnE = "⫋";
var subne = "⊊";
var subplus = "⪿";
var subrarr = "⥹";
var subset = "⊂";
var Subset = "⋐";
var subseteq = "⊆";
var subseteqq = "⫅";
var SubsetEqual = "⊆";
var subsetneq = "⊊";
var subsetneqq = "⫋";
var subsim = "⫇";
var subsub = "⫕";
var subsup = "⫓";
var succapprox = "⪸";
var succ = "≻";
var succcurlyeq = "≽";
var Succeeds = "≻";
var SucceedsEqual = "⪰";
var SucceedsSlantEqual = "≽";
var SucceedsTilde = "≿";
var succeq = "⪰";
var succnapprox = "⪺";
var succneqq = "⪶";
var succnsim = "⋩";
var succsim = "≿";
var SuchThat = "∋";
var sum = "∑";
var Sum = "∑";
var sung = "♪";
var sup1$1 = "¹";
var sup2$1 = "²";
var sup3$1 = "³";
var sup = "⊃";
var Sup = "⋑";
var supdot = "⪾";
var supdsub = "⫘";
var supE = "⫆";
var supe = "⊇";
var supedot = "⫄";
var Superset = "⊃";
var SupersetEqual = "⊇";
var suphsol = "⟉";
var suphsub = "⫗";
var suplarr = "⥻";
var supmult = "⫂";
var supnE = "⫌";
var supne = "⊋";
var supplus = "⫀";
var supset = "⊃";
var Supset = "⋑";
var supseteq = "⊇";
var supseteqq = "⫆";
var supsetneq = "⊋";
var supsetneqq = "⫌";
var supsim = "⫈";
var supsub = "⫔";
var supsup = "⫖";
var swarhk = "⤦";
var swarr = "↙";
var swArr = "⇙";
var swarrow = "↙";
var swnwar = "⤪";
var szlig$1 = "ß";
var Tab$2 = "\t";
var target = "⌖";
var Tau = "Τ";
var tau = "τ";
var tbrk = "⎴";
var Tcaron = "Ť";
var tcaron = "ť";
var Tcedil = "Ţ";
var tcedil = "ţ";
var Tcy = "Т";
var tcy = "т";
var tdot = "⃛";
var telrec = "⌕";
var Tfr = "𝔗";
var tfr = "𝔱";
var there4 = "∴";
var therefore = "∴";
var Therefore = "∴";
var Theta = "Θ";
var theta = "θ";
var thetasym = "ϑ";
var thetav = "ϑ";
var thickapprox = "≈";
var thicksim = "∼";
var ThickSpace = "  ";
var ThinSpace = " ";
var thinsp = " ";
var thkap = "≈";
var thksim = "∼";
var THORN$1 = "Þ";
var thorn$1 = "þ";
var tilde = "˜";
var Tilde = "∼";
var TildeEqual = "≃";
var TildeFullEqual = "≅";
var TildeTilde = "≈";
var timesbar = "⨱";
var timesb = "⊠";
var times$1 = "×";
var timesd = "⨰";
var tint = "∭";
var toea = "⤨";
var topbot = "⌶";
var topcir = "⫱";
var top = "⊤";
var Topf = "𝕋";
var topf = "𝕥";
var topfork = "⫚";
var tosa = "⤩";
var tprime = "‴";
var trade = "™";
var TRADE = "™";
var triangle = "▵";
var triangledown = "▿";
var triangleleft = "◃";
var trianglelefteq = "⊴";
var triangleq = "≜";
var triangleright = "▹";
var trianglerighteq = "⊵";
var tridot = "◬";
var trie = "≜";
var triminus = "⨺";
var TripleDot = "⃛";
var triplus = "⨹";
var trisb = "⧍";
var tritime = "⨻";
var trpezium = "⏢";
var Tscr = "𝒯";
var tscr = "𝓉";
var TScy = "Ц";
var tscy = "ц";
var TSHcy = "Ћ";
var tshcy = "ћ";
var Tstrok = "Ŧ";
var tstrok = "ŧ";
var twixt = "≬";
var twoheadleftarrow = "↞";
var twoheadrightarrow = "↠";
var Uacute$1 = "Ú";
var uacute$1 = "ú";
var uarr = "↑";
var Uarr = "↟";
var uArr = "⇑";
var Uarrocir = "⥉";
var Ubrcy = "Ў";
var ubrcy = "ў";
var Ubreve = "Ŭ";
var ubreve = "ŭ";
var Ucirc$1 = "Û";
var ucirc$1 = "û";
var Ucy = "У";
var ucy = "у";
var udarr = "⇅";
var Udblac = "Ű";
var udblac = "ű";
var udhar = "⥮";
var ufisht = "⥾";
var Ufr = "𝔘";
var ufr = "𝔲";
var Ugrave$1 = "Ù";
var ugrave$1 = "ù";
var uHar = "⥣";
var uharl = "↿";
var uharr = "↾";
var uhblk = "▀";
var ulcorn = "⌜";
var ulcorner = "⌜";
var ulcrop = "⌏";
var ultri = "◸";
var Umacr = "Ū";
var umacr = "ū";
var uml$1 = "¨";
var UnderBar = "_";
var UnderBrace = "⏟";
var UnderBracket = "⎵";
var UnderParenthesis = "⏝";
var Union = "⋃";
var UnionPlus = "⊎";
var Uogon = "Ų";
var uogon = "ų";
var Uopf = "𝕌";
var uopf = "𝕦";
var UpArrowBar = "⤒";
var uparrow = "↑";
var UpArrow = "↑";
var Uparrow = "⇑";
var UpArrowDownArrow = "⇅";
var updownarrow = "↕";
var UpDownArrow = "↕";
var Updownarrow = "⇕";
var UpEquilibrium = "⥮";
var upharpoonleft = "↿";
var upharpoonright = "↾";
var uplus = "⊎";
var UpperLeftArrow = "↖";
var UpperRightArrow = "↗";
var upsi = "υ";
var Upsi = "ϒ";
var upsih = "ϒ";
var Upsilon = "Υ";
var upsilon = "υ";
var UpTeeArrow = "↥";
var UpTee = "⊥";
var upuparrows = "⇈";
var urcorn = "⌝";
var urcorner = "⌝";
var urcrop = "⌎";
var Uring = "Ů";
var uring = "ů";
var urtri = "◹";
var Uscr = "𝒰";
var uscr = "𝓊";
var utdot = "⋰";
var Utilde = "Ũ";
var utilde = "ũ";
var utri = "▵";
var utrif = "▴";
var uuarr = "⇈";
var Uuml$1 = "Ü";
var uuml$1 = "ü";
var uwangle = "⦧";
var vangrt = "⦜";
var varepsilon = "ϵ";
var varkappa = "ϰ";
var varnothing = "∅";
var varphi = "ϕ";
var varpi = "ϖ";
var varpropto = "∝";
var varr = "↕";
var vArr = "⇕";
var varrho = "ϱ";
var varsigma = "ς";
var varsubsetneq = "⊊︀";
var varsubsetneqq = "⫋︀";
var varsupsetneq = "⊋︀";
var varsupsetneqq = "⫌︀";
var vartheta = "ϑ";
var vartriangleleft = "⊲";
var vartriangleright = "⊳";
var vBar = "⫨";
var Vbar = "⫫";
var vBarv = "⫩";
var Vcy = "В";
var vcy = "в";
var vdash = "⊢";
var vDash = "⊨";
var Vdash = "⊩";
var VDash = "⊫";
var Vdashl = "⫦";
var veebar = "⊻";
var vee = "∨";
var Vee = "⋁";
var veeeq = "≚";
var vellip = "⋮";
var verbar = "|";
var Verbar = "‖";
var vert = "|";
var Vert = "‖";
var VerticalBar = "∣";
var VerticalLine = "|";
var VerticalSeparator = "❘";
var VerticalTilde = "≀";
var VeryThinSpace = " ";
var Vfr = "𝔙";
var vfr = "𝔳";
var vltri = "⊲";
var vnsub = "⊂⃒";
var vnsup = "⊃⃒";
var Vopf = "𝕍";
var vopf = "𝕧";
var vprop = "∝";
var vrtri = "⊳";
var Vscr = "𝒱";
var vscr = "𝓋";
var vsubnE = "⫋︀";
var vsubne = "⊊︀";
var vsupnE = "⫌︀";
var vsupne = "⊋︀";
var Vvdash = "⊪";
var vzigzag = "⦚";
var Wcirc = "Ŵ";
var wcirc = "ŵ";
var wedbar = "⩟";
var wedge = "∧";
var Wedge = "⋀";
var wedgeq = "≙";
var weierp = "℘";
var Wfr = "𝔚";
var wfr = "𝔴";
var Wopf = "𝕎";
var wopf = "𝕨";
var wp = "℘";
var wr = "≀";
var wreath = "≀";
var Wscr = "𝒲";
var wscr = "𝓌";
var xcap = "⋂";
var xcirc = "◯";
var xcup = "⋃";
var xdtri = "▽";
var Xfr = "𝔛";
var xfr = "𝔵";
var xharr = "⟷";
var xhArr = "⟺";
var Xi = "Ξ";
var xi = "ξ";
var xlarr = "⟵";
var xlArr = "⟸";
var xmap = "⟼";
var xnis = "⋻";
var xodot = "⨀";
var Xopf = "𝕏";
var xopf = "𝕩";
var xoplus = "⨁";
var xotime = "⨂";
var xrarr = "⟶";
var xrArr = "⟹";
var Xscr = "𝒳";
var xscr = "𝓍";
var xsqcup = "⨆";
var xuplus = "⨄";
var xutri = "△";
var xvee = "⋁";
var xwedge = "⋀";
var Yacute$1 = "Ý";
var yacute$1 = "ý";
var YAcy = "Я";
var yacy = "я";
var Ycirc = "Ŷ";
var ycirc = "ŷ";
var Ycy = "Ы";
var ycy = "ы";
var yen$1 = "¥";
var Yfr = "𝔜";
var yfr = "𝔶";
var YIcy = "Ї";
var yicy = "ї";
var Yopf = "𝕐";
var yopf = "𝕪";
var Yscr = "𝒴";
var yscr = "𝓎";
var YUcy = "Ю";
var yucy = "ю";
var yuml$1 = "ÿ";
var Yuml = "Ÿ";
var Zacute = "Ź";
var zacute = "ź";
var Zcaron = "Ž";
var zcaron = "ž";
var Zcy = "З";
var zcy = "з";
var Zdot = "Ż";
var zdot = "ż";
var zeetrf = "ℨ";
var ZeroWidthSpace = "​";
var Zeta = "Ζ";
var zeta = "ζ";
var zfr = "𝔷";
var Zfr = "ℨ";
var ZHcy = "Ж";
var zhcy = "ж";
var zigrarr = "⇝";
var zopf = "𝕫";
var Zopf = "ℤ";
var Zscr = "𝒵";
var zscr = "𝓏";
var zwj = "‍";
var zwnj = "‌";
var require$$1$1 = {
	Aacute: Aacute$1,
	aacute: aacute$1,
	Abreve: Abreve,
	abreve: abreve,
	ac: ac,
	acd: acd,
	acE: acE,
	Acirc: Acirc$1,
	acirc: acirc$1,
	acute: acute$1,
	Acy: Acy,
	acy: acy,
	AElig: AElig$1,
	aelig: aelig$1,
	af: af,
	Afr: Afr,
	afr: afr,
	Agrave: Agrave$1,
	agrave: agrave$1,
	alefsym: alefsym,
	aleph: aleph,
	Alpha: Alpha,
	alpha: alpha,
	Amacr: Amacr,
	amacr: amacr,
	amalg: amalg,
	amp: amp$2,
	AMP: AMP$1,
	andand: andand,
	And: And,
	and: and,
	andd: andd,
	andslope: andslope,
	andv: andv,
	ang: ang,
	ange: ange,
	angle: angle,
	angmsdaa: angmsdaa,
	angmsdab: angmsdab,
	angmsdac: angmsdac,
	angmsdad: angmsdad,
	angmsdae: angmsdae,
	angmsdaf: angmsdaf,
	angmsdag: angmsdag,
	angmsdah: angmsdah,
	angmsd: angmsd,
	angrt: angrt,
	angrtvb: angrtvb,
	angrtvbd: angrtvbd,
	angsph: angsph,
	angst: angst,
	angzarr: angzarr,
	Aogon: Aogon,
	aogon: aogon,
	Aopf: Aopf,
	aopf: aopf,
	apacir: apacir,
	ap: ap,
	apE: apE,
	ape: ape,
	apid: apid,
	apos: apos$1,
	ApplyFunction: ApplyFunction,
	approx: approx,
	approxeq: approxeq,
	Aring: Aring$1,
	aring: aring$1,
	Ascr: Ascr,
	ascr: ascr,
	Assign: Assign,
	ast: ast,
	asymp: asymp,
	asympeq: asympeq,
	Atilde: Atilde$1,
	atilde: atilde$1,
	Auml: Auml$1,
	auml: auml$1,
	awconint: awconint,
	awint: awint,
	backcong: backcong,
	backepsilon: backepsilon,
	backprime: backprime,
	backsim: backsim,
	backsimeq: backsimeq,
	Backslash: Backslash,
	Barv: Barv,
	barvee: barvee,
	barwed: barwed,
	Barwed: Barwed,
	barwedge: barwedge,
	bbrk: bbrk,
	bbrktbrk: bbrktbrk,
	bcong: bcong,
	Bcy: Bcy,
	bcy: bcy,
	bdquo: bdquo,
	becaus: becaus,
	because: because,
	Because: Because,
	bemptyv: bemptyv,
	bepsi: bepsi,
	bernou: bernou,
	Bernoullis: Bernoullis,
	Beta: Beta,
	beta: beta,
	beth: beth,
	between: between,
	Bfr: Bfr,
	bfr: bfr,
	bigcap: bigcap,
	bigcirc: bigcirc,
	bigcup: bigcup,
	bigodot: bigodot,
	bigoplus: bigoplus,
	bigotimes: bigotimes,
	bigsqcup: bigsqcup,
	bigstar: bigstar,
	bigtriangledown: bigtriangledown,
	bigtriangleup: bigtriangleup,
	biguplus: biguplus,
	bigvee: bigvee,
	bigwedge: bigwedge,
	bkarow: bkarow,
	blacklozenge: blacklozenge,
	blacksquare: blacksquare,
	blacktriangle: blacktriangle,
	blacktriangledown: blacktriangledown,
	blacktriangleleft: blacktriangleleft,
	blacktriangleright: blacktriangleright,
	blank: blank,
	blk12: blk12,
	blk14: blk14,
	blk34: blk34,
	block: block,
	bne: bne,
	bnequiv: bnequiv,
	bNot: bNot,
	bnot: bnot,
	Bopf: Bopf,
	bopf: bopf,
	bot: bot,
	bottom: bottom,
	bowtie: bowtie,
	boxbox: boxbox,
	boxdl: boxdl,
	boxdL: boxdL,
	boxDl: boxDl,
	boxDL: boxDL,
	boxdr: boxdr,
	boxdR: boxdR,
	boxDr: boxDr,
	boxDR: boxDR,
	boxh: boxh,
	boxH: boxH,
	boxhd: boxhd,
	boxHd: boxHd,
	boxhD: boxhD,
	boxHD: boxHD,
	boxhu: boxhu,
	boxHu: boxHu,
	boxhU: boxhU,
	boxHU: boxHU,
	boxminus: boxminus,
	boxplus: boxplus,
	boxtimes: boxtimes,
	boxul: boxul,
	boxuL: boxuL,
	boxUl: boxUl,
	boxUL: boxUL,
	boxur: boxur,
	boxuR: boxuR,
	boxUr: boxUr,
	boxUR: boxUR,
	boxv: boxv,
	boxV: boxV,
	boxvh: boxvh,
	boxvH: boxvH,
	boxVh: boxVh,
	boxVH: boxVH,
	boxvl: boxvl,
	boxvL: boxvL,
	boxVl: boxVl,
	boxVL: boxVL,
	boxvr: boxvr,
	boxvR: boxvR,
	boxVr: boxVr,
	boxVR: boxVR,
	bprime: bprime,
	breve: breve,
	Breve: Breve,
	brvbar: brvbar$1,
	bscr: bscr,
	Bscr: Bscr,
	bsemi: bsemi,
	bsim: bsim,
	bsime: bsime,
	bsolb: bsolb,
	bsol: bsol,
	bsolhsub: bsolhsub,
	bull: bull,
	bullet: bullet,
	bump: bump,
	bumpE: bumpE,
	bumpe: bumpe,
	Bumpeq: Bumpeq,
	bumpeq: bumpeq,
	Cacute: Cacute,
	cacute: cacute,
	capand: capand,
	capbrcup: capbrcup,
	capcap: capcap,
	cap: cap,
	Cap: Cap,
	capcup: capcup,
	capdot: capdot,
	CapitalDifferentialD: CapitalDifferentialD,
	caps: caps,
	caret: caret,
	caron: caron,
	Cayleys: Cayleys,
	ccaps: ccaps,
	Ccaron: Ccaron,
	ccaron: ccaron,
	Ccedil: Ccedil$1,
	ccedil: ccedil$1,
	Ccirc: Ccirc,
	ccirc: ccirc,
	Cconint: Cconint,
	ccups: ccups,
	ccupssm: ccupssm,
	Cdot: Cdot,
	cdot: cdot,
	cedil: cedil$1,
	Cedilla: Cedilla,
	cemptyv: cemptyv,
	cent: cent$1,
	centerdot: centerdot,
	CenterDot: CenterDot,
	cfr: cfr,
	Cfr: Cfr,
	CHcy: CHcy,
	chcy: chcy,
	check: check,
	checkmark: checkmark,
	Chi: Chi,
	chi: chi,
	circ: circ,
	circeq: circeq,
	circlearrowleft: circlearrowleft,
	circlearrowright: circlearrowright,
	circledast: circledast,
	circledcirc: circledcirc,
	circleddash: circleddash,
	CircleDot: CircleDot,
	circledR: circledR,
	circledS: circledS,
	CircleMinus: CircleMinus,
	CirclePlus: CirclePlus,
	CircleTimes: CircleTimes,
	cir: cir,
	cirE: cirE,
	cire: cire,
	cirfnint: cirfnint,
	cirmid: cirmid,
	cirscir: cirscir,
	ClockwiseContourIntegral: ClockwiseContourIntegral,
	CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
	CloseCurlyQuote: CloseCurlyQuote,
	clubs: clubs,
	clubsuit: clubsuit,
	colon: colon,
	Colon: Colon,
	Colone: Colone,
	colone: colone,
	coloneq: coloneq,
	comma: comma,
	commat: commat,
	comp: comp,
	compfn: compfn,
	complement: complement,
	complexes: complexes,
	cong: cong,
	congdot: congdot,
	Congruent: Congruent,
	conint: conint,
	Conint: Conint,
	ContourIntegral: ContourIntegral,
	copf: copf,
	Copf: Copf,
	coprod: coprod,
	Coproduct: Coproduct,
	copy: copy$1,
	COPY: COPY$1,
	copysr: copysr,
	CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
	crarr: crarr,
	cross: cross,
	Cross: Cross,
	Cscr: Cscr,
	cscr: cscr,
	csub: csub,
	csube: csube,
	csup: csup,
	csupe: csupe,
	ctdot: ctdot,
	cudarrl: cudarrl,
	cudarrr: cudarrr,
	cuepr: cuepr,
	cuesc: cuesc,
	cularr: cularr,
	cularrp: cularrp,
	cupbrcap: cupbrcap,
	cupcap: cupcap,
	CupCap: CupCap,
	cup: cup,
	Cup: Cup,
	cupcup: cupcup,
	cupdot: cupdot,
	cupor: cupor,
	cups: cups,
	curarr: curarr,
	curarrm: curarrm,
	curlyeqprec: curlyeqprec,
	curlyeqsucc: curlyeqsucc,
	curlyvee: curlyvee,
	curlywedge: curlywedge,
	curren: curren$1,
	curvearrowleft: curvearrowleft,
	curvearrowright: curvearrowright,
	cuvee: cuvee,
	cuwed: cuwed,
	cwconint: cwconint,
	cwint: cwint,
	cylcty: cylcty,
	dagger: dagger,
	Dagger: Dagger,
	daleth: daleth,
	darr: darr,
	Darr: Darr,
	dArr: dArr,
	dash: dash,
	Dashv: Dashv,
	dashv: dashv,
	dbkarow: dbkarow,
	dblac: dblac,
	Dcaron: Dcaron,
	dcaron: dcaron,
	Dcy: Dcy,
	dcy: dcy,
	ddagger: ddagger,
	ddarr: ddarr,
	DD: DD,
	dd: dd,
	DDotrahd: DDotrahd,
	ddotseq: ddotseq,
	deg: deg$1,
	Del: Del,
	Delta: Delta,
	delta: delta,
	demptyv: demptyv,
	dfisht: dfisht,
	Dfr: Dfr,
	dfr: dfr,
	dHar: dHar,
	dharl: dharl,
	dharr: dharr,
	DiacriticalAcute: DiacriticalAcute,
	DiacriticalDot: DiacriticalDot,
	DiacriticalDoubleAcute: DiacriticalDoubleAcute,
	DiacriticalGrave: DiacriticalGrave,
	DiacriticalTilde: DiacriticalTilde,
	diam: diam,
	diamond: diamond,
	Diamond: Diamond,
	diamondsuit: diamondsuit,
	diams: diams,
	die: die,
	DifferentialD: DifferentialD,
	digamma: digamma,
	disin: disin,
	div: div,
	divide: divide$1,
	divideontimes: divideontimes,
	divonx: divonx,
	DJcy: DJcy,
	djcy: djcy,
	dlcorn: dlcorn,
	dlcrop: dlcrop,
	dollar: dollar,
	Dopf: Dopf,
	dopf: dopf,
	Dot: Dot,
	dot: dot,
	DotDot: DotDot,
	doteq: doteq,
	doteqdot: doteqdot,
	DotEqual: DotEqual,
	dotminus: dotminus,
	dotplus: dotplus,
	dotsquare: dotsquare,
	doublebarwedge: doublebarwedge,
	DoubleContourIntegral: DoubleContourIntegral,
	DoubleDot: DoubleDot,
	DoubleDownArrow: DoubleDownArrow,
	DoubleLeftArrow: DoubleLeftArrow,
	DoubleLeftRightArrow: DoubleLeftRightArrow,
	DoubleLeftTee: DoubleLeftTee,
	DoubleLongLeftArrow: DoubleLongLeftArrow,
	DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
	DoubleLongRightArrow: DoubleLongRightArrow,
	DoubleRightArrow: DoubleRightArrow,
	DoubleRightTee: DoubleRightTee,
	DoubleUpArrow: DoubleUpArrow,
	DoubleUpDownArrow: DoubleUpDownArrow,
	DoubleVerticalBar: DoubleVerticalBar,
	DownArrowBar: DownArrowBar,
	downarrow: downarrow,
	DownArrow: DownArrow,
	Downarrow: Downarrow,
	DownArrowUpArrow: DownArrowUpArrow,
	DownBreve: DownBreve,
	downdownarrows: downdownarrows,
	downharpoonleft: downharpoonleft,
	downharpoonright: downharpoonright,
	DownLeftRightVector: DownLeftRightVector,
	DownLeftTeeVector: DownLeftTeeVector,
	DownLeftVectorBar: DownLeftVectorBar,
	DownLeftVector: DownLeftVector,
	DownRightTeeVector: DownRightTeeVector,
	DownRightVectorBar: DownRightVectorBar,
	DownRightVector: DownRightVector,
	DownTeeArrow: DownTeeArrow,
	DownTee: DownTee,
	drbkarow: drbkarow,
	drcorn: drcorn,
	drcrop: drcrop,
	Dscr: Dscr,
	dscr: dscr,
	DScy: DScy,
	dscy: dscy,
	dsol: dsol,
	Dstrok: Dstrok,
	dstrok: dstrok,
	dtdot: dtdot,
	dtri: dtri,
	dtrif: dtrif,
	duarr: duarr,
	duhar: duhar,
	dwangle: dwangle,
	DZcy: DZcy,
	dzcy: dzcy,
	dzigrarr: dzigrarr,
	Eacute: Eacute$1,
	eacute: eacute$1,
	easter: easter,
	Ecaron: Ecaron,
	ecaron: ecaron,
	Ecirc: Ecirc$1,
	ecirc: ecirc$1,
	ecir: ecir,
	ecolon: ecolon,
	Ecy: Ecy,
	ecy: ecy,
	eDDot: eDDot,
	Edot: Edot,
	edot: edot,
	eDot: eDot,
	ee: ee,
	efDot: efDot,
	Efr: Efr,
	efr: efr,
	eg: eg,
	Egrave: Egrave$1,
	egrave: egrave$1,
	egs: egs,
	egsdot: egsdot,
	el: el,
	Element: Element,
	elinters: elinters,
	ell: ell,
	els: els,
	elsdot: elsdot,
	Emacr: Emacr,
	emacr: emacr,
	empty: empty,
	emptyset: emptyset,
	EmptySmallSquare: EmptySmallSquare,
	emptyv: emptyv,
	EmptyVerySmallSquare: EmptyVerySmallSquare,
	emsp13: emsp13,
	emsp14: emsp14,
	emsp: emsp,
	ENG: ENG,
	eng: eng,
	ensp: ensp,
	Eogon: Eogon,
	eogon: eogon,
	Eopf: Eopf,
	eopf: eopf,
	epar: epar,
	eparsl: eparsl,
	eplus: eplus,
	epsi: epsi,
	Epsilon: Epsilon,
	epsilon: epsilon,
	epsiv: epsiv,
	eqcirc: eqcirc,
	eqcolon: eqcolon,
	eqsim: eqsim,
	eqslantgtr: eqslantgtr,
	eqslantless: eqslantless,
	Equal: Equal,
	equals: equals,
	EqualTilde: EqualTilde,
	equest: equest,
	Equilibrium: Equilibrium,
	equiv: equiv,
	equivDD: equivDD,
	eqvparsl: eqvparsl,
	erarr: erarr,
	erDot: erDot,
	escr: escr,
	Escr: Escr,
	esdot: esdot,
	Esim: Esim,
	esim: esim,
	Eta: Eta,
	eta: eta,
	ETH: ETH$1,
	eth: eth$1,
	Euml: Euml$1,
	euml: euml$1,
	euro: euro,
	excl: excl,
	exist: exist,
	Exists: Exists,
	expectation: expectation,
	exponentiale: exponentiale,
	ExponentialE: ExponentialE,
	fallingdotseq: fallingdotseq,
	Fcy: Fcy,
	fcy: fcy,
	female: female,
	ffilig: ffilig,
	fflig: fflig,
	ffllig: ffllig,
	Ffr: Ffr,
	ffr: ffr,
	filig: filig,
	FilledSmallSquare: FilledSmallSquare,
	FilledVerySmallSquare: FilledVerySmallSquare,
	fjlig: fjlig,
	flat: flat,
	fllig: fllig,
	fltns: fltns,
	fnof: fnof,
	Fopf: Fopf,
	fopf: fopf,
	forall: forall,
	ForAll: ForAll,
	fork: fork,
	forkv: forkv,
	Fouriertrf: Fouriertrf,
	fpartint: fpartint,
	frac12: frac12$1,
	frac13: frac13,
	frac14: frac14$1,
	frac15: frac15,
	frac16: frac16,
	frac18: frac18,
	frac23: frac23,
	frac25: frac25,
	frac34: frac34$1,
	frac35: frac35,
	frac38: frac38,
	frac45: frac45,
	frac56: frac56,
	frac58: frac58,
	frac78: frac78,
	frasl: frasl,
	frown: frown,
	fscr: fscr,
	Fscr: Fscr,
	gacute: gacute,
	Gamma: Gamma,
	gamma: gamma,
	Gammad: Gammad,
	gammad: gammad,
	gap: gap,
	Gbreve: Gbreve,
	gbreve: gbreve,
	Gcedil: Gcedil,
	Gcirc: Gcirc,
	gcirc: gcirc,
	Gcy: Gcy,
	gcy: gcy,
	Gdot: Gdot,
	gdot: gdot,
	ge: ge,
	gE: gE,
	gEl: gEl,
	gel: gel,
	geq: geq,
	geqq: geqq,
	geqslant: geqslant,
	gescc: gescc,
	ges: ges,
	gesdot: gesdot,
	gesdoto: gesdoto,
	gesdotol: gesdotol,
	gesl: gesl,
	gesles: gesles,
	Gfr: Gfr,
	gfr: gfr,
	gg: gg,
	Gg: Gg,
	ggg: ggg,
	gimel: gimel,
	GJcy: GJcy,
	gjcy: gjcy,
	gla: gla,
	gl: gl,
	glE: glE,
	glj: glj,
	gnap: gnap,
	gnapprox: gnapprox,
	gne: gne,
	gnE: gnE,
	gneq: gneq,
	gneqq: gneqq,
	gnsim: gnsim,
	Gopf: Gopf,
	gopf: gopf,
	grave: grave,
	GreaterEqual: GreaterEqual,
	GreaterEqualLess: GreaterEqualLess,
	GreaterFullEqual: GreaterFullEqual,
	GreaterGreater: GreaterGreater,
	GreaterLess: GreaterLess,
	GreaterSlantEqual: GreaterSlantEqual,
	GreaterTilde: GreaterTilde,
	Gscr: Gscr,
	gscr: gscr,
	gsim: gsim,
	gsime: gsime,
	gsiml: gsiml,
	gtcc: gtcc,
	gtcir: gtcir,
	gt: gt$2,
	GT: GT$1,
	Gt: Gt,
	gtdot: gtdot,
	gtlPar: gtlPar,
	gtquest: gtquest,
	gtrapprox: gtrapprox,
	gtrarr: gtrarr,
	gtrdot: gtrdot,
	gtreqless: gtreqless,
	gtreqqless: gtreqqless,
	gtrless: gtrless,
	gtrsim: gtrsim,
	gvertneqq: gvertneqq,
	gvnE: gvnE,
	Hacek: Hacek,
	hairsp: hairsp,
	half: half,
	hamilt: hamilt,
	HARDcy: HARDcy,
	hardcy: hardcy,
	harrcir: harrcir,
	harr: harr,
	hArr: hArr,
	harrw: harrw,
	Hat: Hat,
	hbar: hbar,
	Hcirc: Hcirc,
	hcirc: hcirc,
	hearts: hearts,
	heartsuit: heartsuit,
	hellip: hellip,
	hercon: hercon,
	hfr: hfr,
	Hfr: Hfr,
	HilbertSpace: HilbertSpace,
	hksearow: hksearow,
	hkswarow: hkswarow,
	hoarr: hoarr,
	homtht: homtht,
	hookleftarrow: hookleftarrow,
	hookrightarrow: hookrightarrow,
	hopf: hopf,
	Hopf: Hopf,
	horbar: horbar,
	HorizontalLine: HorizontalLine,
	hscr: hscr,
	Hscr: Hscr,
	hslash: hslash,
	Hstrok: Hstrok,
	hstrok: hstrok,
	HumpDownHump: HumpDownHump,
	HumpEqual: HumpEqual,
	hybull: hybull,
	hyphen: hyphen,
	Iacute: Iacute$1,
	iacute: iacute$1,
	ic: ic,
	Icirc: Icirc$1,
	icirc: icirc$1,
	Icy: Icy,
	icy: icy,
	Idot: Idot,
	IEcy: IEcy,
	iecy: iecy,
	iexcl: iexcl$1,
	iff: iff,
	ifr: ifr,
	Ifr: Ifr,
	Igrave: Igrave$1,
	igrave: igrave$1,
	ii: ii,
	iiiint: iiiint,
	iiint: iiint,
	iinfin: iinfin,
	iiota: iiota,
	IJlig: IJlig,
	ijlig: ijlig,
	Imacr: Imacr,
	imacr: imacr,
	image: image,
	ImaginaryI: ImaginaryI,
	imagline: imagline,
	imagpart: imagpart,
	imath: imath,
	Im: Im,
	imof: imof,
	imped: imped,
	Implies: Implies,
	incare: incare,
	"in": "∈",
	infin: infin,
	infintie: infintie,
	inodot: inodot,
	intcal: intcal,
	int: int,
	Int: Int,
	integers: integers,
	Integral: Integral,
	intercal: intercal,
	Intersection: Intersection,
	intlarhk: intlarhk,
	intprod: intprod,
	InvisibleComma: InvisibleComma,
	InvisibleTimes: InvisibleTimes,
	IOcy: IOcy,
	iocy: iocy,
	Iogon: Iogon,
	iogon: iogon,
	Iopf: Iopf,
	iopf: iopf,
	Iota: Iota,
	iota: iota,
	iprod: iprod,
	iquest: iquest$1,
	iscr: iscr,
	Iscr: Iscr,
	isin: isin,
	isindot: isindot,
	isinE: isinE,
	isins: isins,
	isinsv: isinsv,
	isinv: isinv,
	it: it,
	Itilde: Itilde,
	itilde: itilde,
	Iukcy: Iukcy,
	iukcy: iukcy,
	Iuml: Iuml$1,
	iuml: iuml$1,
	Jcirc: Jcirc,
	jcirc: jcirc,
	Jcy: Jcy,
	jcy: jcy,
	Jfr: Jfr,
	jfr: jfr,
	jmath: jmath,
	Jopf: Jopf,
	jopf: jopf,
	Jscr: Jscr,
	jscr: jscr,
	Jsercy: Jsercy,
	jsercy: jsercy,
	Jukcy: Jukcy,
	jukcy: jukcy,
	Kappa: Kappa,
	kappa: kappa,
	kappav: kappav,
	Kcedil: Kcedil,
	kcedil: kcedil,
	Kcy: Kcy,
	kcy: kcy,
	Kfr: Kfr,
	kfr: kfr,
	kgreen: kgreen,
	KHcy: KHcy,
	khcy: khcy,
	KJcy: KJcy,
	kjcy: kjcy,
	Kopf: Kopf,
	kopf: kopf,
	Kscr: Kscr,
	kscr: kscr,
	lAarr: lAarr,
	Lacute: Lacute,
	lacute: lacute,
	laemptyv: laemptyv,
	lagran: lagran,
	Lambda: Lambda,
	lambda: lambda,
	lang: lang,
	Lang: Lang,
	langd: langd,
	langle: langle,
	lap: lap,
	Laplacetrf: Laplacetrf,
	laquo: laquo$1,
	larrb: larrb,
	larrbfs: larrbfs,
	larr: larr,
	Larr: Larr,
	lArr: lArr,
	larrfs: larrfs,
	larrhk: larrhk,
	larrlp: larrlp,
	larrpl: larrpl,
	larrsim: larrsim,
	larrtl: larrtl,
	latail: latail,
	lAtail: lAtail,
	lat: lat,
	late: late,
	lates: lates,
	lbarr: lbarr,
	lBarr: lBarr,
	lbbrk: lbbrk,
	lbrace: lbrace,
	lbrack: lbrack,
	lbrke: lbrke,
	lbrksld: lbrksld,
	lbrkslu: lbrkslu,
	Lcaron: Lcaron,
	lcaron: lcaron,
	Lcedil: Lcedil,
	lcedil: lcedil,
	lceil: lceil,
	lcub: lcub,
	Lcy: Lcy,
	lcy: lcy,
	ldca: ldca,
	ldquo: ldquo,
	ldquor: ldquor,
	ldrdhar: ldrdhar,
	ldrushar: ldrushar,
	ldsh: ldsh,
	le: le,
	lE: lE,
	LeftAngleBracket: LeftAngleBracket,
	LeftArrowBar: LeftArrowBar,
	leftarrow: leftarrow,
	LeftArrow: LeftArrow,
	Leftarrow: Leftarrow,
	LeftArrowRightArrow: LeftArrowRightArrow,
	leftarrowtail: leftarrowtail,
	LeftCeiling: LeftCeiling,
	LeftDoubleBracket: LeftDoubleBracket,
	LeftDownTeeVector: LeftDownTeeVector,
	LeftDownVectorBar: LeftDownVectorBar,
	LeftDownVector: LeftDownVector,
	LeftFloor: LeftFloor,
	leftharpoondown: leftharpoondown,
	leftharpoonup: leftharpoonup,
	leftleftarrows: leftleftarrows,
	leftrightarrow: leftrightarrow,
	LeftRightArrow: LeftRightArrow,
	Leftrightarrow: Leftrightarrow,
	leftrightarrows: leftrightarrows,
	leftrightharpoons: leftrightharpoons,
	leftrightsquigarrow: leftrightsquigarrow,
	LeftRightVector: LeftRightVector,
	LeftTeeArrow: LeftTeeArrow,
	LeftTee: LeftTee,
	LeftTeeVector: LeftTeeVector,
	leftthreetimes: leftthreetimes,
	LeftTriangleBar: LeftTriangleBar,
	LeftTriangle: LeftTriangle,
	LeftTriangleEqual: LeftTriangleEqual,
	LeftUpDownVector: LeftUpDownVector,
	LeftUpTeeVector: LeftUpTeeVector,
	LeftUpVectorBar: LeftUpVectorBar,
	LeftUpVector: LeftUpVector,
	LeftVectorBar: LeftVectorBar,
	LeftVector: LeftVector,
	lEg: lEg,
	leg: leg,
	leq: leq,
	leqq: leqq,
	leqslant: leqslant,
	lescc: lescc,
	les: les,
	lesdot: lesdot,
	lesdoto: lesdoto,
	lesdotor: lesdotor,
	lesg: lesg,
	lesges: lesges,
	lessapprox: lessapprox,
	lessdot: lessdot,
	lesseqgtr: lesseqgtr,
	lesseqqgtr: lesseqqgtr,
	LessEqualGreater: LessEqualGreater,
	LessFullEqual: LessFullEqual,
	LessGreater: LessGreater,
	lessgtr: lessgtr,
	LessLess: LessLess,
	lesssim: lesssim,
	LessSlantEqual: LessSlantEqual,
	LessTilde: LessTilde,
	lfisht: lfisht,
	lfloor: lfloor,
	Lfr: Lfr,
	lfr: lfr,
	lg: lg,
	lgE: lgE,
	lHar: lHar,
	lhard: lhard,
	lharu: lharu,
	lharul: lharul,
	lhblk: lhblk,
	LJcy: LJcy,
	ljcy: ljcy,
	llarr: llarr,
	ll: ll,
	Ll: Ll,
	llcorner: llcorner,
	Lleftarrow: Lleftarrow,
	llhard: llhard,
	lltri: lltri,
	Lmidot: Lmidot,
	lmidot: lmidot,
	lmoustache: lmoustache,
	lmoust: lmoust,
	lnap: lnap,
	lnapprox: lnapprox,
	lne: lne,
	lnE: lnE,
	lneq: lneq,
	lneqq: lneqq,
	lnsim: lnsim,
	loang: loang,
	loarr: loarr,
	lobrk: lobrk,
	longleftarrow: longleftarrow,
	LongLeftArrow: LongLeftArrow,
	Longleftarrow: Longleftarrow,
	longleftrightarrow: longleftrightarrow,
	LongLeftRightArrow: LongLeftRightArrow,
	Longleftrightarrow: Longleftrightarrow,
	longmapsto: longmapsto,
	longrightarrow: longrightarrow,
	LongRightArrow: LongRightArrow,
	Longrightarrow: Longrightarrow,
	looparrowleft: looparrowleft,
	looparrowright: looparrowright,
	lopar: lopar,
	Lopf: Lopf,
	lopf: lopf,
	loplus: loplus,
	lotimes: lotimes,
	lowast: lowast,
	lowbar: lowbar,
	LowerLeftArrow: LowerLeftArrow,
	LowerRightArrow: LowerRightArrow,
	loz: loz,
	lozenge: lozenge,
	lozf: lozf,
	lpar: lpar,
	lparlt: lparlt,
	lrarr: lrarr,
	lrcorner: lrcorner,
	lrhar: lrhar,
	lrhard: lrhard,
	lrm: lrm,
	lrtri: lrtri,
	lsaquo: lsaquo,
	lscr: lscr,
	Lscr: Lscr,
	lsh: lsh,
	Lsh: Lsh,
	lsim: lsim,
	lsime: lsime,
	lsimg: lsimg,
	lsqb: lsqb,
	lsquo: lsquo,
	lsquor: lsquor,
	Lstrok: Lstrok,
	lstrok: lstrok,
	ltcc: ltcc,
	ltcir: ltcir,
	lt: lt$2,
	LT: LT$1,
	Lt: Lt,
	ltdot: ltdot,
	lthree: lthree,
	ltimes: ltimes,
	ltlarr: ltlarr,
	ltquest: ltquest,
	ltri: ltri,
	ltrie: ltrie,
	ltrif: ltrif,
	ltrPar: ltrPar,
	lurdshar: lurdshar,
	luruhar: luruhar,
	lvertneqq: lvertneqq,
	lvnE: lvnE,
	macr: macr$1,
	male: male,
	malt: malt,
	maltese: maltese,
	"Map": "⤅",
	map: map,
	mapsto: mapsto,
	mapstodown: mapstodown,
	mapstoleft: mapstoleft,
	mapstoup: mapstoup,
	marker: marker,
	mcomma: mcomma,
	Mcy: Mcy,
	mcy: mcy,
	mdash: mdash,
	mDDot: mDDot,
	measuredangle: measuredangle,
	MediumSpace: MediumSpace,
	Mellintrf: Mellintrf,
	Mfr: Mfr,
	mfr: mfr,
	mho: mho,
	micro: micro$1,
	midast: midast,
	midcir: midcir,
	mid: mid,
	middot: middot$1,
	minusb: minusb,
	minus: minus,
	minusd: minusd,
	minusdu: minusdu,
	MinusPlus: MinusPlus,
	mlcp: mlcp,
	mldr: mldr,
	mnplus: mnplus,
	models: models,
	Mopf: Mopf,
	mopf: mopf,
	mp: mp,
	mscr: mscr,
	Mscr: Mscr,
	mstpos: mstpos,
	Mu: Mu,
	mu: mu,
	multimap: multimap,
	mumap: mumap,
	nabla: nabla,
	Nacute: Nacute,
	nacute: nacute,
	nang: nang,
	nap: nap,
	napE: napE,
	napid: napid,
	napos: napos,
	napprox: napprox,
	natural: natural,
	naturals: naturals,
	natur: natur,
	nbsp: nbsp$1,
	nbump: nbump,
	nbumpe: nbumpe,
	ncap: ncap,
	Ncaron: Ncaron,
	ncaron: ncaron,
	Ncedil: Ncedil,
	ncedil: ncedil,
	ncong: ncong,
	ncongdot: ncongdot,
	ncup: ncup,
	Ncy: Ncy,
	ncy: ncy,
	ndash: ndash,
	nearhk: nearhk,
	nearr: nearr,
	neArr: neArr,
	nearrow: nearrow,
	ne: ne,
	nedot: nedot,
	NegativeMediumSpace: NegativeMediumSpace,
	NegativeThickSpace: NegativeThickSpace,
	NegativeThinSpace: NegativeThinSpace,
	NegativeVeryThinSpace: NegativeVeryThinSpace,
	nequiv: nequiv,
	nesear: nesear,
	nesim: nesim,
	NestedGreaterGreater: NestedGreaterGreater,
	NestedLessLess: NestedLessLess,
	NewLine: NewLine,
	nexist: nexist,
	nexists: nexists,
	Nfr: Nfr,
	nfr: nfr,
	ngE: ngE,
	nge: nge,
	ngeq: ngeq,
	ngeqq: ngeqq,
	ngeqslant: ngeqslant,
	nges: nges,
	nGg: nGg,
	ngsim: ngsim,
	nGt: nGt,
	ngt: ngt,
	ngtr: ngtr,
	nGtv: nGtv,
	nharr: nharr,
	nhArr: nhArr,
	nhpar: nhpar,
	ni: ni,
	nis: nis,
	nisd: nisd,
	niv: niv,
	NJcy: NJcy,
	njcy: njcy,
	nlarr: nlarr,
	nlArr: nlArr,
	nldr: nldr,
	nlE: nlE,
	nle: nle,
	nleftarrow: nleftarrow,
	nLeftarrow: nLeftarrow,
	nleftrightarrow: nleftrightarrow,
	nLeftrightarrow: nLeftrightarrow,
	nleq: nleq,
	nleqq: nleqq,
	nleqslant: nleqslant,
	nles: nles,
	nless: nless,
	nLl: nLl,
	nlsim: nlsim,
	nLt: nLt,
	nlt: nlt,
	nltri: nltri,
	nltrie: nltrie,
	nLtv: nLtv,
	nmid: nmid,
	NoBreak: NoBreak,
	NonBreakingSpace: NonBreakingSpace,
	nopf: nopf,
	Nopf: Nopf,
	Not: Not,
	not: not$1,
	NotCongruent: NotCongruent,
	NotCupCap: NotCupCap,
	NotDoubleVerticalBar: NotDoubleVerticalBar,
	NotElement: NotElement,
	NotEqual: NotEqual,
	NotEqualTilde: NotEqualTilde,
	NotExists: NotExists,
	NotGreater: NotGreater,
	NotGreaterEqual: NotGreaterEqual,
	NotGreaterFullEqual: NotGreaterFullEqual,
	NotGreaterGreater: NotGreaterGreater,
	NotGreaterLess: NotGreaterLess,
	NotGreaterSlantEqual: NotGreaterSlantEqual,
	NotGreaterTilde: NotGreaterTilde,
	NotHumpDownHump: NotHumpDownHump,
	NotHumpEqual: NotHumpEqual,
	notin: notin,
	notindot: notindot,
	notinE: notinE,
	notinva: notinva,
	notinvb: notinvb,
	notinvc: notinvc,
	NotLeftTriangleBar: NotLeftTriangleBar,
	NotLeftTriangle: NotLeftTriangle,
	NotLeftTriangleEqual: NotLeftTriangleEqual,
	NotLess: NotLess,
	NotLessEqual: NotLessEqual,
	NotLessGreater: NotLessGreater,
	NotLessLess: NotLessLess,
	NotLessSlantEqual: NotLessSlantEqual,
	NotLessTilde: NotLessTilde,
	NotNestedGreaterGreater: NotNestedGreaterGreater,
	NotNestedLessLess: NotNestedLessLess,
	notni: notni,
	notniva: notniva,
	notnivb: notnivb,
	notnivc: notnivc,
	NotPrecedes: NotPrecedes,
	NotPrecedesEqual: NotPrecedesEqual,
	NotPrecedesSlantEqual: NotPrecedesSlantEqual,
	NotReverseElement: NotReverseElement,
	NotRightTriangleBar: NotRightTriangleBar,
	NotRightTriangle: NotRightTriangle,
	NotRightTriangleEqual: NotRightTriangleEqual,
	NotSquareSubset: NotSquareSubset,
	NotSquareSubsetEqual: NotSquareSubsetEqual,
	NotSquareSuperset: NotSquareSuperset,
	NotSquareSupersetEqual: NotSquareSupersetEqual,
	NotSubset: NotSubset,
	NotSubsetEqual: NotSubsetEqual,
	NotSucceeds: NotSucceeds,
	NotSucceedsEqual: NotSucceedsEqual,
	NotSucceedsSlantEqual: NotSucceedsSlantEqual,
	NotSucceedsTilde: NotSucceedsTilde,
	NotSuperset: NotSuperset,
	NotSupersetEqual: NotSupersetEqual,
	NotTilde: NotTilde,
	NotTildeEqual: NotTildeEqual,
	NotTildeFullEqual: NotTildeFullEqual,
	NotTildeTilde: NotTildeTilde,
	NotVerticalBar: NotVerticalBar,
	nparallel: nparallel,
	npar: npar,
	nparsl: nparsl,
	npart: npart,
	npolint: npolint,
	npr: npr,
	nprcue: nprcue,
	nprec: nprec,
	npreceq: npreceq,
	npre: npre,
	nrarrc: nrarrc,
	nrarr: nrarr,
	nrArr: nrArr,
	nrarrw: nrarrw,
	nrightarrow: nrightarrow,
	nRightarrow: nRightarrow,
	nrtri: nrtri,
	nrtrie: nrtrie,
	nsc: nsc,
	nsccue: nsccue,
	nsce: nsce,
	Nscr: Nscr,
	nscr: nscr,
	nshortmid: nshortmid,
	nshortparallel: nshortparallel,
	nsim: nsim,
	nsime: nsime,
	nsimeq: nsimeq,
	nsmid: nsmid,
	nspar: nspar,
	nsqsube: nsqsube,
	nsqsupe: nsqsupe,
	nsub: nsub,
	nsubE: nsubE,
	nsube: nsube,
	nsubset: nsubset,
	nsubseteq: nsubseteq,
	nsubseteqq: nsubseteqq,
	nsucc: nsucc,
	nsucceq: nsucceq,
	nsup: nsup,
	nsupE: nsupE,
	nsupe: nsupe,
	nsupset: nsupset,
	nsupseteq: nsupseteq,
	nsupseteqq: nsupseteqq,
	ntgl: ntgl,
	Ntilde: Ntilde$1,
	ntilde: ntilde$1,
	ntlg: ntlg,
	ntriangleleft: ntriangleleft,
	ntrianglelefteq: ntrianglelefteq,
	ntriangleright: ntriangleright,
	ntrianglerighteq: ntrianglerighteq,
	Nu: Nu,
	nu: nu,
	num: num,
	numero: numero,
	numsp: numsp,
	nvap: nvap,
	nvdash: nvdash,
	nvDash: nvDash,
	nVdash: nVdash,
	nVDash: nVDash,
	nvge: nvge,
	nvgt: nvgt,
	nvHarr: nvHarr,
	nvinfin: nvinfin,
	nvlArr: nvlArr,
	nvle: nvle,
	nvlt: nvlt,
	nvltrie: nvltrie,
	nvrArr: nvrArr,
	nvrtrie: nvrtrie,
	nvsim: nvsim,
	nwarhk: nwarhk,
	nwarr: nwarr,
	nwArr: nwArr,
	nwarrow: nwarrow,
	nwnear: nwnear,
	Oacute: Oacute$1,
	oacute: oacute$1,
	oast: oast,
	Ocirc: Ocirc$1,
	ocirc: ocirc$1,
	ocir: ocir,
	Ocy: Ocy,
	ocy: ocy,
	odash: odash,
	Odblac: Odblac,
	odblac: odblac,
	odiv: odiv,
	odot: odot,
	odsold: odsold,
	OElig: OElig,
	oelig: oelig,
	ofcir: ofcir,
	Ofr: Ofr,
	ofr: ofr,
	ogon: ogon,
	Ograve: Ograve$1,
	ograve: ograve$1,
	ogt: ogt,
	ohbar: ohbar,
	ohm: ohm,
	oint: oint,
	olarr: olarr,
	olcir: olcir,
	olcross: olcross,
	oline: oline,
	olt: olt,
	Omacr: Omacr,
	omacr: omacr,
	Omega: Omega,
	omega: omega,
	Omicron: Omicron,
	omicron: omicron,
	omid: omid,
	ominus: ominus,
	Oopf: Oopf,
	oopf: oopf,
	opar: opar,
	OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
	OpenCurlyQuote: OpenCurlyQuote,
	operp: operp,
	oplus: oplus,
	orarr: orarr,
	Or: Or,
	or: or,
	ord: ord,
	order: order,
	orderof: orderof,
	ordf: ordf$1,
	ordm: ordm$1,
	origof: origof,
	oror: oror,
	orslope: orslope,
	orv: orv,
	oS: oS,
	Oscr: Oscr,
	oscr: oscr,
	Oslash: Oslash$1,
	oslash: oslash$1,
	osol: osol,
	Otilde: Otilde$1,
	otilde: otilde$1,
	otimesas: otimesas,
	Otimes: Otimes,
	otimes: otimes,
	Ouml: Ouml$1,
	ouml: ouml$1,
	ovbar: ovbar,
	OverBar: OverBar,
	OverBrace: OverBrace,
	OverBracket: OverBracket,
	OverParenthesis: OverParenthesis,
	para: para$1,
	parallel: parallel,
	par: par,
	parsim: parsim,
	parsl: parsl,
	part: part,
	PartialD: PartialD,
	Pcy: Pcy,
	pcy: pcy,
	percnt: percnt,
	period: period,
	permil: permil,
	perp: perp,
	pertenk: pertenk,
	Pfr: Pfr,
	pfr: pfr,
	Phi: Phi,
	phi: phi,
	phiv: phiv,
	phmmat: phmmat,
	phone: phone,
	Pi: Pi,
	pi: pi,
	pitchfork: pitchfork,
	piv: piv,
	planck: planck,
	planckh: planckh,
	plankv: plankv,
	plusacir: plusacir,
	plusb: plusb,
	pluscir: pluscir,
	plus: plus,
	plusdo: plusdo,
	plusdu: plusdu,
	pluse: pluse,
	PlusMinus: PlusMinus,
	plusmn: plusmn$1,
	plussim: plussim,
	plustwo: plustwo,
	pm: pm,
	Poincareplane: Poincareplane,
	pointint: pointint,
	popf: popf,
	Popf: Popf,
	pound: pound$1,
	prap: prap,
	Pr: Pr,
	pr: pr,
	prcue: prcue,
	precapprox: precapprox,
	prec: prec,
	preccurlyeq: preccurlyeq,
	Precedes: Precedes,
	PrecedesEqual: PrecedesEqual,
	PrecedesSlantEqual: PrecedesSlantEqual,
	PrecedesTilde: PrecedesTilde,
	preceq: preceq,
	precnapprox: precnapprox,
	precneqq: precneqq,
	precnsim: precnsim,
	pre: pre,
	prE: prE,
	precsim: precsim,
	prime: prime,
	Prime: Prime,
	primes: primes,
	prnap: prnap,
	prnE: prnE,
	prnsim: prnsim,
	prod: prod,
	Product: Product,
	profalar: profalar,
	profline: profline,
	profsurf: profsurf,
	prop: prop,
	Proportional: Proportional,
	Proportion: Proportion,
	propto: propto,
	prsim: prsim,
	prurel: prurel,
	Pscr: Pscr,
	pscr: pscr,
	Psi: Psi,
	psi: psi,
	puncsp: puncsp,
	Qfr: Qfr,
	qfr: qfr,
	qint: qint,
	qopf: qopf,
	Qopf: Qopf,
	qprime: qprime,
	Qscr: Qscr,
	qscr: qscr,
	quaternions: quaternions,
	quatint: quatint,
	quest: quest,
	questeq: questeq,
	quot: quot$2,
	QUOT: QUOT$1,
	rAarr: rAarr,
	race: race,
	Racute: Racute,
	racute: racute,
	radic: radic,
	raemptyv: raemptyv,
	rang: rang,
	Rang: Rang,
	rangd: rangd,
	range: range,
	rangle: rangle,
	raquo: raquo$1,
	rarrap: rarrap,
	rarrb: rarrb,
	rarrbfs: rarrbfs,
	rarrc: rarrc,
	rarr: rarr,
	Rarr: Rarr,
	rArr: rArr,
	rarrfs: rarrfs,
	rarrhk: rarrhk,
	rarrlp: rarrlp,
	rarrpl: rarrpl,
	rarrsim: rarrsim,
	Rarrtl: Rarrtl,
	rarrtl: rarrtl,
	rarrw: rarrw,
	ratail: ratail,
	rAtail: rAtail,
	ratio: ratio,
	rationals: rationals,
	rbarr: rbarr,
	rBarr: rBarr,
	RBarr: RBarr,
	rbbrk: rbbrk,
	rbrace: rbrace,
	rbrack: rbrack,
	rbrke: rbrke,
	rbrksld: rbrksld,
	rbrkslu: rbrkslu,
	Rcaron: Rcaron,
	rcaron: rcaron,
	Rcedil: Rcedil,
	rcedil: rcedil,
	rceil: rceil,
	rcub: rcub,
	Rcy: Rcy,
	rcy: rcy,
	rdca: rdca,
	rdldhar: rdldhar,
	rdquo: rdquo,
	rdquor: rdquor,
	rdsh: rdsh,
	real: real,
	realine: realine,
	realpart: realpart,
	reals: reals,
	Re: Re,
	rect: rect,
	reg: reg$1,
	REG: REG$1,
	ReverseElement: ReverseElement,
	ReverseEquilibrium: ReverseEquilibrium,
	ReverseUpEquilibrium: ReverseUpEquilibrium,
	rfisht: rfisht,
	rfloor: rfloor,
	rfr: rfr,
	Rfr: Rfr,
	rHar: rHar,
	rhard: rhard,
	rharu: rharu,
	rharul: rharul,
	Rho: Rho,
	rho: rho,
	rhov: rhov,
	RightAngleBracket: RightAngleBracket,
	RightArrowBar: RightArrowBar,
	rightarrow: rightarrow,
	RightArrow: RightArrow,
	Rightarrow: Rightarrow,
	RightArrowLeftArrow: RightArrowLeftArrow,
	rightarrowtail: rightarrowtail,
	RightCeiling: RightCeiling,
	RightDoubleBracket: RightDoubleBracket,
	RightDownTeeVector: RightDownTeeVector,
	RightDownVectorBar: RightDownVectorBar,
	RightDownVector: RightDownVector,
	RightFloor: RightFloor,
	rightharpoondown: rightharpoondown,
	rightharpoonup: rightharpoonup,
	rightleftarrows: rightleftarrows,
	rightleftharpoons: rightleftharpoons,
	rightrightarrows: rightrightarrows,
	rightsquigarrow: rightsquigarrow,
	RightTeeArrow: RightTeeArrow,
	RightTee: RightTee,
	RightTeeVector: RightTeeVector,
	rightthreetimes: rightthreetimes,
	RightTriangleBar: RightTriangleBar,
	RightTriangle: RightTriangle,
	RightTriangleEqual: RightTriangleEqual,
	RightUpDownVector: RightUpDownVector,
	RightUpTeeVector: RightUpTeeVector,
	RightUpVectorBar: RightUpVectorBar,
	RightUpVector: RightUpVector,
	RightVectorBar: RightVectorBar,
	RightVector: RightVector,
	ring: ring,
	risingdotseq: risingdotseq,
	rlarr: rlarr,
	rlhar: rlhar,
	rlm: rlm,
	rmoustache: rmoustache,
	rmoust: rmoust,
	rnmid: rnmid,
	roang: roang,
	roarr: roarr,
	robrk: robrk,
	ropar: ropar,
	ropf: ropf,
	Ropf: Ropf,
	roplus: roplus,
	rotimes: rotimes,
	RoundImplies: RoundImplies,
	rpar: rpar,
	rpargt: rpargt,
	rppolint: rppolint,
	rrarr: rrarr,
	Rrightarrow: Rrightarrow,
	rsaquo: rsaquo,
	rscr: rscr,
	Rscr: Rscr,
	rsh: rsh,
	Rsh: Rsh,
	rsqb: rsqb,
	rsquo: rsquo,
	rsquor: rsquor,
	rthree: rthree,
	rtimes: rtimes,
	rtri: rtri,
	rtrie: rtrie,
	rtrif: rtrif,
	rtriltri: rtriltri,
	RuleDelayed: RuleDelayed,
	ruluhar: ruluhar,
	rx: rx,
	Sacute: Sacute,
	sacute: sacute,
	sbquo: sbquo,
	scap: scap,
	Scaron: Scaron,
	scaron: scaron,
	Sc: Sc,
	sc: sc,
	sccue: sccue,
	sce: sce,
	scE: scE,
	Scedil: Scedil,
	scedil: scedil,
	Scirc: Scirc,
	scirc: scirc,
	scnap: scnap,
	scnE: scnE,
	scnsim: scnsim,
	scpolint: scpolint,
	scsim: scsim,
	Scy: Scy,
	scy: scy,
	sdotb: sdotb,
	sdot: sdot,
	sdote: sdote,
	searhk: searhk,
	searr: searr,
	seArr: seArr,
	searrow: searrow,
	sect: sect$1,
	semi: semi,
	seswar: seswar,
	setminus: setminus,
	setmn: setmn,
	sext: sext,
	Sfr: Sfr,
	sfr: sfr,
	sfrown: sfrown,
	sharp: sharp,
	SHCHcy: SHCHcy,
	shchcy: shchcy,
	SHcy: SHcy,
	shcy: shcy,
	ShortDownArrow: ShortDownArrow,
	ShortLeftArrow: ShortLeftArrow,
	shortmid: shortmid,
	shortparallel: shortparallel,
	ShortRightArrow: ShortRightArrow,
	ShortUpArrow: ShortUpArrow,
	shy: shy$1,
	Sigma: Sigma,
	sigma: sigma,
	sigmaf: sigmaf,
	sigmav: sigmav,
	sim: sim,
	simdot: simdot,
	sime: sime,
	simeq: simeq,
	simg: simg,
	simgE: simgE,
	siml: siml,
	simlE: simlE,
	simne: simne,
	simplus: simplus,
	simrarr: simrarr,
	slarr: slarr,
	SmallCircle: SmallCircle,
	smallsetminus: smallsetminus,
	smashp: smashp,
	smeparsl: smeparsl,
	smid: smid,
	smile: smile,
	smt: smt,
	smte: smte,
	smtes: smtes,
	SOFTcy: SOFTcy,
	softcy: softcy,
	solbar: solbar,
	solb: solb,
	sol: sol,
	Sopf: Sopf,
	sopf: sopf,
	spades: spades,
	spadesuit: spadesuit,
	spar: spar,
	sqcap: sqcap,
	sqcaps: sqcaps,
	sqcup: sqcup,
	sqcups: sqcups,
	Sqrt: Sqrt,
	sqsub: sqsub,
	sqsube: sqsube,
	sqsubset: sqsubset,
	sqsubseteq: sqsubseteq,
	sqsup: sqsup,
	sqsupe: sqsupe,
	sqsupset: sqsupset,
	sqsupseteq: sqsupseteq,
	square: square,
	Square: Square,
	SquareIntersection: SquareIntersection,
	SquareSubset: SquareSubset,
	SquareSubsetEqual: SquareSubsetEqual,
	SquareSuperset: SquareSuperset,
	SquareSupersetEqual: SquareSupersetEqual,
	SquareUnion: SquareUnion,
	squarf: squarf,
	squ: squ,
	squf: squf,
	srarr: srarr,
	Sscr: Sscr,
	sscr: sscr,
	ssetmn: ssetmn,
	ssmile: ssmile,
	sstarf: sstarf,
	Star: Star,
	star: star,
	starf: starf,
	straightepsilon: straightepsilon,
	straightphi: straightphi,
	strns: strns,
	sub: sub,
	Sub: Sub,
	subdot: subdot,
	subE: subE,
	sube: sube,
	subedot: subedot,
	submult: submult,
	subnE: subnE,
	subne: subne,
	subplus: subplus,
	subrarr: subrarr,
	subset: subset,
	Subset: Subset,
	subseteq: subseteq,
	subseteqq: subseteqq,
	SubsetEqual: SubsetEqual,
	subsetneq: subsetneq,
	subsetneqq: subsetneqq,
	subsim: subsim,
	subsub: subsub,
	subsup: subsup,
	succapprox: succapprox,
	succ: succ,
	succcurlyeq: succcurlyeq,
	Succeeds: Succeeds,
	SucceedsEqual: SucceedsEqual,
	SucceedsSlantEqual: SucceedsSlantEqual,
	SucceedsTilde: SucceedsTilde,
	succeq: succeq,
	succnapprox: succnapprox,
	succneqq: succneqq,
	succnsim: succnsim,
	succsim: succsim,
	SuchThat: SuchThat,
	sum: sum,
	Sum: Sum,
	sung: sung,
	sup1: sup1$1,
	sup2: sup2$1,
	sup3: sup3$1,
	sup: sup,
	Sup: Sup,
	supdot: supdot,
	supdsub: supdsub,
	supE: supE,
	supe: supe,
	supedot: supedot,
	Superset: Superset,
	SupersetEqual: SupersetEqual,
	suphsol: suphsol,
	suphsub: suphsub,
	suplarr: suplarr,
	supmult: supmult,
	supnE: supnE,
	supne: supne,
	supplus: supplus,
	supset: supset,
	Supset: Supset,
	supseteq: supseteq,
	supseteqq: supseteqq,
	supsetneq: supsetneq,
	supsetneqq: supsetneqq,
	supsim: supsim,
	supsub: supsub,
	supsup: supsup,
	swarhk: swarhk,
	swarr: swarr,
	swArr: swArr,
	swarrow: swarrow,
	swnwar: swnwar,
	szlig: szlig$1,
	Tab: Tab$2,
	target: target,
	Tau: Tau,
	tau: tau,
	tbrk: tbrk,
	Tcaron: Tcaron,
	tcaron: tcaron,
	Tcedil: Tcedil,
	tcedil: tcedil,
	Tcy: Tcy,
	tcy: tcy,
	tdot: tdot,
	telrec: telrec,
	Tfr: Tfr,
	tfr: tfr,
	there4: there4,
	therefore: therefore,
	Therefore: Therefore,
	Theta: Theta,
	theta: theta,
	thetasym: thetasym,
	thetav: thetav,
	thickapprox: thickapprox,
	thicksim: thicksim,
	ThickSpace: ThickSpace,
	ThinSpace: ThinSpace,
	thinsp: thinsp,
	thkap: thkap,
	thksim: thksim,
	THORN: THORN$1,
	thorn: thorn$1,
	tilde: tilde,
	Tilde: Tilde,
	TildeEqual: TildeEqual,
	TildeFullEqual: TildeFullEqual,
	TildeTilde: TildeTilde,
	timesbar: timesbar,
	timesb: timesb,
	times: times$1,
	timesd: timesd,
	tint: tint,
	toea: toea,
	topbot: topbot,
	topcir: topcir,
	top: top,
	Topf: Topf,
	topf: topf,
	topfork: topfork,
	tosa: tosa,
	tprime: tprime,
	trade: trade,
	TRADE: TRADE,
	triangle: triangle,
	triangledown: triangledown,
	triangleleft: triangleleft,
	trianglelefteq: trianglelefteq,
	triangleq: triangleq,
	triangleright: triangleright,
	trianglerighteq: trianglerighteq,
	tridot: tridot,
	trie: trie,
	triminus: triminus,
	TripleDot: TripleDot,
	triplus: triplus,
	trisb: trisb,
	tritime: tritime,
	trpezium: trpezium,
	Tscr: Tscr,
	tscr: tscr,
	TScy: TScy,
	tscy: tscy,
	TSHcy: TSHcy,
	tshcy: tshcy,
	Tstrok: Tstrok,
	tstrok: tstrok,
	twixt: twixt,
	twoheadleftarrow: twoheadleftarrow,
	twoheadrightarrow: twoheadrightarrow,
	Uacute: Uacute$1,
	uacute: uacute$1,
	uarr: uarr,
	Uarr: Uarr,
	uArr: uArr,
	Uarrocir: Uarrocir,
	Ubrcy: Ubrcy,
	ubrcy: ubrcy,
	Ubreve: Ubreve,
	ubreve: ubreve,
	Ucirc: Ucirc$1,
	ucirc: ucirc$1,
	Ucy: Ucy,
	ucy: ucy,
	udarr: udarr,
	Udblac: Udblac,
	udblac: udblac,
	udhar: udhar,
	ufisht: ufisht,
	Ufr: Ufr,
	ufr: ufr,
	Ugrave: Ugrave$1,
	ugrave: ugrave$1,
	uHar: uHar,
	uharl: uharl,
	uharr: uharr,
	uhblk: uhblk,
	ulcorn: ulcorn,
	ulcorner: ulcorner,
	ulcrop: ulcrop,
	ultri: ultri,
	Umacr: Umacr,
	umacr: umacr,
	uml: uml$1,
	UnderBar: UnderBar,
	UnderBrace: UnderBrace,
	UnderBracket: UnderBracket,
	UnderParenthesis: UnderParenthesis,
	Union: Union,
	UnionPlus: UnionPlus,
	Uogon: Uogon,
	uogon: uogon,
	Uopf: Uopf,
	uopf: uopf,
	UpArrowBar: UpArrowBar,
	uparrow: uparrow,
	UpArrow: UpArrow,
	Uparrow: Uparrow,
	UpArrowDownArrow: UpArrowDownArrow,
	updownarrow: updownarrow,
	UpDownArrow: UpDownArrow,
	Updownarrow: Updownarrow,
	UpEquilibrium: UpEquilibrium,
	upharpoonleft: upharpoonleft,
	upharpoonright: upharpoonright,
	uplus: uplus,
	UpperLeftArrow: UpperLeftArrow,
	UpperRightArrow: UpperRightArrow,
	upsi: upsi,
	Upsi: Upsi,
	upsih: upsih,
	Upsilon: Upsilon,
	upsilon: upsilon,
	UpTeeArrow: UpTeeArrow,
	UpTee: UpTee,
	upuparrows: upuparrows,
	urcorn: urcorn,
	urcorner: urcorner,
	urcrop: urcrop,
	Uring: Uring,
	uring: uring,
	urtri: urtri,
	Uscr: Uscr,
	uscr: uscr,
	utdot: utdot,
	Utilde: Utilde,
	utilde: utilde,
	utri: utri,
	utrif: utrif,
	uuarr: uuarr,
	Uuml: Uuml$1,
	uuml: uuml$1,
	uwangle: uwangle,
	vangrt: vangrt,
	varepsilon: varepsilon,
	varkappa: varkappa,
	varnothing: varnothing,
	varphi: varphi,
	varpi: varpi,
	varpropto: varpropto,
	varr: varr,
	vArr: vArr,
	varrho: varrho,
	varsigma: varsigma,
	varsubsetneq: varsubsetneq,
	varsubsetneqq: varsubsetneqq,
	varsupsetneq: varsupsetneq,
	varsupsetneqq: varsupsetneqq,
	vartheta: vartheta,
	vartriangleleft: vartriangleleft,
	vartriangleright: vartriangleright,
	vBar: vBar,
	Vbar: Vbar,
	vBarv: vBarv,
	Vcy: Vcy,
	vcy: vcy,
	vdash: vdash,
	vDash: vDash,
	Vdash: Vdash,
	VDash: VDash,
	Vdashl: Vdashl,
	veebar: veebar,
	vee: vee,
	Vee: Vee,
	veeeq: veeeq,
	vellip: vellip,
	verbar: verbar,
	Verbar: Verbar,
	vert: vert,
	Vert: Vert,
	VerticalBar: VerticalBar,
	VerticalLine: VerticalLine,
	VerticalSeparator: VerticalSeparator,
	VerticalTilde: VerticalTilde,
	VeryThinSpace: VeryThinSpace,
	Vfr: Vfr,
	vfr: vfr,
	vltri: vltri,
	vnsub: vnsub,
	vnsup: vnsup,
	Vopf: Vopf,
	vopf: vopf,
	vprop: vprop,
	vrtri: vrtri,
	Vscr: Vscr,
	vscr: vscr,
	vsubnE: vsubnE,
	vsubne: vsubne,
	vsupnE: vsupnE,
	vsupne: vsupne,
	Vvdash: Vvdash,
	vzigzag: vzigzag,
	Wcirc: Wcirc,
	wcirc: wcirc,
	wedbar: wedbar,
	wedge: wedge,
	Wedge: Wedge,
	wedgeq: wedgeq,
	weierp: weierp,
	Wfr: Wfr,
	wfr: wfr,
	Wopf: Wopf,
	wopf: wopf,
	wp: wp,
	wr: wr,
	wreath: wreath,
	Wscr: Wscr,
	wscr: wscr,
	xcap: xcap,
	xcirc: xcirc,
	xcup: xcup,
	xdtri: xdtri,
	Xfr: Xfr,
	xfr: xfr,
	xharr: xharr,
	xhArr: xhArr,
	Xi: Xi,
	xi: xi,
	xlarr: xlarr,
	xlArr: xlArr,
	xmap: xmap,
	xnis: xnis,
	xodot: xodot,
	Xopf: Xopf,
	xopf: xopf,
	xoplus: xoplus,
	xotime: xotime,
	xrarr: xrarr,
	xrArr: xrArr,
	Xscr: Xscr,
	xscr: xscr,
	xsqcup: xsqcup,
	xuplus: xuplus,
	xutri: xutri,
	xvee: xvee,
	xwedge: xwedge,
	Yacute: Yacute$1,
	yacute: yacute$1,
	YAcy: YAcy,
	yacy: yacy,
	Ycirc: Ycirc,
	ycirc: ycirc,
	Ycy: Ycy,
	ycy: ycy,
	yen: yen$1,
	Yfr: Yfr,
	yfr: yfr,
	YIcy: YIcy,
	yicy: yicy,
	Yopf: Yopf,
	yopf: yopf,
	Yscr: Yscr,
	yscr: yscr,
	YUcy: YUcy,
	yucy: yucy,
	yuml: yuml$1,
	Yuml: Yuml,
	Zacute: Zacute,
	zacute: zacute,
	Zcaron: Zcaron,
	zcaron: zcaron,
	Zcy: Zcy,
	zcy: zcy,
	Zdot: Zdot,
	zdot: zdot,
	zeetrf: zeetrf,
	ZeroWidthSpace: ZeroWidthSpace,
	Zeta: Zeta,
	zeta: zeta,
	zfr: zfr,
	Zfr: Zfr,
	ZHcy: ZHcy,
	zhcy: zhcy,
	zigrarr: zigrarr,
	zopf: zopf,
	Zopf: Zopf,
	Zscr: Zscr,
	zscr: zscr,
	zwj: zwj,
	zwnj: zwnj
};

var Aacute = "Á";
var aacute = "á";
var Acirc = "Â";
var acirc = "â";
var acute = "´";
var AElig = "Æ";
var aelig = "æ";
var Agrave = "À";
var agrave = "à";
var amp$1 = "&";
var AMP = "&";
var Aring = "Å";
var aring = "å";
var Atilde = "Ã";
var atilde = "ã";
var Auml = "Ä";
var auml = "ä";
var brvbar = "¦";
var Ccedil = "Ç";
var ccedil = "ç";
var cedil = "¸";
var cent = "¢";
var copy = "©";
var COPY = "©";
var curren = "¤";
var deg = "°";
var divide = "÷";
var Eacute = "É";
var eacute = "é";
var Ecirc = "Ê";
var ecirc = "ê";
var Egrave = "È";
var egrave = "è";
var ETH = "Ð";
var eth = "ð";
var Euml = "Ë";
var euml = "ë";
var frac12 = "½";
var frac14 = "¼";
var frac34 = "¾";
var gt$1 = ">";
var GT = ">";
var Iacute = "Í";
var iacute = "í";
var Icirc = "Î";
var icirc = "î";
var iexcl = "¡";
var Igrave = "Ì";
var igrave = "ì";
var iquest = "¿";
var Iuml = "Ï";
var iuml = "ï";
var laquo = "«";
var lt$1 = "<";
var LT = "<";
var macr = "¯";
var micro = "µ";
var middot = "·";
var nbsp = " ";
var not = "¬";
var Ntilde = "Ñ";
var ntilde = "ñ";
var Oacute = "Ó";
var oacute = "ó";
var Ocirc = "Ô";
var ocirc = "ô";
var Ograve = "Ò";
var ograve = "ò";
var ordf = "ª";
var ordm = "º";
var Oslash = "Ø";
var oslash = "ø";
var Otilde = "Õ";
var otilde = "õ";
var Ouml = "Ö";
var ouml = "ö";
var para = "¶";
var plusmn = "±";
var pound = "£";
var quot$1 = "\"";
var QUOT = "\"";
var raquo = "»";
var reg = "®";
var REG = "®";
var sect = "§";
var shy = "­";
var sup1 = "¹";
var sup2 = "²";
var sup3 = "³";
var szlig = "ß";
var THORN = "Þ";
var thorn = "þ";
var times = "×";
var Uacute = "Ú";
var uacute = "ú";
var Ucirc = "Û";
var ucirc = "û";
var Ugrave = "Ù";
var ugrave = "ù";
var uml = "¨";
var Uuml = "Ü";
var uuml = "ü";
var Yacute = "Ý";
var yacute = "ý";
var yen = "¥";
var yuml = "ÿ";
var require$$1 = {
	Aacute: Aacute,
	aacute: aacute,
	Acirc: Acirc,
	acirc: acirc,
	acute: acute,
	AElig: AElig,
	aelig: aelig,
	Agrave: Agrave,
	agrave: agrave,
	amp: amp$1,
	AMP: AMP,
	Aring: Aring,
	aring: aring,
	Atilde: Atilde,
	atilde: atilde,
	Auml: Auml,
	auml: auml,
	brvbar: brvbar,
	Ccedil: Ccedil,
	ccedil: ccedil,
	cedil: cedil,
	cent: cent,
	copy: copy,
	COPY: COPY,
	curren: curren,
	deg: deg,
	divide: divide,
	Eacute: Eacute,
	eacute: eacute,
	Ecirc: Ecirc,
	ecirc: ecirc,
	Egrave: Egrave,
	egrave: egrave,
	ETH: ETH,
	eth: eth,
	Euml: Euml,
	euml: euml,
	frac12: frac12,
	frac14: frac14,
	frac34: frac34,
	gt: gt$1,
	GT: GT,
	Iacute: Iacute,
	iacute: iacute,
	Icirc: Icirc,
	icirc: icirc,
	iexcl: iexcl,
	Igrave: Igrave,
	igrave: igrave,
	iquest: iquest,
	Iuml: Iuml,
	iuml: iuml,
	laquo: laquo,
	lt: lt$1,
	LT: LT,
	macr: macr,
	micro: micro,
	middot: middot,
	nbsp: nbsp,
	not: not,
	Ntilde: Ntilde,
	ntilde: ntilde,
	Oacute: Oacute,
	oacute: oacute,
	Ocirc: Ocirc,
	ocirc: ocirc,
	Ograve: Ograve,
	ograve: ograve,
	ordf: ordf,
	ordm: ordm,
	Oslash: Oslash,
	oslash: oslash,
	Otilde: Otilde,
	otilde: otilde,
	Ouml: Ouml,
	ouml: ouml,
	para: para,
	plusmn: plusmn,
	pound: pound,
	quot: quot$1,
	QUOT: QUOT,
	raquo: raquo,
	reg: reg,
	REG: REG,
	sect: sect,
	shy: shy,
	sup1: sup1,
	sup2: sup2,
	sup3: sup3,
	szlig: szlig,
	THORN: THORN,
	thorn: thorn,
	times: times,
	Uacute: Uacute,
	uacute: uacute,
	Ucirc: Ucirc,
	ucirc: ucirc,
	Ugrave: Ugrave,
	ugrave: ugrave,
	uml: uml,
	Uuml: Uuml,
	uuml: uuml,
	Yacute: Yacute,
	yacute: yacute,
	yen: yen,
	yuml: yuml
};

var amp = "&";
var apos = "'";
var gt = ">";
var lt = "<";
var quot = "\"";
var require$$0 = {
	amp: amp,
	apos: apos,
	gt: gt,
	lt: lt,
	quot: quot
};

var hasRequiredTokenizer;

function requireTokenizer () {
	if (hasRequiredTokenizer) return Tokenizer;
	hasRequiredTokenizer = 1;
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(Tokenizer, "__esModule", { value: true });
	var decode_codepoint_1 = __importDefault(requireDecode_codepoint());
	var entities_json_1 = __importDefault(require$$1$1);
	var legacy_json_1 = __importDefault(require$$1);
	var xml_json_1 = __importDefault(require$$0);
	function whitespace(c) {
	    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	function isASCIIAlpha(c) {
	    return (c >= "a" && c <= "z") || (c >= "A" && c <= "Z");
	}
	function ifElseState(upper, SUCCESS, FAILURE) {
	    var lower = upper.toLowerCase();
	    if (upper === lower) {
	        return function (t, c) {
	            if (c === lower) {
	                t._state = SUCCESS;
	            }
	            else {
	                t._state = FAILURE;
	                t._index--;
	            }
	        };
	    }
	    return function (t, c) {
	        if (c === lower || c === upper) {
	            t._state = SUCCESS;
	        }
	        else {
	            t._state = FAILURE;
	            t._index--;
	        }
	    };
	}
	function consumeSpecialNameChar(upper, NEXT_STATE) {
	    var lower = upper.toLowerCase();
	    return function (t, c) {
	        if (c === lower || c === upper) {
	            t._state = NEXT_STATE;
	        }
	        else {
	            t._state = 3 /* InTagName */;
	            t._index--; // Consume the token again
	        }
	    };
	}
	var stateBeforeCdata1 = ifElseState("C", 24 /* BeforeCdata2 */, 16 /* InDeclaration */);
	var stateBeforeCdata2 = ifElseState("D", 25 /* BeforeCdata3 */, 16 /* InDeclaration */);
	var stateBeforeCdata3 = ifElseState("A", 26 /* BeforeCdata4 */, 16 /* InDeclaration */);
	var stateBeforeCdata4 = ifElseState("T", 27 /* BeforeCdata5 */, 16 /* InDeclaration */);
	var stateBeforeCdata5 = ifElseState("A", 28 /* BeforeCdata6 */, 16 /* InDeclaration */);
	var stateBeforeScript1 = consumeSpecialNameChar("R", 35 /* BeforeScript2 */);
	var stateBeforeScript2 = consumeSpecialNameChar("I", 36 /* BeforeScript3 */);
	var stateBeforeScript3 = consumeSpecialNameChar("P", 37 /* BeforeScript4 */);
	var stateBeforeScript4 = consumeSpecialNameChar("T", 38 /* BeforeScript5 */);
	var stateAfterScript1 = ifElseState("R", 40 /* AfterScript2 */, 1 /* Text */);
	var stateAfterScript2 = ifElseState("I", 41 /* AfterScript3 */, 1 /* Text */);
	var stateAfterScript3 = ifElseState("P", 42 /* AfterScript4 */, 1 /* Text */);
	var stateAfterScript4 = ifElseState("T", 43 /* AfterScript5 */, 1 /* Text */);
	var stateBeforeStyle1 = consumeSpecialNameChar("Y", 45 /* BeforeStyle2 */);
	var stateBeforeStyle2 = consumeSpecialNameChar("L", 46 /* BeforeStyle3 */);
	var stateBeforeStyle3 = consumeSpecialNameChar("E", 47 /* BeforeStyle4 */);
	var stateAfterStyle1 = ifElseState("Y", 49 /* AfterStyle2 */, 1 /* Text */);
	var stateAfterStyle2 = ifElseState("L", 50 /* AfterStyle3 */, 1 /* Text */);
	var stateAfterStyle3 = ifElseState("E", 51 /* AfterStyle4 */, 1 /* Text */);
	var stateBeforeSpecialT = consumeSpecialNameChar("I", 54 /* BeforeTitle1 */);
	var stateBeforeTitle1 = consumeSpecialNameChar("T", 55 /* BeforeTitle2 */);
	var stateBeforeTitle2 = consumeSpecialNameChar("L", 56 /* BeforeTitle3 */);
	var stateBeforeTitle3 = consumeSpecialNameChar("E", 57 /* BeforeTitle4 */);
	var stateAfterSpecialTEnd = ifElseState("I", 58 /* AfterTitle1 */, 1 /* Text */);
	var stateAfterTitle1 = ifElseState("T", 59 /* AfterTitle2 */, 1 /* Text */);
	var stateAfterTitle2 = ifElseState("L", 60 /* AfterTitle3 */, 1 /* Text */);
	var stateAfterTitle3 = ifElseState("E", 61 /* AfterTitle4 */, 1 /* Text */);
	var stateBeforeEntity = ifElseState("#", 63 /* BeforeNumericEntity */, 64 /* InNamedEntity */);
	var stateBeforeNumericEntity = ifElseState("X", 66 /* InHexEntity */, 65 /* InNumericEntity */);
	var Tokenizer$1 = /** @class */ (function () {
	    function Tokenizer(options, cbs) {
	        var _a;
	        /** The current state the tokenizer is in. */
	        this._state = 1 /* Text */;
	        /** The read buffer. */
	        this.buffer = "";
	        /** The beginning of the section that is currently being read. */
	        this.sectionStart = 0;
	        /** The index within the buffer that we are currently looking at. */
	        this._index = 0;
	        /**
	         * Data that has already been processed will be removed from the buffer occasionally.
	         * `_bufferOffset` keeps track of how many characters have been removed, to make sure position information is accurate.
	         */
	        this.bufferOffset = 0;
	        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */
	        this.baseState = 1 /* Text */;
	        /** For special parsing behavior inside of script and style tags. */
	        this.special = 1 /* None */;
	        /** Indicates whether the tokenizer has been paused. */
	        this.running = true;
	        /** Indicates whether the tokenizer has finished running / `.end` has been called. */
	        this.ended = false;
	        this.cbs = cbs;
	        this.xmlMode = !!(options === null || options === void 0 ? void 0 : options.xmlMode);
	        this.decodeEntities = (_a = options === null || options === void 0 ? void 0 : options.decodeEntities) !== null && _a !== void 0 ? _a : true;
	    }
	    Tokenizer.prototype.reset = function () {
	        this._state = 1 /* Text */;
	        this.buffer = "";
	        this.sectionStart = 0;
	        this._index = 0;
	        this.bufferOffset = 0;
	        this.baseState = 1 /* Text */;
	        this.special = 1 /* None */;
	        this.running = true;
	        this.ended = false;
	    };
	    Tokenizer.prototype.write = function (chunk) {
	        if (this.ended)
	            this.cbs.onerror(Error(".write() after done!"));
	        this.buffer += chunk;
	        this.parse();
	    };
	    Tokenizer.prototype.end = function (chunk) {
	        if (this.ended)
	            this.cbs.onerror(Error(".end() after done!"));
	        if (chunk)
	            this.write(chunk);
	        this.ended = true;
	        if (this.running)
	            this.finish();
	    };
	    Tokenizer.prototype.pause = function () {
	        this.running = false;
	    };
	    Tokenizer.prototype.resume = function () {
	        this.running = true;
	        if (this._index < this.buffer.length) {
	            this.parse();
	        }
	        if (this.ended) {
	            this.finish();
	        }
	    };
	    /**
	     * The current index within all of the written data.
	     */
	    Tokenizer.prototype.getAbsoluteIndex = function () {
	        return this.bufferOffset + this._index;
	    };
	    Tokenizer.prototype.stateText = function (c) {
	        if (c === "<") {
	            if (this._index > this.sectionStart) {
	                this.cbs.ontext(this.getSection());
	            }
	            this._state = 2 /* BeforeTagName */;
	            this.sectionStart = this._index;
	        }
	        else if (this.decodeEntities &&
	            c === "&" &&
	            (this.special === 1 /* None */ || this.special === 4 /* Title */)) {
	            if (this._index > this.sectionStart) {
	                this.cbs.ontext(this.getSection());
	            }
	            this.baseState = 1 /* Text */;
	            this._state = 62 /* BeforeEntity */;
	            this.sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype.stateBeforeTagName = function (c) {
	        if (c === "/") {
	            this._state = 5 /* BeforeClosingTagName */;
	        }
	        else if (c === "<") {
	            this.cbs.ontext(this.getSection());
	            this.sectionStart = this._index;
	        }
	        else if (c === ">" ||
	            this.special !== 1 /* None */ ||
	            whitespace(c)) {
	            this._state = 1 /* Text */;
	        }
	        else if (c === "!") {
	            this._state = 15 /* BeforeDeclaration */;
	            this.sectionStart = this._index + 1;
	        }
	        else if (c === "?") {
	            this._state = 17 /* InProcessingInstruction */;
	            this.sectionStart = this._index + 1;
	        }
	        else if (!isASCIIAlpha(c)) {
	            this._state = 1 /* Text */;
	        }
	        else {
	            this._state =
	                !this.xmlMode && (c === "s" || c === "S")
	                    ? 32 /* BeforeSpecialS */
	                    : !this.xmlMode && (c === "t" || c === "T")
	                        ? 52 /* BeforeSpecialT */
	                        : 3 /* InTagName */;
	            this.sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype.stateInTagName = function (c) {
	        if (c === "/" || c === ">" || whitespace(c)) {
	            this.emitToken("onopentagname");
	            this._state = 8 /* BeforeAttributeName */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype.stateBeforeClosingTagName = function (c) {
	        if (whitespace(c)) ;
	        else if (c === ">") {
	            this._state = 1 /* Text */;
	        }
	        else if (this.special !== 1 /* None */) {
	            if (c === "s" || c === "S") {
	                this._state = 33 /* BeforeSpecialSEnd */;
	            }
	            else if (c === "t" || c === "T") {
	                this._state = 53 /* BeforeSpecialTEnd */;
	            }
	            else {
	                this._state = 1 /* Text */;
	                this._index--;
	            }
	        }
	        else if (!isASCIIAlpha(c)) {
	            this._state = 20 /* InSpecialComment */;
	            this.sectionStart = this._index;
	        }
	        else {
	            this._state = 6 /* InClosingTagName */;
	            this.sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype.stateInClosingTagName = function (c) {
	        if (c === ">" || whitespace(c)) {
	            this.emitToken("onclosetag");
	            this._state = 7 /* AfterClosingTagName */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype.stateAfterClosingTagName = function (c) {
	        // Skip everything until ">"
	        if (c === ">") {
	            this._state = 1 /* Text */;
	            this.sectionStart = this._index + 1;
	        }
	    };
	    Tokenizer.prototype.stateBeforeAttributeName = function (c) {
	        if (c === ">") {
	            this.cbs.onopentagend();
	            this._state = 1 /* Text */;
	            this.sectionStart = this._index + 1;
	        }
	        else if (c === "/") {
	            this._state = 4 /* InSelfClosingTag */;
	        }
	        else if (!whitespace(c)) {
	            this._state = 9 /* InAttributeName */;
	            this.sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype.stateInSelfClosingTag = function (c) {
	        if (c === ">") {
	            this.cbs.onselfclosingtag();
	            this._state = 1 /* Text */;
	            this.sectionStart = this._index + 1;
	            this.special = 1 /* None */; // Reset special state, in case of self-closing special tags
	        }
	        else if (!whitespace(c)) {
	            this._state = 8 /* BeforeAttributeName */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype.stateInAttributeName = function (c) {
	        if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
	            this.cbs.onattribname(this.getSection());
	            this.sectionStart = -1;
	            this._state = 10 /* AfterAttributeName */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype.stateAfterAttributeName = function (c) {
	        if (c === "=") {
	            this._state = 11 /* BeforeAttributeValue */;
	        }
	        else if (c === "/" || c === ">") {
	            this.cbs.onattribend(undefined);
	            this._state = 8 /* BeforeAttributeName */;
	            this._index--;
	        }
	        else if (!whitespace(c)) {
	            this.cbs.onattribend(undefined);
	            this._state = 9 /* InAttributeName */;
	            this.sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype.stateBeforeAttributeValue = function (c) {
	        if (c === '"') {
	            this._state = 12 /* InAttributeValueDq */;
	            this.sectionStart = this._index + 1;
	        }
	        else if (c === "'") {
	            this._state = 13 /* InAttributeValueSq */;
	            this.sectionStart = this._index + 1;
	        }
	        else if (!whitespace(c)) {
	            this._state = 14 /* InAttributeValueNq */;
	            this.sectionStart = this._index;
	            this._index--; // Reconsume token
	        }
	    };
	    Tokenizer.prototype.handleInAttributeValue = function (c, quote) {
	        if (c === quote) {
	            this.emitToken("onattribdata");
	            this.cbs.onattribend(quote);
	            this._state = 8 /* BeforeAttributeName */;
	        }
	        else if (this.decodeEntities && c === "&") {
	            this.emitToken("onattribdata");
	            this.baseState = this._state;
	            this._state = 62 /* BeforeEntity */;
	            this.sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function (c) {
	        this.handleInAttributeValue(c, '"');
	    };
	    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function (c) {
	        this.handleInAttributeValue(c, "'");
	    };
	    Tokenizer.prototype.stateInAttributeValueNoQuotes = function (c) {
	        if (whitespace(c) || c === ">") {
	            this.emitToken("onattribdata");
	            this.cbs.onattribend(null);
	            this._state = 8 /* BeforeAttributeName */;
	            this._index--;
	        }
	        else if (this.decodeEntities && c === "&") {
	            this.emitToken("onattribdata");
	            this.baseState = this._state;
	            this._state = 62 /* BeforeEntity */;
	            this.sectionStart = this._index;
	        }
	    };
	    Tokenizer.prototype.stateBeforeDeclaration = function (c) {
	        this._state =
	            c === "["
	                ? 23 /* BeforeCdata1 */
	                : c === "-"
	                    ? 18 /* BeforeComment */
	                    : 16 /* InDeclaration */;
	    };
	    Tokenizer.prototype.stateInDeclaration = function (c) {
	        if (c === ">") {
	            this.cbs.ondeclaration(this.getSection());
	            this._state = 1 /* Text */;
	            this.sectionStart = this._index + 1;
	        }
	    };
	    Tokenizer.prototype.stateInProcessingInstruction = function (c) {
	        if (c === ">") {
	            this.cbs.onprocessinginstruction(this.getSection());
	            this._state = 1 /* Text */;
	            this.sectionStart = this._index + 1;
	        }
	    };
	    Tokenizer.prototype.stateBeforeComment = function (c) {
	        if (c === "-") {
	            this._state = 19 /* InComment */;
	            this.sectionStart = this._index + 1;
	        }
	        else {
	            this._state = 16 /* InDeclaration */;
	        }
	    };
	    Tokenizer.prototype.stateInComment = function (c) {
	        if (c === "-")
	            this._state = 21 /* AfterComment1 */;
	    };
	    Tokenizer.prototype.stateInSpecialComment = function (c) {
	        if (c === ">") {
	            this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index));
	            this._state = 1 /* Text */;
	            this.sectionStart = this._index + 1;
	        }
	    };
	    Tokenizer.prototype.stateAfterComment1 = function (c) {
	        if (c === "-") {
	            this._state = 22 /* AfterComment2 */;
	        }
	        else {
	            this._state = 19 /* InComment */;
	        }
	    };
	    Tokenizer.prototype.stateAfterComment2 = function (c) {
	        if (c === ">") {
	            // Remove 2 trailing chars
	            this.cbs.oncomment(this.buffer.substring(this.sectionStart, this._index - 2));
	            this._state = 1 /* Text */;
	            this.sectionStart = this._index + 1;
	        }
	        else if (c !== "-") {
	            this._state = 19 /* InComment */;
	        }
	        // Else: stay in AFTER_COMMENT_2 (`--->`)
	    };
	    Tokenizer.prototype.stateBeforeCdata6 = function (c) {
	        if (c === "[") {
	            this._state = 29 /* InCdata */;
	            this.sectionStart = this._index + 1;
	        }
	        else {
	            this._state = 16 /* InDeclaration */;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype.stateInCdata = function (c) {
	        if (c === "]")
	            this._state = 30 /* AfterCdata1 */;
	    };
	    Tokenizer.prototype.stateAfterCdata1 = function (c) {
	        if (c === "]")
	            this._state = 31 /* AfterCdata2 */;
	        else
	            this._state = 29 /* InCdata */;
	    };
	    Tokenizer.prototype.stateAfterCdata2 = function (c) {
	        if (c === ">") {
	            // Remove 2 trailing chars
	            this.cbs.oncdata(this.buffer.substring(this.sectionStart, this._index - 2));
	            this._state = 1 /* Text */;
	            this.sectionStart = this._index + 1;
	        }
	        else if (c !== "]") {
	            this._state = 29 /* InCdata */;
	        }
	        // Else: stay in AFTER_CDATA_2 (`]]]>`)
	    };
	    Tokenizer.prototype.stateBeforeSpecialS = function (c) {
	        if (c === "c" || c === "C") {
	            this._state = 34 /* BeforeScript1 */;
	        }
	        else if (c === "t" || c === "T") {
	            this._state = 44 /* BeforeStyle1 */;
	        }
	        else {
	            this._state = 3 /* InTagName */;
	            this._index--; // Consume the token again
	        }
	    };
	    Tokenizer.prototype.stateBeforeSpecialSEnd = function (c) {
	        if (this.special === 2 /* Script */ && (c === "c" || c === "C")) {
	            this._state = 39 /* AfterScript1 */;
	        }
	        else if (this.special === 3 /* Style */ && (c === "t" || c === "T")) {
	            this._state = 48 /* AfterStyle1 */;
	        }
	        else
	            this._state = 1 /* Text */;
	    };
	    Tokenizer.prototype.stateBeforeSpecialLast = function (c, special) {
	        if (c === "/" || c === ">" || whitespace(c)) {
	            this.special = special;
	        }
	        this._state = 3 /* InTagName */;
	        this._index--; // Consume the token again
	    };
	    Tokenizer.prototype.stateAfterSpecialLast = function (c, sectionStartOffset) {
	        if (c === ">" || whitespace(c)) {
	            this.special = 1 /* None */;
	            this._state = 6 /* InClosingTagName */;
	            this.sectionStart = this._index - sectionStartOffset;
	            this._index--; // Reconsume the token
	        }
	        else
	            this._state = 1 /* Text */;
	    };
	    // For entities terminated with a semicolon
	    Tokenizer.prototype.parseFixedEntity = function (map) {
	        if (map === void 0) { map = this.xmlMode ? xml_json_1.default : entities_json_1.default; }
	        // Offset = 1
	        if (this.sectionStart + 1 < this._index) {
	            var entity = this.buffer.substring(this.sectionStart + 1, this._index);
	            if (Object.prototype.hasOwnProperty.call(map, entity)) {
	                this.emitPartial(map[entity]);
	                this.sectionStart = this._index + 1;
	            }
	        }
	    };
	    // Parses legacy entities (without trailing semicolon)
	    Tokenizer.prototype.parseLegacyEntity = function () {
	        var start = this.sectionStart + 1;
	        // The max length of legacy entities is 6
	        var limit = Math.min(this._index - start, 6);
	        while (limit >= 2) {
	            // The min length of legacy entities is 2
	            var entity = this.buffer.substr(start, limit);
	            if (Object.prototype.hasOwnProperty.call(legacy_json_1.default, entity)) {
	                this.emitPartial(legacy_json_1.default[entity]);
	                this.sectionStart += limit + 1;
	                return;
	            }
	            limit--;
	        }
	    };
	    Tokenizer.prototype.stateInNamedEntity = function (c) {
	        if (c === ";") {
	            this.parseFixedEntity();
	            // Retry as legacy entity if entity wasn't parsed
	            if (this.baseState === 1 /* Text */ &&
	                this.sectionStart + 1 < this._index &&
	                !this.xmlMode) {
	                this.parseLegacyEntity();
	            }
	            this._state = this.baseState;
	        }
	        else if ((c < "0" || c > "9") && !isASCIIAlpha(c)) {
	            if (this.xmlMode || this.sectionStart + 1 === this._index) ;
	            else if (this.baseState !== 1 /* Text */) {
	                if (c !== "=") {
	                    // Parse as legacy entity, without allowing additional characters.
	                    this.parseFixedEntity(legacy_json_1.default);
	                }
	            }
	            else {
	                this.parseLegacyEntity();
	            }
	            this._state = this.baseState;
	            this._index--;
	        }
	    };
	    Tokenizer.prototype.decodeNumericEntity = function (offset, base, strict) {
	        var sectionStart = this.sectionStart + offset;
	        if (sectionStart !== this._index) {
	            // Parse entity
	            var entity = this.buffer.substring(sectionStart, this._index);
	            var parsed = parseInt(entity, base);
	            this.emitPartial(decode_codepoint_1.default(parsed));
	            this.sectionStart = strict ? this._index + 1 : this._index;
	        }
	        this._state = this.baseState;
	    };
	    Tokenizer.prototype.stateInNumericEntity = function (c) {
	        if (c === ";") {
	            this.decodeNumericEntity(2, 10, true);
	        }
	        else if (c < "0" || c > "9") {
	            if (!this.xmlMode) {
	                this.decodeNumericEntity(2, 10, false);
	            }
	            else {
	                this._state = this.baseState;
	            }
	            this._index--;
	        }
	    };
	    Tokenizer.prototype.stateInHexEntity = function (c) {
	        if (c === ";") {
	            this.decodeNumericEntity(3, 16, true);
	        }
	        else if ((c < "a" || c > "f") &&
	            (c < "A" || c > "F") &&
	            (c < "0" || c > "9")) {
	            if (!this.xmlMode) {
	                this.decodeNumericEntity(3, 16, false);
	            }
	            else {
	                this._state = this.baseState;
	            }
	            this._index--;
	        }
	    };
	    Tokenizer.prototype.cleanup = function () {
	        if (this.sectionStart < 0) {
	            this.buffer = "";
	            this.bufferOffset += this._index;
	            this._index = 0;
	        }
	        else if (this.running) {
	            if (this._state === 1 /* Text */) {
	                if (this.sectionStart !== this._index) {
	                    this.cbs.ontext(this.buffer.substr(this.sectionStart));
	                }
	                this.buffer = "";
	                this.bufferOffset += this._index;
	                this._index = 0;
	            }
	            else if (this.sectionStart === this._index) {
	                // The section just started
	                this.buffer = "";
	                this.bufferOffset += this._index;
	                this._index = 0;
	            }
	            else {
	                // Remove everything unnecessary
	                this.buffer = this.buffer.substr(this.sectionStart);
	                this._index -= this.sectionStart;
	                this.bufferOffset += this.sectionStart;
	            }
	            this.sectionStart = 0;
	        }
	    };
	    /**
	     * Iterates through the buffer, calling the function corresponding to the current state.
	     *
	     * States that are more likely to be hit are higher up, as a performance improvement.
	     */
	    Tokenizer.prototype.parse = function () {
	        while (this._index < this.buffer.length && this.running) {
	            var c = this.buffer.charAt(this._index);
	            if (this._state === 1 /* Text */) {
	                this.stateText(c);
	            }
	            else if (this._state === 12 /* InAttributeValueDq */) {
	                this.stateInAttributeValueDoubleQuotes(c);
	            }
	            else if (this._state === 9 /* InAttributeName */) {
	                this.stateInAttributeName(c);
	            }
	            else if (this._state === 19 /* InComment */) {
	                this.stateInComment(c);
	            }
	            else if (this._state === 20 /* InSpecialComment */) {
	                this.stateInSpecialComment(c);
	            }
	            else if (this._state === 8 /* BeforeAttributeName */) {
	                this.stateBeforeAttributeName(c);
	            }
	            else if (this._state === 3 /* InTagName */) {
	                this.stateInTagName(c);
	            }
	            else if (this._state === 6 /* InClosingTagName */) {
	                this.stateInClosingTagName(c);
	            }
	            else if (this._state === 2 /* BeforeTagName */) {
	                this.stateBeforeTagName(c);
	            }
	            else if (this._state === 10 /* AfterAttributeName */) {
	                this.stateAfterAttributeName(c);
	            }
	            else if (this._state === 13 /* InAttributeValueSq */) {
	                this.stateInAttributeValueSingleQuotes(c);
	            }
	            else if (this._state === 11 /* BeforeAttributeValue */) {
	                this.stateBeforeAttributeValue(c);
	            }
	            else if (this._state === 5 /* BeforeClosingTagName */) {
	                this.stateBeforeClosingTagName(c);
	            }
	            else if (this._state === 7 /* AfterClosingTagName */) {
	                this.stateAfterClosingTagName(c);
	            }
	            else if (this._state === 32 /* BeforeSpecialS */) {
	                this.stateBeforeSpecialS(c);
	            }
	            else if (this._state === 21 /* AfterComment1 */) {
	                this.stateAfterComment1(c);
	            }
	            else if (this._state === 14 /* InAttributeValueNq */) {
	                this.stateInAttributeValueNoQuotes(c);
	            }
	            else if (this._state === 4 /* InSelfClosingTag */) {
	                this.stateInSelfClosingTag(c);
	            }
	            else if (this._state === 16 /* InDeclaration */) {
	                this.stateInDeclaration(c);
	            }
	            else if (this._state === 15 /* BeforeDeclaration */) {
	                this.stateBeforeDeclaration(c);
	            }
	            else if (this._state === 22 /* AfterComment2 */) {
	                this.stateAfterComment2(c);
	            }
	            else if (this._state === 18 /* BeforeComment */) {
	                this.stateBeforeComment(c);
	            }
	            else if (this._state === 33 /* BeforeSpecialSEnd */) {
	                this.stateBeforeSpecialSEnd(c);
	            }
	            else if (this._state === 53 /* BeforeSpecialTEnd */) {
	                stateAfterSpecialTEnd(this, c);
	            }
	            else if (this._state === 39 /* AfterScript1 */) {
	                stateAfterScript1(this, c);
	            }
	            else if (this._state === 40 /* AfterScript2 */) {
	                stateAfterScript2(this, c);
	            }
	            else if (this._state === 41 /* AfterScript3 */) {
	                stateAfterScript3(this, c);
	            }
	            else if (this._state === 34 /* BeforeScript1 */) {
	                stateBeforeScript1(this, c);
	            }
	            else if (this._state === 35 /* BeforeScript2 */) {
	                stateBeforeScript2(this, c);
	            }
	            else if (this._state === 36 /* BeforeScript3 */) {
	                stateBeforeScript3(this, c);
	            }
	            else if (this._state === 37 /* BeforeScript4 */) {
	                stateBeforeScript4(this, c);
	            }
	            else if (this._state === 38 /* BeforeScript5 */) {
	                this.stateBeforeSpecialLast(c, 2 /* Script */);
	            }
	            else if (this._state === 42 /* AfterScript4 */) {
	                stateAfterScript4(this, c);
	            }
	            else if (this._state === 43 /* AfterScript5 */) {
	                this.stateAfterSpecialLast(c, 6);
	            }
	            else if (this._state === 44 /* BeforeStyle1 */) {
	                stateBeforeStyle1(this, c);
	            }
	            else if (this._state === 29 /* InCdata */) {
	                this.stateInCdata(c);
	            }
	            else if (this._state === 45 /* BeforeStyle2 */) {
	                stateBeforeStyle2(this, c);
	            }
	            else if (this._state === 46 /* BeforeStyle3 */) {
	                stateBeforeStyle3(this, c);
	            }
	            else if (this._state === 47 /* BeforeStyle4 */) {
	                this.stateBeforeSpecialLast(c, 3 /* Style */);
	            }
	            else if (this._state === 48 /* AfterStyle1 */) {
	                stateAfterStyle1(this, c);
	            }
	            else if (this._state === 49 /* AfterStyle2 */) {
	                stateAfterStyle2(this, c);
	            }
	            else if (this._state === 50 /* AfterStyle3 */) {
	                stateAfterStyle3(this, c);
	            }
	            else if (this._state === 51 /* AfterStyle4 */) {
	                this.stateAfterSpecialLast(c, 5);
	            }
	            else if (this._state === 52 /* BeforeSpecialT */) {
	                stateBeforeSpecialT(this, c);
	            }
	            else if (this._state === 54 /* BeforeTitle1 */) {
	                stateBeforeTitle1(this, c);
	            }
	            else if (this._state === 55 /* BeforeTitle2 */) {
	                stateBeforeTitle2(this, c);
	            }
	            else if (this._state === 56 /* BeforeTitle3 */) {
	                stateBeforeTitle3(this, c);
	            }
	            else if (this._state === 57 /* BeforeTitle4 */) {
	                this.stateBeforeSpecialLast(c, 4 /* Title */);
	            }
	            else if (this._state === 58 /* AfterTitle1 */) {
	                stateAfterTitle1(this, c);
	            }
	            else if (this._state === 59 /* AfterTitle2 */) {
	                stateAfterTitle2(this, c);
	            }
	            else if (this._state === 60 /* AfterTitle3 */) {
	                stateAfterTitle3(this, c);
	            }
	            else if (this._state === 61 /* AfterTitle4 */) {
	                this.stateAfterSpecialLast(c, 5);
	            }
	            else if (this._state === 17 /* InProcessingInstruction */) {
	                this.stateInProcessingInstruction(c);
	            }
	            else if (this._state === 64 /* InNamedEntity */) {
	                this.stateInNamedEntity(c);
	            }
	            else if (this._state === 23 /* BeforeCdata1 */) {
	                stateBeforeCdata1(this, c);
	            }
	            else if (this._state === 62 /* BeforeEntity */) {
	                stateBeforeEntity(this, c);
	            }
	            else if (this._state === 24 /* BeforeCdata2 */) {
	                stateBeforeCdata2(this, c);
	            }
	            else if (this._state === 25 /* BeforeCdata3 */) {
	                stateBeforeCdata3(this, c);
	            }
	            else if (this._state === 30 /* AfterCdata1 */) {
	                this.stateAfterCdata1(c);
	            }
	            else if (this._state === 31 /* AfterCdata2 */) {
	                this.stateAfterCdata2(c);
	            }
	            else if (this._state === 26 /* BeforeCdata4 */) {
	                stateBeforeCdata4(this, c);
	            }
	            else if (this._state === 27 /* BeforeCdata5 */) {
	                stateBeforeCdata5(this, c);
	            }
	            else if (this._state === 28 /* BeforeCdata6 */) {
	                this.stateBeforeCdata6(c);
	            }
	            else if (this._state === 66 /* InHexEntity */) {
	                this.stateInHexEntity(c);
	            }
	            else if (this._state === 65 /* InNumericEntity */) {
	                this.stateInNumericEntity(c);
	                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	            }
	            else if (this._state === 63 /* BeforeNumericEntity */) {
	                stateBeforeNumericEntity(this, c);
	            }
	            else {
	                this.cbs.onerror(Error("unknown _state"), this._state);
	            }
	            this._index++;
	        }
	        this.cleanup();
	    };
	    Tokenizer.prototype.finish = function () {
	        // If there is remaining data, emit it in a reasonable way
	        if (this.sectionStart < this._index) {
	            this.handleTrailingData();
	        }
	        this.cbs.onend();
	    };
	    Tokenizer.prototype.handleTrailingData = function () {
	        var data = this.buffer.substr(this.sectionStart);
	        if (this._state === 29 /* InCdata */ ||
	            this._state === 30 /* AfterCdata1 */ ||
	            this._state === 31 /* AfterCdata2 */) {
	            this.cbs.oncdata(data);
	        }
	        else if (this._state === 19 /* InComment */ ||
	            this._state === 21 /* AfterComment1 */ ||
	            this._state === 22 /* AfterComment2 */) {
	            this.cbs.oncomment(data);
	        }
	        else if (this._state === 64 /* InNamedEntity */ && !this.xmlMode) {
	            this.parseLegacyEntity();
	            if (this.sectionStart < this._index) {
	                this._state = this.baseState;
	                this.handleTrailingData();
	            }
	        }
	        else if (this._state === 65 /* InNumericEntity */ && !this.xmlMode) {
	            this.decodeNumericEntity(2, 10, false);
	            if (this.sectionStart < this._index) {
	                this._state = this.baseState;
	                this.handleTrailingData();
	            }
	        }
	        else if (this._state === 66 /* InHexEntity */ && !this.xmlMode) {
	            this.decodeNumericEntity(3, 16, false);
	            if (this.sectionStart < this._index) {
	                this._state = this.baseState;
	                this.handleTrailingData();
	            }
	        }
	        else if (this._state !== 3 /* InTagName */ &&
	            this._state !== 8 /* BeforeAttributeName */ &&
	            this._state !== 11 /* BeforeAttributeValue */ &&
	            this._state !== 10 /* AfterAttributeName */ &&
	            this._state !== 9 /* InAttributeName */ &&
	            this._state !== 13 /* InAttributeValueSq */ &&
	            this._state !== 12 /* InAttributeValueDq */ &&
	            this._state !== 14 /* InAttributeValueNq */ &&
	            this._state !== 6 /* InClosingTagName */) {
	            this.cbs.ontext(data);
	        }
	        /*
	         * Else, ignore remaining data
	         * TODO add a way to remove current tag
	         */
	    };
	    Tokenizer.prototype.getSection = function () {
	        return this.buffer.substring(this.sectionStart, this._index);
	    };
	    Tokenizer.prototype.emitToken = function (name) {
	        this.cbs[name](this.getSection());
	        this.sectionStart = -1;
	    };
	    Tokenizer.prototype.emitPartial = function (value) {
	        if (this.baseState !== 1 /* Text */) {
	            this.cbs.onattribdata(value); // TODO implement the new event
	        }
	        else {
	            this.cbs.ontext(value);
	        }
	    };
	    return Tokenizer;
	}());
	Tokenizer.default = Tokenizer$1;
	return Tokenizer;
}

var hasRequiredParser$1;

function requireParser$1 () {
	if (hasRequiredParser$1) return Parser;
	hasRequiredParser$1 = 1;
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(Parser, "__esModule", { value: true });
	Parser.Parser = void 0;
	var Tokenizer_1 = __importDefault(requireTokenizer());
	var formTags = new Set([
	    "input",
	    "option",
	    "optgroup",
	    "select",
	    "button",
	    "datalist",
	    "textarea",
	]);
	var pTag = new Set(["p"]);
	var openImpliesClose = {
	    tr: new Set(["tr", "th", "td"]),
	    th: new Set(["th"]),
	    td: new Set(["thead", "th", "td"]),
	    body: new Set(["head", "link", "script"]),
	    li: new Set(["li"]),
	    p: pTag,
	    h1: pTag,
	    h2: pTag,
	    h3: pTag,
	    h4: pTag,
	    h5: pTag,
	    h6: pTag,
	    select: formTags,
	    input: formTags,
	    output: formTags,
	    button: formTags,
	    datalist: formTags,
	    textarea: formTags,
	    option: new Set(["option"]),
	    optgroup: new Set(["optgroup", "option"]),
	    dd: new Set(["dt", "dd"]),
	    dt: new Set(["dt", "dd"]),
	    address: pTag,
	    article: pTag,
	    aside: pTag,
	    blockquote: pTag,
	    details: pTag,
	    div: pTag,
	    dl: pTag,
	    fieldset: pTag,
	    figcaption: pTag,
	    figure: pTag,
	    footer: pTag,
	    form: pTag,
	    header: pTag,
	    hr: pTag,
	    main: pTag,
	    nav: pTag,
	    ol: pTag,
	    pre: pTag,
	    section: pTag,
	    table: pTag,
	    ul: pTag,
	    rt: new Set(["rt", "rp"]),
	    rp: new Set(["rt", "rp"]),
	    tbody: new Set(["thead", "tbody"]),
	    tfoot: new Set(["thead", "tbody"]),
	};
	var voidElements = new Set([
	    "area",
	    "base",
	    "basefont",
	    "br",
	    "col",
	    "command",
	    "embed",
	    "frame",
	    "hr",
	    "img",
	    "input",
	    "isindex",
	    "keygen",
	    "link",
	    "meta",
	    "param",
	    "source",
	    "track",
	    "wbr",
	]);
	var foreignContextElements = new Set(["math", "svg"]);
	var htmlIntegrationElements = new Set([
	    "mi",
	    "mo",
	    "mn",
	    "ms",
	    "mtext",
	    "annotation-xml",
	    "foreignObject",
	    "desc",
	    "title",
	]);
	var reNameEnd = /\s|\//;
	var Parser$1 = /** @class */ (function () {
	    function Parser(cbs, options) {
	        if (options === void 0) { options = {}; }
	        var _a, _b, _c, _d, _e;
	        /** The start index of the last event. */
	        this.startIndex = 0;
	        /** The end index of the last event. */
	        this.endIndex = null;
	        this.tagname = "";
	        this.attribname = "";
	        this.attribvalue = "";
	        this.attribs = null;
	        this.stack = [];
	        this.foreignContext = [];
	        this.options = options;
	        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
	        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
	        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
	        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_1.default)(this.options, this);
	        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
	    }
	    Parser.prototype.updatePosition = function (initialOffset) {
	        if (this.endIndex === null) {
	            if (this.tokenizer.sectionStart <= initialOffset) {
	                this.startIndex = 0;
	            }
	            else {
	                this.startIndex = this.tokenizer.sectionStart - initialOffset;
	            }
	        }
	        else {
	            this.startIndex = this.endIndex + 1;
	        }
	        this.endIndex = this.tokenizer.getAbsoluteIndex();
	    };
	    // Tokenizer event handlers
	    Parser.prototype.ontext = function (data) {
	        var _a, _b;
	        this.updatePosition(1);
	        this.endIndex--;
	        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
	    };
	    Parser.prototype.onopentagname = function (name) {
	        var _a, _b;
	        if (this.lowerCaseTagNames) {
	            name = name.toLowerCase();
	        }
	        this.tagname = name;
	        if (!this.options.xmlMode &&
	            Object.prototype.hasOwnProperty.call(openImpliesClose, name)) {
	            var el = void 0;
	            while (this.stack.length > 0 &&
	                openImpliesClose[name].has((el = this.stack[this.stack.length - 1]))) {
	                this.onclosetag(el);
	            }
	        }
	        if (this.options.xmlMode || !voidElements.has(name)) {
	            this.stack.push(name);
	            if (foreignContextElements.has(name)) {
	                this.foreignContext.push(true);
	            }
	            else if (htmlIntegrationElements.has(name)) {
	                this.foreignContext.push(false);
	            }
	        }
	        (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, name);
	        if (this.cbs.onopentag)
	            this.attribs = {};
	    };
	    Parser.prototype.onopentagend = function () {
	        var _a, _b;
	        this.updatePosition(1);
	        if (this.attribs) {
	            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs);
	            this.attribs = null;
	        }
	        if (!this.options.xmlMode &&
	            this.cbs.onclosetag &&
	            voidElements.has(this.tagname)) {
	            this.cbs.onclosetag(this.tagname);
	        }
	        this.tagname = "";
	    };
	    Parser.prototype.onclosetag = function (name) {
	        this.updatePosition(1);
	        if (this.lowerCaseTagNames) {
	            name = name.toLowerCase();
	        }
	        if (foreignContextElements.has(name) ||
	            htmlIntegrationElements.has(name)) {
	            this.foreignContext.pop();
	        }
	        if (this.stack.length &&
	            (this.options.xmlMode || !voidElements.has(name))) {
	            var pos = this.stack.lastIndexOf(name);
	            if (pos !== -1) {
	                if (this.cbs.onclosetag) {
	                    pos = this.stack.length - pos;
	                    while (pos--) {
	                        // We know the stack has sufficient elements.
	                        this.cbs.onclosetag(this.stack.pop());
	                    }
	                }
	                else
	                    this.stack.length = pos;
	            }
	            else if (name === "p" && !this.options.xmlMode) {
	                this.onopentagname(name);
	                this.closeCurrentTag();
	            }
	        }
	        else if (!this.options.xmlMode && (name === "br" || name === "p")) {
	            this.onopentagname(name);
	            this.closeCurrentTag();
	        }
	    };
	    Parser.prototype.onselfclosingtag = function () {
	        if (this.options.xmlMode ||
	            this.options.recognizeSelfClosing ||
	            this.foreignContext[this.foreignContext.length - 1]) {
	            this.closeCurrentTag();
	        }
	        else {
	            this.onopentagend();
	        }
	    };
	    Parser.prototype.closeCurrentTag = function () {
	        var _a, _b;
	        var name = this.tagname;
	        this.onopentagend();
	        /*
	         * Self-closing tags will be on the top of the stack
	         * (cheaper check than in onclosetag)
	         */
	        if (this.stack[this.stack.length - 1] === name) {
	            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name);
	            this.stack.pop();
	        }
	    };
	    Parser.prototype.onattribname = function (name) {
	        if (this.lowerCaseAttributeNames) {
	            name = name.toLowerCase();
	        }
	        this.attribname = name;
	    };
	    Parser.prototype.onattribdata = function (value) {
	        this.attribvalue += value;
	    };
	    Parser.prototype.onattribend = function (quote) {
	        var _a, _b;
	        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote);
	        if (this.attribs &&
	            !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
	            this.attribs[this.attribname] = this.attribvalue;
	        }
	        this.attribname = "";
	        this.attribvalue = "";
	    };
	    Parser.prototype.getInstructionName = function (value) {
	        var idx = value.search(reNameEnd);
	        var name = idx < 0 ? value : value.substr(0, idx);
	        if (this.lowerCaseTagNames) {
	            name = name.toLowerCase();
	        }
	        return name;
	    };
	    Parser.prototype.ondeclaration = function (value) {
	        if (this.cbs.onprocessinginstruction) {
	            var name_1 = this.getInstructionName(value);
	            this.cbs.onprocessinginstruction("!" + name_1, "!" + value);
	        }
	    };
	    Parser.prototype.onprocessinginstruction = function (value) {
	        if (this.cbs.onprocessinginstruction) {
	            var name_2 = this.getInstructionName(value);
	            this.cbs.onprocessinginstruction("?" + name_2, "?" + value);
	        }
	    };
	    Parser.prototype.oncomment = function (value) {
	        var _a, _b, _c, _d;
	        this.updatePosition(4);
	        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, value);
	        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
	    };
	    Parser.prototype.oncdata = function (value) {
	        var _a, _b, _c, _d, _e, _f;
	        this.updatePosition(1);
	        if (this.options.xmlMode || this.options.recognizeCDATA) {
	            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
	            (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
	            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
	        }
	        else {
	            this.oncomment("[CDATA[" + value + "]]");
	        }
	    };
	    Parser.prototype.onerror = function (err) {
	        var _a, _b;
	        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, err);
	    };
	    Parser.prototype.onend = function () {
	        var _a, _b;
	        if (this.cbs.onclosetag) {
	            for (var i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i]))
	                ;
	        }
	        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
	    };
	    /**
	     * Resets the parser to a blank state, ready to parse a new HTML document
	     */
	    Parser.prototype.reset = function () {
	        var _a, _b, _c, _d;
	        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
	        this.tokenizer.reset();
	        this.tagname = "";
	        this.attribname = "";
	        this.attribs = null;
	        this.stack = [];
	        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
	    };
	    /**
	     * Resets the parser, then parses a complete document and
	     * pushes it to the handler.
	     *
	     * @param data Document to parse.
	     */
	    Parser.prototype.parseComplete = function (data) {
	        this.reset();
	        this.end(data);
	    };
	    /**
	     * Parses a chunk of data and calls the corresponding callbacks.
	     *
	     * @param chunk Chunk to parse.
	     */
	    Parser.prototype.write = function (chunk) {
	        this.tokenizer.write(chunk);
	    };
	    /**
	     * Parses the end of the buffer and clears the stack, calls onend.
	     *
	     * @param chunk Optional final chunk to parse.
	     */
	    Parser.prototype.end = function (chunk) {
	        this.tokenizer.end(chunk);
	    };
	    /**
	     * Pauses parsing. The parser won't emit events until `resume` is called.
	     */
	    Parser.prototype.pause = function () {
	        this.tokenizer.pause();
	    };
	    /**
	     * Resumes parsing after `pause` was called.
	     */
	    Parser.prototype.resume = function () {
	        this.tokenizer.resume();
	    };
	    /**
	     * Alias of `write`, for backwards compatibility.
	     *
	     * @param chunk Chunk to parse.
	     * @deprecated
	     */
	    Parser.prototype.parseChunk = function (chunk) {
	        this.write(chunk);
	    };
	    /**
	     * Alias of `end`, for backwards compatibility.
	     *
	     * @param chunk Optional final chunk to parse.
	     * @deprecated
	     */
	    Parser.prototype.done = function (chunk) {
	        this.end(chunk);
	    };
	    return Parser;
	}());
	Parser.Parser = Parser$1;
	return Parser;
}

var lib$4 = {};

var node$1 = {};

var hasRequiredNode$1;

function requireNode$1 () {
	if (hasRequiredNode$1) return node$1;
	hasRequiredNode$1 = 1;
	var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(node$1, "__esModule", { value: true });
	node$1.cloneNode = node$1.Element = node$1.Document = node$1.NodeWithChildren = node$1.ProcessingInstruction = node$1.Comment = node$1.Text = node$1.DataNode = node$1.Node = void 0;
	var nodeTypes = new Map([
	    ["tag" /* Tag */, 1],
	    ["script" /* Script */, 1],
	    ["style" /* Style */, 1],
	    ["directive" /* Directive */, 1],
	    ["text" /* Text */, 3],
	    ["cdata" /* CDATA */, 4],
	    ["comment" /* Comment */, 8],
	    ["root" /* Root */, 9],
	]);
	/**
	 * This object will be used as the prototype for Nodes when creating a
	 * DOM-Level-1-compliant structure.
	 */
	var Node = /** @class */ (function () {
	    /**
	     *
	     * @param type The type of the node.
	     */
	    function Node(type) {
	        this.type = type;
	        /** Parent of the node */
	        this.parent = null;
	        /** Previous sibling */
	        this.prev = null;
	        /** Next sibling */
	        this.next = null;
	        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
	        this.startIndex = null;
	        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
	        this.endIndex = null;
	    }
	    Object.defineProperty(Node.prototype, "nodeType", {
	        // Read-only aliases
	        get: function () {
	            var _a;
	            return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "parentNode", {
	        // Read-write aliases for properties
	        get: function () {
	            return this.parent;
	        },
	        set: function (parent) {
	            this.parent = parent;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "previousSibling", {
	        get: function () {
	            return this.prev;
	        },
	        set: function (prev) {
	            this.prev = prev;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Node.prototype, "nextSibling", {
	        get: function () {
	            return this.next;
	        },
	        set: function (next) {
	            this.next = next;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Clone this node, and optionally its children.
	     *
	     * @param recursive Clone child nodes as well.
	     * @returns A clone of the node.
	     */
	    Node.prototype.cloneNode = function (recursive) {
	        if (recursive === void 0) { recursive = false; }
	        return cloneNode(this, recursive);
	    };
	    return Node;
	}());
	node$1.Node = Node;
	var DataNode = /** @class */ (function (_super) {
	    __extends(DataNode, _super);
	    /**
	     * @param type The type of the node
	     * @param data The content of the data node
	     */
	    function DataNode(type, data) {
	        var _this = _super.call(this, type) || this;
	        _this.data = data;
	        return _this;
	    }
	    Object.defineProperty(DataNode.prototype, "nodeValue", {
	        get: function () {
	            return this.data;
	        },
	        set: function (data) {
	            this.data = data;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return DataNode;
	}(Node));
	node$1.DataNode = DataNode;
	var Text = /** @class */ (function (_super) {
	    __extends(Text, _super);
	    function Text(data) {
	        return _super.call(this, "text" /* Text */, data) || this;
	    }
	    return Text;
	}(DataNode));
	node$1.Text = Text;
	var Comment = /** @class */ (function (_super) {
	    __extends(Comment, _super);
	    function Comment(data) {
	        return _super.call(this, "comment" /* Comment */, data) || this;
	    }
	    return Comment;
	}(DataNode));
	node$1.Comment = Comment;
	var ProcessingInstruction = /** @class */ (function (_super) {
	    __extends(ProcessingInstruction, _super);
	    function ProcessingInstruction(name, data) {
	        var _this = _super.call(this, "directive" /* Directive */, data) || this;
	        _this.name = name;
	        return _this;
	    }
	    return ProcessingInstruction;
	}(DataNode));
	node$1.ProcessingInstruction = ProcessingInstruction;
	/**
	 * A `Node` that can have children.
	 */
	var NodeWithChildren = /** @class */ (function (_super) {
	    __extends(NodeWithChildren, _super);
	    /**
	     * @param type Type of the node.
	     * @param children Children of the node. Only certain node types can have children.
	     */
	    function NodeWithChildren(type, children) {
	        var _this = _super.call(this, type) || this;
	        _this.children = children;
	        return _this;
	    }
	    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
	        // Aliases
	        get: function () {
	            var _a;
	            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
	        get: function () {
	            return this.children.length > 0
	                ? this.children[this.children.length - 1]
	                : null;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
	        get: function () {
	            return this.children;
	        },
	        set: function (children) {
	            this.children = children;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return NodeWithChildren;
	}(Node));
	node$1.NodeWithChildren = NodeWithChildren;
	var Document = /** @class */ (function (_super) {
	    __extends(Document, _super);
	    function Document(children) {
	        return _super.call(this, "root" /* Root */, children) || this;
	    }
	    return Document;
	}(NodeWithChildren));
	node$1.Document = Document;
	var Element = /** @class */ (function (_super) {
	    __extends(Element, _super);
	    /**
	     * @param name Name of the tag, eg. `div`, `span`.
	     * @param attribs Object mapping attribute names to attribute values.
	     * @param children Children of the node.
	     */
	    function Element(name, attribs, children) {
	        if (children === void 0) { children = []; }
	        var _this = _super.call(this, name === "script"
	            ? "script" /* Script */
	            : name === "style"
	                ? "style" /* Style */
	                : "tag" /* Tag */, children) || this;
	        _this.name = name;
	        _this.attribs = attribs;
	        _this.attribs = attribs;
	        return _this;
	    }
	    Object.defineProperty(Element.prototype, "tagName", {
	        // DOM Level 1 aliases
	        get: function () {
	            return this.name;
	        },
	        set: function (name) {
	            this.name = name;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Element.prototype, "attributes", {
	        get: function () {
	            var _this = this;
	            return Object.keys(this.attribs).map(function (name) {
	                var _a, _b;
	                return ({
	                    name: name,
	                    value: _this.attribs[name],
	                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
	                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
	                });
	            });
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Element;
	}(NodeWithChildren));
	node$1.Element = Element;
	/**
	 * Clone a node, and optionally its children.
	 *
	 * @param recursive Clone child nodes as well.
	 * @returns A clone of the node.
	 */
	function cloneNode(node, recursive) {
	    if (recursive === void 0) { recursive = false; }
	    var result;
	    switch (node.type) {
	        case "text" /* Text */:
	            result = new Text(node.data);
	            break;
	        case "directive" /* Directive */: {
	            var instr = node;
	            result = new ProcessingInstruction(instr.name, instr.data);
	            if (instr["x-name"] != null) {
	                result["x-name"] = instr["x-name"];
	                result["x-publicId"] = instr["x-publicId"];
	                result["x-systemId"] = instr["x-systemId"];
	            }
	            break;
	        }
	        case "comment" /* Comment */:
	            result = new Comment(node.data);
	            break;
	        case "tag" /* Tag */:
	        case "script" /* Script */:
	        case "style" /* Style */: {
	            var elem = node;
	            var children = recursive ? cloneChildren(elem.children) : [];
	            var clone_1 = new Element(elem.name, __assign({}, elem.attribs), children);
	            children.forEach(function (child) { return (child.parent = clone_1); });
	            if (elem["x-attribsNamespace"]) {
	                clone_1["x-attribsNamespace"] = __assign({}, elem["x-attribsNamespace"]);
	            }
	            if (elem["x-attribsPrefix"]) {
	                clone_1["x-attribsPrefix"] = __assign({}, elem["x-attribsPrefix"]);
	            }
	            result = clone_1;
	            break;
	        }
	        case "cdata" /* CDATA */: {
	            var cdata = node;
	            var children = recursive ? cloneChildren(cdata.children) : [];
	            var clone_2 = new NodeWithChildren(node.type, children);
	            children.forEach(function (child) { return (child.parent = clone_2); });
	            result = clone_2;
	            break;
	        }
	        case "root" /* Root */: {
	            var doc = node;
	            var children = recursive ? cloneChildren(doc.children) : [];
	            var clone_3 = new Document(children);
	            children.forEach(function (child) { return (child.parent = clone_3); });
	            if (doc["x-mode"]) {
	                clone_3["x-mode"] = doc["x-mode"];
	            }
	            result = clone_3;
	            break;
	        }
	        case "doctype" /* Doctype */: {
	            // This type isn't used yet.
	            throw new Error("Not implemented yet: ElementType.Doctype case");
	        }
	    }
	    result.startIndex = node.startIndex;
	    result.endIndex = node.endIndex;
	    return result;
	}
	node$1.cloneNode = cloneNode;
	function cloneChildren(childs) {
	    var children = childs.map(function (child) { return cloneNode(child, true); });
	    for (var i = 1; i < children.length; i++) {
	        children[i].prev = children[i - 1];
	        children[i - 1].next = children[i];
	    }
	    return children;
	}
	return node$1;
}

var hasRequiredLib$5;

function requireLib$5 () {
	if (hasRequiredLib$5) return lib$4;
	hasRequiredLib$5 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.DomHandler = void 0;
		var node_1 = requireNode$1();
		__exportStar(requireNode$1(), exports);
		var reWhitespace = /\s+/g;
		// Default options
		var defaultOpts = {
		    normalizeWhitespace: false,
		    withStartIndices: false,
		    withEndIndices: false,
		};
		var DomHandler = /** @class */ (function () {
		    /**
		     * @param callback Called once parsing has completed.
		     * @param options Settings for the handler.
		     * @param elementCB Callback whenever a tag is closed.
		     */
		    function DomHandler(callback, options, elementCB) {
		        /** The elements of the DOM */
		        this.dom = [];
		        /** The root element for the DOM */
		        this.root = new node_1.Document(this.dom);
		        /** Indicated whether parsing has been completed. */
		        this.done = false;
		        /** Stack of open tags. */
		        this.tagStack = [this.root];
		        /** A data node that is still being written to. */
		        this.lastNode = null;
		        /** Reference to the parser instance. Used for location information. */
		        this.parser = null;
		        // Make it possible to skip arguments, for backwards-compatibility
		        if (typeof options === "function") {
		            elementCB = options;
		            options = defaultOpts;
		        }
		        if (typeof callback === "object") {
		            options = callback;
		            callback = undefined;
		        }
		        this.callback = callback !== null && callback !== void 0 ? callback : null;
		        this.options = options !== null && options !== void 0 ? options : defaultOpts;
		        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
		    }
		    DomHandler.prototype.onparserinit = function (parser) {
		        this.parser = parser;
		    };
		    // Resets the handler back to starting state
		    DomHandler.prototype.onreset = function () {
		        var _a;
		        this.dom = [];
		        this.root = new node_1.Document(this.dom);
		        this.done = false;
		        this.tagStack = [this.root];
		        this.lastNode = null;
		        this.parser = (_a = this.parser) !== null && _a !== void 0 ? _a : null;
		    };
		    // Signals the handler that parsing is done
		    DomHandler.prototype.onend = function () {
		        if (this.done)
		            return;
		        this.done = true;
		        this.parser = null;
		        this.handleCallback(null);
		    };
		    DomHandler.prototype.onerror = function (error) {
		        this.handleCallback(error);
		    };
		    DomHandler.prototype.onclosetag = function () {
		        this.lastNode = null;
		        var elem = this.tagStack.pop();
		        if (this.options.withEndIndices) {
		            elem.endIndex = this.parser.endIndex;
		        }
		        if (this.elementCB)
		            this.elementCB(elem);
		    };
		    DomHandler.prototype.onopentag = function (name, attribs) {
		        var element = new node_1.Element(name, attribs);
		        this.addNode(element);
		        this.tagStack.push(element);
		    };
		    DomHandler.prototype.ontext = function (data) {
		        var normalizeWhitespace = this.options.normalizeWhitespace;
		        var lastNode = this.lastNode;
		        if (lastNode && lastNode.type === "text" /* Text */) {
		            if (normalizeWhitespace) {
		                lastNode.data = (lastNode.data + data).replace(reWhitespace, " ");
		            }
		            else {
		                lastNode.data += data;
		            }
		        }
		        else {
		            if (normalizeWhitespace) {
		                data = data.replace(reWhitespace, " ");
		            }
		            var node = new node_1.Text(data);
		            this.addNode(node);
		            this.lastNode = node;
		        }
		    };
		    DomHandler.prototype.oncomment = function (data) {
		        if (this.lastNode && this.lastNode.type === "comment" /* Comment */) {
		            this.lastNode.data += data;
		            return;
		        }
		        var node = new node_1.Comment(data);
		        this.addNode(node);
		        this.lastNode = node;
		    };
		    DomHandler.prototype.oncommentend = function () {
		        this.lastNode = null;
		    };
		    DomHandler.prototype.oncdatastart = function () {
		        var text = new node_1.Text("");
		        var node = new node_1.NodeWithChildren("cdata" /* CDATA */, [text]);
		        this.addNode(node);
		        text.parent = node;
		        this.lastNode = text;
		    };
		    DomHandler.prototype.oncdataend = function () {
		        this.lastNode = null;
		    };
		    DomHandler.prototype.onprocessinginstruction = function (name, data) {
		        var node = new node_1.ProcessingInstruction(name, data);
		        this.addNode(node);
		    };
		    DomHandler.prototype.handleCallback = function (error) {
		        if (typeof this.callback === "function") {
		            this.callback(error, this.dom);
		        }
		        else if (error) {
		            throw error;
		        }
		    };
		    DomHandler.prototype.addNode = function (node) {
		        var parent = this.tagStack[this.tagStack.length - 1];
		        var previousSibling = parent.children[parent.children.length - 1];
		        if (this.options.withStartIndices) {
		            node.startIndex = this.parser.startIndex;
		        }
		        if (this.options.withEndIndices) {
		            node.endIndex = this.parser.endIndex;
		        }
		        parent.children.push(node);
		        if (previousSibling) {
		            node.prev = previousSibling;
		            previousSibling.next = node;
		        }
		        node.parent = parent;
		        this.lastNode = null;
		    };
		    DomHandler.prototype.addDataNode = function (node) {
		        this.addNode(node);
		        this.lastNode = node;
		    };
		    return DomHandler;
		}());
		exports.DomHandler = DomHandler;
		exports.default = DomHandler;
} (lib$4));
	return lib$4;
}

var lib$3 = {};

var hasRequiredLib$4;

function requireLib$4 () {
	if (hasRequiredLib$4) return lib$3;
	hasRequiredLib$4 = 1;
	Object.defineProperty(lib$3, "__esModule", { value: true });
	lib$3.Doctype = lib$3.CDATA = lib$3.Tag = lib$3.Style = lib$3.Script = lib$3.Comment = lib$3.Directive = lib$3.Text = lib$3.Root = lib$3.isTag = void 0;
	/**
	 * Tests whether an element is a tag or not.
	 *
	 * @param elem Element to test
	 */
	function isTag(elem) {
	    return (elem.type === "tag" /* Tag */ ||
	        elem.type === "script" /* Script */ ||
	        elem.type === "style" /* Style */);
	}
	lib$3.isTag = isTag;
	// Exports for backwards compatibility
	/** Type for the root element of a document */
	lib$3.Root = "root" /* Root */;
	/** Type for Text */
	lib$3.Text = "text" /* Text */;
	/** Type for <? ... ?> */
	lib$3.Directive = "directive" /* Directive */;
	/** Type for <!-- ... --> */
	lib$3.Comment = "comment" /* Comment */;
	/** Type for <script> tags */
	lib$3.Script = "script" /* Script */;
	/** Type for <style> tags */
	lib$3.Style = "style" /* Style */;
	/** Type for Any tag */
	lib$3.Tag = "tag" /* Tag */;
	/** Type for <![CDATA[ ... ]]> */
	lib$3.CDATA = "cdata" /* CDATA */;
	/** Type for <!doctype ...> */
	lib$3.Doctype = "doctype" /* Doctype */;
	return lib$3;
}

var FeedHandler = {};

var lib$2 = {};

var stringify = {};

var tagtypes = {};

var hasRequiredTagtypes;

function requireTagtypes () {
	if (hasRequiredTagtypes) return tagtypes;
	hasRequiredTagtypes = 1;
	Object.defineProperty(tagtypes, "__esModule", { value: true });
	tagtypes.hasChildren = tagtypes.isComment = tagtypes.isText = tagtypes.isCDATA = tagtypes.isTag = void 0;
	var domelementtype_1 = requireLib$4();
	/**
	 * @param node Node to check.
	 * @returns `true` if the node is a `Element`, `false` otherwise.
	 */
	function isTag(node) {
	    return domelementtype_1.isTag(node);
	}
	tagtypes.isTag = isTag;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node is a `NodeWithChildren`, `false` otherwise.
	 */
	function isCDATA(node) {
	    return node.type === "cdata" /* CDATA */;
	}
	tagtypes.isCDATA = isCDATA;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node is a `DataNode`, `false` otherwise.
	 */
	function isText(node) {
	    return node.type === "text" /* Text */;
	}
	tagtypes.isText = isText;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node is a `DataNode`, `false` otherwise.
	 */
	function isComment(node) {
	    return node.type === "comment" /* Comment */;
	}
	tagtypes.isComment = isComment;
	/**
	 * @param node Node to check.
	 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
	 */
	function hasChildren(node) {
	    return Object.prototype.hasOwnProperty.call(node, "children");
	}
	tagtypes.hasChildren = hasChildren;
	return tagtypes;
}

var lib$1 = {};

var lib = {};

var decode = {};

var hasRequiredDecode;

function requireDecode () {
	if (hasRequiredDecode) return decode;
	hasRequiredDecode = 1;
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(decode, "__esModule", { value: true });
	decode.decodeHTML = decode.decodeHTMLStrict = decode.decodeXML = void 0;
	var entities_json_1 = __importDefault(require$$1$1);
	var legacy_json_1 = __importDefault(require$$1);
	var xml_json_1 = __importDefault(require$$0);
	var decode_codepoint_1 = __importDefault(requireDecode_codepoint());
	decode.decodeXML = getStrictDecoder(xml_json_1.default);
	decode.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
	function getStrictDecoder(map) {
	    var keys = Object.keys(map).join("|");
	    var replace = getReplacer(map);
	    keys += "|#[xX][\\da-fA-F]+|#\\d+";
	    var re = new RegExp("&(?:" + keys + ");", "g");
	    return function (str) { return String(str).replace(re, replace); };
	}
	var sorter = function (a, b) { return (a < b ? 1 : -1); };
	decode.decodeHTML = (function () {
	    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
	    var keys = Object.keys(entities_json_1.default).sort(sorter);
	    for (var i = 0, j = 0; i < keys.length; i++) {
	        if (legacy[j] === keys[i]) {
	            keys[i] += ";?";
	            j++;
	        }
	        else {
	            keys[i] += ";";
	        }
	    }
	    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
	    var replace = getReplacer(entities_json_1.default);
	    function replacer(str) {
	        if (str.substr(-1) !== ";")
	            str += ";";
	        return replace(str);
	    }
	    //TODO consider creating a merged map
	    return function (str) { return String(str).replace(re, replacer); };
	})();
	function getReplacer(map) {
	    return function replace(str) {
	        if (str.charAt(1) === "#") {
	            var secondChar = str.charAt(2);
	            if (secondChar === "X" || secondChar === "x") {
	                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
	            }
	            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
	        }
	        return map[str.slice(1, -1)];
	    };
	}
	return decode;
}

var encode = {};

var hasRequiredEncode;

function requireEncode () {
	if (hasRequiredEncode) return encode;
	hasRequiredEncode = 1;
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(encode, "__esModule", { value: true });
	encode.escape = encode.encodeHTML = encode.encodeXML = void 0;
	var xml_json_1 = __importDefault(require$$0);
	var inverseXML = getInverseObj(xml_json_1.default);
	var xmlReplacer = getInverseReplacer(inverseXML);
	encode.encodeXML = getInverse(inverseXML, xmlReplacer);
	var entities_json_1 = __importDefault(require$$1$1);
	var inverseHTML = getInverseObj(entities_json_1.default);
	var htmlReplacer = getInverseReplacer(inverseHTML);
	encode.encodeHTML = getInverse(inverseHTML, htmlReplacer);
	function getInverseObj(obj) {
	    return Object.keys(obj)
	        .sort()
	        .reduce(function (inverse, name) {
	        inverse[obj[name]] = "&" + name + ";";
	        return inverse;
	    }, {});
	}
	function getInverseReplacer(inverse) {
	    var single = [];
	    var multiple = [];
	    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
	        var k = _a[_i];
	        if (k.length === 1) {
	            // Add value to single array
	            single.push("\\" + k);
	        }
	        else {
	            // Add value to multiple array
	            multiple.push(k);
	        }
	    }
	    // Add ranges to single characters.
	    single.sort();
	    for (var start = 0; start < single.length - 1; start++) {
	        // Find the end of a run of characters
	        var end = start;
	        while (end < single.length - 1 &&
	            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
	            end += 1;
	        }
	        var count = 1 + end - start;
	        // We want to replace at least three characters
	        if (count < 3)
	            continue;
	        single.splice(start, count, single[start] + "-" + single[end]);
	    }
	    multiple.unshift("[" + single.join("") + "]");
	    return new RegExp(multiple.join("|"), "g");
	}
	var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
	function singleCharReplacer(c) {
	    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	    return "&#x" + c.codePointAt(0).toString(16).toUpperCase() + ";";
	}
	function getInverse(inverse, re) {
	    return function (data) {
	        return data
	            .replace(re, function (name) { return inverse[name]; })
	            .replace(reNonASCII, singleCharReplacer);
	    };
	}
	var reXmlChars = getInverseReplacer(inverseXML);
	function escape(data) {
	    return data
	        .replace(reXmlChars, singleCharReplacer)
	        .replace(reNonASCII, singleCharReplacer);
	}
	encode.escape = escape;
	return encode;
}

var hasRequiredLib$3;

function requireLib$3 () {
	if (hasRequiredLib$3) return lib;
	hasRequiredLib$3 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.encode = exports.decodeStrict = exports.decode = void 0;
		var decode_1 = requireDecode();
		var encode_1 = requireEncode();
		/**
		 * Decodes a string with entities.
		 *
		 * @param data String to decode.
		 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
		 */
		function decode(data, level) {
		    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
		}
		exports.decode = decode;
		/**
		 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
		 *
		 * @param data String to decode.
		 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
		 */
		function decodeStrict(data, level) {
		    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
		}
		exports.decodeStrict = decodeStrict;
		/**
		 * Encodes a string with entities.
		 *
		 * @param data String to encode.
		 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
		 */
		function encode(data, level) {
		    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
		}
		exports.encode = encode;
		var encode_2 = requireEncode();
		Object.defineProperty(exports, "encodeXML", { enumerable: true, get: function () { return encode_2.encodeXML; } });
		Object.defineProperty(exports, "encodeHTML", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
		Object.defineProperty(exports, "escape", { enumerable: true, get: function () { return encode_2.escape; } });
		// Legacy aliases
		Object.defineProperty(exports, "encodeHTML4", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
		Object.defineProperty(exports, "encodeHTML5", { enumerable: true, get: function () { return encode_2.encodeHTML; } });
		var decode_2 = requireDecode();
		Object.defineProperty(exports, "decodeXML", { enumerable: true, get: function () { return decode_2.decodeXML; } });
		Object.defineProperty(exports, "decodeHTML", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
		Object.defineProperty(exports, "decodeHTMLStrict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
		// Legacy aliases
		Object.defineProperty(exports, "decodeHTML4", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
		Object.defineProperty(exports, "decodeHTML5", { enumerable: true, get: function () { return decode_2.decodeHTML; } });
		Object.defineProperty(exports, "decodeHTML4Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
		Object.defineProperty(exports, "decodeHTML5Strict", { enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } });
		Object.defineProperty(exports, "decodeXMLStrict", { enumerable: true, get: function () { return decode_2.decodeXML; } });
} (lib));
	return lib;
}

var foreignNames = {};

var hasRequiredForeignNames;

function requireForeignNames () {
	if (hasRequiredForeignNames) return foreignNames;
	hasRequiredForeignNames = 1;
	Object.defineProperty(foreignNames, "__esModule", { value: true });
	foreignNames.attributeNames = foreignNames.elementNames = void 0;
	foreignNames.elementNames = new Map([
	    ["altglyph", "altGlyph"],
	    ["altglyphdef", "altGlyphDef"],
	    ["altglyphitem", "altGlyphItem"],
	    ["animatecolor", "animateColor"],
	    ["animatemotion", "animateMotion"],
	    ["animatetransform", "animateTransform"],
	    ["clippath", "clipPath"],
	    ["feblend", "feBlend"],
	    ["fecolormatrix", "feColorMatrix"],
	    ["fecomponenttransfer", "feComponentTransfer"],
	    ["fecomposite", "feComposite"],
	    ["feconvolvematrix", "feConvolveMatrix"],
	    ["fediffuselighting", "feDiffuseLighting"],
	    ["fedisplacementmap", "feDisplacementMap"],
	    ["fedistantlight", "feDistantLight"],
	    ["fedropshadow", "feDropShadow"],
	    ["feflood", "feFlood"],
	    ["fefunca", "feFuncA"],
	    ["fefuncb", "feFuncB"],
	    ["fefuncg", "feFuncG"],
	    ["fefuncr", "feFuncR"],
	    ["fegaussianblur", "feGaussianBlur"],
	    ["feimage", "feImage"],
	    ["femerge", "feMerge"],
	    ["femergenode", "feMergeNode"],
	    ["femorphology", "feMorphology"],
	    ["feoffset", "feOffset"],
	    ["fepointlight", "fePointLight"],
	    ["fespecularlighting", "feSpecularLighting"],
	    ["fespotlight", "feSpotLight"],
	    ["fetile", "feTile"],
	    ["feturbulence", "feTurbulence"],
	    ["foreignobject", "foreignObject"],
	    ["glyphref", "glyphRef"],
	    ["lineargradient", "linearGradient"],
	    ["radialgradient", "radialGradient"],
	    ["textpath", "textPath"],
	]);
	foreignNames.attributeNames = new Map([
	    ["definitionurl", "definitionURL"],
	    ["attributename", "attributeName"],
	    ["attributetype", "attributeType"],
	    ["basefrequency", "baseFrequency"],
	    ["baseprofile", "baseProfile"],
	    ["calcmode", "calcMode"],
	    ["clippathunits", "clipPathUnits"],
	    ["diffuseconstant", "diffuseConstant"],
	    ["edgemode", "edgeMode"],
	    ["filterunits", "filterUnits"],
	    ["glyphref", "glyphRef"],
	    ["gradienttransform", "gradientTransform"],
	    ["gradientunits", "gradientUnits"],
	    ["kernelmatrix", "kernelMatrix"],
	    ["kernelunitlength", "kernelUnitLength"],
	    ["keypoints", "keyPoints"],
	    ["keysplines", "keySplines"],
	    ["keytimes", "keyTimes"],
	    ["lengthadjust", "lengthAdjust"],
	    ["limitingconeangle", "limitingConeAngle"],
	    ["markerheight", "markerHeight"],
	    ["markerunits", "markerUnits"],
	    ["markerwidth", "markerWidth"],
	    ["maskcontentunits", "maskContentUnits"],
	    ["maskunits", "maskUnits"],
	    ["numoctaves", "numOctaves"],
	    ["pathlength", "pathLength"],
	    ["patterncontentunits", "patternContentUnits"],
	    ["patterntransform", "patternTransform"],
	    ["patternunits", "patternUnits"],
	    ["pointsatx", "pointsAtX"],
	    ["pointsaty", "pointsAtY"],
	    ["pointsatz", "pointsAtZ"],
	    ["preservealpha", "preserveAlpha"],
	    ["preserveaspectratio", "preserveAspectRatio"],
	    ["primitiveunits", "primitiveUnits"],
	    ["refx", "refX"],
	    ["refy", "refY"],
	    ["repeatcount", "repeatCount"],
	    ["repeatdur", "repeatDur"],
	    ["requiredextensions", "requiredExtensions"],
	    ["requiredfeatures", "requiredFeatures"],
	    ["specularconstant", "specularConstant"],
	    ["specularexponent", "specularExponent"],
	    ["spreadmethod", "spreadMethod"],
	    ["startoffset", "startOffset"],
	    ["stddeviation", "stdDeviation"],
	    ["stitchtiles", "stitchTiles"],
	    ["surfacescale", "surfaceScale"],
	    ["systemlanguage", "systemLanguage"],
	    ["tablevalues", "tableValues"],
	    ["targetx", "targetX"],
	    ["targety", "targetY"],
	    ["textlength", "textLength"],
	    ["viewbox", "viewBox"],
	    ["viewtarget", "viewTarget"],
	    ["xchannelselector", "xChannelSelector"],
	    ["ychannelselector", "yChannelSelector"],
	    ["zoomandpan", "zoomAndPan"],
	]);
	return foreignNames;
}

var hasRequiredLib$2;

function requireLib$2 () {
	if (hasRequiredLib$2) return lib$1;
	hasRequiredLib$2 = 1;
	var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(lib$1, "__esModule", { value: true });
	/*
	 * Module dependencies
	 */
	var ElementType = __importStar(requireLib$4());
	var entities_1 = requireLib$3();
	/*
	 * Mixed-case SVG and MathML tags & attributes
	 * recognized by the HTML parser, see
	 * https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	 */
	var foreignNames_1 = requireForeignNames();
	var unencodedElements = new Set([
	    "style",
	    "script",
	    "xmp",
	    "iframe",
	    "noembed",
	    "noframes",
	    "plaintext",
	    "noscript",
	]);
	/**
	 * Format attributes
	 */
	function formatAttributes(attributes, opts) {
	    if (!attributes)
	        return;
	    return Object.keys(attributes)
	        .map(function (key) {
	        var _a, _b;
	        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
	        if (opts.xmlMode === "foreign") {
	            /* Fix up mixed-case attribute names */
	            key = (_b = foreignNames_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
	        }
	        if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
	            return key;
	        }
	        return key + "=\"" + (opts.decodeEntities ? entities_1.encodeXML(value) : value.replace(/"/g, "&quot;")) + "\"";
	    })
	        .join(" ");
	}
	/**
	 * Self-enclosing tags
	 */
	var singleTag = new Set([
	    "area",
	    "base",
	    "basefont",
	    "br",
	    "col",
	    "command",
	    "embed",
	    "frame",
	    "hr",
	    "img",
	    "input",
	    "isindex",
	    "keygen",
	    "link",
	    "meta",
	    "param",
	    "source",
	    "track",
	    "wbr",
	]);
	/**
	 * Renders a DOM node or an array of DOM nodes to a string.
	 *
	 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
	 *
	 * @param node Node to be rendered.
	 * @param options Changes serialization behavior
	 */
	function render(node, options) {
	    if (options === void 0) { options = {}; }
	    // TODO: This is a bit hacky.
	    var nodes = Array.isArray(node) || node.cheerio ? node : [node];
	    var output = "";
	    for (var i = 0; i < nodes.length; i++) {
	        output += renderNode(nodes[i], options);
	    }
	    return output;
	}
	lib$1.default = render;
	function renderNode(node, options) {
	    switch (node.type) {
	        case ElementType.Root:
	            return render(node.children, options);
	        case ElementType.Directive:
	        case ElementType.Doctype:
	            return renderDirective(node);
	        case ElementType.Comment:
	            return renderComment(node);
	        case ElementType.CDATA:
	            return renderCdata(node);
	        case ElementType.Script:
	        case ElementType.Style:
	        case ElementType.Tag:
	            return renderTag(node, options);
	        case ElementType.Text:
	            return renderText(node, options);
	    }
	}
	var foreignModeIntegrationPoints = new Set([
	    "mi",
	    "mo",
	    "mn",
	    "ms",
	    "mtext",
	    "annotation-xml",
	    "foreignObject",
	    "desc",
	    "title",
	]);
	var foreignElements = new Set(["svg", "math"]);
	function renderTag(elem, opts) {
	    var _a;
	    // Handle SVG / MathML in HTML
	    if (opts.xmlMode === "foreign") {
	        /* Fix up mixed-case element names */
	        elem.name = (_a = foreignNames_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
	        /* Exit foreign mode at integration points */
	        if (elem.parent &&
	            foreignModeIntegrationPoints.has(elem.parent.name)) {
	            opts = __assign(__assign({}, opts), { xmlMode: false });
	        }
	    }
	    if (!opts.xmlMode && foreignElements.has(elem.name)) {
	        opts = __assign(__assign({}, opts), { xmlMode: "foreign" });
	    }
	    var tag = "<" + elem.name;
	    var attribs = formatAttributes(elem.attribs, opts);
	    if (attribs) {
	        tag += " " + attribs;
	    }
	    if (elem.children.length === 0 &&
	        (opts.xmlMode
	            ? // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
	                opts.selfClosingTags !== false
	            : // User explicitly asked for self-closing tags, even in HTML mode
	                opts.selfClosingTags && singleTag.has(elem.name))) {
	        if (!opts.xmlMode)
	            tag += " ";
	        tag += "/>";
	    }
	    else {
	        tag += ">";
	        if (elem.children.length > 0) {
	            tag += render(elem.children, opts);
	        }
	        if (opts.xmlMode || !singleTag.has(elem.name)) {
	            tag += "</" + elem.name + ">";
	        }
	    }
	    return tag;
	}
	function renderDirective(elem) {
	    return "<" + elem.data + ">";
	}
	function renderText(elem, opts) {
	    var data = elem.data || "";
	    // If entities weren't decoded, no need to encode them back
	    if (opts.decodeEntities &&
	        !(elem.parent && unencodedElements.has(elem.parent.name))) {
	        data = entities_1.encodeXML(data);
	    }
	    return data;
	}
	function renderCdata(elem) {
	    return "<![CDATA[" + elem.children[0].data + "]]>";
	}
	function renderComment(elem) {
	    return "<!--" + elem.data + "-->";
	}
	return lib$1;
}

var hasRequiredStringify$1;

function requireStringify$1 () {
	if (hasRequiredStringify$1) return stringify;
	hasRequiredStringify$1 = 1;
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(stringify, "__esModule", { value: true });
	stringify.getText = stringify.getInnerHTML = stringify.getOuterHTML = void 0;
	var tagtypes_1 = requireTagtypes();
	var dom_serializer_1 = __importDefault(requireLib$2());
	/**
	 * @param node Node to get the outer HTML of.
	 * @param options Options for serialization.
	 * @deprecated Use the `dom-serializer` module directly.
	 * @returns `node`'s outer HTML.
	 */
	function getOuterHTML(node, options) {
	    return dom_serializer_1.default(node, options);
	}
	stringify.getOuterHTML = getOuterHTML;
	/**
	 * @param node Node to get the inner HTML of.
	 * @param options Options for serialization.
	 * @deprecated Use the `dom-serializer` module directly.
	 * @returns `node`'s inner HTML.
	 */
	function getInnerHTML(node, options) {
	    return tagtypes_1.hasChildren(node)
	        ? node.children.map(function (node) { return getOuterHTML(node, options); }).join("")
	        : "";
	}
	stringify.getInnerHTML = getInnerHTML;
	/**
	 * Get a node's inner text.
	 *
	 * @param node Node to get the inner text of.
	 * @returns `node`'s inner text.
	 */
	function getText(node) {
	    if (Array.isArray(node))
	        return node.map(getText).join("");
	    if (tagtypes_1.isTag(node))
	        return node.name === "br" ? "\n" : getText(node.children);
	    if (tagtypes_1.isCDATA(node))
	        return getText(node.children);
	    if (tagtypes_1.isText(node))
	        return node.data;
	    return "";
	}
	stringify.getText = getText;
	return stringify;
}

var traversal = {};

var hasRequiredTraversal;

function requireTraversal () {
	if (hasRequiredTraversal) return traversal;
	hasRequiredTraversal = 1;
	Object.defineProperty(traversal, "__esModule", { value: true });
	traversal.nextElementSibling = traversal.getName = traversal.hasAttrib = traversal.getAttributeValue = traversal.getSiblings = traversal.getParent = traversal.getChildren = void 0;
	var tagtypes_1 = requireTagtypes();
	var emptyArray = [];
	/**
	 * Get a node's children.
	 *
	 * @param elem Node to get the children of.
	 * @returns `elem`'s children, or an empty array.
	 */
	function getChildren(elem) {
	    var _a;
	    return (_a = elem.children) !== null && _a !== void 0 ? _a : emptyArray;
	}
	traversal.getChildren = getChildren;
	/**
	 * Get a node's parent.
	 *
	 * @param elem Node to get the parent of.
	 * @returns `elem`'s parent node.
	 */
	function getParent(elem) {
	    return elem.parent || null;
	}
	traversal.getParent = getParent;
	/**
	 * Gets an elements siblings, including the element itself.
	 *
	 * Attempts to get the children through the element's parent first.
	 * If we don't have a parent (the element is a root node),
	 * we walk the element's `prev` & `next` to get all remaining nodes.
	 *
	 * @param elem Element to get the siblings of.
	 * @returns `elem`'s siblings.
	 */
	function getSiblings(elem) {
	    var _a, _b;
	    var parent = getParent(elem);
	    if (parent != null)
	        return getChildren(parent);
	    var siblings = [elem];
	    var prev = elem.prev, next = elem.next;
	    while (prev != null) {
	        siblings.unshift(prev);
	        (_a = prev, prev = _a.prev);
	    }
	    while (next != null) {
	        siblings.push(next);
	        (_b = next, next = _b.next);
	    }
	    return siblings;
	}
	traversal.getSiblings = getSiblings;
	/**
	 * Gets an attribute from an element.
	 *
	 * @param elem Element to check.
	 * @param name Attribute name to retrieve.
	 * @returns The element's attribute value, or `undefined`.
	 */
	function getAttributeValue(elem, name) {
	    var _a;
	    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
	}
	traversal.getAttributeValue = getAttributeValue;
	/**
	 * Checks whether an element has an attribute.
	 *
	 * @param elem Element to check.
	 * @param name Attribute name to look for.
	 * @returns Returns whether `elem` has the attribute `name`.
	 */
	function hasAttrib(elem, name) {
	    return (elem.attribs != null &&
	        Object.prototype.hasOwnProperty.call(elem.attribs, name) &&
	        elem.attribs[name] != null);
	}
	traversal.hasAttrib = hasAttrib;
	/**
	 * Get the tag name of an element.
	 *
	 * @param elem The element to get the name for.
	 * @returns The tag name of `elem`.
	 */
	function getName(elem) {
	    return elem.name;
	}
	traversal.getName = getName;
	/**
	 * Returns the next element sibling of a node.
	 *
	 * @param elem The element to get the next sibling of.
	 * @returns `elem`'s next sibling that is a tag.
	 */
	function nextElementSibling(elem) {
	    var _a;
	    var next = elem.next;
	    while (next !== null && !tagtypes_1.isTag(next))
	        (_a = next, next = _a.next);
	    return next;
	}
	traversal.nextElementSibling = nextElementSibling;
	return traversal;
}

var manipulation = {};

var hasRequiredManipulation;

function requireManipulation () {
	if (hasRequiredManipulation) return manipulation;
	hasRequiredManipulation = 1;
	Object.defineProperty(manipulation, "__esModule", { value: true });
	manipulation.prepend = manipulation.prependChild = manipulation.append = manipulation.appendChild = manipulation.replaceElement = manipulation.removeElement = void 0;
	/**
	 * Remove an element from the dom
	 *
	 * @param elem The element to be removed
	 */
	function removeElement(elem) {
	    if (elem.prev)
	        elem.prev.next = elem.next;
	    if (elem.next)
	        elem.next.prev = elem.prev;
	    if (elem.parent) {
	        var childs = elem.parent.children;
	        childs.splice(childs.lastIndexOf(elem), 1);
	    }
	}
	manipulation.removeElement = removeElement;
	/**
	 * Replace an element in the dom
	 *
	 * @param elem The element to be replaced
	 * @param replacement The element to be added
	 */
	function replaceElement(elem, replacement) {
	    var prev = (replacement.prev = elem.prev);
	    if (prev) {
	        prev.next = replacement;
	    }
	    var next = (replacement.next = elem.next);
	    if (next) {
	        next.prev = replacement;
	    }
	    var parent = (replacement.parent = elem.parent);
	    if (parent) {
	        var childs = parent.children;
	        childs[childs.lastIndexOf(elem)] = replacement;
	    }
	}
	manipulation.replaceElement = replaceElement;
	/**
	 * Append a child to an element.
	 *
	 * @param elem The element to append to.
	 * @param child The element to be added as a child.
	 */
	function appendChild(elem, child) {
	    removeElement(child);
	    child.next = null;
	    child.parent = elem;
	    if (elem.children.push(child) > 1) {
	        var sibling = elem.children[elem.children.length - 2];
	        sibling.next = child;
	        child.prev = sibling;
	    }
	    else {
	        child.prev = null;
	    }
	}
	manipulation.appendChild = appendChild;
	/**
	 * Append an element after another.
	 *
	 * @param elem The element to append after.
	 * @param next The element be added.
	 */
	function append(elem, next) {
	    removeElement(next);
	    var parent = elem.parent;
	    var currNext = elem.next;
	    next.next = currNext;
	    next.prev = elem;
	    elem.next = next;
	    next.parent = parent;
	    if (currNext) {
	        currNext.prev = next;
	        if (parent) {
	            var childs = parent.children;
	            childs.splice(childs.lastIndexOf(currNext), 0, next);
	        }
	    }
	    else if (parent) {
	        parent.children.push(next);
	    }
	}
	manipulation.append = append;
	/**
	 * Prepend a child to an element.
	 *
	 * @param elem The element to prepend before.
	 * @param child The element to be added as a child.
	 */
	function prependChild(elem, child) {
	    removeElement(child);
	    child.parent = elem;
	    child.prev = null;
	    if (elem.children.unshift(child) !== 1) {
	        var sibling = elem.children[1];
	        sibling.prev = child;
	        child.next = sibling;
	    }
	    else {
	        child.next = null;
	    }
	}
	manipulation.prependChild = prependChild;
	/**
	 * Prepend an element before another.
	 *
	 * @param elem The element to prepend before.
	 * @param prev The element be added.
	 */
	function prepend(elem, prev) {
	    removeElement(prev);
	    var parent = elem.parent;
	    if (parent) {
	        var childs = parent.children;
	        childs.splice(childs.indexOf(elem), 0, prev);
	    }
	    if (elem.prev) {
	        elem.prev.next = prev;
	    }
	    prev.parent = parent;
	    prev.prev = elem.prev;
	    prev.next = elem;
	    elem.prev = prev;
	}
	manipulation.prepend = prepend;
	return manipulation;
}

var querying = {};

var hasRequiredQuerying;

function requireQuerying () {
	if (hasRequiredQuerying) return querying;
	hasRequiredQuerying = 1;
	Object.defineProperty(querying, "__esModule", { value: true });
	querying.findAll = querying.existsOne = querying.findOne = querying.findOneChild = querying.find = querying.filter = void 0;
	var tagtypes_1 = requireTagtypes();
	/**
	 * Search a node and its children for nodes passing a test function.
	 *
	 * @param test Function to test nodes on.
	 * @param node Node to search. Will be included in the result set if it matches.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes passing `test`.
	 */
	function filter(test, node, recurse, limit) {
	    if (recurse === void 0) { recurse = true; }
	    if (limit === void 0) { limit = Infinity; }
	    if (!Array.isArray(node))
	        node = [node];
	    return find(test, node, recurse, limit);
	}
	querying.filter = filter;
	/**
	 * Search an array of node and its children for nodes passing a test function.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes passing `test`.
	 */
	function find(test, nodes, recurse, limit) {
	    var result = [];
	    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
	        var elem = nodes_1[_i];
	        if (test(elem)) {
	            result.push(elem);
	            if (--limit <= 0)
	                break;
	        }
	        if (recurse && tagtypes_1.hasChildren(elem) && elem.children.length > 0) {
	            var children = find(test, elem.children, recurse, limit);
	            result.push.apply(result, children);
	            limit -= children.length;
	            if (limit <= 0)
	                break;
	        }
	    }
	    return result;
	}
	querying.find = find;
	/**
	 * Finds the first element inside of an array that matches a test function.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @returns The first node in the array that passes `test`.
	 */
	function findOneChild(test, nodes) {
	    return nodes.find(test);
	}
	querying.findOneChild = findOneChild;
	/**
	 * Finds one element in a tree that passes a test.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @param recurse Also consider child nodes.
	 * @returns The first child node that passes `test`.
	 */
	function findOne(test, nodes, recurse) {
	    if (recurse === void 0) { recurse = true; }
	    var elem = null;
	    for (var i = 0; i < nodes.length && !elem; i++) {
	        var checked = nodes[i];
	        if (!tagtypes_1.isTag(checked)) {
	            continue;
	        }
	        else if (test(checked)) {
	            elem = checked;
	        }
	        else if (recurse && checked.children.length > 0) {
	            elem = findOne(test, checked.children);
	        }
	    }
	    return elem;
	}
	querying.findOne = findOne;
	/**
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @returns Whether a tree of nodes contains at least one node passing a test.
	 */
	function existsOne(test, nodes) {
	    return nodes.some(function (checked) {
	        return tagtypes_1.isTag(checked) &&
	            (test(checked) ||
	                (checked.children.length > 0 &&
	                    existsOne(test, checked.children)));
	    });
	}
	querying.existsOne = existsOne;
	/**
	 * Search and array of nodes and its children for nodes passing a test function.
	 *
	 * Same as `find`, only with less options, leading to reduced complexity.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @returns All nodes passing `test`.
	 */
	function findAll(test, nodes) {
	    var _a;
	    var result = [];
	    var stack = nodes.filter(tagtypes_1.isTag);
	    var elem;
	    while ((elem = stack.shift())) {
	        var children = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.filter(tagtypes_1.isTag);
	        if (children && children.length > 0) {
	            stack.unshift.apply(stack, children);
	        }
	        if (test(elem))
	            result.push(elem);
	    }
	    return result;
	}
	querying.findAll = findAll;
	return querying;
}

var legacy = {};

var hasRequiredLegacy;

function requireLegacy () {
	if (hasRequiredLegacy) return legacy;
	hasRequiredLegacy = 1;
	Object.defineProperty(legacy, "__esModule", { value: true });
	legacy.getElementsByTagType = legacy.getElementsByTagName = legacy.getElementById = legacy.getElements = legacy.testElement = void 0;
	var querying_1 = requireQuerying();
	var tagtypes_1 = requireTagtypes();
	var Checks = {
	    tag_name: function (name) {
	        if (typeof name === "function") {
	            return function (elem) { return tagtypes_1.isTag(elem) && name(elem.name); };
	        }
	        else if (name === "*") {
	            return tagtypes_1.isTag;
	        }
	        return function (elem) { return tagtypes_1.isTag(elem) && elem.name === name; };
	    },
	    tag_type: function (type) {
	        if (typeof type === "function") {
	            return function (elem) { return type(elem.type); };
	        }
	        return function (elem) { return elem.type === type; };
	    },
	    tag_contains: function (data) {
	        if (typeof data === "function") {
	            return function (elem) { return tagtypes_1.isText(elem) && data(elem.data); };
	        }
	        return function (elem) { return tagtypes_1.isText(elem) && elem.data === data; };
	    },
	};
	/**
	 * @param attrib Attribute to check.
	 * @param value Attribute value to look for.
	 * @returns A function to check whether the a node has an attribute with a particular value.
	 */
	function getAttribCheck(attrib, value) {
	    if (typeof value === "function") {
	        return function (elem) { return tagtypes_1.isTag(elem) && value(elem.attribs[attrib]); };
	    }
	    return function (elem) { return tagtypes_1.isTag(elem) && elem.attribs[attrib] === value; };
	}
	/**
	 * @param a First function to combine.
	 * @param b Second function to combine.
	 * @returns A function taking a node and returning `true` if either
	 * of the input functions returns `true` for the node.
	 */
	function combineFuncs(a, b) {
	    return function (elem) { return a(elem) || b(elem); };
	}
	/**
	 * @param options An object describing nodes to look for.
	 * @returns A function executing all checks in `options` and returning `true`
	 * if any of them match a node.
	 */
	function compileTest(options) {
	    var funcs = Object.keys(options).map(function (key) {
	        var value = options[key];
	        return key in Checks
	            ? Checks[key](value)
	            : getAttribCheck(key, value);
	    });
	    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
	}
	/**
	 * @param options An object describing nodes to look for.
	 * @param node The element to test.
	 * @returns Whether the element matches the description in `options`.
	 */
	function testElement(options, node) {
	    var test = compileTest(options);
	    return test ? test(node) : true;
	}
	legacy.testElement = testElement;
	/**
	 * @param options An object describing nodes to look for.
	 * @param nodes Nodes to search through.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes that match `options`.
	 */
	function getElements(options, nodes, recurse, limit) {
	    if (limit === void 0) { limit = Infinity; }
	    var test = compileTest(options);
	    return test ? querying_1.filter(test, nodes, recurse, limit) : [];
	}
	legacy.getElements = getElements;
	/**
	 * @param id The unique ID attribute value to look for.
	 * @param nodes Nodes to search through.
	 * @param recurse Also consider child nodes.
	 * @returns The node with the supplied ID.
	 */
	function getElementById(id, nodes, recurse) {
	    if (recurse === void 0) { recurse = true; }
	    if (!Array.isArray(nodes))
	        nodes = [nodes];
	    return querying_1.findOne(getAttribCheck("id", id), nodes, recurse);
	}
	legacy.getElementById = getElementById;
	/**
	 * @param tagName Tag name to search for.
	 * @param nodes Nodes to search through.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes with the supplied `tagName`.
	 */
	function getElementsByTagName(tagName, nodes, recurse, limit) {
	    if (recurse === void 0) { recurse = true; }
	    if (limit === void 0) { limit = Infinity; }
	    return querying_1.filter(Checks.tag_name(tagName), nodes, recurse, limit);
	}
	legacy.getElementsByTagName = getElementsByTagName;
	/**
	 * @param type Element type to look for.
	 * @param nodes Nodes to search through.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 * @returns All nodes with the supplied `type`.
	 */
	function getElementsByTagType(type, nodes, recurse, limit) {
	    if (recurse === void 0) { recurse = true; }
	    if (limit === void 0) { limit = Infinity; }
	    return querying_1.filter(Checks.tag_type(type), nodes, recurse, limit);
	}
	legacy.getElementsByTagType = getElementsByTagType;
	return legacy;
}

var helpers = {};

var hasRequiredHelpers;

function requireHelpers () {
	if (hasRequiredHelpers) return helpers;
	hasRequiredHelpers = 1;
	Object.defineProperty(helpers, "__esModule", { value: true });
	helpers.uniqueSort = helpers.compareDocumentPosition = helpers.removeSubsets = void 0;
	var tagtypes_1 = requireTagtypes();
	/**
	 * Given an array of nodes, remove any member that is contained by another.
	 *
	 * @param nodes Nodes to filter.
	 * @returns Remaining nodes that aren't subtrees of each other.
	 */
	function removeSubsets(nodes) {
	    var idx = nodes.length;
	    /*
	     * Check if each node (or one of its ancestors) is already contained in the
	     * array.
	     */
	    while (--idx >= 0) {
	        var node = nodes[idx];
	        /*
	         * Remove the node if it is not unique.
	         * We are going through the array from the end, so we only
	         * have to check nodes that preceed the node under consideration in the array.
	         */
	        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
	            nodes.splice(idx, 1);
	            continue;
	        }
	        for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
	            if (nodes.includes(ancestor)) {
	                nodes.splice(idx, 1);
	                break;
	            }
	        }
	    }
	    return nodes;
	}
	helpers.removeSubsets = removeSubsets;
	/**
	 * Compare the position of one node against another node in any other document.
	 * The return value is a bitmask with the following values:
	 *
	 * Document order:
	 * > There is an ordering, document order, defined on all the nodes in the
	 * > document corresponding to the order in which the first character of the
	 * > XML representation of each node occurs in the XML representation of the
	 * > document after expansion of general entities. Thus, the document element
	 * > node will be the first node. Element nodes occur before their children.
	 * > Thus, document order orders element nodes in order of the occurrence of
	 * > their start-tag in the XML (after expansion of entities). The attribute
	 * > nodes of an element occur after the element and before its children. The
	 * > relative order of attribute nodes is implementation-dependent./
	 *
	 * Source:
	 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	 *
	 * @param nodeA The first node to use in the comparison
	 * @param nodeB The second node to use in the comparison
	 * @returns A bitmask describing the input nodes' relative position.
	 *
	 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	 * a description of these values.
	 */
	function compareDocumentPosition(nodeA, nodeB) {
	    var aParents = [];
	    var bParents = [];
	    if (nodeA === nodeB) {
	        return 0;
	    }
	    var current = tagtypes_1.hasChildren(nodeA) ? nodeA : nodeA.parent;
	    while (current) {
	        aParents.unshift(current);
	        current = current.parent;
	    }
	    current = tagtypes_1.hasChildren(nodeB) ? nodeB : nodeB.parent;
	    while (current) {
	        bParents.unshift(current);
	        current = current.parent;
	    }
	    var maxIdx = Math.min(aParents.length, bParents.length);
	    var idx = 0;
	    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
	        idx++;
	    }
	    if (idx === 0) {
	        return 1 /* DISCONNECTED */;
	    }
	    var sharedParent = aParents[idx - 1];
	    var siblings = sharedParent.children;
	    var aSibling = aParents[idx];
	    var bSibling = bParents[idx];
	    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
	        if (sharedParent === nodeB) {
	            return 4 /* FOLLOWING */ | 16 /* CONTAINED_BY */;
	        }
	        return 4 /* FOLLOWING */;
	    }
	    if (sharedParent === nodeA) {
	        return 2 /* PRECEDING */ | 8 /* CONTAINS */;
	    }
	    return 2 /* PRECEDING */;
	}
	helpers.compareDocumentPosition = compareDocumentPosition;
	/**
	 * Sort an array of nodes based on their relative position in the document and
	 * remove any duplicate nodes. If the array contains nodes that do not belong
	 * to the same document, sort order is unspecified.
	 *
	 * @param nodes Array of DOM nodes.
	 * @returns Collection of unique nodes, sorted in document order.
	 */
	function uniqueSort(nodes) {
	    nodes = nodes.filter(function (node, i, arr) { return !arr.includes(node, i + 1); });
	    nodes.sort(function (a, b) {
	        var relative = compareDocumentPosition(a, b);
	        if (relative & 2 /* PRECEDING */) {
	            return -1;
	        }
	        else if (relative & 4 /* FOLLOWING */) {
	            return 1;
	        }
	        return 0;
	    });
	    return nodes;
	}
	helpers.uniqueSort = uniqueSort;
	return helpers;
}

var hasRequiredLib$1;

function requireLib$1 () {
	if (hasRequiredLib$1) return lib$2;
	hasRequiredLib$1 = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		__exportStar(requireStringify$1(), exports);
		__exportStar(requireTraversal(), exports);
		__exportStar(requireManipulation(), exports);
		__exportStar(requireQuerying(), exports);
		__exportStar(requireLegacy(), exports);
		__exportStar(requireHelpers(), exports);
		__exportStar(requireTagtypes(), exports);
} (lib$2));
	return lib$2;
}

var hasRequiredFeedHandler;

function requireFeedHandler () {
	if (hasRequiredFeedHandler) return FeedHandler;
	hasRequiredFeedHandler = 1;
	var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(FeedHandler, "__esModule", { value: true });
	FeedHandler.parseFeed = FeedHandler.FeedHandler = void 0;
	var domhandler_1 = __importDefault(requireLib$5());
	var DomUtils = __importStar(requireLib$1());
	var Parser_1 = requireParser$1();
	var FeedItemMediaMedium;
	(function (FeedItemMediaMedium) {
	    FeedItemMediaMedium[FeedItemMediaMedium["image"] = 0] = "image";
	    FeedItemMediaMedium[FeedItemMediaMedium["audio"] = 1] = "audio";
	    FeedItemMediaMedium[FeedItemMediaMedium["video"] = 2] = "video";
	    FeedItemMediaMedium[FeedItemMediaMedium["document"] = 3] = "document";
	    FeedItemMediaMedium[FeedItemMediaMedium["executable"] = 4] = "executable";
	})(FeedItemMediaMedium || (FeedItemMediaMedium = {}));
	var FeedItemMediaExpression;
	(function (FeedItemMediaExpression) {
	    FeedItemMediaExpression[FeedItemMediaExpression["sample"] = 0] = "sample";
	    FeedItemMediaExpression[FeedItemMediaExpression["full"] = 1] = "full";
	    FeedItemMediaExpression[FeedItemMediaExpression["nonstop"] = 2] = "nonstop";
	})(FeedItemMediaExpression || (FeedItemMediaExpression = {}));
	// TODO: Consume data as it is coming in
	var FeedHandler$1 = /** @class */ (function (_super) {
	    __extends(FeedHandler, _super);
	    /**
	     *
	     * @param callback
	     * @param options
	     */
	    function FeedHandler(callback, options) {
	        var _this = this;
	        if (typeof callback === "object") {
	            callback = undefined;
	            options = callback;
	        }
	        _this = _super.call(this, callback, options) || this;
	        return _this;
	    }
	    FeedHandler.prototype.onend = function () {
	        var _a, _b;
	        var feedRoot = getOneElement(isValidFeed, this.dom);
	        if (!feedRoot) {
	            this.handleCallback(new Error("couldn't find root of feed"));
	            return;
	        }
	        var feed = {};
	        if (feedRoot.name === "feed") {
	            var childs = feedRoot.children;
	            feed.type = "atom";
	            addConditionally(feed, "id", "id", childs);
	            addConditionally(feed, "title", "title", childs);
	            var href = getAttribute("href", getOneElement("link", childs));
	            if (href) {
	                feed.link = href;
	            }
	            addConditionally(feed, "description", "subtitle", childs);
	            var updated = fetch("updated", childs);
	            if (updated) {
	                feed.updated = new Date(updated);
	            }
	            addConditionally(feed, "author", "email", childs, true);
	            feed.items = getElements("entry", childs).map(function (item) {
	                var entry = {};
	                var children = item.children;
	                addConditionally(entry, "id", "id", children);
	                addConditionally(entry, "title", "title", children);
	                var href = getAttribute("href", getOneElement("link", children));
	                if (href) {
	                    entry.link = href;
	                }
	                var description = fetch("summary", children) || fetch("content", children);
	                if (description) {
	                    entry.description = description;
	                }
	                var pubDate = fetch("updated", children);
	                if (pubDate) {
	                    entry.pubDate = new Date(pubDate);
	                }
	                entry.media = getMediaElements(children);
	                return entry;
	            });
	        }
	        else {
	            var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
	            feed.type = feedRoot.name.substr(0, 3);
	            feed.id = "";
	            addConditionally(feed, "title", "title", childs);
	            addConditionally(feed, "link", "link", childs);
	            addConditionally(feed, "description", "description", childs);
	            var updated = fetch("lastBuildDate", childs);
	            if (updated) {
	                feed.updated = new Date(updated);
	            }
	            addConditionally(feed, "author", "managingEditor", childs, true);
	            feed.items = getElements("item", feedRoot.children).map(function (item) {
	                var entry = {};
	                var children = item.children;
	                addConditionally(entry, "id", "guid", children);
	                addConditionally(entry, "title", "title", children);
	                addConditionally(entry, "link", "link", children);
	                addConditionally(entry, "description", "description", children);
	                var pubDate = fetch("pubDate", children);
	                if (pubDate)
	                    entry.pubDate = new Date(pubDate);
	                entry.media = getMediaElements(children);
	                return entry;
	            });
	        }
	        this.feed = feed;
	        this.handleCallback(null);
	    };
	    return FeedHandler;
	}(domhandler_1.default));
	FeedHandler.FeedHandler = FeedHandler$1;
	function getMediaElements(where) {
	    return getElements("media:content", where).map(function (elem) {
	        var media = {
	            medium: elem.attribs.medium,
	            isDefault: !!elem.attribs.isDefault,
	        };
	        if (elem.attribs.url) {
	            media.url = elem.attribs.url;
	        }
	        if (elem.attribs.fileSize) {
	            media.fileSize = parseInt(elem.attribs.fileSize, 10);
	        }
	        if (elem.attribs.type) {
	            media.type = elem.attribs.type;
	        }
	        if (elem.attribs.expression) {
	            media.expression = elem.attribs
	                .expression;
	        }
	        if (elem.attribs.bitrate) {
	            media.bitrate = parseInt(elem.attribs.bitrate, 10);
	        }
	        if (elem.attribs.framerate) {
	            media.framerate = parseInt(elem.attribs.framerate, 10);
	        }
	        if (elem.attribs.samplingrate) {
	            media.samplingrate = parseInt(elem.attribs.samplingrate, 10);
	        }
	        if (elem.attribs.channels) {
	            media.channels = parseInt(elem.attribs.channels, 10);
	        }
	        if (elem.attribs.duration) {
	            media.duration = parseInt(elem.attribs.duration, 10);
	        }
	        if (elem.attribs.height) {
	            media.height = parseInt(elem.attribs.height, 10);
	        }
	        if (elem.attribs.width) {
	            media.width = parseInt(elem.attribs.width, 10);
	        }
	        if (elem.attribs.lang) {
	            media.lang = elem.attribs.lang;
	        }
	        return media;
	    });
	}
	function getElements(tagName, where) {
	    return DomUtils.getElementsByTagName(tagName, where, true);
	}
	function getOneElement(tagName, node) {
	    return DomUtils.getElementsByTagName(tagName, node, true, 1)[0];
	}
	function fetch(tagName, where, recurse) {
	    if (recurse === void 0) { recurse = false; }
	    return DomUtils.getText(DomUtils.getElementsByTagName(tagName, where, recurse, 1)).trim();
	}
	function getAttribute(name, elem) {
	    if (!elem) {
	        return null;
	    }
	    var attribs = elem.attribs;
	    return attribs[name];
	}
	function addConditionally(obj, prop, what, where, recurse) {
	    if (recurse === void 0) { recurse = false; }
	    var tmp = fetch(what, where, recurse);
	    if (tmp)
	        obj[prop] = tmp;
	}
	function isValidFeed(value) {
	    return value === "rss" || value === "feed" || value === "rdf:RDF";
	}
	/**
	 * Parse a feed.
	 *
	 * @param feed The feed that should be parsed, as a string.
	 * @param options Optionally, options for parsing. When using this option, you should set `xmlMode` to `true`.
	 */
	function parseFeed(feed, options) {
	    if (options === void 0) { options = { xmlMode: true }; }
	    var handler = new FeedHandler$1(options);
	    new Parser_1.Parser(handler, options).end(feed);
	    return handler.feed;
	}
	FeedHandler.parseFeed = parseFeed;
	return FeedHandler;
}

var hasRequiredLib;

function requireLib () {
	if (hasRequiredLib) return lib$5;
	hasRequiredLib = 1;
	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
		    Object.defineProperty(o, "default", { enumerable: true, value: v });
		}) : function(o, v) {
		    o["default"] = v;
		});
		var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
		    if (mod && mod.__esModule) return mod;
		    var result = {};
		    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		    __setModuleDefault(result, mod);
		    return result;
		};
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.RssHandler = exports.DefaultHandler = exports.DomUtils = exports.ElementType = exports.Tokenizer = exports.createDomStream = exports.parseDOM = exports.parseDocument = exports.DomHandler = exports.Parser = void 0;
		var Parser_1 = requireParser$1();
		Object.defineProperty(exports, "Parser", { enumerable: true, get: function () { return Parser_1.Parser; } });
		var domhandler_1 = requireLib$5();
		Object.defineProperty(exports, "DomHandler", { enumerable: true, get: function () { return domhandler_1.DomHandler; } });
		Object.defineProperty(exports, "DefaultHandler", { enumerable: true, get: function () { return domhandler_1.DomHandler; } });
		// Helper methods
		/**
		 * Parses the data, returns the resulting document.
		 *
		 * @param data The data that should be parsed.
		 * @param options Optional options for the parser and DOM builder.
		 */
		function parseDocument(data, options) {
		    var handler = new domhandler_1.DomHandler(undefined, options);
		    new Parser_1.Parser(handler, options).end(data);
		    return handler.root;
		}
		exports.parseDocument = parseDocument;
		/**
		 * Parses data, returns an array of the root nodes.
		 *
		 * Note that the root nodes still have a `Document` node as their parent.
		 * Use `parseDocument` to get the `Document` node instead.
		 *
		 * @param data The data that should be parsed.
		 * @param options Optional options for the parser and DOM builder.
		 * @deprecated Use `parseDocument` instead.
		 */
		function parseDOM(data, options) {
		    return parseDocument(data, options).children;
		}
		exports.parseDOM = parseDOM;
		/**
		 * Creates a parser instance, with an attached DOM handler.
		 *
		 * @param cb A callback that will be called once parsing has been completed.
		 * @param options Optional options for the parser and DOM builder.
		 * @param elementCb An optional callback that will be called every time a tag has been completed inside of the DOM.
		 */
		function createDomStream(cb, options, elementCb) {
		    var handler = new domhandler_1.DomHandler(cb, options, elementCb);
		    return new Parser_1.Parser(handler, options);
		}
		exports.createDomStream = createDomStream;
		var Tokenizer_1 = requireTokenizer();
		Object.defineProperty(exports, "Tokenizer", { enumerable: true, get: function () { return __importDefault(Tokenizer_1).default; } });
		var ElementType = __importStar(requireLib$4());
		exports.ElementType = ElementType;
		/*
		 * All of the following exports exist for backwards-compatibility.
		 * They should probably be removed eventually.
		 */
		__exportStar(requireFeedHandler(), exports);
		exports.DomUtils = __importStar(requireLib$1());
		var FeedHandler_1 = requireFeedHandler();
		Object.defineProperty(exports, "RssHandler", { enumerable: true, get: function () { return FeedHandler_1.FeedHandler; } });
} (lib$5));
	return lib$5;
}

var escapeStringRegexp;
var hasRequiredEscapeStringRegexp;

function requireEscapeStringRegexp () {
	if (hasRequiredEscapeStringRegexp) return escapeStringRegexp;
	hasRequiredEscapeStringRegexp = 1;

	escapeStringRegexp = string => {
		if (typeof string !== 'string') {
			throw new TypeError('Expected a string');
		}

		// Escape characters with special meaning either inside or outside character sets.
		// Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
		return string
			.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
			.replace(/-/g, '\\x2d');
	};
	return escapeStringRegexp;
}

var isPlainObject = {};

var hasRequiredIsPlainObject;

function requireIsPlainObject () {
	if (hasRequiredIsPlainObject) return isPlainObject;
	hasRequiredIsPlainObject = 1;

	Object.defineProperty(isPlainObject, '__esModule', { value: true });

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */

	function isObject(o) {
	  return Object.prototype.toString.call(o) === '[object Object]';
	}

	function isPlainObject$1(o) {
	  var ctor,prot;

	  if (isObject(o) === false) return false;

	  // If has modified constructor
	  ctor = o.constructor;
	  if (ctor === undefined) return true;

	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObject(prot) === false) return false;

	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }

	  // Most likely a plain Object
	  return true;
	}

	isPlainObject.isPlainObject = isPlainObject$1;
	return isPlainObject;
}

var cjs;
var hasRequiredCjs;

function requireCjs () {
	if (hasRequiredCjs) return cjs;
	hasRequiredCjs = 1;

	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};

	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}

	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);

		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}

	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}

	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}

	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}

	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}

	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}

	function getEnumerableOwnPropertySymbols(target) {
		return Object.getOwnPropertySymbols
			? Object.getOwnPropertySymbols(target).filter(function(symbol) {
				return target.propertyIsEnumerable(symbol)
			})
			: []
	}

	function getKeys(target) {
		return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
	}

	function propertyIsOnObject(object, property) {
		try {
			return property in object
		} catch(_) {
			return false
		}
	}

	// Protects from prototype poisoning and unexpected merging up the prototype chain.
	function propertyIsUnsafe(target, key) {
		return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
			&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
				&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
	}

	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			getKeys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		getKeys(source).forEach(function(key) {
			if (propertyIsUnsafe(target, key)) {
				return
			}

			if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			} else {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			}
		});
		return destination
	}

	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
		// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
		// implementations can use it. The caller may not replace it.
		options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}

	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}

		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};

	var deepmerge_1 = deepmerge;

	cjs = deepmerge_1;
	return cjs;
}

var parseSrcsetExports = {};
var parseSrcset = {
  get exports(){ return parseSrcsetExports; },
  set exports(v){ parseSrcsetExports = v; },
};

/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */

var hasRequiredParseSrcset;

function requireParseSrcset () {
	if (hasRequiredParseSrcset) return parseSrcsetExports;
	hasRequiredParseSrcset = 1;
	(function (module) {
		(function (root, factory) {
			if (module.exports) {
				// Node. Does not work with strict CommonJS, but
				// only CommonJS-like environments that support module.exports,
				// like Node.
				module.exports = factory();
			} else {
				// Browser globals (root is window)
				root.parseSrcset = factory();
			}
		}(commonjsGlobal, function () {

			// 1. Let input be the value passed to this algorithm.
			return function (input) {

				// UTILITY FUNCTIONS

				// Manual is faster than RegEx
				// http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
				// http://jsperf.com/whitespace-character/5
				function isSpace(c) {
					return (c === "\u0020" || // space
					c === "\u0009" || // horizontal tab
					c === "\u000A" || // new line
					c === "\u000C" || // form feed
					c === "\u000D");  // carriage return
				}

				function collectCharacters(regEx) {
					var chars,
						match = regEx.exec(input.substring(pos));
					if (match) {
						chars = match[ 0 ];
						pos += chars.length;
						return chars;
					}
				}

				var inputLength = input.length,

					// (Don't use \s, to avoid matching non-breaking space)
					regexLeadingSpaces = /^[ \t\n\r\u000c]+/,
					regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/,
					regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/,
					regexTrailingCommas = /[,]+$/,
					regexNonNegativeInteger = /^\d+$/,

					// ( Positive or negative or unsigned integers or decimals, without or without exponents.
					// Must include at least one digit.
					// According to spec tests any decimal point must be followed by a digit.
					// No leading plus sign is allowed.)
					// https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
					regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,

					url,
					descriptors,
					currentDescriptor,
					state,
					c,

					// 2. Let position be a pointer into input, initially pointing at the start
					//    of the string.
					pos = 0,

					// 3. Let candidates be an initially empty source set.
					candidates = [];

				// 4. Splitting loop: Collect a sequence of characters that are space
				//    characters or U+002C COMMA characters. If any U+002C COMMA characters
				//    were collected, that is a parse error.
				while (true) {
					collectCharacters(regexLeadingCommasOrSpaces);

					// 5. If position is past the end of input, return candidates and abort these steps.
					if (pos >= inputLength) {
						return candidates; // (we're done, this is the sole return path)
					}

					// 6. Collect a sequence of characters that are not space characters,
					//    and let that be url.
					url = collectCharacters(regexLeadingNotSpaces);

					// 7. Let descriptors be a new empty list.
					descriptors = [];

					// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
					//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
					//         more than one character, that is a parse error.
					if (url.slice(-1) === ",") {
						url = url.replace(regexTrailingCommas, "");
						// (Jump ahead to step 9 to skip tokenization and just push the candidate).
						parseDescriptors();

						//	Otherwise, follow these substeps:
					} else {
						tokenize();
					} // (close else of step 8)

					// 16. Return to the step labeled splitting loop.
				} // (Close of big while loop.)

				/**
				 * Tokenizes descriptor properties prior to parsing
				 * Returns undefined.
				 */
				function tokenize() {

					// 8.1. Descriptor tokeniser: Skip whitespace
					collectCharacters(regexLeadingSpaces);

					// 8.2. Let current descriptor be the empty string.
					currentDescriptor = "";

					// 8.3. Let state be in descriptor.
					state = "in descriptor";

					while (true) {

						// 8.4. Let c be the character at position.
						c = input.charAt(pos);

						//  Do the following depending on the value of state.
						//  For the purpose of this step, "EOF" is a special character representing
						//  that position is past the end of input.

						// In descriptor
						if (state === "in descriptor") {
							// Do the following, depending on the value of c:

							// Space character
							// If current descriptor is not empty, append current descriptor to
							// descriptors and let current descriptor be the empty string.
							// Set state to after descriptor.
							if (isSpace(c)) {
								if (currentDescriptor) {
									descriptors.push(currentDescriptor);
									currentDescriptor = "";
									state = "after descriptor";
								}

								// U+002C COMMA (,)
								// Advance position to the next character in input. If current descriptor
								// is not empty, append current descriptor to descriptors. Jump to the step
								// labeled descriptor parser.
							} else if (c === ",") {
								pos += 1;
								if (currentDescriptor) {
									descriptors.push(currentDescriptor);
								}
								parseDescriptors();
								return;

								// U+0028 LEFT PARENTHESIS (()
								// Append c to current descriptor. Set state to in parens.
							} else if (c === "\u0028") {
								currentDescriptor = currentDescriptor + c;
								state = "in parens";

								// EOF
								// If current descriptor is not empty, append current descriptor to
								// descriptors. Jump to the step labeled descriptor parser.
							} else if (c === "") {
								if (currentDescriptor) {
									descriptors.push(currentDescriptor);
								}
								parseDescriptors();
								return;

								// Anything else
								// Append c to current descriptor.
							} else {
								currentDescriptor = currentDescriptor + c;
							}
							// (end "in descriptor"

							// In parens
						} else if (state === "in parens") {

							// U+0029 RIGHT PARENTHESIS ())
							// Append c to current descriptor. Set state to in descriptor.
							if (c === ")") {
								currentDescriptor = currentDescriptor + c;
								state = "in descriptor";

								// EOF
								// Append current descriptor to descriptors. Jump to the step labeled
								// descriptor parser.
							} else if (c === "") {
								descriptors.push(currentDescriptor);
								parseDescriptors();
								return;

								// Anything else
								// Append c to current descriptor.
							} else {
								currentDescriptor = currentDescriptor + c;
							}

							// After descriptor
						} else if (state === "after descriptor") {

							// Do the following, depending on the value of c:
							// Space character: Stay in this state.
							if (isSpace(c)) ; else if (c === "") {
								parseDescriptors();
								return;

								// Anything else
								// Set state to in descriptor. Set position to the previous character in input.
							} else {
								state = "in descriptor";
								pos -= 1;

							}
						}

						// Advance position to the next character in input.
						pos += 1;

						// Repeat this step.
					} // (close while true loop)
				}

				/**
				 * Adds descriptor properties to a candidate, pushes to the candidates array
				 * @return undefined
				 */
				// Declared outside of the while loop so that it's only created once.
				function parseDescriptors() {

					// 9. Descriptor parser: Let error be no.
					var pError = false,

						// 10. Let width be absent.
						// 11. Let density be absent.
						// 12. Let future-compat-h be absent. (We're implementing it now as h)
						w, d, h, i,
						candidate = {},
						desc, lastChar, value, intVal, floatVal;

					// 13. For each descriptor in descriptors, run the appropriate set of steps
					// from the following list:
					for (i = 0 ; i < descriptors.length; i++) {
						desc = descriptors[ i ];

						lastChar = desc[ desc.length - 1 ];
						value = desc.substring(0, desc.length - 1);
						intVal = parseInt(value, 10);
						floatVal = parseFloat(value);

						// If the descriptor consists of a valid non-negative integer followed by
						// a U+0077 LATIN SMALL LETTER W character
						if (regexNonNegativeInteger.test(value) && (lastChar === "w")) {

							// If width and density are not both absent, then let error be yes.
							if (w || d) {pError = true;}

							// Apply the rules for parsing non-negative integers to the descriptor.
							// If the result is zero, let error be yes.
							// Otherwise, let width be the result.
							if (intVal === 0) {pError = true;} else {w = intVal;}

							// If the descriptor consists of a valid floating-point number followed by
							// a U+0078 LATIN SMALL LETTER X character
						} else if (regexFloatingPoint.test(value) && (lastChar === "x")) {

							// If width, density and future-compat-h are not all absent, then let error
							// be yes.
							if (w || d || h) {pError = true;}

							// Apply the rules for parsing floating-point number values to the descriptor.
							// If the result is less than zero, let error be yes. Otherwise, let density
							// be the result.
							if (floatVal < 0) {pError = true;} else {d = floatVal;}

							// If the descriptor consists of a valid non-negative integer followed by
							// a U+0068 LATIN SMALL LETTER H character
						} else if (regexNonNegativeInteger.test(value) && (lastChar === "h")) {

							// If height and density are not both absent, then let error be yes.
							if (h || d) {pError = true;}

							// Apply the rules for parsing non-negative integers to the descriptor.
							// If the result is zero, let error be yes. Otherwise, let future-compat-h
							// be the result.
							if (intVal === 0) {pError = true;} else {h = intVal;}

							// Anything else, Let error be yes.
						} else {pError = true;}
					} // (close step 13 for loop)

					// 15. If error is still no, then append a new image source to candidates whose
					// URL is url, associated with a width width if not absent and a pixel
					// density density if not absent. Otherwise, there is a parse error.
					if (!pError) {
						candidate.url = url;
						if (w) { candidate.w = w;}
						if (d) { candidate.d = d;}
						if (h) { candidate.h = h;}
						candidates.push(candidate);
					} else if (console && console.log) {
						console.log("Invalid srcset descriptor found in '" +
							input + "' at '" + desc + "'.");
					}
				} // (close parseDescriptors fn)

			}
		}));
} (parseSrcset));
	return parseSrcsetExports;
}

var picocolors_browserExports = {};
var picocolors_browser = {
  get exports(){ return picocolors_browserExports; },
  set exports(v){ picocolors_browserExports = v; },
};

var hasRequiredPicocolors_browser;

function requirePicocolors_browser () {
	if (hasRequiredPicocolors_browser) return picocolors_browserExports;
	hasRequiredPicocolors_browser = 1;
	var x=String;
	var create=function() {return {isColorSupported:false,reset:x,bold:x,dim:x,italic:x,underline:x,inverse:x,hidden:x,strikethrough:x,black:x,red:x,green:x,yellow:x,blue:x,magenta:x,cyan:x,white:x,gray:x,bgBlack:x,bgRed:x,bgGreen:x,bgYellow:x,bgBlue:x,bgMagenta:x,bgCyan:x,bgWhite:x,blackBright:x,redBright:x,greenBright:x,yellowBright:x,blueBright:x,magentaBright:x,cyanBright:x,whiteBright:x,bgBlackBright:x,bgRedBright:x,bgGreenBright:x,bgYellowBright:x,bgBlueBright:x,bgMagentaBright:x,bgCyanBright:x,bgWhiteBright:x}};
	picocolors_browser.exports=create();
	picocolors_browserExports.createColors = create;
	return picocolors_browserExports;
}

var cssSyntaxError;
var hasRequiredCssSyntaxError;

function requireCssSyntaxError () {
	if (hasRequiredCssSyntaxError) return cssSyntaxError;
	hasRequiredCssSyntaxError = 1;

	let pico = requirePicocolors_browser();

	let terminalHighlight = require$$2;

	class CssSyntaxError extends Error {
	  constructor(message, line, column, source, file, plugin) {
	    super(message);
	    this.name = 'CssSyntaxError';
	    this.reason = message;

	    if (file) {
	      this.file = file;
	    }
	    if (source) {
	      this.source = source;
	    }
	    if (plugin) {
	      this.plugin = plugin;
	    }
	    if (typeof line !== 'undefined' && typeof column !== 'undefined') {
	      if (typeof line === 'number') {
	        this.line = line;
	        this.column = column;
	      } else {
	        this.line = line.line;
	        this.column = line.column;
	        this.endLine = column.line;
	        this.endColumn = column.column;
	      }
	    }

	    this.setMessage();

	    if (Error.captureStackTrace) {
	      Error.captureStackTrace(this, CssSyntaxError);
	    }
	  }

	  setMessage() {
	    this.message = this.plugin ? this.plugin + ': ' : '';
	    this.message += this.file ? this.file : '<css input>';
	    if (typeof this.line !== 'undefined') {
	      this.message += ':' + this.line + ':' + this.column;
	    }
	    this.message += ': ' + this.reason;
	  }

	  showSourceCode(color) {
	    if (!this.source) return ''

	    let css = this.source;
	    if (color == null) color = pico.isColorSupported;
	    if (terminalHighlight) {
	      if (color) css = terminalHighlight(css);
	    }

	    let lines = css.split(/\r?\n/);
	    let start = Math.max(this.line - 3, 0);
	    let end = Math.min(this.line + 2, lines.length);

	    let maxWidth = String(end).length;

	    let mark, aside;
	    if (color) {
	      let { bold, red, gray } = pico.createColors(true);
	      mark = text => bold(red(text));
	      aside = text => gray(text);
	    } else {
	      mark = aside = str => str;
	    }

	    return lines
	      .slice(start, end)
	      .map((line, index) => {
	        let number = start + 1 + index;
	        let gutter = ' ' + (' ' + number).slice(-maxWidth) + ' | ';
	        if (number === this.line) {
	          let spacing =
	            aside(gutter.replace(/\d/g, ' ')) +
	            line.slice(0, this.column - 1).replace(/[^\t]/g, ' ');
	          return mark('>') + aside(gutter) + line + '\n ' + spacing + mark('^')
	        }
	        return ' ' + aside(gutter) + line
	      })
	      .join('\n')
	  }

	  toString() {
	    let code = this.showSourceCode();
	    if (code) {
	      code = '\n\n' + code + '\n';
	    }
	    return this.name + ': ' + this.message + code
	  }
	}

	cssSyntaxError = CssSyntaxError;
	CssSyntaxError.default = CssSyntaxError;
	return cssSyntaxError;
}

var symbols = {};

var hasRequiredSymbols;

function requireSymbols () {
	if (hasRequiredSymbols) return symbols;
	hasRequiredSymbols = 1;

	symbols.isClean = Symbol('isClean');

	symbols.my = Symbol('my');
	return symbols;
}

var stringifier;
var hasRequiredStringifier;

function requireStringifier () {
	if (hasRequiredStringifier) return stringifier;
	hasRequiredStringifier = 1;

	const DEFAULT_RAW = {
	  colon: ': ',
	  indent: '    ',
	  beforeDecl: '\n',
	  beforeRule: '\n',
	  beforeOpen: ' ',
	  beforeClose: '\n',
	  beforeComment: '\n',
	  after: '\n',
	  emptyBody: '',
	  commentLeft: ' ',
	  commentRight: ' ',
	  semicolon: false
	};

	function capitalize(str) {
	  return str[0].toUpperCase() + str.slice(1)
	}

	class Stringifier {
	  constructor(builder) {
	    this.builder = builder;
	  }

	  stringify(node, semicolon) {
	    /* c8 ignore start */
	    if (!this[node.type]) {
	      throw new Error(
	        'Unknown AST node type ' +
	          node.type +
	          '. ' +
	          'Maybe you need to change PostCSS stringifier.'
	      )
	    }
	    /* c8 ignore stop */
	    this[node.type](node, semicolon);
	  }

	  document(node) {
	    this.body(node);
	  }

	  root(node) {
	    this.body(node);
	    if (node.raws.after) this.builder(node.raws.after);
	  }

	  comment(node) {
	    let left = this.raw(node, 'left', 'commentLeft');
	    let right = this.raw(node, 'right', 'commentRight');
	    this.builder('/*' + left + node.text + right + '*/', node);
	  }

	  decl(node, semicolon) {
	    let between = this.raw(node, 'between', 'colon');
	    let string = node.prop + between + this.rawValue(node, 'value');

	    if (node.important) {
	      string += node.raws.important || ' !important';
	    }

	    if (semicolon) string += ';';
	    this.builder(string, node);
	  }

	  rule(node) {
	    this.block(node, this.rawValue(node, 'selector'));
	    if (node.raws.ownSemicolon) {
	      this.builder(node.raws.ownSemicolon, node, 'end');
	    }
	  }

	  atrule(node, semicolon) {
	    let name = '@' + node.name;
	    let params = node.params ? this.rawValue(node, 'params') : '';

	    if (typeof node.raws.afterName !== 'undefined') {
	      name += node.raws.afterName;
	    } else if (params) {
	      name += ' ';
	    }

	    if (node.nodes) {
	      this.block(node, name + params);
	    } else {
	      let end = (node.raws.between || '') + (semicolon ? ';' : '');
	      this.builder(name + params + end, node);
	    }
	  }

	  body(node) {
	    let last = node.nodes.length - 1;
	    while (last > 0) {
	      if (node.nodes[last].type !== 'comment') break
	      last -= 1;
	    }

	    let semicolon = this.raw(node, 'semicolon');
	    for (let i = 0; i < node.nodes.length; i++) {
	      let child = node.nodes[i];
	      let before = this.raw(child, 'before');
	      if (before) this.builder(before);
	      this.stringify(child, last !== i || semicolon);
	    }
	  }

	  block(node, start) {
	    let between = this.raw(node, 'between', 'beforeOpen');
	    this.builder(start + between + '{', node, 'start');

	    let after;
	    if (node.nodes && node.nodes.length) {
	      this.body(node);
	      after = this.raw(node, 'after');
	    } else {
	      after = this.raw(node, 'after', 'emptyBody');
	    }

	    if (after) this.builder(after);
	    this.builder('}', node, 'end');
	  }

	  raw(node, own, detect) {
	    let value;
	    if (!detect) detect = own;

	    // Already had
	    if (own) {
	      value = node.raws[own];
	      if (typeof value !== 'undefined') return value
	    }

	    let parent = node.parent;

	    if (detect === 'before') {
	      // Hack for first rule in CSS
	      if (!parent || (parent.type === 'root' && parent.first === node)) {
	        return ''
	      }

	      // `root` nodes in `document` should use only their own raws
	      if (parent && parent.type === 'document') {
	        return ''
	      }
	    }

	    // Floating child without parent
	    if (!parent) return DEFAULT_RAW[detect]

	    // Detect style by other nodes
	    let root = node.root();
	    if (!root.rawCache) root.rawCache = {};
	    if (typeof root.rawCache[detect] !== 'undefined') {
	      return root.rawCache[detect]
	    }

	    if (detect === 'before' || detect === 'after') {
	      return this.beforeAfter(node, detect)
	    } else {
	      let method = 'raw' + capitalize(detect);
	      if (this[method]) {
	        value = this[method](root, node);
	      } else {
	        root.walk(i => {
	          value = i.raws[own];
	          if (typeof value !== 'undefined') return false
	        });
	      }
	    }

	    if (typeof value === 'undefined') value = DEFAULT_RAW[detect];

	    root.rawCache[detect] = value;
	    return value
	  }

	  rawSemicolon(root) {
	    let value;
	    root.walk(i => {
	      if (i.nodes && i.nodes.length && i.last.type === 'decl') {
	        value = i.raws.semicolon;
	        if (typeof value !== 'undefined') return false
	      }
	    });
	    return value
	  }

	  rawEmptyBody(root) {
	    let value;
	    root.walk(i => {
	      if (i.nodes && i.nodes.length === 0) {
	        value = i.raws.after;
	        if (typeof value !== 'undefined') return false
	      }
	    });
	    return value
	  }

	  rawIndent(root) {
	    if (root.raws.indent) return root.raws.indent
	    let value;
	    root.walk(i => {
	      let p = i.parent;
	      if (p && p !== root && p.parent && p.parent === root) {
	        if (typeof i.raws.before !== 'undefined') {
	          let parts = i.raws.before.split('\n');
	          value = parts[parts.length - 1];
	          value = value.replace(/\S/g, '');
	          return false
	        }
	      }
	    });
	    return value
	  }

	  rawBeforeComment(root, node) {
	    let value;
	    root.walkComments(i => {
	      if (typeof i.raws.before !== 'undefined') {
	        value = i.raws.before;
	        if (value.includes('\n')) {
	          value = value.replace(/[^\n]+$/, '');
	        }
	        return false
	      }
	    });
	    if (typeof value === 'undefined') {
	      value = this.raw(node, null, 'beforeDecl');
	    } else if (value) {
	      value = value.replace(/\S/g, '');
	    }
	    return value
	  }

	  rawBeforeDecl(root, node) {
	    let value;
	    root.walkDecls(i => {
	      if (typeof i.raws.before !== 'undefined') {
	        value = i.raws.before;
	        if (value.includes('\n')) {
	          value = value.replace(/[^\n]+$/, '');
	        }
	        return false
	      }
	    });
	    if (typeof value === 'undefined') {
	      value = this.raw(node, null, 'beforeRule');
	    } else if (value) {
	      value = value.replace(/\S/g, '');
	    }
	    return value
	  }

	  rawBeforeRule(root) {
	    let value;
	    root.walk(i => {
	      if (i.nodes && (i.parent !== root || root.first !== i)) {
	        if (typeof i.raws.before !== 'undefined') {
	          value = i.raws.before;
	          if (value.includes('\n')) {
	            value = value.replace(/[^\n]+$/, '');
	          }
	          return false
	        }
	      }
	    });
	    if (value) value = value.replace(/\S/g, '');
	    return value
	  }

	  rawBeforeClose(root) {
	    let value;
	    root.walk(i => {
	      if (i.nodes && i.nodes.length > 0) {
	        if (typeof i.raws.after !== 'undefined') {
	          value = i.raws.after;
	          if (value.includes('\n')) {
	            value = value.replace(/[^\n]+$/, '');
	          }
	          return false
	        }
	      }
	    });
	    if (value) value = value.replace(/\S/g, '');
	    return value
	  }

	  rawBeforeOpen(root) {
	    let value;
	    root.walk(i => {
	      if (i.type !== 'decl') {
	        value = i.raws.between;
	        if (typeof value !== 'undefined') return false
	      }
	    });
	    return value
	  }

	  rawColon(root) {
	    let value;
	    root.walkDecls(i => {
	      if (typeof i.raws.between !== 'undefined') {
	        value = i.raws.between.replace(/[^\s:]/g, '');
	        return false
	      }
	    });
	    return value
	  }

	  beforeAfter(node, detect) {
	    let value;
	    if (node.type === 'decl') {
	      value = this.raw(node, null, 'beforeDecl');
	    } else if (node.type === 'comment') {
	      value = this.raw(node, null, 'beforeComment');
	    } else if (detect === 'before') {
	      value = this.raw(node, null, 'beforeRule');
	    } else {
	      value = this.raw(node, null, 'beforeClose');
	    }

	    let buf = node.parent;
	    let depth = 0;
	    while (buf && buf.type !== 'root') {
	      depth += 1;
	      buf = buf.parent;
	    }

	    if (value.includes('\n')) {
	      let indent = this.raw(node, null, 'indent');
	      if (indent.length) {
	        for (let step = 0; step < depth; step++) value += indent;
	      }
	    }

	    return value
	  }

	  rawValue(node, prop) {
	    let value = node[prop];
	    let raw = node.raws[prop];
	    if (raw && raw.value === value) {
	      return raw.raw
	    }

	    return value
	  }
	}

	stringifier = Stringifier;
	Stringifier.default = Stringifier;
	return stringifier;
}

var stringify_1;
var hasRequiredStringify;

function requireStringify () {
	if (hasRequiredStringify) return stringify_1;
	hasRequiredStringify = 1;

	let Stringifier = requireStringifier();

	function stringify(node, builder) {
	  let str = new Stringifier(builder);
	  str.stringify(node);
	}

	stringify_1 = stringify;
	stringify.default = stringify;
	return stringify_1;
}

var node;
var hasRequiredNode;

function requireNode () {
	if (hasRequiredNode) return node;
	hasRequiredNode = 1;

	let { isClean, my } = requireSymbols();
	let CssSyntaxError = requireCssSyntaxError();
	let Stringifier = requireStringifier();
	let stringify = requireStringify();

	function cloneNode(obj, parent) {
	  let cloned = new obj.constructor();

	  for (let i in obj) {
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) {
	      /* c8 ignore next 2 */
	      continue
	    }
	    if (i === 'proxyCache') continue
	    let value = obj[i];
	    let type = typeof value;

	    if (i === 'parent' && type === 'object') {
	      if (parent) cloned[i] = parent;
	    } else if (i === 'source') {
	      cloned[i] = value;
	    } else if (Array.isArray(value)) {
	      cloned[i] = value.map(j => cloneNode(j, cloned));
	    } else {
	      if (type === 'object' && value !== null) value = cloneNode(value);
	      cloned[i] = value;
	    }
	  }

	  return cloned
	}

	class Node {
	  constructor(defaults = {}) {
	    this.raws = {};
	    this[isClean] = false;
	    this[my] = true;

	    for (let name in defaults) {
	      if (name === 'nodes') {
	        this.nodes = [];
	        for (let node of defaults[name]) {
	          if (typeof node.clone === 'function') {
	            this.append(node.clone());
	          } else {
	            this.append(node);
	          }
	        }
	      } else {
	        this[name] = defaults[name];
	      }
	    }
	  }

	  error(message, opts = {}) {
	    if (this.source) {
	      let { start, end } = this.rangeBy(opts);
	      return this.source.input.error(
	        message,
	        { line: start.line, column: start.column },
	        { line: end.line, column: end.column },
	        opts
	      )
	    }
	    return new CssSyntaxError(message)
	  }

	  warn(result, text, opts) {
	    let data = { node: this };
	    for (let i in opts) data[i] = opts[i];
	    return result.warn(text, data)
	  }

	  remove() {
	    if (this.parent) {
	      this.parent.removeChild(this);
	    }
	    this.parent = undefined;
	    return this
	  }

	  toString(stringifier = stringify) {
	    if (stringifier.stringify) stringifier = stringifier.stringify;
	    let result = '';
	    stringifier(this, i => {
	      result += i;
	    });
	    return result
	  }

	  assign(overrides = {}) {
	    for (let name in overrides) {
	      this[name] = overrides[name];
	    }
	    return this
	  }

	  clone(overrides = {}) {
	    let cloned = cloneNode(this);
	    for (let name in overrides) {
	      cloned[name] = overrides[name];
	    }
	    return cloned
	  }

	  cloneBefore(overrides = {}) {
	    let cloned = this.clone(overrides);
	    this.parent.insertBefore(this, cloned);
	    return cloned
	  }

	  cloneAfter(overrides = {}) {
	    let cloned = this.clone(overrides);
	    this.parent.insertAfter(this, cloned);
	    return cloned
	  }

	  replaceWith(...nodes) {
	    if (this.parent) {
	      let bookmark = this;
	      let foundSelf = false;
	      for (let node of nodes) {
	        if (node === this) {
	          foundSelf = true;
	        } else if (foundSelf) {
	          this.parent.insertAfter(bookmark, node);
	          bookmark = node;
	        } else {
	          this.parent.insertBefore(bookmark, node);
	        }
	      }

	      if (!foundSelf) {
	        this.remove();
	      }
	    }

	    return this
	  }

	  next() {
	    if (!this.parent) return undefined
	    let index = this.parent.index(this);
	    return this.parent.nodes[index + 1]
	  }

	  prev() {
	    if (!this.parent) return undefined
	    let index = this.parent.index(this);
	    return this.parent.nodes[index - 1]
	  }

	  before(add) {
	    this.parent.insertBefore(this, add);
	    return this
	  }

	  after(add) {
	    this.parent.insertAfter(this, add);
	    return this
	  }

	  root() {
	    let result = this;
	    while (result.parent && result.parent.type !== 'document') {
	      result = result.parent;
	    }
	    return result
	  }

	  raw(prop, defaultType) {
	    let str = new Stringifier();
	    return str.raw(this, prop, defaultType)
	  }

	  cleanRaws(keepBetween) {
	    delete this.raws.before;
	    delete this.raws.after;
	    if (!keepBetween) delete this.raws.between;
	  }

	  toJSON(_, inputs) {
	    let fixed = {};
	    let emitInputs = inputs == null;
	    inputs = inputs || new Map();
	    let inputsNextIndex = 0;

	    for (let name in this) {
	      if (!Object.prototype.hasOwnProperty.call(this, name)) {
	        /* c8 ignore next 2 */
	        continue
	      }
	      if (name === 'parent' || name === 'proxyCache') continue
	      let value = this[name];

	      if (Array.isArray(value)) {
	        fixed[name] = value.map(i => {
	          if (typeof i === 'object' && i.toJSON) {
	            return i.toJSON(null, inputs)
	          } else {
	            return i
	          }
	        });
	      } else if (typeof value === 'object' && value.toJSON) {
	        fixed[name] = value.toJSON(null, inputs);
	      } else if (name === 'source') {
	        let inputId = inputs.get(value.input);
	        if (inputId == null) {
	          inputId = inputsNextIndex;
	          inputs.set(value.input, inputsNextIndex);
	          inputsNextIndex++;
	        }
	        fixed[name] = {
	          inputId,
	          start: value.start,
	          end: value.end
	        };
	      } else {
	        fixed[name] = value;
	      }
	    }

	    if (emitInputs) {
	      fixed.inputs = [...inputs.keys()].map(input => input.toJSON());
	    }

	    return fixed
	  }

	  positionInside(index) {
	    let string = this.toString();
	    let column = this.source.start.column;
	    let line = this.source.start.line;

	    for (let i = 0; i < index; i++) {
	      if (string[i] === '\n') {
	        column = 1;
	        line += 1;
	      } else {
	        column += 1;
	      }
	    }

	    return { line, column }
	  }

	  positionBy(opts) {
	    let pos = this.source.start;
	    if (opts.index) {
	      pos = this.positionInside(opts.index);
	    } else if (opts.word) {
	      let index = this.toString().indexOf(opts.word);
	      if (index !== -1) pos = this.positionInside(index);
	    }
	    return pos
	  }

	  rangeBy(opts) {
	    let start = {
	      line: this.source.start.line,
	      column: this.source.start.column
	    };
	    let end = this.source.end
	      ? {
	          line: this.source.end.line,
	          column: this.source.end.column + 1
	        }
	      : {
	          line: start.line,
	          column: start.column + 1
	        };

	    if (opts.word) {
	      let index = this.toString().indexOf(opts.word);
	      if (index !== -1) {
	        start = this.positionInside(index);
	        end = this.positionInside(index + opts.word.length);
	      }
	    } else {
	      if (opts.start) {
	        start = {
	          line: opts.start.line,
	          column: opts.start.column
	        };
	      } else if (opts.index) {
	        start = this.positionInside(opts.index);
	      }

	      if (opts.end) {
	        end = {
	          line: opts.end.line,
	          column: opts.end.column
	        };
	      } else if (opts.endIndex) {
	        end = this.positionInside(opts.endIndex);
	      } else if (opts.index) {
	        end = this.positionInside(opts.index + 1);
	      }
	    }

	    if (
	      end.line < start.line ||
	      (end.line === start.line && end.column <= start.column)
	    ) {
	      end = { line: start.line, column: start.column + 1 };
	    }

	    return { start, end }
	  }

	  getProxyProcessor() {
	    return {
	      set(node, prop, value) {
	        if (node[prop] === value) return true
	        node[prop] = value;
	        if (
	          prop === 'prop' ||
	          prop === 'value' ||
	          prop === 'name' ||
	          prop === 'params' ||
	          prop === 'important' ||
	          /* c8 ignore next */
	          prop === 'text'
	        ) {
	          node.markDirty();
	        }
	        return true
	      },

	      get(node, prop) {
	        if (prop === 'proxyOf') {
	          return node
	        } else if (prop === 'root') {
	          return () => node.root().toProxy()
	        } else {
	          return node[prop]
	        }
	      }
	    }
	  }

	  toProxy() {
	    if (!this.proxyCache) {
	      this.proxyCache = new Proxy(this, this.getProxyProcessor());
	    }
	    return this.proxyCache
	  }

	  addToError(error) {
	    error.postcssNode = this;
	    if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
	      let s = this.source;
	      error.stack = error.stack.replace(
	        /\n\s{4}at /,
	        `$&${s.input.from}:${s.start.line}:${s.start.column}$&`
	      );
	    }
	    return error
	  }

	  markDirty() {
	    if (this[isClean]) {
	      this[isClean] = false;
	      let next = this;
	      while ((next = next.parent)) {
	        next[isClean] = false;
	      }
	    }
	  }

	  get proxyOf() {
	    return this
	  }
	}

	node = Node;
	Node.default = Node;
	return node;
}

var declaration;
var hasRequiredDeclaration;

function requireDeclaration () {
	if (hasRequiredDeclaration) return declaration;
	hasRequiredDeclaration = 1;

	let Node = requireNode();

	class Declaration extends Node {
	  constructor(defaults) {
	    if (
	      defaults &&
	      typeof defaults.value !== 'undefined' &&
	      typeof defaults.value !== 'string'
	    ) {
	      defaults = { ...defaults, value: String(defaults.value) };
	    }
	    super(defaults);
	    this.type = 'decl';
	  }

	  get variable() {
	    return this.prop.startsWith('--') || this.prop[0] === '$'
	  }
	}

	declaration = Declaration;
	Declaration.default = Declaration;
	return declaration;
}

var nonSecure;
var hasRequiredNonSecure;

function requireNonSecure () {
	if (hasRequiredNonSecure) return nonSecure;
	hasRequiredNonSecure = 1;
	let urlAlphabet =
	  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
	let customAlphabet = (alphabet, defaultSize = 21) => {
	  return (size = defaultSize) => {
	    let id = '';
	    let i = size;
	    while (i--) {
	      id += alphabet[(Math.random() * alphabet.length) | 0];
	    }
	    return id
	  }
	};
	let nanoid = (size = 21) => {
	  let id = '';
	  let i = size;
	  while (i--) {
	    id += urlAlphabet[(Math.random() * 64) | 0];
	  }
	  return id
	};
	nonSecure = { nanoid, customAlphabet };
	return nonSecure;
}

var previousMap;
var hasRequiredPreviousMap;

function requirePreviousMap () {
	if (hasRequiredPreviousMap) return previousMap;
	hasRequiredPreviousMap = 1;

	let { SourceMapConsumer, SourceMapGenerator } = require$$2;
	let { existsSync, readFileSync } = require$$2;
	let { dirname, join } = require$$2;

	function fromBase64(str) {
	  if (Buffer) {
	    return Buffer.from(str, 'base64').toString()
	  } else {
	    /* c8 ignore next 2 */
	    return window.atob(str)
	  }
	}

	class PreviousMap {
	  constructor(css, opts) {
	    if (opts.map === false) return
	    this.loadAnnotation(css);
	    this.inline = this.startWith(this.annotation, 'data:');

	    let prev = opts.map ? opts.map.prev : undefined;
	    let text = this.loadMap(opts.from, prev);
	    if (!this.mapFile && opts.from) {
	      this.mapFile = opts.from;
	    }
	    if (this.mapFile) this.root = dirname(this.mapFile);
	    if (text) this.text = text;
	  }

	  consumer() {
	    if (!this.consumerCache) {
	      this.consumerCache = new SourceMapConsumer(this.text);
	    }
	    return this.consumerCache
	  }

	  withContent() {
	    return !!(
	      this.consumer().sourcesContent &&
	      this.consumer().sourcesContent.length > 0
	    )
	  }

	  startWith(string, start) {
	    if (!string) return false
	    return string.substr(0, start.length) === start
	  }

	  getAnnotationURL(sourceMapString) {
	    return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, '').trim()
	  }

	  loadAnnotation(css) {
	    let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
	    if (!comments) return

	    // sourceMappingURLs from comments, strings, etc.
	    let start = css.lastIndexOf(comments.pop());
	    let end = css.indexOf('*/', start);

	    if (start > -1 && end > -1) {
	      // Locate the last sourceMappingURL to avoid pickin
	      this.annotation = this.getAnnotationURL(css.substring(start, end));
	    }
	  }

	  decodeInline(text) {
	    let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
	    let baseUri = /^data:application\/json;base64,/;
	    let charsetUri = /^data:application\/json;charset=utf-?8,/;
	    let uri = /^data:application\/json,/;

	    if (charsetUri.test(text) || uri.test(text)) {
	      return decodeURIComponent(text.substr(RegExp.lastMatch.length))
	    }

	    if (baseCharsetUri.test(text) || baseUri.test(text)) {
	      return fromBase64(text.substr(RegExp.lastMatch.length))
	    }

	    let encoding = text.match(/data:application\/json;([^,]+),/)[1];
	    throw new Error('Unsupported source map encoding ' + encoding)
	  }

	  loadFile(path) {
	    this.root = dirname(path);
	    if (existsSync(path)) {
	      this.mapFile = path;
	      return readFileSync(path, 'utf-8').toString().trim()
	    }
	  }

	  loadMap(file, prev) {
	    if (prev === false) return false

	    if (prev) {
	      if (typeof prev === 'string') {
	        return prev
	      } else if (typeof prev === 'function') {
	        let prevPath = prev(file);
	        if (prevPath) {
	          let map = this.loadFile(prevPath);
	          if (!map) {
	            throw new Error(
	              'Unable to load previous source map: ' + prevPath.toString()
	            )
	          }
	          return map
	        }
	      } else if (prev instanceof SourceMapConsumer) {
	        return SourceMapGenerator.fromSourceMap(prev).toString()
	      } else if (prev instanceof SourceMapGenerator) {
	        return prev.toString()
	      } else if (this.isMap(prev)) {
	        return JSON.stringify(prev)
	      } else {
	        throw new Error(
	          'Unsupported previous source map format: ' + prev.toString()
	        )
	      }
	    } else if (this.inline) {
	      return this.decodeInline(this.annotation)
	    } else if (this.annotation) {
	      let map = this.annotation;
	      if (file) map = join(dirname(file), map);
	      return this.loadFile(map)
	    }
	  }

	  isMap(map) {
	    if (typeof map !== 'object') return false
	    return (
	      typeof map.mappings === 'string' ||
	      typeof map._mappings === 'string' ||
	      Array.isArray(map.sections)
	    )
	  }
	}

	previousMap = PreviousMap;
	PreviousMap.default = PreviousMap;
	return previousMap;
}

var input;
var hasRequiredInput;

function requireInput () {
	if (hasRequiredInput) return input;
	hasRequiredInput = 1;

	let { SourceMapConsumer, SourceMapGenerator } = require$$2;
	let { fileURLToPath, pathToFileURL } = require$$2;
	let { resolve, isAbsolute } = require$$2;
	let { nanoid } = requireNonSecure();

	let terminalHighlight = require$$2;
	let CssSyntaxError = requireCssSyntaxError();
	let PreviousMap = requirePreviousMap();

	let fromOffsetCache = Symbol('fromOffsetCache');

	let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
	let pathAvailable = Boolean(resolve && isAbsolute);

	class Input {
	  constructor(css, opts = {}) {
	    if (
	      css === null ||
	      typeof css === 'undefined' ||
	      (typeof css === 'object' && !css.toString)
	    ) {
	      throw new Error(`PostCSS received ${css} instead of CSS string`)
	    }

	    this.css = css.toString();

	    if (this.css[0] === '\uFEFF' || this.css[0] === '\uFFFE') {
	      this.hasBOM = true;
	      this.css = this.css.slice(1);
	    } else {
	      this.hasBOM = false;
	    }

	    if (opts.from) {
	      if (
	        !pathAvailable ||
	        /^\w+:\/\//.test(opts.from) ||
	        isAbsolute(opts.from)
	      ) {
	        this.file = opts.from;
	      } else {
	        this.file = resolve(opts.from);
	      }
	    }

	    if (pathAvailable && sourceMapAvailable) {
	      let map = new PreviousMap(this.css, opts);
	      if (map.text) {
	        this.map = map;
	        let file = map.consumer().file;
	        if (!this.file && file) this.file = this.mapResolve(file);
	      }
	    }

	    if (!this.file) {
	      this.id = '<input css ' + nanoid(6) + '>';
	    }
	    if (this.map) this.map.file = this.from;
	  }

	  fromOffset(offset) {
	    let lastLine, lineToIndex;
	    if (!this[fromOffsetCache]) {
	      let lines = this.css.split('\n');
	      lineToIndex = new Array(lines.length);
	      let prevIndex = 0;

	      for (let i = 0, l = lines.length; i < l; i++) {
	        lineToIndex[i] = prevIndex;
	        prevIndex += lines[i].length + 1;
	      }

	      this[fromOffsetCache] = lineToIndex;
	    } else {
	      lineToIndex = this[fromOffsetCache];
	    }
	    lastLine = lineToIndex[lineToIndex.length - 1];

	    let min = 0;
	    if (offset >= lastLine) {
	      min = lineToIndex.length - 1;
	    } else {
	      let max = lineToIndex.length - 2;
	      let mid;
	      while (min < max) {
	        mid = min + ((max - min) >> 1);
	        if (offset < lineToIndex[mid]) {
	          max = mid - 1;
	        } else if (offset >= lineToIndex[mid + 1]) {
	          min = mid + 1;
	        } else {
	          min = mid;
	          break
	        }
	      }
	    }
	    return {
	      line: min + 1,
	      col: offset - lineToIndex[min] + 1
	    }
	  }

	  error(message, line, column, opts = {}) {
	    let result, endLine, endColumn;

	    if (line && typeof line === 'object') {
	      let start = line;
	      let end = column;
	      if (typeof line.offset === 'number') {
	        let pos = this.fromOffset(start.offset);
	        line = pos.line;
	        column = pos.col;
	      } else {
	        line = start.line;
	        column = start.column;
	      }
	      if (typeof end.offset === 'number') {
	        let pos = this.fromOffset(end.offset);
	        endLine = pos.line;
	        endColumn = pos.col;
	      } else {
	        endLine = end.line;
	        endColumn = end.column;
	      }
	    } else if (!column) {
	      let pos = this.fromOffset(line);
	      line = pos.line;
	      column = pos.col;
	    }

	    let origin = this.origin(line, column, endLine, endColumn);
	    if (origin) {
	      result = new CssSyntaxError(
	        message,
	        origin.endLine === undefined
	          ? origin.line
	          : { line: origin.line, column: origin.column },
	        origin.endLine === undefined
	          ? origin.column
	          : { line: origin.endLine, column: origin.endColumn },
	        origin.source,
	        origin.file,
	        opts.plugin
	      );
	    } else {
	      result = new CssSyntaxError(
	        message,
	        endLine === undefined ? line : { line, column },
	        endLine === undefined ? column : { line: endLine, column: endColumn },
	        this.css,
	        this.file,
	        opts.plugin
	      );
	    }

	    result.input = { line, column, endLine, endColumn, source: this.css };
	    if (this.file) {
	      if (pathToFileURL) {
	        result.input.url = pathToFileURL(this.file).toString();
	      }
	      result.input.file = this.file;
	    }

	    return result
	  }

	  origin(line, column, endLine, endColumn) {
	    if (!this.map) return false
	    let consumer = this.map.consumer();

	    let from = consumer.originalPositionFor({ line, column });
	    if (!from.source) return false

	    let to;
	    if (typeof endLine === 'number') {
	      to = consumer.originalPositionFor({ line: endLine, column: endColumn });
	    }

	    let fromUrl;

	    if (isAbsolute(from.source)) {
	      fromUrl = pathToFileURL(from.source);
	    } else {
	      fromUrl = new URL(
	        from.source,
	        this.map.consumer().sourceRoot || pathToFileURL(this.map.mapFile)
	      );
	    }

	    let result = {
	      url: fromUrl.toString(),
	      line: from.line,
	      column: from.column,
	      endLine: to && to.line,
	      endColumn: to && to.column
	    };

	    if (fromUrl.protocol === 'file:') {
	      if (fileURLToPath) {
	        result.file = fileURLToPath(fromUrl);
	      } else {
	        /* c8 ignore next 2 */
	        throw new Error(`file: protocol is not available in this PostCSS build`)
	      }
	    }

	    let source = consumer.sourceContentFor(from.source);
	    if (source) result.source = source;

	    return result
	  }

	  mapResolve(file) {
	    if (/^\w+:\/\//.test(file)) {
	      return file
	    }
	    return resolve(this.map.consumer().sourceRoot || this.map.root || '.', file)
	  }

	  get from() {
	    return this.file || this.id
	  }

	  toJSON() {
	    let json = {};
	    for (let name of ['hasBOM', 'css', 'file', 'id']) {
	      if (this[name] != null) {
	        json[name] = this[name];
	      }
	    }
	    if (this.map) {
	      json.map = { ...this.map };
	      if (json.map.consumerCache) {
	        json.map.consumerCache = undefined;
	      }
	    }
	    return json
	  }
	}

	input = Input;
	Input.default = Input;

	if (terminalHighlight && terminalHighlight.registerInput) {
	  terminalHighlight.registerInput(Input);
	}
	return input;
}

var mapGenerator;
var hasRequiredMapGenerator;

function requireMapGenerator () {
	if (hasRequiredMapGenerator) return mapGenerator;
	hasRequiredMapGenerator = 1;

	let { SourceMapConsumer, SourceMapGenerator } = require$$2;
	let { dirname, resolve, relative, sep } = require$$2;
	let { pathToFileURL } = require$$2;

	let Input = requireInput();

	let sourceMapAvailable = Boolean(SourceMapConsumer && SourceMapGenerator);
	let pathAvailable = Boolean(dirname && resolve && relative && sep);

	class MapGenerator {
	  constructor(stringify, root, opts, cssString) {
	    this.stringify = stringify;
	    this.mapOpts = opts.map || {};
	    this.root = root;
	    this.opts = opts;
	    this.css = cssString;
	    this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
	  }

	  isMap() {
	    if (typeof this.opts.map !== 'undefined') {
	      return !!this.opts.map
	    }
	    return this.previous().length > 0
	  }

	  previous() {
	    if (!this.previousMaps) {
	      this.previousMaps = [];
	      if (this.root) {
	        this.root.walk(node => {
	          if (node.source && node.source.input.map) {
	            let map = node.source.input.map;
	            if (!this.previousMaps.includes(map)) {
	              this.previousMaps.push(map);
	            }
	          }
	        });
	      } else {
	        let input = new Input(this.css, this.opts);
	        if (input.map) this.previousMaps.push(input.map);
	      }
	    }

	    return this.previousMaps
	  }

	  isInline() {
	    if (typeof this.mapOpts.inline !== 'undefined') {
	      return this.mapOpts.inline
	    }

	    let annotation = this.mapOpts.annotation;
	    if (typeof annotation !== 'undefined' && annotation !== true) {
	      return false
	    }

	    if (this.previous().length) {
	      return this.previous().some(i => i.inline)
	    }
	    return true
	  }

	  isSourcesContent() {
	    if (typeof this.mapOpts.sourcesContent !== 'undefined') {
	      return this.mapOpts.sourcesContent
	    }
	    if (this.previous().length) {
	      return this.previous().some(i => i.withContent())
	    }
	    return true
	  }

	  clearAnnotation() {
	    if (this.mapOpts.annotation === false) return

	    if (this.root) {
	      let node;
	      for (let i = this.root.nodes.length - 1; i >= 0; i--) {
	        node = this.root.nodes[i];
	        if (node.type !== 'comment') continue
	        if (node.text.indexOf('# sourceMappingURL=') === 0) {
	          this.root.removeChild(i);
	        }
	      }
	    } else if (this.css) {
	      this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, '');
	    }
	  }

	  setSourcesContent() {
	    let already = {};
	    if (this.root) {
	      this.root.walk(node => {
	        if (node.source) {
	          let from = node.source.input.from;
	          if (from && !already[from]) {
	            already[from] = true;
	            let fromUrl = this.usesFileUrls
	              ? this.toFileUrl(from)
	              : this.toUrl(this.path(from));
	            this.map.setSourceContent(fromUrl, node.source.input.css);
	          }
	        }
	      });
	    } else if (this.css) {
	      let from = this.opts.from
	        ? this.toUrl(this.path(this.opts.from))
	        : '<no source>';
	      this.map.setSourceContent(from, this.css);
	    }
	  }

	  applyPrevMaps() {
	    for (let prev of this.previous()) {
	      let from = this.toUrl(this.path(prev.file));
	      let root = prev.root || dirname(prev.file);
	      let map;

	      if (this.mapOpts.sourcesContent === false) {
	        map = new SourceMapConsumer(prev.text);
	        if (map.sourcesContent) {
	          map.sourcesContent = map.sourcesContent.map(() => null);
	        }
	      } else {
	        map = prev.consumer();
	      }

	      this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
	    }
	  }

	  isAnnotation() {
	    if (this.isInline()) {
	      return true
	    }
	    if (typeof this.mapOpts.annotation !== 'undefined') {
	      return this.mapOpts.annotation
	    }
	    if (this.previous().length) {
	      return this.previous().some(i => i.annotation)
	    }
	    return true
	  }

	  toBase64(str) {
	    if (Buffer) {
	      return Buffer.from(str).toString('base64')
	    } else {
	      return window.btoa(unescape(encodeURIComponent(str)))
	    }
	  }

	  addAnnotation() {
	    let content;

	    if (this.isInline()) {
	      content =
	        'data:application/json;base64,' + this.toBase64(this.map.toString());
	    } else if (typeof this.mapOpts.annotation === 'string') {
	      content = this.mapOpts.annotation;
	    } else if (typeof this.mapOpts.annotation === 'function') {
	      content = this.mapOpts.annotation(this.opts.to, this.root);
	    } else {
	      content = this.outputFile() + '.map';
	    }
	    let eol = '\n';
	    if (this.css.includes('\r\n')) eol = '\r\n';

	    this.css += eol + '/*# sourceMappingURL=' + content + ' */';
	  }

	  outputFile() {
	    if (this.opts.to) {
	      return this.path(this.opts.to)
	    } else if (this.opts.from) {
	      return this.path(this.opts.from)
	    } else {
	      return 'to.css'
	    }
	  }

	  generateMap() {
	    if (this.root) {
	      this.generateString();
	    } else if (this.previous().length === 1) {
	      let prev = this.previous()[0].consumer();
	      prev.file = this.outputFile();
	      this.map = SourceMapGenerator.fromSourceMap(prev);
	    } else {
	      this.map = new SourceMapGenerator({ file: this.outputFile() });
	      this.map.addMapping({
	        source: this.opts.from
	          ? this.toUrl(this.path(this.opts.from))
	          : '<no source>',
	        generated: { line: 1, column: 0 },
	        original: { line: 1, column: 0 }
	      });
	    }

	    if (this.isSourcesContent()) this.setSourcesContent();
	    if (this.root && this.previous().length > 0) this.applyPrevMaps();
	    if (this.isAnnotation()) this.addAnnotation();

	    if (this.isInline()) {
	      return [this.css]
	    } else {
	      return [this.css, this.map]
	    }
	  }

	  path(file) {
	    if (file.indexOf('<') === 0) return file
	    if (/^\w+:\/\//.test(file)) return file
	    if (this.mapOpts.absolute) return file

	    let from = this.opts.to ? dirname(this.opts.to) : '.';

	    if (typeof this.mapOpts.annotation === 'string') {
	      from = dirname(resolve(from, this.mapOpts.annotation));
	    }

	    file = relative(from, file);
	    return file
	  }

	  toUrl(path) {
	    if (sep === '\\') {
	      path = path.replace(/\\/g, '/');
	    }
	    return encodeURI(path).replace(/[#?]/g, encodeURIComponent)
	  }

	  toFileUrl(path) {
	    if (pathToFileURL) {
	      return pathToFileURL(path).toString()
	    } else {
	      throw new Error(
	        '`map.absolute` option is not available in this PostCSS build'
	      )
	    }
	  }

	  sourcePath(node) {
	    if (this.mapOpts.from) {
	      return this.toUrl(this.mapOpts.from)
	    } else if (this.usesFileUrls) {
	      return this.toFileUrl(node.source.input.from)
	    } else {
	      return this.toUrl(this.path(node.source.input.from))
	    }
	  }

	  generateString() {
	    this.css = '';
	    this.map = new SourceMapGenerator({ file: this.outputFile() });

	    let line = 1;
	    let column = 1;

	    let noSource = '<no source>';
	    let mapping = {
	      source: '',
	      generated: { line: 0, column: 0 },
	      original: { line: 0, column: 0 }
	    };

	    let lines, last;
	    this.stringify(this.root, (str, node, type) => {
	      this.css += str;

	      if (node && type !== 'end') {
	        mapping.generated.line = line;
	        mapping.generated.column = column - 1;
	        if (node.source && node.source.start) {
	          mapping.source = this.sourcePath(node);
	          mapping.original.line = node.source.start.line;
	          mapping.original.column = node.source.start.column - 1;
	          this.map.addMapping(mapping);
	        } else {
	          mapping.source = noSource;
	          mapping.original.line = 1;
	          mapping.original.column = 0;
	          this.map.addMapping(mapping);
	        }
	      }

	      lines = str.match(/\n/g);
	      if (lines) {
	        line += lines.length;
	        last = str.lastIndexOf('\n');
	        column = str.length - last;
	      } else {
	        column += str.length;
	      }

	      if (node && type !== 'start') {
	        let p = node.parent || { raws: {} };
	        if (node.type !== 'decl' || node !== p.last || p.raws.semicolon) {
	          if (node.source && node.source.end) {
	            mapping.source = this.sourcePath(node);
	            mapping.original.line = node.source.end.line;
	            mapping.original.column = node.source.end.column - 1;
	            mapping.generated.line = line;
	            mapping.generated.column = column - 2;
	            this.map.addMapping(mapping);
	          } else {
	            mapping.source = noSource;
	            mapping.original.line = 1;
	            mapping.original.column = 0;
	            mapping.generated.line = line;
	            mapping.generated.column = column - 1;
	            this.map.addMapping(mapping);
	          }
	        }
	      }
	    });
	  }

	  generate() {
	    this.clearAnnotation();
	    if (pathAvailable && sourceMapAvailable && this.isMap()) {
	      return this.generateMap()
	    } else {
	      let result = '';
	      this.stringify(this.root, i => {
	        result += i;
	      });
	      return [result]
	    }
	  }
	}

	mapGenerator = MapGenerator;
	return mapGenerator;
}

var comment;
var hasRequiredComment;

function requireComment () {
	if (hasRequiredComment) return comment;
	hasRequiredComment = 1;

	let Node = requireNode();

	class Comment extends Node {
	  constructor(defaults) {
	    super(defaults);
	    this.type = 'comment';
	  }
	}

	comment = Comment;
	Comment.default = Comment;
	return comment;
}

var container;
var hasRequiredContainer;

function requireContainer () {
	if (hasRequiredContainer) return container;
	hasRequiredContainer = 1;

	let { isClean, my } = requireSymbols();
	let Declaration = requireDeclaration();
	let Comment = requireComment();
	let Node = requireNode();

	let parse, Rule, AtRule, Root;

	function cleanSource(nodes) {
	  return nodes.map(i => {
	    if (i.nodes) i.nodes = cleanSource(i.nodes);
	    delete i.source;
	    return i
	  })
	}

	function markDirtyUp(node) {
	  node[isClean] = false;
	  if (node.proxyOf.nodes) {
	    for (let i of node.proxyOf.nodes) {
	      markDirtyUp(i);
	    }
	  }
	}

	class Container extends Node {
	  push(child) {
	    child.parent = this;
	    this.proxyOf.nodes.push(child);
	    return this
	  }

	  each(callback) {
	    if (!this.proxyOf.nodes) return undefined
	    let iterator = this.getIterator();

	    let index, result;
	    while (this.indexes[iterator] < this.proxyOf.nodes.length) {
	      index = this.indexes[iterator];
	      result = callback(this.proxyOf.nodes[index], index);
	      if (result === false) break

	      this.indexes[iterator] += 1;
	    }

	    delete this.indexes[iterator];
	    return result
	  }

	  walk(callback) {
	    return this.each((child, i) => {
	      let result;
	      try {
	        result = callback(child, i);
	      } catch (e) {
	        throw child.addToError(e)
	      }
	      if (result !== false && child.walk) {
	        result = child.walk(callback);
	      }

	      return result
	    })
	  }

	  walkDecls(prop, callback) {
	    if (!callback) {
	      callback = prop;
	      return this.walk((child, i) => {
	        if (child.type === 'decl') {
	          return callback(child, i)
	        }
	      })
	    }
	    if (prop instanceof RegExp) {
	      return this.walk((child, i) => {
	        if (child.type === 'decl' && prop.test(child.prop)) {
	          return callback(child, i)
	        }
	      })
	    }
	    return this.walk((child, i) => {
	      if (child.type === 'decl' && child.prop === prop) {
	        return callback(child, i)
	      }
	    })
	  }

	  walkRules(selector, callback) {
	    if (!callback) {
	      callback = selector;

	      return this.walk((child, i) => {
	        if (child.type === 'rule') {
	          return callback(child, i)
	        }
	      })
	    }
	    if (selector instanceof RegExp) {
	      return this.walk((child, i) => {
	        if (child.type === 'rule' && selector.test(child.selector)) {
	          return callback(child, i)
	        }
	      })
	    }
	    return this.walk((child, i) => {
	      if (child.type === 'rule' && child.selector === selector) {
	        return callback(child, i)
	      }
	    })
	  }

	  walkAtRules(name, callback) {
	    if (!callback) {
	      callback = name;
	      return this.walk((child, i) => {
	        if (child.type === 'atrule') {
	          return callback(child, i)
	        }
	      })
	    }
	    if (name instanceof RegExp) {
	      return this.walk((child, i) => {
	        if (child.type === 'atrule' && name.test(child.name)) {
	          return callback(child, i)
	        }
	      })
	    }
	    return this.walk((child, i) => {
	      if (child.type === 'atrule' && child.name === name) {
	        return callback(child, i)
	      }
	    })
	  }

	  walkComments(callback) {
	    return this.walk((child, i) => {
	      if (child.type === 'comment') {
	        return callback(child, i)
	      }
	    })
	  }

	  append(...children) {
	    for (let child of children) {
	      let nodes = this.normalize(child, this.last);
	      for (let node of nodes) this.proxyOf.nodes.push(node);
	    }

	    this.markDirty();

	    return this
	  }

	  prepend(...children) {
	    children = children.reverse();
	    for (let child of children) {
	      let nodes = this.normalize(child, this.first, 'prepend').reverse();
	      for (let node of nodes) this.proxyOf.nodes.unshift(node);
	      for (let id in this.indexes) {
	        this.indexes[id] = this.indexes[id] + nodes.length;
	      }
	    }

	    this.markDirty();

	    return this
	  }

	  cleanRaws(keepBetween) {
	    super.cleanRaws(keepBetween);
	    if (this.nodes) {
	      for (let node of this.nodes) node.cleanRaws(keepBetween);
	    }
	  }

	  insertBefore(exist, add) {
	    let existIndex = this.index(exist);
	    let type = existIndex === 0 ? 'prepend' : false;
	    let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
	    existIndex = this.index(exist);
	    for (let node of nodes) this.proxyOf.nodes.splice(existIndex, 0, node);

	    let index;
	    for (let id in this.indexes) {
	      index = this.indexes[id];
	      if (existIndex <= index) {
	        this.indexes[id] = index + nodes.length;
	      }
	    }

	    this.markDirty();

	    return this
	  }

	  insertAfter(exist, add) {
	    let existIndex = this.index(exist);
	    let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
	    existIndex = this.index(exist);
	    for (let node of nodes) this.proxyOf.nodes.splice(existIndex + 1, 0, node);

	    let index;
	    for (let id in this.indexes) {
	      index = this.indexes[id];
	      if (existIndex < index) {
	        this.indexes[id] = index + nodes.length;
	      }
	    }

	    this.markDirty();

	    return this
	  }

	  removeChild(child) {
	    child = this.index(child);
	    this.proxyOf.nodes[child].parent = undefined;
	    this.proxyOf.nodes.splice(child, 1);

	    let index;
	    for (let id in this.indexes) {
	      index = this.indexes[id];
	      if (index >= child) {
	        this.indexes[id] = index - 1;
	      }
	    }

	    this.markDirty();

	    return this
	  }

	  removeAll() {
	    for (let node of this.proxyOf.nodes) node.parent = undefined;
	    this.proxyOf.nodes = [];

	    this.markDirty();

	    return this
	  }

	  replaceValues(pattern, opts, callback) {
	    if (!callback) {
	      callback = opts;
	      opts = {};
	    }

	    this.walkDecls(decl => {
	      if (opts.props && !opts.props.includes(decl.prop)) return
	      if (opts.fast && !decl.value.includes(opts.fast)) return

	      decl.value = decl.value.replace(pattern, callback);
	    });

	    this.markDirty();

	    return this
	  }

	  every(condition) {
	    return this.nodes.every(condition)
	  }

	  some(condition) {
	    return this.nodes.some(condition)
	  }

	  index(child) {
	    if (typeof child === 'number') return child
	    if (child.proxyOf) child = child.proxyOf;
	    return this.proxyOf.nodes.indexOf(child)
	  }

	  get first() {
	    if (!this.proxyOf.nodes) return undefined
	    return this.proxyOf.nodes[0]
	  }

	  get last() {
	    if (!this.proxyOf.nodes) return undefined
	    return this.proxyOf.nodes[this.proxyOf.nodes.length - 1]
	  }

	  normalize(nodes, sample) {
	    if (typeof nodes === 'string') {
	      nodes = cleanSource(parse(nodes).nodes);
	    } else if (Array.isArray(nodes)) {
	      nodes = nodes.slice(0);
	      for (let i of nodes) {
	        if (i.parent) i.parent.removeChild(i, 'ignore');
	      }
	    } else if (nodes.type === 'root' && this.type !== 'document') {
	      nodes = nodes.nodes.slice(0);
	      for (let i of nodes) {
	        if (i.parent) i.parent.removeChild(i, 'ignore');
	      }
	    } else if (nodes.type) {
	      nodes = [nodes];
	    } else if (nodes.prop) {
	      if (typeof nodes.value === 'undefined') {
	        throw new Error('Value field is missed in node creation')
	      } else if (typeof nodes.value !== 'string') {
	        nodes.value = String(nodes.value);
	      }
	      nodes = [new Declaration(nodes)];
	    } else if (nodes.selector) {
	      nodes = [new Rule(nodes)];
	    } else if (nodes.name) {
	      nodes = [new AtRule(nodes)];
	    } else if (nodes.text) {
	      nodes = [new Comment(nodes)];
	    } else {
	      throw new Error('Unknown node type in node creation')
	    }

	    let processed = nodes.map(i => {
	      /* c8 ignore next */
	      if (!i[my]) Container.rebuild(i);
	      i = i.proxyOf;
	      if (i.parent) i.parent.removeChild(i);
	      if (i[isClean]) markDirtyUp(i);
	      if (typeof i.raws.before === 'undefined') {
	        if (sample && typeof sample.raws.before !== 'undefined') {
	          i.raws.before = sample.raws.before.replace(/\S/g, '');
	        }
	      }
	      i.parent = this.proxyOf;
	      return i
	    });

	    return processed
	  }

	  getProxyProcessor() {
	    return {
	      set(node, prop, value) {
	        if (node[prop] === value) return true
	        node[prop] = value;
	        if (prop === 'name' || prop === 'params' || prop === 'selector') {
	          node.markDirty();
	        }
	        return true
	      },

	      get(node, prop) {
	        if (prop === 'proxyOf') {
	          return node
	        } else if (!node[prop]) {
	          return node[prop]
	        } else if (
	          prop === 'each' ||
	          (typeof prop === 'string' && prop.startsWith('walk'))
	        ) {
	          return (...args) => {
	            return node[prop](
	              ...args.map(i => {
	                if (typeof i === 'function') {
	                  return (child, index) => i(child.toProxy(), index)
	                } else {
	                  return i
	                }
	              })
	            )
	          }
	        } else if (prop === 'every' || prop === 'some') {
	          return cb => {
	            return node[prop]((child, ...other) =>
	              cb(child.toProxy(), ...other)
	            )
	          }
	        } else if (prop === 'root') {
	          return () => node.root().toProxy()
	        } else if (prop === 'nodes') {
	          return node.nodes.map(i => i.toProxy())
	        } else if (prop === 'first' || prop === 'last') {
	          return node[prop].toProxy()
	        } else {
	          return node[prop]
	        }
	      }
	    }
	  }

	  getIterator() {
	    if (!this.lastEach) this.lastEach = 0;
	    if (!this.indexes) this.indexes = {};

	    this.lastEach += 1;
	    let iterator = this.lastEach;
	    this.indexes[iterator] = 0;

	    return iterator
	  }
	}

	Container.registerParse = dependant => {
	  parse = dependant;
	};

	Container.registerRule = dependant => {
	  Rule = dependant;
	};

	Container.registerAtRule = dependant => {
	  AtRule = dependant;
	};

	Container.registerRoot = dependant => {
	  Root = dependant;
	};

	container = Container;
	Container.default = Container;

	/* c8 ignore start */
	Container.rebuild = node => {
	  if (node.type === 'atrule') {
	    Object.setPrototypeOf(node, AtRule.prototype);
	  } else if (node.type === 'rule') {
	    Object.setPrototypeOf(node, Rule.prototype);
	  } else if (node.type === 'decl') {
	    Object.setPrototypeOf(node, Declaration.prototype);
	  } else if (node.type === 'comment') {
	    Object.setPrototypeOf(node, Comment.prototype);
	  } else if (node.type === 'root') {
	    Object.setPrototypeOf(node, Root.prototype);
	  }

	  node[my] = true;

	  if (node.nodes) {
	    node.nodes.forEach(child => {
	      Container.rebuild(child);
	    });
	  }
	};
	/* c8 ignore stop */
	return container;
}

var document$1;
var hasRequiredDocument;

function requireDocument () {
	if (hasRequiredDocument) return document$1;
	hasRequiredDocument = 1;

	let Container = requireContainer();

	let LazyResult, Processor;

	class Document extends Container {
	  constructor(defaults) {
	    // type needs to be passed to super, otherwise child roots won't be normalized correctly
	    super({ type: 'document', ...defaults });

	    if (!this.nodes) {
	      this.nodes = [];
	    }
	  }

	  toResult(opts = {}) {
	    let lazy = new LazyResult(new Processor(), this, opts);

	    return lazy.stringify()
	  }
	}

	Document.registerLazyResult = dependant => {
	  LazyResult = dependant;
	};

	Document.registerProcessor = dependant => {
	  Processor = dependant;
	};

	document$1 = Document;
	Document.default = Document;
	return document$1;
}

/* eslint-disable no-console */

var warnOnce;
var hasRequiredWarnOnce;

function requireWarnOnce () {
	if (hasRequiredWarnOnce) return warnOnce;
	hasRequiredWarnOnce = 1;

	let printed = {};

	warnOnce = function warnOnce(message) {
	  if (printed[message]) return
	  printed[message] = true;

	  if (typeof console !== 'undefined' && console.warn) {
	    console.warn(message);
	  }
	};
	return warnOnce;
}

var warning;
var hasRequiredWarning;

function requireWarning () {
	if (hasRequiredWarning) return warning;
	hasRequiredWarning = 1;

	class Warning {
	  constructor(text, opts = {}) {
	    this.type = 'warning';
	    this.text = text;

	    if (opts.node && opts.node.source) {
	      let range = opts.node.rangeBy(opts);
	      this.line = range.start.line;
	      this.column = range.start.column;
	      this.endLine = range.end.line;
	      this.endColumn = range.end.column;
	    }

	    for (let opt in opts) this[opt] = opts[opt];
	  }

	  toString() {
	    if (this.node) {
	      return this.node.error(this.text, {
	        plugin: this.plugin,
	        index: this.index,
	        word: this.word
	      }).message
	    }

	    if (this.plugin) {
	      return this.plugin + ': ' + this.text
	    }

	    return this.text
	  }
	}

	warning = Warning;
	Warning.default = Warning;
	return warning;
}

var result;
var hasRequiredResult;

function requireResult () {
	if (hasRequiredResult) return result;
	hasRequiredResult = 1;

	let Warning = requireWarning();

	class Result {
	  constructor(processor, root, opts) {
	    this.processor = processor;
	    this.messages = [];
	    this.root = root;
	    this.opts = opts;
	    this.css = undefined;
	    this.map = undefined;
	  }

	  toString() {
	    return this.css
	  }

	  warn(text, opts = {}) {
	    if (!opts.plugin) {
	      if (this.lastPlugin && this.lastPlugin.postcssPlugin) {
	        opts.plugin = this.lastPlugin.postcssPlugin;
	      }
	    }

	    let warning = new Warning(text, opts);
	    this.messages.push(warning);

	    return warning
	  }

	  warnings() {
	    return this.messages.filter(i => i.type === 'warning')
	  }

	  get content() {
	    return this.css
	  }
	}

	result = Result;
	Result.default = Result;
	return result;
}

var tokenize;
var hasRequiredTokenize;

function requireTokenize () {
	if (hasRequiredTokenize) return tokenize;
	hasRequiredTokenize = 1;

	const SINGLE_QUOTE = "'".charCodeAt(0);
	const DOUBLE_QUOTE = '"'.charCodeAt(0);
	const BACKSLASH = '\\'.charCodeAt(0);
	const SLASH = '/'.charCodeAt(0);
	const NEWLINE = '\n'.charCodeAt(0);
	const SPACE = ' '.charCodeAt(0);
	const FEED = '\f'.charCodeAt(0);
	const TAB = '\t'.charCodeAt(0);
	const CR = '\r'.charCodeAt(0);
	const OPEN_SQUARE = '['.charCodeAt(0);
	const CLOSE_SQUARE = ']'.charCodeAt(0);
	const OPEN_PARENTHESES = '('.charCodeAt(0);
	const CLOSE_PARENTHESES = ')'.charCodeAt(0);
	const OPEN_CURLY = '{'.charCodeAt(0);
	const CLOSE_CURLY = '}'.charCodeAt(0);
	const SEMICOLON = ';'.charCodeAt(0);
	const ASTERISK = '*'.charCodeAt(0);
	const COLON = ':'.charCodeAt(0);
	const AT = '@'.charCodeAt(0);

	const RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
	const RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
	const RE_BAD_BRACKET = /.[\n"'(/\\]/;
	const RE_HEX_ESCAPE = /[\da-f]/i;

	tokenize = function tokenizer(input, options = {}) {
	  let css = input.css.valueOf();
	  let ignore = options.ignoreErrors;

	  let code, next, quote, content, escape;
	  let escaped, escapePos, prev, n, currentToken;

	  let length = css.length;
	  let pos = 0;
	  let buffer = [];
	  let returned = [];

	  function position() {
	    return pos
	  }

	  function unclosed(what) {
	    throw input.error('Unclosed ' + what, pos)
	  }

	  function endOfFile() {
	    return returned.length === 0 && pos >= length
	  }

	  function nextToken(opts) {
	    if (returned.length) return returned.pop()
	    if (pos >= length) return

	    let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;

	    code = css.charCodeAt(pos);

	    switch (code) {
	      case NEWLINE:
	      case SPACE:
	      case TAB:
	      case CR:
	      case FEED: {
	        next = pos;
	        do {
	          next += 1;
	          code = css.charCodeAt(next);
	        } while (
	          code === SPACE ||
	          code === NEWLINE ||
	          code === TAB ||
	          code === CR ||
	          code === FEED
	        )

	        currentToken = ['space', css.slice(pos, next)];
	        pos = next - 1;
	        break
	      }

	      case OPEN_SQUARE:
	      case CLOSE_SQUARE:
	      case OPEN_CURLY:
	      case CLOSE_CURLY:
	      case COLON:
	      case SEMICOLON:
	      case CLOSE_PARENTHESES: {
	        let controlChar = String.fromCharCode(code);
	        currentToken = [controlChar, controlChar, pos];
	        break
	      }

	      case OPEN_PARENTHESES: {
	        prev = buffer.length ? buffer.pop()[1] : '';
	        n = css.charCodeAt(pos + 1);
	        if (
	          prev === 'url' &&
	          n !== SINGLE_QUOTE &&
	          n !== DOUBLE_QUOTE &&
	          n !== SPACE &&
	          n !== NEWLINE &&
	          n !== TAB &&
	          n !== FEED &&
	          n !== CR
	        ) {
	          next = pos;
	          do {
	            escaped = false;
	            next = css.indexOf(')', next + 1);
	            if (next === -1) {
	              if (ignore || ignoreUnclosed) {
	                next = pos;
	                break
	              } else {
	                unclosed('bracket');
	              }
	            }
	            escapePos = next;
	            while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	              escapePos -= 1;
	              escaped = !escaped;
	            }
	          } while (escaped)

	          currentToken = ['brackets', css.slice(pos, next + 1), pos, next];

	          pos = next;
	        } else {
	          next = css.indexOf(')', pos + 1);
	          content = css.slice(pos, next + 1);

	          if (next === -1 || RE_BAD_BRACKET.test(content)) {
	            currentToken = ['(', '(', pos];
	          } else {
	            currentToken = ['brackets', content, pos, next];
	            pos = next;
	          }
	        }

	        break
	      }

	      case SINGLE_QUOTE:
	      case DOUBLE_QUOTE: {
	        quote = code === SINGLE_QUOTE ? "'" : '"';
	        next = pos;
	        do {
	          escaped = false;
	          next = css.indexOf(quote, next + 1);
	          if (next === -1) {
	            if (ignore || ignoreUnclosed) {
	              next = pos + 1;
	              break
	            } else {
	              unclosed('string');
	            }
	          }
	          escapePos = next;
	          while (css.charCodeAt(escapePos - 1) === BACKSLASH) {
	            escapePos -= 1;
	            escaped = !escaped;
	          }
	        } while (escaped)

	        currentToken = ['string', css.slice(pos, next + 1), pos, next];
	        pos = next;
	        break
	      }

	      case AT: {
	        RE_AT_END.lastIndex = pos + 1;
	        RE_AT_END.test(css);
	        if (RE_AT_END.lastIndex === 0) {
	          next = css.length - 1;
	        } else {
	          next = RE_AT_END.lastIndex - 2;
	        }

	        currentToken = ['at-word', css.slice(pos, next + 1), pos, next];

	        pos = next;
	        break
	      }

	      case BACKSLASH: {
	        next = pos;
	        escape = true;
	        while (css.charCodeAt(next + 1) === BACKSLASH) {
	          next += 1;
	          escape = !escape;
	        }
	        code = css.charCodeAt(next + 1);
	        if (
	          escape &&
	          code !== SLASH &&
	          code !== SPACE &&
	          code !== NEWLINE &&
	          code !== TAB &&
	          code !== CR &&
	          code !== FEED
	        ) {
	          next += 1;
	          if (RE_HEX_ESCAPE.test(css.charAt(next))) {
	            while (RE_HEX_ESCAPE.test(css.charAt(next + 1))) {
	              next += 1;
	            }
	            if (css.charCodeAt(next + 1) === SPACE) {
	              next += 1;
	            }
	          }
	        }

	        currentToken = ['word', css.slice(pos, next + 1), pos, next];

	        pos = next;
	        break
	      }

	      default: {
	        if (code === SLASH && css.charCodeAt(pos + 1) === ASTERISK) {
	          next = css.indexOf('*/', pos + 2) + 1;
	          if (next === 0) {
	            if (ignore || ignoreUnclosed) {
	              next = css.length;
	            } else {
	              unclosed('comment');
	            }
	          }

	          currentToken = ['comment', css.slice(pos, next + 1), pos, next];
	          pos = next;
	        } else {
	          RE_WORD_END.lastIndex = pos + 1;
	          RE_WORD_END.test(css);
	          if (RE_WORD_END.lastIndex === 0) {
	            next = css.length - 1;
	          } else {
	            next = RE_WORD_END.lastIndex - 2;
	          }

	          currentToken = ['word', css.slice(pos, next + 1), pos, next];
	          buffer.push(currentToken);
	          pos = next;
	        }

	        break
	      }
	    }

	    pos++;
	    return currentToken
	  }

	  function back(token) {
	    returned.push(token);
	  }

	  return {
	    back,
	    nextToken,
	    endOfFile,
	    position
	  }
	};
	return tokenize;
}

var atRule;
var hasRequiredAtRule;

function requireAtRule () {
	if (hasRequiredAtRule) return atRule;
	hasRequiredAtRule = 1;

	let Container = requireContainer();

	class AtRule extends Container {
	  constructor(defaults) {
	    super(defaults);
	    this.type = 'atrule';
	  }

	  append(...children) {
	    if (!this.proxyOf.nodes) this.nodes = [];
	    return super.append(...children)
	  }

	  prepend(...children) {
	    if (!this.proxyOf.nodes) this.nodes = [];
	    return super.prepend(...children)
	  }
	}

	atRule = AtRule;
	AtRule.default = AtRule;

	Container.registerAtRule(AtRule);
	return atRule;
}

var root;
var hasRequiredRoot;

function requireRoot () {
	if (hasRequiredRoot) return root;
	hasRequiredRoot = 1;

	let Container = requireContainer();

	let LazyResult, Processor;

	class Root extends Container {
	  constructor(defaults) {
	    super(defaults);
	    this.type = 'root';
	    if (!this.nodes) this.nodes = [];
	  }

	  removeChild(child, ignore) {
	    let index = this.index(child);

	    if (!ignore && index === 0 && this.nodes.length > 1) {
	      this.nodes[1].raws.before = this.nodes[index].raws.before;
	    }

	    return super.removeChild(child)
	  }

	  normalize(child, sample, type) {
	    let nodes = super.normalize(child);

	    if (sample) {
	      if (type === 'prepend') {
	        if (this.nodes.length > 1) {
	          sample.raws.before = this.nodes[1].raws.before;
	        } else {
	          delete sample.raws.before;
	        }
	      } else if (this.first !== sample) {
	        for (let node of nodes) {
	          node.raws.before = sample.raws.before;
	        }
	      }
	    }

	    return nodes
	  }

	  toResult(opts = {}) {
	    let lazy = new LazyResult(new Processor(), this, opts);
	    return lazy.stringify()
	  }
	}

	Root.registerLazyResult = dependant => {
	  LazyResult = dependant;
	};

	Root.registerProcessor = dependant => {
	  Processor = dependant;
	};

	root = Root;
	Root.default = Root;

	Container.registerRoot(Root);
	return root;
}

var list_1;
var hasRequiredList;

function requireList () {
	if (hasRequiredList) return list_1;
	hasRequiredList = 1;

	let list = {
	  split(string, separators, last) {
	    let array = [];
	    let current = '';
	    let split = false;

	    let func = 0;
	    let inQuote = false;
	    let prevQuote = '';
	    let escape = false;

	    for (let letter of string) {
	      if (escape) {
	        escape = false;
	      } else if (letter === '\\') {
	        escape = true;
	      } else if (inQuote) {
	        if (letter === prevQuote) {
	          inQuote = false;
	        }
	      } else if (letter === '"' || letter === "'") {
	        inQuote = true;
	        prevQuote = letter;
	      } else if (letter === '(') {
	        func += 1;
	      } else if (letter === ')') {
	        if (func > 0) func -= 1;
	      } else if (func === 0) {
	        if (separators.includes(letter)) split = true;
	      }

	      if (split) {
	        if (current !== '') array.push(current.trim());
	        current = '';
	        split = false;
	      } else {
	        current += letter;
	      }
	    }

	    if (last || current !== '') array.push(current.trim());
	    return array
	  },

	  space(string) {
	    let spaces = [' ', '\n', '\t'];
	    return list.split(string, spaces)
	  },

	  comma(string) {
	    return list.split(string, [','], true)
	  }
	};

	list_1 = list;
	list.default = list;
	return list_1;
}

var rule;
var hasRequiredRule;

function requireRule () {
	if (hasRequiredRule) return rule;
	hasRequiredRule = 1;

	let Container = requireContainer();
	let list = requireList();

	class Rule extends Container {
	  constructor(defaults) {
	    super(defaults);
	    this.type = 'rule';
	    if (!this.nodes) this.nodes = [];
	  }

	  get selectors() {
	    return list.comma(this.selector)
	  }

	  set selectors(values) {
	    let match = this.selector ? this.selector.match(/,\s*/) : null;
	    let sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
	    this.selector = values.join(sep);
	  }
	}

	rule = Rule;
	Rule.default = Rule;

	Container.registerRule(Rule);
	return rule;
}

var parser;
var hasRequiredParser;

function requireParser () {
	if (hasRequiredParser) return parser;
	hasRequiredParser = 1;

	let Declaration = requireDeclaration();
	let tokenizer = requireTokenize();
	let Comment = requireComment();
	let AtRule = requireAtRule();
	let Root = requireRoot();
	let Rule = requireRule();

	const SAFE_COMMENT_NEIGHBOR = {
	  empty: true,
	  space: true
	};

	function findLastWithPosition(tokens) {
	  for (let i = tokens.length - 1; i >= 0; i--) {
	    let token = tokens[i];
	    let pos = token[3] || token[2];
	    if (pos) return pos
	  }
	}

	class Parser {
	  constructor(input) {
	    this.input = input;

	    this.root = new Root();
	    this.current = this.root;
	    this.spaces = '';
	    this.semicolon = false;
	    this.customProperty = false;

	    this.createTokenizer();
	    this.root.source = { input, start: { offset: 0, line: 1, column: 1 } };
	  }

	  createTokenizer() {
	    this.tokenizer = tokenizer(this.input);
	  }

	  parse() {
	    let token;
	    while (!this.tokenizer.endOfFile()) {
	      token = this.tokenizer.nextToken();

	      switch (token[0]) {
	        case 'space':
	          this.spaces += token[1];
	          break

	        case ';':
	          this.freeSemicolon(token);
	          break

	        case '}':
	          this.end(token);
	          break

	        case 'comment':
	          this.comment(token);
	          break

	        case 'at-word':
	          this.atrule(token);
	          break

	        case '{':
	          this.emptyRule(token);
	          break

	        default:
	          this.other(token);
	          break
	      }
	    }
	    this.endFile();
	  }

	  comment(token) {
	    let node = new Comment();
	    this.init(node, token[2]);
	    node.source.end = this.getPosition(token[3] || token[2]);

	    let text = token[1].slice(2, -2);
	    if (/^\s*$/.test(text)) {
	      node.text = '';
	      node.raws.left = text;
	      node.raws.right = '';
	    } else {
	      let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
	      node.text = match[2];
	      node.raws.left = match[1];
	      node.raws.right = match[3];
	    }
	  }

	  emptyRule(token) {
	    let node = new Rule();
	    this.init(node, token[2]);
	    node.selector = '';
	    node.raws.between = '';
	    this.current = node;
	  }

	  other(start) {
	    let end = false;
	    let type = null;
	    let colon = false;
	    let bracket = null;
	    let brackets = [];
	    let customProperty = start[1].startsWith('--');

	    let tokens = [];
	    let token = start;
	    while (token) {
	      type = token[0];
	      tokens.push(token);

	      if (type === '(' || type === '[') {
	        if (!bracket) bracket = token;
	        brackets.push(type === '(' ? ')' : ']');
	      } else if (customProperty && colon && type === '{') {
	        if (!bracket) bracket = token;
	        brackets.push('}');
	      } else if (brackets.length === 0) {
	        if (type === ';') {
	          if (colon) {
	            this.decl(tokens, customProperty);
	            return
	          } else {
	            break
	          }
	        } else if (type === '{') {
	          this.rule(tokens);
	          return
	        } else if (type === '}') {
	          this.tokenizer.back(tokens.pop());
	          end = true;
	          break
	        } else if (type === ':') {
	          colon = true;
	        }
	      } else if (type === brackets[brackets.length - 1]) {
	        brackets.pop();
	        if (brackets.length === 0) bracket = null;
	      }

	      token = this.tokenizer.nextToken();
	    }

	    if (this.tokenizer.endOfFile()) end = true;
	    if (brackets.length > 0) this.unclosedBracket(bracket);

	    if (end && colon) {
	      if (!customProperty) {
	        while (tokens.length) {
	          token = tokens[tokens.length - 1][0];
	          if (token !== 'space' && token !== 'comment') break
	          this.tokenizer.back(tokens.pop());
	        }
	      }
	      this.decl(tokens, customProperty);
	    } else {
	      this.unknownWord(tokens);
	    }
	  }

	  rule(tokens) {
	    tokens.pop();

	    let node = new Rule();
	    this.init(node, tokens[0][2]);

	    node.raws.between = this.spacesAndCommentsFromEnd(tokens);
	    this.raw(node, 'selector', tokens);
	    this.current = node;
	  }

	  decl(tokens, customProperty) {
	    let node = new Declaration();
	    this.init(node, tokens[0][2]);

	    let last = tokens[tokens.length - 1];
	    if (last[0] === ';') {
	      this.semicolon = true;
	      tokens.pop();
	    }

	    node.source.end = this.getPosition(
	      last[3] || last[2] || findLastWithPosition(tokens)
	    );

	    while (tokens[0][0] !== 'word') {
	      if (tokens.length === 1) this.unknownWord(tokens);
	      node.raws.before += tokens.shift()[1];
	    }
	    node.source.start = this.getPosition(tokens[0][2]);

	    node.prop = '';
	    while (tokens.length) {
	      let type = tokens[0][0];
	      if (type === ':' || type === 'space' || type === 'comment') {
	        break
	      }
	      node.prop += tokens.shift()[1];
	    }

	    node.raws.between = '';

	    let token;
	    while (tokens.length) {
	      token = tokens.shift();

	      if (token[0] === ':') {
	        node.raws.between += token[1];
	        break
	      } else {
	        if (token[0] === 'word' && /\w/.test(token[1])) {
	          this.unknownWord([token]);
	        }
	        node.raws.between += token[1];
	      }
	    }

	    if (node.prop[0] === '_' || node.prop[0] === '*') {
	      node.raws.before += node.prop[0];
	      node.prop = node.prop.slice(1);
	    }

	    let firstSpaces = [];
	    let next;
	    while (tokens.length) {
	      next = tokens[0][0];
	      if (next !== 'space' && next !== 'comment') break
	      firstSpaces.push(tokens.shift());
	    }

	    this.precheckMissedSemicolon(tokens);

	    for (let i = tokens.length - 1; i >= 0; i--) {
	      token = tokens[i];
	      if (token[1].toLowerCase() === '!important') {
	        node.important = true;
	        let string = this.stringFrom(tokens, i);
	        string = this.spacesFromEnd(tokens) + string;
	        if (string !== ' !important') node.raws.important = string;
	        break
	      } else if (token[1].toLowerCase() === 'important') {
	        let cache = tokens.slice(0);
	        let str = '';
	        for (let j = i; j > 0; j--) {
	          let type = cache[j][0];
	          if (str.trim().indexOf('!') === 0 && type !== 'space') {
	            break
	          }
	          str = cache.pop()[1] + str;
	        }
	        if (str.trim().indexOf('!') === 0) {
	          node.important = true;
	          node.raws.important = str;
	          tokens = cache;
	        }
	      }

	      if (token[0] !== 'space' && token[0] !== 'comment') {
	        break
	      }
	    }

	    let hasWord = tokens.some(i => i[0] !== 'space' && i[0] !== 'comment');

	    if (hasWord) {
	      node.raws.between += firstSpaces.map(i => i[1]).join('');
	      firstSpaces = [];
	    }
	    this.raw(node, 'value', firstSpaces.concat(tokens), customProperty);

	    if (node.value.includes(':') && !customProperty) {
	      this.checkMissedSemicolon(tokens);
	    }
	  }

	  atrule(token) {
	    let node = new AtRule();
	    node.name = token[1].slice(1);
	    if (node.name === '') {
	      this.unnamedAtrule(node, token);
	    }
	    this.init(node, token[2]);

	    let type;
	    let prev;
	    let shift;
	    let last = false;
	    let open = false;
	    let params = [];
	    let brackets = [];

	    while (!this.tokenizer.endOfFile()) {
	      token = this.tokenizer.nextToken();
	      type = token[0];

	      if (type === '(' || type === '[') {
	        brackets.push(type === '(' ? ')' : ']');
	      } else if (type === '{' && brackets.length > 0) {
	        brackets.push('}');
	      } else if (type === brackets[brackets.length - 1]) {
	        brackets.pop();
	      }

	      if (brackets.length === 0) {
	        if (type === ';') {
	          node.source.end = this.getPosition(token[2]);
	          this.semicolon = true;
	          break
	        } else if (type === '{') {
	          open = true;
	          break
	        } else if (type === '}') {
	          if (params.length > 0) {
	            shift = params.length - 1;
	            prev = params[shift];
	            while (prev && prev[0] === 'space') {
	              prev = params[--shift];
	            }
	            if (prev) {
	              node.source.end = this.getPosition(prev[3] || prev[2]);
	            }
	          }
	          this.end(token);
	          break
	        } else {
	          params.push(token);
	        }
	      } else {
	        params.push(token);
	      }

	      if (this.tokenizer.endOfFile()) {
	        last = true;
	        break
	      }
	    }

	    node.raws.between = this.spacesAndCommentsFromEnd(params);
	    if (params.length) {
	      node.raws.afterName = this.spacesAndCommentsFromStart(params);
	      this.raw(node, 'params', params);
	      if (last) {
	        token = params[params.length - 1];
	        node.source.end = this.getPosition(token[3] || token[2]);
	        this.spaces = node.raws.between;
	        node.raws.between = '';
	      }
	    } else {
	      node.raws.afterName = '';
	      node.params = '';
	    }

	    if (open) {
	      node.nodes = [];
	      this.current = node;
	    }
	  }

	  end(token) {
	    if (this.current.nodes && this.current.nodes.length) {
	      this.current.raws.semicolon = this.semicolon;
	    }
	    this.semicolon = false;

	    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	    this.spaces = '';

	    if (this.current.parent) {
	      this.current.source.end = this.getPosition(token[2]);
	      this.current = this.current.parent;
	    } else {
	      this.unexpectedClose(token);
	    }
	  }

	  endFile() {
	    if (this.current.parent) this.unclosedBlock();
	    if (this.current.nodes && this.current.nodes.length) {
	      this.current.raws.semicolon = this.semicolon;
	    }
	    this.current.raws.after = (this.current.raws.after || '') + this.spaces;
	  }

	  freeSemicolon(token) {
	    this.spaces += token[1];
	    if (this.current.nodes) {
	      let prev = this.current.nodes[this.current.nodes.length - 1];
	      if (prev && prev.type === 'rule' && !prev.raws.ownSemicolon) {
	        prev.raws.ownSemicolon = this.spaces;
	        this.spaces = '';
	      }
	    }
	  }

	  // Helpers

	  getPosition(offset) {
	    let pos = this.input.fromOffset(offset);
	    return {
	      offset,
	      line: pos.line,
	      column: pos.col
	    }
	  }

	  init(node, offset) {
	    this.current.push(node);
	    node.source = {
	      start: this.getPosition(offset),
	      input: this.input
	    };
	    node.raws.before = this.spaces;
	    this.spaces = '';
	    if (node.type !== 'comment') this.semicolon = false;
	  }

	  raw(node, prop, tokens, customProperty) {
	    let token, type;
	    let length = tokens.length;
	    let value = '';
	    let clean = true;
	    let next, prev;

	    for (let i = 0; i < length; i += 1) {
	      token = tokens[i];
	      type = token[0];
	      if (type === 'space' && i === length - 1 && !customProperty) {
	        clean = false;
	      } else if (type === 'comment') {
	        prev = tokens[i - 1] ? tokens[i - 1][0] : 'empty';
	        next = tokens[i + 1] ? tokens[i + 1][0] : 'empty';
	        if (!SAFE_COMMENT_NEIGHBOR[prev] && !SAFE_COMMENT_NEIGHBOR[next]) {
	          if (value.slice(-1) === ',') {
	            clean = false;
	          } else {
	            value += token[1];
	          }
	        } else {
	          clean = false;
	        }
	      } else {
	        value += token[1];
	      }
	    }
	    if (!clean) {
	      let raw = tokens.reduce((all, i) => all + i[1], '');
	      node.raws[prop] = { value, raw };
	    }
	    node[prop] = value;
	  }

	  spacesAndCommentsFromEnd(tokens) {
	    let lastTokenType;
	    let spaces = '';
	    while (tokens.length) {
	      lastTokenType = tokens[tokens.length - 1][0];
	      if (lastTokenType !== 'space' && lastTokenType !== 'comment') break
	      spaces = tokens.pop()[1] + spaces;
	    }
	    return spaces
	  }

	  spacesAndCommentsFromStart(tokens) {
	    let next;
	    let spaces = '';
	    while (tokens.length) {
	      next = tokens[0][0];
	      if (next !== 'space' && next !== 'comment') break
	      spaces += tokens.shift()[1];
	    }
	    return spaces
	  }

	  spacesFromEnd(tokens) {
	    let lastTokenType;
	    let spaces = '';
	    while (tokens.length) {
	      lastTokenType = tokens[tokens.length - 1][0];
	      if (lastTokenType !== 'space') break
	      spaces = tokens.pop()[1] + spaces;
	    }
	    return spaces
	  }

	  stringFrom(tokens, from) {
	    let result = '';
	    for (let i = from; i < tokens.length; i++) {
	      result += tokens[i][1];
	    }
	    tokens.splice(from, tokens.length - from);
	    return result
	  }

	  colon(tokens) {
	    let brackets = 0;
	    let token, type, prev;
	    for (let [i, element] of tokens.entries()) {
	      token = element;
	      type = token[0];

	      if (type === '(') {
	        brackets += 1;
	      }
	      if (type === ')') {
	        brackets -= 1;
	      }
	      if (brackets === 0 && type === ':') {
	        if (!prev) {
	          this.doubleColon(token);
	        } else if (prev[0] === 'word' && prev[1] === 'progid') {
	          continue
	        } else {
	          return i
	        }
	      }

	      prev = token;
	    }
	    return false
	  }

	  // Errors

	  unclosedBracket(bracket) {
	    throw this.input.error(
	      'Unclosed bracket',
	      { offset: bracket[2] },
	      { offset: bracket[2] + 1 }
	    )
	  }

	  unknownWord(tokens) {
	    throw this.input.error(
	      'Unknown word',
	      { offset: tokens[0][2] },
	      { offset: tokens[0][2] + tokens[0][1].length }
	    )
	  }

	  unexpectedClose(token) {
	    throw this.input.error(
	      'Unexpected }',
	      { offset: token[2] },
	      { offset: token[2] + 1 }
	    )
	  }

	  unclosedBlock() {
	    let pos = this.current.source.start;
	    throw this.input.error('Unclosed block', pos.line, pos.column)
	  }

	  doubleColon(token) {
	    throw this.input.error(
	      'Double colon',
	      { offset: token[2] },
	      { offset: token[2] + token[1].length }
	    )
	  }

	  unnamedAtrule(node, token) {
	    throw this.input.error(
	      'At-rule without name',
	      { offset: token[2] },
	      { offset: token[2] + token[1].length }
	    )
	  }

	  precheckMissedSemicolon(/* tokens */) {
	    // Hook for Safe Parser
	  }

	  checkMissedSemicolon(tokens) {
	    let colon = this.colon(tokens);
	    if (colon === false) return

	    let founded = 0;
	    let token;
	    for (let j = colon - 1; j >= 0; j--) {
	      token = tokens[j];
	      if (token[0] !== 'space') {
	        founded += 1;
	        if (founded === 2) break
	      }
	    }
	    // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
	    // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
	    // And because we need it after that one we do +1 to get the next one.
	    throw this.input.error(
	      'Missed semicolon',
	      token[0] === 'word' ? token[3] + 1 : token[2]
	    )
	  }
	}

	parser = Parser;
	return parser;
}

var parse_1;
var hasRequiredParse;

function requireParse () {
	if (hasRequiredParse) return parse_1;
	hasRequiredParse = 1;

	let Container = requireContainer();
	let Parser = requireParser();
	let Input = requireInput();

	function parse(css, opts) {
	  let input = new Input(css, opts);
	  let parser = new Parser(input);
	  try {
	    parser.parse();
	  } catch (e) {
	    if (process.env.NODE_ENV !== 'production') {
	      if (e.name === 'CssSyntaxError' && opts && opts.from) {
	        if (/\.scss$/i.test(opts.from)) {
	          e.message +=
	            '\nYou tried to parse SCSS with ' +
	            'the standard CSS parser; ' +
	            'try again with the postcss-scss parser';
	        } else if (/\.sass/i.test(opts.from)) {
	          e.message +=
	            '\nYou tried to parse Sass with ' +
	            'the standard CSS parser; ' +
	            'try again with the postcss-sass parser';
	        } else if (/\.less$/i.test(opts.from)) {
	          e.message +=
	            '\nYou tried to parse Less with ' +
	            'the standard CSS parser; ' +
	            'try again with the postcss-less parser';
	        }
	      }
	    }
	    throw e
	  }

	  return parser.root
	}

	parse_1 = parse;
	parse.default = parse;

	Container.registerParse(parse);
	return parse_1;
}

var lazyResult;
var hasRequiredLazyResult;

function requireLazyResult () {
	if (hasRequiredLazyResult) return lazyResult;
	hasRequiredLazyResult = 1;

	let { isClean, my } = requireSymbols();
	let MapGenerator = requireMapGenerator();
	let stringify = requireStringify();
	let Container = requireContainer();
	let Document = requireDocument();
	let warnOnce = requireWarnOnce();
	let Result = requireResult();
	let parse = requireParse();
	let Root = requireRoot();

	const TYPE_TO_CLASS_NAME = {
	  document: 'Document',
	  root: 'Root',
	  atrule: 'AtRule',
	  rule: 'Rule',
	  decl: 'Declaration',
	  comment: 'Comment'
	};

	const PLUGIN_PROPS = {
	  postcssPlugin: true,
	  prepare: true,
	  Once: true,
	  Document: true,
	  Root: true,
	  Declaration: true,
	  Rule: true,
	  AtRule: true,
	  Comment: true,
	  DeclarationExit: true,
	  RuleExit: true,
	  AtRuleExit: true,
	  CommentExit: true,
	  RootExit: true,
	  DocumentExit: true,
	  OnceExit: true
	};

	const NOT_VISITORS = {
	  postcssPlugin: true,
	  prepare: true,
	  Once: true
	};

	const CHILDREN = 0;

	function isPromise(obj) {
	  return typeof obj === 'object' && typeof obj.then === 'function'
	}

	function getEvents(node) {
	  let key = false;
	  let type = TYPE_TO_CLASS_NAME[node.type];
	  if (node.type === 'decl') {
	    key = node.prop.toLowerCase();
	  } else if (node.type === 'atrule') {
	    key = node.name.toLowerCase();
	  }

	  if (key && node.append) {
	    return [
	      type,
	      type + '-' + key,
	      CHILDREN,
	      type + 'Exit',
	      type + 'Exit-' + key
	    ]
	  } else if (key) {
	    return [type, type + '-' + key, type + 'Exit', type + 'Exit-' + key]
	  } else if (node.append) {
	    return [type, CHILDREN, type + 'Exit']
	  } else {
	    return [type, type + 'Exit']
	  }
	}

	function toStack(node) {
	  let events;
	  if (node.type === 'document') {
	    events = ['Document', CHILDREN, 'DocumentExit'];
	  } else if (node.type === 'root') {
	    events = ['Root', CHILDREN, 'RootExit'];
	  } else {
	    events = getEvents(node);
	  }

	  return {
	    node,
	    events,
	    eventIndex: 0,
	    visitors: [],
	    visitorIndex: 0,
	    iterator: 0
	  }
	}

	function cleanMarks(node) {
	  node[isClean] = false;
	  if (node.nodes) node.nodes.forEach(i => cleanMarks(i));
	  return node
	}

	let postcss = {};

	class LazyResult {
	  constructor(processor, css, opts) {
	    this.stringified = false;
	    this.processed = false;

	    let root;
	    if (
	      typeof css === 'object' &&
	      css !== null &&
	      (css.type === 'root' || css.type === 'document')
	    ) {
	      root = cleanMarks(css);
	    } else if (css instanceof LazyResult || css instanceof Result) {
	      root = cleanMarks(css.root);
	      if (css.map) {
	        if (typeof opts.map === 'undefined') opts.map = {};
	        if (!opts.map.inline) opts.map.inline = false;
	        opts.map.prev = css.map;
	      }
	    } else {
	      let parser = parse;
	      if (opts.syntax) parser = opts.syntax.parse;
	      if (opts.parser) parser = opts.parser;
	      if (parser.parse) parser = parser.parse;

	      try {
	        root = parser(css, opts);
	      } catch (error) {
	        this.processed = true;
	        this.error = error;
	      }

	      if (root && !root[my]) {
	        /* c8 ignore next 2 */
	        Container.rebuild(root);
	      }
	    }

	    this.result = new Result(processor, root, opts);
	    this.helpers = { ...postcss, result: this.result, postcss };
	    this.plugins = this.processor.plugins.map(plugin => {
	      if (typeof plugin === 'object' && plugin.prepare) {
	        return { ...plugin, ...plugin.prepare(this.result) }
	      } else {
	        return plugin
	      }
	    });
	  }

	  get [Symbol.toStringTag]() {
	    return 'LazyResult'
	  }

	  get processor() {
	    return this.result.processor
	  }

	  get opts() {
	    return this.result.opts
	  }

	  get css() {
	    return this.stringify().css
	  }

	  get content() {
	    return this.stringify().content
	  }

	  get map() {
	    return this.stringify().map
	  }

	  get root() {
	    return this.sync().root
	  }

	  get messages() {
	    return this.sync().messages
	  }

	  warnings() {
	    return this.sync().warnings()
	  }

	  toString() {
	    return this.css
	  }

	  then(onFulfilled, onRejected) {
	    if (process.env.NODE_ENV !== 'production') {
	      if (!('from' in this.opts)) {
	        warnOnce(
	          'Without `from` option PostCSS could generate wrong source map ' +
	            'and will not find Browserslist config. Set it to CSS file path ' +
	            'or to `undefined` to prevent this warning.'
	        );
	      }
	    }
	    return this.async().then(onFulfilled, onRejected)
	  }

	  catch(onRejected) {
	    return this.async().catch(onRejected)
	  }

	  finally(onFinally) {
	    return this.async().then(onFinally, onFinally)
	  }

	  async() {
	    if (this.error) return Promise.reject(this.error)
	    if (this.processed) return Promise.resolve(this.result)
	    if (!this.processing) {
	      this.processing = this.runAsync();
	    }
	    return this.processing
	  }

	  sync() {
	    if (this.error) throw this.error
	    if (this.processed) return this.result
	    this.processed = true;

	    if (this.processing) {
	      throw this.getAsyncError()
	    }

	    for (let plugin of this.plugins) {
	      let promise = this.runOnRoot(plugin);
	      if (isPromise(promise)) {
	        throw this.getAsyncError()
	      }
	    }

	    this.prepareVisitors();
	    if (this.hasListener) {
	      let root = this.result.root;
	      while (!root[isClean]) {
	        root[isClean] = true;
	        this.walkSync(root);
	      }
	      if (this.listeners.OnceExit) {
	        if (root.type === 'document') {
	          for (let subRoot of root.nodes) {
	            this.visitSync(this.listeners.OnceExit, subRoot);
	          }
	        } else {
	          this.visitSync(this.listeners.OnceExit, root);
	        }
	      }
	    }

	    return this.result
	  }

	  stringify() {
	    if (this.error) throw this.error
	    if (this.stringified) return this.result
	    this.stringified = true;

	    this.sync();

	    let opts = this.result.opts;
	    let str = stringify;
	    if (opts.syntax) str = opts.syntax.stringify;
	    if (opts.stringifier) str = opts.stringifier;
	    if (str.stringify) str = str.stringify;

	    let map = new MapGenerator(str, this.result.root, this.result.opts);
	    let data = map.generate();
	    this.result.css = data[0];
	    this.result.map = data[1];

	    return this.result
	  }

	  walkSync(node) {
	    node[isClean] = true;
	    let events = getEvents(node);
	    for (let event of events) {
	      if (event === CHILDREN) {
	        if (node.nodes) {
	          node.each(child => {
	            if (!child[isClean]) this.walkSync(child);
	          });
	        }
	      } else {
	        let visitors = this.listeners[event];
	        if (visitors) {
	          if (this.visitSync(visitors, node.toProxy())) return
	        }
	      }
	    }
	  }

	  visitSync(visitors, node) {
	    for (let [plugin, visitor] of visitors) {
	      this.result.lastPlugin = plugin;
	      let promise;
	      try {
	        promise = visitor(node, this.helpers);
	      } catch (e) {
	        throw this.handleError(e, node.proxyOf)
	      }
	      if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
	        return true
	      }
	      if (isPromise(promise)) {
	        throw this.getAsyncError()
	      }
	    }
	  }

	  runOnRoot(plugin) {
	    this.result.lastPlugin = plugin;
	    try {
	      if (typeof plugin === 'object' && plugin.Once) {
	        if (this.result.root.type === 'document') {
	          let roots = this.result.root.nodes.map(root =>
	            plugin.Once(root, this.helpers)
	          );

	          if (isPromise(roots[0])) {
	            return Promise.all(roots)
	          }

	          return roots
	        }

	        return plugin.Once(this.result.root, this.helpers)
	      } else if (typeof plugin === 'function') {
	        return plugin(this.result.root, this.result)
	      }
	    } catch (error) {
	      throw this.handleError(error)
	    }
	  }

	  getAsyncError() {
	    throw new Error('Use process(css).then(cb) to work with async plugins')
	  }

	  handleError(error, node) {
	    let plugin = this.result.lastPlugin;
	    try {
	      if (node) node.addToError(error);
	      this.error = error;
	      if (error.name === 'CssSyntaxError' && !error.plugin) {
	        error.plugin = plugin.postcssPlugin;
	        error.setMessage();
	      } else if (plugin.postcssVersion) {
	        if (process.env.NODE_ENV !== 'production') {
	          let pluginName = plugin.postcssPlugin;
	          let pluginVer = plugin.postcssVersion;
	          let runtimeVer = this.result.processor.version;
	          let a = pluginVer.split('.');
	          let b = runtimeVer.split('.');

	          if (a[0] !== b[0] || parseInt(a[1]) > parseInt(b[1])) {
	            // eslint-disable-next-line no-console
	            console.error(
	              'Unknown error from PostCSS plugin. Your current PostCSS ' +
	                'version is ' +
	                runtimeVer +
	                ', but ' +
	                pluginName +
	                ' uses ' +
	                pluginVer +
	                '. Perhaps this is the source of the error below.'
	            );
	          }
	        }
	      }
	    } catch (err) {
	      /* c8 ignore next 3 */
	      // eslint-disable-next-line no-console
	      if (console && console.error) console.error(err);
	    }
	    return error
	  }

	  async runAsync() {
	    this.plugin = 0;
	    for (let i = 0; i < this.plugins.length; i++) {
	      let plugin = this.plugins[i];
	      let promise = this.runOnRoot(plugin);
	      if (isPromise(promise)) {
	        try {
	          await promise;
	        } catch (error) {
	          throw this.handleError(error)
	        }
	      }
	    }

	    this.prepareVisitors();
	    if (this.hasListener) {
	      let root = this.result.root;
	      while (!root[isClean]) {
	        root[isClean] = true;
	        let stack = [toStack(root)];
	        while (stack.length > 0) {
	          let promise = this.visitTick(stack);
	          if (isPromise(promise)) {
	            try {
	              await promise;
	            } catch (e) {
	              let node = stack[stack.length - 1].node;
	              throw this.handleError(e, node)
	            }
	          }
	        }
	      }

	      if (this.listeners.OnceExit) {
	        for (let [plugin, visitor] of this.listeners.OnceExit) {
	          this.result.lastPlugin = plugin;
	          try {
	            if (root.type === 'document') {
	              let roots = root.nodes.map(subRoot =>
	                visitor(subRoot, this.helpers)
	              );

	              await Promise.all(roots);
	            } else {
	              await visitor(root, this.helpers);
	            }
	          } catch (e) {
	            throw this.handleError(e)
	          }
	        }
	      }
	    }

	    this.processed = true;
	    return this.stringify()
	  }

	  prepareVisitors() {
	    this.listeners = {};
	    let add = (plugin, type, cb) => {
	      if (!this.listeners[type]) this.listeners[type] = [];
	      this.listeners[type].push([plugin, cb]);
	    };
	    for (let plugin of this.plugins) {
	      if (typeof plugin === 'object') {
	        for (let event in plugin) {
	          if (!PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) {
	            throw new Error(
	              `Unknown event ${event} in ${plugin.postcssPlugin}. ` +
	                `Try to update PostCSS (${this.processor.version} now).`
	            )
	          }
	          if (!NOT_VISITORS[event]) {
	            if (typeof plugin[event] === 'object') {
	              for (let filter in plugin[event]) {
	                if (filter === '*') {
	                  add(plugin, event, plugin[event][filter]);
	                } else {
	                  add(
	                    plugin,
	                    event + '-' + filter.toLowerCase(),
	                    plugin[event][filter]
	                  );
	                }
	              }
	            } else if (typeof plugin[event] === 'function') {
	              add(plugin, event, plugin[event]);
	            }
	          }
	        }
	      }
	    }
	    this.hasListener = Object.keys(this.listeners).length > 0;
	  }

	  visitTick(stack) {
	    let visit = stack[stack.length - 1];
	    let { node, visitors } = visit;

	    if (node.type !== 'root' && node.type !== 'document' && !node.parent) {
	      stack.pop();
	      return
	    }

	    if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
	      let [plugin, visitor] = visitors[visit.visitorIndex];
	      visit.visitorIndex += 1;
	      if (visit.visitorIndex === visitors.length) {
	        visit.visitors = [];
	        visit.visitorIndex = 0;
	      }
	      this.result.lastPlugin = plugin;
	      try {
	        return visitor(node.toProxy(), this.helpers)
	      } catch (e) {
	        throw this.handleError(e, node)
	      }
	    }

	    if (visit.iterator !== 0) {
	      let iterator = visit.iterator;
	      let child;
	      while ((child = node.nodes[node.indexes[iterator]])) {
	        node.indexes[iterator] += 1;
	        if (!child[isClean]) {
	          child[isClean] = true;
	          stack.push(toStack(child));
	          return
	        }
	      }
	      visit.iterator = 0;
	      delete node.indexes[iterator];
	    }

	    let events = visit.events;
	    while (visit.eventIndex < events.length) {
	      let event = events[visit.eventIndex];
	      visit.eventIndex += 1;
	      if (event === CHILDREN) {
	        if (node.nodes && node.nodes.length) {
	          node[isClean] = true;
	          visit.iterator = node.getIterator();
	        }
	        return
	      } else if (this.listeners[event]) {
	        visit.visitors = this.listeners[event];
	        return
	      }
	    }
	    stack.pop();
	  }
	}

	LazyResult.registerPostcss = dependant => {
	  postcss = dependant;
	};

	lazyResult = LazyResult;
	LazyResult.default = LazyResult;

	Root.registerLazyResult(LazyResult);
	Document.registerLazyResult(LazyResult);
	return lazyResult;
}

var noWorkResult;
var hasRequiredNoWorkResult;

function requireNoWorkResult () {
	if (hasRequiredNoWorkResult) return noWorkResult;
	hasRequiredNoWorkResult = 1;

	let MapGenerator = requireMapGenerator();
	let stringify = requireStringify();
	let warnOnce = requireWarnOnce();
	let parse = requireParse();
	const Result = requireResult();

	class NoWorkResult {
	  constructor(processor, css, opts) {
	    css = css.toString();
	    this.stringified = false;

	    this._processor = processor;
	    this._css = css;
	    this._opts = opts;
	    this._map = undefined;
	    let root;

	    let str = stringify;
	    this.result = new Result(this._processor, root, this._opts);
	    this.result.css = css;

	    let self = this;
	    Object.defineProperty(this.result, 'root', {
	      get() {
	        return self.root
	      }
	    });

	    let map = new MapGenerator(str, root, this._opts, css);
	    if (map.isMap()) {
	      let [generatedCSS, generatedMap] = map.generate();
	      if (generatedCSS) {
	        this.result.css = generatedCSS;
	      }
	      if (generatedMap) {
	        this.result.map = generatedMap;
	      }
	    }
	  }

	  get [Symbol.toStringTag]() {
	    return 'NoWorkResult'
	  }

	  get processor() {
	    return this.result.processor
	  }

	  get opts() {
	    return this.result.opts
	  }

	  get css() {
	    return this.result.css
	  }

	  get content() {
	    return this.result.css
	  }

	  get map() {
	    return this.result.map
	  }

	  get root() {
	    if (this._root) {
	      return this._root
	    }

	    let root;
	    let parser = parse;

	    try {
	      root = parser(this._css, this._opts);
	    } catch (error) {
	      this.error = error;
	    }

	    if (this.error) {
	      throw this.error
	    } else {
	      this._root = root;
	      return root
	    }
	  }

	  get messages() {
	    return []
	  }

	  warnings() {
	    return []
	  }

	  toString() {
	    return this._css
	  }

	  then(onFulfilled, onRejected) {
	    if (process.env.NODE_ENV !== 'production') {
	      if (!('from' in this._opts)) {
	        warnOnce(
	          'Without `from` option PostCSS could generate wrong source map ' +
	            'and will not find Browserslist config. Set it to CSS file path ' +
	            'or to `undefined` to prevent this warning.'
	        );
	      }
	    }

	    return this.async().then(onFulfilled, onRejected)
	  }

	  catch(onRejected) {
	    return this.async().catch(onRejected)
	  }

	  finally(onFinally) {
	    return this.async().then(onFinally, onFinally)
	  }

	  async() {
	    if (this.error) return Promise.reject(this.error)
	    return Promise.resolve(this.result)
	  }

	  sync() {
	    if (this.error) throw this.error
	    return this.result
	  }
	}

	noWorkResult = NoWorkResult;
	NoWorkResult.default = NoWorkResult;
	return noWorkResult;
}

var processor;
var hasRequiredProcessor;

function requireProcessor () {
	if (hasRequiredProcessor) return processor;
	hasRequiredProcessor = 1;

	let NoWorkResult = requireNoWorkResult();
	let LazyResult = requireLazyResult();
	let Document = requireDocument();
	let Root = requireRoot();

	class Processor {
	  constructor(plugins = []) {
	    this.version = '8.4.19';
	    this.plugins = this.normalize(plugins);
	  }

	  use(plugin) {
	    this.plugins = this.plugins.concat(this.normalize([plugin]));
	    return this
	  }

	  process(css, opts = {}) {
	    if (
	      this.plugins.length === 0 &&
	      typeof opts.parser === 'undefined' &&
	      typeof opts.stringifier === 'undefined' &&
	      typeof opts.syntax === 'undefined'
	    ) {
	      return new NoWorkResult(this, css, opts)
	    } else {
	      return new LazyResult(this, css, opts)
	    }
	  }

	  normalize(plugins) {
	    let normalized = [];
	    for (let i of plugins) {
	      if (i.postcss === true) {
	        i = i();
	      } else if (i.postcss) {
	        i = i.postcss;
	      }

	      if (typeof i === 'object' && Array.isArray(i.plugins)) {
	        normalized = normalized.concat(i.plugins);
	      } else if (typeof i === 'object' && i.postcssPlugin) {
	        normalized.push(i);
	      } else if (typeof i === 'function') {
	        normalized.push(i);
	      } else if (typeof i === 'object' && (i.parse || i.stringify)) {
	        if (process.env.NODE_ENV !== 'production') {
	          throw new Error(
	            'PostCSS syntaxes cannot be used as plugins. Instead, please use ' +
	              'one of the syntax/parser/stringifier options as outlined ' +
	              'in your PostCSS runner documentation.'
	          )
	        }
	      } else {
	        throw new Error(i + ' is not a PostCSS plugin')
	      }
	    }
	    return normalized
	  }
	}

	processor = Processor;
	Processor.default = Processor;

	Root.registerProcessor(Processor);
	Document.registerProcessor(Processor);
	return processor;
}

var fromJSON_1;
var hasRequiredFromJSON;

function requireFromJSON () {
	if (hasRequiredFromJSON) return fromJSON_1;
	hasRequiredFromJSON = 1;

	let Declaration = requireDeclaration();
	let PreviousMap = requirePreviousMap();
	let Comment = requireComment();
	let AtRule = requireAtRule();
	let Input = requireInput();
	let Root = requireRoot();
	let Rule = requireRule();

	function fromJSON(json, inputs) {
	  if (Array.isArray(json)) return json.map(n => fromJSON(n))

	  let { inputs: ownInputs, ...defaults } = json;
	  if (ownInputs) {
	    inputs = [];
	    for (let input of ownInputs) {
	      let inputHydrated = { ...input, __proto__: Input.prototype };
	      if (inputHydrated.map) {
	        inputHydrated.map = {
	          ...inputHydrated.map,
	          __proto__: PreviousMap.prototype
	        };
	      }
	      inputs.push(inputHydrated);
	    }
	  }
	  if (defaults.nodes) {
	    defaults.nodes = json.nodes.map(n => fromJSON(n, inputs));
	  }
	  if (defaults.source) {
	    let { inputId, ...source } = defaults.source;
	    defaults.source = source;
	    if (inputId != null) {
	      defaults.source.input = inputs[inputId];
	    }
	  }
	  if (defaults.type === 'root') {
	    return new Root(defaults)
	  } else if (defaults.type === 'decl') {
	    return new Declaration(defaults)
	  } else if (defaults.type === 'rule') {
	    return new Rule(defaults)
	  } else if (defaults.type === 'comment') {
	    return new Comment(defaults)
	  } else if (defaults.type === 'atrule') {
	    return new AtRule(defaults)
	  } else {
	    throw new Error('Unknown node type: ' + json.type)
	  }
	}

	fromJSON_1 = fromJSON;
	fromJSON.default = fromJSON;
	return fromJSON_1;
}

var postcss_1;
var hasRequiredPostcss;

function requirePostcss () {
	if (hasRequiredPostcss) return postcss_1;
	hasRequiredPostcss = 1;

	let CssSyntaxError = requireCssSyntaxError();
	let Declaration = requireDeclaration();
	let LazyResult = requireLazyResult();
	let Container = requireContainer();
	let Processor = requireProcessor();
	let stringify = requireStringify();
	let fromJSON = requireFromJSON();
	let Document = requireDocument();
	let Warning = requireWarning();
	let Comment = requireComment();
	let AtRule = requireAtRule();
	let Result = requireResult();
	let Input = requireInput();
	let parse = requireParse();
	let list = requireList();
	let Rule = requireRule();
	let Root = requireRoot();
	let Node = requireNode();

	function postcss(...plugins) {
	  if (plugins.length === 1 && Array.isArray(plugins[0])) {
	    plugins = plugins[0];
	  }
	  return new Processor(plugins)
	}

	postcss.plugin = function plugin(name, initializer) {
	  let warningPrinted = false;
	  function creator(...args) {
	    // eslint-disable-next-line no-console
	    if (console && console.warn && !warningPrinted) {
	      warningPrinted = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        name +
	          ': postcss.plugin was deprecated. Migration guide:\n' +
	          'https://evilmartians.com/chronicles/postcss-8-plugin-migration'
	      );
	      if (process.env.LANG && process.env.LANG.startsWith('cn')) {
	        /* c8 ignore next 7 */
	        // eslint-disable-next-line no-console
	        console.warn(
	          name +
	            ': 里面 postcss.plugin 被弃用. 迁移指南:\n' +
	            'https://www.w3ctech.com/topic/2226'
	        );
	      }
	    }
	    let transformer = initializer(...args);
	    transformer.postcssPlugin = name;
	    transformer.postcssVersion = new Processor().version;
	    return transformer
	  }

	  let cache;
	  Object.defineProperty(creator, 'postcss', {
	    get() {
	      if (!cache) cache = creator();
	      return cache
	    }
	  });

	  creator.process = function (css, processOpts, pluginOpts) {
	    return postcss([creator(pluginOpts)]).process(css, processOpts)
	  };

	  return creator
	};

	postcss.stringify = stringify;
	postcss.parse = parse;
	postcss.fromJSON = fromJSON;
	postcss.list = list;

	postcss.comment = defaults => new Comment(defaults);
	postcss.atRule = defaults => new AtRule(defaults);
	postcss.decl = defaults => new Declaration(defaults);
	postcss.rule = defaults => new Rule(defaults);
	postcss.root = defaults => new Root(defaults);
	postcss.document = defaults => new Document(defaults);

	postcss.CssSyntaxError = CssSyntaxError;
	postcss.Declaration = Declaration;
	postcss.Container = Container;
	postcss.Processor = Processor;
	postcss.Document = Document;
	postcss.Comment = Comment;
	postcss.Warning = Warning;
	postcss.AtRule = AtRule;
	postcss.Result = Result;
	postcss.Input = Input;
	postcss.Rule = Rule;
	postcss.Root = Root;
	postcss.Node = Node;

	LazyResult.registerPostcss(postcss);

	postcss_1 = postcss;
	postcss.default = postcss;
	return postcss_1;
}

var sanitizeHtml_1;
var hasRequiredSanitizeHtml;

function requireSanitizeHtml () {
	if (hasRequiredSanitizeHtml) return sanitizeHtml_1;
	hasRequiredSanitizeHtml = 1;
	const htmlparser = requireLib();
	const escapeStringRegexp = requireEscapeStringRegexp();
	const { isPlainObject } = requireIsPlainObject();
	const deepmerge = requireCjs();
	const parseSrcset = requireParseSrcset();
	const { parse: postcssParse } = requirePostcss();
	// Tags that can conceivably represent stand-alone media.
	const mediaTags = [
	  'img', 'audio', 'video', 'picture', 'svg',
	  'object', 'map', 'iframe', 'embed'
	];
	// Tags that are inherently vulnerable to being used in XSS attacks.
	const vulnerableTags = [ 'script', 'style' ];

	function each(obj, cb) {
	  if (obj) {
	    Object.keys(obj).forEach(function (key) {
	      cb(obj[key], key);
	    });
	  }
	}

	// Avoid false positives with .__proto__, .hasOwnProperty, etc.
	function has(obj, key) {
	  return ({}).hasOwnProperty.call(obj, key);
	}

	// Returns those elements of `a` for which `cb(a)` returns truthy
	function filter(a, cb) {
	  const n = [];
	  each(a, function(v) {
	    if (cb(v)) {
	      n.push(v);
	    }
	  });
	  return n;
	}

	function isEmptyObject(obj) {
	  for (const key in obj) {
	    if (has(obj, key)) {
	      return false;
	    }
	  }
	  return true;
	}

	function stringifySrcset(parsedSrcset) {
	  return parsedSrcset.map(function(part) {
	    if (!part.url) {
	      throw new Error('URL missing');
	    }

	    return (
	      part.url +
	      (part.w ? ` ${part.w}w` : '') +
	      (part.h ? ` ${part.h}h` : '') +
	      (part.d ? ` ${part.d}x` : '')
	    );
	  }).join(', ');
	}

	sanitizeHtml_1 = sanitizeHtml;

	// A valid attribute name.
	// We use a tolerant definition based on the set of strings defined by
	// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
	// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
	// The characters accepted are ones which can be appended to the attribute
	// name buffer without triggering a parse error:
	//   * unexpected-equals-sign-before-attribute-name
	//   * unexpected-null-character
	//   * unexpected-character-in-attribute-name
	// We exclude the empty string because it's impossible to get to the after
	// attribute name state with an empty attribute name buffer.
	const VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;

	// Ignore the _recursing flag; it's there for recursive
	// invocation as a guard against this exploit:
	// https://github.com/fb55/htmlparser2/issues/105

	function sanitizeHtml(html, options, _recursing) {
	  if (html == null) {
	    return '';
	  }

	  let result = '';
	  // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
	  let tempResult = '';

	  function Frame(tag, attribs) {
	    const that = this;
	    this.tag = tag;
	    this.attribs = attribs || {};
	    this.tagPosition = result.length;
	    this.text = ''; // Node inner text
	    this.mediaChildren = [];

	    this.updateParentNodeText = function() {
	      if (stack.length) {
	        const parentFrame = stack[stack.length - 1];
	        parentFrame.text += that.text;
	      }
	    };

	    this.updateParentNodeMediaChildren = function() {
	      if (stack.length && mediaTags.includes(this.tag)) {
	        const parentFrame = stack[stack.length - 1];
	        parentFrame.mediaChildren.push(this.tag);
	      }
	    };
	  }

	  options = Object.assign({}, sanitizeHtml.defaults, options);
	  options.parser = Object.assign({}, htmlParserDefaults, options.parser);

	  // vulnerableTags
	  vulnerableTags.forEach(function (tag) {
	    if (
	      options.allowedTags && options.allowedTags.indexOf(tag) > -1 &&
	      !options.allowVulnerableTags
	    ) {
	      console.warn(`\n\n⚠️ Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
	    }
	  });

	  // Tags that contain something other than HTML, or where discarding
	  // the text when the tag is disallowed makes sense for other reasons.
	  // If we are not allowing these tags, we should drop their content too.
	  // For other tags you would drop the tag but keep its content.
	  const nonTextTagsArray = options.nonTextTags || [
	    'script',
	    'style',
	    'textarea',
	    'option'
	  ];
	  let allowedAttributesMap;
	  let allowedAttributesGlobMap;
	  if (options.allowedAttributes) {
	    allowedAttributesMap = {};
	    allowedAttributesGlobMap = {};
	    each(options.allowedAttributes, function(attributes, tag) {
	      allowedAttributesMap[tag] = [];
	      const globRegex = [];
	      attributes.forEach(function(obj) {
	        if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
	          globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
	        } else {
	          allowedAttributesMap[tag].push(obj);
	        }
	      });
	      if (globRegex.length) {
	        allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
	      }
	    });
	  }
	  const allowedClassesMap = {};
	  const allowedClassesGlobMap = {};
	  const allowedClassesRegexMap = {};
	  each(options.allowedClasses, function(classes, tag) {
	    // Implicitly allows the class attribute
	    if (allowedAttributesMap) {
	      if (!has(allowedAttributesMap, tag)) {
	        allowedAttributesMap[tag] = [];
	      }
	      allowedAttributesMap[tag].push('class');
	    }

	    allowedClassesMap[tag] = [];
	    allowedClassesRegexMap[tag] = [];
	    const globRegex = [];
	    classes.forEach(function(obj) {
	      if (typeof obj === 'string' && obj.indexOf('*') >= 0) {
	        globRegex.push(escapeStringRegexp(obj).replace(/\\\*/g, '.*'));
	      } else if (obj instanceof RegExp) {
	        allowedClassesRegexMap[tag].push(obj);
	      } else {
	        allowedClassesMap[tag].push(obj);
	      }
	    });
	    if (globRegex.length) {
	      allowedClassesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
	    }
	  });

	  const transformTagsMap = {};
	  let transformTagsAll;
	  each(options.transformTags, function(transform, tag) {
	    let transFun;
	    if (typeof transform === 'function') {
	      transFun = transform;
	    } else if (typeof transform === 'string') {
	      transFun = sanitizeHtml.simpleTransform(transform);
	    }
	    if (tag === '*') {
	      transformTagsAll = transFun;
	    } else {
	      transformTagsMap[tag] = transFun;
	    }
	  });

	  let depth;
	  let stack;
	  let skipMap;
	  let transformMap;
	  let skipText;
	  let skipTextDepth;
	  let addedText = false;

	  initializeState();

	  const parser = new htmlparser.Parser({
	    onopentag: function(name, attribs) {
	      // If `enforceHtmlBoundary` is `true` and this has found the opening
	      // `html` tag, reset the state.
	      if (options.enforceHtmlBoundary && name === 'html') {
	        initializeState();
	      }

	      if (skipText) {
	        skipTextDepth++;
	        return;
	      }
	      const frame = new Frame(name, attribs);
	      stack.push(frame);

	      let skip = false;
	      const hasText = !!frame.text;
	      let transformedTag;
	      if (has(transformTagsMap, name)) {
	        transformedTag = transformTagsMap[name](name, attribs);

	        frame.attribs = attribs = transformedTag.attribs;

	        if (transformedTag.text !== undefined) {
	          frame.innerText = transformedTag.text;
	        }

	        if (name !== transformedTag.tagName) {
	          frame.name = name = transformedTag.tagName;
	          transformMap[depth] = transformedTag.tagName;
	        }
	      }
	      if (transformTagsAll) {
	        transformedTag = transformTagsAll(name, attribs);

	        frame.attribs = attribs = transformedTag.attribs;
	        if (name !== transformedTag.tagName) {
	          frame.name = name = transformedTag.tagName;
	          transformMap[depth] = transformedTag.tagName;
	        }
	      }

	      if ((options.allowedTags && options.allowedTags.indexOf(name) === -1) || (options.disallowedTagsMode === 'recursiveEscape' && !isEmptyObject(skipMap)) || (options.nestingLimit != null && depth >= options.nestingLimit)) {
	        skip = true;
	        skipMap[depth] = true;
	        if (options.disallowedTagsMode === 'discard') {
	          if (nonTextTagsArray.indexOf(name) !== -1) {
	            skipText = true;
	            skipTextDepth = 1;
	          }
	        }
	        skipMap[depth] = true;
	      }
	      depth++;
	      if (skip) {
	        if (options.disallowedTagsMode === 'discard') {
	          // We want the contents but not this tag
	          return;
	        }
	        tempResult = result;
	        result = '';
	      }
	      result += '<' + name;

	      if (name === 'script') {
	        if (options.allowedScriptHostnames || options.allowedScriptDomains) {
	          frame.innerText = '';
	        }
	      }

	      if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
	        each(attribs, function(value, a) {
	          if (!VALID_HTML_ATTRIBUTE_NAME.test(a)) {
	            // This prevents part of an attribute name in the output from being
	            // interpreted as the end of an attribute, or end of a tag.
	            delete frame.attribs[a];
	            return;
	          }
	          let parsed;
	          // check allowedAttributesMap for the element and attribute and modify the value
	          // as necessary if there are specific values defined.
	          let passedAllowedAttributesMapCheck = false;
	          if (!allowedAttributesMap ||
	            (has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1) ||
	            (allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1) ||
	            (has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a)) ||
	            (allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a))) {
	            passedAllowedAttributesMapCheck = true;
	          } else if (allowedAttributesMap && allowedAttributesMap[name]) {
	            for (const o of allowedAttributesMap[name]) {
	              if (isPlainObject(o) && o.name && (o.name === a)) {
	                passedAllowedAttributesMapCheck = true;
	                let newValue = '';
	                if (o.multiple === true) {
	                  // verify the values that are allowed
	                  const splitStrArray = value.split(' ');
	                  for (const s of splitStrArray) {
	                    if (o.values.indexOf(s) !== -1) {
	                      if (newValue === '') {
	                        newValue = s;
	                      } else {
	                        newValue += ' ' + s;
	                      }
	                    }
	                  }
	                } else if (o.values.indexOf(value) >= 0) {
	                  // verified an allowed value matches the entire attribute value
	                  newValue = value;
	                }
	                value = newValue;
	              }
	            }
	          }
	          if (passedAllowedAttributesMapCheck) {
	            if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
	              if (naughtyHref(name, value)) {
	                delete frame.attribs[a];
	                return;
	              }
	            }

	            if (name === 'script' && a === 'src') {

	              let allowed = true;

	              try {
	                const parsed = new URL(value);

	                if (options.allowedScriptHostnames || options.allowedScriptDomains) {
	                  const allowedHostname = (options.allowedScriptHostnames || []).find(function (hostname) {
	                    return hostname === parsed.hostname;
	                  });
	                  const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
	                    return parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`);
	                  });
	                  allowed = allowedHostname || allowedDomain;
	                }
	              } catch (e) {
	                allowed = false;
	              }

	              if (!allowed) {
	                delete frame.attribs[a];
	                return;
	              }
	            }

	            if (name === 'iframe' && a === 'src') {
	              let allowed = true;
	              try {
	                // Chrome accepts \ as a substitute for / in the // at the
	                // start of a URL, so rewrite accordingly to prevent exploit.
	                // Also drop any whitespace at that point in the URL
	                value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, '$1//');
	                if (value.startsWith('relative:')) {
	                  // An attempt to exploit our workaround for base URLs being
	                  // mandatory for relative URL validation in the WHATWG
	                  // URL parser, reject it
	                  throw new Error('relative: exploit attempt');
	                }
	                // naughtyHref is in charge of whether protocol relative URLs
	                // are cool. Here we are concerned just with allowed hostnames and
	                // whether to allow relative URLs.
	                //
	                // Build a placeholder "base URL" against which any reasonable
	                // relative URL may be parsed successfully
	                let base = 'relative://relative-site';
	                for (let i = 0; (i < 100); i++) {
	                  base += `/${i}`;
	                }
	                const parsed = new URL(value, base);
	                const isRelativeUrl = parsed && parsed.hostname === 'relative-site' && parsed.protocol === 'relative:';
	                if (isRelativeUrl) {
	                  // default value of allowIframeRelativeUrls is true
	                  // unless allowedIframeHostnames or allowedIframeDomains specified
	                  allowed = has(options, 'allowIframeRelativeUrls')
	                    ? options.allowIframeRelativeUrls
	                    : (!options.allowedIframeHostnames && !options.allowedIframeDomains);
	                } else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
	                  const allowedHostname = (options.allowedIframeHostnames || []).find(function (hostname) {
	                    return hostname === parsed.hostname;
	                  });
	                  const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
	                    return parsed.hostname === domain || parsed.hostname.endsWith(`.${domain}`);
	                  });
	                  allowed = allowedHostname || allowedDomain;
	                }
	              } catch (e) {
	                // Unparseable iframe src
	                allowed = false;
	              }
	              if (!allowed) {
	                delete frame.attribs[a];
	                return;
	              }
	            }
	            if (a === 'srcset') {
	              try {
	                parsed = parseSrcset(value);
	                parsed.forEach(function(value) {
	                  if (naughtyHref('srcset', value.url)) {
	                    value.evil = true;
	                  }
	                });
	                parsed = filter(parsed, function(v) {
	                  return !v.evil;
	                });
	                if (!parsed.length) {
	                  delete frame.attribs[a];
	                  return;
	                } else {
	                  value = stringifySrcset(filter(parsed, function(v) {
	                    return !v.evil;
	                  }));
	                  frame.attribs[a] = value;
	                }
	              } catch (e) {
	                // Unparseable srcset
	                delete frame.attribs[a];
	                return;
	              }
	            }
	            if (a === 'class') {
	              const allowedSpecificClasses = allowedClassesMap[name];
	              const allowedWildcardClasses = allowedClassesMap['*'];
	              const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
	              const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
	              const allowedWildcardClassesGlob = allowedClassesGlobMap['*'];
	              const allowedClassesGlobs = [
	                allowedSpecificClassesGlob,
	                allowedWildcardClassesGlob
	              ]
	                .concat(allowedSpecificClassesRegex)
	                .filter(function (t) {
	                  return t;
	                });
	              if (allowedSpecificClasses && allowedWildcardClasses) {
	                value = filterClasses(value, deepmerge(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
	              } else {
	                value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
	              }
	              if (!value.length) {
	                delete frame.attribs[a];
	                return;
	              }
	            }
	            if (a === 'style') {
	              try {
	                const abstractSyntaxTree = postcssParse(name + ' {' + value + '}');
	                const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);

	                value = stringifyStyleAttributes(filteredAST);

	                if (value.length === 0) {
	                  delete frame.attribs[a];
	                  return;
	                }
	              } catch (e) {
	                delete frame.attribs[a];
	                return;
	              }
	            }
	            result += ' ' + a;
	            if (value && value.length) {
	              result += '="' + escapeHtml(value, true) + '"';
	            }
	          } else {
	            delete frame.attribs[a];
	          }
	        });
	      }
	      if (options.selfClosing.indexOf(name) !== -1) {
	        result += ' />';
	      } else {
	        result += '>';
	        if (frame.innerText && !hasText && !options.textFilter) {
	          result += escapeHtml(frame.innerText);
	          addedText = true;
	        }
	      }
	      if (skip) {
	        result = tempResult + escapeHtml(result);
	        tempResult = '';
	      }
	    },
	    ontext: function(text) {
	      if (skipText) {
	        return;
	      }
	      const lastFrame = stack[stack.length - 1];
	      let tag;

	      if (lastFrame) {
	        tag = lastFrame.tag;
	        // If inner text was set by transform function then let's use it
	        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
	      }

	      if (options.disallowedTagsMode === 'discard' && ((tag === 'script') || (tag === 'style'))) {
	        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
	        // script tags is, by definition, game over for XSS protection, so if that's
	        // your concern, don't allow them. The same is essentially true for style tags
	        // which have their own collection of XSS vectors.
	        result += text;
	      } else {
	        const escaped = escapeHtml(text, false);
	        if (options.textFilter && !addedText) {
	          result += options.textFilter(escaped, tag);
	        } else if (!addedText) {
	          result += escaped;
	        }
	      }
	      if (stack.length) {
	        const frame = stack[stack.length - 1];
	        frame.text += text;
	      }
	    },
	    onclosetag: function(name) {

	      if (skipText) {
	        skipTextDepth--;
	        if (!skipTextDepth) {
	          skipText = false;
	        } else {
	          return;
	        }
	      }

	      const frame = stack.pop();
	      if (!frame) {
	        // Do not crash on bad markup
	        return;
	      }
	      skipText = options.enforceHtmlBoundary ? name === 'html' : false;
	      depth--;
	      const skip = skipMap[depth];
	      if (skip) {
	        delete skipMap[depth];
	        if (options.disallowedTagsMode === 'discard') {
	          frame.updateParentNodeText();
	          return;
	        }
	        tempResult = result;
	        result = '';
	      }

	      if (transformMap[depth]) {
	        name = transformMap[depth];
	        delete transformMap[depth];
	      }

	      if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
	        result = result.substr(0, frame.tagPosition);
	        return;
	      }

	      frame.updateParentNodeMediaChildren();
	      frame.updateParentNodeText();

	      if (options.selfClosing.indexOf(name) !== -1) {
	        // Already output />
	        if (skip) {
	          result = tempResult;
	          tempResult = '';
	        }
	        return;
	      }

	      result += '</' + name + '>';
	      if (skip) {
	        result = tempResult + escapeHtml(result);
	        tempResult = '';
	      }
	    }
	  }, options.parser);
	  parser.write(html);
	  parser.end();

	  return result;

	  function initializeState() {
	    result = '';
	    depth = 0;
	    stack = [];
	    skipMap = {};
	    transformMap = {};
	    skipText = false;
	    skipTextDepth = 0;
	  }

	  function escapeHtml(s, quote) {
	    if (typeof (s) !== 'string') {
	      s = s + '';
	    }
	    if (options.parser.decodeEntities) {
	      s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	      if (quote) {
	        s = s.replace(/"/g, '&quot;');
	      }
	    }
	    // TODO: this is inadequate because it will pass `&0;`. This approach
	    // will not work, each & must be considered with regard to whether it
	    // is followed by a 100% syntactically valid entity or not, and escaped
	    // if it is not. If this bothers you, don't set parser.decodeEntities
	    // to false. (The default is true.)
	    s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;') // Match ampersands not part of existing HTML entity
	      .replace(/</g, '&lt;')
	      .replace(/>/g, '&gt;');
	    if (quote) {
	      s = s.replace(/"/g, '&quot;');
	    }
	    return s;
	  }

	  function naughtyHref(name, href) {
	    // Browsers ignore character codes of 32 (space) and below in a surprising
	    // number of situations. Start reading here:
	    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
	    // eslint-disable-next-line no-control-regex
	    href = href.replace(/[\x00-\x20]+/g, '');
	    // Clobber any comments in URLs, which the browser might
	    // interpret inside an XML data island, allowing
	    // a javascript: URL to be snuck through
	    href = href.replace(/<!--.*?-->/g, '');
	    // Case insensitive so we don't get faked out by JAVASCRIPT #1
	    // Allow more characters after the first so we don't get faked
	    // out by certain schemes browsers accept
	    const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
	    if (!matches) {
	      // Protocol-relative URL starting with any combination of '/' and '\'
	      if (href.match(/^[/\\]{2}/)) {
	        return !options.allowProtocolRelative;
	      }

	      // No scheme
	      return false;
	    }
	    const scheme = matches[1].toLowerCase();

	    if (has(options.allowedSchemesByTag, name)) {
	      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
	    }

	    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
	  }

	  /**
	   * Filters user input css properties by allowlisted regex attributes.
	   * Modifies the abstractSyntaxTree object.
	   *
	   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
	   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
	   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
	   * @return {object}                    - The modified tree.
	   */
	  function filterCss(abstractSyntaxTree, allowedStyles) {
	    if (!allowedStyles) {
	      return abstractSyntaxTree;
	    }

	    const astRules = abstractSyntaxTree.nodes[0];
	    let selectedRule;

	    // Merge global and tag-specific styles into new AST.
	    if (allowedStyles[astRules.selector] && allowedStyles['*']) {
	      selectedRule = deepmerge(
	        allowedStyles[astRules.selector],
	        allowedStyles['*']
	      );
	    } else {
	      selectedRule = allowedStyles[astRules.selector] || allowedStyles['*'];
	    }

	    if (selectedRule) {
	      abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
	    }

	    return abstractSyntaxTree;
	  }

	  /**
	   * Extracts the style attribues from an AbstractSyntaxTree and formats those
	   * values in the inline style attribute format.
	   *
	   * @param  {AbstractSyntaxTree} filteredAST
	   * @return {string}             - Example: "color:yellow;text-align:center;font-family:helvetica;"
	   */
	  function stringifyStyleAttributes(filteredAST) {
	    return filteredAST.nodes[0].nodes
	      .reduce(function(extractedAttributes, attributeObject) {
	        extractedAttributes.push(
	          attributeObject.prop + ':' + attributeObject.value
	        );
	        return extractedAttributes;
	      }, [])
	      .join(';');
	  }

	  /**
	    * Filters the existing attributes for the given property. Discards any attributes
	    * which don't match the allowlist.
	    *
	    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
	    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
	    * @param  {object} attributeObject          - Object representing the current css property.
	    * @property {string} attributeObject.type   - Typically 'declaration'.
	    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
	    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
	    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
	    */
	  function filterDeclarations(selectedRule) {
	    return function (allowedDeclarationsList, attributeObject) {
	      // If this property is allowlisted...
	      if (has(selectedRule, attributeObject.prop)) {
	        const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
	          return regularExpression.test(attributeObject.value);
	        });

	        if (matchesRegex) {
	          allowedDeclarationsList.push(attributeObject);
	        }
	      }
	      return allowedDeclarationsList;
	    };
	  }

	  function filterClasses(classes, allowed, allowedGlobs) {
	    if (!allowed) {
	      // The class attribute is allowed without filtering on this tag
	      return classes;
	    }
	    classes = classes.split(/\s+/);
	    return classes.filter(function(clss) {
	      return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
	        return glob.test(clss);
	      });
	    }).join(' ');
	  }
	}

	// Defaults are accessible to you so that you can use them as a starting point
	// programmatically if you wish

	const htmlParserDefaults = {
	  decodeEntities: true
	};
	sanitizeHtml.defaults = {
	  allowedTags: [
	    // Sections derived from MDN element categories and limited to the more
	    // benign categories.
	    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
	    // Content sectioning
	    'address', 'article', 'aside', 'footer', 'header',
	    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup',
	    'main', 'nav', 'section',
	    // Text content
	    'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure',
	    'hr', 'li', 'main', 'ol', 'p', 'pre', 'ul',
	    // Inline text semantics
	    'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn',
	    'em', 'i', 'kbd', 'mark', 'q',
	    'rb', 'rp', 'rt', 'rtc', 'ruby',
	    's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr',
	    // Table content
	    'caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th',
	    'thead', 'tr'
	  ],
	  disallowedTagsMode: 'discard',
	  allowedAttributes: {
	    a: [ 'href', 'name', 'target' ],
	    // We don't currently allow img itself by default, but this
	    // would make sense if we did. You could add srcset here,
	    // and if you do the URL is checked for safety
	    img: [ 'src' ]
	  },
	  // Lots of these won't come up by default because we don't allow them
	  selfClosing: [ 'img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
	  // URL schemes we permit
	  allowedSchemes: [ 'http', 'https', 'ftp', 'mailto', 'tel' ],
	  allowedSchemesByTag: {},
	  allowedSchemesAppliedToAttributes: [ 'href', 'src', 'cite' ],
	  allowProtocolRelative: true,
	  enforceHtmlBoundary: false
	};

	sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
	  merge = (merge === undefined) ? true : merge;
	  newAttribs = newAttribs || {};

	  return function(tagName, attribs) {
	    let attrib;
	    if (merge) {
	      for (attrib in newAttribs) {
	        attribs[attrib] = newAttribs[attrib];
	      }
	    } else {
	      attribs = newAttribs;
	    }

	    return {
	      tagName: newTagName,
	      attribs: attribs
	    };
	  };
	};
	return sanitizeHtml_1;
}

var sanitizeHtmlExports = requireSanitizeHtml();
var sanitize = /*@__PURE__*/getDefaultExportFromCjs(sanitizeHtmlExports);

const allowedTags = [
    'a',
    'abbr',
    'address',
    'article',
    'aside',
    'b',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'br',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'del',
    'div',
    'dd',
    'details',
    'dfn',
    'dl',
    'dt',
    'em',
    'figcaption',
    'figure',
    'font',
    'footer',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hr',
    'i',
    'img',
    'ins',
    'kbd',
    'li',
    'main',
    'mark',
    'nav',
    'o',
    'ol',
    'p',
    'pre',
    'q',
    'rp',
    'rt',
    'rtc',
    'ruby',
    's',
    'samp',
    'section',
    'small',
    'span',
    'strike',
    'strong',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'tt',
    'u',
    'ul',
    'var',
    'wbr'
];
const allowedStyles = [
    'background',
    'background-attachment',
    'background-color',
    'background-image',
    'background-position',
    'background-repeat',
    'border',
    'border-bottom',
    'border-bottom-color',
    'border-bottom-left-radius',
    'border-bottom-right-radius',
    'border-bottom-style',
    'border-bottom-width',
    'border-collapse',
    'border-color',
    'border-left',
    'border-left-color',
    'border-left-style',
    'border-left-width',
    'border-radius',
    'border-right',
    'border-right-color',
    'border-right-style',
    'border-right-width',
    'border-spacing',
    'border-style',
    'border-top',
    'border-top-color',
    'border-top-left-radius',
    'border-top-right-radius',
    'border-top-style',
    'border-top-width',
    'border-width',
    'box-shadow',
    'caption-side',
    'color',
    'cue',
    'cue-after',
    'cue-before',
    'direction',
    'elevation',
    'empty-cells',
    'font',
    'font-family',
    'font-size',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'height',
    'letter-spacing',
    'line-height',
    'list-style',
    'list-style-image',
    'list-style-position',
    'list-style-type',
    'margin',
    'margin-bottom',
    'margin-left',
    'margin-right',
    'margin-top',
    'max-height',
    'max-width',
    'min-height',
    'min-width',
    'outline',
    'outline-color',
    'outline-style',
    'outline-width',
    'padding',
    'padding-bottom',
    'padding-left',
    'padding-right',
    'padding-top',
    'pause',
    'pause-after',
    'pause-before',
    'pitch',
    'pitch-range',
    'quotes',
    'richness',
    'speak',
    'speak-header',
    'speak-numeral',
    'speak-punctuation',
    'speech-rate',
    'stress',
    'table-layout',
    'text-align',
    'text-decoration',
    'text-indent',
    'text-overflow',
    'text-shadow',
    'text-transform',
    'text-wrap',
    'unicode-bidi',
    'vertical-align',
    'voice-family',
    'volume',
    'white-space',
    'width',
    'word-spacing',
    'word-wrap'
];
function buildAllowedStyles() {
    const styles = {};
    allowedStyles.forEach(style => (styles[style] = [/^.+$/]));
    return styles;
}
const options = {
    allowedTags,
    allowedSchemes: ['http', 'https', 'mailto'],
    allowedSchemesByTag: {
        img: ['data']
    },
    allowedAttributes: {
        '*': ['style'],
        a: ['href', 'rel', 'target', 'data-iwa-route'],
        img: ['src', 'alt', 'height', 'width'],
        table: ['summary', 'align', 'valign'],
        thead: ['align', 'valign'],
        tbody: ['align', 'valign'],
        tfoot: ['align', 'valign'],
        colgroup: ['align', 'valign'],
        col: ['align', 'valign'],
        tr: ['align', 'valign'],
        th: ['align', 'valign'],
        td: ['align', 'valign']
    },
    allowedStyles: {
        '*': buildAllowedStyles()
    },
    nonTextTags: ['style', 'script', 'textarea', 'option', 'noscript', 'title'],
    selfClosing: sanitize.defaults.selfClosing.concat(['col', 'wbr']),
    transformTags: {
        // Add rel and target attributes to all links.
        a: sanitizeHtmlExports.simpleTransform('a', {
            rel: 'nofollow',
            target: '_blank'
        }, true)
    }
};
function sanitiseHtml(html) {
    return sanitize(html, options);
}

/**
 * Component to display raw HTML, sanitised by default.
 *
 * @param props - Component props.
 */
const HtmlView = forwardRef((props, ref) => {
    const { sanitise, elementType, className, children } = props;
    const sanitised = useMemo(() => {
        return sanitise === undefined || sanitise ? sanitiseHtml(children) : children;
    }, [sanitise, children]);
    return createElement(elementType !== null && elementType !== void 0 ? elementType : 'div', {
        className,
        ref,
        dangerouslySetInnerHTML: {
            __html: sanitised
        }
    });
});
HtmlView.displayName = 'HtmlView';

const MessageView = ({ message }) => {
    const { message: strings } = useStrings();
    const rootElement = useRef(null);
    useExternalRouteLinks(rootElement);
    return React__default.createElement("div", { className: "MessageView" },
        React__default.createElement(DefinitionList, { definitions: [
                { name: strings.fromLabel, value: message.from },
                { name: strings.subjectLabel, value: message.subject },
                { name: strings.dateLabel, value: React__default.createElement(DateText, { date: message.date }) }
            ] }),
        React__default.createElement(HtmlView, { className: "MessageView-body", ref: rootElement }, message.htmlBody));
};

/**
 * Hook to mark a message as read after a timeout.
 *
 * @param messageId - ID of the message to mark as read, or null to disable the hook.
 */
function useReadMarker(messageId) {
    const user = useTypedSelector(selectCurrentUser);
    const [markMessages] = useMarkMessagesMutation();
    useEffect(() => {
        if (!user || messageId === null) {
            return;
        }
        const timeout = setTimeout(() => {
            markMessages({
                userId: user.id,
                markReadIds: [{ id: messageId, read: true }]
            });
        }, config.markMessagesReadTimeout);
        return () => {
            clearTimeout(timeout);
        };
    }, [user, markMessages, messageId]);
}

const textHeight = 25;
const MessageScreenSkeleton = () => {
    const { message: strings } = useStrings();
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(Screen, { header: React__default.createElement(ContentHeaderSkeleton, { hasRole: false }), className: className$s() },
            React__default.createElement("section", { className: className$s('content') },
                React__default.createElement(DefinitionList, { definitions: [
                        { name: strings.fromLabel, value: React__default.createElement(Skeleton$1, { width: "35%", maxWidth: 120 }) },
                        { name: strings.subjectLabel, value: React__default.createElement(Skeleton$1, { width: "70%", maxWidth: 250 }) },
                        { name: strings.dateLabel, value: React__default.createElement(Skeleton$1, { width: "50%", maxWidth: 160 }) }
                    ] }),
                React__default.createElement("div", { className: className$s('message') },
                    React__default.createElement(Skeleton$1, { height: textHeight, width: "55%" }),
                    React__default.createElement(Skeleton$1, { height: textHeight, width: "45%" }),
                    React__default.createElement(Skeleton$1, { height: textHeight, width: "70%" }),
                    React__default.createElement(Skeleton$1, { height: textHeight, width: "58%" }),
                    React__default.createElement(Skeleton$1, { height: textHeight, width: "65%" })))));
};
const className$s = createClassName('MessageScreenSkeleton');

const MessageScreen = ({ messageId }) => {
    const { message: strings } = useStrings();
    const user = useTypedSelector(selectCurrentUser);
    const { data: message, error } = useGetMessageQuery(user ? {
        userId: user.id,
        messageId
    } : queryExports.skipToken);
    const errorMessage = useApiErrorMessage(strings.loadError, error, {
        404: strings.notFound
    });
    usePageTitle(message === null || message === void 0 ? void 0 : message.subject);
    useReadMarker(message && !message.read ? message.id : null);
    if (!user) {
        return null;
    }
    else if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!message) {
        return React__default.createElement(MessageScreenSkeleton, null);
    }
    const header = React__default.createElement(ContentHeader, { backUrl: "/messages", backTitle: strings.backToMessages },
        React__default.createElement(ContentHeader.Title, { title: message.subject }));
    return React__default.createElement(Screen, { className: "MessageScreen", header: header },
        React__default.createElement("section", { className: "MessageScreen-content" },
            React__default.createElement(MessageView, { message: message })));
};

const MessageRoute = () => {
    const { messageId } = useParams();
    if (!messageId || !isNumeric(messageId)) {
        return React__default.createElement(NotFoundScreen, null);
    }
    return React__default.createElement(MessageScreen, { messageId: messageId });
};

const MessagesRouter = () => {
    const dispatch = useTypedDispatch();
    useEffect(() => {
        return () => {
            dispatch(clearMessagesPage());
        };
    }, [dispatch]);
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { path: "/", element: React__default.createElement(MessagesScreen, null) }),
        React__default.createElement(Route, { path: ":messageId/*", element: React__default.createElement(MessageRoute, null) }),
        React__default.createElement(Route, { path: "*", element: React__default.createElement(NotFoundScreen, null) }));
};

const ModuleGuestLookupPanel = () => {
    const { modules } = useContext();
    const panel = useMemo(() => {
        var _a, _b;
        const layouts = modules === null || modules === void 0 ? void 0 : modules.flatMap(mod => { var _a; return (_a = mod.layouts) !== null && _a !== void 0 ? _a : []; });
        return (_b = (_a = layouts === null || layouts === void 0 ? void 0 : layouts.find(layout => layout.guestLookupPanel)) === null || _a === void 0 ? void 0 : _a.guestLookupPanel) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [modules]);
    return panel ? React__default.createElement(React__default.Fragment, null, panel) : null;
};

const GuestLookupScreen = () => {
    const { vehicleLookup: strings } = useStrings();
    const dispatch = useTypedDispatch();
    usePageTitle(strings.title);
    useHelp('vehicle.lookupForm');
    useEffect(() => {
        dispatch(clearCurrentVehicle());
    }, [dispatch]);
    return React__default.createElement(Screen, { className: "GuestLookupScreen" },
        React__default.createElement(PanelGrid, null,
            React__default.createElement(ChooseVehiclePanel, null),
            React__default.createElement(ModuleGuestLookupPanel, null)));
};

var faCalendar = {};

var hasRequiredFaCalendar;

function requireFaCalendar () {
	if (hasRequiredFaCalendar) return faCalendar;
	hasRequiredFaCalendar = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'calendar';
		var width = 448;
		var height = 512;
		var ligatures = [];
		var unicode = 'f133';
		var svgPathData = 'M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faCalendar = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faCalendar));
	return faCalendar;
}

var faCalendarExports = requireFaCalendar();

function r$1(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r$1(e[t]))&&(n&&(n+=" "),n+=f);}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r$1(e))&&(n&&(n+=" "),n+=t);return n}

const _excluded$i = ["localeText"];
const MuiPickersAdapterContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  MuiPickersAdapterContext.displayName = 'MuiPickersAdapterContext';
}
/**
 * Demos:
 *
 * - [Date format and localization](https://mui.com/x/react-date-pickers/adapters-locale/)
 * - [Calendar systems](https://mui.com/x/react-date-pickers/calendar-systems/)
 * - [Translated components](https://mui.com/x/react-date-pickers/localization/)
 * - [UTC and timezones](https://mui.com/x/react-date-pickers/timezone/)
 *
 * API:
 *
 * - [LocalizationProvider API](https://mui.com/x/api/date-pickers/localization-provider/)
 */
const LocalizationProvider = function LocalizationProvider(inProps) {
  const {
      localeText: inLocaleText
    } = inProps,
    otherInProps = _objectWithoutPropertiesLoose(inProps, _excluded$i);
  const {
    utils: parentUtils,
    localeText: parentLocaleText
  } = React.useContext(MuiPickersAdapterContext) ?? {
    utils: undefined,
    localeText: undefined
  };
  const props = useThemeProps({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: otherInProps,
    name: 'MuiLocalizationProvider'
  });
  const {
    children,
    dateAdapter: DateAdapter,
    dateFormats,
    dateLibInstance,
    adapterLocale,
    localeText: themeLocaleText
  } = props;
  const localeText = React.useMemo(() => _extends({}, themeLocaleText, parentLocaleText, inLocaleText), [themeLocaleText, parentLocaleText, inLocaleText]);
  const utils = React.useMemo(() => {
    if (!DateAdapter) {
      if (parentUtils) {
        return parentUtils;
      }
      return null;
    }
    const adapter = new DateAdapter({
      locale: adapterLocale,
      formats: dateFormats,
      instance: dateLibInstance
    });
    if (!adapter.isMUIAdapter) {
      throw new Error(['MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`', "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", 'More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation'].join(`\n`));
    }
    return adapter;
  }, [DateAdapter, adapterLocale, dateFormats, dateLibInstance, parentUtils]);
  const defaultDates = React.useMemo(() => {
    if (!utils) {
      return null;
    }
    return {
      minDate: utils.date('1900-01-01T00:00:00.000'),
      maxDate: utils.date('2099-12-31T00:00:00.000')
    };
  }, [utils]);
  const contextValue = React.useMemo(() => {
    return {
      utils,
      defaultDates,
      localeText
    };
  }, [defaultDates, utils, localeText]);
  return /*#__PURE__*/jsx(MuiPickersAdapterContext.Provider, {
    value: contextValue,
    children: children
  });
};
process.env.NODE_ENV !== "production" ? LocalizationProvider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: PropTypes.any,
  children: PropTypes.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: PropTypes.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: PropTypes.shape({
    dayOfMonth: PropTypes.string,
    dayOfMonthFull: PropTypes.string,
    fullDate: PropTypes.string,
    fullTime: PropTypes.string,
    fullTime12h: PropTypes.string,
    fullTime24h: PropTypes.string,
    hours12h: PropTypes.string,
    hours24h: PropTypes.string,
    keyboardDate: PropTypes.string,
    keyboardDateTime: PropTypes.string,
    keyboardDateTime12h: PropTypes.string,
    keyboardDateTime24h: PropTypes.string,
    meridiem: PropTypes.string,
    minutes: PropTypes.string,
    month: PropTypes.string,
    monthShort: PropTypes.string,
    normalDate: PropTypes.string,
    normalDateWithWeekday: PropTypes.string,
    seconds: PropTypes.string,
    shortDate: PropTypes.string,
    weekday: PropTypes.string,
    weekdayShort: PropTypes.string,
    year: PropTypes.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: PropTypes.any,
  /**
   * Locale for components texts
   */
  localeText: PropTypes.object
} : void 0;

const getPickersLocalization = pickersTranslations => {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: _extends({}, pickersTranslations)
        }
      }
    }
  };
};

// This object is not Partial<PickersLocaleText> because it is the default values

const enUSPickers = {
  // Calendar navigation
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  // View navigation
  openPreviousView: 'Open previous view',
  openNextView: 'Open next view',
  calendarViewSwitchingButtonAriaLabel: view => view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
  // DateRange labels
  start: 'Start',
  end: 'End',
  startDate: 'Start date',
  startTime: 'Start time',
  endDate: 'End date',
  endTime: 'End time',
  // Action bar
  cancelButtonLabel: 'Cancel',
  clearButtonLabel: 'Clear',
  okButtonLabel: 'OK',
  todayButtonLabel: 'Today',
  // Toolbar titles
  datePickerToolbarTitle: 'Select date',
  dateTimePickerToolbarTitle: 'Select date & time',
  timePickerToolbarTitle: 'Select time',
  dateRangePickerToolbarTitle: 'Select date range',
  // Clock labels
  clockLabelText: (view, time, utils, formattedTime) => `Select ${view}. ${!formattedTime && (time === null || !utils.isValid(time)) ? 'No time selected' : `Selected time is ${formattedTime ?? utils.format(time, 'fullTime')}`}`,
  hoursClockNumberText: hours => `${hours} hours`,
  minutesClockNumberText: minutes => `${minutes} minutes`,
  secondsClockNumberText: seconds => `${seconds} seconds`,
  // Digital clock labels
  selectViewText: view => `Select ${view}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: 'Week number',
  calendarWeekNumberHeaderText: '#',
  calendarWeekNumberAriaLabelText: weekNumber => `Week ${weekNumber}`,
  calendarWeekNumberText: weekNumber => `${weekNumber}`,
  // Open picker labels
  openDatePickerDialogue: (value, utils, formattedDate) => formattedDate || value !== null && utils.isValid(value) ? `Choose date, selected date is ${formattedDate ?? utils.format(value, 'fullDate')}` : 'Choose date',
  openTimePickerDialogue: (value, utils, formattedTime) => formattedTime || value !== null && utils.isValid(value) ? `Choose time, selected time is ${formattedTime ?? utils.format(value, 'fullTime')}` : 'Choose time',
  fieldClearLabel: 'Clear',
  // Table labels
  timeTableLabel: 'pick time',
  dateTableLabel: 'pick date',
  // Field section placeholders
  fieldYearPlaceholder: params => 'Y'.repeat(params.digitAmount),
  fieldMonthPlaceholder: params => params.contentType === 'letter' ? 'MMMM' : 'MM',
  fieldDayPlaceholder: () => 'DD',
  fieldWeekDayPlaceholder: params => params.contentType === 'letter' ? 'EEEE' : 'EE',
  fieldHoursPlaceholder: () => 'hh',
  fieldMinutesPlaceholder: () => 'mm',
  fieldSecondsPlaceholder: () => 'ss',
  fieldMeridiemPlaceholder: () => 'aa',
  // View names
  year: 'Year',
  month: 'Month',
  day: 'Day',
  weekDay: 'Week day',
  hours: 'Hours',
  minutes: 'Minutes',
  seconds: 'Seconds',
  meridiem: 'Meridiem',
  // Common
  empty: 'Empty'
};
const DEFAULT_LOCALE = enUSPickers;
getPickersLocalization(enUSPickers);

const useLocalizationContext = () => {
  const localization = React.useContext(MuiPickersAdapterContext);
  if (localization === null) {
    throw new Error(['MUI X: Can not find the date and time pickers localization context.', 'It looks like you forgot to wrap your component in LocalizationProvider.', 'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'].join('\n'));
  }
  if (localization.utils === null) {
    throw new Error(['MUI X: Can not find the date and time pickers adapter from its localization context.', 'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'].join('\n'));
  }
  const localeText = React.useMemo(() => _extends({}, DEFAULT_LOCALE, localization.localeText), [localization.localeText]);
  return React.useMemo(() => _extends({}, localization, {
    localeText
  }), [localization, localeText]);
};
const useUtils = () => useLocalizationContext().utils;
const useDefaultDates = () => useLocalizationContext().defaultDates;
const useNow = timezone => {
  const utils = useUtils();
  const now = React.useRef();
  if (now.current === undefined) {
    now.current = utils.date(undefined, timezone);
  }
  return now.current;
};

const usePickersTranslations = () => useLocalizationContext().localeText;

const ArrowDropDownIcon = createSvgIcon(/*#__PURE__*/jsx("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

/**
 * @ignore - internal component.
 */
const ArrowLeftIcon = createSvgIcon(/*#__PURE__*/jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');

/**
 * @ignore - internal component.
 */
const ArrowRightIcon = createSvgIcon(/*#__PURE__*/jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');

/**
 * @ignore - internal component.
 */
createSvgIcon(/*#__PURE__*/jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');

/**
 * @ignore - internal component.
 */
createSvgIcon(/*#__PURE__*/jsxs(React.Fragment, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Clock');

/**
 * @ignore - internal component.
 */
createSvgIcon(/*#__PURE__*/jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');

/**
 * @ignore - internal component.
 */
createSvgIcon(/*#__PURE__*/jsxs(React.Fragment, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), 'Time');

/**
 * @ignore - internal component.
 */
createSvgIcon(/*#__PURE__*/jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

function getPickersArrowSwitcherUtilityClass(slot) {
  return generateUtilityClass('MuiPickersArrowSwitcher', slot);
}
generateUtilityClasses('MuiPickersArrowSwitcher', ['root', 'spacer', 'button', 'previousIconButton', 'nextIconButton', 'leftArrowIcon', 'rightArrowIcon']);

const _excluded$h = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel", "labelId"],
  _excluded2$3 = ["ownerState"],
  _excluded3 = ["ownerState"];
const PickersArrowSwitcherRoot = styled('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex'
});
const PickersArrowSwitcherSpacer = styled('div', {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Spacer',
  overridesResolver: (props, styles) => styles.spacer
})(({
  theme
}) => ({
  width: theme.spacing(3)
}));
const PickersArrowSwitcherButton = styled(IconButton$1, {
  name: 'MuiPickersArrowSwitcher',
  slot: 'Button',
  overridesResolver: (props, styles) => styles.button
})({
  variants: [{
    props: {
      hidden: true
    },
    style: {
      visibility: 'hidden'
    }
  }]
});
const useUtilityClasses$g = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    spacer: ['spacer'],
    button: ['button'],
    previousIconButton: ['previousIconButton'],
    nextIconButton: ['nextIconButton'],
    leftArrowIcon: ['leftArrowIcon'],
    rightArrowIcon: ['rightArrowIcon']
  };
  return composeClasses(slots, getPickersArrowSwitcherUtilityClass, classes);
};
const PickersArrowSwitcher = /*#__PURE__*/React.forwardRef(function PickersArrowSwitcher(inProps, ref) {
  const isRtl = useRtl();
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersArrowSwitcher'
  });
  const {
      children,
      className,
      slots,
      slotProps,
      isNextDisabled,
      isNextHidden,
      onGoToNext,
      nextLabel,
      isPreviousDisabled,
      isPreviousHidden,
      onGoToPrevious,
      previousLabel,
      labelId
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$h);
  const ownerState = props;
  const classes = useUtilityClasses$g(ownerState);
  const nextProps = {
    isDisabled: isNextDisabled,
    isHidden: isNextHidden,
    goTo: onGoToNext,
    label: nextLabel
  };
  const previousProps = {
    isDisabled: isPreviousDisabled,
    isHidden: isPreviousHidden,
    goTo: onGoToPrevious,
    label: previousLabel
  };
  const PreviousIconButton = slots?.previousIconButton ?? PickersArrowSwitcherButton;
  const previousIconButtonProps = useSlotProps({
    elementType: PreviousIconButton,
    externalSlotProps: slotProps?.previousIconButton,
    additionalProps: {
      size: 'medium',
      title: previousProps.label,
      'aria-label': previousProps.label,
      disabled: previousProps.isDisabled,
      edge: 'end',
      onClick: previousProps.goTo
    },
    ownerState: _extends({}, ownerState, {
      hidden: previousProps.isHidden
    }),
    className: clsx(classes.button, classes.previousIconButton)
  });
  const NextIconButton = slots?.nextIconButton ?? PickersArrowSwitcherButton;
  const nextIconButtonProps = useSlotProps({
    elementType: NextIconButton,
    externalSlotProps: slotProps?.nextIconButton,
    additionalProps: {
      size: 'medium',
      title: nextProps.label,
      'aria-label': nextProps.label,
      disabled: nextProps.isDisabled,
      edge: 'start',
      onClick: nextProps.goTo
    },
    ownerState: _extends({}, ownerState, {
      hidden: nextProps.isHidden
    }),
    className: clsx(classes.button, classes.nextIconButton)
  });
  const LeftArrowIcon = slots?.leftArrowIcon ?? ArrowLeftIcon;
  // The spread is here to avoid this bug mui/material-ui#34056
  const _useSlotProps = useSlotProps({
      elementType: LeftArrowIcon,
      externalSlotProps: slotProps?.leftArrowIcon,
      additionalProps: {
        fontSize: 'inherit'
      },
      ownerState,
      className: classes.leftArrowIcon
    }),
    leftArrowIconProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2$3);
  const RightArrowIcon = slots?.rightArrowIcon ?? ArrowRightIcon;
  // The spread is here to avoid this bug mui/material-ui#34056
  const _useSlotProps2 = useSlotProps({
      elementType: RightArrowIcon,
      externalSlotProps: slotProps?.rightArrowIcon,
      additionalProps: {
        fontSize: 'inherit'
      },
      ownerState,
      className: classes.rightArrowIcon
    }),
    rightArrowIconProps = _objectWithoutPropertiesLoose(_useSlotProps2, _excluded3);
  return /*#__PURE__*/jsxs(PickersArrowSwitcherRoot, _extends({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/jsx(PreviousIconButton, _extends({}, previousIconButtonProps, {
      children: isRtl ? /*#__PURE__*/jsx(RightArrowIcon, _extends({}, rightArrowIconProps)) : /*#__PURE__*/jsx(LeftArrowIcon, _extends({}, leftArrowIconProps))
    })), children ? /*#__PURE__*/jsx(Typography, {
      variant: "subtitle1",
      component: "span",
      id: labelId,
      children: children
    }) : /*#__PURE__*/jsx(PickersArrowSwitcherSpacer, {
      className: classes.spacer,
      ownerState: ownerState
    }), /*#__PURE__*/jsx(NextIconButton, _extends({}, nextIconButtonProps, {
      children: isRtl ? /*#__PURE__*/jsx(LeftArrowIcon, _extends({}, leftArrowIconProps)) : /*#__PURE__*/jsx(RightArrowIcon, _extends({}, rightArrowIconProps))
    }))]
  }));
});

const getSecondsInDay = (date, utils) => {
  return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, utils) => (dateLeft, dateRight) => {
  if (disableIgnoringDatePartForTimeValidation) {
    return utils.isAfter(dateLeft, dateRight);
  }
  return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
};

let warnedOnceNotValidView = false;
function useViews({
  onChange,
  onViewChange,
  openTo,
  view: inView,
  views,
  autoFocus,
  focusedView: inFocusedView,
  onFocusedViewChange
}) {
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnceNotValidView) {
      if (inView != null && !views.includes(inView)) {
        console.warn(`MUI X: \`view="${inView}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
        warnedOnceNotValidView = true;
      }
      if (inView == null && openTo != null && !views.includes(openTo)) {
        console.warn(`MUI X: \`openTo="${openTo}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
        warnedOnceNotValidView = true;
      }
    }
  }
  const previousOpenTo = React.useRef(openTo);
  const previousViews = React.useRef(views);
  const defaultView = React.useRef(views.includes(openTo) ? openTo : views[0]);
  const [view, setView] = useControlled({
    name: 'useViews',
    state: 'view',
    controlled: inView,
    default: defaultView.current
  });
  const defaultFocusedView = React.useRef(autoFocus ? view : null);
  const [focusedView, setFocusedView] = useControlled({
    name: 'useViews',
    state: 'focusedView',
    controlled: inFocusedView,
    default: defaultFocusedView.current
  });
  React.useEffect(() => {
    // Update the current view when `openTo` or `views` props change
    if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some(previousView => !views.includes(previousView))) {
      setView(views.includes(openTo) ? openTo : views[0]);
      previousViews.current = views;
      previousOpenTo.current = openTo;
    }
  }, [openTo, setView, view, views]);
  const viewIndex = views.indexOf(view);
  const previousView = views[viewIndex - 1] ?? null;
  const nextView = views[viewIndex + 1] ?? null;
  const handleFocusedViewChange = useEventCallback((viewToFocus, hasFocus) => {
    if (hasFocus) {
      // Focus event
      setFocusedView(viewToFocus);
    } else {
      // Blur event
      setFocusedView(prevFocusedView => viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
      );
    }
    onFocusedViewChange?.(viewToFocus, hasFocus);
  });
  const handleChangeView = useEventCallback(newView => {
    // always keep the focused view in sync
    handleFocusedViewChange(newView, true);
    if (newView === view) {
      return;
    }
    setView(newView);
    if (onViewChange) {
      onViewChange(newView);
    }
  });
  const goToNextView = useEventCallback(() => {
    if (nextView) {
      handleChangeView(nextView);
    }
  });
  const setValueAndGoToNextView = useEventCallback((value, currentViewSelectionState, selectedView) => {
    const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
    const hasMoreViews = selectedView ?
    // handles case like `DateTimePicker`, where a view might return a `finish` selection state
    // but when it's not the final view given all `views` -> overall selection state should be `partial`.
    views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
    const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
    onChange(value, globalSelectionState, selectedView);
    // Detects if the selected view is not the active one.
    // Can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
    if (selectedView && selectedView !== view) {
      const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
      if (nextViewAfterSelected) {
        // move to next view after the selected one
        handleChangeView(nextViewAfterSelected);
      }
    } else if (isSelectionFinishedOnCurrentView) {
      goToNextView();
    }
  });
  return {
    view,
    setView: handleChangeView,
    focusedView,
    setFocusedView: handleFocusedViewChange,
    nextView,
    previousView,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: views.includes(openTo) ? openTo : views[0],
    goToNextView,
    setValueAndGoToNextView
  };
}

function useNextMonthDisabled(month, {
  disableFuture,
  maxDate,
  timezone
}) {
  const utils = useUtils();
  return React.useMemo(() => {
    const now = utils.date(undefined, timezone);
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    return !utils.isAfter(lastEnabledMonth, month);
  }, [disableFuture, maxDate, month, utils, timezone]);
}
function usePreviousMonthDisabled(month, {
  disablePast,
  minDate,
  timezone
}) {
  const utils = useUtils();
  return React.useMemo(() => {
    const now = utils.date(undefined, timezone);
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    return !utils.isBefore(firstEnabledMonth, month);
  }, [disablePast, minDate, month, utils, timezone]);
}

const DAY_SIZE = 36;
const DAY_MARGIN = 2;
const DIALOG_WIDTH = 320;
const MAX_CALENDAR_HEIGHT = 280;
const VIEW_HEIGHT = 336;

const PickerViewRoot = styled('div')({
  overflow: 'hidden',
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto'
});

const mergeDateAndTime = (utils, dateParam, timeParam) => {
  let mergedDate = dateParam;
  mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
  mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
  mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
  mergedDate = utils.setMilliseconds(mergedDate, utils.getMilliseconds(timeParam));
  return mergedDate;
};
const findClosestEnabledDate = ({
  date,
  disableFuture,
  disablePast,
  maxDate,
  minDate,
  isDateDisabled,
  utils,
  timezone
}) => {
  const today = mergeDateAndTime(utils, utils.date(undefined, timezone), date);
  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }
  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }
  let forward = date;
  let backward = date;
  if (utils.isBefore(date, minDate)) {
    forward = minDate;
    backward = null;
  }
  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = maxDate;
    }
    forward = null;
  }
  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }
    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }
    if (forward) {
      if (!isDateDisabled(forward)) {
        return forward;
      }
      forward = utils.addDays(forward, 1);
    }
    if (backward) {
      if (!isDateDisabled(backward)) {
        return backward;
      }
      backward = utils.addDays(backward, -1);
    }
  }
  return null;
};
const replaceInvalidDateByNull = (utils, value) => value == null || !utils.isValid(value) ? null : value;
const applyDefaultDate = (utils, value, defaultValue) => {
  if (value == null || !utils.isValid(value)) {
    return defaultValue;
  }
  return value;
};
const areDatesEqual = (utils, a, b) => {
  if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) {
    return true;
  }
  return utils.isEqual(a, b);
};
const getMonthsInYear = (utils, year) => {
  const firstMonth = utils.startOfYear(year);
  const months = [firstMonth];
  while (months.length < 12) {
    const prevMonth = months[months.length - 1];
    months.push(utils.addMonths(prevMonth, 1));
  }
  return months;
};
const getTodayDate = (utils, timezone, valueType) => valueType === 'date' ? utils.startOfDay(utils.date(undefined, timezone)) : utils.date(undefined, timezone);
const getWeekdays = (utils, date) => {
  const start = utils.startOfWeek(date);
  return [0, 1, 2, 3, 4, 5, 6].map(diff => utils.addDays(start, diff));
};

/**
 * Hooks making sure that:
 * - The value returned by `onChange` always have the timezone of `props.value` or `props.defaultValue` if defined
 * - The value rendered is always the one from `props.timezone` if defined
 */
const useValueWithTimezone = ({
  timezone: timezoneProp,
  value: valueProp,
  defaultValue,
  referenceDate,
  onChange,
  valueManager
}) => {
  const utils = useUtils();
  const firstDefaultValue = React.useRef(defaultValue);
  const inputValue = valueProp ?? firstDefaultValue.current ?? valueManager.emptyValue;
  const inputTimezone = React.useMemo(() => valueManager.getTimezone(utils, inputValue), [utils, valueManager, inputValue]);
  const setInputTimezone = useEventCallback(newValue => {
    if (inputTimezone == null) {
      return newValue;
    }
    return valueManager.setTimezone(utils, inputTimezone, newValue);
  });
  let timezoneToRender;
  if (timezoneProp) {
    timezoneToRender = timezoneProp;
  } else if (inputTimezone) {
    timezoneToRender = inputTimezone;
  } else if (referenceDate) {
    timezoneToRender = utils.getTimezone(referenceDate);
  } else {
    timezoneToRender = 'default';
  }
  const valueWithTimezoneToRender = React.useMemo(() => valueManager.setTimezone(utils, timezoneToRender, inputValue), [valueManager, utils, timezoneToRender, inputValue]);
  const handleValueChange = useEventCallback((newValue, ...otherParams) => {
    const newValueWithInputTimezone = setInputTimezone(newValue);
    onChange?.(newValueWithInputTimezone, ...otherParams);
  });
  return {
    value: valueWithTimezoneToRender,
    handleValueChange,
    timezone: timezoneToRender
  };
};

/**
 * Wrapper around `useControlled` and `useValueWithTimezone`
 */
const useControlledValueWithTimezone = ({
  name,
  timezone: timezoneProp,
  value: valueProp,
  defaultValue,
  referenceDate,
  onChange: onChangeProp,
  valueManager
}) => {
  const [valueWithInputTimezone, setValue] = useControlled({
    name,
    state: 'value',
    controlled: valueProp,
    default: defaultValue ?? valueManager.emptyValue
  });
  const onChange = useEventCallback((newValue, ...otherParams) => {
    setValue(newValue);
    onChangeProp?.(newValue, ...otherParams);
  });
  return useValueWithTimezone({
    timezone: timezoneProp,
    value: valueWithInputTimezone,
    defaultValue: undefined,
    referenceDate,
    onChange,
    valueManager
  });
};

const SECTION_TYPE_GRANULARITY = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
};
const roundDate = (utils, granularity, date) => {
  if (granularity === SECTION_TYPE_GRANULARITY.year) {
    return utils.startOfYear(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.month) {
    return utils.startOfMonth(date);
  }
  if (granularity === SECTION_TYPE_GRANULARITY.day) {
    return utils.startOfDay(date);
  }

  // We don't have startOfHour / startOfMinute / startOfSecond
  let roundedDate = date;
  if (granularity < SECTION_TYPE_GRANULARITY.minutes) {
    roundedDate = utils.setMinutes(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.seconds) {
    roundedDate = utils.setSeconds(roundedDate, 0);
  }
  if (granularity < SECTION_TYPE_GRANULARITY.milliseconds) {
    roundedDate = utils.setMilliseconds(roundedDate, 0);
  }
  return roundedDate;
};
const getDefaultReferenceDate = ({
  props,
  utils,
  granularity,
  timezone,
  getTodayDate: inGetTodayDate
}) => {
  let referenceDate = inGetTodayDate ? inGetTodayDate() : roundDate(utils, granularity, getTodayDate(utils, timezone));
  if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.minDate);
  }
  if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.maxDate);
  }
  const isAfter = createIsAfterIgnoreDatePart(props.disableIgnoringDatePartForTimeValidation ?? false, utils);
  if (props.minTime != null && isAfter(props.minTime, referenceDate)) {
    referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : mergeDateAndTime(utils, referenceDate, props.minTime));
  }
  if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) {
    referenceDate = roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : mergeDateAndTime(utils, referenceDate, props.maxTime));
  }
  return referenceDate;
};

const removeLocalizedDigits = (valueStr, localizedDigits) => {
  if (localizedDigits[0] === '0') {
    return valueStr;
  }
  const digits = [];
  let currentFormattedDigit = '';
  for (let i = 0; i < valueStr.length; i += 1) {
    currentFormattedDigit += valueStr[i];
    const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
    if (matchingDigitIndex > -1) {
      digits.push(matchingDigitIndex.toString());
      currentFormattedDigit = '';
    }
  }
  return digits.join('');
};
const getSectionVisibleValue = (section, target, localizedDigits) => {
  let value = section.value || section.placeholder;
  const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
  if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) {
    value = Number(removeLocalizedDigits(value, localizedDigits)).toString();
  }

  // In the input, we add an empty character at the end of each section without leading zeros.
  // This makes sure that `onChange` will always be fired.
  // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
  // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
  // So the browser will not fire the input `onChange`.
  const shouldAddInvisibleSpace = ['input-rtl', 'input-ltr'].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
  if (shouldAddInvisibleSpace) {
    value = `${value}\u200e`;
  }
  if (target === 'input-rtl') {
    value = `\u2068${value}\u2069`;
  }
  return value;
};
const createDateStrForV7HiddenInputFromSections = sections => sections.map(section => {
  return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
}).join('');
const createDateStrForV6InputFromSections = (sections, localizedDigits, isRtl) => {
  const formattedSections = sections.map(section => {
    const dateValue = getSectionVisibleValue(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
    return `${section.startSeparator}${dateValue}${section.endSeparator}`;
  });
  const dateStr = formattedSections.join('');
  if (!isRtl) {
    return dateStr;
  }

  // \u2066: start left-to-right isolation
  // \u2067: start right-to-left isolation
  // \u2068: start first strong character isolation
  // \u2069: pop isolation
  // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
  return `\u2066${dateStr}\u2069`;
};

const _excluded$g = ["value", "referenceDate"];
const singleItemValueManager = {
  emptyValue: null,
  getTodayValue: getTodayDate,
  getInitialReferenceValue: _ref => {
    let {
        value,
        referenceDate
      } = _ref,
      params = _objectWithoutPropertiesLoose(_ref, _excluded$g);
    if (value != null && params.utils.isValid(value)) {
      return value;
    }
    if (referenceDate != null) {
      return referenceDate;
    }
    return getDefaultReferenceDate(params);
  },
  cleanValue: replaceInvalidDateByNull,
  areValuesEqual: areDatesEqual,
  isSameError: (a, b) => a === b,
  hasError: error => error != null,
  defaultErrorState: null,
  getTimezone: (utils, value) => value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
  setTimezone: (utils, timezone, value) => value == null ? null : utils.setTimezone(value, timezone)
};
({
  updateReferenceValue: (utils, value, prevReferenceValue) => value == null || !utils.isValid(value) ? prevReferenceValue : value,
  getSectionsFromValue: (utils, date, prevSections, getSectionsFromDate) => {
    const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
    if (shouldReUsePrevDateSections) {
      return prevSections;
    }
    return getSectionsFromDate(date);
  },
  getV7HiddenInputValueFromSections: createDateStrForV7HiddenInputFromSections,
  getV6InputValueFromSections: createDateStrForV6InputFromSections,
  getActiveDateManager: (utils, state) => ({
    date: state.value,
    referenceDate: state.referenceValue,
    getSections: sections => sections,
    getNewValuesFromNewActiveDate: newActiveDate => ({
      value: newActiveDate,
      referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
    })
  }),
  parseValueStr: (valueStr, referenceValue, parseDate) => parseDate(valueStr.trim(), referenceValue)
});

function getPickersDayUtilityClass(slot) {
  return generateUtilityClass('MuiPickersDay', slot);
}
const pickersDayClasses = generateUtilityClasses('MuiPickersDay', ['root', 'dayWithMargin', 'dayOutsideMonth', 'hiddenDaySpacingFiller', 'today', 'selected', 'disabled']);

const _excluded$f = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"];
const useUtilityClasses$f = ownerState => {
  const {
    selected,
    disableMargin,
    disableHighlightToday,
    today,
    disabled,
    outsideCurrentMonth,
    showDaysOutsideCurrentMonth,
    classes
  } = ownerState;
  const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
  const slots = {
    root: ['root', selected && !isHiddenDaySpacingFiller && 'selected', disabled && 'disabled', !disableMargin && 'dayWithMargin', !disableHighlightToday && today && 'today', outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth', isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'],
    hiddenDaySpacingFiller: ['hiddenDaySpacingFiller']
  };
  return composeClasses(slots, getPickersDayUtilityClass, classes);
};
const styleArg = ({
  theme
}) => _extends({}, theme.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  borderRadius: '50%',
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: 'transparent',
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.short
  }),
  color: (theme.vars || theme).palette.text.primary,
  '@media (pointer: fine)': {
    '&:hover': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha$1(theme.palette.primary.main, theme.palette.action.hoverOpacity)
    }
  },
  '&:focus': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : alpha$1(theme.palette.primary.main, theme.palette.action.focusOpacity),
    [`&.${pickersDayClasses.selected}`]: {
      willChange: 'background-color',
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '&:hover': {
      willChange: 'background-color',
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.disabled}:not(.${pickersDayClasses.selected})`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${pickersDayClasses.disabled}&.${pickersDayClasses.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: false
    },
    style: {
      margin: `0 ${DAY_MARGIN}px`
    }
  }, {
    props: {
      outsideCurrentMonth: true,
      showDaysOutsideCurrentMonth: true
    },
    style: {
      color: (theme.vars || theme).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: false,
      today: true
    },
    style: {
      [`&:not(.${pickersDayClasses.selected})`]: {
        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
      }
    }
  }]
});
const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, !ownerState.disableMargin && styles.dayWithMargin, !ownerState.disableHighlightToday && ownerState.today && styles.today, !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth, ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller];
};
const PickersDayRoot = styled(ButtonBase, {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver
})(styleArg);
const PickersDayFiller = styled('div', {
  name: 'MuiPickersDay',
  slot: 'Root',
  overridesResolver
})(({
  theme
}) => _extends({}, styleArg({
  theme
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: 'none'
}));
const noop = () => {};
const PickersDayRaw = /*#__PURE__*/React.forwardRef(function PickersDay(inProps, forwardedRef) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersDay'
  });
  const {
      autoFocus = false,
      className,
      day,
      disabled = false,
      disableHighlightToday = false,
      disableMargin = false,
      isAnimating,
      onClick,
      onDaySelect,
      onFocus = noop,
      onBlur = noop,
      onKeyDown = noop,
      onMouseDown = noop,
      onMouseEnter = noop,
      outsideCurrentMonth,
      selected = false,
      showDaysOutsideCurrentMonth = false,
      children,
      today: isToday = false
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$f);
  const ownerState = _extends({}, props, {
    autoFocus,
    disabled,
    disableHighlightToday,
    disableMargin,
    selected,
    showDaysOutsideCurrentMonth,
    today: isToday
  });
  const classes = useUtilityClasses$f(ownerState);
  const utils = useUtils();
  const ref = React.useRef(null);
  const handleRef = useForkRef(ref, forwardedRef);

  // Since this is rendered when a Popper is opened we can't use passive effects.
  // Focusing in passive effects in Popper causes scroll jump.
  useEnhancedEffect(() => {
    if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) {
      // ref.current being null would be a bug in MUI
      ref.current.focus();
    }
  }, [autoFocus, disabled, isAnimating, outsideCurrentMonth]);

  // For a day outside the current month, move the focus from mouseDown to mouseUp
  // Goal: have the onClick ends before sliding to the new month
  const handleMouseDown = event => {
    onMouseDown(event);
    if (outsideCurrentMonth) {
      event.preventDefault();
    }
  };
  const handleClick = event => {
    if (!disabled) {
      onDaySelect(day);
    }
    if (outsideCurrentMonth) {
      event.currentTarget.focus();
    }
    if (onClick) {
      onClick(event);
    }
  };
  if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) {
    return /*#__PURE__*/jsx(PickersDayFiller, {
      className: clsx(classes.root, classes.hiddenDaySpacingFiller, className),
      ownerState: ownerState,
      role: other.role
    });
  }
  return /*#__PURE__*/jsx(PickersDayRoot, _extends({
    className: clsx(classes.root, className),
    ref: handleRef,
    centerRipple: true,
    disabled: disabled,
    tabIndex: selected ? 0 : -1,
    onKeyDown: event => onKeyDown(event, day),
    onFocus: event => onFocus(event, day),
    onBlur: event => onBlur(event, day),
    onMouseEnter: event => onMouseEnter(event, day),
    onClick: handleClick,
    onMouseDown: handleMouseDown
  }, other, {
    ownerState: ownerState,
    children: !children ? utils.format(day, 'dayOfMonth') : children
  }));
});
process.env.NODE_ENV !== "production" ? PickersDayRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focusVisible: PropTypes.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * The date to show.
   */
  day: PropTypes.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  isAnimating: PropTypes.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: PropTypes.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: PropTypes.bool.isRequired,
  onBlur: PropTypes.func,
  onDaySelect: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: PropTypes.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: PropTypes.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })])
} : void 0;

/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * API:
 *
 * - [PickersDay API](https://mui.com/x/api/date-pickers/pickers-day/)
 */
const PickersDay = /*#__PURE__*/React.memo(PickersDayRaw);

const validateDate = ({
  props,
  value,
  timezone,
  adapter
}) => {
  if (value === null) {
    return null;
  }
  const {
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    disablePast,
    disableFuture
  } = props;
  const now = adapter.utils.date(undefined, timezone);
  const minDate = applyDefaultDate(adapter.utils, props.minDate, adapter.defaultDates.minDate);
  const maxDate = applyDefaultDate(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
  switch (true) {
    case !adapter.utils.isValid(value):
      return 'invalidDate';
    case Boolean(shouldDisableDate && shouldDisableDate(value)):
      return 'shouldDisableDate';
    case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
      return 'shouldDisableMonth';
    case Boolean(shouldDisableYear && shouldDisableYear(value)):
      return 'shouldDisableYear';
    case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
      return 'disableFuture';
    case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
      return 'disablePast';
    case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
      return 'minDate';
    case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
      return 'maxDate';
    default:
      return null;
  }
};
validateDate.valueManager = singleItemValueManager;

const useIsDateDisabled = ({
  shouldDisableDate,
  shouldDisableMonth,
  shouldDisableYear,
  minDate,
  maxDate,
  disableFuture,
  disablePast,
  timezone
}) => {
  const adapter = useLocalizationContext();
  return React.useCallback(day => validateDate({
    adapter,
    value: day,
    timezone,
    props: {
      shouldDisableDate,
      shouldDisableMonth,
      shouldDisableYear,
      minDate,
      maxDate,
      disableFuture,
      disablePast
    }
  }) !== null, [adapter, shouldDisableDate, shouldDisableMonth, shouldDisableYear, minDate, maxDate, disableFuture, disablePast, timezone]);
};

const createCalendarStateReducer = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils) => (state, action) => {
  switch (action.type) {
    case 'changeMonth':
      return _extends({}, state, {
        slideDirection: action.direction,
        currentMonth: action.newMonth,
        isMonthSwitchingAnimating: !reduceAnimations
      });
    case 'changeMonthTimezone':
      {
        const newTimezone = action.newTimezone;
        if (utils.getTimezone(state.currentMonth) === newTimezone) {
          return state;
        }
        let newCurrentMonth = utils.setTimezone(state.currentMonth, newTimezone);
        if (utils.getMonth(newCurrentMonth) !== utils.getMonth(state.currentMonth)) {
          newCurrentMonth = utils.setMonth(newCurrentMonth, utils.getMonth(state.currentMonth));
        }
        return _extends({}, state, {
          currentMonth: newCurrentMonth
        });
      }
    case 'finishMonthSwitchingAnimation':
      return _extends({}, state, {
        isMonthSwitchingAnimating: false
      });
    case 'changeFocusedDay':
      {
        if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) {
          return state;
        }
        const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
        return _extends({}, state, {
          focusedDay: action.focusedDay,
          isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
          currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
          slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
        });
      }
    default:
      throw new Error('missing support');
  }
};
const useCalendarState = params => {
  const {
    value,
    referenceDate: referenceDateProp,
    disableFuture,
    disablePast,
    disableSwitchToMonthOnDayFocus = false,
    maxDate,
    minDate,
    onMonthChange,
    reduceAnimations,
    shouldDisableDate,
    timezone
  } = params;
  const utils = useUtils();
  const reducerFn = React.useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
  const referenceDate = React.useMemo(() => {
    return singleItemValueManager.getInitialReferenceValue({
      value,
      utils,
      timezone,
      props: params,
      referenceDate: referenceDateProp,
      granularity: SECTION_TYPE_GRANULARITY.day
    });
  },
  // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [referenceDateProp, timezone]);
  const [calendarState, dispatch] = React.useReducer(reducerFn, {
    isMonthSwitchingAnimating: false,
    focusedDay: referenceDate,
    currentMonth: utils.startOfMonth(referenceDate),
    slideDirection: 'left'
  });

  // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
  // https://github.com/mui/mui-x/issues/10804
  React.useEffect(() => {
    dispatch({
      type: 'changeMonthTimezone',
      newTimezone: utils.getTimezone(referenceDate)
    });
  }, [referenceDate, utils]);
  const handleChangeMonth = React.useCallback(payload => {
    dispatch(_extends({
      type: 'changeMonth'
    }, payload));
    if (onMonthChange) {
      onMonthChange(payload.newMonth);
    }
  }, [onMonthChange]);
  const changeMonth = React.useCallback(newDate => {
    const newDateRequested = newDate;
    if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) {
      return;
    }
    handleChangeMonth({
      newMonth: utils.startOfMonth(newDateRequested),
      direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
    });
  }, [calendarState.currentMonth, handleChangeMonth, utils]);
  const isDateDisabled = useIsDateDisabled({
    shouldDisableDate,
    minDate,
    maxDate,
    disableFuture,
    disablePast,
    timezone
  });
  const onMonthSwitchingAnimationEnd = React.useCallback(() => {
    dispatch({
      type: 'finishMonthSwitchingAnimation'
    });
  }, []);
  const changeFocusedDay = useEventCallback((newFocusedDate, withoutMonthSwitchingAnimation) => {
    if (!isDateDisabled(newFocusedDate)) {
      dispatch({
        type: 'changeFocusedDay',
        focusedDay: newFocusedDate,
        withoutMonthSwitchingAnimation
      });
    }
  });
  return {
    referenceDate,
    calendarState,
    changeMonth,
    changeFocusedDay,
    isDateDisabled,
    onMonthSwitchingAnimationEnd,
    handleChangeMonth
  };
};

const getPickersFadeTransitionGroupUtilityClass = slot => generateUtilityClass('MuiPickersFadeTransitionGroup', slot);
generateUtilityClasses('MuiPickersFadeTransitionGroup', ['root']);

const useUtilityClasses$e = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getPickersFadeTransitionGroupUtilityClass, classes);
};
const PickersFadeTransitionGroupRoot = styled(TransitionGroup, {
  name: 'MuiPickersFadeTransitionGroup',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})({
  display: 'block',
  position: 'relative'
});

/**
 * @ignore - do not document.
 */
function PickersFadeTransitionGroup(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersFadeTransitionGroup'
  });
  const {
    children,
    className,
    reduceAnimations,
    transKey
  } = props;
  const classes = useUtilityClasses$e(props);
  const theme = useTheme$3();
  if (reduceAnimations) {
    return children;
  }
  return /*#__PURE__*/jsx(PickersFadeTransitionGroupRoot, {
    className: clsx(classes.root, className),
    children: /*#__PURE__*/jsx(Fade, {
      appear: false,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: {
        appear: theme.transitions.duration.enteringScreen,
        enter: theme.transitions.duration.enteringScreen,
        exit: 0
      },
      children: children
    }, transKey)
  });
}

const getPickersSlideTransitionUtilityClass = slot => generateUtilityClass('MuiPickersSlideTransition', slot);
const pickersSlideTransitionClasses = generateUtilityClasses('MuiPickersSlideTransition', ['root', 'slideEnter-left', 'slideEnter-right', 'slideEnterActive', 'slideExit', 'slideExitActiveLeft-left', 'slideExitActiveLeft-right']);

const _excluded$e = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"];
const useUtilityClasses$d = ownerState => {
  const {
    classes,
    slideDirection
  } = ownerState;
  const slots = {
    root: ['root'],
    exit: ['slideExit'],
    enterActive: ['slideEnterActive'],
    enter: [`slideEnter-${slideDirection}`],
    exitActive: [`slideExitActiveLeft-${slideDirection}`]
  };
  return composeClasses(slots, getPickersSlideTransitionUtilityClass, classes);
};
const PickersSlideTransitionRoot = styled(TransitionGroup, {
  name: 'MuiPickersSlideTransition',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root, {
    [`.${pickersSlideTransitionClasses['slideEnter-left']}`]: styles['slideEnter-left']
  }, {
    [`.${pickersSlideTransitionClasses['slideEnter-right']}`]: styles['slideEnter-right']
  }, {
    [`.${pickersSlideTransitionClasses.slideEnterActive}`]: styles.slideEnterActive
  }, {
    [`.${pickersSlideTransitionClasses.slideExit}`]: styles.slideExit
  }, {
    [`.${pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
  }, {
    [`.${pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
  }]
})(({
  theme
}) => {
  const slideTransition = theme.transitions.create('transform', {
    duration: theme.transitions.duration.complex,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return {
    display: 'block',
    position: 'relative',
    overflowX: 'hidden',
    '& > *': {
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${pickersSlideTransitionClasses['slideEnter-left']}`]: {
      willChange: 'transform',
      transform: 'translate(100%)',
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses['slideEnter-right']}`]: {
      willChange: 'transform',
      transform: 'translate(-100%)',
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses.slideEnterActive}`]: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    [`& .${pickersSlideTransitionClasses.slideExit}`]: {
      transform: 'translate(0%)'
    },
    [`& .${pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: {
      willChange: 'transform',
      transform: 'translate(-100%)',
      transition: slideTransition,
      zIndex: 0
    },
    [`& .${pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: {
      willChange: 'transform',
      transform: 'translate(100%)',
      transition: slideTransition,
      zIndex: 0
    }
  };
});

/**
 * @ignore - do not document.
 */
function PickersSlideTransition(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersSlideTransition'
  });
  const {
      children,
      className,
      reduceAnimations,
      transKey
      // extracting `classes` from `other`
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$e);
  const classes = useUtilityClasses$d(props);
  const theme = useTheme$3();
  if (reduceAnimations) {
    return /*#__PURE__*/jsx("div", {
      className: clsx(classes.root, className),
      children: children
    });
  }
  const transitionClasses = {
    exit: classes.exit,
    enterActive: classes.enterActive,
    enter: classes.enter,
    exitActive: classes.exitActive
  };
  return /*#__PURE__*/jsx(PickersSlideTransitionRoot, {
    className: clsx(classes.root, className),
    childFactory: element => /*#__PURE__*/React.cloneElement(element, {
      classNames: transitionClasses
    }),
    role: "presentation",
    children: /*#__PURE__*/jsx(CSSTransition, _extends({
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: theme.transitions.duration.complex,
      classNames: transitionClasses
    }, other, {
      children: children
    }), transKey)
  });
}

const getDayCalendarUtilityClass = slot => generateUtilityClass('MuiDayCalendar', slot);
generateUtilityClasses('MuiDayCalendar', ['root', 'header', 'weekDayLabel', 'loadingContainer', 'slideTransition', 'monthContainer', 'weekContainer', 'weekNumberLabel', 'weekNumber']);

const _excluded$d = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"],
  _excluded2$2 = ["ownerState"];
const useUtilityClasses$c = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    header: ['header'],
    weekDayLabel: ['weekDayLabel'],
    loadingContainer: ['loadingContainer'],
    slideTransition: ['slideTransition'],
    monthContainer: ['monthContainer'],
    weekContainer: ['weekContainer'],
    weekNumberLabel: ['weekNumberLabel'],
    weekNumber: ['weekNumber']
  };
  return composeClasses(slots, getDayCalendarUtilityClass, classes);
};
const weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 2) * 6;
const PickersCalendarDayRoot = styled('div', {
  name: 'MuiDayCalendar',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})({});
const PickersCalendarDayHeader = styled('div', {
  name: 'MuiDayCalendar',
  slot: 'Header',
  overridesResolver: (_, styles) => styles.header
})({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
const PickersCalendarWeekDayLabel = styled(Typography, {
  name: 'MuiDayCalendar',
  slot: 'WeekDayLabel',
  overridesResolver: (_, styles) => styles.weekDayLabel
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: '0 2px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: (theme.vars || theme).palette.text.secondary
}));
const PickersCalendarWeekNumberLabel = styled(Typography, {
  name: 'MuiDayCalendar',
  slot: 'WeekNumberLabel',
  overridesResolver: (_, styles) => styles.weekNumberLabel
})(({
  theme
}) => ({
  width: 36,
  height: 40,
  margin: '0 2px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.text.disabled
}));
const PickersCalendarWeekNumber = styled(Typography, {
  name: 'MuiDayCalendar',
  slot: 'WeekNumber',
  overridesResolver: (_, styles) => styles.weekNumber
})(({
  theme
}) => _extends({}, theme.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  padding: 0,
  margin: `0 ${DAY_MARGIN}px`,
  color: theme.palette.text.disabled,
  fontSize: '0.75rem',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'inline-flex'
}));
const PickersCalendarLoadingContainer = styled('div', {
  name: 'MuiDayCalendar',
  slot: 'LoadingContainer',
  overridesResolver: (_, styles) => styles.loadingContainer
})({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: weeksContainerHeight
});
const PickersCalendarSlideTransition = styled(PickersSlideTransition, {
  name: 'MuiDayCalendar',
  slot: 'SlideTransition',
  overridesResolver: (_, styles) => styles.slideTransition
})({
  minHeight: weeksContainerHeight
});
const PickersCalendarWeekContainer = styled('div', {
  name: 'MuiDayCalendar',
  slot: 'MonthContainer',
  overridesResolver: (_, styles) => styles.monthContainer
})({
  overflow: 'hidden'
});
const PickersCalendarWeek = styled('div', {
  name: 'MuiDayCalendar',
  slot: 'WeekContainer',
  overridesResolver: (_, styles) => styles.weekContainer
})({
  margin: `${DAY_MARGIN}px 0`,
  display: 'flex',
  justifyContent: 'center'
});
function WrappedDay(_ref) {
  let {
      parentProps,
      day,
      focusableDay,
      selectedDays,
      isDateDisabled,
      currentMonthNumber,
      isViewFocused
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  const {
    disabled,
    disableHighlightToday,
    isMonthSwitchingAnimating,
    showDaysOutsideCurrentMonth,
    slots,
    slotProps,
    timezone
  } = parentProps;
  const utils = useUtils();
  const now = useNow(timezone);
  const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
  const isSelected = selectedDays.some(selectedDay => utils.isSameDay(selectedDay, day));
  const isToday = utils.isSameDay(day, now);
  const Day = slots?.day ?? PickersDay;
  // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
  const _useSlotProps = useSlotProps({
      elementType: Day,
      externalSlotProps: slotProps?.day,
      additionalProps: _extends({
        disableHighlightToday,
        showDaysOutsideCurrentMonth,
        role: 'gridcell',
        isAnimating: isMonthSwitchingAnimating,
        // it is used in date range dragging logic by accessing `dataset.timestamp`
        'data-timestamp': utils.toJsDate(day).valueOf()
      }, other),
      ownerState: _extends({}, parentProps, {
        day,
        selected: isSelected
      })
    }),
    dayProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2$2);
  const isDisabled = React.useMemo(() => disabled || isDateDisabled(day), [disabled, isDateDisabled, day]);
  const outsideCurrentMonth = React.useMemo(() => utils.getMonth(day) !== currentMonthNumber, [utils, day, currentMonthNumber]);
  const isFirstVisibleCell = React.useMemo(() => {
    const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return utils.isSameDay(day, startOfMonth);
    }
    return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, utils]);
  const isLastVisibleCell = React.useMemo(() => {
    const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
    if (!showDaysOutsideCurrentMonth) {
      return utils.isSameDay(day, endOfMonth);
    }
    return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
  }, [currentMonthNumber, day, showDaysOutsideCurrentMonth, utils]);
  return /*#__PURE__*/jsx(Day, _extends({}, dayProps, {
    day: day,
    disabled: isDisabled,
    autoFocus: isViewFocused && isFocusableDay,
    today: isToday,
    outsideCurrentMonth: outsideCurrentMonth,
    isFirstVisibleCell: isFirstVisibleCell,
    isLastVisibleCell: isLastVisibleCell,
    selected: isSelected,
    tabIndex: isFocusableDay ? 0 : -1,
    "aria-selected": isSelected,
    "aria-current": isToday ? 'date' : undefined
  }));
}

/**
 * @ignore - do not document.
 */
function DayCalendar(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDayCalendar'
  });
  const utils = useUtils();
  const {
    onFocusedDayChange,
    className,
    currentMonth,
    selectedDays,
    focusedDay,
    loading,
    onSelectedDaysChange,
    onMonthSwitchingAnimationEnd,
    readOnly,
    reduceAnimations,
    renderLoading = () => /*#__PURE__*/jsx("span", {
      children: "..."
    }),
    slideDirection,
    TransitionProps,
    disablePast,
    disableFuture,
    minDate,
    maxDate,
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    dayOfWeekFormatter = date => utils.format(date, 'weekdayShort').charAt(0).toUpperCase(),
    hasFocus,
    onFocusedViewChange,
    gridLabelId,
    displayWeekNumber,
    fixedWeekNumber,
    autoFocus,
    timezone
  } = props;
  const now = useNow(timezone);
  const classes = useUtilityClasses$c(props);
  const isRtl = useRtl();
  const isDateDisabled = useIsDateDisabled({
    shouldDisableDate,
    shouldDisableMonth,
    shouldDisableYear,
    minDate,
    maxDate,
    disablePast,
    disableFuture,
    timezone
  });
  const translations = usePickersTranslations();
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: 'DayCalendar',
    state: 'hasFocus',
    controlled: hasFocus,
    default: autoFocus ?? false
  });
  const [internalFocusedDay, setInternalFocusedDay] = React.useState(() => focusedDay || now);
  const handleDaySelect = useEventCallback(day => {
    if (readOnly) {
      return;
    }
    onSelectedDaysChange(day);
  });
  const focusDay = day => {
    if (!isDateDisabled(day)) {
      onFocusedDayChange(day);
      setInternalFocusedDay(day);
      onFocusedViewChange?.(true);
      setInternalHasFocus(true);
    }
  };
  const handleKeyDown = useEventCallback((event, day) => {
    switch (event.key) {
      case 'ArrowUp':
        focusDay(utils.addDays(day, -7));
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusDay(utils.addDays(day, 7));
        event.preventDefault();
        break;
      case 'ArrowLeft':
        {
          const newFocusedDayDefault = utils.addDays(day, isRtl ? 1 : -1);
          const nextAvailableMonth = utils.addMonths(day, isRtl ? 1 : -1);
          const closestDayToFocus = findClosestEnabledDate({
            utils,
            date: newFocusedDayDefault,
            minDate: isRtl ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
            maxDate: isRtl ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
            isDateDisabled,
            timezone
          });
          focusDay(closestDayToFocus || newFocusedDayDefault);
          event.preventDefault();
          break;
        }
      case 'ArrowRight':
        {
          const newFocusedDayDefault = utils.addDays(day, isRtl ? -1 : 1);
          const nextAvailableMonth = utils.addMonths(day, isRtl ? -1 : 1);
          const closestDayToFocus = findClosestEnabledDate({
            utils,
            date: newFocusedDayDefault,
            minDate: isRtl ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
            maxDate: isRtl ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
            isDateDisabled,
            timezone
          });
          focusDay(closestDayToFocus || newFocusedDayDefault);
          event.preventDefault();
          break;
        }
      case 'Home':
        focusDay(utils.startOfWeek(day));
        event.preventDefault();
        break;
      case 'End':
        focusDay(utils.endOfWeek(day));
        event.preventDefault();
        break;
      case 'PageUp':
        focusDay(utils.addMonths(day, 1));
        event.preventDefault();
        break;
      case 'PageDown':
        focusDay(utils.addMonths(day, -1));
        event.preventDefault();
        break;
    }
  });
  const handleFocus = useEventCallback((event, day) => focusDay(day));
  const handleBlur = useEventCallback((event, day) => {
    if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) {
      onFocusedViewChange?.(false);
    }
  });
  const currentMonthNumber = utils.getMonth(currentMonth);
  const currentYearNumber = utils.getYear(currentMonth);
  const validSelectedDays = React.useMemo(() => selectedDays.filter(day => !!day).map(day => utils.startOfDay(day)), [utils, selectedDays]);

  // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
  const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const slideNodeRef = React.useMemo(() => /*#__PURE__*/React.createRef(), [transitionKey]);
  const focusableDay = React.useMemo(() => {
    const startOfMonth = utils.startOfMonth(currentMonth);
    const endOfMonth = utils.endOfMonth(currentMonth);
    if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) {
      return findClosestEnabledDate({
        utils,
        date: internalFocusedDay,
        minDate: startOfMonth,
        maxDate: endOfMonth,
        disablePast,
        disableFuture,
        isDateDisabled,
        timezone
      });
    }
    return internalFocusedDay;
  }, [currentMonth, disableFuture, disablePast, internalFocusedDay, isDateDisabled, utils, timezone]);
  const weeksToDisplay = React.useMemo(() => {
    const toDisplay = utils.getWeekArray(currentMonth);
    let nextMonth = utils.addMonths(currentMonth, 1);
    while (fixedWeekNumber && toDisplay.length < fixedWeekNumber) {
      const additionalWeeks = utils.getWeekArray(nextMonth);
      const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
      additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach(week => {
        if (toDisplay.length < fixedWeekNumber) {
          toDisplay.push(week);
        }
      });
      nextMonth = utils.addMonths(nextMonth, 1);
    }
    return toDisplay;
  }, [currentMonth, fixedWeekNumber, utils]);
  return /*#__PURE__*/jsxs(PickersCalendarDayRoot, {
    role: "grid",
    "aria-labelledby": gridLabelId,
    className: classes.root,
    children: [/*#__PURE__*/jsxs(PickersCalendarDayHeader, {
      role: "row",
      className: classes.header,
      children: [displayWeekNumber && /*#__PURE__*/jsx(PickersCalendarWeekNumberLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": translations.calendarWeekNumberHeaderLabel,
        className: classes.weekNumberLabel,
        children: translations.calendarWeekNumberHeaderText
      }), getWeekdays(utils, now).map((weekday, i) => /*#__PURE__*/jsx(PickersCalendarWeekDayLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": utils.format(weekday, 'weekday'),
        className: classes.weekDayLabel,
        children: dayOfWeekFormatter(weekday)
      }, i.toString()))]
    }), loading ? /*#__PURE__*/jsx(PickersCalendarLoadingContainer, {
      className: classes.loadingContainer,
      children: renderLoading()
    }) : /*#__PURE__*/jsx(PickersCalendarSlideTransition, _extends({
      transKey: transitionKey,
      onExited: onMonthSwitchingAnimationEnd,
      reduceAnimations: reduceAnimations,
      slideDirection: slideDirection,
      className: clsx(className, classes.slideTransition)
    }, TransitionProps, {
      nodeRef: slideNodeRef,
      children: /*#__PURE__*/jsx(PickersCalendarWeekContainer, {
        ref: slideNodeRef,
        role: "rowgroup",
        className: classes.monthContainer,
        children: weeksToDisplay.map((week, index) => /*#__PURE__*/jsxs(PickersCalendarWeek, {
          role: "row",
          className: classes.weekContainer
          // fix issue of announcing row 1 as row 2
          // caused by week day labels row
          ,
          "aria-rowindex": index + 1,
          children: [displayWeekNumber && /*#__PURE__*/jsx(PickersCalendarWeekNumber, {
            className: classes.weekNumber,
            role: "rowheader",
            "aria-label": translations.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
            children: translations.calendarWeekNumberText(utils.getWeekNumber(week[0]))
          }), week.map((day, dayIndex) => /*#__PURE__*/jsx(WrappedDay, {
            parentProps: props,
            day: day,
            selectedDays: validSelectedDays,
            focusableDay: focusableDay,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onDaySelect: handleDaySelect,
            isDateDisabled: isDateDisabled,
            currentMonthNumber: currentMonthNumber,
            isViewFocused: internalHasFocus
            // fix issue of announcing column 1 as column 2 when `displayWeekNumber` is enabled
            ,
            "aria-colindex": dayIndex + 1
          }, day.toString()))]
        }, `week-${week[0]}`))
      })
    }))]
  });
}

function getPickersMonthUtilityClass(slot) {
  return generateUtilityClass('MuiPickersMonth', slot);
}
const pickersMonthClasses = generateUtilityClasses('MuiPickersMonth', ['root', 'monthButton', 'disabled', 'selected']);

const _excluded$c = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow", "slots", "slotProps"];
const useUtilityClasses$b = ownerState => {
  const {
    disabled,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    monthButton: ['monthButton', disabled && 'disabled', selected && 'selected']
  };
  return composeClasses(slots, getPickersMonthUtilityClass, classes);
};
const PickersMonthRoot = styled('div', {
  name: 'MuiPickersMonth',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root]
})({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexBasis: '33.3%',
  variants: [{
    props: {
      monthsPerRow: 4
    },
    style: {
      flexBasis: '25%'
    }
  }]
});
const MonthCalendarButton = styled('button', {
  name: 'MuiPickersMonth',
  slot: 'MonthButton',
  overridesResolver: (_, styles) => [styles.monthButton, {
    [`&.${pickersMonthClasses.disabled}`]: styles.disabled
  }, {
    [`&.${pickersMonthClasses.selected}`]: styles.selected
  }]
})(({
  theme
}) => _extends({
  color: 'unset',
  backgroundColor: 'transparent',
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: '8px 0',
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: 'pointer',
  '&:focus': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha$1(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha$1(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:disabled': {
    cursor: 'auto',
    pointerEvents: 'none'
  },
  [`&.${pickersMonthClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${pickersMonthClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));

/**
 * @ignore - do not document.
 */
const PickersMonth = /*#__PURE__*/React.memo(function PickersMonth(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersMonth'
  });
  const {
      autoFocus,
      className,
      children,
      disabled,
      selected,
      value,
      tabIndex,
      onClick,
      onKeyDown,
      onFocus,
      onBlur,
      'aria-current': ariaCurrent,
      'aria-label': ariaLabel
      // We don't want to forward this prop to the root element
      ,

      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$c);
  const ref = React.useRef(null);
  const classes = useUtilityClasses$b(props);

  // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
  useEnhancedEffect(() => {
    if (autoFocus) {
      // `ref.current` being `null` would be a bug in MUI.
      ref.current?.focus();
    }
  }, [autoFocus]);
  const MonthButton = slots?.monthButton ?? MonthCalendarButton;
  const monthButtonProps = useSlotProps({
    elementType: MonthButton,
    externalSlotProps: slotProps?.monthButton,
    additionalProps: {
      children,
      disabled,
      tabIndex,
      ref,
      type: 'button',
      role: 'radio',
      'aria-current': ariaCurrent,
      'aria-checked': selected,
      'aria-label': ariaLabel,
      onClick: event => onClick(event, value),
      onKeyDown: event => onKeyDown(event, value),
      onFocus: event => onFocus(event, value),
      onBlur: event => onBlur(event, value)
    },
    ownerState: props,
    className: classes.monthButton
  });
  return /*#__PURE__*/jsx(PickersMonthRoot, _extends({
    className: clsx(classes.root, className),
    ownerState: props
  }, other, {
    children: /*#__PURE__*/jsx(MonthButton, _extends({}, monthButtonProps))
  }));
});

function getMonthCalendarUtilityClass(slot) {
  return generateUtilityClass('MuiMonthCalendar', slot);
}
generateUtilityClasses('MuiMonthCalendar', ['root']);

const _excluded$b = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"];
const useUtilityClasses$a = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getMonthCalendarUtilityClass, classes);
};
function useMonthCalendarDefaultizedProps(props, name) {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const themeProps = useThemeProps({
    props,
    name
  });
  return _extends({
    disableFuture: false,
    disablePast: false
  }, themeProps, {
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
const MonthCalendarRoot = styled('div', {
  name: 'MuiMonthCalendar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignContent: 'stretch',
  padding: '0 4px',
  width: DIALOG_WIDTH,
  // avoid padding increasing width over defined
  boxSizing: 'border-box'
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 *
 * API:
 *
 * - [MonthCalendar API](https://mui.com/x/api/date-pickers/month-calendar/)
 */
const MonthCalendar = /*#__PURE__*/React.forwardRef(function MonthCalendar(inProps, ref) {
  const props = useMonthCalendarDefaultizedProps(inProps, 'MuiMonthCalendar');
  const {
      className,
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      disabled,
      disableFuture,
      disablePast,
      maxDate,
      minDate,
      onChange,
      shouldDisableMonth,
      readOnly,
      autoFocus = false,
      onMonthFocus,
      hasFocus,
      onFocusedViewChange,
      monthsPerRow = 3,
      timezone: timezoneProp,
      gridLabelId,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$b);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValueWithTimezone({
    name: 'MonthCalendar',
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    onChange,
    valueManager: singleItemValueManager
  });
  const now = useNow(timezone);
  const isRtl = useRtl();
  const utils = useUtils();
  const referenceDate = React.useMemo(() => singleItemValueManager.getInitialReferenceValue({
    value,
    utils,
    props,
    timezone,
    referenceDate: referenceDateProp,
    granularity: SECTION_TYPE_GRANULARITY.month
  }), [] // eslint-disable-line react-hooks/exhaustive-deps
  );
  const ownerState = props;
  const classes = useUtilityClasses$a(ownerState);
  const todayMonth = React.useMemo(() => utils.getMonth(now), [utils, now]);
  const selectedMonth = React.useMemo(() => {
    if (value != null) {
      return utils.getMonth(value);
    }
    return null;
  }, [value, utils]);
  const [focusedMonth, setFocusedMonth] = React.useState(() => selectedMonth || utils.getMonth(referenceDate));
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: 'MonthCalendar',
    state: 'hasFocus',
    controlled: hasFocus,
    default: autoFocus ?? false
  });
  const changeHasFocus = useEventCallback(newHasFocus => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isMonthDisabled = React.useCallback(dateToValidate => {
    const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    const monthToValidate = utils.startOfMonth(dateToValidate);
    if (utils.isBefore(monthToValidate, firstEnabledMonth)) {
      return true;
    }
    if (utils.isAfter(monthToValidate, lastEnabledMonth)) {
      return true;
    }
    if (!shouldDisableMonth) {
      return false;
    }
    return shouldDisableMonth(monthToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now, shouldDisableMonth, utils]);
  const handleMonthSelection = useEventCallback((event, month) => {
    if (readOnly) {
      return;
    }
    const newDate = utils.setMonth(value ?? referenceDate, month);
    handleValueChange(newDate);
  });
  const focusMonth = useEventCallback(month => {
    if (!isMonthDisabled(utils.setMonth(value ?? referenceDate, month))) {
      setFocusedMonth(month);
      changeHasFocus(true);
      if (onMonthFocus) {
        onMonthFocus(month);
      }
    }
  });
  React.useEffect(() => {
    setFocusedMonth(prevFocusedMonth => selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
  }, [selectedMonth]);
  const handleKeyDown = useEventCallback((event, month) => {
    const monthsInYear = 12;
    const monthsInRow = 3;
    switch (event.key) {
      case 'ArrowUp':
        focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
        event.preventDefault();
        break;
      case 'ArrowLeft':
        focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
        event.preventDefault();
        break;
      case 'ArrowRight':
        focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
        event.preventDefault();
        break;
    }
  });
  const handleMonthFocus = useEventCallback((event, month) => {
    focusMonth(month);
  });
  const handleMonthBlur = useEventCallback((event, month) => {
    if (focusedMonth === month) {
      changeHasFocus(false);
    }
  });
  return /*#__PURE__*/jsx(MonthCalendarRoot, _extends({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    role: "radiogroup",
    "aria-labelledby": gridLabelId
  }, other, {
    children: getMonthsInYear(utils, value ?? referenceDate).map(month => {
      const monthNumber = utils.getMonth(month);
      const monthText = utils.format(month, 'monthShort');
      const monthLabel = utils.format(month, 'month');
      const isSelected = monthNumber === selectedMonth;
      const isDisabled = disabled || isMonthDisabled(month);
      return /*#__PURE__*/jsx(PickersMonth, {
        selected: isSelected,
        value: monthNumber,
        onClick: handleMonthSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && monthNumber === focusedMonth,
        disabled: isDisabled,
        tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
        onFocus: handleMonthFocus,
        onBlur: handleMonthBlur,
        "aria-current": todayMonth === monthNumber ? 'date' : undefined,
        "aria-label": monthLabel,
        monthsPerRow: monthsPerRow,
        slots: slots,
        slotProps: slotProps,
        children: monthText
      }, monthText);
    })
  }));
});
process.env.NODE_ENV !== "production" ? MonthCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true` picker is disabled
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onMonthFocus: PropTypes.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object
} : void 0;

function getPickersYearUtilityClass(slot) {
  return generateUtilityClass('MuiPickersYear', slot);
}
const pickersYearClasses = generateUtilityClasses('MuiPickersYear', ['root', 'yearButton', 'selected', 'disabled']);

const _excluded$a = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow", "slots", "slotProps"];
const useUtilityClasses$9 = ownerState => {
  const {
    disabled,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    yearButton: ['yearButton', disabled && 'disabled', selected && 'selected']
  };
  return composeClasses(slots, getPickersYearUtilityClass, classes);
};
const PickersYearRoot = styled('div', {
  name: 'MuiPickersYear',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles.root]
})({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexBasis: '33.3%',
  variants: [{
    props: {
      yearsPerRow: 4
    },
    style: {
      flexBasis: '25%'
    }
  }]
});
const YearCalendarButton = styled('button', {
  name: 'MuiPickersYear',
  slot: 'YearButton',
  overridesResolver: (_, styles) => [styles.yearButton, {
    [`&.${pickersYearClasses.disabled}`]: styles.disabled
  }, {
    [`&.${pickersYearClasses.selected}`]: styles.selected
  }]
})(({
  theme
}) => _extends({
  color: 'unset',
  backgroundColor: 'transparent',
  border: 0,
  outline: 0
}, theme.typography.subtitle1, {
  margin: '6px 0',
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: 'pointer',
  '&:focus': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : alpha$1(theme.palette.action.active, theme.palette.action.focusOpacity)
  },
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : alpha$1(theme.palette.action.active, theme.palette.action.hoverOpacity)
  },
  '&:disabled': {
    cursor: 'auto',
    pointerEvents: 'none'
  },
  [`&.${pickersYearClasses.disabled}`]: {
    color: (theme.vars || theme).palette.text.secondary
  },
  [`&.${pickersYearClasses.selected}`]: {
    color: (theme.vars || theme).palette.primary.contrastText,
    backgroundColor: (theme.vars || theme).palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: (theme.vars || theme).palette.primary.dark
    }
  }
}));

/**
 * @ignore - internal component.
 */
const PickersYear = /*#__PURE__*/React.memo(function PickersYear(inProps) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersYear'
  });
  const {
      autoFocus,
      className,
      children,
      disabled,
      selected,
      value,
      tabIndex,
      onClick,
      onKeyDown,
      onFocus,
      onBlur,
      'aria-current': ariaCurrent
      // We don't want to forward this prop to the root element
      ,

      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$a);
  const ref = React.useRef(null);
  const classes = useUtilityClasses$9(props);

  // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
  useEnhancedEffect(() => {
    if (autoFocus) {
      // `ref.current` being `null` would be a bug in MUI.
      ref.current?.focus();
    }
  }, [autoFocus]);
  const YearButton = slots?.yearButton ?? YearCalendarButton;
  const yearButtonProps = useSlotProps({
    elementType: YearButton,
    externalSlotProps: slotProps?.yearButton,
    additionalProps: {
      children,
      disabled,
      tabIndex,
      ref,
      type: 'button',
      role: 'radio',
      'aria-current': ariaCurrent,
      'aria-checked': selected,
      onClick: event => onClick(event, value),
      onKeyDown: event => onKeyDown(event, value),
      onFocus: event => onFocus(event, value),
      onBlur: event => onBlur(event, value)
    },
    ownerState: props,
    className: classes.yearButton
  });
  return /*#__PURE__*/jsx(PickersYearRoot, _extends({
    className: clsx(classes.root, className),
    ownerState: props
  }, other, {
    children: /*#__PURE__*/jsx(YearButton, _extends({}, yearButtonProps))
  }));
});

function getYearCalendarUtilityClass(slot) {
  return generateUtilityClass('MuiYearCalendar', slot);
}
generateUtilityClasses('MuiYearCalendar', ['root']);

const _excluded$9 = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsOrder", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"];
const useUtilityClasses$8 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getYearCalendarUtilityClass, classes);
};
function useYearCalendarDefaultizedProps(props, name) {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const themeProps = useThemeProps({
    props,
    name
  });
  return _extends({
    disablePast: false,
    disableFuture: false
  }, themeProps, {
    yearsPerRow: themeProps.yearsPerRow ?? 3,
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
const YearCalendarRoot = styled('div', {
  name: 'MuiYearCalendar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  overflowY: 'auto',
  height: '100%',
  padding: '0 4px',
  width: DIALOG_WIDTH,
  maxHeight: MAX_CALENDAR_HEIGHT,
  // avoid padding increasing width over defined
  boxSizing: 'border-box',
  position: 'relative'
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 *
 * API:
 *
 * - [YearCalendar API](https://mui.com/x/api/date-pickers/year-calendar/)
 */
const YearCalendar = /*#__PURE__*/React.forwardRef(function YearCalendar(inProps, ref) {
  const props = useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
  const {
      autoFocus,
      className,
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      disabled,
      disableFuture,
      disablePast,
      maxDate,
      minDate,
      onChange,
      readOnly,
      shouldDisableYear,
      onYearFocus,
      hasFocus,
      onFocusedViewChange,
      yearsOrder = 'asc',
      yearsPerRow,
      timezone: timezoneProp,
      gridLabelId,
      slots,
      slotProps
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$9);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValueWithTimezone({
    name: 'YearCalendar',
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    onChange,
    valueManager: singleItemValueManager
  });
  const now = useNow(timezone);
  const isRtl = useRtl();
  const utils = useUtils();
  const referenceDate = React.useMemo(() => singleItemValueManager.getInitialReferenceValue({
    value,
    utils,
    props,
    timezone,
    referenceDate: referenceDateProp,
    granularity: SECTION_TYPE_GRANULARITY.year
  }), [] // eslint-disable-line react-hooks/exhaustive-deps
  );
  const ownerState = props;
  const classes = useUtilityClasses$8(ownerState);
  const todayYear = React.useMemo(() => utils.getYear(now), [utils, now]);
  const selectedYear = React.useMemo(() => {
    if (value != null) {
      return utils.getYear(value);
    }
    return null;
  }, [value, utils]);
  const [focusedYear, setFocusedYear] = React.useState(() => selectedYear || utils.getYear(referenceDate));
  const [internalHasFocus, setInternalHasFocus] = useControlled({
    name: 'YearCalendar',
    state: 'hasFocus',
    controlled: hasFocus,
    default: autoFocus ?? false
  });
  const changeHasFocus = useEventCallback(newHasFocus => {
    setInternalHasFocus(newHasFocus);
    if (onFocusedViewChange) {
      onFocusedViewChange(newHasFocus);
    }
  });
  const isYearDisabled = React.useCallback(dateToValidate => {
    if (disablePast && utils.isBeforeYear(dateToValidate, now)) {
      return true;
    }
    if (disableFuture && utils.isAfterYear(dateToValidate, now)) {
      return true;
    }
    if (minDate && utils.isBeforeYear(dateToValidate, minDate)) {
      return true;
    }
    if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) {
      return true;
    }
    if (!shouldDisableYear) {
      return false;
    }
    const yearToValidate = utils.startOfYear(dateToValidate);
    return shouldDisableYear(yearToValidate);
  }, [disableFuture, disablePast, maxDate, minDate, now, shouldDisableYear, utils]);
  const handleYearSelection = useEventCallback((event, year) => {
    if (readOnly) {
      return;
    }
    const newDate = utils.setYear(value ?? referenceDate, year);
    handleValueChange(newDate);
  });
  const focusYear = useEventCallback(year => {
    if (!isYearDisabled(utils.setYear(value ?? referenceDate, year))) {
      setFocusedYear(year);
      changeHasFocus(true);
      onYearFocus?.(year);
    }
  });
  React.useEffect(() => {
    setFocusedYear(prevFocusedYear => selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
  }, [selectedYear]);
  const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
  const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
  const handleKeyDown = useEventCallback((event, year) => {
    switch (event.key) {
      case 'ArrowUp':
        focusYear(year - verticalDirection);
        event.preventDefault();
        break;
      case 'ArrowDown':
        focusYear(year + verticalDirection);
        event.preventDefault();
        break;
      case 'ArrowLeft':
        focusYear(year - horizontalDirection);
        event.preventDefault();
        break;
      case 'ArrowRight':
        focusYear(year + horizontalDirection);
        event.preventDefault();
        break;
    }
  });
  const handleYearFocus = useEventCallback((event, year) => {
    focusYear(year);
  });
  const handleYearBlur = useEventCallback((event, year) => {
    if (focusedYear === year) {
      changeHasFocus(false);
    }
  });
  const scrollerRef = React.useRef(null);
  const handleRef = useForkRef(ref, scrollerRef);
  React.useEffect(() => {
    if (autoFocus || scrollerRef.current === null) {
      return;
    }
    const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
    if (!tabbableButton) {
      return;
    }

    // Taken from useScroll in x-data-grid, but vertically centered
    const offsetHeight = tabbableButton.offsetHeight;
    const offsetTop = tabbableButton.offsetTop;
    const clientHeight = scrollerRef.current.clientHeight;
    const scrollTop = scrollerRef.current.scrollTop;
    const elementBottom = offsetTop + offsetHeight;
    if (offsetHeight > clientHeight || offsetTop < scrollTop) {
      // Button already visible
      return;
    }
    scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
  }, [autoFocus]);
  const yearRange = utils.getYearRange([minDate, maxDate]);
  if (yearsOrder === 'desc') {
    yearRange.reverse();
  }
  return /*#__PURE__*/jsx(YearCalendarRoot, _extends({
    ref: handleRef,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    role: "radiogroup",
    "aria-labelledby": gridLabelId
  }, other, {
    children: yearRange.map(year => {
      const yearNumber = utils.getYear(year);
      const isSelected = yearNumber === selectedYear;
      const isDisabled = disabled || isYearDisabled(year);
      return /*#__PURE__*/jsx(PickersYear, {
        selected: isSelected,
        value: yearNumber,
        onClick: handleYearSelection,
        onKeyDown: handleKeyDown,
        autoFocus: internalHasFocus && yearNumber === focusedYear,
        disabled: isDisabled,
        tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
        onFocus: handleYearFocus,
        onBlur: handleYearBlur,
        "aria-current": todayYear === yearNumber ? 'date' : undefined,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        children: utils.format(year, 'year')
      }, utils.format(year, 'year'));
    })
  }));
});
process.env.NODE_ENV !== "production" ? YearCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true` picker is disabled
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onYearFocus: PropTypes.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(['asc', 'desc']),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
} : void 0;

const getPickersCalendarHeaderUtilityClass = slot => generateUtilityClass('MuiPickersCalendarHeader', slot);
const pickersCalendarHeaderClasses = generateUtilityClasses('MuiPickersCalendarHeader', ['root', 'labelContainer', 'label', 'switchViewButton', 'switchViewIcon']);

const _excluded$8 = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone", "format"],
  _excluded2$1 = ["ownerState"];
const useUtilityClasses$7 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    labelContainer: ['labelContainer'],
    label: ['label'],
    switchViewButton: ['switchViewButton'],
    switchViewIcon: ['switchViewIcon']
  };
  return composeClasses(slots, getPickersCalendarHeaderUtilityClass, classes);
};
const PickersCalendarHeaderRoot = styled('div', {
  name: 'MuiPickersCalendarHeader',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})({
  display: 'flex',
  alignItems: 'center',
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
});
const PickersCalendarHeaderLabelContainer = styled('div', {
  name: 'MuiPickersCalendarHeader',
  slot: 'LabelContainer',
  overridesResolver: (_, styles) => styles.labelContainer
})(({
  theme
}) => _extends({
  display: 'flex',
  overflow: 'hidden',
  alignItems: 'center',
  cursor: 'pointer',
  marginRight: 'auto'
}, theme.typography.body1, {
  fontWeight: theme.typography.fontWeightMedium
}));
const PickersCalendarHeaderLabel = styled('div', {
  name: 'MuiPickersCalendarHeader',
  slot: 'Label',
  overridesResolver: (_, styles) => styles.label
})({
  marginRight: 6
});
const PickersCalendarHeaderSwitchViewButton = styled(IconButton$1, {
  name: 'MuiPickersCalendarHeader',
  slot: 'SwitchViewButton',
  overridesResolver: (_, styles) => styles.switchViewButton
})({
  marginRight: 'auto',
  variants: [{
    props: {
      view: 'year'
    },
    style: {
      [`.${pickersCalendarHeaderClasses.switchViewIcon}`]: {
        transform: 'rotate(180deg)'
      }
    }
  }]
});
const PickersCalendarHeaderSwitchViewIcon = styled(ArrowDropDownIcon, {
  name: 'MuiPickersCalendarHeader',
  slot: 'SwitchViewIcon',
  overridesResolver: (_, styles) => styles.switchViewIcon
})(({
  theme
}) => ({
  willChange: 'transform',
  transition: theme.transitions.create('transform'),
  transform: 'rotate(0deg)'
}));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */
const PickersCalendarHeader = /*#__PURE__*/React.forwardRef(function PickersCalendarHeader(inProps, ref) {
  const translations = usePickersTranslations();
  const utils = useUtils();
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersCalendarHeader'
  });
  const {
      slots,
      slotProps,
      currentMonth: month,
      disabled,
      disableFuture,
      disablePast,
      maxDate,
      minDate,
      onMonthChange,
      onViewChange,
      view,
      reduceAnimations,
      views,
      labelId,
      className,
      timezone,
      format = `${utils.formats.month} ${utils.formats.year}`
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$8);
  const ownerState = props;
  const classes = useUtilityClasses$7(props);
  const SwitchViewButton = slots?.switchViewButton ?? PickersCalendarHeaderSwitchViewButton;
  const switchViewButtonProps = useSlotProps({
    elementType: SwitchViewButton,
    externalSlotProps: slotProps?.switchViewButton,
    additionalProps: {
      size: 'small',
      'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
    },
    ownerState,
    className: classes.switchViewButton
  });
  const SwitchViewIcon = slots?.switchViewIcon ?? PickersCalendarHeaderSwitchViewIcon;
  // The spread is here to avoid this bug mui/material-ui#34056
  const _useSlotProps = useSlotProps({
      elementType: SwitchViewIcon,
      externalSlotProps: slotProps?.switchViewIcon,
      ownerState,
      className: classes.switchViewIcon
    }),
    switchViewIconProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2$1);
  const selectNextMonth = () => onMonthChange(utils.addMonths(month, 1), 'left');
  const selectPreviousMonth = () => onMonthChange(utils.addMonths(month, -1), 'right');
  const isNextMonthDisabled = useNextMonthDisabled(month, {
    disableFuture,
    maxDate,
    timezone
  });
  const isPreviousMonthDisabled = usePreviousMonthDisabled(month, {
    disablePast,
    minDate,
    timezone
  });
  const handleToggleView = () => {
    if (views.length === 1 || !onViewChange || disabled) {
      return;
    }
    if (views.length === 2) {
      onViewChange(views.find(el => el !== view) || views[0]);
    } else {
      // switching only between first 2
      const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
      onViewChange(views[nextIndexToOpen]);
    }
  };

  // No need to display more information
  if (views.length === 1 && views[0] === 'year') {
    return null;
  }
  const label = utils.formatByString(month, format);
  return /*#__PURE__*/jsxs(PickersCalendarHeaderRoot, _extends({}, other, {
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref,
    children: [/*#__PURE__*/jsxs(PickersCalendarHeaderLabelContainer, {
      role: "presentation",
      onClick: handleToggleView,
      ownerState: ownerState
      // putting this on the label item element below breaks when using transition
      ,
      "aria-live": "polite",
      className: classes.labelContainer,
      children: [/*#__PURE__*/jsx(PickersFadeTransitionGroup, {
        reduceAnimations: reduceAnimations,
        transKey: label,
        children: /*#__PURE__*/jsx(PickersCalendarHeaderLabel, {
          id: labelId,
          ownerState: ownerState,
          className: classes.label,
          children: label
        })
      }), views.length > 1 && !disabled && /*#__PURE__*/jsx(SwitchViewButton, _extends({}, switchViewButtonProps, {
        children: /*#__PURE__*/jsx(SwitchViewIcon, _extends({}, switchViewIconProps))
      }))]
    }), /*#__PURE__*/jsx(Fade, {
      in: view === 'day',
      children: /*#__PURE__*/jsx(PickersArrowSwitcher, {
        slots: slots,
        slotProps: slotProps,
        onGoToPrevious: selectPreviousMonth,
        isPreviousDisabled: isPreviousMonthDisabled,
        previousLabel: translations.previousMonth,
        onGoToNext: selectNextMonth,
        isNextDisabled: isNextMonthDisabled,
        nextLabel: translations.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" ? PickersCalendarHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  currentMonth: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: PropTypes.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: PropTypes.string,
  maxDate: PropTypes.object.isRequired,
  minDate: PropTypes.object.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onViewChange: PropTypes.func,
  reduceAnimations: PropTypes.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  timezone: PropTypes.string.isRequired,
  view: PropTypes.oneOf(['day', 'month', 'year']).isRequired,
  views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'month', 'year']).isRequired).isRequired
} : void 0;

const PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';

// detect if user agent has Android version < 10 or iOS version < 13
const mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const androidVersion = mobileVersionMatches && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null;
const iOSVersion = mobileVersionMatches && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null;
const slowAnimationDevices = androidVersion && androidVersion < 10 || iOSVersion && iOSVersion < 13 || false;
const useDefaultReduceAnimations = () => {
  const prefersReduced = useMediaQuery(PREFERS_REDUCED_MOTION, {
    defaultMatches: false
  });
  return prefersReduced || slowAnimationDevices;
};

const getDateCalendarUtilityClass = slot => generateUtilityClass('MuiDateCalendar', slot);
generateUtilityClasses('MuiDateCalendar', ['root', 'viewTransitionContainer']);

const _excluded$7 = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsOrder", "yearsPerRow", "monthsPerRow", "timezone"];
const useUtilityClasses$6 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    viewTransitionContainer: ['viewTransitionContainer']
  };
  return composeClasses(slots, getDateCalendarUtilityClass, classes);
};
function useDateCalendarDefaultizedProps(props, name) {
  const utils = useUtils();
  const defaultDates = useDefaultDates();
  const defaultReduceAnimations = useDefaultReduceAnimations();
  const themeProps = useThemeProps({
    props,
    name
  });
  return _extends({}, themeProps, {
    loading: themeProps.loading ?? false,
    disablePast: themeProps.disablePast ?? false,
    disableFuture: themeProps.disableFuture ?? false,
    openTo: themeProps.openTo ?? 'day',
    views: themeProps.views ?? ['year', 'day'],
    reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
    renderLoading: themeProps.renderLoading ?? (() => /*#__PURE__*/jsx("span", {
      children: "..."
    })),
    minDate: applyDefaultDate(utils, themeProps.minDate, defaultDates.minDate),
    maxDate: applyDefaultDate(utils, themeProps.maxDate, defaultDates.maxDate)
  });
}
const DateCalendarRoot = styled(PickerViewRoot, {
  name: 'MuiDateCalendar',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'column',
  height: VIEW_HEIGHT
});
const DateCalendarViewTransitionContainer = styled(PickersFadeTransitionGroup, {
  name: 'MuiDateCalendar',
  slot: 'ViewTransitionContainer',
  overridesResolver: (props, styles) => styles.viewTransitionContainer
})({});
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateCalendar API](https://mui.com/x/api/date-pickers/date-calendar/)
 */
const DateCalendar = /*#__PURE__*/React.forwardRef(function DateCalendar(inProps, ref) {
  const utils = useUtils();
  const id = useId();
  const props = useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
  const {
      autoFocus,
      onViewChange,
      value: valueProp,
      defaultValue,
      referenceDate: referenceDateProp,
      disableFuture,
      disablePast,
      onChange,
      onYearChange,
      onMonthChange,
      reduceAnimations,
      shouldDisableDate,
      shouldDisableMonth,
      shouldDisableYear,
      view: inView,
      views,
      openTo,
      className,
      disabled,
      readOnly,
      minDate,
      maxDate,
      disableHighlightToday,
      focusedView: inFocusedView,
      onFocusedViewChange,
      showDaysOutsideCurrentMonth,
      fixedWeekNumber,
      dayOfWeekFormatter,
      slots,
      slotProps,
      loading,
      renderLoading,
      displayWeekNumber,
      yearsOrder,
      yearsPerRow,
      monthsPerRow,
      timezone: timezoneProp
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$7);
  const {
    value,
    handleValueChange,
    timezone
  } = useControlledValueWithTimezone({
    name: 'DateCalendar',
    timezone: timezoneProp,
    value: valueProp,
    defaultValue,
    referenceDate: referenceDateProp,
    onChange,
    valueManager: singleItemValueManager
  });
  const {
    view,
    setView,
    focusedView,
    setFocusedView,
    goToNextView,
    setValueAndGoToNextView
  } = useViews({
    view: inView,
    views,
    openTo,
    onChange: handleValueChange,
    onViewChange,
    autoFocus,
    focusedView: inFocusedView,
    onFocusedViewChange
  });
  const {
    referenceDate,
    calendarState,
    changeFocusedDay,
    changeMonth,
    handleChangeMonth,
    isDateDisabled,
    onMonthSwitchingAnimationEnd
  } = useCalendarState({
    value,
    referenceDate: referenceDateProp,
    reduceAnimations,
    onMonthChange,
    minDate,
    maxDate,
    shouldDisableDate,
    disablePast,
    disableFuture,
    timezone
  });

  // When disabled, limit the view to the selected date
  const minDateWithDisabled = disabled && value || minDate;
  const maxDateWithDisabled = disabled && value || maxDate;
  const gridLabelId = `${id}-grid-label`;
  const hasFocus = focusedView !== null;
  const CalendarHeader = slots?.calendarHeader ?? PickersCalendarHeader;
  const calendarHeaderProps = useSlotProps({
    elementType: CalendarHeader,
    externalSlotProps: slotProps?.calendarHeader,
    additionalProps: {
      views,
      view,
      currentMonth: calendarState.currentMonth,
      onViewChange: setView,
      onMonthChange: (newMonth, direction) => handleChangeMonth({
        newMonth,
        direction
      }),
      minDate: minDateWithDisabled,
      maxDate: maxDateWithDisabled,
      disabled,
      disablePast,
      disableFuture,
      reduceAnimations,
      timezone,
      labelId: gridLabelId
    },
    ownerState: props
  });
  const handleDateMonthChange = useEventCallback(newDate => {
    const startOfMonth = utils.startOfMonth(newDate);
    const endOfMonth = utils.endOfMonth(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
      maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, 'finish');
      onMonthChange?.(startOfMonth);
    } else {
      goToNextView();
      changeMonth(startOfMonth);
    }
    changeFocusedDay(closestEnabledDate, true);
  });
  const handleDateYearChange = useEventCallback(newDate => {
    const startOfYear = utils.startOfYear(newDate);
    const endOfYear = utils.endOfYear(newDate);
    const closestEnabledDate = isDateDisabled(newDate) ? findClosestEnabledDate({
      utils,
      date: newDate,
      minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
      maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
      disablePast,
      disableFuture,
      isDateDisabled,
      timezone
    }) : newDate;
    if (closestEnabledDate) {
      setValueAndGoToNextView(closestEnabledDate, 'finish');
      onYearChange?.(closestEnabledDate);
    } else {
      goToNextView();
      changeMonth(startOfYear);
    }
    changeFocusedDay(closestEnabledDate, true);
  });
  const handleSelectedDayChange = useEventCallback(day => {
    if (day) {
      // If there is a date already selected, then we want to keep its time
      return handleValueChange(mergeDateAndTime(utils, day, value ?? referenceDate), 'finish', view);
    }
    return handleValueChange(day, 'finish', view);
  });
  React.useEffect(() => {
    if (value != null && utils.isValid(value)) {
      changeMonth(value);
    }
  }, [value]); // eslint-disable-line

  const ownerState = props;
  const classes = useUtilityClasses$6(ownerState);
  const baseDateValidationProps = {
    disablePast,
    disableFuture,
    maxDate,
    minDate
  };
  const commonViewProps = {
    disableHighlightToday,
    readOnly,
    disabled,
    timezone,
    gridLabelId,
    slots,
    slotProps
  };
  const prevOpenViewRef = React.useRef(view);
  React.useEffect(() => {
    // If the view change and the focus was on the previous view
    // Then we update the focus.
    if (prevOpenViewRef.current === view) {
      return;
    }
    if (focusedView === prevOpenViewRef.current) {
      setFocusedView(view, true);
    }
    prevOpenViewRef.current = view;
  }, [focusedView, setFocusedView, view]);
  const selectedDays = React.useMemo(() => [value], [value]);
  return /*#__PURE__*/jsxs(DateCalendarRoot, _extends({
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/jsx(CalendarHeader, _extends({}, calendarHeaderProps, {
      slots: slots,
      slotProps: slotProps
    })), /*#__PURE__*/jsx(DateCalendarViewTransitionContainer, {
      reduceAnimations: reduceAnimations,
      className: classes.viewTransitionContainer,
      transKey: view,
      ownerState: ownerState,
      children: /*#__PURE__*/jsxs("div", {
        children: [view === 'year' && /*#__PURE__*/jsx(YearCalendar, _extends({}, baseDateValidationProps, commonViewProps, {
          value: value,
          onChange: handleDateYearChange,
          shouldDisableYear: shouldDisableYear,
          hasFocus: hasFocus,
          onFocusedViewChange: isViewFocused => setFocusedView('year', isViewFocused),
          yearsOrder: yearsOrder,
          yearsPerRow: yearsPerRow,
          referenceDate: referenceDate
        })), view === 'month' && /*#__PURE__*/jsx(MonthCalendar, _extends({}, baseDateValidationProps, commonViewProps, {
          hasFocus: hasFocus,
          className: className,
          value: value,
          onChange: handleDateMonthChange,
          shouldDisableMonth: shouldDisableMonth,
          onFocusedViewChange: isViewFocused => setFocusedView('month', isViewFocused),
          monthsPerRow: monthsPerRow,
          referenceDate: referenceDate
        })), view === 'day' && /*#__PURE__*/jsx(DayCalendar, _extends({}, calendarState, baseDateValidationProps, commonViewProps, {
          onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
          onFocusedDayChange: changeFocusedDay,
          reduceAnimations: reduceAnimations,
          selectedDays: selectedDays,
          onSelectedDaysChange: handleSelectedDayChange,
          shouldDisableDate: shouldDisableDate,
          shouldDisableMonth: shouldDisableMonth,
          shouldDisableYear: shouldDisableYear,
          hasFocus: hasFocus,
          onFocusedViewChange: isViewFocused => setFocusedView('day', isViewFocused),
          showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
          fixedWeekNumber: fixedWeekNumber,
          dayOfWeekFormatter: dayOfWeekFormatter,
          displayWeekNumber: displayWeekNumber,
          loading: loading,
          renderLoading: renderLoading
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" ? DateCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Controlled focused view.
   */
  focusedView: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: PropTypes.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(['day', 'month', 'year']),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(['day', 'month', 'year']).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(['asc', 'desc']),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
} : void 0;

function getButtonUtilityClass(slot) {
  return generateUtilityClass('MuiButton', slot);
}
const buttonClasses = generateUtilityClasses('MuiButton', ['root', 'text', 'textInherit', 'textPrimary', 'textSecondary', 'textSuccess', 'textError', 'textInfo', 'textWarning', 'outlined', 'outlinedInherit', 'outlinedPrimary', 'outlinedSecondary', 'outlinedSuccess', 'outlinedError', 'outlinedInfo', 'outlinedWarning', 'contained', 'containedInherit', 'containedPrimary', 'containedSecondary', 'containedSuccess', 'containedError', 'containedInfo', 'containedWarning', 'disableElevation', 'focusVisible', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorError', 'colorInfo', 'colorWarning', 'textSizeSmall', 'textSizeMedium', 'textSizeLarge', 'outlinedSizeSmall', 'outlinedSizeMedium', 'outlinedSizeLarge', 'containedSizeSmall', 'containedSizeMedium', 'containedSizeLarge', 'sizeMedium', 'sizeSmall', 'sizeLarge', 'fullWidth', 'startIcon', 'endIcon', 'icon', 'iconSizeSmall', 'iconSizeMedium', 'iconSizeLarge']);
var buttonClasses$1 = buttonClasses;

/**
 * @ignore - internal component.
 */
const ButtonGroupContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ButtonGroupContext.displayName = 'ButtonGroupContext';
}
var ButtonGroupContext$1 = ButtonGroupContext;

/**
 * @ignore - internal component.
 */
const ButtonGroupButtonContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ButtonGroupButtonContext.displayName = 'ButtonGroupButtonContext';
}
var ButtonGroupButtonContext$1 = ButtonGroupButtonContext;

const _excluded$6 = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"];
const useUtilityClasses$5 = ownerState => {
  const {
    color,
    disableElevation,
    fullWidth,
    size,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, `${variant}${capitalize(color)}`, `size${capitalize(size)}`, `${variant}Size${capitalize(size)}`, `color${capitalize(color)}`, disableElevation && 'disableElevation', fullWidth && 'fullWidth'],
    label: ['label'],
    startIcon: ['icon', 'startIcon', `iconSize${capitalize(size)}`],
    endIcon: ['icon', 'endIcon', `iconSize${capitalize(size)}`]
  };
  const composedClasses = composeClasses(slots, getButtonUtilityClass, classes);
  return _extends({}, classes, composedClasses);
};
const commonIconStyles = ownerState => _extends({}, ownerState.size === 'small' && {
  '& > *:nth-of-type(1)': {
    fontSize: 18
  }
}, ownerState.size === 'medium' && {
  '& > *:nth-of-type(1)': {
    fontSize: 20
  }
}, ownerState.size === 'large' && {
  '& > *:nth-of-type(1)': {
    fontSize: 22
  }
});
const ButtonRoot = styled(ButtonBase, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${capitalize(ownerState.color)}`], styles[`size${capitalize(ownerState.size)}`], styles[`${ownerState.variant}Size${capitalize(ownerState.size)}`], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disableElevation && styles.disableElevation, ownerState.fullWidth && styles.fullWidth];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$palette$getCon, _theme$palette;
  const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
  const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
  return _extends({}, theme.typography.button, {
    minWidth: 64,
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
      duration: theme.transitions.duration.short
    }),
    '&:hover': _extends({
      textDecoration: 'none',
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : colorManipulatorExports.alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : colorManipulatorExports.alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
      border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : colorManipulatorExports.alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'contained' && {
      backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
      boxShadow: (theme.vars || theme).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: (theme.vars || theme).shadows[2],
        backgroundColor: (theme.vars || theme).palette.grey[300]
      }
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
      }
    }),
    '&:active': _extends({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[8]
    }),
    [`&.${buttonClasses$1.focusVisible}`]: _extends({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[6]
    }),
    [`&.${buttonClasses$1.disabled}`]: _extends({
      color: (theme.vars || theme).palette.action.disabled
    }, ownerState.variant === 'outlined' && {
      border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
    }, ownerState.variant === 'contained' && {
      color: (theme.vars || theme).palette.action.disabled,
      boxShadow: (theme.vars || theme).shadows[0],
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    })
  }, ownerState.variant === 'text' && {
    padding: '6px 8px'
  }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.variant === 'outlined' && {
    padding: '5px 15px',
    border: '1px solid currentColor'
  }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main,
    border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${colorManipulatorExports.alpha(theme.palette[ownerState.color].main, 0.5)}`
  }, ownerState.variant === 'contained' && {
    color: theme.vars ?
    // this is safe because grey does not change between default light/dark mode
    theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
    backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
    boxShadow: (theme.vars || theme).shadows[2]
  }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].contrastText,
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.color === 'inherit' && {
    color: 'inherit',
    borderColor: 'currentColor'
  }, ownerState.size === 'small' && ownerState.variant === 'text' && {
    padding: '4px 5px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'text' && {
    padding: '8px 11px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
    padding: '3px 9px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
    padding: '7px 21px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
    padding: '4px 10px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
    padding: '8px 22px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.fullWidth && {
    width: '100%'
  });
}, ({
  ownerState
}) => ownerState.disableElevation && {
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none'
  },
  [`&.${buttonClasses$1.focusVisible}`]: {
    boxShadow: 'none'
  },
  '&:active': {
    boxShadow: 'none'
  },
  [`&.${buttonClasses$1.disabled}`]: {
    boxShadow: 'none'
  }
});
const ButtonStartIcon = styled('span', {
  name: 'MuiButton',
  slot: 'StartIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.startIcon, styles[`iconSize${capitalize(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends({
  display: 'inherit',
  marginRight: 8,
  marginLeft: -4
}, ownerState.size === 'small' && {
  marginLeft: -2
}, commonIconStyles(ownerState)));
const ButtonEndIcon = styled('span', {
  name: 'MuiButton',
  slot: 'EndIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.endIcon, styles[`iconSize${capitalize(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends({
  display: 'inherit',
  marginRight: -4,
  marginLeft: 8
}, ownerState.size === 'small' && {
  marginRight: -2
}, commonIconStyles(ownerState)));
const Button = /*#__PURE__*/React.forwardRef(function Button(inProps, ref) {
  // props priority: `inProps` > `contextProps` > `themeDefaultProps`
  const contextProps = React.useContext(ButtonGroupContext$1);
  const buttonGroupButtonContextPositionClassName = React.useContext(ButtonGroupButtonContext$1);
  const resolvedProps = resolveProps(contextProps, inProps);
  const props = useDefaultProps({
    props: resolvedProps,
    name: 'MuiButton'
  });
  const {
      children,
      color = 'primary',
      component = 'button',
      className,
      disabled = false,
      disableElevation = false,
      disableFocusRipple = false,
      endIcon: endIconProp,
      focusVisibleClassName,
      fullWidth = false,
      size = 'medium',
      startIcon: startIconProp,
      type,
      variant = 'text'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$6);
  const ownerState = _extends({}, props, {
    color,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    fullWidth,
    size,
    type,
    variant
  });
  const classes = useUtilityClasses$5(ownerState);
  const startIcon = startIconProp && /*#__PURE__*/jsx(ButtonStartIcon, {
    className: classes.startIcon,
    ownerState: ownerState,
    children: startIconProp
  });
  const endIcon = endIconProp && /*#__PURE__*/jsx(ButtonEndIcon, {
    className: classes.endIcon,
    ownerState: ownerState,
    children: endIconProp
  });
  const positionClassName = buttonGroupButtonContextPositionClassName || '';
  return /*#__PURE__*/jsxs(ButtonRoot, _extends({
    ownerState: ownerState,
    className: clsx$1(contextProps.className, classes.root, className, positionClassName),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx$1(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other, {
    classes: classes,
    children: [startIcon, children, endIcon]
  }));
});
process.env.NODE_ENV !== "production" ? Button.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning']), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['small', 'medium', 'large']), PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['contained', 'outlined', 'text']), PropTypes.string])
} : void 0;
var Button$1 = Button;

function getTabUtilityClass(slot) {
  return generateUtilityClass('MuiTab', slot);
}
const tabClasses = generateUtilityClasses('MuiTab', ['root', 'labelIcon', 'textColorInherit', 'textColorPrimary', 'textColorSecondary', 'selected', 'disabled', 'fullWidth', 'wrapped', 'iconWrapper']);
var tabClasses$1 = tabClasses;

const _excluded$5 = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"];
const useUtilityClasses$4 = ownerState => {
  const {
    classes,
    textColor,
    fullWidth,
    wrapped,
    icon,
    label,
    selected,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', icon && label && 'labelIcon', `textColor${capitalize(textColor)}`, fullWidth && 'fullWidth', wrapped && 'wrapped', selected && 'selected', disabled && 'disabled'],
    iconWrapper: ['iconWrapper']
  };
  return composeClasses(slots, getTabUtilityClass, classes);
};
const TabRoot = styled(ButtonBase, {
  name: 'MuiTab',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.label && ownerState.icon && styles.labelIcon, styles[`textColor${capitalize(ownerState.textColor)}`], ownerState.fullWidth && styles.fullWidth, ownerState.wrapped && styles.wrapped, {
      [`& .${tabClasses$1.iconWrapper}`]: styles.iconWrapper
    }];
  }
})(({
  theme,
  ownerState
}) => _extends({}, theme.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: 'relative',
  minHeight: 48,
  flexShrink: 0,
  padding: '12px 16px',
  overflow: 'hidden',
  whiteSpace: 'normal',
  textAlign: 'center'
}, ownerState.label && {
  flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
}, {
  lineHeight: 1.25
}, ownerState.icon && ownerState.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${tabClasses$1.iconWrapper}`]: _extends({}, ownerState.iconPosition === 'top' && {
    marginBottom: 6
  }, ownerState.iconPosition === 'bottom' && {
    marginTop: 6
  }, ownerState.iconPosition === 'start' && {
    marginRight: theme.spacing(1)
  }, ownerState.iconPosition === 'end' && {
    marginLeft: theme.spacing(1)
  })
}, ownerState.textColor === 'inherit' && {
  color: 'inherit',
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${tabClasses$1.selected}`]: {
    opacity: 1
  },
  [`&.${tabClasses$1.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }
}, ownerState.textColor === 'primary' && {
  color: (theme.vars || theme).palette.text.secondary,
  [`&.${tabClasses$1.selected}`]: {
    color: (theme.vars || theme).palette.primary.main
  },
  [`&.${tabClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  }
}, ownerState.textColor === 'secondary' && {
  color: (theme.vars || theme).palette.text.secondary,
  [`&.${tabClasses$1.selected}`]: {
    color: (theme.vars || theme).palette.secondary.main
  },
  [`&.${tabClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  }
}, ownerState.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: 'none'
}, ownerState.wrapped && {
  fontSize: theme.typography.pxToRem(12)
}));
const Tab = /*#__PURE__*/React.forwardRef(function Tab(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTab'
  });
  const {
      className,
      disabled = false,
      disableFocusRipple = false,
      // eslint-disable-next-line react/prop-types
      fullWidth,
      icon: iconProp,
      iconPosition = 'top',
      // eslint-disable-next-line react/prop-types
      indicator,
      label,
      onChange,
      onClick,
      onFocus,
      // eslint-disable-next-line react/prop-types
      selected,
      // eslint-disable-next-line react/prop-types
      selectionFollowsFocus,
      // eslint-disable-next-line react/prop-types
      textColor = 'inherit',
      value,
      wrapped = false
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$5);
  const ownerState = _extends({}, props, {
    disabled,
    disableFocusRipple,
    selected,
    icon: !!iconProp,
    iconPosition,
    label: !!label,
    fullWidth,
    textColor,
    wrapped
  });
  const classes = useUtilityClasses$4(ownerState);
  const icon = iconProp && label && /*#__PURE__*/React.isValidElement(iconProp) ? /*#__PURE__*/React.cloneElement(iconProp, {
    className: clsx$1(classes.iconWrapper, iconProp.props.className)
  }) : iconProp;
  const handleClick = event => {
    if (!selected && onChange) {
      onChange(event, value);
    }
    if (onClick) {
      onClick(event);
    }
  };
  const handleFocus = event => {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event, value);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  return /*#__PURE__*/jsxs(TabRoot, _extends({
    focusRipple: !disableFocusRipple,
    className: clsx$1(classes.root, className),
    ref: ref,
    role: "tab",
    "aria-selected": selected,
    disabled: disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    ownerState: ownerState,
    tabIndex: selected ? 0 : -1
  }, other, {
    children: [iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/jsxs(React.Fragment, {
      children: [icon, label]
    }) : /*#__PURE__*/jsxs(React.Fragment, {
      children: [label, icon]
    }), indicator]
  }));
});
process.env.NODE_ENV !== "production" ? Tab.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display.
   */
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: PropTypes.oneOf(['bottom', 'end', 'start', 'top']),
  /**
   * The label element.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: PropTypes.bool
} : void 0;
var Tab$1 = Tab;

function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function animate(property, element, to, options = {}, cb = () => {}) {
  const {
    ease = easeInOutSin,
    duration = 300 // standard
  } = options;
  let start = null;
  const from = element[property];
  let cancelled = false;
  const cancel = () => {
    cancelled = true;
  };
  const step = timestamp => {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }
    if (start === null) {
      start = timestamp;
    }
    const time = Math.min(1, (timestamp - start) / duration);
    element[property] = ease(time) * (to - from) + from;
    if (time >= 1) {
      requestAnimationFrame(() => {
        cb(null);
      });
      return;
    }
    requestAnimationFrame(step);
  };
  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }
  requestAnimationFrame(step);
  return cancel;
}

const _excluded$4 = ["onChange"];
const styles = {
  width: 99,
  height: 99,
  position: 'absolute',
  top: -9999,
  overflow: 'scroll'
};

/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */
function ScrollbarSize(props) {
  const {
      onChange
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$4);
  const scrollbarHeight = React.useRef();
  const nodeRef = React.useRef(null);
  const setMeasurements = () => {
    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
  };
  useEnhancedEffect(() => {
    const handleResize = debounce(() => {
      const prevHeight = scrollbarHeight.current;
      setMeasurements();
      if (prevHeight !== scrollbarHeight.current) {
        onChange(scrollbarHeight.current);
      }
    });
    const containerWindow = ownerWindow(nodeRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [onChange]);
  React.useEffect(() => {
    setMeasurements();
    onChange(scrollbarHeight.current);
  }, [onChange]);
  return /*#__PURE__*/jsx("div", _extends({
    style: styles
  }, other, {
    ref: nodeRef
  }));
}
process.env.NODE_ENV !== "production" ? ScrollbarSize.propTypes = {
  onChange: PropTypes.func.isRequired
} : void 0;

var KeyboardArrowLeft = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

var KeyboardArrowRight = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

function getTabScrollButtonUtilityClass(slot) {
  return generateUtilityClass('MuiTabScrollButton', slot);
}
const tabScrollButtonClasses = generateUtilityClasses('MuiTabScrollButton', ['root', 'vertical', 'horizontal', 'disabled']);
var tabScrollButtonClasses$1 = tabScrollButtonClasses;

const _excluded$3 = ["className", "slots", "slotProps", "direction", "orientation", "disabled"];
const useUtilityClasses$3 = ownerState => {
  const {
    classes,
    orientation,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', orientation, disabled && 'disabled']
  };
  return composeClasses(slots, getTabScrollButtonUtilityClass, classes);
};
const TabScrollButtonRoot = styled(ButtonBase, {
  name: 'MuiTabScrollButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.orientation && styles[ownerState.orientation]];
  }
})(({
  ownerState
}) => _extends({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${tabScrollButtonClasses$1.disabled}`]: {
    opacity: 0
  }
}, ownerState.orientation === 'vertical' && {
  width: '100%',
  height: 40,
  '& svg': {
    transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
  }
}));
const TabScrollButton = /*#__PURE__*/React.forwardRef(function TabScrollButton(inProps, ref) {
  var _slots$StartScrollBut, _slots$EndScrollButto;
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTabScrollButton'
  });
  const {
      className,
      slots = {},
      slotProps = {},
      direction
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$3);
  const isRtl = useRtl();
  const ownerState = _extends({
    isRtl
  }, props);
  const classes = useUtilityClasses$3(ownerState);
  const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : KeyboardArrowLeft;
  const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : KeyboardArrowRight;
  const startButtonIconProps = useSlotProps({
    elementType: StartButtonIcon,
    externalSlotProps: slotProps.startScrollButtonIcon,
    additionalProps: {
      fontSize: 'small'
    },
    ownerState
  });
  const endButtonIconProps = useSlotProps({
    elementType: EndButtonIcon,
    externalSlotProps: slotProps.endScrollButtonIcon,
    additionalProps: {
      fontSize: 'small'
    },
    ownerState
  });
  return /*#__PURE__*/jsx(TabScrollButtonRoot, _extends({
    component: "div",
    className: clsx$1(classes.root, className),
    ref: ref,
    role: null,
    ownerState: ownerState,
    tabIndex: null
  }, other, {
    children: direction === 'left' ? /*#__PURE__*/jsx(StartButtonIcon, _extends({}, startButtonIconProps)) : /*#__PURE__*/jsx(EndButtonIcon, _extends({}, endButtonIconProps))
  }));
});
process.env.NODE_ENV !== "production" ? TabScrollButton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The direction the button should indicate.
   */
  direction: PropTypes.oneOf(['left', 'right']).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: PropTypes.shape({
    endScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    startScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    EndScrollButtonIcon: PropTypes.elementType,
    StartScrollButtonIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var TabScrollButton$1 = TabScrollButton;

function getTabsUtilityClass(slot) {
  return generateUtilityClass('MuiTabs', slot);
}
const tabsClasses = generateUtilityClasses('MuiTabs', ['root', 'vertical', 'flexContainer', 'flexContainerVertical', 'centered', 'scroller', 'fixed', 'scrollableX', 'scrollableY', 'hideScrollbar', 'scrollButtons', 'scrollButtonsHideMobile', 'indicator']);
var tabsClasses$1 = tabsClasses;

const _excluded$2 = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"];
const nextItem = (list, item) => {
  if (list === item) {
    return list.firstChild;
  }
  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }
  return list.firstChild;
};
const previousItem = (list, item) => {
  if (list === item) {
    return list.lastChild;
  }
  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }
  return list.lastChild;
};
const moveFocus = (list, currentFocus, traversalFunction) => {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list, currentFocus);
  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }
      wrappedOnce = true;
    }

    // Same logic as useAutocomplete.js
    const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
    if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus);
    } else {
      nextFocus.focus();
      return;
    }
  }
};
const useUtilityClasses$2 = ownerState => {
  const {
    vertical,
    fixed,
    hideScrollbar,
    scrollableX,
    scrollableY,
    centered,
    scrollButtonsHideMobile,
    classes
  } = ownerState;
  const slots = {
    root: ['root', vertical && 'vertical'],
    scroller: ['scroller', fixed && 'fixed', hideScrollbar && 'hideScrollbar', scrollableX && 'scrollableX', scrollableY && 'scrollableY'],
    flexContainer: ['flexContainer', vertical && 'flexContainerVertical', centered && 'centered'],
    indicator: ['indicator'],
    scrollButtons: ['scrollButtons', scrollButtonsHideMobile && 'scrollButtonsHideMobile'],
    scrollableX: [scrollableX && 'scrollableX'],
    hideScrollbar: [hideScrollbar && 'hideScrollbar']
  };
  return composeClasses(slots, getTabsUtilityClass, classes);
};
const TabsRoot = styled('div', {
  name: 'MuiTabs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${tabsClasses$1.scrollButtons}`]: styles.scrollButtons
    }, {
      [`& .${tabsClasses$1.scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
    }, styles.root, ownerState.vertical && styles.vertical];
  }
})(({
  ownerState,
  theme
}) => _extends({
  overflow: 'hidden',
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  display: 'flex'
}, ownerState.vertical && {
  flexDirection: 'column'
}, ownerState.scrollButtonsHideMobile && {
  [`& .${tabsClasses$1.scrollButtons}`]: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));
const TabsScroller = styled('div', {
  name: 'MuiTabs',
  slot: 'Scroller',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.scroller, ownerState.fixed && styles.fixed, ownerState.hideScrollbar && styles.hideScrollbar, ownerState.scrollableX && styles.scrollableX, ownerState.scrollableY && styles.scrollableY];
  }
})(({
  ownerState
}) => _extends({
  position: 'relative',
  display: 'inline-block',
  flex: '1 1 auto',
  whiteSpace: 'nowrap'
}, ownerState.fixed && {
  overflowX: 'hidden',
  width: '100%'
}, ownerState.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: 'none',
  // Firefox
  '&::-webkit-scrollbar': {
    display: 'none' // Safari + Chrome
  }
}, ownerState.scrollableX && {
  overflowX: 'auto',
  overflowY: 'hidden'
}, ownerState.scrollableY && {
  overflowY: 'auto',
  overflowX: 'hidden'
}));
const FlexContainer = styled('div', {
  name: 'MuiTabs',
  slot: 'FlexContainer',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.flexContainer, ownerState.vertical && styles.flexContainerVertical, ownerState.centered && styles.centered];
  }
})(({
  ownerState
}) => _extends({
  display: 'flex'
}, ownerState.vertical && {
  flexDirection: 'column'
}, ownerState.centered && {
  justifyContent: 'center'
}));
const TabsIndicator = styled('span', {
  name: 'MuiTabs',
  slot: 'Indicator',
  overridesResolver: (props, styles) => styles.indicator
})(({
  ownerState,
  theme
}) => _extends({
  position: 'absolute',
  height: 2,
  bottom: 0,
  width: '100%',
  transition: theme.transitions.create()
}, ownerState.indicatorColor === 'primary' && {
  backgroundColor: (theme.vars || theme).palette.primary.main
}, ownerState.indicatorColor === 'secondary' && {
  backgroundColor: (theme.vars || theme).palette.secondary.main
}, ownerState.vertical && {
  height: '100%',
  width: 2,
  right: 0
}));
const TabsScrollbarSize = styled(ScrollbarSize)({
  overflowX: 'auto',
  overflowY: 'hidden',
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: 'none',
  // Firefox
  '&::-webkit-scrollbar': {
    display: 'none' // Safari + Chrome
  }
});
const defaultIndicatorStyle = {};
let warnedOnceTabPresent = false;
const Tabs = /*#__PURE__*/React.forwardRef(function Tabs(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiTabs'
  });
  const theme = useTheme$3();
  const isRtl = useRtl();
  const {
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      action,
      centered = false,
      children: childrenProp,
      className,
      component = 'div',
      allowScrollButtonsMobile = false,
      indicatorColor = 'primary',
      onChange,
      orientation = 'horizontal',
      ScrollButtonComponent = TabScrollButton$1,
      scrollButtons = 'auto',
      selectionFollowsFocus,
      slots = {},
      slotProps = {},
      TabIndicatorProps = {},
      TabScrollButtonProps = {},
      textColor = 'primary',
      value,
      variant = 'standard',
      visibleScrollbar = false
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$2);
  const scrollable = variant === 'scrollable';
  const vertical = orientation === 'vertical';
  const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
  const start = vertical ? 'top' : 'left';
  const end = vertical ? 'bottom' : 'right';
  const clientSize = vertical ? 'clientHeight' : 'clientWidth';
  const size = vertical ? 'height' : 'width';
  const ownerState = _extends({}, props, {
    component,
    allowScrollButtonsMobile,
    indicatorColor,
    orientation,
    vertical,
    scrollButtons,
    textColor,
    variant,
    visibleScrollbar,
    fixed: !scrollable,
    hideScrollbar: scrollable && !visibleScrollbar,
    scrollableX: scrollable && !vertical,
    scrollableY: scrollable && vertical,
    centered: centered && !scrollable,
    scrollButtonsHideMobile: !allowScrollButtonsMobile
  });
  const classes = useUtilityClasses$2(ownerState);
  const startScrollButtonIconProps = useSlotProps({
    elementType: slots.StartScrollButtonIcon,
    externalSlotProps: slotProps.startScrollButtonIcon,
    ownerState
  });
  const endScrollButtonIconProps = useSlotProps({
    elementType: slots.EndScrollButtonIcon,
    externalSlotProps: slotProps.endScrollButtonIcon,
    ownerState
  });
  if (process.env.NODE_ENV !== 'production') {
    if (centered && scrollable) {
      console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
    }
  }
  const [mounted, setMounted] = React.useState(false);
  const [indicatorStyle, setIndicatorStyle] = React.useState(defaultIndicatorStyle);
  const [displayStartScroll, setDisplayStartScroll] = React.useState(false);
  const [displayEndScroll, setDisplayEndScroll] = React.useState(false);
  const [updateScrollObserver, setUpdateScrollObserver] = React.useState(false);
  const [scrollerStyle, setScrollerStyle] = React.useState({
    overflow: 'hidden',
    scrollbarWidth: 0
  });
  const valueToIndex = new Map();
  const tabsRef = React.useRef(null);
  const tabListRef = React.useRef(null);
  const getTabsMeta = () => {
    const tabsNode = tabsRef.current;
    let tabsMeta;
    if (tabsNode) {
      const rect = tabsNode.getBoundingClientRect();
      // create a new object with ClientRect class props + scrollLeft
      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollTop: tabsNode.scrollTop,
        scrollLeftNormalized: getNormalizedScrollLeft(tabsNode, isRtl ? 'rtl' : 'ltr'),
        scrollWidth: tabsNode.scrollWidth,
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
    }
    let tabMeta;
    if (tabsNode && value !== false) {
      const children = tabListRef.current.children;
      if (children.length > 0) {
        const tab = children[valueToIndex.get(value)];
        if (process.env.NODE_ENV !== 'production') {
          if (!tab) {
            console.error([`MUI: The \`value\` provided to the Tabs component is invalid.`, `None of the Tabs' children match with "${value}".`, valueToIndex.keys ? `You can provide one of the following values: ${Array.from(valueToIndex.keys()).join(', ')}.` : null].join('\n'));
          }
        }
        tabMeta = tab ? tab.getBoundingClientRect() : null;
        if (process.env.NODE_ENV !== 'production') {
          if (process.env.NODE_ENV !== 'test' && !warnedOnceTabPresent && tabMeta && tabMeta.width === 0 && tabMeta.height === 0 &&
          // if the whole Tabs component is hidden, don't warn
          tabsMeta.clientWidth !== 0) {
            tabsMeta = null;
            console.error(['MUI: The `value` provided to the Tabs component is invalid.', `The Tab with this \`value\` ("${value}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join('\n'));
            warnedOnceTabPresent = true;
          }
        }
      }
    }
    return {
      tabsMeta,
      tabMeta
    };
  };
  const updateIndicatorState = useEventCallback(() => {
    const {
      tabsMeta,
      tabMeta
    } = getTabsMeta();
    let startValue = 0;
    let startIndicator;
    if (vertical) {
      startIndicator = 'top';
      if (tabMeta && tabsMeta) {
        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
      }
    } else {
      startIndicator = isRtl ? 'right' : 'left';
      if (tabMeta && tabsMeta) {
        const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
      }
    }
    const newIndicatorStyle = {
      [startIndicator]: startValue,
      // May be wrong until the font is loaded.
      [size]: tabMeta ? tabMeta[size] : 0
    };

    // IE11 support, replace with Number.isNaN
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) {
      setIndicatorStyle(newIndicatorStyle);
    } else {
      const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
      const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
      if (dStart >= 1 || dSize >= 1) {
        setIndicatorStyle(newIndicatorStyle);
      }
    }
  });
  const scroll = (scrollValue, {
    animation = true
  } = {}) => {
    if (animation) {
      animate(scrollStart, tabsRef.current, scrollValue, {
        duration: theme.transitions.duration.standard
      });
    } else {
      tabsRef.current[scrollStart] = scrollValue;
    }
  };
  const moveTabsScroll = delta => {
    let scrollValue = tabsRef.current[scrollStart];
    if (vertical) {
      scrollValue += delta;
    } else {
      scrollValue += delta * (isRtl ? -1 : 1);
      // Fix for Edge
      scrollValue *= isRtl && detectScrollType() === 'reverse' ? -1 : 1;
    }
    scroll(scrollValue);
  };
  const getScrollSize = () => {
    const containerSize = tabsRef.current[clientSize];
    let totalSize = 0;
    const children = Array.from(tabListRef.current.children);
    for (let i = 0; i < children.length; i += 1) {
      const tab = children[i];
      if (totalSize + tab[clientSize] > containerSize) {
        // If the first item is longer than the container size, then only scroll
        // by the container size.
        if (i === 0) {
          totalSize = containerSize;
        }
        break;
      }
      totalSize += tab[clientSize];
    }
    return totalSize;
  };
  const handleStartScrollClick = () => {
    moveTabsScroll(-1 * getScrollSize());
  };
  const handleEndScrollClick = () => {
    moveTabsScroll(getScrollSize());
  };

  // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
  // with CSS improves.
  const handleScrollbarSizeChange = React.useCallback(scrollbarWidth => {
    setScrollerStyle({
      overflow: null,
      scrollbarWidth
    });
  }, []);
  const getConditionalElements = () => {
    const conditionalElements = {};
    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/jsx(TabsScrollbarSize, {
      onChange: handleScrollbarSizeChange,
      className: clsx$1(classes.scrollableX, classes.hideScrollbar)
    }) : null;
    const scrollButtonsActive = displayStartScroll || displayEndScroll;
    const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/jsx(ScrollButtonComponent, _extends({
      slots: {
        StartScrollButtonIcon: slots.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: startScrollButtonIconProps
      },
      orientation: orientation,
      direction: isRtl ? 'right' : 'left',
      onClick: handleStartScrollClick,
      disabled: !displayStartScroll
    }, TabScrollButtonProps, {
      className: clsx$1(classes.scrollButtons, TabScrollButtonProps.className)
    })) : null;
    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/jsx(ScrollButtonComponent, _extends({
      slots: {
        EndScrollButtonIcon: slots.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: endScrollButtonIconProps
      },
      orientation: orientation,
      direction: isRtl ? 'left' : 'right',
      onClick: handleEndScrollClick,
      disabled: !displayEndScroll
    }, TabScrollButtonProps, {
      className: clsx$1(classes.scrollButtons, TabScrollButtonProps.className)
    })) : null;
    return conditionalElements;
  };
  const scrollSelectedIntoView = useEventCallback(animation => {
    const {
      tabsMeta,
      tabMeta
    } = getTabsMeta();
    if (!tabMeta || !tabsMeta) {
      return;
    }
    if (tabMeta[start] < tabsMeta[start]) {
      // left side of button is out of view
      const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
      scroll(nextScrollStart, {
        animation
      });
    } else if (tabMeta[end] > tabsMeta[end]) {
      // right side of button is out of view
      const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
      scroll(nextScrollStart, {
        animation
      });
    }
  });
  const updateScrollButtonState = useEventCallback(() => {
    if (scrollable && scrollButtons !== false) {
      setUpdateScrollObserver(!updateScrollObserver);
    }
  });
  React.useEffect(() => {
    const handleResize = debounce(() => {
      // If the Tabs component is replaced by Suspense with a fallback, the last
      // ResizeObserver's handler that runs because of the change in the layout is trying to
      // access a dom node that is no longer there (as the fallback component is being shown instead).
      // See https://github.com/mui/material-ui/issues/33276
      // TODO: Add tests that will ensure the component is not failing when
      // replaced by Suspense with a fallback, once React is updated to version 18
      if (tabsRef.current) {
        updateIndicatorState();
      }
    });
    let resizeObserver;

    /**
     * @type {MutationCallback}
     */
    const handleMutation = records => {
      records.forEach(record => {
        record.removedNodes.forEach(item => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
        });
        record.addedNodes.forEach(item => {
          var _resizeObserver2;
          (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
        });
      });
      handleResize();
      updateScrollButtonState();
    };
    const win = ownerWindow(tabsRef.current);
    win.addEventListener('resize', handleResize);
    let mutationObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(handleResize);
      Array.from(tabListRef.current.children).forEach(child => {
        resizeObserver.observe(child);
      });
    }
    if (typeof MutationObserver !== 'undefined') {
      mutationObserver = new MutationObserver(handleMutation);
      mutationObserver.observe(tabListRef.current, {
        childList: true
      });
    }
    return () => {
      var _mutationObserver, _resizeObserver3;
      handleResize.clear();
      win.removeEventListener('resize', handleResize);
      (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
      (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
    };
  }, [updateIndicatorState, updateScrollButtonState]);

  /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */
  React.useEffect(() => {
    const tabListChildren = Array.from(tabListRef.current.children);
    const length = tabListChildren.length;
    if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
      const firstTab = tabListChildren[0];
      const lastTab = tabListChildren[length - 1];
      const observerOptions = {
        root: tabsRef.current,
        threshold: 0.99
      };
      const handleScrollButtonStart = entries => {
        setDisplayStartScroll(!entries[0].isIntersecting);
      };
      const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
      firstObserver.observe(firstTab);
      const handleScrollButtonEnd = entries => {
        setDisplayEndScroll(!entries[0].isIntersecting);
      };
      const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
      lastObserver.observe(lastTab);
      return () => {
        firstObserver.disconnect();
        lastObserver.disconnect();
      };
    }
    return undefined;
  }, [scrollable, scrollButtons, updateScrollObserver, childrenProp == null ? void 0 : childrenProp.length]);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  React.useEffect(() => {
    updateIndicatorState();
  });
  React.useEffect(() => {
    // Don't animate on the first render.
    scrollSelectedIntoView(defaultIndicatorStyle !== indicatorStyle);
  }, [scrollSelectedIntoView, indicatorStyle]);
  React.useImperativeHandle(action, () => ({
    updateIndicator: updateIndicatorState,
    updateScrollButtons: updateScrollButtonState
  }), [updateIndicatorState, updateScrollButtonState]);
  const indicator = /*#__PURE__*/jsx(TabsIndicator, _extends({}, TabIndicatorProps, {
    className: clsx$1(classes.indicator, TabIndicatorProps.className),
    ownerState: ownerState,
    style: _extends({}, indicatorStyle, TabIndicatorProps.style)
  }));
  let childIndex = 0;
  const children = React.Children.map(childrenProp, child => {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return null;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (reactIsExports.isFragment(child)) {
        console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    const childValue = child.props.value === undefined ? childIndex : child.props.value;
    valueToIndex.set(childValue, childIndex);
    const selected = childValue === value;
    childIndex += 1;
    return /*#__PURE__*/React.cloneElement(child, _extends({
      fullWidth: variant === 'fullWidth',
      indicator: selected && !mounted && indicator,
      selected,
      selectionFollowsFocus,
      onChange,
      textColor,
      value: childValue
    }, childIndex === 1 && value === false && !child.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  });
  const handleKeyDown = event => {
    const list = tabListRef.current;
    const currentFocus = ownerDocument(list).activeElement;
    // Keyboard navigation assumes that [role="tab"] are siblings
    // though we might warn in the future about nested, interactive elements
    // as a a11y violation
    const role = currentFocus.getAttribute('role');
    if (role !== 'tab') {
      return;
    }
    let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
    let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
    if (orientation === 'horizontal' && isRtl) {
      // swap previousItemKey with nextItemKey
      previousItemKey = 'ArrowRight';
      nextItemKey = 'ArrowLeft';
    }
    switch (event.key) {
      case previousItemKey:
        event.preventDefault();
        moveFocus(list, currentFocus, previousItem);
        break;
      case nextItemKey:
        event.preventDefault();
        moveFocus(list, currentFocus, nextItem);
        break;
      case 'Home':
        event.preventDefault();
        moveFocus(list, null, nextItem);
        break;
      case 'End':
        event.preventDefault();
        moveFocus(list, null, previousItem);
        break;
    }
  };
  const conditionalElements = getConditionalElements();
  return /*#__PURE__*/jsxs(TabsRoot, _extends({
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    ref: ref,
    as: component
  }, other, {
    children: [conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/jsxs(TabsScroller, {
      className: classes.scroller,
      ownerState: ownerState,
      style: {
        overflow: scrollerStyle.overflow,
        [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
      },
      ref: tabsRef,
      children: [/*#__PURE__*/jsx(FlexContainer, {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
        className: classes.flexContainer,
        ownerState: ownerState,
        onKeyDown: handleKeyDown,
        ref: tabListRef,
        role: "tablist",
        children: children
      }), mounted && indicator]
    }), conditionalElements.scrollButtonEnd]
  }));
});
process.env.NODE_ENV !== "production" ? Tabs.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: refType,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: PropTypes.bool,
  /**
   * The label for the Tabs as a string.
   */
  'aria-label': PropTypes.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  'aria-labelledby': PropTypes.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: PropTypes /* @typescript-to-proptypes-ignore */.oneOfType([PropTypes.oneOf(['primary', 'secondary']), PropTypes.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: PropTypes.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: PropTypes.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: PropTypes /* @typescript-to-proptypes-ignore */.oneOf(['auto', false, true]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: PropTypes.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: PropTypes.shape({
    endScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    startScrollButtonIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    EndScrollButtonIcon: PropTypes.elementType,
    StartScrollButtonIcon: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: PropTypes.object,
  /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: PropTypes.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: PropTypes.oneOf(['inherit', 'primary', 'secondary']),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: PropTypes.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: PropTypes.oneOf(['fullWidth', 'scrollable', 'standard']),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: PropTypes.bool
} : void 0;
var Tabs$1 = Tabs;

const DateFilter = ({ isOpen, anchorEl, disableFuture, disableBefore, disableAfter, value, onChange, onClose }) => {
    const { documentFilter: strings } = useStrings();
    const getCanClear = () => value !== null;
    const [canClear, setCanClear] = useState(getCanClear());
    function handleChange(value) {
        onChange(value);
        onClose();
    }
    return React__default.createElement(Popover, { className: className$r(), open: isOpen, anchorEl: anchorEl, anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom'
        }, TransitionProps: {
            onExited() {
                // Prevent clear button appearing/disappearing during close animation
                // by only changing visibility when fully closed.
                setCanClear(getCanClear());
            }
        }, onClose: onClose },
        React__default.createElement(DateCalendar, { value: value, disableFuture: disableFuture, shouldDisableDate: date => (disableBefore !== undefined && date < disableBefore)
                || (disableAfter !== undefined && date > disableAfter), onChange: (value, _selectionState, selectedView) => {
                if (selectedView === 'day') {
                    handleChange(value);
                }
            } }),
        canClear && React__default.createElement("div", { className: className$r('clear') },
            React__default.createElement(Button$2, { variant: "outlined", onClick: () => handleChange(null) }, strings.clearFilter)));
};
const className$r = createClassName('DateFilter');

const DocumentGroupFilter = ({ onPublishedOnOrAfterChange, onPublishedOnOrBeforeChange }) => {
    const { documentFilter: strings } = useStrings();
    const [publishedBefore, setPublishedBefore] = useState(null);
    const [publishedBeforeOpen, setPublishedBeforeOpen] = useState(false);
    const publishedBeforeRef = useRef(null);
    const publishedBeforeDate = useDateText(publishedBefore, { format: DateText.DATE_SHORT });
    const [publishedAfter, setPublishedAfter] = useState(null);
    const [publishedAfterOpen, setPublishedAfterOpen] = useState(false);
    const publishedAfterRef = useRef(null);
    const publishedAfterDate = useDateText(publishedAfter, { format: DateText.DATE_SHORT });
    function getButtonClasses(isOpen, isActive) {
        return classNames({
            [`${className$q()}-open`]: isOpen,
            [`${className$q()}-active`]: isActive
        });
    }
    return React__default.createElement("div", { className: className$q() },
        React__default.createElement("button", { ref: publishedAfterRef, className: getButtonClasses(publishedAfterOpen, publishedAfter !== null), onClick: () => setPublishedAfterOpen(true) },
            React__default.createElement(FontAwesomeIcon, { icon: faCalendarExports.faCalendar, size: "sm" }),
            publishedAfter ? strings.publishedOnOrAfterDate(publishedAfterDate) : strings.publishedOnOrAfter,
            React__default.createElement(FontAwesomeIcon, { icon: faChevronDownExports.faChevronDown, size: "sm" })),
        React__default.createElement("button", { ref: publishedBeforeRef, className: getButtonClasses(publishedBeforeOpen, publishedBefore !== null), onClick: () => setPublishedBeforeOpen(true) },
            React__default.createElement(FontAwesomeIcon, { icon: faCalendarExports.faCalendar, size: "sm" }),
            publishedBefore ? strings.publishedOnOrBeforeDate(publishedBeforeDate) : strings.publishedOnOrBefore,
            React__default.createElement(FontAwesomeIcon, { icon: faChevronDownExports.faChevronDown, size: "sm" })),
        React__default.createElement(DateFilter, { isOpen: publishedAfterOpen, anchorEl: publishedAfterRef.current, disableFuture: true, disableAfter: publishedBefore !== null && publishedBefore !== void 0 ? publishedBefore : undefined, value: publishedAfter, onChange: value => {
                setPublishedAfter(value);
                onPublishedOnOrAfterChange(value);
            }, onClose: () => setPublishedAfterOpen(false) }),
        React__default.createElement(DateFilter, { isOpen: publishedBeforeOpen, anchorEl: publishedBeforeRef.current, disableFuture: true, disableBefore: publishedAfter !== null && publishedAfter !== void 0 ? publishedAfter : undefined, value: publishedBefore, onChange: value => {
                setPublishedBefore(value);
                onPublishedOnOrBeforeChange(value);
            }, onClose: () => setPublishedBeforeOpen(false) }));
};
const className$q = createClassName('DocumentGroupFilter');

const DocumentGroupHeader = ({ group, paginator, showDateFilter, isLoading, onFilter, onPublishedOnOrAfterChange, onPublishedOnOrBeforeChange }) => {
    const strings = useStrings();
    const { hideDocumentGroupFilter } = useContext();
    const [filterInputValue, setFilterInputValue] = useState('');
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    useEffect(() => {
        // Clear the filter when changing groups.
        setFilterInputValue('');
    }, [group.id]);
    useEffect(() => {
        // Clear the filter when loading.
        if (isLoading) {
            setFilterInputValue('');
        }
    }, [isLoading]);
    return React__default.createElement(ContentHeader, { className: className$p(), columns: createResponsiveValue(3).maxWidth(600, 2) },
        React__default.createElement(ContentHeader.Title, { title: isLoading ? loadingToken : group.name }),
        React__default.createElement(Pagination, { paginator: paginator, isLoading: isLoading }),
        React__default.createElement("div", { className: className$p('filter') },
            React__default.createElement(SearchBox, { value: filterInputValue, placeholder: strings.documentGroup.filterPlaceholder, onChange: setFilterInputValue, onDebouncedChange: onFilter }),
            showDateFilter && !hideDocumentGroupFilter && React__default.createElement(ButtonBar, { buttons: [
                    {
                        id: 'filter',
                        icon: faCalendarExports.faCalendar,
                        title: strings.documentFilter.filterByPublicationDate,
                        onClick() {
                            if (isFilterVisible) {
                                onPublishedOnOrAfterChange(null);
                                onPublishedOnOrBeforeChange(null);
                            }
                            setIsFilterVisible(!isFilterVisible);
                        }
                    }
                ] })),
        isFilterVisible && React__default.createElement(DocumentGroupFilter, { onPublishedOnOrAfterChange: onPublishedOnOrAfterChange, onPublishedOnOrBeforeChange: onPublishedOnOrBeforeChange }));
};
const className$p = createClassName('DocumentGroupHeader');

/**
 * Returns a value that is reset when `resetKey` changes.
 */
function useResettableValue(initialValue, resetKey) {
    const [value, setValue] = useState(initialValue);
    const resetValue = useRef(initialValue);
    useEffect(() => {
        setValue(resetValue.current);
    }, [resetKey]);
    return [value, setValue];
}

const DocumentGroupScreen = ({ vehicle, groupId, fromSearchViaDocumentGroup = false }) => {
    const { documentGroup: strings } = useStrings();
    const [filter, setFilter] = useResettableValue('', groupId);
    const [pageNumber, setPageNumber] = useState(0);
    const vinResolver = useVinResolver();
    const { documentGroupDocumentsSortOrder, searchViaDocumentGroupSortOrder } = useContext();
    const [publishedOnOrAfter, setPublishedOnOrAfter] = useState(null);
    const [publishedOnOrBefore, setPublishedOnOrBefore] = useState(null);
    const [{ sortKey, sortDirection }, setSortOrder] = useState(fromSearchViaDocumentGroup
        ? searchViaDocumentGroupSortOrder !== null && searchViaDocumentGroupSortOrder !== void 0 ? searchViaDocumentGroupSortOrder : {
            sortKey: 'publicationDate',
            sortDirection: 'descending'
        }
        : documentGroupDocumentsSortOrder !== null && documentGroupDocumentsSortOrder !== void 0 ? documentGroupDocumentsSortOrder : {
            sortKey: 'title',
            sortDirection: 'ascending'
        });
    const { data, isFetching, error } = useGetDocumentsQuery({
        vehicle,
        groupId,
        filter,
        publishedOnOrAfter: publishedOnOrAfter !== null && publishedOnOrAfter !== void 0 ? publishedOnOrAfter : undefined,
        publishedOnOrBefore: publishedOnOrBefore !== null && publishedOnOrBefore !== void 0 ? publishedOnOrBefore : undefined,
        pageNumber,
        pageSize: config.paginationPageSize,
        sortKey,
        sortDirection
    });
    const paginator = usePaginator(data, setPageNumber, [groupId, filter, sortKey, sortDirection]);
    const isLoadingNewGroup = useIsLoadingWithDifferentKey(isFetching, groupId);
    const title = vehicle ? [data === null || data === void 0 ? void 0 : data.group.name, vehicle.ref === 'vin' ? vinResolver(vehicle.vin) : vehicle.name] : [data === null || data === void 0 ? void 0 : data.group.name];
    usePageTitle(...title);
    const errorMessage = useApiErrorMessage(strings.loadError, error, {
        404: strings.notFound
    });
    const sortProps = useMemo(() => ({
        sortKey,
        sortDirection,
        onSort: (sortKey, sortDirection) => setSortOrder({ sortKey, sortDirection })
    }), [sortKey, sortDirection]);
    if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!data) {
        return React__default.createElement(TableScreenSkeleton, { hasActions: true });
    }
    const header = React__default.createElement(DocumentGroupHeader, { group: data.group, paginator: paginator, showDateFilter: fromSearchViaDocumentGroup, isLoading: isLoadingNewGroup, onFilter: setFilter, onPublishedOnOrAfterChange: setPublishedOnOrAfter, onPublishedOnOrBeforeChange: setPublishedOnOrBefore });
    return React__default.createElement(Screen, { className: "DocumentGroupScreen", header: header, bottomPagination: React__default.createElement(Pagination, { paginator: paginator, isLoading: isLoadingNewGroup, centerHorizontally: true }) },
        React__default.createElement(PanelGrid, null,
            React__default.createElement(Panel, null,
                React__default.createElement(DocumentTable, { documents: data.elements, sort: sortProps, isPublicationDateShown: true, isLoading: isFetching }))));
};

const DocumentGroupRouter = ({ vehicle, fromSearchViaDocumentGroup }) => {
    const { groupId } = useParams();
    if (!groupId || !isNumeric(groupId)) {
        return React__default.createElement(NotFoundScreen, null);
    }
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { path: "/", element: React__default.createElement(DocumentGroupScreen, { vehicle: vehicle, groupId: groupId, fromSearchViaDocumentGroup: fromSearchViaDocumentGroup }) }),
        React__default.createElement(Route, { path: "documents/:documentId/*", element: React__default.createElement(DocumentRouter, null) }));
};

const VehicleHeader = props => {
    const { vehicle: strings, qrCode: qrCodeStrings } = useStrings();
    const vinResolver = useVinResolver();
    const isQrCodeVisible = useIsQrCodesEnabled() && props.vehicle.ref === 'vin';
    const buttons = [{
            id: 'favourite',
            icon: props.isFavourite ? faStarExports.faStar : faStarExports$1.faStar,
            title: props.isFavourite ? strings.removeFavouriteButton : strings.addFavouriteButton,
            visible: props.showFavourite ? 'visible' : 'never',
            disabled: !props.enableFavourite,
            onClick: props.onFavouriteClick
        }, {
            id: 'qrCode',
            icon: faQrcodeExports.faQrcode,
            title: qrCodeStrings.generateQrCode,
            visible: isQrCodeVisible ? 'visible' : 'never',
            onClick: props.onQrCodeClick
        }];
    return React__default.createElement(ContentHeader, { columns: 2 },
        React__default.createElement(ContentHeader.Title, { title: getVehicleDisplayName(props.vehicle, vinResolver) }),
        React__default.createElement(ButtonBar, { buttons: buttons }),
        props.children);
};

const LinkTab = Tab$1;
const VehicleTabs = ({ vehicle, isFeaturesTabShown, isLinksTabShown }) => {
    const { vehicle: strings } = useStrings();
    const location = useLocation();
    const navigation = useNavigation();
    const vehicleUrl = navigation.vehicle(vehicle);
    const moduleTabs = useModuleVehicleTabs(vehicle);
    const tabs = useMemo(() => {
        let result = [
            {
                title: strings.overviewTab,
                href: joinPath(vehicleUrl, '/')
            },
            isFeaturesTabShown && {
                title: strings.featuresTab,
                href: joinPath(vehicleUrl, '/features')
            },
            isLinksTabShown && {
                title: strings.linksTab,
                href: joinPath(vehicleUrl, '/links')
            }
        ].filter(filterFalse);
        if (moduleTabs) {
            result = result.concat(moduleTabs.map(tab => {
                var _a;
                return ({
                    title: tab.title,
                    href: joinPath(vehicleUrl, tab.href),
                    adornment: (_a = tab.adornment) === null || _a === void 0 ? void 0 : _a.call(tab)
                });
            }));
        }
        return result;
    }, [strings.overviewTab, strings.featuresTab, strings.linksTab, isFeaturesTabShown, isLinksTabShown, moduleTabs, vehicleUrl]);
    const selectedTab = useMemo(() => {
        var _a, _b;
        return (_b = (_a = tabs.find(tab => tab.href === location.pathname)) === null || _a === void 0 ? void 0 : _a.href) !== null && _b !== void 0 ? _b : false;
    }, [tabs, location.pathname]);
    return React__default.createElement(Tabs$1, { className: className$o(), value: selectedTab, variant: "scrollable" }, tabs.map(({ title, href, adornment }) => React__default.createElement(LinkTab, { key: href, value: href, label: title, "aria-label": title, component: Link, to: href, icon: adornment ? React__default.createElement("div", { className: className$o('adornment') }, adornment) : undefined, iconPosition: "end" })));
};
const className$o = createClassName('VehicleTabs');

const VehicleInformationPanel = ({ vehicle }) => {
    const { vehicle: strings } = useStrings();
    return React__default.createElement(Panel, { className: "VehicleInformationPanel" },
        React__default.createElement(Panel.Header, { title: strings.title }),
        React__default.createElement(Panel.Content, null,
            React__default.createElement(VehicleInformationImage, { imageUrl: vehicle.imageUrl }),
            React__default.createElement(VehicleInformationDefinitionList, { vehicle: vehicle })));
};

const VehiclePurchaseSubscriptionPanel = ({ vehicle }) => {
    const { vehicle: strings } = useStrings();
    const navigation = useNavigation();
    return React__default.createElement(Panel, { className: "VehiclePurchaseSubscriptionPanel" },
        React__default.createElement(Link$1, { href: navigation.subscriptions(getVehicleSpecificity(vehicle)) },
            strings.purchaseSubscription,
            React__default.createElement(FontAwesomeIcon, { icon: faShoppingCartExports.faShoppingCart })));
};

const ModuleVehiclePanels = ({ vehicle }) => {
    const { modules } = useContext();
    const panels = useMemo(() => {
        return modules === null || modules === void 0 ? void 0 : modules.flatMap(({ id, layouts }) => {
            if (layouts === null || layouts === void 0 ? void 0 : layouts.vehiclePanel) {
                return [React__default.createElement(Fragment, { key: String(id) }, layouts.vehiclePanel(vehicle))];
            }
            return [];
        });
    }, [modules, vehicle]);
    return panels ? React__default.createElement(React__default.Fragment, null, panels) : null;
};

const ServiceHistoryPanel = ({ vehicle }) => {
    const { serviceHistory: strings } = useStrings();
    const vin = vehicle.ref === 'vin' && vehicle.vin;
    const { data: serviceHistory, isLoading, error } = useGetServiceHistoryQuery(vin ? vin : queryExports.skipToken);
    if (!vin || isLoading || (error && 'status' in error && (error.status === 401 || error.status === 404))) {
        return null;
    }
    return React__default.createElement(Panel, { className: className$n() },
        React__default.createElement(Panel.Header, { title: strings.title }),
        serviceHistory ? React__default.createElement(Panel.Content, null,
            React__default.createElement(DefinitionList, { definitions: [
                    {
                        name: strings.lastService,
                        value: serviceHistory.lastService
                            ? React__default.createElement(ServiceRecordText, { service: serviceHistory.lastService })
                            : strings.never
                    },
                    {
                        name: strings.nextServiceDue,
                        value: serviceHistory.nextService
                            ? React__default.createElement(ServiceRecordText, { service: serviceHistory.nextService })
                            : strings.none
                    }
                ] })) : React__default.createElement(Panel.Message, { text: strings.loadError }));
};
const className$n = createClassName('ServiceHistoryPanel');

const VehicleOverviewTab = ({ vehicle }) => {
    const { showServiceHistoryPanel } = useContext();
    const isImportantDocumentsShown = useFeatureToggles().isFeatureToggleEnabled('RECENT_IMPORTANT_DOCUMENTS');
    const isPurchaseSubscriptionPanelShown = useFeatureToggles().isFeatureToggleEnabled('SUBSCRIPTION_PURCHASING');
    const showFrequentlyUsedDocuments = useFeatureToggles().isFeatureToggleEnabled('SHOW_FREQUENTLY_USED_DOCUMENTS');
    const { getColumnPanels } = useVehicleOverviewPanelLayout();
    const panels = {
        info: React__default.createElement(VehicleInformationPanel, { key: "info", vehicle: vehicle }),
        importantDocuments: isImportantDocumentsShown && React__default.createElement(ImportantDocumentPanel, { key: "importantDocuments", forCurrentVehicle: true }),
        favouriteContent: React__default.createElement(FavouriteContentPanel, { key: "favouriteContent", forCurrentVehicle: true }),
        frequentlyUsedDocuments: showFrequentlyUsedDocuments && React__default.createElement(FrequentlyUsedDocumentsPanel, { key: "frequentlyUsedDocuments", vehicle: vehicle }),
        purchaseSubscriptions: isPurchaseSubscriptionPanelShown && React__default.createElement(VehiclePurchaseSubscriptionPanel, { key: "purchaseSubscriptions", vehicle: vehicle }),
        serviceHistory: Boolean(showServiceHistoryPanel) && React__default.createElement(ServiceHistoryPanel, { key: "serviceHistory", vehicle: vehicle }),
        modules: React__default.createElement(ModuleVehiclePanels, { key: "modules", vehicle: vehicle })
    };
    return React__default.createElement(PanelGrid, { className: "VehicleOverviewTab" },
        React__default.createElement(PanelGrid.Column, null, getColumnPanels(panels, 'left')),
        React__default.createElement(PanelGrid.Column, null, getColumnPanels(panels, 'right')));
};

const FeaturesSubscribeScreen = () => {
    const { document: strings, subscriptions: subscriptionStrings } = useStrings();
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const specificity = vehicle ? getVehicleSpecificity(vehicle) : getGlobalSpecificity();
    const navigation = useNavigation();
    return React__default.createElement(MessageWithButtonsScreen, { title: strings.subscriptionRequiredTitle, heading: strings.subscriptionRequiredTitle, text: strings.subscriptionRequired, buttons: React__default.createElement(ButtonLink, { href: navigation.subscriptions(specificity) }, subscriptionStrings.purchaseTitle) });
};

const VehicleFeaturesTab = ({ features, hasFeatures }) => {
    if (!(features === null || features === void 0 ? void 0 : features.length)) {
        if (hasFeatures) {
            return React__default.createElement(FeaturesSubscribeScreen, null);
        }
        return null;
    }
    return (React__default.createElement(PanelGrid, { className: className$m() },
        React__default.createElement(Panel, null,
            React__default.createElement(FeaturesTable, { features: features }))));
};
const className$m = createClassName('VehicleFeaturesTab');

const LinkExitWarningDialogue = ({ url, isOpen, onClose }) => {
    const { links: strings } = useStrings();
    return React__default.createElement(ConfirmDialogue, { className: "LinkExitWarningDialogue", isOpen: isOpen, title: strings.exitWarningTitle, confirmTitle: strings.exitWarningConfirmButton, onConfirm: () => {
            window.open(url, '_blank');
            onClose();
        }, onCancel: onClose },
        React__default.createElement("p", null, strings.exitWarningPara1),
        React__default.createElement("p", null, strings.exitWarningPara2));
};

const VehicleLinksTab = ({ hyperlinks, isError }) => {
    const { links: strings } = useStrings();
    const [exitWarningUrl, setExitWarningUrl] = useState('');
    if (isError) {
        return React__default.createElement(CentredMessage, { title: strings.loadError });
    }
    function handleLinkClick(event, link) {
        if (link.exitWarning) {
            event.preventDefault();
            setExitWarningUrl(link.url);
        }
    }
    return React__default.createElement(PanelGrid, { className: className$l() },
        React__default.createElement(Panel, null,
            React__default.createElement("div", { className: className$l('links') }, hyperlinks.links.map(({ group, links }) => React__default.createElement(Fragment, { key: group.id },
                React__default.createElement("h4", null, group.name),
                React__default.createElement("ul", null, links.map(link => React__default.createElement("li", { key: `${link.url}-${link.title}` },
                    React__default.createElement(Link$1, { href: link.url, onClick: event => handleLinkClick(event, link) }, link.title)))))))),
        React__default.createElement(LinkExitWarningDialogue, { url: exitWarningUrl, isOpen: exitWarningUrl !== '', onClose: () => setExitWarningUrl('') }));
};
const className$l = createClassName('VehicleLinksTab');

const DocumentListPanelSkeleton = ({ hasRole }) => {
    return React__default.createElement(PanelSkeleton, { hasRole: hasRole },
        React__default.createElement(Panel.Content, null,
            React__default.createElement(DocumentListSkeleton, { hasRole: false })));
};

const VehicleOverviewTabSkeleton = ({ hasRole }) => {
    const { showServiceHistoryPanel } = useContext();
    const featureToggles = useFeatureToggles();
    const isImportantDocumentsShown = featureToggles.isFeatureToggleEnabled('RECENT_IMPORTANT_DOCUMENTS');
    const isPurchaseSubscriptionShown = featureToggles.isFeatureToggleEnabled('SUBSCRIPTION_PURCHASING');
    const isFrequentlyUsedDocumentsShown = featureToggles.isFeatureToggleEnabled('SHOW_FREQUENTLY_USED_DOCUMENTS');
    const { getColumnPanels } = useVehicleOverviewPanelLayout();
    const panels = {
        info: React__default.createElement(PanelSkeleton, { key: "info", hasRole: false },
            React__default.createElement(Panel.Content, null,
                React__default.createElement(Skeleton, { variant: "rectangular", width: 300, height: 180, className: className$k('image') }),
                React__default.createElement(DefinitionList, { definitions: [
                        { name: React__default.createElement(Skeleton, { width: 50 }), value: React__default.createElement(Skeleton, { width: "50%" }) },
                        { name: React__default.createElement(Skeleton, { width: 100 }), value: React__default.createElement(Skeleton, { width: "90%" }) },
                        { name: React__default.createElement(Skeleton, { width: 70 }), value: React__default.createElement(Skeleton, { width: "70%" }) }
                    ] }))),
        importantDocuments: isImportantDocumentsShown && React__default.createElement(DocumentListPanelSkeleton, { key: "importantDocuments", hasRole: false }),
        favouriteContent: React__default.createElement(DocumentListPanelSkeleton, { key: "favouriteContent", hasRole: false }),
        frequentlyUsedDocuments: isFrequentlyUsedDocumentsShown && React__default.createElement(DocumentListPanelSkeleton, { key: "frequentlyUsedDocuments", hasRole: false }),
        purchaseSubscriptions: isPurchaseSubscriptionShown && React__default.createElement(PanelSkeleton, { key: "purchaseSubscriptions", hasRole: false, hasTitle: false },
            React__default.createElement(Panel.Content, { className: className$k('purchaseSubscriptions') },
                React__default.createElement(Skeleton, { width: "50%" }),
                React__default.createElement(Skeleton, { variant: "circular", width: 16, height: 16 }))),
        serviceHistory: Boolean(showServiceHistoryPanel) && React__default.createElement(PanelSkeleton, { key: "serviceHistory", hasRole: false },
            React__default.createElement(Panel.Content, null,
                React__default.createElement(DefinitionList, { definitions: [
                        { name: React__default.createElement(Skeleton, { width: 50 }), value: React__default.createElement(Skeleton, { width: "50%" }) },
                        { name: React__default.createElement(Skeleton, { width: 70 }), value: React__default.createElement(Skeleton, { width: "70%" }) }
                    ] }))),
        modules: false
    };
    return React__default.createElement(SkeletonContainer, { hasRole: hasRole },
        React__default.createElement(PanelGrid, { className: className$k() },
            React__default.createElement(PanelGrid.Column, null, getColumnPanels(panels, 'left')),
            React__default.createElement(PanelGrid.Column, null, getColumnPanels(panels, 'right'))));
};
const className$k = createClassName('VehicleOverviewTabSkeleton');

const VehicleListTabSkeleton = ({ hasRole }) => {
    return React__default.createElement(SkeletonContainer, { hasRole: hasRole, className: className$j() },
        React__default.createElement(PanelGrid, null,
            React__default.createElement(Panel, null,
                React__default.createElement("div", { className: className$j('row') },
                    React__default.createElement("div", { className: className$j('column') },
                        React__default.createElement(Skeleton, { width: "60%" })),
                    React__default.createElement("div", { className: className$j('column') },
                        React__default.createElement(Skeleton, { width: "40%" }),
                        React__default.createElement(Skeleton, { width: "55%" }))),
                React__default.createElement("div", { className: className$j('row') },
                    React__default.createElement("div", { className: className$j('column') },
                        React__default.createElement(Skeleton, { width: "100%" })),
                    React__default.createElement("div", { className: className$j('column') },
                        React__default.createElement(Skeleton, { width: "65%" }))),
                React__default.createElement("div", { className: className$j('row') },
                    React__default.createElement("div", { className: className$j('column') },
                        React__default.createElement(Skeleton, { width: "50%" })),
                    React__default.createElement("div", { className: className$j('column') },
                        React__default.createElement(Skeleton, { width: "30%" }),
                        React__default.createElement(Skeleton, { width: "60%" }),
                        React__default.createElement(Skeleton, { width: "45%" }))))));
};
const className$j = createClassName('VehicleListTabSkeleton');

const VehicleTabsSkeleton = ({ vehicle, hasRole }) => {
    const moduleTabs = useModuleVehicleTabs(vehicle);
    return React__default.createElement(SkeletonContainer, { hasRole: hasRole },
        React__default.createElement(Routes, null,
            React__default.createElement(Route, { path: "/", element: React__default.createElement(VehicleOverviewTabSkeleton, { hasRole: false }) }),
            React__default.createElement(Route, { path: "features", element: React__default.createElement(VehicleListTabSkeleton, { hasRole: false }) }),
            React__default.createElement(Route, { path: "links", element: React__default.createElement(VehicleListTabSkeleton, { hasRole: false }) }), moduleTabs === null || moduleTabs === void 0 ? void 0 :
            moduleTabs.map(tab => {
                var _a, _b;
                return React__default.createElement(Route, { key: tab.href, element: React__default.createElement(RouteAccess, { access: tab.visibility }) },
                    React__default.createElement(Route, { path: tab.href, element: (_b = (_a = tab.fallback) === null || _a === void 0 ? void 0 : _a.call(tab)) !== null && _b !== void 0 ? _b : React__default.createElement(VehicleListTabSkeleton, { hasRole: false }) }));
            }),
            moduleTabs && React__default.createElement(Route, { path: "*", element: React__default.createElement(VehicleListTabSkeleton, { hasRole: false }) })));
};

const VehicleQrCodeDialogue = ({ isOpen, vehicle, onClose }) => {
    const { vehicle: strings, qrCode: qrCodeStrings } = useStrings();
    const { qrCode } = useContext();
    const vinResolver = useVinResolver();
    if (!qrCode) {
        return null;
    }
    const url = queryString.stringifyUrl({
        url: qrCode.resolverUrl,
        query: {
            vin: vehicle.ref === 'vin' ? vehicle.vin : undefined,
            pvc: vehicle.ref === 'product' ? vehicle.code : undefined
        }
    });
    return React__default.createElement(QrCodeDialogue, { isOpen: isOpen, url: url, onClose: onClose },
        React__default.createElement("p", null, qrCodeStrings.generateForVehicle),
        React__default.createElement(DefinitionList, { definitions: [
                {
                    name: vehicle.ref === 'vin' ? strings.vinLabel : strings.modelNameLabel,
                    value: vehicle.ref === 'vin' ? vinResolver(vehicle.vin) : vehicle.name
                }
            ] }));
};

const VehicleScreen = ({ vehicle }) => {
    const strings = useStrings();
    const moduleTabs = useModuleVehicleTabs(vehicle);
    const actions = useVehicleActions();
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const { data: vehicleHistory, isSuccess: isHistoryLoaded } = useGetVehicleHistoryQuery(undefined, { skip: !isLoggedIn });
    const { data: vehicleLinksData, isError: isVehicleLinksError } = useGetHyperlinksQuery();
    const isFavourite = (vehicleHistory === null || vehicleHistory === void 0 ? void 0 : vehicleHistory.favouriteVehicles.find(favourite => isSameVehicle(favourite, vehicle))) !== undefined;
    const scrollResetRef = useNavigationScrollReset();
    const isFeaturesTabShown = Boolean((vehicle.features && vehicle.features.length > 0) || vehicle.hasFeatures);
    const isLinksTabShown = Boolean(vehicleLinksData && vehicleLinksData.links.length > 0);
    const tabsLoaded = Boolean(vehicleLinksData && moduleTabs);
    const vinResolver = useVinResolver();
    const [showQrCodeDialogue, setShowQrCodeDialogue] = useState(false);
    usePageTitle(vehicle.ref === 'vin' ? vinResolver(vehicle.vin) : vehicle.name);
    useHelp('vehicle.info');
    function toggleFavourite() {
        if (vehicle.ref === 'vin') {
            actions.favourite(vehicle, !isFavourite);
        }
    }
    const header = React__default.createElement(VehicleHeader, { vehicle: vehicle, showFavourite: vehicle.ref === 'vin', enableFavourite: isHistoryLoaded, isFavourite: isFavourite, onFavouriteClick: toggleFavourite, onQrCodeClick: () => setShowQrCodeDialogue(true) },
        React__default.createElement(VehicleTabs, { vehicle: vehicle, isFeaturesTabShown: isFeaturesTabShown, isLinksTabShown: isLinksTabShown }));
    return React__default.createElement(Screen, { className: "VehicleScreen", header: header, contentRef: scrollResetRef },
        React__default.createElement(Routes, null,
            React__default.createElement(Route, { path: "/", element: React__default.createElement(VehicleOverviewTab, { vehicle: vehicle }) }),
            isFeaturesTabShown && React__default.createElement(Route, { path: "features", element: React__default.createElement(VehicleFeaturesTab, { features: vehicle.features, hasFeatures: vehicle.hasFeatures }) }),
            isLinksTabShown && vehicleLinksData && React__default.createElement(Route, { path: "links", element: React__default.createElement(VehicleLinksTab, { hyperlinks: vehicleLinksData, isError: isVehicleLinksError }) }), moduleTabs === null || moduleTabs === void 0 ? void 0 :
            moduleTabs.map(tab => React__default.createElement(Route, { key: tab.href, element: React__default.createElement(RouteAccess, { access: tab.visibility }) },
                React__default.createElement(Route, { path: tab.href, element: tab.content() }))),
            React__default.createElement(Route, { path: "*", element: tabsLoaded
                    ? React__default.createElement(CentredMessage, { title: strings.errors.pageNotFound })
                    : React__default.createElement(VehicleTabsSkeleton, { vehicle: vehicle }) })),
        React__default.createElement(VehicleQrCodeDialogue, { isOpen: showQrCodeDialogue, vehicle: vehicle, onClose: () => setShowQrCodeDialogue(false) }));
};

const FavouriteContentPageTable = ({ document }) => {
    var _a;
    const { document: strings, documentGroup } = useStrings();
    const favouriteDocumentPages = (_a = document.favouriteDocumentPages) !== null && _a !== void 0 ? _a : [];
    const navigation = useNavigation();
    const linkRef = useRef(null);
    const actions = useDocumentActions();
    const columns = useMemo(() => [
        { id: 'title', title: documentGroup.pageTitleColumn, className: 'FavouriteContentPageTable-title' },
        { id: 'actions', title: '', className: 'FavouriteContentPageTable-actions' }
    ], [documentGroup.pageTitleColumn]);
    function getPageRow(index) {
        const favouriteDocumentPage = favouriteDocumentPages[index];
        return {
            id: favouriteDocumentPage.pageId,
            component: ({ rowProps, favouriteDocumentPage }) => (React__default.createElement(Table.Row, { rowProps: rowProps, onClick: () => { var _a; return (_a = linkRef.current) === null || _a === void 0 ? void 0 : _a.click(); } },
                React__default.createElement(Table.TextCell, { primary: (() => (React__default.createElement(Link$1, { ref: linkRef, variant: "title", href: navigation.document(document, { fragment: favouriteDocumentPage.pageId }), preventIfOffline: strings.cannotOpenOffline, onClick: event => event.stopPropagation() }, favouriteDocumentPage.pageTitle)))() }),
                React__default.createElement(Table.ActionCell, null,
                    React__default.createElement(IconButton$2, { icon: faStarExports.faStar, title: strings.removeFavouriteButton, onClick: () => actions.favourite({ documentId: document.id, pageId: favouriteDocumentPage.pageId, favourite: false }) })))),
            props: {
                favouriteDocumentPage
            }
        };
    }
    return (React__default.createElement(Table, { className: "FavouriteContentPageTable", columns: columns, rowCount: favouriteDocumentPages.length, compactHeader: createResponsiveValue(false).maxWidth(MOBILE_BREAKPOINT, true), getRow: getPageRow }));
};

const FavouriteContentTableRow = ({ rowProps, isCompactTable, document }) => {
    var _a;
    const isFavouriteContentEnabled = useFeatureToggles().isFeatureToggleEnabled('BOOKMARK_DOCUMENT_PAGES');
    const { favouriteContent: strings } = useStrings();
    const linkRef = useRef(null);
    const link = React__default.createElement(DocumentLink, { ref: linkRef, document: document, variant: "title", onClick: event => event.stopPropagation() });
    const content = React__default.createElement(DocumentLabelAdornment, { document: document }, link);
    const [pagesVisible, setPagesVisible] = useState(false);
    const displayPagesTable = Boolean((_a = document.favouriteDocumentPages) === null || _a === void 0 ? void 0 : _a.length);
    const isFavourite = document.favourite === undefined ? true : document.favourite;
    const toggleButtonTitle = pagesVisible ? strings.hidePages : strings.showPages;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Table.Row, { className: "FavouriteContentTableRow", rowProps: rowProps, onClick: () => { var _a; return (_a = linkRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, isCompactTable ? (React__default.createElement(MobileRowCells, { content: content, displayPagesTable: displayPagesTable, document: document, isFavourite: isFavourite, setPagesVisible: setPagesVisible, toggleButtonTitle: toggleButtonTitle })) : (React__default.createElement(RowCells, { content: content, displayPagesTable: displayPagesTable, document: document, isFavourite: isFavourite, setPagesVisible: setPagesVisible, toggleButtonTitle: toggleButtonTitle }))),
        pagesVisible && displayPagesTable && isFavouriteContentEnabled && (React__default.createElement(Table.Row, { className: "FavouriteContentTableRow", rowProps: rowProps },
            React__default.createElement("td", { className: "FavouriteContentTableRow-subTable", colSpan: 4 },
                React__default.createElement(FavouriteContentPageTable, { document: document }))))));
};
const MobileRowCells = ({ content, displayPagesTable, document, isFavourite, setPagesVisible, toggleButtonTitle }) => {
    const isFavouriteContentEnabled = useFeatureToggles().isFeatureToggleEnabled('BOOKMARK_DOCUMENT_PAGES');
    return (React__default.createElement(MobileTableCell, { before: isFavouriteContentEnabled ? (React__default.createElement("div", { className: "FavouriteContentTableRow-mobileButtonContainer" }, displayPagesTable && (React__default.createElement(IconButton$2, { title: toggleButtonTitle, icon: faCaretDownExports.faCaretDown, onClick: () => setPagesVisible(visible => !visible) })))) : undefined, primary: content, secondary: document.reference, actions: React__default.createElement(DocumentActionButtons, { document: document, showFavourite: true, buttonSize: "large", isFavourite: isFavourite }) }));
};
const RowCells = ({ content, displayPagesTable, document, isFavourite, setPagesVisible, toggleButtonTitle }) => {
    const isFavouriteContentEnabled = useFeatureToggles().isFeatureToggleEnabled('BOOKMARK_DOCUMENT_PAGES');
    return (React__default.createElement(React__default.Fragment, null,
        isFavouriteContentEnabled && (React__default.createElement(Table.ActionCell, null, displayPagesTable && (React__default.createElement(IconButton$2, { title: toggleButtonTitle, icon: faCaretDownExports.faCaretDown, onClick: () => setPagesVisible(visible => !visible) })))),
        React__default.createElement(Table.TextCell, { primary: content }),
        React__default.createElement(Table.TextCell, { primary: document.reference }),
        React__default.createElement(Table.ActionCell, null,
            React__default.createElement(DocumentActionButtons, { document: document, showFavourite: true, isFavourite: isFavourite }))));
};

const FavouriteContentTable = props => {
    const { favouriteContent: contentStrings, favouriteDocuments: documentsStrings, documentGroup: columnStrings } = useStrings();
    const isFavouriteContentEnabled = useFeatureToggles().isFeatureToggleEnabled('BOOKMARK_DOCUMENT_PAGES');
    const columns = useMemo(() => {
        const columns = [
            { id: 'title', title: columnStrings.titleColumn, sortKey: 'title', className: 'FavouriteContentTable-title' },
            { id: 'reference', title: columnStrings.referenceColumn, sortKey: 'reference', className: 'FavouriteContentTable-reference' },
            { id: 'actions', title: '' }
        ];
        if (isFavouriteContentEnabled) {
            columns.unshift({ id: 'collapse', title: '' });
        }
        return columns;
    }, [columnStrings.titleColumn, columnStrings.referenceColumn, isFavouriteContentEnabled]);
    function getRow(index) {
        const document = props.documents[index];
        return {
            id: document.id,
            component: FavouriteContentTableRow,
            props: {
                document
            }
        };
    }
    return React__default.createElement(Table, { className: "FavouriteContentTable", columns: columns, rowCount: props.documents.length, sort: props.sort, compactHeader: createResponsiveValue(false).maxWidth(MOBILE_BREAKPOINT, true), getRow: getRow },
        React__default.createElement(EmptyTableRow, { message: isFavouriteContentEnabled ? contentStrings.emptyList : documentsStrings.emptyList, size: "lg" }));
};

const FavouriteContentScreen = props => {
    const isFavouriteContentEnabled = useFeatureToggles().isFeatureToggleEnabled('BOOKMARK_DOCUMENT_PAGES');
    const { favouriteContent, favouriteDocuments } = useStrings();
    const strings = isFavouriteContentEnabled ? favouriteContent : favouriteDocuments;
    const dispatch = useTypedDispatch();
    const [pageNumber, setPageNumber] = useState(0);
    const { sortKey, sortDirection } = useTypedSelector(selectFavouriteContentSortOrder);
    const currentVehicle = useTypedSelector(selectCurrentVehicle);
    usePageTitle(strings.title);
    const { data, isLoading, isFetching, error } = useGetFavouriteContentQuery({
        pageNumber,
        pageSize: config.paginationPageSize,
        sortKey,
        sortDirection,
        vehicle: props.forCurrentVehicle ? currentVehicle : null
    }, {
        refetchOnMountOrArgChange: true
    });
    useShowLoadingIndicator(isFetching && !isLoading);
    const paginator = usePaginator(data, setPageNumber);
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const scrollElement = useTokenScrollReset(String(pageNumber));
    const documents = data === null || data === void 0 ? void 0 : data.elements;
    const sortProps = React__default.useMemo(() => ({
        sortKey,
        sortDirection,
        onSort: (key, direction) => dispatch(setFavouriteContentSortOrder({
            sortKey: key,
            sortDirection: direction
        }))
    }), [dispatch, sortKey, sortDirection]);
    if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!documents) {
        return React__default.createElement(TableScreenSkeleton, { hasActions: true });
    }
    const header = React__default.createElement(ContentHeader, { columns: 2 },
        React__default.createElement(ContentHeader.Title, { title: strings.title }),
        React__default.createElement(Pagination, { paginator: paginator }));
    return React__default.createElement(Screen, { className: "FavouriteContentScreen", header: header, bottomPagination: React__default.createElement(Pagination, { paginator: paginator, centerHorizontally: true }), contentRef: scrollElement },
        React__default.createElement(PanelGrid, null,
            React__default.createElement(Panel, null,
                React__default.createElement(FavouriteContentTable, { documents: documents, sort: sortProps }))));
};

const LoadingScreenSkeleton = () => {
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(Screen, { header: React__default.createElement(ContentHeaderSkeleton, { hasRole: false }) },
            React__default.createElement("div", { className: "LoadingScreenSkeleton-content" },
                React__default.createElement(DocumentSkeleton, { hasRole: false }))));
};

function useModuleRoutes() {
    const { modules } = useContext();
    return useMemo(() => {
        var _a;
        function getRoutes(routes, render) {
            return routes.map(route => {
                var _a, _b, _c;
                const fallback = (_b = (_a = route.fallback) === null || _a === void 0 ? void 0 : _a.call(route)) !== null && _b !== void 0 ? _b : React__default.createElement(LoadingScreenSkeleton, null);
                return React__default.createElement(Route, { key: route.path, element: React__default.createElement(RouteAccess, { access: route.access }) },
                    React__default.createElement(Route, { path: route.path, element: React__default.createElement(Suspense, { fallback: fallback }, (_c = render(route)) !== null && _c !== void 0 ? _c : fallback) }));
            });
        }
        const routes = (_a = modules === null || modules === void 0 ? void 0 : modules.flatMap(mod => { var _a; return (_a = mod.routes) !== null && _a !== void 0 ? _a : []; })) !== null && _a !== void 0 ? _a : [];
        const mainRoutes = routes.flatMap(route => { var _a; return (_a = route.main) !== null && _a !== void 0 ? _a : []; });
        const vehicleRoutes = routes.flatMap(route => { var _a; return (_a = route.vehicle) !== null && _a !== void 0 ? _a : []; });
        return {
            main: {
                content: () => getRoutes(mainRoutes, route => route.component()),
                fallback: () => getRoutes(mainRoutes, route => { var _a; return (_a = route.fallback) === null || _a === void 0 ? void 0 : _a.call(route); })
            },
            vehicle: {
                content: vehicle => getRoutes(vehicleRoutes, route => route.component(vehicle)),
                fallback: () => getRoutes(vehicleRoutes, route => { var _a; return (_a = route.fallback) === null || _a === void 0 ? void 0 : _a.call(route); })
            }
        };
    }, [modules]);
}

const tabHeight = 28;
const tabWidth = 70;
const VehicleScreenSkeleton = ({ vehicle }) => {
    const header = React__default.createElement(ContentHeaderSkeleton, { hasRole: false },
        React__default.createElement("div", { className: "VehicleScreenSkeleton-tabs" },
            React__default.createElement(Skeleton, { height: tabHeight, width: tabWidth }),
            React__default.createElement(Skeleton, { height: tabHeight, width: tabWidth }),
            React__default.createElement(Skeleton, { height: tabHeight, width: tabWidth })));
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(Screen, { header: header }, vehicle ? React__default.createElement(VehicleTabsSkeleton, { vehicle: vehicle, hasRole: false }) : React__default.createElement(VehicleOverviewTabSkeleton, { hasRole: false })));
};

const SubscriptionsScreenSkeleton = () => {
    const { ref, width } = useElementWidth();
    const header = React__default.createElement(ContentHeaderSkeleton, { hasRole: false },
        React__default.createElement(Skeleton, { width: "35%" }));
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(Screen, { header: header },
            React__default.createElement(PanelGrid, null,
                React__default.createElement(PanelSkeleton, { hasTitle: false, hasRole: false },
                    React__default.createElement(Panel.Content, null,
                        React__default.createElement("div", { ref: ref, className: className$i(width > 600 ? 'filter' : 'compactFilter') },
                            React__default.createElement(Skeleton, { width: 100 }),
                            React__default.createElement(Skeleton, { variant: "rectangular", width: "100%", height: 36 }),
                            React__default.createElement(Skeleton, { width: 100 }),
                            React__default.createElement(Skeleton, { variant: "rectangular", width: "100%", height: 36 })))),
                React__default.createElement(Skeleton, { className: className$i('text'), width: "55%" }),
                React__default.createElement(PanelSkeleton, { hasRole: false },
                    React__default.createElement(TableSkeleton, { hasRole: false })))));
};
const className$i = createClassName('SubscriptionsScreenSkeleton');

const VehicleRouter = ({ vehicleRef }) => {
    const { vehicle: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const { data: vehicle, isLoading, isFetching, error } = useGetVehicleQuery(vehicleRef);
    const moduleRoutes = useModuleRoutes();
    useShowLoadingIndicator(isFetching && !isLoading);
    useEffect(() => {
        if (vehicle) {
            dispatch(makeSessionVehicle(vehicle));
        }
    }, [vehicle, dispatch]);
    const errorMessage = useApiErrorMessage(strings.loadError, error, {
        404: strings.notFound
    });
    if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    return React__default.createElement(VehicleContextProvider, { vehicle: vehicle !== null && vehicle !== void 0 ? vehicle : null },
        React__default.createElement(Routes, null,
            React__default.createElement(Route, { path: "groups/:groupId/*", element: vehicle ? React__default.createElement(DocumentGroupRouter, { vehicle: vehicle }) : React__default.createElement(TableScreenSkeleton, { hasActions: true }) }),
            React__default.createElement(Route, { path: "document-groups/:groupId", element: React__default.createElement(DocumentGroupsRedirect, null) }),
            React__default.createElement(Route, { path: "search/*", element: vehicle ? React__default.createElement(SearchRouter, { vehicle: vehicle }) : React__default.createElement(TableScreenSkeleton, { hasActions: true }) }),
            React__default.createElement(Route, { element: React__default.createElement(RouteAccess, { access: "users" }) },
                React__default.createElement(Route, { path: "documents/favourites", element: React__default.createElement(FavouriteContentScreen, { forCurrentVehicle: true }) }),
                React__default.createElement(Route, { path: "subscriptions/*", element: vehicle ? React__default.createElement(SubscriptionsRouter, { specificity: getVehicleSpecificity(vehicle) }) : React__default.createElement(SubscriptionsScreenSkeleton, null) })),
            React__default.createElement(Route, { path: "documents/:documentId/*", element: React__default.createElement(DocumentRouter, null) }),
            vehicle ? moduleRoutes.vehicle.content(vehicle) : moduleRoutes.vehicle.fallback(),
            React__default.createElement(Route, { path: "*", element: vehicle ? React__default.createElement(VehicleScreen, { vehicle: vehicle }) : React__default.createElement(VehicleScreenSkeleton, { vehicle: vehicleRef }) })));
};
const DocumentGroupsRedirect = () => {
    const { groupId } = useParams();
    return React__default.createElement(Navigate, { to: `../groups/${groupId}` });
};

const VinRouter = () => {
    const { vin } = useParams();
    const vehicleRef = useMemo(() => {
        if (vin) {
            return {
                ref: 'vin',
                vin
            };
        }
    }, [vin]);
    if (!vehicleRef) {
        return React__default.createElement(NotFoundScreen, null);
    }
    return React__default.createElement(VehicleRouter, { vehicleRef: vehicleRef });
};

var isIntExports$1 = {};
var isInt$1 = {
  get exports(){ return isIntExports$1; },
  set exports(v){ isIntExports$1 = v; },
};

var hasRequiredIsInt;

function requireIsInt () {
	if (hasRequiredIsInt) return isIntExports$1;
	hasRequiredIsInt = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = isInt;

		var _assertString = _interopRequireDefault(requireAssertString());

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
		var intLeadingZeroes = /^[-+]?[0-9]+$/;

		function isInt(str, options) {
		  (0, _assertString.default)(str);
		  options = options || {}; // Get the regex to use for testing, based on whether
		  // leading zeroes are allowed or not.

		  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes; // Check min/max/lt/gt

		  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
		  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
		  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
		  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
		  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
		}

		module.exports = exports.default;
		module.exports.default = exports.default;
} (isInt$1, isIntExports$1));
	return isIntExports$1;
}

var isIntExports = requireIsInt();
var isInt = /*@__PURE__*/getDefaultExportFromCjs(isIntExports);

const ProductRouter = () => {
    const location = useLocation();
    const { productVariantId } = useParams();
    // Include year segment only if year is an integer.
    const year = useMemo(() => {
        const yearMatch = matchPath({
            path: '/products/:productVariantId/:year/*'
        }, location.pathname);
        const yearString = yearMatch === null || yearMatch === void 0 ? void 0 : yearMatch.params.year;
        return yearString && isInt(yearString) ? toInt(yearString) : undefined;
    }, [location.pathname]);
    const vehicleRef = useMemo(() => {
        if (productVariantId && isNumeric(productVariantId)) {
            return {
                ref: 'product',
                productVariantId,
                year
            };
        }
    }, [productVariantId, year]);
    if (!vehicleRef) {
        return React__default.createElement(NotFoundScreen, null);
    }
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { path: year ? ':year/*' : '*', element: React__default.createElement(VehicleRouter, { vehicleRef: vehicleRef }) }));
};

const ProductCodeResolver = ({ code, year }) => {
    const { vehicle: strings } = useStrings();
    const navigation = useNavigation();
    const { data: vehicle, error } = useGetVehicleByCodeQuery({ code, year });
    const errorMessage = useApiErrorMessage(strings.loadError, error, {
        404: strings.notFound
    });
    if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    if (!vehicle) {
        return React__default.createElement(VehicleScreenSkeleton, null);
    }
    return React__default.createElement(Navigate, { to: navigation.vehicle(vehicle), replace: true });
};

const ProductCodeYearRoute = ({ code }) => {
    const { year } = useParams();
    if (!year || !isInt(year)) {
        return React__default.createElement(NotFoundScreen, null);
    }
    return React__default.createElement(ProductCodeResolver, { code: code, year: toInt(year) });
};

const ProductCodeRouter = () => {
    const { code } = useParams();
    if (!code) {
        return React__default.createElement(NotFoundScreen, null);
    }
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { path: ":year", element: React__default.createElement(ProductCodeYearRoute, { code: code }) }),
        React__default.createElement(Route, { path: "/", element: React__default.createElement(ProductCodeResolver, { code: code }) }),
        React__default.createElement(Route, { path: "*", element: React__default.createElement(NotFoundScreen, null) }));
};

const ProductsRouter = () => {
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { path: "codes/:code/*", element: React__default.createElement(ProductCodeRouter, null) }),
        React__default.createElement(Route, { path: ":productVariantId/*", element: React__default.createElement(ProductRouter, null) }),
        React__default.createElement(Route, { path: "*", element: React__default.createElement(NotFoundScreen, null) }));
};

const NoticeTableRow = ({ rowProps, isCompactTable, notice, onClick }) => {
    const content = React__default.createElement(React__default.Fragment, null,
        React__default.createElement(LinkButton, { variant: "title", onClick: onClick }, notice.title),
        React__default.createElement("div", { className: "NoticeTableRow-body" }, notice.body));
    return React__default.createElement(Table.Row, { className: "NoticeTableRow", rowProps: rowProps }, (() => {
        if (isCompactTable) {
            return React__default.createElement(MobileTableCell, { primary: content, date: React__default.createElement(DateText, { date: notice.date, dynamicFormat: DateText.DYNAMIC_SHORT, showTooltip: true }) });
        }
        else {
            return React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Table.TextCell, { primary: content }),
                React__default.createElement(Table.TextCell, { wrap: false },
                    React__default.createElement(DateText, { date: notice.date, format: DateText.DATE_LONG })));
        }
    })());
};

const NoticeTable = ({ notices }) => {
    const { notices: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const columns = useMemo(() => ([
        { id: 'notice', title: strings.noticeColumn, className: 'NoticeTable-notice' },
        { id: 'date', title: strings.dateColumn }
    ]), [strings.noticeColumn, strings.dateColumn]);
    function getRow(index) {
        const notice = notices[index];
        return {
            id: notice.id,
            component: NoticeTableRow,
            props: {
                notice,
                onClick: () => dispatch(showNotice(notice.id))
            }
        };
    }
    return React__default.createElement(Table, { className: "NoticeTable", columns: columns, rowCount: notices.length, compactHeader: createResponsiveValue(false).maxWidth(MOBILE_BREAKPOINT, true), getRow: getRow, onClick: rowIndex => dispatch(showNotice(notices[rowIndex].id)) },
        React__default.createElement(EmptyTableRow, { size: "lg", message: strings.emptyList }));
};

const NoticesScreen = () => {
    const { notices: strings } = useStrings();
    const [pageNumber, setPageNumber] = useState(0);
    usePageTitle(strings.title);
    const { data, isLoading, isFetching, error } = useGetNoticesQuery({
        pageNumber,
        pageSize: config.paginationPageSize
    });
    useShowLoadingIndicator(isFetching && !isLoading);
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const paginator = usePaginator(data, setPageNumber);
    const scrollElement = useTokenScrollReset(String(pageNumber));
    const notices = data === null || data === void 0 ? void 0 : data.elements;
    if (errorMessage) {
        return React__default.createElement(Screen, { errorText: errorMessage });
    }
    else if (!notices) {
        return React__default.createElement(TableScreenSkeleton, null);
    }
    const header = React__default.createElement(ContentHeader, { columns: 2 },
        React__default.createElement(ContentHeader.Title, { title: strings.title }),
        React__default.createElement(Pagination, { paginator: paginator }));
    return React__default.createElement(Screen, { className: "NoticesScreen", header: header, bottomPagination: React__default.createElement(Pagination, { paginator: paginator, centerHorizontally: true }), contentRef: scrollElement },
        React__default.createElement(PanelGrid, null,
            React__default.createElement(Panel, null,
                React__default.createElement(NoticeTable, { notices: notices }))));
};

/**
 * Map of external (ITIS) URLs to IWA URLs. Must start with a slash and not include the context path.
 */
const externalUrls = new Map([
    ['/legal/terms', '/terms'],
    ['/legal/privacy-policy', '/privacy'],
    ['/legal/cookie-policy', '/cookies'],
    ['/contact', '/contact?create=false'],
    ['/contact/createForm', '/contact?create=true'],
    ['/content/document/view', query => {
            if (query.id) {
                return `/documents/${query.id}`;
            }
        }]
]);
/**
 * Rewrites links from external (ITIS) URLs to IWA URLs. Only URLs in {@link externalUrls} will be rewritten.
 *
 * @param rootElement - Root element to search for links to rewrite.
 * @param key - Links will be rewritten again when this changes. Usually set to the HTML source.
 */
function useExternalLinkRewriter(rootElement, key) {
    const { itisUrl } = useContext();
    const navigate = useNavigate();
    useEffect(() => {
        if (rootElement.current === null) {
            return;
        }
        const itisUrlWithoutTrailingSlash = itisUrl.replace(/\/$/, '');
        const contextPath = new URL(itisUrlWithoutTrailingSlash).pathname;
        for (const link of Array.from(rootElement.current.querySelectorAll('a[href]'))) {
            const href = link.getAttribute('href');
            if (!href) {
                continue;
            }
            const { url, query } = queryString.parseUrl(href);
            let pathWithoutContext;
            if (url.startsWith(itisUrlWithoutTrailingSlash + '/')) {
                pathWithoutContext = url.substring(itisUrlWithoutTrailingSlash.length);
            }
            else if (url.startsWith(contextPath + '/')) {
                pathWithoutContext = url.substring(contextPath.length);
            }
            else {
                continue;
            }
            for (const [path, urlResolver] of Array.from(externalUrls)) {
                const match = matchPath({ path }, pathWithoutContext);
                if (!match) {
                    continue;
                }
                const newUrl = typeof urlResolver === 'function' ? urlResolver(query, match) : urlResolver;
                if (newUrl) {
                    link.setAttribute('href', newUrl);
                    link.addEventListener('click', event => {
                        // Use React Router history to prevent a full page reload.
                        event.preventDefault();
                        navigate(newUrl);
                    });
                    break;
                }
            }
        }
    }, [rootElement, itisUrl, navigate, key]);
}

/**
 * Component that provides additional styling for legal documents.
 *
 * @param props - Component props.
 */
const LegalDocumentView = ({ className, children }) => {
    const classes = classNames('LegalDocumentView', className);
    const rootElement = useRef(null);
    useExternalLinkRewriter(rootElement, children);
    return React__default.createElement(HtmlView, { className: classes, ref: rootElement }, children);
};

const LegalDocumentScreen = ({ documentType }) => {
    const { legal: strings } = useStrings();
    const { data: content, isFetching, error } = useGetLegalDocumentContentQuery(documentType, {
        refetchOnReconnect: true
    });
    const errorMessage = useApiErrorMessage(strings.documentLoadError, error);
    const contentElement = useNavigationScrollReset();
    const titles = useMemo(() => ({
        privacy: strings.privacyPolicy,
        terms: strings.termsAndConditions,
        cookies: strings.cookiePolicy
    }), [strings.privacyPolicy, strings.termsAndConditions, strings.cookiePolicy]);
    const title = titles[documentType];
    usePageTitle(title);
    const header = React__default.createElement(ContentHeader, null,
        React__default.createElement(ContentHeader.Title, { title: title }));
    return React__default.createElement(Screen, { className: "LegalDocumentScreen", header: header, errorText: errorMessage !== null && errorMessage !== void 0 ? errorMessage : undefined, contentRef: contentElement },
        React__default.createElement("div", { className: "LegalDocumentScreen-content" },
            React__default.createElement(Panel, null,
                React__default.createElement(Panel.Content, null, content && !isFetching
                    ? React__default.createElement(LegalDocumentView, { className: "LegalDocumentScreen-document" }, content)
                    : React__default.createElement(DocumentSkeleton, null)))));
};

const ScreenRouter = () => {
    const mandatoryLogin = useFeatureToggles().isFeatureToggleEnabled('MANDATORY_LOGIN');
    const moduleRoutes = useModuleRoutes();
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { element: React__default.createElement(RouteAccess, { access: "guests" }) },
            React__default.createElement(Route, { path: "/login", element: React__default.createElement(WelcomeScreen, null) })),
        React__default.createElement(Route, { element: React__default.createElement(RouteAccess, { access: "users" }) },
            React__default.createElement(Route, { path: "/", element: React__default.createElement(VehicleLookupScreen, null) }),
            React__default.createElement(Route, { path: "/documents/favourites", element: React__default.createElement(FavouriteContentScreen, { forCurrentVehicle: false }) }),
            React__default.createElement(Route, { path: "/messages/*", element: React__default.createElement(MessagesRouter, null) }),
            React__default.createElement(Route, { path: "/notices", element: React__default.createElement(NoticesScreen, null) }),
            React__default.createElement(Route, { path: "/subscriptions/*", element: React__default.createElement(SubscriptionsRouter, { specificity: getGlobalSpecificity() }) })),
        React__default.createElement(Route, { element: React__default.createElement(RouteAccess, { access: mandatoryLogin ? 'users' : 'all' }) },
            React__default.createElement(Route, { path: "/lookup", element: React__default.createElement(GuestLookupScreen, null) }),
            React__default.createElement(Route, { path: "/vehicles/:vin/*", element: React__default.createElement(VinRouter, null) }),
            React__default.createElement(Route, { path: "/products/*", element: React__default.createElement(ProductsRouter, null) }),
            React__default.createElement(Route, { path: "/groups/:groupId/*", element: React__default.createElement(DocumentGroupRouter, { vehicle: null, fromSearchViaDocumentGroup: true }) }),
            React__default.createElement(Route, { path: "/search/*", element: React__default.createElement(SearchRouter, { vehicle: null }) })),
        React__default.createElement(Route, { path: "/documents/:documentId/*", element: React__default.createElement(DocumentRouter, null) }),
        React__default.createElement(Route, { path: "/account/*", element: React__default.createElement(AccountRouter, null) }),
        React__default.createElement(Route, { path: "/privacy", element: React__default.createElement(LegalDocumentScreen, { documentType: "privacy" }) }),
        React__default.createElement(Route, { path: "/terms", element: React__default.createElement(LegalDocumentScreen, { documentType: "terms" }) }),
        React__default.createElement(Route, { path: "/cookies", element: React__default.createElement(LegalDocumentScreen, { documentType: "cookies" }) }),
        moduleRoutes.main.content(),
        React__default.createElement(Route, { path: "*", element: React__default.createElement(NotFoundScreen, null) }));
};

const LanguageSelectItem = ({ title, isSelected, onClick }) => {
    const classes = classNames('LanguageSelectItem', {
        'LanguageSelectItem-selected': isSelected
    });
    return React__default.createElement("button", { className: classes, "aria-current": isSelected, onClick: onClick },
        title,
        isSelected && React__default.createElement(FontAwesomeIcon, { icon: faCheckExports.faCheck, size: "sm" }));
};

const LanguageSelectDialogue = ({ isOpen, onClose }) => {
    const { language: strings } = useStrings();
    const supportedLanguages = useSupportedBaseLanguages();
    const locale = useTypedSelector(selectLocale);
    const dispatch = useTypedDispatch();
    const { getOnlineMessage } = useOnlineStatus();
    function changeLanguage(language) {
        return __awaiter(this, void 0, void 0, function* () {
            const newLocale = getLocaleCode(language, getOptionalLanguageCode(locale));
            try {
                yield dispatch(updateLocale(newLocale)).unwrap();
                window.location.reload();
            }
            catch (_a) {
                dispatch(queueNotification(getOnlineMessage(strings.errorChangingLanguage)));
            }
            onClose();
        });
    }
    return React__default.createElement(Dialogue, { className: className$h(), ariaLabel: strings.changeLanguageTitle, isOpen: isOpen, onClose: onClose },
        React__default.createElement(Dialogue.Header, { title: strings.changeLanguageTitle, onClose: onClose }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement("ul", { className: className$h('languages') }, supportedLanguages.map(({ code, name }) => React__default.createElement("li", { key: code },
                React__default.createElement(LanguageSelectItem, { title: name, isSelected: code === getPrimaryLanguageCode(locale), onClick: () => changeLanguage(code) }))))));
};
const className$h = createClassName('LanguageSelectDialogue');

function parseCountryOptions(countryNames) {
    return Object.entries(countryNames !== null && countryNames !== void 0 ? countryNames : [])
        .map(([id, label]) => ({ id, label }))
        .sort((a, b) => a.label.localeCompare(b.label));
}
function useCountries({ preSelectDefaultOption }) {
    const countryNames = useCountryNames();
    const locale = useTypedSelector(selectLocale);
    const options = useMemo(() => {
        return parseCountryOptions(countryNames);
    }, [countryNames]);
    const value = useMemo(() => {
        var _a;
        return preSelectDefaultOption ?
            (_a = options.find(option => option.id === getOptionalLanguageCode(locale))) !== null && _a !== void 0 ? _a : options[0]
            : undefined;
    }, [preSelectDefaultOption, options, locale]);
    return {
        options,
        value
    };
}

const CountrySelectDialogue = ({ isOpen, onClose }) => {
    const strings = useStrings();
    const canChangeOwnCountry = useCanChangeOwnCountry();
    const locale = useTypedSelector(selectLocale);
    const dispatch = useTypedDispatch();
    const { getOnlineMessage } = useOnlineStatus();
    const { value, options } = useCountries({ preSelectDefaultOption: true });
    function changeCountry(country) {
        return __awaiter(this, void 0, void 0, function* () {
            const newLocale = getLocaleCode(getPrimaryLanguageCode(locale), country);
            try {
                yield dispatch(updateLocale(newLocale)).unwrap();
                window.location.reload();
            }
            catch (_a) {
                dispatch(queueNotification(getOnlineMessage(strings.language.errorChangingCountry)));
            }
            onClose();
        });
    }
    return React__default.createElement(Dialogue, { className: className$g(), ariaLabel: strings.language.changeCountryTitle, isOpen: isOpen, onClose: onClose },
        React__default.createElement(Dialogue.Header, { title: strings.language.changeCountryTitle, onClose: onClose }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement("div", { className: className$g('content') },
                !canChangeOwnCountry && React__default.createElement(Panel, { variant: "info" },
                    React__default.createElement(Panel.Content, null, strings.language.cannotChangeCountry)),
                React__default.createElement(Autocomplete$1, { options: options, value: value, isOptionEqualToValue: (option, value) => option.id === value.id, onChange: (_event, value) => changeCountry(value.id), renderInput: params => React__default.createElement(TextField$1, Object.assign({}, params)), disabled: !canChangeOwnCountry, disableClearable: true, openOnFocus: true, role: "combobox", "aria-label": strings.preferences.country.label, openText: strings.buttons.open, closeText: strings.buttons.close }))));
};
const className$g = createClassName('CountrySelectDialogue');

const SidebarLanguageSelect = () => {
    var _a, _b, _c;
    const [isLanguageDialogueOpen, setIsLanguageDialogueOpen] = useState(false);
    const [isCountryDialogueOpen, setIsCountryDialogueOpen] = useState(false);
    const locale = useTypedSelector(selectLocale);
    const { language: strings } = useStrings();
    const languages = useSupportedBaseLanguages();
    const countryNames = useCountryNames();
    const languageName = (_b = (_a = languages.find(language => language.code === getPrimaryLanguageCode(locale))) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : strings.unknownLanguage;
    const countryName = countryNames ? ((_c = countryNames[getOptionalLanguageCode(locale)]) !== null && _c !== void 0 ? _c : strings.unknownCountry) : '';
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: className$f() },
            React__default.createElement(LinkButton, { className: className$f('language'), preventIfOffline: true, onClick: () => setIsLanguageDialogueOpen(true) },
                React__default.createElement(FontAwesomeIcon, { icon: faGlobeExports.faGlobe, size: "sm" }),
                languageName),
            React__default.createElement(LinkButton, { className: className$f('country'), preventIfOffline: true, onClick: () => setIsCountryDialogueOpen(true) }, countryName)),
        React__default.createElement(LanguageSelectDialogue, { isOpen: isLanguageDialogueOpen, onClose: () => setIsLanguageDialogueOpen(false) }),
        React__default.createElement(CountrySelectDialogue, { isOpen: isCountryDialogueOpen, onClose: () => setIsCountryDialogueOpen(false) }));
};
const className$f = createClassName('SidebarLanguageSelect');

var faChevronCircleLeft = {};

var hasRequiredFaChevronCircleLeft;

function requireFaChevronCircleLeft () {
	if (hasRequiredFaChevronCircleLeft) return faChevronCircleLeft;
	hasRequiredFaChevronCircleLeft = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'chevron-circle-left';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f137';
		var svgPathData = 'M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faChevronCircleLeft = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faChevronCircleLeft));
	return faChevronCircleLeft;
}

var faChevronCircleLeftExports = requireFaChevronCircleLeft();

const SidebarOldLookLink = () => {
    const { sidebar: strings } = useStrings();
    const isTryingNewLook = useFeatureToggles().isFeatureToggleEnabled('TRY_NEW_LOOK');
    if (!isTryingNewLook) {
        return null;
    }
    return React__default.createElement(Link$1, { className: "SidebarOldLookLink", href: getOldLookUrl(), preventIfOffline: true },
        React__default.createElement(FontAwesomeIcon, { icon: faChevronCircleLeftExports.faChevronCircleLeft, size: "sm" }),
        " ",
        strings.backToOldLook);
};

var CookiePreference;
(function (CookiePreference) {
    CookiePreference["NewRelic"] = "new_relic_enabled";
})(CookiePreference || (CookiePreference = {}));
const COOKIE_CONSENT_KEY = 'cookie_consent';
function showCookieNotification() {
    return localStorage.getItem(COOKIE_CONSENT_KEY) !== 'true';
}
function agreeCookiePolicy() {
    localStorage.setItem(COOKIE_CONSENT_KEY, String(true));
}
function saveCookiePreferences(key, value) {
    localStorage.setItem(key, String(value));
}
function getCookiePreference(key) {
    return localStorage.getItem(key) === 'true';
}

const CookiePreferencesDialogue = ({ isOpen, onClose }) => {
    const { legal: strings } = useStrings();
    const enableNewRelic = useTickBox({
        id: CookiePreference.NewRelic,
        label: strings.cookie.preference.newRelic,
        value: getCookiePreference(CookiePreference.NewRelic) || showCookieNotification()
    });
    function onAgree() {
        saveCookiePreferences(CookiePreference.NewRelic, enableNewRelic.value);
        agreeCookiePolicy();
        window.location.reload();
    }
    return React__default.createElement(ConfirmDialogue, { title: strings.cookiePolicy, isOpen: isOpen, onCancel: onClose, onConfirm: onAgree, confirmTitle: showCookieNotification() ? strings.termsAgreeButton : strings.termsSaveButton },
        React__default.createElement("div", { className: "CookiePreferencesDialogue" },
            React__default.createElement(Text, { element: "p" }, strings.cookie.para1),
            React__default.createElement("p", null,
                strings.cookie.para2,
                React__default.createElement(Text, { onLinkClick: onClose }, strings.cookie.para3('/cookies'))),
            enableNewRelic.input));
};

const SidebarFooter = ({ children }) => {
    const [cookiesDialogueOpen, setCookiesDialogueOpen] = useState(false);
    const [versionInfo, setVersionInfo] = useState('');
    const strings = useStrings();
    const navigation = useNavigation();
    const { showItisVersion } = useContext();
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (showItisVersion) {
                const { actualVersion } = yield getVersionInfo();
                actualVersion && setVersionInfo(actualVersion);
            }
        }))();
    }, [showItisVersion]);
    return React__default.createElement("footer", { className: "SidebarFooter" },
        React__default.createElement(CookiePreferencesDialogue, { isOpen: cookiesDialogueOpen, onClose: () => setCookiesDialogueOpen(false) }),
        React__default.createElement("div", { className: "SidebarFooter-content" },
            React__default.createElement("div", { className: "SidebarFooter-text" },
                React__default.createElement(SidebarLanguageSelect, null),
                React__default.createElement(SidebarOldLookLink, null),
                React__default.createElement("div", { className: "SidebarFooter-links" },
                    React__default.createElement(Link$1, { href: "/terms" }, strings.footer.terms),
                    React__default.createElement(Link$1, { href: "/privacy" }, strings.footer.privacy),
                    React__default.createElement("button", { onClick: () => setCookiesDialogueOpen(true) }, strings.footer.cookies),
                    React__default.createElement(Link$1, { href: navigation.contact(), preventIfOffline: true }, strings.footer.contact)),
                React__default.createElement("div", { className: "SidebarFooter-copyright" }, strings.footer.copyright(new Date().getFullYear())),
                showItisVersion && React__default.createElement("div", { className: "SidebarFooter-appInfo" }, `${strings.app.name} | ${versionInfo}`)),
            children));
};

const SidebarSection = ({ className, children }) => {
    const classes = classNames('SidebarSection', className);
    return React__default.createElement("div", { className: classes }, children);
};

const SidebarSectionItem = ({ selected, className, children }) => {
    const classes = classNames('SidebarSectionItem', className, {
        'SidebarSectionItem-selected': selected
    });
    return React__default.createElement("div", { className: classes }, children);
};

const SidebarVehicle = () => {
    const { vehicle: strings } = useStrings();
    const navigation = useNavigation();
    const location = useLocation();
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const vinResolver = useVinResolver();
    if (!vehicle) {
        return null;
    }
    const url = navigation.vehicle(vehicle);
    const selected = location.pathname === url || location.pathname.startsWith(url + '/');
    return React__default.createElement(SidebarSection, { className: "SidebarVehicle" },
        React__default.createElement(SidebarSectionItem, { selected: selected },
            React__default.createElement("div", { className: "SidebarVehicle-text" },
                React__default.createElement(Link, { to: url, className: "SidebarVehicle-name" },
                    vehicle.name,
                    " ",
                    vehicle.year && `(${vehicle.year})`),
                vehicle.code && React__default.createElement("div", { className: "SidebarVehicle-model" }, vehicle.code),
                vehicle.ref === 'vin' && React__default.createElement("div", { className: "SidebarVehicle-vin" }, vinResolver(vehicle.vin))),
            vehicle.imageUrl && React__default.createElement("img", { src: vehicle.imageUrl, className: "SidebarVehicle-image", alt: strings.imageAlt })));
};

// Remove the 'level' prop from the exported component as we want to start from 1.
function Accordion(props) {
    return React__default.createElement(AccordionComponent, { items: props.items, level: 1, className: props.className, scrollIntoViewId: props.scrollIntoViewId, getItem: props.getItem });
}
function AccordionComponent(props) {
    const classes = classNames('Accordion', {
        [`${props.className}`]: props.className && props.level === 1 // Only add user classes at the root level.
    });
    return React__default.createElement("ul", { role: props.level === 1 ? 'tree' : 'group', className: classes }, props.items.map(props.getItem).map(item => React__default.createElement(AccordionItemComponent, { key: item.id, level: props.level, className: props.className, scrollIntoViewId: props.scrollIntoViewId, getItem: props.getItem, id: item.id, title: item.title, isSelected: item.isSelected, isExpanded: item.isExpanded, element: item.element }, item.children)));
}
function AccordionItemComponent(props) {
    const element = useRef(null);
    const [haveHandledScrollIntoView, setHaveHandledScrollIntoView] = useState(false);
    const classes = classNames(`Accordion-level-${props.level}`, {
        'Accordion-selected': props.isSelected,
        'Accordion-expanded': props.isExpanded
    });
    useLayoutEffect(() => {
        var _a;
        if (!haveHandledScrollIntoView && props.scrollIntoViewId === props.id) {
            (_a = element.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ block: 'center' });
        }
        setHaveHandledScrollIntoView(true);
    }, [haveHandledScrollIntoView, props.scrollIntoViewId, props.id]);
    return React__default.createElement("li", { role: "treeitem", ref: element, className: classes, title: props.title, "aria-current": props.isSelected, "aria-expanded": props.isExpanded },
        props.element,
        props.children && props.isExpanded && React__default.createElement(AccordionComponent, { items: props.children, level: props.level + 1, className: props.className, scrollIntoViewId: props.scrollIntoViewId, getItem: props.getItem }));
}

const SidebarDocumentGroup = props => {
    const { documentGroups: strings } = useStrings();
    const title = props.isExpanded ? strings.collapse : strings.expand;
    function onExpandCollapse(event) {
        var _a;
        event.stopPropagation();
        (_a = props.onExpandCollapse) === null || _a === void 0 ? void 0 : _a.call(props);
    }
    function onLinkClick() {
        var _a;
        if (props.canExpand && (!props.isExpanded || props.isSelected)) {
            (_a = props.onExpandCollapse) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    }
    const buttonContent = React__default.createElement(React__default.Fragment, null,
        props.title,
        props.count !== undefined && React__default.createElement("span", { className: className$e('count') },
            "(",
            props.count,
            ")"),
        props.adornment !== undefined && React__default.createElement("span", { className: className$e('adornment') }, props.adornment));
    return React__default.createElement(SidebarSectionItem, { className: className$e(), selected: props.isSelected },
        props.shouldLinkToList ?
            React__default.createElement(Link$1, { href: props.url, className: className$e('button'), ariaLabel: props.title, onClick: onLinkClick }, buttonContent) :
            React__default.createElement("button", { className: className$e('button'), "aria-label": props.title, onClick: onExpandCollapse }, buttonContent),
        props.canExpand && React__default.createElement("button", { className: className$e('expand'), title: title, "aria-label": title, onClick: onExpandCollapse },
            React__default.createElement(FontAwesomeIcon, { icon: props.isExpanded ? faChevronDownExports.faChevronDown : faChevronRightExports.faChevronRight, size: "1x" })));
};
const className$e = createClassName('SidebarDocumentGroup');

function useDocumentGroupTree({ groups, getGroupUrl, resetKey }) {
    const location = useLocation();
    const groupMatchId = useDocumentGroupMatch();
    const [expandedIds, setExpandedIds] = useState([]);
    const selectedGroupId = useMemo(() => {
        function findSelectedGroupId(groups) {
            for (const group of groups) {
                const { url } = queryString.parseUrl(getGroupUrl(group));
                if (url === location.pathname || url === window.location.origin + location.pathname) {
                    return group.id;
                }
                if (group.children) {
                    const groupId = findSelectedGroupId(group.children);
                    if (groupId) {
                        return groupId;
                    }
                }
            }
            return null;
        }
        if (groupMatchId) {
            return groupMatchId;
        }
        if (groups) {
            return findSelectedGroupId(groups);
        }
        return null;
    }, [getGroupUrl, groups, location.pathname, groupMatchId]);
    useEffect(() => {
        setExpandedIds([]);
    }, [resetKey]);
    // Expand the selected group.
    useEffect(() => {
        if (groups && selectedGroupId) {
            setExpandedIds(expandedIds => {
                function expandPath(tree, groupId) {
                    const group = tree.find(group => {
                        return group.id === groupId || (group.children && expandPath(group.children, groupId));
                    });
                    if (group) {
                        expandedIds = expandedIds.concat(group.id);
                        return true;
                    }
                    return false;
                }
                expandPath(groups, selectedGroupId);
                return expandedIds;
            });
        }
    }, [selectedGroupId, groups]);
    return useMemo(() => ({
        selectedGroupId,
        expandGroup(groupId) {
            if (!expandedIds.includes(groupId)) {
                setExpandedIds(expandedIds.concat(groupId));
            }
        },
        collapseGroup(groupId) {
            if (expandedIds.includes(groupId)) {
                setExpandedIds(expandedIds.filter(id => id !== groupId));
            }
        },
        isGroupExpanded(groupId) {
            return expandedIds.includes(groupId);
        }
    }), [expandedIds, selectedGroupId]);
}

const SearchDocumentGroups = ({ params, groups, matchCount }) => {
    const { documentSearch: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const navigation = useNavigation();
    const navigate = useNavigate();
    const currentVehicle = useTypedSelector(selectCurrentVehicle);
    const getGroupUrl = useCallback((item) => {
        return navigation.documentSearch(Object.assign(Object.assign({}, params), { groupId: item.id }), params.vehicle);
    }, [navigation, params]);
    const { selectedGroupId, expandGroup, collapseGroup, isGroupExpanded } = useDocumentGroupTree({
        groups,
        getGroupUrl,
        resetKey: `${params.query}-${params.vehicle ? getVehicleId(params.vehicle) : ''}`
    });
    function clearSearch() {
        dispatch(clearDocumentSearch());
        // Calling navigator.home() while a vehicle is in session will clear that vehicle from being in session
        // We should instead navigate back to the vehicle overview view if there's currently a vehicle in session
        navigate(currentVehicle ? navigation.vehicle(currentVehicle) : navigation.home());
    }
    const allDocumentsUrl = navigation.documentSearch(Object.assign(Object.assign({}, params), { groupId: null }), params.vehicle);
    const isAllDocumentsSelected = selectedGroupId === null;
    const allDocumentsItem = {
        id: 'all',
        title: strings.allDocuments,
        isSelected: isAllDocumentsSelected,
        element: React__default.createElement(SidebarDocumentGroup, { shouldLinkToList: true, url: allDocumentsUrl, title: strings.allDocuments, count: matchCount, isSelected: isAllDocumentsSelected })
    };
    function getItem(item) {
        const canExpand = item.children && item.children.length > 0;
        const isExpanded = canExpand && isGroupExpanded(item.id);
        const isSelected = item.id === selectedGroupId;
        return {
            id: item.id,
            title: item.name,
            isSelected,
            isExpanded,
            children: item.children,
            element: React__default.createElement(SidebarDocumentGroup, { url: getGroupUrl(item), title: item.name, count: item.treeMatchCount, shouldLinkToList: true, canExpand: canExpand, isExpanded: isExpanded, isSelected: isSelected, onExpandCollapse: () => isExpanded ? collapseGroup(item.id) : expandGroup(item.id) })
        };
    }
    return React__default.createElement("div", { className: "SearchDocumentGroups" },
        React__default.createElement("div", { className: "SearchDocumentGroups-header" },
            React__default.createElement("button", { className: "SearchDocumentGroups-button", onClick: () => dispatch(focusDocumentSearch()) },
                React__default.createElement(FontAwesomeIcon, { icon: faSearchExports.faSearch, size: "1x" }),
                React__default.createElement("span", { className: "SearchDocumentGroups-query" }, params.query)),
            React__default.createElement("button", { className: "SearchDocumentGroups-clear", title: strings.clearSearch, "aria-label": strings.clearSearch, onClick: clearSearch },
                React__default.createElement(FontAwesomeIcon, { icon: faTimesExports.faTimes, size: "1x" }))),
        React__default.createElement(Accordion, { items: [1], getItem: () => allDocumentsItem }),
        React__default.createElement(Accordion, { items: groups, getItem: getItem, scrollIntoViewId: selectedGroupId !== null && selectedGroupId !== void 0 ? selectedGroupId : undefined }));
};

const VehicleDocumentGroups = ({ vehicle, groups }) => {
    const navigation = useNavigation();
    const location = useLocation();
    const { vehicleDocumentGroupsItemAdornment = {} } = useContext();
    const getGroupUrl = useCallback((item) => {
        const groupUrl = navigation.vehicleDocumentGroup(vehicle, item.id);
        return item.shortcutToDoc
            ? navigation.document({
                id: item.shortcutToDoc.documentId,
                documentTypeContentType: item.shortcutToDoc.type,
                vehicle,
                groupId: item.id,
                search: null
            })
            : groupUrl;
    }, [navigation, vehicle]);
    const { selectedGroupId, expandGroup, collapseGroup, isGroupExpanded } = useDocumentGroupTree({
        groups,
        getGroupUrl,
        resetKey: getVehicleId(vehicle)
    });
    function getItem(item) {
        var _a;
        const canExpand = item.children && item.children.length > 0;
        const isExpanded = canExpand && isGroupExpanded(item.id);
        const isSelected = item.id === selectedGroupId;
        const adornment = (_a = vehicleDocumentGroupsItemAdornment[item.id]) === null || _a === void 0 ? void 0 : _a.call(vehicleDocumentGroupsItemAdornment, location.pathname);
        return {
            id: item.id,
            title: item.name,
            isSelected,
            isExpanded,
            children: item.children,
            element: React__default.createElement(SidebarDocumentGroup, { url: getGroupUrl(item), title: item.name, canExpand: canExpand, shouldLinkToList: item.documentCount !== 0, isExpanded: isExpanded, isSelected: isSelected, onExpandCollapse: () => isExpanded ? collapseGroup(item.id) : expandGroup(item.id), adornment: adornment })
        };
    }
    if (groups.length === 0) {
        return null;
    }
    return React__default.createElement("div", { className: "VehicleDocumentGroups" },
        React__default.createElement(Accordion, { items: groups, getItem: getItem, scrollIntoViewId: selectedGroupId !== null && selectedGroupId !== void 0 ? selectedGroupId : undefined }));
};

const DocumentGroups = () => {
    const { documentGroups: strings } = useStrings();
    const navigation = useNavigation();
    const { currentData, isFetching, error } = useGetDocumentGroupsQuery({ vehicle: null, treeStructure: true });
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    const getGroupUrl = useCallback((item) => {
        if (item.link) {
            return item.link;
        }
        const groupUrl = navigation.documentGroup(item.id);
        return item.shortcutToDoc
            ? navigation.document({
                id: item.shortcutToDoc.documentId,
                documentTypeContentType: item.shortcutToDoc.type,
                groupId: item.id,
                vehicle: null,
                search: null
            })
            : groupUrl;
    }, [navigation]);
    const { selectedGroupId, expandGroup, collapseGroup, isGroupExpanded } = useDocumentGroupTree({
        groups: currentData === null || currentData === void 0 ? void 0 : currentData.groups,
        getGroupUrl
    });
    function getItem(item) {
        const canExpand = item.children && item.children.length > 0;
        const isExpanded = canExpand && isGroupExpanded(item.id);
        const isSelected = item.id === selectedGroupId;
        return {
            id: item.id,
            title: item.name,
            isSelected,
            isExpanded,
            children: item.children,
            element: React__default.createElement(SidebarDocumentGroup, { url: getGroupUrl(item), title: item.name, canExpand: canExpand, shouldLinkToList: Boolean(item.link) || item.documentCount !== 0, isExpanded: isExpanded, isSelected: isSelected, onExpandCollapse: () => isExpanded ? collapseGroup(item.id) : expandGroup(item.id) })
        };
    }
    if (errorMessage) {
        return React__default.createElement("div", { className: className$d('error') }, errorMessage);
    }
    if (isFetching) {
        return React__default.createElement(SkeletonContainer, { className: className$d('loading') },
            React__default.createElement(Skeleton$1, { width: 120, height: 24 }),
            React__default.createElement(Skeleton$1, { width: 200, height: 24 }),
            React__default.createElement(Skeleton$1, { width: 150, height: 24 }));
    }
    if (!(currentData === null || currentData === void 0 ? void 0 : currentData.groups) || (currentData === null || currentData === void 0 ? void 0 : currentData.groups.length) === 0) {
        return null;
    }
    return React__default.createElement("div", { className: className$d() },
        React__default.createElement(Accordion, { items: currentData === null || currentData === void 0 ? void 0 : currentData.groups, getItem: getItem, scrollIntoViewId: selectedGroupId !== null && selectedGroupId !== void 0 ? selectedGroupId : undefined }));
};
const className$d = createClassName('DocumentGroups');

const SidebarDocumentGroups = () => {
    const { documentGroups: strings } = useStrings();
    const vehicle = useTypedSelector(selectCurrentVehicle, shallowEqual);
    const searchParams = useTypedSelector(selectActiveSearchParams);
    const { currentData: vehicleGroups, isFetching: isVehicleGroupsFetching, error: vehicleGroupsError } = useGetDocumentGroupsQuery(vehicle ? { vehicle } : queryExports.skipToken, {
        refetchOnMountOrArgChange: 60 * 60 // Force refresh every hour.
    });
    const { data: searchGroups, isFetching: isSearchGroupsFetching, error: searchGroupsError } = useSearchDocumentsQuery(searchParams !== null && searchParams !== void 0 ? searchParams : queryExports.skipToken);
    const errorMessage = useApiErrorMessage(strings.loadError, vehicleGroupsError !== null && vehicleGroupsError !== void 0 ? vehicleGroupsError : searchGroupsError);
    const isLoadingNewSearchQuery = useIsLoadingWithDifferentKey(isSearchGroupsFetching, (searchParams === null || searchParams === void 0 ? void 0 : searchParams.query) ? [searchParams.query] : []);
    const { showNonVehicleSidebarDocumentGroups } = useContext();
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const isDocumentGroupSearchEnabled = useFeatureToggles().isFeatureToggleEnabled('SEARCH_VIA_DOCUMENT_GROUP');
    const content = (() => {
        if (errorMessage) {
            return React__default.createElement("div", { className: className$c('error') }, errorMessage);
        }
        if (isLoadingNewSearchQuery || isVehicleGroupsFetching) {
            return React__default.createElement(SkeletonContainer, { className: className$c('loading') },
                React__default.createElement(Skeleton$1, { width: 120, height: 24 }),
                React__default.createElement(Skeleton$1, { width: 200, height: 24 }),
                React__default.createElement(Skeleton$1, { width: 150, height: 24 }));
        }
        if (searchParams && searchGroups) {
            return React__default.createElement(SearchDocumentGroups, { params: searchParams, groups: searchGroups.groups, matchCount: searchGroups.matchCount });
        }
        if (!searchParams && vehicle && vehicleGroups && vehicleGroups.groups.length > 0) {
            return React__default.createElement(VehicleDocumentGroups, { vehicle: vehicle, groups: vehicleGroups.groups });
        }
        if (showNonVehicleSidebarDocumentGroups && isDocumentGroupSearchEnabled && isLoggedIn && !searchParams && !vehicle) {
            return React__default.createElement(DocumentGroups, null);
        }
    })();
    return content ? React__default.createElement(SidebarSection, { className: className$c() }, content) : null;
};
const className$c = createClassName('SidebarDocumentGroups');

function useGroupedModuleSidebarItems() {
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const filterVisibility = useMemo(() => (item) => {
        return !item.visibility || item.visibility === 'all' ||
            (item.visibility === 'users' && isLoggedIn) ||
            (item.visibility === 'guests' && !isLoggedIn);
    }, [isLoggedIn]);
    const items = useModuleSidebarItems().filter(filterVisibility);
    const vehicleItems = useModuleVehicleSidebarItems(vehicle).filter(filterVisibility);
    const groupItems = useCallback((items) => {
        const groups = new Map();
        items.forEach(item => {
            var _a;
            const groupKey = (_a = item.group) !== null && _a !== void 0 ? _a : '';
            const group = groups.get(groupKey);
            if (group) {
                group.push(item);
            }
            else {
                groups.set(groupKey, [item]);
            }
        });
        return Array.from(groups.entries());
    }, []);
    return useMemo(() => ({
        topGroups: groupItems(items.filter(item => item.position === 'top' && item.group)),
        topItems: items.filter(item => item.position === 'top' && !item.group),
        bottomItems: items.filter(item => (!item.position || item.position === 'bottom') && !item.group),
        bottomGroups: groupItems(items.filter(item => (!item.position || item.position === 'bottom') && item.group)),
        vehicleGroups: groupItems(vehicleItems)
    }), [items, vehicleItems, groupItems]);
}

const SidebarSectionLink = ({ href, title, preventIfOffline, ariaLabel, children, shouldUseNewTabIcon }) => {
    const location = useLocation();
    const classes = classNames(className$b(), {
        [className$b('custom')]: typeof children !== 'string'
    });
    const selected = useMemo(() => {
        const { url } = queryString.parseUrl(href);
        return url === location.pathname;
    }, [href, location.pathname]);
    return React__default.createElement(SidebarSectionItem, { className: classes, selected: selected },
        React__default.createElement(Link$1, { href: href, title: title, ariaLabel: ariaLabel, preventIfOffline: preventIfOffline }, children),
        shouldUseNewTabIcon && React__default.createElement(Link$1, { openInNewTab: true, href: href, title: title, ariaLabel: ariaLabel },
            React__default.createElement(FontAwesomeIcon, { icon: faExternalLinkAltExports.faExternalLinkAlt, size: "1x" })));
};
const className$b = createClassName('SidebarSectionLink');

const ModuleSidebarItem = ({ item }) => {
    var _a;
    const content = (_a = item.content) === null || _a === void 0 ? void 0 : _a.call(item);
    return React__default.createElement(SidebarSectionLink, { href: item.href, ariaLabel: content ? item.title : undefined, shouldUseNewTabIcon: item.shouldUseNewTabIcon }, content !== null && content !== void 0 ? content : item.title);
};

const ModuleSidebarItemGroups = ({ groups }) => {
    return React__default.createElement(React__default.Fragment, null, groups.map(([group, items]) => React__default.createElement(SidebarSection, { key: group },
        React__default.createElement("ul", null, items.map(item => React__default.createElement("li", { key: item.href },
            React__default.createElement(ModuleSidebarItem, { item: item })))))));
};

const SidebarContent = () => {
    const { sidebar: strings, welcome: welcomeStrings } = useStrings();
    const navigation = useNavigation();
    const loggedIn = useTypedSelector(selectIsLoggedIn);
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const search = useTypedSelector(selectActiveSearchParams);
    const locale = useTypedSelector(selectLocale);
    const mandatoryLogin = useFeatureToggles().isFeatureToggleEnabled('MANDATORY_LOGIN');
    const awsCognitoLogin = useFeatureToggles().isFeatureToggleEnabled('AWS_COGNITO_AUTHENTICATION');
    const { topGroups, topItems, bottomItems, bottomGroups, vehicleGroups } = useGroupedModuleSidebarItems();
    return React__default.createElement("div", { className: "SidebarContent" },
        React__default.createElement(ModuleSidebarItemGroups, { groups: topGroups }),
        React__default.createElement(SidebarSection, null,
            React__default.createElement("ul", null,
                topItems.map(item => React__default.createElement("li", { key: item.href },
                    React__default.createElement(ModuleSidebarItem, { item: item }))),
                loggedIn && React__default.createElement("li", null,
                    React__default.createElement(SidebarSectionLink, { href: "/", shouldUseNewTabIcon: true }, strings.vehicleLookup)),
                !loggedIn && React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("li", null,
                        React__default.createElement(SidebarSectionLink, { href: navigation.login() }, strings.logIn)),
                    !awsCognitoLogin && React__default.createElement("li", null,
                        React__default.createElement(SidebarSectionLink, { href: getRegisterUrl(locale), preventIfOffline: welcomeStrings.cannotRegisterOffline }, strings.register)),
                    !mandatoryLogin && React__default.createElement("li", null,
                        React__default.createElement(SidebarSectionLink, { href: "/lookup", preventIfOffline: true }, strings.searchByVin))),
                bottomItems.map(item => React__default.createElement("li", { key: item.href },
                    React__default.createElement(ModuleSidebarItem, { item: item }))))),
        React__default.createElement(ModuleSidebarItemGroups, { groups: bottomGroups }),
        (search && !search.vehicle && vehicle) && React__default.createElement(SidebarSection, null,
            React__default.createElement(SidebarSectionLink, { href: navigation.vehicle(vehicle) }, strings.backToVehicle(vehicle.name))),
        (!search || search.vehicle) && React__default.createElement(React__default.Fragment, null,
            React__default.createElement(SidebarVehicle, null),
            React__default.createElement(ModuleSidebarItemGroups, { groups: vehicleGroups })),
        React__default.createElement(SidebarDocumentGroups, null));
};

const ExpandedSidebar = props => {
    const { sidebarLogo } = useContext();
    const navigation = useNavigation();
    const navElement = useRef(null);
    const classes = classNames('Sidebar', 'ExpandedSidebar', {
        'ExpandedSidebar_Floating': props.viewState === 'floating'
    });
    useSwipeGesture({
        element: navElement,
        onSwipeLeft: () => {
            if (props.viewState === 'floating') {
                props.onStopFloating();
            }
        }
    });
    return React__default.createElement(React__default.Fragment, null,
        props.viewState === 'floating' && React__default.createElement("div", { className: "ExpandedSidebar_Cover", "aria-hidden": true, onMouseEnter: props.onStopFloating, onClick: props.onStopFloating }),
        React__default.createElement(CSSTransition, { in: props.viewState !== 'collapsed', classNames: "ExpandedSidebar_Floating", timeout: 200, mountOnEnter: true },
            React__default.createElement("nav", { ref: navElement, className: classes },
                React__default.createElement(Link, { to: navigation.home(), className: "ExpandedSidebar_Logo" }, sidebarLogo()),
                React__default.createElement(SidebarContent, null),
                React__default.createElement(SidebarFooter, null,
                    React__default.createElement(SidebarToggle, { expand: props.viewState !== 'visible', variant: "circle", accented: props.viewState !== 'visible', onExpand: props.onExpand, onCollapse: props.onCollapse })))));
};

const CollapsedSidebar = ({ onStartFloating, onExpand }) => {
    const { sidebar: strings } = useStrings();
    const navElement = useRef(null);
    useSwipeGesture({
        element: navElement,
        onSwipeRight: onStartFloating
    });
    return React__default.createElement("nav", { className: "CollapsedSidebar", ref: navElement },
        React__default.createElement("button", { title: strings.showSidebar, onMouseEnter: onStartFloating, onClick: onStartFloating, className: "CollapsedSidebar-button" },
            React__default.createElement("div", { className: "CollapsedSidebar-handle" })),
        React__default.createElement(SidebarToggle, { expand: true, variant: "tab", accented: true, shadow: true, onExpand: onExpand }));
};

var faQuestionCircle = {};

var hasRequiredFaQuestionCircle;

function requireFaQuestionCircle () {
	if (hasRequiredFaQuestionCircle) return faQuestionCircle;
	hasRequiredFaQuestionCircle = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'question-circle';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f059';
		var svgPathData = 'M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faQuestionCircle = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faQuestionCircle));
	return faQuestionCircle;
}

var faQuestionCircleExports = requireFaQuestionCircle();

const SearchOptions = forwardRef(({ tickBoxVariant, showHelp }, ref) => {
    const { documentSearch: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const { searchVehicle, searchTitles, searchDescriptions, searchContents } = useTypedSelector(selectSearchOptions);
    const vinResolver = useVinResolver();
    const classes = classNames('SearchOptions-helpButton', {
        [`SearchOptions-helpButtonSidebar`]: tickBoxVariant === 'sidebar'
    });
    return React__default.createElement("div", { className: "SearchOptions", ref: ref },
        React__default.createElement("h4", null, strings.searchIn),
        React__default.createElement("div", { className: "SearchOptions-options" },
            vehicle && React__default.createElement(TickBox, { id: "SearchOptions-searchVehicle", variant: tickBoxVariant, value: searchVehicle, label: getVehicleDisplayName(vehicle, vinResolver), onChange: searchVehicle => dispatch(updateSearchOptions({ searchVehicle })) }),
            React__default.createElement(TickBox, { id: "SearchOptions-searchTitles", variant: tickBoxVariant, label: strings.searchTitles, value: searchTitles, onChange: searchTitles => dispatch(updateSearchOptions({ searchTitles })) }),
            React__default.createElement(TickBox, { id: "SearchOptions-searchDescriptions", variant: tickBoxVariant, value: searchDescriptions, label: strings.searchDescriptions, onChange: searchDescriptions => dispatch(updateSearchOptions({ searchDescriptions })) }),
            React__default.createElement(TickBox, { id: "SearchOptions-searchContents", variant: tickBoxVariant, value: searchContents, label: strings.searchContents, onChange: searchContents => dispatch(updateSearchOptions({ searchContents })) })),
        React__default.createElement(IconButton$2, { className: classes, icon: faQuestionCircleExports.faQuestionCircle, iconSize: "lg", title: strings.helpButton, onClick: showHelp }));
});
SearchOptions.displayName = 'SearchOptions';

const SearchSuggestions = props => {
    const { suggestions, search, setSearch, icon } = props;
    const onMobile = useOnMobile();
    const { searchBox: { suggestions: strings } } = useStrings();
    function setSearchValue(entry) {
        setSearch(entry);
    }
    const classes = classNames(className$a(), {
        [className$a('mobile')]: onMobile
    });
    return (React__default.createElement("div", { className: classes }, suggestions.map(entry => {
        return (React__default.createElement("div", { key: entry, className: className$a('option') },
            React__default.createElement("button", { className: className$a('searchButton'), title: strings.search, "aria-label": strings.search, onClick: () => search(entry) },
                React__default.createElement("span", { className: className$a('icon') },
                    React__default.createElement(FontAwesomeIcon, { icon: icon })),
                React__default.createElement("p", { className: className$a('text') }, entry)),
            React__default.createElement(IconButton$2, { className: className$a('setSearchButton'), icon: faArrowUpExports.faArrowUp, title: strings.setInput, onClick: () => setSearchValue(entry) })));
    })));
};
const className$a = createClassName('SearchSuggestions');

function useDocumentSearchSuggestions(maxResults) {
    var _a;
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const { query, searchTitles, searchDescriptions, searchContents } = useTypedSelector(selectSearchOptions);
    const prefix = (_a = useDebouncedValue(query, 300)) !== null && _a !== void 0 ? _a : '';
    const { data, error } = useGetDocumentSearchSuggestionsQuery({
        vehicle,
        prefix,
        maxResults,
        searchTitles,
        searchDescriptions,
        searchContents
    });
    return { data, error };
}

const SearchRelatedSuggestions = props => {
    const { maxResults, search, setSearch } = props;
    const { data, error } = useDocumentSearchSuggestions(maxResults);
    if (error || !data) {
        return null;
    }
    return React__default.createElement(SearchSuggestions, { search: search, setSearch: setSearch, suggestions: data.suggestions, icon: faSearchExports.faSearch });
};

var faHistory = {};

var hasRequiredFaHistory;

function requireFaHistory () {
	if (hasRequiredFaHistory) return faHistory;
	hasRequiredFaHistory = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'history';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f1da';
		var svgPathData = 'M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faHistory = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faHistory));
	return faHistory;
}

var faHistoryExports = requireFaHistory();

const SearchHistorySuggestions = props => {
    const { maxResults, search, setSearch } = props;
    const { data, error } = useGetUserSearchHistoryQuery();
    if (error || !data) {
        return null;
    }
    const uniqueLatestSuggestions = Array.from(new Set(data.records.map(record => record.query).reverse())).slice(0, maxResults);
    return React__default.createElement(SearchSuggestions, { search: search, setSearch: setSearch, suggestions: uniqueLatestSuggestions, icon: faHistoryExports.faHistory });
};

const MobileSearch = ({ onSearched, showHelp }) => {
    var _a;
    const { documentSearch: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const { options, search } = useDocumentSearch();
    const searchInput = useRef(null);
    useEffect(() => {
        var _a;
        (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [searchInput]);
    function doSearch(query) {
        if (search({ query })) {
            onSearched();
        }
    }
    function onChange(query) {
        var _a;
        dispatch(updateSearchOptions({ query }));
        (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    return (React__default.createElement("div", { className: "MobileSearch" },
        React__default.createElement(SearchBox, { inputRef: searchInput, value: (_a = options.query) !== null && _a !== void 0 ? _a : '', placeholder: strings.searchDocuments, variant: "sidebar", onChange: onChange, onEnterPress: doSearch }),
        React__default.createElement(SidebarSection, { className: "MobileSearch-options" },
            React__default.createElement(SearchHistorySuggestions, { search: doSearch, setSearch: onChange, maxResults: 3 }),
            React__default.createElement(SearchRelatedSuggestions, { search: doSearch, setSearch: onChange, maxResults: 3 }),
            React__default.createElement(SearchOptions, { tickBoxVariant: "sidebar", showHelp: showHelp }))));
};

function usePopupFocus({ focusElements, blurOnClose, onEnterPress }) {
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        function shouldClose(node) {
            var _a;
            for (const element of focusElements) {
                if ((_a = element.current) === null || _a === void 0 ? void 0 : _a.contains(node)) {
                    return false;
                }
            }
            return true;
        }
        function handleClickAndFocus(event) {
            if (event.target instanceof Node && shouldClose(event.target)) {
                setIsOpen(false);
            }
        }
        function handleKeyDown(event) {
            if (event.key === 'Escape') {
                setIsOpen(false);
            }
            else if (event.key === 'Enter') {
                onEnterPress === null || onEnterPress === void 0 ? void 0 : onEnterPress();
            }
        }
        function handleWindowsBlur(event) {
            const activeElement = event.relatedTarget || window.document.activeElement;
            if (activeElement instanceof Node && shouldClose(activeElement)) {
                setIsOpen(false);
            }
        }
        let haveAddedListeners = false;
        function removeListeners() {
            if (haveAddedListeners) {
                document.removeEventListener('click', handleClickAndFocus, { capture: true });
                document.removeEventListener('focusin', handleClickAndFocus);
                document.removeEventListener('keydown', handleKeyDown);
                window.removeEventListener('blur', handleWindowsBlur);
                haveAddedListeners = false;
            }
        }
        if (isOpen) {
            document.addEventListener('click', handleClickAndFocus, { capture: true });
            document.addEventListener('focusin', handleClickAndFocus);
            document.addEventListener('keydown', handleKeyDown);
            window.addEventListener('blur', handleWindowsBlur);
            haveAddedListeners = true;
        }
        else {
            removeListeners();
        }
        return removeListeners;
    }, [focusElements, isOpen, onEnterPress]);
    useEffect(() => {
        var _a;
        if (!isOpen) {
            (_a = blurOnClose === null || blurOnClose === void 0 ? void 0 : blurOnClose.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    }, [isOpen, blurOnClose]);
    return [isOpen, setIsOpen];
}

function useDocumentSearchFocusListener(onFocus) {
    const dispatch = useTypedDispatch();
    const focus = useTypedSelector(selectFocusDocumentSearch);
    useEffect(() => {
        if (focus) {
            onFocus();
            dispatch(clearFocusDocumentSearch());
        }
    }, [focus, onFocus, dispatch]);
}

var faUserCircle = {};

var hasRequiredFaUserCircle;

function requireFaUserCircle () {
	if (hasRequiredFaUserCircle) return faUserCircle;
	hasRequiredFaUserCircle = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'user-circle';
		var width = 496;
		var height = 512;
		var ligatures = [];
		var unicode = 'f2bd';
		var svgPathData = 'M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faUserCircle = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faUserCircle));
	return faUserCircle;
}

var faUserCircleExports = requireFaUserCircle();

var faBars = {};

var hasRequiredFaBars;

function requireFaBars () {
	if (hasRequiredFaBars) return faBars;
	hasRequiredFaBars = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'bars';
		var width = 448;
		var height = 512;
		var ligatures = [];
		var unicode = 'f0c9';
		var svgPathData = 'M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faBars = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faBars));
	return faBars;
}

var faBarsExports = requireFaBars();

function useUnreadMessageCount() {
    const { data: userStatus } = useGetUserStatusQueryState();
    return userStatus === null || userStatus === void 0 ? void 0 : userStatus.unreadMessageCount;
}

var faUser = {};

var hasRequiredFaUser;

function requireFaUser () {
	if (hasRequiredFaUser) return faUser;
	hasRequiredFaUser = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'user';
		var width = 448;
		var height = 512;
		var ligatures = [];
		var unicode = 'f007';
		var svgPathData = 'M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faUser = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faUser));
	return faUser;
}

var faUserExports = requireFaUser();

var faTools = {};

var hasRequiredFaTools;

function requireFaTools () {
	if (hasRequiredFaTools) return faTools;
	hasRequiredFaTools = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'tools';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f7d9';
		var svgPathData = 'M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faTools = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faTools));
	return faTools;
}

var faToolsExports = requireFaTools();

var faInbox = {};

var hasRequiredFaInbox;

function requireFaInbox () {
	if (hasRequiredFaInbox) return faInbox;
	hasRequiredFaInbox = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'inbox';
		var width = 576;
		var height = 512;
		var ligatures = [];
		var unicode = 'f01c';
		var svgPathData = 'M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faInbox = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faInbox));
	return faInbox;
}

var faInboxExports = requireFaInbox();

const AccountMenuItem = ({ title, icon, badgeCount, badgeLabel, href, openInNewTab, onClick }) => {
    return React__default.createElement(MenuItem, { role: "menuitem", ariaLabel: title, component: href ? Link$1 : LinkButton, href: href, openInNewTab: openInNewTab, preventIfOffline: true, onClick: onClick },
        React__default.createElement(ListItemIcon$1, null,
            React__default.createElement(Badge, { count: badgeCount, ariaLabel: badgeLabel }, icon && React__default.createElement(FontAwesomeIcon, { icon: icon, size: "1x" }))),
        title);
};

const AccountMenu = ({ anchor, isOpen, onClose }) => {
    const user = useTypedSelector(selectCurrentUser);
    const { header: strings } = useStrings();
    const { openAdminPageInNewTab, openAuthoringPageInNewTab } = useContext();
    const dispatch = useTypedDispatch();
    const navigate = useNavigate();
    const unreadMessageCount = useUnreadMessageCount();
    const moduleItems = useModuleAccountMenuItems();
    const accountItems = moduleItems.filter(({ position }) => !position || position === 'default');
    const adminItems = moduleItems.filter(({ position }) => position === 'admin');
    const navigation = useNavigation();
    const tabs = useAccountTabs();
    const hasAccountTabs = tabs !== null && Object.values(tabs).some(item => item !== null);
    function doLogOut() {
        return __awaiter(this, void 0, void 0, function* () {
            dispatch(showGlobalIndicator('logOut'));
            yield new Promise(resolve => setTimeout(resolve, 1000)); // Intentional delay.
            yield dispatch(logOut());
            dispatch(hideGlobalIndicator('logOut'));
            navigate(navigation.login());
        });
    }
    function clickHandler(onClick) {
        return () => {
            onClose();
            onClick === null || onClick === void 0 ? void 0 : onClick();
        };
    }
    return React__default.createElement(Menu, { className: "AccountMenu", MenuListProps: {
            'aria-label': strings.account
        }, open: isOpen, onClose: onClose, anchorEl: anchor, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' } },
        hasAccountTabs && React__default.createElement(AccountMenuItem, { title: strings.accountDetails, icon: faUserExports.faUser, href: "/account", onClick: clickHandler() }),
        accountItems.map(({ title, icon, href, onClick }) => React__default.createElement(AccountMenuItem, { key: title, title: title, icon: icon, href: href, onClick: clickHandler(onClick) })),
        (hasAccountTabs || accountItems.length > 0) && React__default.createElement(Divider$1, null),
        React__default.createElement(AccountMenuItem, { title: strings.messages, icon: faInboxExports.faInbox, badgeCount: unreadMessageCount, badgeLabel: unreadMessageCount ? strings.unreadMessages(unreadMessageCount) : undefined, href: "/messages", onClick: clickHandler() }),
        React__default.createElement(Divider$1, null),
        (user === null || user === void 0 ? void 0 : user.authoringUrl) && React__default.createElement(AccountMenuItem, { title: strings.authoring, icon: faEditExports.faEdit, href: user.authoringUrl, openInNewTab: openAuthoringPageInNewTab, onClick: clickHandler() }),
        (user === null || user === void 0 ? void 0 : user.administrationUrl) && React__default.createElement(AccountMenuItem, { title: strings.administration, icon: faToolsExports.faTools, href: user.administrationUrl, openInNewTab: openAdminPageInNewTab, onClick: clickHandler() }),
        adminItems.map(({ title, icon, href, onClick }) => React__default.createElement(AccountMenuItem, { key: title, title: title, icon: icon, href: href, onClick: clickHandler(onClick) })),
        ((user === null || user === void 0 ? void 0 : user.authoringUrl) || (user === null || user === void 0 ? void 0 : user.administrationUrl) || adminItems.length > 0) && React__default.createElement(Divider$1, null),
        React__default.createElement(AccountMenuItem, { title: strings.logOut, icon: faSignOutAltExports.faSignOutAlt, onClick: clickHandler(doLogOut) }));
};

const ModuleHeaderItem = ({ item, variant }) => {
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const { visibility } = item;
    if ((visibility === 'users' && !isLoggedIn) || (visibility === 'guests' && isLoggedIn)) {
        return null;
    }
    if (item.content) {
        return item.content(variant);
    }
    return (React__default.createElement(HeaderButton, { key: item.title, icon: item.icon, title: item.title, badgeCount: item.badgeCount, badgeLabel: item.badgeLabel, href: item.href, variant: variant, onClick: item.onClick }));
};

const MobileHeader = ({ isMenuOpen, onMenuClick, onSearchClick }) => {
    const strings = useStrings();
    const navigation = useNavigation();
    const navigate = useNavigate();
    const user = useTypedSelector(selectCurrentUser);
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const [accountMenuAnchor, setAccountMenuAnchor] = useState(null);
    const dispatch = useTypedDispatch();
    const vinResolver = useVinResolver();
    const moduleItems = useModuleHeaderItems();
    const unreadMessageCount = useUnreadMessageCount();
    const { hideSearchBarWhenUserLoggedOut, headerElementsOrder } = useContext();
    const mandatoryLogin = useFeatureToggles().isFeatureToggleEnabled('MANDATORY_LOGIN');
    const loggedIn = useTypedSelector(selectIsLoggedIn);
    const memoizedModuleItems = useMemo(() => moduleItems
        .map(item => React__default.createElement(ModuleHeaderItem, { key: v4(), item: item, variant: "mobile" })), [moduleItems]);
    const sortedElements = useMemo(() => {
        const headerElements = [
            { id: 'search', content: () => (loggedIn || !mandatoryLogin || !hideSearchBarWhenUserLoggedOut) && (React__default.createElement(HeaderButton, { icon: faSearchExports.faSearch, title: strings.sidebar.searchButton, variant: "mobile", onClick: onSearchClick })) },
            { id: 'help', content: () => React__default.createElement(HeaderButton, { icon: faQuestionCircleExports.faQuestionCircle, title: strings.sidebar.helpButton, variant: "mobile", onClick: () => dispatch(showHelp()) })
            },
            {
                id: 'modules',
                content: () => memoizedModuleItems
            },
            { id: 'account', content: () => user && React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(HeaderButton, { icon: faUserCircleExports.faUserCircle, title: strings.sidebar.accountButton, badgeCount: unreadMessageCount, badgeLabel: unreadMessageCount ? strings.header.unreadMessages(unreadMessageCount) : undefined, variant: "mobile", onClick: event => setAccountMenuAnchor(event.currentTarget) },
                        React__default.createElement(FontAwesomeIcon, { className: className$9('accountMenuArrow'), icon: faChevronDownExports.faChevronDown, size: "sm" })),
                    React__default.createElement(AccountMenu, { anchor: accountMenuAnchor, isOpen: accountMenuAnchor !== null, onClose: () => setAccountMenuAnchor(null) }))
            }
        ];
        const defaultHeaderElementsOrder = {
            search: 0,
            help: 1,
            modules: 2,
            account: 3
        };
        return Object.entries(headerElementsOrder || defaultHeaderElementsOrder)
            .map(([id, order]) => ({ id, order }))
            .sort((a, b) => a.order - b.order)
            .map(item => { var _a; return React__default.createElement(React__default.Fragment, { key: item.id }, (_a = headerElements.find(({ id }) => id === item.id)) === null || _a === void 0 ? void 0 : _a.content()); });
    }, [accountMenuAnchor, dispatch, headerElementsOrder, hideSearchBarWhenUserLoggedOut, loggedIn, mandatoryLogin, memoizedModuleItems, onSearchClick, strings, unreadMessageCount, user]);
    return React__default.createElement("header", { className: className$9() },
        React__default.createElement(HeaderButton, { icon: isMenuOpen ? faTimesExports.faTimes : faBarsExports.faBars, title: strings.sidebar.menuButton, variant: "mobile", onClick: onMenuClick }),
        React__default.createElement(CSSTransition, { in: !isMenuOpen && vehicle !== null, classNames: className$9('vehicle'), timeout: 200, mountOnEnter: true }, !vehicle ? React__default.createElement("div", null) : React__default.createElement("button", { className: className$9('vehicle'), title: vehicle.name, onClick: () => navigate(navigation.vehicle(vehicle)) },
            React__default.createElement("div", { className: className$9('vehicleName') }, vehicle.name),
            vehicle.ref === 'vin' && React__default.createElement("div", { className: className$9('vehicleVin') }, vinResolver(vehicle.vin)))),
        React__default.createElement("div", { className: className$9('buttons') }, sortedElements));
};
const className$9 = createClassName('MobileHeader');

const SearchOptionsHelpDialogue = forwardRef(({ isOpen, onClose }, ref) => {
    const { documentSearch: strings } = useStrings();
    const tableContent = useMemo(() => Object.entries(strings.helpDialogue.table.content).map(([key, value]) => (Object.assign({ id: key }, value))), [strings.helpDialogue.table.content]);
    function getRow(rowIndex) {
        const item = tableContent[rowIndex];
        const { id, operator, example, result } = item;
        return {
            id,
            component: ({ rowProps }) => (React__default.createElement(Table.Row, { rowProps: rowProps },
                React__default.createElement(Table.TextCell, null, operator),
                React__default.createElement(Table.TextCell, null, example),
                React__default.createElement(Table.TextCell, null, result))),
            props: { item }
        };
    }
    return React__default.createElement(Dialogue, { ref: ref, className: className$8(), isOpen: isOpen, onClose: onClose, ariaLabel: strings.helpDialogue.title },
        React__default.createElement(Dialogue.Header, { title: strings.helpDialogue.title, border: true, onClose: onClose }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement("h3", null, strings.helpDialogue.searchOptionsTitle),
            React__default.createElement(DefinitionList, { definitions: [
                    { name: strings.helpDialogue.boxes.searchVehicleTerm, value: strings.helpDialogue.boxes.searchVehicle },
                    { name: strings.searchTitles, value: strings.helpDialogue.boxes.searchTitles },
                    { name: strings.searchDescriptions, value: strings.helpDialogue.boxes.searchDescriptions },
                    { name: strings.searchContents, value: strings.helpDialogue.boxes.searchContents }
                ] }),
            React__default.createElement("h3", null, strings.helpDialogue.advancedSearchingTitle),
            React__default.createElement("p", null, strings.helpDialogue.advancedSearchingTip),
            React__default.createElement(Table, { title: strings.helpDialogue.table.title, columns: [
                    { id: 'operators', title: strings.helpDialogue.table.operators, className: className$8('emailAddress') },
                    { id: 'examples', title: strings.helpDialogue.table.examples, className: className$8('emailAddress') },
                    { id: 'results', title: strings.helpDialogue.table.results, className: className$8('emailAddress') }
                ], rowCount: tableContent.length, getRow: getRow })));
});
const className$8 = createClassName('SearchOptionsHelpDialogue');
SearchOptionsHelpDialogue.displayName = 'SearchOptionsHelpDialogue';

const MobileSidebar = () => {
    const navigation = useNavigation();
    const [expandedState, setExpandedState] = useState('collapsed');
    const containerRef = useRef(null);
    const dialogRef = useRef(null);
    const [isHelpOpen, setIsHelpOpen] = useState(false);
    const { mobileSidebarLogo } = useContext();
    useDocumentSearchFocusListener(() => setExpandedState('search'));
    const [isOpen, setIsOpen] = usePopupFocus({
        focusElements: [containerRef, dialogRef]
    });
    useEffect(() => {
        if (expandedState !== 'collapsed') {
            setIsOpen(true);
        }
    }, [expandedState, setIsOpen]);
    useEffect(() => {
        if (!isOpen) {
            setExpandedState('collapsed');
        }
    }, [isOpen]);
    // Close sidebar when location changes.
    useNavigationChangeListener(() => setExpandedState('collapsed'));
    function toggleExpanded() {
        setExpandedState(expandedState === 'collapsed' ? 'expanded' : 'collapsed');
    }
    function toggleSearchExpanded() {
        setExpandedState(expandedState !== 'search' ? 'search' : 'collapsed');
    }
    function collapseWithDelay() {
        setTimeout(() => setExpandedState('collapsed'), 50);
    }
    return React__default.createElement("div", { className: "Sidebar MobileSidebar", ref: containerRef },
        React__default.createElement(MobileHeader, { isMenuOpen: expandedState !== 'collapsed', onMenuClick: toggleExpanded, onSearchClick: toggleSearchExpanded }),
        React__default.createElement(CSSTransition, { in: expandedState === 'expanded', classNames: "MobileSidebar-expanded", timeout: 200, mountOnEnter: true },
            React__default.createElement("nav", { className: "MobileSidebar-expanded" },
                React__default.createElement(SidebarContent, null),
                React__default.createElement(SidebarFooter, null,
                    React__default.createElement(Link, { to: navigation.home(), className: "MobileSidebar-logo" }, mobileSidebarLogo())))),
        React__default.createElement(CSSTransition, { in: expandedState === 'search', classNames: "MobileSidebar-search", timeout: 200, mountOnEnter: true },
            React__default.createElement("div", { role: "search", className: "MobileSidebar-search" },
                React__default.createElement(MobileSearch, { onSearched: collapseWithDelay, showHelp: () => setIsHelpOpen(true) }),
                React__default.createElement(SearchOptionsHelpDialogue, { ref: dialogRef, isOpen: isHelpOpen, onClose: () => setIsHelpOpen(false) }))));
};

const Sidebar = () => {
    const onMobile = useOnMobile();
    const [isCollapsed, setIsCollapsed] = React__default.useState(false);
    const [isFloating, setIsFloating] = React__default.useState(false);
    function onExpand() {
        setIsCollapsed(false);
        setIsFloating(false);
    }
    const showCollapsed = !onMobile && isCollapsed;
    const viewState = isFloating ? 'floating' : showCollapsed ? 'collapsed' : 'visible';
    return React__default.createElement(React__default.Fragment, null,
        !onMobile && React__default.createElement(ExpandedSidebar, { viewState: viewState, onExpand: onExpand, onCollapse: () => setIsCollapsed(true), onStopFloating: () => setIsFloating(false) }),
        showCollapsed && React__default.createElement(CollapsedSidebar, { onStartFloating: () => setIsFloating(true), onExpand: onExpand }),
        onMobile && React__default.createElement(MobileSidebar, null));
};

const CompleteLogin = () => {
    const { auth: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const navigate = useNavigate();
    const query = useLocation().search;
    useEffect(() => {
        function doLogin() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    dispatch(showGlobalIndicator('CompleteLogin'));
                    yield dispatch(logIn(query)).unwrap();
                    navigate((_a = takePostAuthRedirectUrl()) !== null && _a !== void 0 ? _a : '/', { replace: true });
                }
                catch (_b) {
                    dispatch(queueNotification(strings.logInError));
                    navigate('/', { replace: true });
                }
                finally {
                    dispatch(hideGlobalIndicator('CompleteLogin'));
                }
            });
        }
        doLogin();
    }, [dispatch, query, navigate, strings.logInError]);
    return null;
};

var faUnlink = {};

var hasRequiredFaUnlink;

function requireFaUnlink () {
	if (hasRequiredFaUnlink) return faUnlink;
	hasRequiredFaUnlink = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'unlink';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f127';
		var svgPathData = 'M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faUnlink = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faUnlink));
	return faUnlink;
}

var faUnlinkExports = requireFaUnlink();

const HeaderSearch = () => {
    var _a;
    const { documentSearch: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const { options, search } = useDocumentSearch();
    const searchRef = useRef(null);
    const inputRef = useRef(null);
    const dialogRef = useRef(null);
    const optionsRef = useRef(null);
    const suggestionsRef = useRef(null);
    const [isHelpOpen, setIsHelpOpen] = useState(false);
    const { ref, width } = useElementWidth();
    const { isOnline } = useOnlineStatus();
    useDocumentSearchFocusListener(() => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); });
    const [isOpen, setIsOpen] = usePopupFocus({
        focusElements: [searchRef, optionsRef, dialogRef, suggestionsRef],
        blurOnClose: inputRef,
        onEnterPress: doSearch
    });
    function doSearch() {
        var _a, _b;
        const suggestionButtonFocused = ((_a = suggestionsRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) && ((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.tagName) === 'BUTTON';
        if (suggestionButtonFocused) {
            return;
        }
        if (isOnline && search()) {
            setIsOpen(false);
        }
    }
    function onChange(query) {
        var _a;
        dispatch(updateSearchOptions({ query }));
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
    function onEnterPress(value, event) {
        event.nativeEvent.stopImmediatePropagation(); // Stop usePopupFocus handling the event.
        doSearch();
    }
    function onSuggestionClick(query) {
        search({ query });
        setIsOpen(false);
    }
    const classes = classNames(className$7(), {
        [className$7('open')]: isOpen,
        [className$7('compact')]: isMobile(width)
    });
    function handleKeyboardFocusNavigation(event) {
        var _a, _b, _c;
        const buttons = (_a = suggestionsRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('button');
        if (!buttons) {
            return;
        }
        let selectedIndex = undefined;
        for (let index = 0; index < buttons.length; index++) {
            const element = buttons[index];
            if (document.activeElement === element) {
                selectedIndex = index;
            }
        }
        if (event.key === 'ArrowUp') {
            if (selectedIndex === 0) {
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                return;
            }
            buttons[(selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : buttons.length) - 1].focus();
        }
        if (event.key === 'ArrowDown') {
            if (selectedIndex === undefined) {
                selectedIndex = -1;
            }
            if (selectedIndex >= (buttons === null || buttons === void 0 ? void 0 : buttons.length) - 1) {
                (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.focus();
                return;
            }
            buttons[(selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : -1) + 1].focus();
        }
    }
    return (
    // The <div> element has a child <button> and <input> elements that allows keyboard interaction
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement("div", { className: classes, ref: ref, onKeyDown: handleKeyboardFocusNavigation },
        React__default.createElement(SearchBox, { ref: searchRef, inputRef: inputRef, size: "large", value: (_a = options.query) !== null && _a !== void 0 ? _a : '', placeholder: strings.searchDocuments, onFocus: () => setIsOpen(true), onChange: onChange, onEnterPress: onEnterPress }),
        isOpen && (React__default.createElement("div", { className: className$7('options') }, isOnline ? React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { ref: suggestionsRef },
                React__default.createElement(SearchHistorySuggestions, { search: onSuggestionClick, setSearch: onChange, maxResults: 4 }),
                React__default.createElement(SearchRelatedSuggestions, { search: onSuggestionClick, setSearch: onChange, maxResults: 4 })),
            React__default.createElement(SearchOptions, { ref: optionsRef, showHelp: () => setIsHelpOpen(true) })) : React__default.createElement("div", { className: className$7('offline') },
            React__default.createElement(FontAwesomeIcon, { icon: faUnlinkExports.faUnlink }),
            strings.cannotSearchOffline))),
        React__default.createElement(SearchOptionsHelpDialogue, { ref: dialogRef, isOpen: isHelpOpen, onClose: () => setIsHelpOpen(false) })));
};
const className$7 = createClassName('HeaderSearch');

const Header = () => {
    const { header: strings } = useStrings();
    const user = useTypedSelector(selectCurrentUser);
    const [accountMenuAnchor, setAccountMenuAnchor] = useState(null);
    const dispatch = useTypedDispatch();
    const { ref, width } = useElementWidth();
    const moduleItems = useModuleHeaderItems();
    const unreadMessageCount = useUnreadMessageCount();
    const { hideSearchBarWhenUserLoggedOut, headerElementsOrder } = useContext();
    const mandatoryLogin = useFeatureToggles().isFeatureToggleEnabled('MANDATORY_LOGIN');
    const loggedIn = useTypedSelector(selectIsLoggedIn);
    const dealerName = useModuleDealerName();
    const classes = classNames('Header', {
        'Header-hideUserName': width < 700
    });
    const memoizedModuleItems = useMemo(() => moduleItems
        .map(item => React__default.createElement(ModuleHeaderItem, { key: v4(), item: item })), [moduleItems]);
    const sortedElements = useMemo(() => {
        const headerElements = [
            { id: 'help', content: () => React__default.createElement(HeaderButton, { icon: faQuestionCircleExports.faQuestionCircle, title: strings.help, onClick: () => dispatch(showHelp()) })
            },
            {
                id: 'modules',
                content: () => memoizedModuleItems
            },
            { id: 'account', content: () => user && React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(HeaderButton, { icon: faUserCircleExports.faUserCircle, title: strings.account, badgeCount: unreadMessageCount, badgeLabel: unreadMessageCount ? strings.unreadMessages(unreadMessageCount) : undefined, onClick: event => setAccountMenuAnchor(event.currentTarget) },
                        React__default.createElement("div", { className: "Header-label" }, getUserDisplayName(user)),
                        dealerName && React__default.createElement("div", { className: "Header-name" }, dealerName),
                        React__default.createElement(FontAwesomeIcon, { className: "Header-accountMenuArrow", icon: faChevronDownExports.faChevronDown, size: "sm" })),
                    React__default.createElement(AccountMenu, { anchor: accountMenuAnchor, isOpen: accountMenuAnchor !== null, onClose: () => setAccountMenuAnchor(null) }))
            }
        ];
        const defaultHeaderElementsOrder = {
            help: 0,
            modules: 1,
            account: 2
        };
        return Object.entries(headerElementsOrder || defaultHeaderElementsOrder)
            .map(([id, order]) => ({ id, order }))
            .sort((a, b) => a.order - b.order)
            .map(item => { var _a; return React__default.createElement(React__default.Fragment, { key: item.id }, (_a = headerElements.find(({ id }) => id === item.id)) === null || _a === void 0 ? void 0 : _a.content()); });
    }, [accountMenuAnchor, dispatch, headerElementsOrder, memoizedModuleItems, strings, unreadMessageCount, user, dealerName]);
    return React__default.createElement("header", { ref: ref, className: classes },
        (loggedIn || !mandatoryLogin || !hideSearchBarWhenUserLoggedOut) && React__default.createElement(HeaderSearch, null),
        React__default.createElement("div", { className: "Header-buttons" }, sortedElements));
};

var faKey = {};

var hasRequiredFaKey;

function requireFaKey () {
	if (hasRequiredFaKey) return faKey;
	hasRequiredFaKey = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'key';
		var width = 512;
		var height = 512;
		var ligatures = [];
		var unicode = 'f084';
		var svgPathData = 'M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faKey = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faKey));
	return faKey;
}

var faKeyExports = requireFaKey();

const DocumentHistoryDialogue = ({ isOpen, onClose, document }) => {
    const { documentHistory: strings } = useStrings();
    const { sourceId, documentTypeId, language } = document;
    const { data, isLoading, error } = useGetDocumentHistoryQuery({ sourceId, documentTypeId, language });
    const documentHistory = data !== null && data !== void 0 ? data : [];
    const errorMessage = useApiErrorMessage(strings.loadError, error);
    function getRow(rowIndex) {
        const item = Object.assign({ id: documentHistory[rowIndex].globalReference }, documentHistory[rowIndex]);
        const { id, publicationDate, sourceVersion, globalReference } = item;
        return {
            id,
            component: ({ rowProps }) => (React__default.createElement(Table.Row, { rowProps: rowProps },
                React__default.createElement(Table.TextCell, null,
                    React__default.createElement(DateText, { date: publicationDate })),
                React__default.createElement(Table.TextCell, null, sourceVersion),
                React__default.createElement(Table.TextCell, null, globalReference))),
            props: { item }
        };
    }
    return React__default.createElement(Dialogue, { className: className$6(), isOpen: isOpen, onClose: onClose },
        React__default.createElement(Dialogue.Header, { title: strings.title, adornment: document ? React__default.createElement(DocumentLabels, { document: document }) : undefined, onClose: onClose }),
        React__default.createElement(Dialogue.Content, null, (() => {
            if (errorMessage) {
                return React__default.createElement("div", { className: className$6('error') }, errorMessage);
            }
            return React__default.createElement(Table, { title: strings.tableTitle, columns: [
                    { id: 'publicationDate', title: strings.publicationDateLabel },
                    { id: 'sourceVersion', title: strings.sourceVersionLabel },
                    { id: 'globalReference', title: strings.globalReferenceLabel }
                ], isLoading: isLoading, rowCount: documentHistory.length, getRow: getRow },
                React__default.createElement(EmptyTableRow, { message: strings.emptyList, size: "sm" }));
        })()));
};
const className$6 = createClassName('DocumentHistoryDialogue');

const DocumentInfoDialogue = () => {
    const strings = useStrings();
    const dispatch = useTypedDispatch();
    const documentRef = useTypedSelector(selectShowDocumentInfoDocument);
    const { data: document, isFetching, error } = useGetDocumentQuery(documentRef ? {
        documentId: documentRef.id,
        vehicle: documentRef.vehicle
    } : queryExports.skipToken);
    const user = useTypedSelector(selectCurrentUser);
    const [showHistoryDialogue, setShowHistoryDialogue] = useState(false);
    useShowLoadingIndicator(isFetching);
    const closeDialogue = useCallback(() => dispatch(showDocumentInfo(null)), [dispatch]);
    const errorMessage = useApiErrorMessage(strings.document.loadError, error, {
        404: strings.document.notFound
    });
    useEffect(() => {
        if (errorMessage) {
            closeDialogue();
            dispatch(queueNotification(errorMessage));
        }
    }, [dispatch, errorMessage, closeDialogue]);
    if (!document) {
        return null;
    }
    const definitions = [
        {
            name: strings.documentInfo.referenceLabel,
            value: document.reference
        },
        (user === null || user === void 0 ? void 0 : user.type) === 'MANUFACTURER' && {
            name: strings.documentInfo.sourceIdLabel,
            value: document.sourceId
        },
        {
            name: strings.documentInfo.dateLabel,
            value: document.publicationDate ? React__default.createElement(DateText, { date: document.publicationDate }) : strings.documentInfo.notPublished
        },
        {
            name: strings.documentInfo.embargoedUntilLabel,
            value: document.embargoDate && React__default.createElement(DateText, { date: document.embargoDate })
        }
    ].filter(filterFalse);
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Dialogue, { className: "DocumentInfoDialogue", isOpen: documentRef !== null && !isFetching, onClose: closeDialogue },
            React__default.createElement(Dialogue.Header, { title: document.title, adornment: document ? React__default.createElement(DocumentLabels, { document: document }) : undefined, onClose: closeDialogue }),
            React__default.createElement(Dialogue.Content, null,
                React__default.createElement(DefinitionList, { definitions: definitions, skipMissingValues: true }),
                React__default.createElement("h4", null, strings.documentInfo.pathLabel),
                React__default.createElement(DocumentPaths, { paths: document.path })),
            React__default.createElement(Dialogue.Footer, null,
                React__default.createElement("div", { className: "DocumentInfoDialogue-actions" },
                    document.links.edit && React__default.createElement(Link$1, { href: document.links.edit, openInNewTab: true, preventIfOffline: strings.document.cannotEditOffline },
                        React__default.createElement(FontAwesomeIcon, { icon: faEditExports.faEdit }),
                        strings.documentInfo.editDocument),
                    document.links.applicabilityEdit && React__default.createElement(Link$1, { href: document.links.applicabilityEdit, openInNewTab: true, preventIfOffline: strings.documentInfo.cannotViewApplicabilitiesOffline },
                        React__default.createElement(FontAwesomeIcon, { icon: faKeyExports.faKey }),
                        strings.documentInfo.viewApplicabilities),
                    React__default.createElement(LinkButton, { title: strings.documentInfo.viewHistory, onClick: () => setShowHistoryDialogue(true) },
                        React__default.createElement(FontAwesomeIcon, { icon: faClockExports.faClock }),
                        strings.documentInfo.viewHistory)))),
        React__default.createElement(DocumentHistoryDialogue, { isOpen: showHistoryDialogue, onClose: () => setShowHistoryDialogue(false), document: document }));
};

const NoticeDialogue = () => {
    const { notice: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const noticeId = useTypedSelector(selectShowNoticeId);
    const { data: notice, isFetching, error } = useGetNoticeQuery(noticeId !== null && noticeId !== void 0 ? noticeId : queryExports.skipToken);
    useShowLoadingIndicator(isFetching);
    const closeDialogue = useCallback(() => dispatch(showNotice(null)), [dispatch]);
    const errorMessage = useApiErrorMessage(strings.loadError, error, {
        404: strings.notFound
    });
    useEffect(() => {
        if (errorMessage) {
            closeDialogue();
            dispatch(queueNotification(errorMessage));
        }
    }, [dispatch, errorMessage, closeDialogue]);
    if (!notice) {
        return null;
    }
    return React__default.createElement(Dialogue, { className: "NoticeDialogue", isOpen: noticeId !== null && !isFetching, onClose: closeDialogue },
        React__default.createElement(Dialogue.Header, { title: notice.title, onClose: closeDialogue }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement(DefinitionList, { definitions: [
                    { name: strings.dateLabel, value: React__default.createElement(DateText, { date: notice.date, format: DateText.DATE_LONG }) }
                ] }),
            React__default.createElement("pre", null, notice.body)));
};

/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */
function useSnackbar(parameters = {}) {
  const {
    autoHideDuration = null,
    disableWindowBlurListener = false,
    onClose,
    open,
    resumeHideDuration
  } = parameters;
  const timerAutoHide = useTimeout();
  React.useEffect(() => {
    if (!open) {
      return undefined;
    }

    /**
     * @param {KeyboardEvent} nativeEvent
     */
    function handleKeyDown(nativeEvent) {
      if (!nativeEvent.defaultPrevented) {
        // IE11, Edge (prior to using Blink?) use 'Esc'
        if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
          // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
          onClose == null || onClose(nativeEvent, 'escapeKeyDown');
        }
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);
  const handleClose = useEventCallback((event, reason) => {
    onClose == null || onClose(event, reason);
  });
  const setAutoHideTimer = useEventCallback(autoHideDurationParam => {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }
    timerAutoHide.start(autoHideDurationParam, () => {
      handleClose(null, 'timeout');
    });
  });
  React.useEffect(() => {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }
    return timerAutoHide.clear;
  }, [open, autoHideDuration, setAutoHideTimer, timerAutoHide]);
  const handleClickAway = event => {
    onClose == null || onClose(event, 'clickaway');
  };

  // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.
  const handlePause = timerAutoHide.clear;

  // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.
  const handleResume = React.useCallback(() => {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
  const createHandleBlur = otherHandlers => event => {
    const onBlurCallback = otherHandlers.onBlur;
    onBlurCallback == null || onBlurCallback(event);
    handleResume();
  };
  const createHandleFocus = otherHandlers => event => {
    const onFocusCallback = otherHandlers.onFocus;
    onFocusCallback == null || onFocusCallback(event);
    handlePause();
  };
  const createMouseEnter = otherHandlers => event => {
    const onMouseEnterCallback = otherHandlers.onMouseEnter;
    onMouseEnterCallback == null || onMouseEnterCallback(event);
    handlePause();
  };
  const createMouseLeave = otherHandlers => event => {
    const onMouseLeaveCallback = otherHandlers.onMouseLeave;
    onMouseLeaveCallback == null || onMouseLeaveCallback(event);
    handleResume();
  };
  React.useEffect(() => {
    // TODO: window global should be refactored here
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return () => {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }
    return undefined;
  }, [disableWindowBlurListener, open, handleResume, handlePause]);
  const getRootProps = (externalProps = {}) => {
    const externalEventHandlers = _extends({}, extractEventHandlers(parameters), extractEventHandlers(externalProps));
    return _extends({
      // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
      // See https://github.com/mui/material-ui/issues/29080
      role: 'presentation'
    }, externalProps, externalEventHandlers, {
      onBlur: createHandleBlur(externalEventHandlers),
      onFocus: createHandleFocus(externalEventHandlers),
      onMouseEnter: createMouseEnter(externalEventHandlers),
      onMouseLeave: createMouseLeave(externalEventHandlers)
    });
  };
  return {
    getRootProps,
    onClickAway: handleClickAway
  };
}

function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}
function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */
function ClickAwayListener(props) {
  const {
    children,
    disableReactTree = false,
    mouseEvent = 'onClick',
    onClickAway,
    touchEvent = 'onTouchEnd'
  } = props;
  const movedRef = React.useRef(false);
  const nodeRef = React.useRef(null);
  const activatedRef = React.useRef(false);
  const syntheticEventRef = React.useRef(false);
  React.useEffect(() => {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(() => {
      activatedRef.current = true;
    }, 0);
    return () => {
      activatedRef.current = false;
    };
  }, []);
  const handleRef = useForkRef(getReactElementRef(children), nodeRef);

  // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviors like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.
  const handleClickAway = useEventCallback(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = ownerDocument(nodeRef.current);

    // 1. IE11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.
    if (!activatedRef.current || !nodeRef.current || 'clientX' in event && clickedRootScrollbar(event, doc)) {
      return;
    }

    // Do not act if user performed touchmove
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    let insideDOM;

    // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target) || nodeRef.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target);
    }
    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  });

  // Keep track of mouse/touch events that bubbled up through the portal.
  const createHandleSynthetic = handlerName => event => {
    syntheticEventRef.current = true;
    const childrenPropsHandler = children.props[handlerName];
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  const childrenProps = {
    ref: handleRef
  };
  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }
  React.useEffect(() => {
    if (touchEvent !== false) {
      const mappedTouchEvent = mapEventPropToEvent(touchEvent);
      const doc = ownerDocument(nodeRef.current);
      const handleTouchMove = () => {
        movedRef.current = true;
      };
      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return () => {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }
    return undefined;
  }, [handleClickAway, touchEvent]);
  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }
  React.useEffect(() => {
    if (mouseEvent !== false) {
      const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      const doc = ownerDocument(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return () => {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }
    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/jsx(React.Fragment, {
    children: /*#__PURE__*/React.cloneElement(children, childrenProps)
  });
}
process.env.NODE_ENV !== "production" ? ClickAwayListener.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: PropTypes.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: PropTypes.oneOf(['onClick', 'onMouseDown', 'onMouseUp', 'onPointerDown', 'onPointerUp', false]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: PropTypes.oneOf(['onTouchEnd', 'onTouchStart', false])
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  ClickAwayListener['propTypes' + ''] = exactProp(ClickAwayListener.propTypes);
}

function getSnackbarContentUtilityClass(slot) {
  return generateUtilityClass('MuiSnackbarContent', slot);
}
generateUtilityClasses('MuiSnackbarContent', ['root', 'message', 'action']);

const _excluded$1 = ["action", "className", "message", "role"];
const useUtilityClasses$1 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    action: ['action'],
    message: ['message']
  };
  return composeClasses(slots, getSnackbarContentUtilityClass, classes);
};
const SnackbarContentRoot = styled(Paper, {
  name: 'MuiSnackbarContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
  const backgroundColor = colorManipulatorExports.emphasize(theme.palette.background.default, emphasis);
  return _extends({}, theme.typography.body2, {
    color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
    backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      flexGrow: 'initial',
      minWidth: 288
    }
  });
});
const SnackbarContentMessage = styled('div', {
  name: 'MuiSnackbarContent',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0'
});
const SnackbarContentAction = styled('div', {
  name: 'MuiSnackbarContent',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  paddingLeft: 16,
  marginRight: -8
});
const SnackbarContent = /*#__PURE__*/React.forwardRef(function SnackbarContent(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiSnackbarContent'
  });
  const {
      action,
      className,
      message,
      role = 'alert'
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded$1);
  const ownerState = props;
  const classes = useUtilityClasses$1(ownerState);
  return /*#__PURE__*/jsxs(SnackbarContentRoot, _extends({
    role: role,
    square: true,
    elevation: 6,
    className: clsx$1(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/jsx(SnackbarContentMessage, {
      className: classes.message,
      ownerState: ownerState,
      children: message
    }), action ? /*#__PURE__*/jsx(SnackbarContentAction, {
      className: classes.action,
      ownerState: ownerState,
      children: action
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? SnackbarContent.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The message to display.
   */
  message: PropTypes.node,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: PropTypes /* @typescript-to-proptypes-ignore */.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
var SnackbarContent$1 = SnackbarContent;

function getSnackbarUtilityClass(slot) {
  return generateUtilityClass('MuiSnackbar', slot);
}
generateUtilityClasses('MuiSnackbar', ['root', 'anchorOriginTopCenter', 'anchorOriginBottomCenter', 'anchorOriginTopRight', 'anchorOriginBottomRight', 'anchorOriginTopLeft', 'anchorOriginBottomLeft']);

const _excluded = ["onEnter", "onExited"],
  _excluded2 = ["action", "anchorOrigin", "autoHideDuration", "children", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onBlur", "onClose", "onFocus", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"];
const useUtilityClasses = ownerState => {
  const {
    classes,
    anchorOrigin
  } = ownerState;
  const slots = {
    root: ['root', `anchorOrigin${capitalize(anchorOrigin.vertical)}${capitalize(anchorOrigin.horizontal)}`]
  };
  return composeClasses(slots, getSnackbarUtilityClass, classes);
};
const SnackbarRoot = styled('div', {
  name: 'MuiSnackbar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`anchorOrigin${capitalize(ownerState.anchorOrigin.vertical)}${capitalize(ownerState.anchorOrigin.horizontal)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return _extends({
    zIndex: (theme.vars || theme).zIndex.snackbar,
    position: 'fixed',
    display: 'flex',
    left: 8,
    right: 8,
    justifyContent: 'center',
    alignItems: 'center'
  }, ownerState.anchorOrigin.vertical === 'top' ? {
    top: 8
  } : {
    bottom: 8
  }, ownerState.anchorOrigin.horizontal === 'left' && {
    justifyContent: 'flex-start'
  }, ownerState.anchorOrigin.horizontal === 'right' && {
    justifyContent: 'flex-end'
  }, {
    [theme.breakpoints.up('sm')]: _extends({}, ownerState.anchorOrigin.vertical === 'top' ? {
      top: 24
    } : {
      bottom: 24
    }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
      left: 24,
      right: 'auto'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
      right: 24,
      left: 'auto'
    })
  });
});
const Snackbar = /*#__PURE__*/React.forwardRef(function Snackbar(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: 'MuiSnackbar'
  });
  const theme = useTheme$3();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      action,
      anchorOrigin: {
        vertical,
        horizontal
      } = {
        vertical: 'bottom',
        horizontal: 'left'
      },
      autoHideDuration = null,
      children,
      className,
      ClickAwayListenerProps,
      ContentProps,
      disableWindowBlurListener = false,
      message,
      open,
      TransitionComponent = Grow,
      transitionDuration = defaultTransitionDuration,
      TransitionProps: {
        onEnter,
        onExited
      } = {}
    } = props,
    TransitionProps = _objectWithoutPropertiesLoose(props.TransitionProps, _excluded),
    other = _objectWithoutPropertiesLoose(props, _excluded2);
  const ownerState = _extends({}, props, {
    anchorOrigin: {
      vertical,
      horizontal
    },
    autoHideDuration,
    disableWindowBlurListener,
    TransitionComponent,
    transitionDuration
  });
  const classes = useUtilityClasses(ownerState);
  const {
    getRootProps,
    onClickAway
  } = useSnackbar(_extends({}, ownerState));
  const [exited, setExited] = React.useState(true);
  const rootProps = useSlotProps({
    elementType: SnackbarRoot,
    getSlotProps: getRootProps,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    },
    className: [classes.root, className]
  });
  const handleExited = node => {
    setExited(true);
    if (onExited) {
      onExited(node);
    }
  };
  const handleEnter = (node, isAppearing) => {
    setExited(false);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  // So we only render active snackbars.
  if (!open && exited) {
    return null;
  }
  return /*#__PURE__*/jsx(ClickAwayListener, _extends({
    onClickAway: onClickAway
  }, ClickAwayListenerProps, {
    children: /*#__PURE__*/jsx(SnackbarRoot, _extends({}, rootProps, {
      children: /*#__PURE__*/jsx(TransitionComponent, _extends({
        appear: true,
        in: open,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up',
        onEnter: handleEnter,
        onExited: handleExited
      }, TransitionProps, {
        children: children || /*#__PURE__*/jsx(SnackbarContent$1, _extends({
          message: message,
          action: action
        }, ContentProps))
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Snackbar.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,
  /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['center', 'left', 'right']).isRequired,
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired
  }),
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */
  autoHideDuration: PropTypes.number,
  /**
   * Replace the `SnackbarContent` component.
   */
  children: PropTypes.element,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: PropTypes.object,
  /**
   * Props applied to the [`SnackbarContent`](/material-ui/api/snackbar-content/) element.
   */
  ContentProps: PropTypes.object,
  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */
  disableWindowBlurListener: PropTypes.bool,
  /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */
  key: () => null,
  /**
   * The message to display.
   */
  message: PropTypes.node,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * @ignore
   */
  onMouseEnter: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: PropTypes.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object
} : void 0;
var Snackbar$1 = Snackbar;

const UndoToastComponent = ({ documentId, buttonTitle }) => {
    const actions = useDocumentActions();
    const dispatch = useTypedDispatch();
    const notification = useTypedSelector(selectNextNotification, shallowEqual);
    const undoRemoveFavourite = () => {
        if (notification) {
            dispatch(removeNotification(notification));
        }
        actions.favourite({ documentId, favourite: true, skipNotification: true });
    };
    return (React__default.createElement("div", { className: "UndoToastComponent" },
        React__default.createElement("button", { color: "secondary", onClick: undoRemoveFavourite }, buttonTitle)));
};

const Notifier = () => {
    const dispatch = useTypedDispatch();
    const notification = useTypedSelector(selectNextNotification, shallowEqual);
    const onMobile = useOnMobile();
    const getComponentType = () => {
        var _a;
        switch ((_a = notification === null || notification === void 0 ? void 0 : notification.action) === null || _a === void 0 ? void 0 : _a.type) {
            case UndoActionTypes.UndoRemoveFavouriteContentItemAction: {
                return (React__default.createElement("div", null,
                    React__default.createElement(UndoToastComponent, { buttonTitle: notification.action.buttonTitle, documentId: notification.action.documentId })));
            }
        }
    };
    function onClose() {
        if (notification) {
            dispatch(removeNotification(notification));
        }
    }
    return React__default.createElement(Snackbar$1, { key: notification === null || notification === void 0 ? void 0 : notification.id, open: notification !== undefined, message: notification === null || notification === void 0 ? void 0 : notification.message, autoHideDuration: 3500, anchorOrigin: {
            vertical: onMobile ? 'bottom' : 'top',
            horizontal: 'center'
        }, onClose: onClose, action: notification && notification.action && getComponentType() });
};

function useRelogin() {
    const location = useLocation();
    const { logIn } = useLogin();
    return useMemo(() => ({
        relogin: checkReloginParam => {
            const queryParams = new URLSearchParams(location.search);
            if (!checkReloginParam || queryParams.has('relogin')) {
                clearTokens();
                logIn();
                return true;
            }
            return false;
        }
    }), [location.search, logIn]);
}

const FullScreenMessage = ({ title, message, buttons }) => {
    return React__default.createElement(Centred, null,
        React__default.createElement("div", { className: className$5() },
            React__default.createElement("h1", null, title),
            React__default.createElement("p", null, message),
            React__default.createElement("div", { className: className$5('buttons') }, buttons)));
};
const className$5 = createClassName('FullScreenMessage');

const Init = ({ children }) => {
    const { app: strings, buttons: buttonStrings } = useStrings();
    const { relogin } = useRelogin();
    const dispatch = useTypedDispatch();
    const [connectionStatus, setConnectionStatus] = useState('pending');
    const [authenticated, setAuthenticated] = useState(false);
    const [vehicleLoaded, setVehicleLoaded] = useState(false);
    const loggedIn = useTypedSelector(selectIsLoggedIn);
    const featureToggles = useFeatureToggles();
    const mandatoryLogin = featureToggles.isFeatureToggleEnabled('MANDATORY_LOGIN');
    useShowLoadingIndicator(connectionStatus === 'pending' || (connectionStatus === 'success' && !authenticated));
    function retryConnection() {
        setConnectionStatus('pending');
        featureToggles.refetch();
    }
    // Check connection to ITIS.
    useEffect(() => {
        if (connectionStatus === 'pending' && !featureToggles.isLoading) {
            const error = featureToggles.error;
            if (error && 'status' in error && (error.status === 'FETCH_ERROR' || error.status === 503)) {
                setConnectionStatus('error');
            }
            else {
                setConnectionStatus('success');
            }
        }
    }, [connectionStatus, dispatch, featureToggles]);
    // Authenticate when connected.
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (connectionStatus === 'success' && !authenticated && !relogin(true)) {
                yield dispatch(authenticate());
                setAuthenticated(true);
            }
        }))();
    }, [connectionStatus, authenticated, relogin, dispatch]);
    // Load vehicle after authentication.
    useEffect(() => {
        if (authenticated && !vehicleLoaded) {
            if (loggedIn || !mandatoryLogin) {
                dispatch(loadSessionVehicle());
            }
            setVehicleLoaded(true);
        }
    }, [authenticated, vehicleLoaded, loggedIn, mandatoryLogin, dispatch]);
    if (connectionStatus === 'success' && authenticated) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    if (connectionStatus === 'error') {
        return React__default.createElement(FullScreenMessage, { title: strings.initErrorTitle, message: strings.initErrorDescription, buttons: React__default.createElement(Button$2, { onClick: retryConnection }, buttonStrings.tryAgain) });
    }
    return null;
};

const AuthRevokedListener = () => {
    const navigation = useNavigation();
    const dispatch = useTypedDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const isAuthRevoked = useTypedSelector(selectIsAuthRevoked);
    const [handledRevoke, setHandledRevoke] = useState(false);
    const loginUrl = navigation.login(location);
    const moduleAuthRevokedStrategy = useModuleAuthRevokeStrategy();
    useEffect(() => {
        const defaultAuthRevokedStrategy = {
            logoutBackend: false,
            redirectUrl: loginUrl
        };
        const handleRevoke = () => __awaiter(void 0, void 0, void 0, function* () {
            if (isAuthRevoked) {
                if (!handledRevoke) {
                    setHandledRevoke(true);
                    const customAuthRevokedStrategy = yield moduleAuthRevokedStrategy();
                    const authRevokedStrategy = customAuthRevokedStrategy !== null && customAuthRevokedStrategy !== void 0 ? customAuthRevokedStrategy : defaultAuthRevokedStrategy;
                    yield dispatch(logOut({ authRevoked: !authRevokedStrategy.logoutBackend }));
                    navigate(authRevokedStrategy.redirectUrl);
                }
            }
            else {
                setHandledRevoke(false);
            }
        });
        handleRevoke();
    }, [dispatch, isAuthRevoked, navigate, handledRevoke, loginUrl, moduleAuthRevokedStrategy]);
    return null;
};

const DEFAULT_UPDATE_INTERVAL = 120000;
/**
 * Updates user status on a timer.
 */
const UserStatusUpdater = () => {
    const { userStatusUpdateInterval } = useContext();
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    useGetUserStatusQuery(undefined, {
        skip: !isLoggedIn,
        pollingInterval: userStatusUpdateInterval !== null && userStatusUpdateInterval !== void 0 ? userStatusUpdateInterval : DEFAULT_UPDATE_INTERVAL
    });
    return null;
};

function getDeepProperty(obj, keys, keyIndex = 0) {
    if (keyIndex >= keys.length) {
        return obj;
    }
    const entry = Object.entries(obj).find(([key]) => key === keys[keyIndex]);
    if (entry) {
        return getDeepProperty(entry[1], keys, keyIndex + 1);
    }
    return null;
}
function isHelpSection(value) {
    // A help section is defined as having one or more numeric keys.
    return typeof value === 'object' && value !== null && !Array.isArray(value) &&
        Object.keys(value).find(key => !isNaN(Number(key))) !== undefined;
}
function buildHelp(strings, key) {
    const section = getDeepProperty(strings, key.split('.'));
    if (!section) {
        throw Error(`Help key '${key}' not found.`);
    }
    if (!isHelpSection(section)) {
        return null;
    }
    // Generate content from sorted numeric keys.
    const elements = Object.keys(section)
        .map(key => Number(key))
        .filter(key => !isNaN(key))
        .sort((leftKey, rightKey) => leftKey - rightKey)
        .map(key => section[key])
        .flatMap((item, index) => {
        if (item !== null) {
            const [tag, text] = Array.isArray(item) ? item : ['p', item]; // Default to <p> if no tag specified.
            if (!['script', 'style'].includes(tag)) {
                return [React__default.createElement(Text, { key: index, element: tag }, text)]; // eslint-disable react/no-array-index-key
            }
        }
        return [];
    });
    return {
        title: section.title,
        content: React__default.createElement(React__default.Fragment, null, elements)
    };
}

const HelpDialogue = () => {
    var _a;
    const { help: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const helpKey = useTypedSelector(selectCurrentHelpKey);
    const showHelp = useTypedSelector(selectShowHelp);
    const [help, setHelp] = useState(null);
    const helpStrings = useHelpStrings();
    const closeDialogue = useCallback(() => {
        dispatch(hideHelp());
    }, [dispatch]);
    useEffect(() => {
        function showNoHelpNotification() {
            dispatch(queueNotification(strings.noHelp));
            closeDialogue();
        }
        if (showHelp && helpKey) {
            const help = buildHelp(helpStrings, helpKey);
            if (!help) {
                showNoHelpNotification();
            }
            setHelp(help);
        }
        else if (showHelp) {
            showNoHelpNotification();
        }
        else {
            setHelp(null);
        }
    }, [showHelp, helpKey, dispatch, strings.noHelp, closeDialogue, helpStrings]);
    if (!help) {
        return null;
    }
    return React__default.createElement(Dialogue, { className: "HelpDialogue", isOpen: helpKey !== null, onClose: closeDialogue },
        React__default.createElement(Dialogue.Header, { title: (_a = help.title) !== null && _a !== void 0 ? _a : strings.title, border: true, onClose: closeDialogue }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement("div", { className: "HelpDialogue-content" }, help.content)));
};

const LogOut = () => {
    const { basePath } = useContext();
    const dispatch = useTypedDispatch();
    const { search } = useLocation();
    const query = queryString.parse(search);
    const back = typeof query.back === 'string' ? query.back : '/';
    useEffect(() => {
        function doLogOut() {
            return __awaiter(this, void 0, void 0, function* () {
                yield dispatch(logOut());
                const backUrl = back.startsWith('/') ? joinPath(basePath, back) : back;
                window.location.replace(backUrl);
            });
        }
        doLogOut();
    }, [dispatch, back, basePath]);
    return null;
};

const CookieNotificationView = () => {
    const [open, setOpen] = React__default.useState(showCookieNotification());
    const [dialogueOpen, setDialogueOpen] = React__default.useState(false);
    const { legal: strings } = useStrings();
    const onMobile = useOnMobile();
    const buttons = [
        React__default.createElement(Button$1, { key: "agree", color: "secondary", onClick: () => onAgree() }, strings.cookie.cookieAgreeButton),
        React__default.createElement(Button$1, { key: "details", color: "secondary", onClick: () => openDialogue() }, strings.cookie.details)
    ];
    // Hides the snack bar when the notification view is open
    function openDialogue() {
        setDialogueOpen(true);
        setOpen(false);
    }
    function onAgree() {
        saveCookiePreferences(CookiePreference.NewRelic, true);
        agreeCookiePolicy();
        window.location.reload();
    }
    function onClose() {
        setDialogueOpen(false);
        setOpen(showCookieNotification());
    }
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(CookiePreferencesDialogue, { isOpen: dialogueOpen, onClose: () => onClose() }),
        React__default.createElement(Snackbar$1, { id: "cookieNotification", className: "CookieNotificationView-popup", open: open, message: strings.cookie.para2, anchorOrigin: {
                vertical: 'bottom',
                horizontal: onMobile ? 'center' : 'right'
            }, action: buttons }));
};

var uaParserExports$1 = {};
var uaParser$1 = {
  get exports(){ return uaParserExports$1; },
  set exports(v){ uaParserExports$1 = v; },
};

var hasRequiredUaParser;

function requireUaParser () {
	if (hasRequiredUaParser) return uaParserExports$1;
	hasRequiredUaParser = 1;
	(function (module, exports) {
		/////////////////////////////////////////////////////////////////////////////////
		/* UAParser.js v0.7.35
		   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
		   MIT License *//*
		   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
		   Supports browser & node.js environment. 
		   Demo   : https://faisalman.github.io/ua-parser-js
		   Source : https://github.com/faisalman/ua-parser-js */
		/////////////////////////////////////////////////////////////////////////////////

		(function (window, undefined$1) {

		    //////////////
		    // Constants
		    /////////////


		    var LIBVERSION  = '0.7.35',
		        EMPTY       = '',
		        UNKNOWN     = '?',
		        FUNC_TYPE   = 'function',
		        UNDEF_TYPE  = 'undefined',
		        OBJ_TYPE    = 'object',
		        STR_TYPE    = 'string',
		        MAJOR       = 'major',
		        MODEL       = 'model',
		        NAME        = 'name',
		        TYPE        = 'type',
		        VENDOR      = 'vendor',
		        VERSION     = 'version',
		        ARCHITECTURE= 'architecture',
		        CONSOLE     = 'console',
		        MOBILE      = 'mobile',
		        TABLET      = 'tablet',
		        SMARTTV     = 'smarttv',
		        WEARABLE    = 'wearable',
		        EMBEDDED    = 'embedded',
		        UA_MAX_LENGTH = 350;

		    var AMAZON  = 'Amazon',
		        APPLE   = 'Apple',
		        ASUS    = 'ASUS',
		        BLACKBERRY = 'BlackBerry',
		        BROWSER = 'Browser',
		        CHROME  = 'Chrome',
		        EDGE    = 'Edge',
		        FIREFOX = 'Firefox',
		        GOOGLE  = 'Google',
		        HUAWEI  = 'Huawei',
		        LG      = 'LG',
		        MICROSOFT = 'Microsoft',
		        MOTOROLA  = 'Motorola',
		        OPERA   = 'Opera',
		        SAMSUNG = 'Samsung',
		        SHARP   = 'Sharp',
		        SONY    = 'Sony',
		        XIAOMI  = 'Xiaomi',
		        ZEBRA   = 'Zebra',
		        FACEBOOK    = 'Facebook',
		        CHROMIUM_OS = 'Chromium OS',
		        MAC_OS  = 'Mac OS';

		    ///////////
		    // Helper
		    //////////

		    var extend = function (regexes, extensions) {
		            var mergedRegexes = {};
		            for (var i in regexes) {
		                if (extensions[i] && extensions[i].length % 2 === 0) {
		                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
		                } else {
		                    mergedRegexes[i] = regexes[i];
		                }
		            }
		            return mergedRegexes;
		        },
		        enumerize = function (arr) {
		            var enums = {};
		            for (var i=0; i<arr.length; i++) {
		                enums[arr[i].toUpperCase()] = arr[i];
		            }
		            return enums;
		        },
		        has = function (str1, str2) {
		            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
		        },
		        lowerize = function (str) {
		            return str.toLowerCase();
		        },
		        majorize = function (version) {
		            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
		        },
		        trim = function (str, len) {
		            if (typeof(str) === STR_TYPE) {
		                str = str.replace(/^\s\s*/, EMPTY);
		                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
		            }
		    };

		    ///////////////
		    // Map helper
		    //////////////

		    var rgxMapper = function (ua, arrays) {

		            var i = 0, j, k, p, q, matches, match;

		            // loop through all regexes maps
		            while (i < arrays.length && !matches) {

		                var regex = arrays[i],       // even sequence (0,2,4,..)
		                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
		                j = k = 0;

		                // try matching uastring with regexes
		                while (j < regex.length && !matches) {

		                    if (!regex[j]) { break; }
		                    matches = regex[j++].exec(ua);

		                    if (!!matches) {
		                        for (p = 0; p < props.length; p++) {
		                            match = matches[++k];
		                            q = props[p];
		                            // check if given property is actually array
		                            if (typeof q === OBJ_TYPE && q.length > 0) {
		                                if (q.length === 2) {
		                                    if (typeof q[1] == FUNC_TYPE) {
		                                        // assign modified match
		                                        this[q[0]] = q[1].call(this, match);
		                                    } else {
		                                        // assign given value, ignore regex match
		                                        this[q[0]] = q[1];
		                                    }
		                                } else if (q.length === 3) {
		                                    // check whether function or regex
		                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
		                                        // call function (usually string mapper)
		                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
		                                    } else {
		                                        // sanitize match using given regex
		                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
		                                    }
		                                } else if (q.length === 4) {
		                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
		                                }
		                            } else {
		                                this[q] = match ? match : undefined$1;
		                            }
		                        }
		                    }
		                }
		                i += 2;
		            }
		        },

		        strMapper = function (str, map) {

		            for (var i in map) {
		                // check if current value is array
		                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
		                    for (var j = 0; j < map[i].length; j++) {
		                        if (has(map[i][j], str)) {
		                            return (i === UNKNOWN) ? undefined$1 : i;
		                        }
		                    }
		                } else if (has(map[i], str)) {
		                    return (i === UNKNOWN) ? undefined$1 : i;
		                }
		            }
		            return str;
		    };

		    ///////////////
		    // String map
		    //////////////

		    // Safari < 3.0
		    var oldSafariMap = {
		            '1.0'   : '/8',
		            '1.2'   : '/1',
		            '1.3'   : '/3',
		            '2.0'   : '/412',
		            '2.0.2' : '/416',
		            '2.0.3' : '/417',
		            '2.0.4' : '/419',
		            '?'     : '/'
		        },
		        windowsVersionMap = {
		            'ME'        : '4.90',
		            'NT 3.11'   : 'NT3.51',
		            'NT 4.0'    : 'NT4.0',
		            '2000'      : 'NT 5.0',
		            'XP'        : ['NT 5.1', 'NT 5.2'],
		            'Vista'     : 'NT 6.0',
		            '7'         : 'NT 6.1',
		            '8'         : 'NT 6.2',
		            '8.1'       : 'NT 6.3',
		            '10'        : ['NT 6.4', 'NT 10.0'],
		            'RT'        : 'ARM'
		    };

		    //////////////
		    // Regex map
		    /////////////

		    var regexes = {

		        browser : [[

		            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
		            ], [VERSION, [NAME, 'Chrome']], [
		            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
		            ], [VERSION, [NAME, 'Edge']], [

		            // Presto based
		            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
		            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
		            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
		            ], [NAME, VERSION], [
		            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
		            ], [VERSION, [NAME, OPERA+' Mini']], [
		            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
		            ], [VERSION, [NAME, OPERA]], [

		            // Mixed
		            /(kindle)\/([\w\.]+)/i,                                             // Kindle
		            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
		            // Trident based
		            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
		            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
		            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

		            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
		            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
		                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
		            /(heytap|ovi)browser\/([\d\.]+)/i,                                  // Heytap/Ovi
		            /(weibo)__([\d\.]+)/i                                               // Weibo
		            ], [NAME, VERSION], [
		            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
		            ], [VERSION, [NAME, 'UC'+BROWSER]], [
		            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
		            /\bqbcore\/([\w\.]+).+microm/i
		            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
		            /micromessenger\/([\w\.]+)/i                                        // WeChat
		            ], [VERSION, [NAME, 'WeChat']], [
		            /konqueror\/([\w\.]+)/i                                             // Konqueror
		            ], [VERSION, [NAME, 'Konqueror']], [
		            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
		            ], [VERSION, [NAME, 'IE']], [
		            /ya(?:search)?browser\/([\w\.]+)/i                                  // Yandex
		            ], [VERSION, [NAME, 'Yandex']], [
		            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
		            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
		            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
		            ], [VERSION, [NAME, FIREFOX+' Focus']], [
		            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
		            ], [VERSION, [NAME, OPERA+' Touch']], [
		            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
		            ], [VERSION, [NAME, 'Coc Coc']], [
		            /dolfin\/([\w\.]+)/i                                                // Dolphin
		            ], [VERSION, [NAME, 'Dolphin']], [
		            /coast\/([\w\.]+)/i                                                 // Opera Coast
		            ], [VERSION, [NAME, OPERA+' Coast']], [
		            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
		            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
		            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
		            ], [VERSION, [NAME, FIREFOX]], [
		            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
		            ], [[NAME, '360 '+BROWSER]], [
		            /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
		            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish/Huawei Browser
		            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
		            ], [[NAME, /_/g, ' '], VERSION], [
		            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
		            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
		            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
		            ], [NAME, VERSION], [
		            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
		            /(lbbrowser)/i,                                                     // LieBao Browser
		            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
		            ], [NAME], [

		            // WebView
		            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
		            ], [[NAME, FACEBOOK], VERSION], [
		            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,                             // Kakao App
		            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,                                  // Naver InApp
		            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
		            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
		            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
		            ], [NAME, VERSION], [
		            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
		            ], [VERSION, [NAME, 'GSA']], [
		            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i                        // TikTok
		            ], [VERSION, [NAME, 'TikTok']], [

		            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
		            ], [VERSION, [NAME, CHROME+' Headless']], [

		            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
		            ], [[NAME, CHROME+' WebView'], VERSION], [

		            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
		            ], [VERSION, [NAME, 'Android '+BROWSER]], [

		            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
		            ], [NAME, VERSION], [

		            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
		            ], [VERSION, [NAME, 'Mobile Safari']], [
		            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
		            ], [VERSION, NAME], [
		            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
		            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

		            /(webkit|khtml)\/([\w\.]+)/i
		            ], [NAME, VERSION], [

		            // Gecko based
		            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
		            ], [[NAME, 'Netscape'], VERSION], [
		            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
		            ], [VERSION, [NAME, FIREFOX+' Reality']], [
		            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
		            /(swiftfox)/i,                                                      // Swiftfox
		            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
		                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
		            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
		                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
		            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
		            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

		            // Other
		            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
		                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
		            /(links) \(([\w\.]+)/i,                                             // Links
		            /panasonic;(viera)/i                                                // Panasonic Viera
		            ], [NAME, VERSION], [
		            
		            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
		            ], [NAME, [VERSION, /master.|lts./, ""]]
		        ],

		        cpu : [[

		            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
		            ], [[ARCHITECTURE, 'amd64']], [

		            /(ia32(?=;))/i                                                      // IA32 (quicktime)
		            ], [[ARCHITECTURE, lowerize]], [

		            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
		            ], [[ARCHITECTURE, 'ia32']], [

		            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
		            ], [[ARCHITECTURE, 'arm64']], [

		            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
		            ], [[ARCHITECTURE, 'armhf']], [

		            // PocketPC mistakenly identified as PowerPC
		            /windows (ce|mobile); ppc;/i
		            ], [[ARCHITECTURE, 'arm']], [

		            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
		            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

		            /(sun4\w)[;\)]/i                                                    // SPARC
		            ], [[ARCHITECTURE, 'sparc']], [

		            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
		                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
		            ], [[ARCHITECTURE, lowerize]]
		        ],

		        device : [[

		            //////////////////////////
		            // MOBILES & TABLETS
		            /////////////////////////

		            // Samsung
		            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
		            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
		            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
		            /samsung[- ]([-\w]+)/i,
		            /sec-(sgh\w+)/i
		            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

		            // Apple
		            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i                          // iPod/iPhone
		            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
		            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
		            /applecoremedia\/[\w\.]+ \((ipad)/i,
		            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
		            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
		            /(macintosh);/i
		            ], [MODEL, [VENDOR, APPLE]], [

		            // Sharp
		            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
		            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

		            // Huawei
		            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
		            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
		            /(?:huawei|honor)([-\w ]+)[;\)]/i,
		            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
		            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

		            // Xiaomi
		            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
		            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
		            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
		            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
		            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
		            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
		            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
		            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

		            // OPPO
		            /; (\w+) bui.+ oppo/i,
		            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
		            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

		            // Vivo
		            /vivo (\w+)(?: bui|\))/i,
		            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
		            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

		            // Realme
		            /\b(rmx[12]\d{3})(?: bui|;|\))/i
		            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

		            // Motorola
		            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
		            /\bmot(?:orola)?[- ](\w*)/i,
		            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
		            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
		            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
		            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

		            // LG
		            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
		            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
		            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
		            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
		            /\blg-?([\d\w]+) bui/i
		            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

		            // Lenovo
		            /(ideatab[-\w ]+)/i,
		            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
		            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

		            // Nokia
		            /(?:maemo|nokia).*(n900|lumia \d+)/i,
		            /nokia[-_ ]?([-\w\.]*)/i
		            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

		            // Google
		            /(pixel c)\b/i                                                      // Google Pixel C
		            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
		            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
		            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

		            // Sony
		            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
		            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
		            /sony tablet [ps]/i,
		            /\b(?:sony)?sgp\w+(?: bui|\))/i
		            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

		            // OnePlus
		            / (kb2005|in20[12]5|be20[12][59])\b/i,
		            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
		            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

		            // Amazon
		            /(alexa)webm/i,
		            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,                             // Kindle Fire without Silk / Echo Show
		            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
		            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
		            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
		            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

		            // BlackBerry
		            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
		            ], [MODEL, VENDOR, [TYPE, TABLET]], [
		            /\b((?:bb[a-f]|st[hv])100-\d)/i,
		            /\(bb10; (\w+)/i                                                    // BlackBerry 10
		            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

		            // Asus
		            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
		            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
		            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
		            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

		            // HTC
		            /(nexus 9)/i                                                        // HTC Nexus 9
		            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
		            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

		            // ZTE
		            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
		            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
		            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

		            // Acer
		            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
		            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

		            // Meizu
		            /droid.+; (m[1-5] note) bui/i,
		            /\bmz-([-\w]{2,})/i
		            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

		            // MIXED
		            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
		                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
		            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
		            /(asus)-?(\w+)/i,                                                   // Asus
		            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
		            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
		            /(jolla)/i,                                                         // Jolla
		            /(oppo) ?([\w ]+) bui/i                                             // OPPO
		            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

		            /(kobo)\s(ereader|touch)/i,                                         // Kobo
		            /(archos) (gamepad2?)/i,                                            // Archos
		            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
		            /(kindle)\/([\w\.]+)/i,                                             // Kindle
		            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
		            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
		            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
		            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
		            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
		            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
		            ], [VENDOR, MODEL, [TYPE, TABLET]], [

		            /(surface duo)/i                                                    // Surface Duo
		            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
		            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
		            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
		            /(u304aa)/i                                                         // AT&T
		            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
		            /\bsie-(\w*)/i                                                      // Siemens
		            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
		            /\b(rct\w+) b/i                                                     // RCA Tablets
		            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
		            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
		            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
		            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
		            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
		            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
		            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
		            /\b(tm\d{3}\w+) b/i
		            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
		            /\b(k88) b/i                                                        // ZTE K Series Tablet
		            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
		            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
		            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
		            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
		            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
		            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
		            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
		            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
		            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
		            /\b([yr]\d{2}) b/i,
		            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
		            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
		            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
		            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
		            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
		            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
		            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
		            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
		            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
		            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
		            /\b(ph-1) /i                                                        // Essential PH-1
		            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
		            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
		            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
		            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
		            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
		            /\btu_(1491) b/i                                                    // Rotor Tablets
		            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
		            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
		            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
		            /(sprint) (\w+)/i                                                   // Sprint Phones
		            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
		            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
		            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
		            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
		            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
		            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
		            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

		            ///////////////////
		            // SMARTTVS
		            ///////////////////

		            /smart-tv.+(samsung)/i                                              // Samsung
		            ], [VENDOR, [TYPE, SMARTTV]], [
		            /hbbtv.+maple;(\d+)/i
		            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
		            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
		            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
		            /(apple) ?tv/i                                                      // Apple TV
		            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
		            /crkey/i                                                            // Google Chromecast
		            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
		            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
		            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
		            /\(dtv[\);].+(aquos)/i,
		            /(aquos-tv[\w ]+)\)/i                                               // Sharp
		            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
		            /(bravia[\w ]+)( bui|\))/i                                              // Sony
		            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
		            /(mitv-\w{5}) bui/i                                                 // Xiaomi
		            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
		            /Hbbtv.*(technisat) (.*);/i                                         // TechniSAT
		            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
		            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
		            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i         // HbbTV devices
		            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
		            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
		            ], [[TYPE, SMARTTV]], [

		            ///////////////////
		            // CONSOLES
		            ///////////////////

		            /(ouya)/i,                                                          // Ouya
		            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
		            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
		            /droid.+; (shield) bui/i                                            // Nvidia
		            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
		            /(playstation [345portablevi]+)/i                                   // Playstation
		            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
		            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
		            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

		            ///////////////////
		            // WEARABLES
		            ///////////////////

		            /((pebble))app/i                                                    // Pebble
		            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
		            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i                              // Apple Watch
		            ], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [
		            /droid.+; (glass) \d/i                                              // Google Glass
		            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
		            /droid.+; (wt63?0{2,3})\)/i
		            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
		            /(quest( 2| pro)?)/i                                                // Oculus Quest
		            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

		            ///////////////////
		            // EMBEDDED
		            ///////////////////

		            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
		            ], [VENDOR, [TYPE, EMBEDDED]], [
		            /(aeobc)\b/i                                                        // Echo Dot
		            ], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [

		            ////////////////////
		            // MIXED (GENERIC)
		            ///////////////////

		            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
		            ], [MODEL, [TYPE, MOBILE]], [
		            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
		            ], [MODEL, [TYPE, TABLET]], [
		            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
		            ], [[TYPE, TABLET]], [
		            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
		            ], [[TYPE, MOBILE]], [
		            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
		            ], [MODEL, [VENDOR, 'Generic']]
		        ],

		        engine : [[

		            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
		            ], [VERSION, [NAME, EDGE+'HTML']], [

		            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
		            ], [VERSION, [NAME, 'Blink']], [

		            /(presto)\/([\w\.]+)/i,                                             // Presto
		            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
		            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
		            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
		            /(icab)[\/ ]([23]\.[\d\.]+)/i,                                      // iCab
		            /\b(libweb)/i
		            ], [NAME, VERSION], [

		            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
		            ], [VERSION, NAME]
		        ],

		        os : [[

		            // Windows
		            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
		            ], [NAME, VERSION], [
		            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
		            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
		            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
		            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
		            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
		            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

		            // iOS/macOS
		            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
		            /ios;fbsv\/([\d\.]+)/i,
		            /cfnetwork\/.+darwin/i
		            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
		            /(mac os x) ?([\w\. ]*)/i,
		            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
		            ], [[NAME, MAC_OS], [VERSION, /_/g, '.']], [

		            // Mobile OSes
		            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
		            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
		            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
		            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
		            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
		            /\((series40);/i                                                    // Series 40
		            ], [NAME, VERSION], [
		            /\(bb(10);/i                                                        // BlackBerry 10
		            ], [VERSION, [NAME, BLACKBERRY]], [
		            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
		            ], [VERSION, [NAME, 'Symbian']], [
		            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
		            ], [VERSION, [NAME, FIREFOX+' OS']], [
		            /web0s;.+rt(tv)/i,
		            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
		            ], [VERSION, [NAME, 'webOS']], [
		            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i                              // watchOS
		            ], [VERSION, [NAME, 'watchOS']], [

		            // Google Chromecast
		            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
		            ], [VERSION, [NAME, CHROME+'cast']], [
		            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i                                  // Chromium OS
		            ], [[NAME, CHROMIUM_OS], VERSION],[

		            // Smart TVs
		            /panasonic;(viera)/i,                                               // Panasonic Viera
		            /(netrange)mmh/i,                                                   // Netrange
		            /(nettv)\/(\d+\.[\w\.]+)/i,                                         // NetTV

		            // Console
		            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
		            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

		            // Other
		            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
		            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
		            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
		            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
		                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
		            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
		            /(gnu) ?([\w\.]*)/i,                                                // GNU
		            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
		            /(haiku) (\w+)/i                                                    // Haiku
		            ], [NAME, VERSION], [
		            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
		            ], [[NAME, 'Solaris'], VERSION], [
		            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
		            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
		            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
		            /(unix) ?([\w\.]*)/i                                                // UNIX
		            ], [NAME, VERSION]
		        ]
		    };

		    /////////////////
		    // Constructor
		    ////////////////

		    var UAParser = function (ua, extensions) {

		        if (typeof ua === OBJ_TYPE) {
		            extensions = ua;
		            ua = undefined$1;
		        }

		        if (!(this instanceof UAParser)) {
		            return new UAParser(ua, extensions).getResult();
		        }

		        var _navigator = (typeof window !== UNDEF_TYPE && window.navigator) ? window.navigator : undefined$1;
		        var _ua = ua || ((_navigator && _navigator.userAgent) ? _navigator.userAgent : EMPTY);
		        var _uach = (_navigator && _navigator.userAgentData) ? _navigator.userAgentData : undefined$1;
		        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
		        var _isSelfNav = _navigator && _navigator.userAgent == _ua;

		        this.getBrowser = function () {
		            var _browser = {};
		            _browser[NAME] = undefined$1;
		            _browser[VERSION] = undefined$1;
		            rgxMapper.call(_browser, _ua, _rgxmap.browser);
		            _browser[MAJOR] = majorize(_browser[VERSION]);
		            // Brave-specific detection
		            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
		                _browser[NAME] = 'Brave';
		            }
		            return _browser;
		        };
		        this.getCPU = function () {
		            var _cpu = {};
		            _cpu[ARCHITECTURE] = undefined$1;
		            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
		            return _cpu;
		        };
		        this.getDevice = function () {
		            var _device = {};
		            _device[VENDOR] = undefined$1;
		            _device[MODEL] = undefined$1;
		            _device[TYPE] = undefined$1;
		            rgxMapper.call(_device, _ua, _rgxmap.device);
		            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
		                _device[TYPE] = MOBILE;
		            }
		            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
		            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
		                _device[MODEL] = 'iPad';
		                _device[TYPE] = TABLET;
		            }
		            return _device;
		        };
		        this.getEngine = function () {
		            var _engine = {};
		            _engine[NAME] = undefined$1;
		            _engine[VERSION] = undefined$1;
		            rgxMapper.call(_engine, _ua, _rgxmap.engine);
		            return _engine;
		        };
		        this.getOS = function () {
		            var _os = {};
		            _os[NAME] = undefined$1;
		            _os[VERSION] = undefined$1;
		            rgxMapper.call(_os, _ua, _rgxmap.os);
		            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != 'Unknown') {
		                _os[NAME] = _uach.platform  
		                                    .replace(/chrome os/i, CHROMIUM_OS)
		                                    .replace(/macos/i, MAC_OS);           // backward compatibility
		            }
		            return _os;
		        };
		        this.getResult = function () {
		            return {
		                ua      : this.getUA(),
		                browser : this.getBrowser(),
		                engine  : this.getEngine(),
		                os      : this.getOS(),
		                device  : this.getDevice(),
		                cpu     : this.getCPU()
		            };
		        };
		        this.getUA = function () {
		            return _ua;
		        };
		        this.setUA = function (ua) {
		            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
		            return this;
		        };
		        this.setUA(_ua);
		        return this;
		    };

		    UAParser.VERSION = LIBVERSION;
		    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
		    UAParser.CPU = enumerize([ARCHITECTURE]);
		    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
		    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

		    ///////////
		    // Export
		    //////////

		    // check js environment
		    {
		        // nodejs env
		        if (module.exports) {
		            exports = module.exports = UAParser;
		        }
		        exports.UAParser = UAParser;
		    }

		    // jQuery/Zepto specific (optional)
		    // Note:
		    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
		    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
		    //   and we should catch that.
		    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
		    if ($ && !$.ua) {
		        var parser = new UAParser();
		        $.ua = parser.getResult();
		        $.ua.get = function () {
		            return parser.getUA();
		        };
		        $.ua.set = function (ua) {
		            parser.setUA(ua);
		            var result = parser.getResult();
		            for (var prop in result) {
		                $.ua[prop] = result[prop];
		            }
		        };
		    }

		})(typeof window === 'object' ? window : commonjsGlobal);
} (uaParser$1, uaParserExports$1));
	return uaParserExports$1;
}

var uaParserExports = requireUaParser();
var uaParser = /*@__PURE__*/getDefaultExportFromCjs(uaParserExports);

const SupportedBrowsersDialogue = ({ isOpen, onClose }) => {
    const { browser: strings } = useStrings();
    const { os } = useMemo(() => uaParser(navigator.userAgent), []);
    return React__default.createElement(Dialogue, { className: "SupportedBrowsersDialogue", isOpen: isOpen, onClose: onClose },
        React__default.createElement(Dialogue.Header, { title: strings.supportedBrowsersTitle, onClose: onClose }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement("p", null, strings.supportedBrowsersMessage),
            React__default.createElement("ul", null,
                React__default.createElement("li", null,
                    React__default.createElement("a", { href: "https://www.google.com/chrome" }, strings.supportedBrowsers.chrome)),
                React__default.createElement("li", null,
                    React__default.createElement("a", { href: "https://www.mozilla.org/en-US/firefox/new" }, strings.supportedBrowsers.firefox)),
                os.name === 'Mac OS' && React__default.createElement("li", null,
                    React__default.createElement("a", { href: "http://www.apple.com/macos" }, strings.supportedBrowsers.safari)),
                os.name === 'Windows' && React__default.createElement("li", null,
                    React__default.createElement("a", { href: "https://www.microsoft.com/software-download/windows10" }, strings.supportedBrowsers.edge)))));
};

/**
 * Warning browser names and versions. Earlier versions will also display a warning.
 * Allowed browser names can be found here: https://github.com/faisalman/ua-parser-js
 */
const warningBrowsers = {
    IE: 11,
    Chrome: 83,
    Firefox: 82,
    Safari: 10,
    Edge: 85
};
function isWarningBrowser(userAgent) {
    const { browser } = uaParser(userAgent);
    if (!browser.name || !browser.version) {
        return false;
    }
    const warningVersion = warningBrowsers[browser.name];
    return typeof warningVersion === 'number' && parseInt(browser.version) <= warningVersion;
}

const BANNER_DISMISS_DATE_KEY = 'browserWarningDismissDate';
const BANNER_DISMISS_DURATION = { days: 30 };
const BrowserWarningBanner = () => {
    const { browser: strings, buttons: buttonStrings } = useStrings();
    const isBannerEnabled = useFeatureToggles().isFeatureToggleEnabled('OUTDATED_BROWSER_WARNING');
    const { isDismissed, dismiss } = useDismiss(BANNER_DISMISS_DATE_KEY, BANNER_DISMISS_DURATION);
    const [showDialogue, setShowDialogue] = useState(false);
    const closeDialogue = () => setShowDialogue(false);
    if (!isBannerEnabled || !isWarningBrowser() || isDismissed) {
        return null;
    }
    return React__default.createElement("div", { className: "BrowserWarningBanner" },
        React__default.createElement("div", { className: "BrowserWarningBanner-container" },
            React__default.createElement("p", null, strings.outdatedMessage),
            React__default.createElement(Button$2, { className: "BrowserWarningBanner-supported", onClick: () => setShowDialogue(true) }, strings.seeSupportedBrowsers)),
        React__default.createElement(IconButton$2, { className: "BrowserWarningBanner-hide", icon: faTimesExports.faTimes, iconSize: "lg", title: buttonStrings.hide, onClick: dismiss }),
        React__default.createElement(SupportedBrowsersDialogue, { isOpen: showDialogue, onClose: closeDialogue }));
};

/**
 * Component that automatically redirects to the login page when a `login` query parameter is `true`.
 */
const AutoLogin = ({ force, children }) => {
    const { logIn } = useLogin();
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const { undismiss: undismissNewLookPanel } = useNewLookPanelDismiss();
    const { pathname, search } = useLocation();
    const _a = queryString.parse(search), { login } = _a, queryWithoutLoginParam = __rest(_a, ["login"]);
    const autoLogin = (login === 'true' || force) && !isLoggedIn;
    const redirectUrl = queryString.stringifyUrl({
        url: pathname,
        query: queryWithoutLoginParam
    });
    useEffect(() => {
        if (autoLogin) {
            undismissNewLookPanel();
            logIn({ redirectUrl });
        }
    }, [autoLogin, undismissNewLookPanel, logIn, redirectUrl]);
    if (autoLogin) {
        return null; // Effect will redirect to login page.
    }
    if (login) {
        return React__default.createElement(Navigate, { to: redirectUrl, replace: true }); // Remove login parameter from URL.
    }
    return React__default.createElement(React__default.Fragment, null, children);
};

/** Component that looks for a `route` query parameter and redirects if it contains valid route data. */
const ExternalRouteHandler = ({ children }) => {
    const navigation = useNavigation();
    const { search } = useLocation();
    const _a = queryString.parse(search), { route } = _a, queryWithoutRouteParam = __rest(_a, ["route"]);
    const routeUrl = useMemo(() => {
        if (typeof route !== 'string') {
            return undefined;
        }
        let data;
        try {
            data = JSON.parse(route);
        }
        catch (_a) {
            return undefined;
        }
        const url = getExternalRouteUrl(data, navigation);
        if (url) {
            const parsedUrl = queryString.parseUrl(url);
            return queryString.stringifyUrl(Object.assign(Object.assign({}, parsedUrl), { query: Object.assign(Object.assign({}, queryWithoutRouteParam), parsedUrl.query) }));
        }
    }, [route, queryWithoutRouteParam, navigation]);
    if (routeUrl) {
        return React__default.createElement(Navigate, { to: routeUrl, replace: true });
    }
    else {
        return React__default.createElement(React__default.Fragment, null, children);
    }
};

function useModuleLogOutHookInvoker() {
    const logOut = useModuleLogOut();
    const user = useTypedSelector(selectCurrentUser);
    const navigation = useNavigation();
    const location = useLocation();
    const loginUrl = navigation.login(location);
    const moduleAuthRevokedStrategy = useModuleAuthRevokeStrategy();
    const [haveLoggedIn, setHaveLoggedIn] = useState(false);
    useEffect(() => {
        const defaultAuthRevokedStrategy = {
            logoutBackend: false,
            redirectUrl: loginUrl
        };
        const handleLogOut = () => __awaiter(this, void 0, void 0, function* () {
            if (user) {
                setHaveLoggedIn(true);
            }
            else {
                if (haveLoggedIn) {
                    const customAuthRevokedStrategy = yield moduleAuthRevokedStrategy();
                    const authRevokedStrategy = customAuthRevokedStrategy !== null && customAuthRevokedStrategy !== void 0 ? customAuthRevokedStrategy : defaultAuthRevokedStrategy;
                    logOut(authRevokedStrategy === null || authRevokedStrategy === void 0 ? void 0 : authRevokedStrategy.redirectUrl);
                }
                setHaveLoggedIn(false);
            }
        });
        handleLogOut();
    }, [user, haveLoggedIn, logOut, loginUrl, moduleAuthRevokedStrategy]);
}

function useStateTokens() {
    const { exception: strings } = useStrings();
    const dispatch = useTypedDispatch();
    const [getUserStateToken] = useLazyGetUserStateTokenQuery();
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const vin = vehicle && vehicle.ref === 'vin' ? vehicle.vin : undefined;
    const getStateToken = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        try {
            const stateToken = yield getUserStateToken({
                vin
            }).unwrap();
            return stateToken.stateToken;
        }
        catch (_a) {
            throw new Error('Unable to get state token.');
        }
    }), [getUserStateToken, vin]);
    const openWithStateToken = useCallback((href, options) => __awaiter(this, void 0, void 0, function* () {
        var _b;
        (_b = options === null || options === void 0 ? void 0 : options.event) === null || _b === void 0 ? void 0 : _b.preventDefault();
        const { url, query } = queryString.parseUrl(href);
        const loadingId = 'openWithStateToken';
        dispatch(showGlobalIndicator(loadingId));
        try {
            const href = queryString.stringifyUrl({
                url,
                query: Object.assign(Object.assign({}, query), { stateToken: yield getStateToken() })
            });
            if (options === null || options === void 0 ? void 0 : options.replace) {
                window.location.replace(href);
            }
            else {
                window.location.assign(href);
            }
        }
        catch (_c) {
            dispatch(queueNotification(strings.message));
        }
        finally {
            dispatch(hideGlobalIndicator(loadingId));
        }
    }), [dispatch, getStateToken, strings.message]);
    return useMemo(() => ({
        getStateToken,
        openWithStateToken,
        openLinkWithStateToken: event => openWithStateToken(event.currentTarget.href, {
            event: event.nativeEvent
        })
    }), [getStateToken, openWithStateToken]);
}

/**
 * Redirects to specified URL and includes state token.
 * Displays children if there was an error loading the state token.
 */
const StateTokenRedirect = ({ href, replace, children }) => {
    const { getStateToken } = useStateTokens();
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        function redirectWithStateToken() {
            return __awaiter(this, void 0, void 0, function* () {
                setIsError(false);
                try {
                    const { url, query } = queryString.parseUrl(href);
                    const hrefWithToken = queryString.stringifyUrl({
                        url,
                        query: Object.assign(Object.assign({}, query), { stateToken: yield getStateToken() })
                    });
                    if (replace) {
                        window.location.replace(hrefWithToken);
                    }
                    else {
                        window.location.assign(hrefWithToken);
                    }
                }
                catch (_a) {
                    setIsError(true);
                }
            });
        }
        redirectWithStateToken();
    }, [getStateToken, href, replace]);
    return isError ? React__default.createElement(React__default.Fragment, null, children) : null;
};

const baseContactPath = '/contact';
const createContactPath = '/contact/createForm';
/** Redirects to old look ITIS contact page and includes state token. */
const ContactRoute = () => {
    var _a;
    const { errors: strings } = useStrings();
    const { itisContactPage } = useContext();
    const user = (_a = useTypedSelector(selectCurrentUser)) !== null && _a !== void 0 ? _a : null;
    const { search } = useLocation();
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const vin = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.ref) === 'vin' ? vehicle.vin : undefined;
    const url = useMemo(() => {
        var _a;
        // Override default path with `create` query parameter.
        const query = queryString.parse(search);
        if (query.create === 'true') {
            return getItisUrl(createContactPath);
        }
        if (query.create === 'false') {
            return getItisUrl(baseContactPath);
        }
        const contactPath = (_a = itisContactPage === null || itisContactPage === void 0 ? void 0 : itisContactPage(user)) !== null && _a !== void 0 ? _a : createContactPath;
        return queryString.stringifyUrl({
            url: getItisUrl(contactPath),
            query: { vin }
        });
    }, [search, itisContactPage, user, vin]);
    return React__default.createElement(StateTokenRedirect, { href: url, replace: true },
        React__default.createElement(Screen, { errorText: strings.viewPage }));
};

const VehiclePopupContainer = () => {
    const vehicle = useTypedSelector(selectCurrentVehicle);
    const isFullScreen = useTypedSelector(selectIsFullScreen);
    const dispatch = useTypedDispatch();
    useEffect(() => {
        if (screenfull.isEnabled) {
            screenfull.on('change', () => {
                dispatch(changeIsFullScreen(screenfull.isFullscreen));
            });
        }
    }, [dispatch]);
    return (React__default.createElement("div", null, vehicle && !isFullScreen && React__default.createElement(React__default.Fragment, null,
        React__default.createElement(VehiclePopupToggle, null),
        React__default.createElement(VehiclePopupDialog, null))));
};

const PrivacyPolicyDialogue = ({ isOpen, onClose }) => {
    const { legal: strings, buttons: buttonStrings } = useStrings();
    const { data: termsContent, isError } = useGetLegalDocumentContentQuery('privacy');
    return React__default.createElement(Dialogue, { className: "PrivacyPolicyDialogue", isOpen: isOpen, onClose: onClose, ariaLabel: strings.privacyPolicy, hideBackdrop: true },
        React__default.createElement(Dialogue.Header, { title: strings.privacyPolicy, border: true }),
        React__default.createElement(Dialogue.Content, null, (() => {
            if (isError) {
                return React__default.createElement(CentredMessage, { title: strings.documentLoadError });
            }
            if (!termsContent) {
                return React__default.createElement(DocumentSkeleton, null);
            }
            return React__default.createElement(LegalDocumentView, null, termsContent);
        })()),
        React__default.createElement(Dialogue.Footer, { buttons: [
                React__default.createElement(Button$2, { key: "back", onClick: onClose }, buttonStrings.back)
            ], border: true }));
};

const TermsDialogue = ({ termsDocumentId, onAgreed }) => {
    const { legal: strings } = useStrings();
    const [showDisagreeConfirmation, setShowDisagreeConfirmation] = useState(false);
    const { data: termsContent, isLoading, error } = useGetLegalDocumentContentQuery('terms');
    const [setTermsAgreement, { isLoading: isSettingTermsAgreement }] = useSetTermsAgreementMutation();
    const errorMessage = useApiErrorMessage(strings.documentLoadError, error);
    const dispatch = useTypedDispatch();
    const [isPrivacyPolicyDialogueOpen, setIsPrivacyPolicyDialogueOpen] = useState(false);
    const termsAndConditions = useTickBox({
        id: 'termsAndConditions',
        value: false,
        label: strings.termsAgreeMessage,
        validators: [[isTruthy(), strings.termsApprovalRequired]]
    });
    const privacyPolicy = useTickBox({
        id: 'privacyPolicy',
        value: false,
        label: React__default.createElement(Text, { onLinkClick: event => {
                event.preventDefault();
                setIsPrivacyPolicyDialogueOpen(true);
            } }, strings.privacyAgreeMessage('/privacy')),
        validators: [[isTruthy(), strings.termsApprovalRequired]]
    });
    const form = useForm(termsAndConditions, privacyPolicy);
    function updateTerms(agreed) {
        return setTermsAgreement({
            documentId: termsDocumentId,
            agreed
        });
    }
    function getTermsView() {
        if (errorMessage) {
            return React__default.createElement(CentredMessage, { title: errorMessage });
        }
        else if (isLoading || !termsContent) {
            return React__default.createElement(DocumentSkeleton, null);
        }
        else {
            return React__default.createElement(LegalDocumentView, { className: "TermsDialogue-terms" }, termsContent);
        }
    }
    const buttons = [
        React__default.createElement(Button$2, { key: "disagree", onClick: () => setShowDisagreeConfirmation(true) }, strings.termsDisagreeButton),
        React__default.createElement(Button$2, { key: "agree", busy: isSettingTermsAgreement, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                if (form.validate()) {
                    yield updateTerms(true);
                    onAgreed();
                }
            }) }, strings.termsAgreeButton)
    ];
    return React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Dialogue, { className: "TermsDialogue", isOpen: true, ariaLabel: strings.termsAndConditions },
            React__default.createElement(Dialogue.Header, { title: strings.termsAndConditions, border: true }),
            React__default.createElement(Dialogue.Content, null,
                React__default.createElement("p", { className: "TermsDialogue-message" }, strings.termsChanged),
                getTermsView()),
            React__default.createElement(Dialogue.Footer, { buttons: buttons, border: true },
                React__default.createElement("div", { className: "TermsDialogue-form" },
                    termsAndConditions.input,
                    termsAndConditions.error && React__default.createElement("div", { className: "TermsDialogue-error" }, termsAndConditions.error),
                    privacyPolicy.input,
                    privacyPolicy.error && React__default.createElement("div", { className: "TermsDialogue-error" }, privacyPolicy.error)))),
        React__default.createElement(ConfirmDialogue, { isOpen: showDisagreeConfirmation, title: strings.disagreeConfirmTitle, confirmTitle: strings.disagreeConfirmButton, isDangerous: true, isBusy: isSettingTermsAgreement, onConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                yield updateTerms(false);
                dispatch(logOut());
            }), onCancel: () => setShowDisagreeConfirmation(false) }, strings.disagreeConfirmMessage),
        React__default.createElement(PrivacyPolicyDialogue, { isOpen: isPrivacyPolicyDialogueOpen, onClose: () => setIsPrivacyPolicyDialogueOpen(false) }));
};

const TERMS_REFETCH_INTERVAL = 30000;
const TERMS_AGREEMENT_REQUIRED_PARAMETER = 'terms-agreement-required';
/**
 * Component that checks whether the user has agreed to the Terms and Conditions.
 * Displays children if logged out or the user has agreed to the terms.
 * Displays terms dialogue if the user must agree to terms or there is a `terms-agreement-required=true` query parameter.
 * Displays error dialogue if an error occurred while checking whether the user has agreed to terms.
 *
 * @param props - Component props.
 */
const TermsCheck = ({ children }) => {
    const strings = useStrings();
    const dispatch = useTypedDispatch();
    const isLoggedIn = useTypedSelector(selectIsLoggedIn);
    const { isOnline } = useOnlineStatus();
    const { data: termsAgreement, isLoading, isError, error, refetch: refetchTermsAgreement } = useGetTermsAgreementQuery(undefined, {
        skip: !isLoggedIn,
        refetchOnFocus: true
    });
    useShowLoadingIndicator(isLoading);
    const location = useLocation();
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    const query = queryString.parse(search);
    const termsAgreementRequired = query[TERMS_AGREEMENT_REQUIRED_PARAMETER] === 'true';
    const isServiceUnavailable = error && 'status' in error && (error.status === 'FETCH_ERROR' || error.status === 503);
    // Recheck terms on navigation change.
    useThrottle(location.pathname, TERMS_REFETCH_INTERVAL, useCallback(() => {
        if (isLoggedIn && isOnline) {
            refetchTermsAgreement();
        }
    }, [isLoggedIn, isOnline, refetchTermsAgreement]));
    function handleTermsAgreed() {
        if (termsAgreementRequired) {
            // Redirect with query parameter removed.
            delete query[TERMS_AGREEMENT_REQUIRED_PARAMETER];
            navigate(queryString.stringifyUrl({
                url: pathname,
                query
            }), { replace: true });
        }
    }
    return React__default.createElement(React__default.Fragment, null,
        children,
        termsAgreement && !isError && (termsAgreementRequired || (isLoggedIn && !termsAgreement.agreed)) && React__default.createElement(TermsDialogue, { termsDocumentId: termsAgreement.documentId, onAgreed: handleTermsAgreed }),
        (!isServiceUnavailable && isError && !termsAgreement) && React__default.createElement(ConfirmDialogue, { isOpen: true, title: strings.legal.termsAndConditions, confirmTitle: strings.buttons.tryAgain, cancelTitle: strings.header.logOut, onConfirm: refetchTermsAgreement, onCancel: () => dispatch(logOut()) }, strings.legal.errorCheckingTerms));
};

const RELAY_STATE_PARAMETER = 'relay-state';
const RelayStateHandler = ({ children }) => {
    const moduleRelayState = useModuleRelayState();
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    const query = queryString.parse(search);
    const relayStateParameter = query[RELAY_STATE_PARAMETER];
    const relayState = typeof relayStateParameter === 'string' && relayStateParameter;
    const termsAgreementRequired = query[TERMS_AGREEMENT_REQUIRED_PARAMETER] === 'true';
    useShowLoadingIndicator(Boolean(relayState) && !termsAgreementRequired);
    useEffect(() => {
        // Do not process relay state while waiting for terms agreement.
        if (!relayState || termsAgreementRequired) {
            return;
        }
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const relayUrl = yield moduleRelayState(relayState);
            if (relayUrl) {
                if (relayUrl.startsWith('/')) {
                    // Remove any relay state parameter to prevent redirect loops.
                    navigate(removeRelayStateParameter(relayUrl), { replace: true });
                }
                else {
                    window.location.replace(relayUrl);
                }
            }
            else {
                // Redirect with relay state parameter removed.
                navigate(removeRelayStateParameter(pathname + search), { replace: true });
            }
        }))();
    }, [relayState, termsAgreementRequired, navigate, moduleRelayState, pathname, search]);
    if (relayState) {
        return null;
    }
    return React__default.createElement(React__default.Fragment, null, children);
};
function removeRelayStateParameter(url) {
    const { url: newUrl, query } = queryString.parseUrl(url);
    delete query[RELAY_STATE_PARAMETER];
    return queryString.stringifyUrl({
        url: newUrl,
        query
    });
}

const DocumentShareLinkUserSearch = ({ onSelectedUsersChange, selectedUsers }) => {
    const [searchString, setSearchString] = useState('');
    const strings = useStrings();
    const { data } = useGetUserSearchSuggestionQuery(searchString.length >= 3 ? searchString : queryExports.skipToken);
    const id = className$4('user-suggestion-autocomplete');
    return (React__default.createElement("div", { className: className$4() },
        React__default.createElement("label", { className: className$4('label'), htmlFor: id }, strings.documentShareLink.userSuggestionDescription),
        React__default.createElement(Autocomplete$1, { id: id, role: "combobox", "aria-label": strings.documentShareLink.usersAutocompleteLabel, multiple: true, disableClearable: true, value: selectedUsers, options: data || [], openText: strings.buttons.open, closeText: strings.buttons.close, onChange: (_event, _value, _reason, details) => details && onSelectedUsersChange(details.option), renderInput: params => (React__default.createElement(TextField$1, Object.assign({}, params, { InputProps: Object.assign(Object.assign({}, params.InputProps), { type: 'text', onChange: e => setSearchString(e.target.value) }) }))), renderTags: (_, getTagProps) => selectedUsers.map(({ applicabilityStatus, label }, index) => {
                const { key, onDelete } = getTagProps({ index });
                return (React__default.createElement("div", { key: key, className: classNames(className$4('tag'), {
                        [className$4('applicable')]: applicabilityStatus === 'applicable',
                        [className$4('notApplicable')]: applicabilityStatus === 'not-applicable',
                        [className$4('roleOrGroup')]: applicabilityStatus === 'roleOrGroup'
                    }) },
                    React__default.createElement("span", null, label),
                    React__default.createElement(FontAwesomeIcon, { onClick: onDelete, icon: faTimesExports.faTimes, fixedWidth: true })));
            }) })));
};
const className$4 = createClassName('DocumentShareLinkUserSearch');

var SubmitError;
(function (SubmitError) {
    SubmitError[SubmitError["noUsers"] = 0] = "noUsers";
    SubmitError[SubmitError["submitError"] = 1] = "submitError";
    SubmitError[SubmitError["userNotEligibleError"] = 2] = "userNotEligibleError";
})(SubmitError || (SubmitError = {}));
const DocumentShareLinkDialogue = () => {
    var _a, _b;
    const { buttons: buttonsStrings, document: documentStrings, documentShareLink: shareLinkStrings } = useStrings();
    const dispatch = useTypedDispatch();
    const shareLinkParams = useTypedSelector(selectShowShareLinkFormParams);
    const { data: document, isFetching, error } = useGetDocumentQuery(shareLinkParams ? {
        documentId: shareLinkParams.document.id,
        vehicle: shareLinkParams.vehicle
    } : queryExports.skipToken);
    const errorMessage = useApiErrorMessage(documentStrings.loadError, error);
    const user = useTypedSelector(selectCurrentUser);
    const [linkCopied, setLinkCopied] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [sendShareLink, { isLoading: isSending }] = useSendShareLinkMutation();
    const [applicabilityCheck] = useLazyApplicabilityCheckQuery();
    const [submitError, setSubmitError] = useState();
    const { getOnlineMessage } = useOnlineStatus();
    const getDeepLinkUrl = useDeepLinkUrlProvider();
    useShowLoadingIndicator(isFetching || isSending);
    const shareLinkField = useTextBox({
        id: 'share-link',
        value: document && shareLinkParams ? getDeepLinkUrl({
            sourceId: `"${document.sourceId}"`,
            procedure: (_a = shareLinkParams.procedure) !== null && _a !== void 0 ? _a : undefined,
            locale: document.language,
            vehicle: (_b = shareLinkParams.vehicle) !== null && _b !== void 0 ? _b : undefined,
            shareLinkSearch: true
        }) : '',
        validators: [[isNotEmpty(), shareLinkStrings.shareLinkEmptyError]],
        disabled: true,
        ariaLabel: shareLinkStrings.shareLinkField
    });
    const shareLinkMessageField = useTextArea({
        id: 'share-link-message',
        value: ''
    });
    const form = useForm(shareLinkField, shareLinkMessageField);
    useEffect(() => {
        if (!shareLinkParams) {
            form.reset();
        }
    }, [shareLinkParams, form]);
    const closeDialogue = useCallback(() => {
        dispatch(showDocumentShareLinkForm(null));
        setSelectedUsers([]);
    }, [dispatch]);
    useEffect(() => {
        if (!shareLinkParams) {
            return;
        }
        if (user === undefined) {
            dispatch(queueNotification(shareLinkStrings.logInRequired));
            closeDialogue();
        }
        else if (errorMessage) {
            dispatch(queueNotification(errorMessage));
            closeDialogue();
        }
    }, [shareLinkParams, user, dispatch, closeDialogue, shareLinkStrings.logInRequired, errorMessage]);
    if (!document) {
        return null;
    }
    const checkApplicability = (userId) => __awaiter(void 0, void 0, void 0, function* () {
        // skip check for roles and groups
        if (!userId.startsWith('U-')) {
            return 'roleOrGroup';
        }
        // Regex that removes all non numeric chars from string
        // as we receive the userId in U-123 format
        const userIdNumber = userId.replace(/[^0-9]/g, '');
        try {
            const { applicable } = yield applicabilityCheck({ documentId: document.id, userId: userIdNumber }).unwrap();
            if (applicable) {
                return 'applicable';
            }
            return 'not-applicable';
        }
        catch (err) {
            dispatch(queueNotification(getOnlineMessage(shareLinkStrings.applicableFetchError)));
        }
    });
    const onSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        if (!document) {
            return;
        }
        if (selectedUsers.some(user => user.applicabilityStatus === 'not-applicable')) {
            return setSubmitError(SubmitError.userNotEligibleError);
        }
        if (!selectedUsers || selectedUsers.length === 0) {
            return setSubmitError(SubmitError.noUsers);
        }
        try {
            const res = yield sendShareLink({
                sharedLink: shareLinkField.value,
                message: shareLinkMessageField.value,
                recipients: selectedUsers.map(user => user.value),
                documentId: document.id
            }).unwrap();
            if (res === null || res === void 0 ? void 0 : res.success) {
                dispatch(queueNotification(getOnlineMessage(shareLinkStrings.successMessage)));
                closeDialogue();
            }
        }
        catch (error) {
            setSubmitError(SubmitError.submitError);
        }
    });
    const copyLink = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield navigator.clipboard.writeText(shareLinkField.value);
            setLinkCopied(true);
            setTimeout(() => setLinkCopied(false), 3000);
        }
        catch (err) {
            dispatch(queueNotification(shareLinkStrings.copyLinkError));
        }
    });
    const onSelectedUsersChange = (user) => __awaiter(void 0, void 0, void 0, function* () {
        const isUserSelected = Boolean(selectedUsers.find(u => u.value === user.value));
        if (isUserSelected) {
            setSelectedUsers(selectedUsers.filter(u => u.value !== user.value));
        }
        else {
            const applicabilityStatus = yield checkApplicability(user.value);
            applicabilityStatus && setSelectedUsers([...selectedUsers, Object.assign(Object.assign({}, user), { applicabilityStatus })]);
        }
    });
    const buttons = [
        React__default.createElement(Button$2, { key: "cancel", onClick: closeDialogue }, buttonsStrings.close),
        React__default.createElement(Button$2, { key: "submit", type: "submit", disabled: isSending, busy: isSending }, buttonsStrings.send)
    ];
    return React__default.createElement(Dialogue, { isOpen: shareLinkParams !== null && !isFetching, onClose: closeDialogue, className: className$3() },
        React__default.createElement("form", { name: "shareLink", onSubmit: onSubmit },
            React__default.createElement(Dialogue.Header, { title: documentStrings.shareButton, border: true }),
            React__default.createElement(Dialogue.Content, null,
                React__default.createElement("p", null, shareLinkStrings.shareLinkDescription),
                React__default.createElement("div", { className: className$3('row') },
                    React__default.createElement(FormField, { input: shareLinkField }),
                    React__default.createElement(Button$2, { title: shareLinkStrings.copyLinkButton, onClick: () => copyLink(), className: classNames({ [className$3('copySuccess')]: linkCopied }) },
                        linkCopied ? shareLinkStrings.linkCopiedButton : shareLinkStrings.copyLinkButton,
                        linkCopied && React__default.createElement(FontAwesomeIcon, { icon: faCheckExports.faCheck, fixedWidth: true }))),
                React__default.createElement(DocumentShareLinkUserSearch, { onSelectedUsersChange: onSelectedUsersChange, selectedUsers: selectedUsers }),
                submitError === SubmitError.noUsers && React__default.createElement("p", { className: className$3('error') }, shareLinkStrings.noUsersMessage),
                submitError === SubmitError.userNotEligibleError && React__default.createElement("p", { className: className$3('error') }, shareLinkStrings.userNotEligibleError),
                React__default.createElement(FormField, { className: className$3('oneColumn'), input: shareLinkMessageField, label: shareLinkStrings.messageLabel })),
            React__default.createElement(Dialogue.Footer, { buttons: buttons, border: true }, submitError === SubmitError.submitError && React__default.createElement("p", { className: className$3('error') }, shareLinkStrings.submitError))));
};
const className$3 = createClassName('DocumentShareLinkDialogue');

function useModuleVehicleChangedHookInvoker() {
    const setNewVehicle = useModuleVehicleChanged();
    const currentVehicle = useTypedSelector(selectCurrentVehicle);
    const [tempVehicle, setTempVehicle] = useState(null);
    useEffect(() => {
        if (!currentVehicle && !tempVehicle || isSameVehicle(currentVehicle, tempVehicle)) {
            return;
        }
        setNewVehicle(currentVehicle);
        setTempVehicle(currentVehicle);
    }, [currentVehicle, tempVehicle, setNewVehicle]);
}

const ResolvedDocument = ({ document, isFullScreen, params }) => {
    const navigation = useNavigation();
    if (isFullScreen) {
        return React__default.createElement(DocumentLoader, { document: document, checkSubscription: true, nodeId: params.nid, videoId: params.vid, excludeDocumentTree: params.hideTree, fullscreen: isFullScreen }, (document) => React__default.createElement(DocumentRedirect, { document: document, hideTree: params.hideTree, format: params.format }));
    }
    return React__default.createElement(Navigate, { to: navigation.document(document, params), replace: true });
};
const DocumentRedirect = ({ document, hideTree, format }) => {
    const { document: strings } = useStrings();
    const viewUrl = useDocumentViewUrl(document, { hideTree, format });
    const documentUrl = viewUrl !== null && viewUrl !== void 0 ? viewUrl : getDocumentDownloadUrl(document);
    if (documentUrl) {
        window.location.replace(documentUrl);
        return null;
    }
    return React__default.createElement(CentredMessage, { title: strings.loadError });
};

const DocumentResolver = ({ sourceId, globalReference, reference, tags, isFullScreen = false, isInteractive = true, preCheck, preCheckFailedUrl, hideTree, procedureId, nodeId, videoId, format, vin, modelCode, modelYear, shareLinkSearch }) => {
    var _a, _b, _c;
    const strings = useStrings();
    const navigation = useNavigation();
    const locale = (_a = useTypedSelector(selectOverridingLocale)) !== null && _a !== void 0 ? _a : undefined;
    const query = (_b = sourceId !== null && sourceId !== void 0 ? sourceId : globalReference) !== null && _b !== void 0 ? _b : reference;
    const haveTags = Boolean(tags && tags.length > 0);
    const loggedIn = useTypedSelector(selectIsLoggedIn);
    // One of these must be set even if only searching by tags.
    const searchInSourceId = Boolean(sourceId || reference) || haveTags;
    const searchInGlobalReference = Boolean(globalReference || reference);
    const { data: productVariant, error: productVariantError } = useGetVehicleByCodeQuery(!vin && modelCode ? {
        code: modelCode,
        year: modelYear
    } : queryExports.skipToken);
    const vehicle = useMemo(() => {
        if (vin) {
            return getVinReference(vin);
        }
        if (productVariant) {
            return productVariant;
        }
        return null;
    }, [vin, productVariant]);
    const searchParams = (query || haveTags) ? {
        query,
        searchTitles: false,
        searchDescriptions: false,
        searchContents: false,
        inSourceId: searchInSourceId,
        inGlobalReferenceNumber: searchInGlobalReference,
        groupId: null,
        embargoed: 'show',
        locale,
        tags,
        shareLinkSearch
    } : undefined;
    const { data: searchResults, error: searchError } = useSearchDocumentsQuery(searchParams && (vehicle || (!vin && !modelCode)) ? Object.assign(Object.assign({}, searchParams), { preCheck,
        vehicle, pageNumber: 0, pageSize: 1, sortKey: 'title', sortDirection: 'ascending' }) : queryExports.skipToken);
    const searchErrorMessage = useApiErrorMessage(strings.documentSearch.searchError, searchError, {
        404: strings.vehicle.notFound
    });
    const productVariantErrorMessage = useApiErrorMessage(strings.vehicle.loadError, productVariantError, {
        404: strings.vehicle.notFound
    });
    if (!searchParams) {
        return React__default.createElement(CentredMessage, { title: strings.documentResolver.errorTitle, description: strings.documentResolver.missingQuery });
    }
    // Only one of sourceId, globalReference and reference may be specified.
    if ([sourceId, globalReference, reference].filter(value => value).length > 1) {
        return React__default.createElement(CentredMessage, { title: strings.documentResolver.errorTitle, description: strings.documentResolver.invalidQuery });
    }
    if (vin && modelCode) {
        return React__default.createElement(CentredMessage, { title: strings.documentResolver.errorTitle, description: strings.documentResolver.invalidVehicle });
    }
    if (productVariantErrorMessage) {
        return React__default.createElement(CentredMessage, { title: productVariantErrorMessage });
    }
    if (preCheck && isFetchBaseQueryError(searchError) && searchError.status === 401) {
        return React__default.createElement(Navigate, { to: loggedIn ? preCheckFailedUrl : navigation.login(preCheckFailedUrl), replace: true });
    }
    if (searchErrorMessage) {
        return React__default.createElement(CentredMessage, { title: searchErrorMessage });
    }
    if ((modelCode && !productVariant) || !searchResults) {
        return null;
    }
    if (searchResults.resultCount === 1) {
        const document = Object.assign(Object.assign({}, (_c = searchResults.elements[0].match) !== null && _c !== void 0 ? _c : searchResults.elements[0].translations[0]), { search: null });
        // Use fragment instead of `nid` parameter if there is a procedure ID or the document type is not Blaise.
        const fragment = nodeId && (procedureId || document.documentTypeContentType !== 'BLAISE')
            ? getProcedureFragment({
                uid: procedureId !== null && procedureId !== void 0 ? procedureId : '',
                nid: nodeId
            })
            : undefined;
        return React__default.createElement(ResolvedDocument, { document: document, isFullScreen: isFullScreen, params: {
                hideTree,
                nid: !fragment ? nodeId : undefined,
                vid: videoId,
                format,
                fragment
            } });
    }
    if (!isInteractive) {
        return React__default.createElement(CentredMessage, { title: strings.documentResolver.multipleDocuments });
    }
    return React__default.createElement(Navigate, { to: navigation.documentSearch(searchParams, vehicle), replace: true });
};

const DocumentResolverRoute = () => {
    var _a;
    const location = useLocation();
    const query = queryString.parse(location.search, { parseBooleans: true });
    const sourceId = getStringOrDefault(query.sourceId);
    const globalReference = getStringOrDefault(query.globalReferenceNumber);
    const reference = getStringOrDefault(query.reference);
    const tags = (_a = getStringOrDefault(query.tags)) === null || _a === void 0 ? void 0 : _a.split(',').filter(tag => tag !== '');
    const isFullScreen = getBooleanOrDefault(query.fullscreen);
    const isInteractive = getBooleanOrDefault(query.interactive, true);
    const hideTree = getBooleanOrDefault(query.excludeDocumentTree);
    const procedureId = getStringOrDefault(query.uid);
    const nodeId = getStringOrDefault(query.nid);
    const videoId = getStringOrDefault(query.vid);
    const format = getStringOrDefault(query.format);
    const vin = getStringOrDefault(query.vin);
    const modelCode = getStringOrDefault(query.modelCode);
    const modelYearString = getStringOrDefault(query.modelYear, '');
    const modelYear = isInt(modelYearString) ? toInt(modelYearString) : undefined;
    const preCheck = getBooleanOrDefault(query.preCheck, false);
    const shareLinkSearch = getBooleanOrDefault(query.shareLinkSearch, false);
    const preCheckFailedUrl = useMemo(() => {
        const _a = queryString.parse(location.search), queryWithoutPreCheck = __rest(_a, ["preCheck"]);
        return queryString.stringifyUrl({
            url: location.pathname,
            query: queryWithoutPreCheck
        });
    }, [location]);
    return React__default.createElement(Routes, null,
        React__default.createElement(Route, { path: "/", element: React__default.createElement(DocumentResolver, { sourceId: sourceId, globalReference: globalReference, reference: reference, tags: tags, isFullScreen: isFullScreen, isInteractive: isInteractive, preCheck: preCheck, preCheckFailedUrl: preCheckFailedUrl, hideTree: hideTree, procedureId: procedureId, nodeId: nodeId, videoId: videoId, format: format, vin: vin, modelCode: modelCode, modelYear: modelYear, shareLinkSearch: shareLinkSearch }) }));
};

const localeOverrideEnabledPaths = [
    /^\/search(\/.+|$)/,
    /^\/products\/.+\/search(\/.+|$)/,
    /^\/vehicles\/.+\/search(\/.+|$)/,
    /\/documents\/.+(\/.+|$)/,
    /^\/documents\/lookup(\/.+|$)/
];
/** Overrides the current locale for matching paths with one from a `locale` query parameter. */
function useLocaleOverride() {
    const languages = useSupportedBaseLanguages();
    const dispatch = useTypedDispatch();
    const overriddenLocale = useTypedSelector(selectOverriddenLocale);
    const location = useLocation();
    const query = queryString.parse(location.search);
    const localeParameter = normaliseLocaleCode(getStringOrDefault(query.locale, ''));
    const overrideEnabled = useMemo(() => localeOverrideEnabledPaths.some(path => {
        return path.test(location.pathname);
    }), [location.pathname]);
    const overridingLocale = useMemo(() => {
        if (!overrideEnabled || !localeParameter) {
            return null;
        }
        const languageCode = getPrimaryLanguageCode(localeParameter);
        const isSupportedLanguage = languages.some(language => language.code === languageCode);
        if (!isSupportedLanguage) {
            return null;
        }
        let countryCode = getOptionalLanguageCode(localeParameter);
        if (!i18nIsoCountriesExports.isValid(countryCode)) {
            if (i18nIsoCountriesExports.isValid(languageCode)) {
                countryCode = languageCode;
            }
            else {
                countryCode = getOptionalLanguageCode(overriddenLocale);
            }
        }
        return getLocaleCode(languageCode, countryCode);
    }, [overrideEnabled, localeParameter, languages, overriddenLocale]);
    // useLayoutEffect as locale needs to be overridden before rendering continues.
    useLayoutEffect(() => {
        if (overridingLocale) {
            dispatch(overrideLocale(overridingLocale));
            return () => {
                dispatch(restoreLocale());
            };
        }
    }, [overridingLocale, dispatch]);
}

/**
 * Redirects to old look when `redirectToOldLookWhenNewLookDisabled` is true
 * and both `NEW_LOOK` and `TRY_NEW_LOOK` feature toggles are disabled.
 */
const OldLookRedirect = ({ children }) => {
    const { redirectToOldLookWhenNewLookDisabled } = useContext();
    const featureToggles = useFeatureToggles({
        skip: !redirectToOldLookWhenNewLookDisabled,
        skipCache: true
    });
    const isTryNewLookEnabled = featureToggles.isFeatureToggleEnabled('TRY_NEW_LOOK');
    const isForceNewLookEnabled = featureToggles.isFeatureToggleEnabled('NEW_LOOK');
    const redirect = redirectToOldLookWhenNewLookDisabled && !featureToggles.isLoading && !isTryNewLookEnabled && !isForceNewLookEnabled;
    useEffect(() => {
        if (redirect) {
            sessionStorage.setItem(fromOldLookRedirectKey, 'true');
            window.location.replace(getOldLookUrl());
        }
        else {
            sessionStorage.removeItem(fromOldLookRedirectKey);
        }
    }, [redirect]);
    if (redirect || (redirectToOldLookWhenNewLookDisabled && featureToggles.isLoading)) {
        return null;
    }
    return React__default.createElement(React__default.Fragment, null, children);
};
function useIsFromOldLookRedirect() {
    const { redirectToOldLookWhenNewLookDisabled = false } = useContext();
    return redirectToOldLookWhenNewLookDisabled && sessionStorage.getItem(fromOldLookRedirectKey) !== null;
}
const fromOldLookRedirectKey = 'fromOldLookRedirect';

const propsToSkip = [
    'authSecret',
    'authClientId',
    'stringsLoader',
    'helpStringsLoader',
    'errorStrings',
    'sidebarLogo',
    'mobileSidebarLogo',
    'vehicleToggleIcon'
];
function filterPropsToShow(context, propsToSkip) {
    return Object.entries(context)
        .filter(entry => !propsToSkip.includes(entry[0]))
        .reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: value })), {});
}
function makeModulesPropsReadable(context) {
    const { modules } = context, rest = __rest(context, ["modules"]);
    return Object.assign(Object.assign({}, rest), { modules: modules === null || modules === void 0 ? void 0 : modules.map(module => module.id.toString()) });
}
const PropsInfo = ({ context }) => {
    const props = filterPropsToShow(context, propsToSkip);
    return React__default.createElement("div", { className: className$2() },
        React__default.createElement("div", { className: className$2('innerContainer') }, JSON.stringify(makeModulesPropsReadable(props), null, 4)));
};
const className$2 = createClassName('PropsInfo');

const DocumentAttachmentsListSkeleton = () => {
    return React__default.createElement(SkeletonContainer, null,
        React__default.createElement(Skeleton, { height: 50 }),
        React__default.createElement(Skeleton, { height: 50 }));
};

function getSize(element) {
    var _a, _b;
    return (_b = (_a = element.getElementsByTagName('Size')[0]) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : '';
}
function isFile(size) {
    return parseInt(size) > 0;
}
function processAttachment(element) {
    var _a;
    const size = getSize(element);
    const key = (_a = element.getElementsByTagName('Key')[0]) === null || _a === void 0 ? void 0 : _a.textContent;
    if (!isFile(size) || !key) {
        return;
    }
    const tokens = key.split('/');
    const fileName = tokens[tokens.length - 1];
    return fileName;
}
function parseAttachmentsFromXml(xml) {
    const xmlParser = new DOMParser();
    const attachments = [];
    if (xml) {
        const xmlDoc = xmlParser.parseFromString(xml, 'text/xml');
        const contents = xmlDoc.getElementsByTagName('Contents');
        for (let i = 0; i < contents.length; i++) {
            const attachment = processAttachment(contents[i]);
            attachment && attachments.push(attachment);
        }
    }
    return attachments;
}
function downloadFileFromBlob(name, blob) {
    const file = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = file;
    anchor.setAttribute('download', name);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}

function getAuthToken() {
    return 'Bearer ' + getAccessToken();
}
function useDownloadAttachment(document, baseS3Url) {
    const [isError, setIsError] = useState(false);
    const s3DownloadUrl = baseS3Url && document
        ? joinPath(baseS3Url, `${document.documentTypeId}/${document.sourceId}/${document.language}/`)
        : undefined;
    return {
        downloadAttachment: (key) => __awaiter(this, void 0, void 0, function* () {
            setIsError(false);
            try {
                const url = s3DownloadUrl + key;
                const response = yield fetch(url, { headers: { Authorization: getAuthToken() } });
                const blob = yield response.blob();
                blob && downloadFileFromBlob(key, blob);
            }
            catch (_a) {
                setIsError(true);
            }
        }),
        isError
    };
}
function useAttachments(document, baseS3Url) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const s3ListUrl = baseS3Url && document
        ? joinPath(baseS3Url, `?prefix=${document.documentTypeId}/${document.sourceId}/${document.language}/`)
        : undefined;
    function cleanup() {
        setData([]);
        setLoading(true);
        setError(false);
    }
    useEffect(() => {
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            if (!s3ListUrl) {
                return;
            }
            cleanup();
            try {
                const response = yield fetch(s3ListUrl, {
                    headers: {
                        'Authorization': getAuthToken()
                    }
                });
                if (!response.ok) {
                    setLoading(false);
                    setError(true);
                }
                else {
                    const data = yield response.text();
                    setData(parseAttachmentsFromXml(data));
                    setLoading(false);
                    setError(false);
                }
            }
            catch (error) {
                setLoading(false);
                setError(true);
            }
        });
        fetchData();
    }, [s3ListUrl, document]);
    return {
        data,
        loading,
        error
    };
}

const DocumentAttachmentsDialogue = () => {
    const strings = useStrings();
    const dispatch = useTypedDispatch();
    const closeDialogue = useCallback(() => dispatch(showDocumentAttachments(null)), [dispatch]);
    const { documentAttachmentsS3BucketUrl: baseS3Url } = useContext();
    const documentRef = useTypedSelector(selectShowDocumentAttachmentsDocument);
    const { data: document, isFetching: isDocumentFetching, error: documentError } = useGetDocumentQuery(documentRef ? { documentId: documentRef.id, vehicle: documentRef.vehicle } : queryExports.skipToken);
    const { data: attachments, loading: attachmentsLoading, error: attachmentsError } = useAttachments(document, baseS3Url);
    const { downloadAttachment, isError: downloadAttachmentError } = useDownloadAttachment(document, baseS3Url);
    useShowLoadingIndicator(isDocumentFetching);
    const documentErrorMessage = useApiErrorMessage(strings.document.loadError, documentError, {
        404: strings.document.notFound
    });
    useEffect(() => {
        if (documentErrorMessage) {
            closeDialogue();
            dispatch(queueNotification(documentErrorMessage));
        }
    }, [documentErrorMessage, closeDialogue, dispatch]);
    useEffect(() => {
        if (downloadAttachmentError) {
            dispatch(queueNotification(strings.documentAttachments.downloadError));
        }
    }, [dispatch, downloadAttachmentError, strings.documentAttachments.downloadError]);
    if (!baseS3Url) {
        return null;
    }
    return (React__default.createElement(Dialogue, { className: className$1(), isOpen: documentRef !== null && !isDocumentFetching, onClose: closeDialogue },
        React__default.createElement(Dialogue.Header, { title: strings.documentAttachments.title, onClose: closeDialogue }),
        React__default.createElement(Dialogue.Content, null,
            attachmentsLoading && (React__default.createElement(DocumentAttachmentsListSkeleton, null)),
            attachmentsError && (React__default.createElement("div", { className: className$1('message') }, strings.documentAttachments.loadError)),
            !attachmentsLoading && !attachmentsError && attachments.length === 0 ? (React__default.createElement("div", { className: className$1('message') }, strings.documentAttachments.noAttachments)) : (React__default.createElement("ul", null, attachments.map(key => (React__default.createElement("li", { key: key },
                React__default.createElement(LinkButton, { onClick: () => downloadAttachment(key) },
                    key,
                    React__default.createElement(FontAwesomeIcon, { icon: faDownloadExports.faDownload }))))))))));
};
const className$1 = createClassName('DocumentAttachmentsDialogue');

const ForceCountrySelectDialogue = () => {
    const strings = useStrings();
    const user = useTypedSelector(selectCurrentUser);
    const locale = useTypedSelector(selectLocale);
    const { value, options } = useCountries({});
    const dispatch = useTypedDispatch();
    const { getOnlineMessage } = useOnlineStatus();
    const [updateAddressCountry] = useUpdateAddressCountryMutation();
    function changeCountry(country) {
        return __awaiter(this, void 0, void 0, function* () {
            const newLocale = getLocaleCode(getPrimaryLanguageCode(locale), country);
            try {
                yield updateAddressCountry({ country }).unwrap();
                yield dispatch(updateLocale(newLocale)).unwrap();
                window.location.reload();
            }
            catch (e) {
                dispatch(queueNotification(getOnlineMessage(strings.language.errorChangingCountry)));
            }
        });
    }
    if (!(user === null || user === void 0 ? void 0 : user.addressCountryUpdate)) {
        return null;
    }
    return React__default.createElement(Dialogue, { className: className(), ariaLabel: strings.language.changeCountryTitle, isOpen: true },
        React__default.createElement(Dialogue.Header, { title: strings.language.changeCountryTitle }),
        React__default.createElement(Dialogue.Content, null,
            React__default.createElement("div", { className: className('content') },
                React__default.createElement(Panel, { variant: "info" },
                    React__default.createElement(Panel.Content, null, strings.misc.forceSelectingCountry)),
                React__default.createElement(Autocomplete$1, { options: options, value: value, isOptionEqualToValue: (option, value) => option.id === value.id, onChange: (_event, value) => changeCountry(value.id), renderInput: params => React__default.createElement(TextField$1, Object.assign({}, params)), disableClearable: true, openOnFocus: true, role: "combobox", "aria-label": strings.preferences.country.label, openText: strings.buttons.open, closeText: strings.buttons.close }))));
};
const className = createClassName('ForceCountrySelectDialogue');

function useEnableNewLookInOldLook() {
    const { isOnline } = useOnlineStatus();
    const toggles = useFeatureToggles();
    const isTryNewLookEnabled = toggles.isFeatureToggleEnabled('TRY_NEW_LOOK');
    const isForceNewLookEnabled = toggles.isFeatureToggleEnabled('NEW_LOOK');
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            if (isOnline && isTryNewLookEnabled && !isForceNewLookEnabled) {
                try {
                    // Ensure Old Look is in New Look style when the user is trying New Look.
                    yield fetch(getItisUrl('user/tryNewLook'), { credentials: 'include', redirect: 'manual' });
                }
                catch (_a) { } // eslint-disable-line no-empty
            }
        }))();
    }, [isOnline, isTryNewLookEnabled, isForceNewLookEnabled]);
}

const OfflineBanner = () => {
    const { app: strings } = useStrings();
    const { isOnline } = useOnlineStatus();
    if (isOnline) {
        return null;
    }
    return React__default.createElement("div", { className: "OfflineBanner" },
        React__default.createElement(FontAwesomeIcon, { icon: faUnlinkExports.faUnlink }),
        strings.offlineBanner);
};

try{self["workbox:window:7.2.0"]&&_();}catch(n){}function n(n,t){return new Promise((function(r){var e=new MessageChannel;e.port1.onmessage=function(n){r(n.data);},n.postMessage(t,[e.port2]);}))}function t(n){var t=function(n,t){if("object"!=typeof n||!n)return n;var r=n[Symbol.toPrimitive];if(void 0!==r){var e=r.call(n,t||"default");if("object"!=typeof e)return e;throw new TypeError("@@toPrimitive must return a primitive value.")}return ("string"===t?String:Number)(n)}(n,"string");return "symbol"==typeof t?t:t+""}function r(n,r){for(var e=0;e<r.length;e++){var i=r[e];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(n,t(i.key),i);}}function e(n,t){return e=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(n,t){return n.__proto__=t,n},e(n,t)}function i(n,t){(null==t||t>n.length)&&(t=n.length);for(var r=0,e=new Array(t);r<t;r++)e[r]=n[r];return e}function o(n,t){var r="undefined"!=typeof Symbol&&n[Symbol.iterator]||n["@@iterator"];if(r)return (r=r.call(n)).next.bind(r);if(Array.isArray(n)||(r=function(n,t){if(n){if("string"==typeof n)return i(n,t);var r=Object.prototype.toString.call(n).slice(8,-1);return "Object"===r&&n.constructor&&(r=n.constructor.name),"Map"===r||"Set"===r?Array.from(n):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?i(n,t):void 0}}(n))||t&&n&&"number"==typeof n.length){r&&(n=r);var e=0;return function(){return e>=n.length?{done:!0}:{done:!1,value:n[e++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}try{self["workbox:core:7.2.0"]&&_();}catch(n){}var u=function(){var n=this;this.promise=new Promise((function(t,r){n.resolve=t,n.reject=r;}));};function a(n,t){var r=location.href;return new URL(n,r).href===new URL(t,r).href}var c=function(n,t){this.type=n,Object.assign(this,t);};function f(n,t,r){return r?t?t(n):n:(n&&n.then||(n=Promise.resolve(n)),t?n.then(t):n)}function s(){}var v={type:"SKIP_WAITING"};function h(n,t){if(!t)return n&&n.then?n.then(s):Promise.resolve()}var l=function(t){function i(n,r){var e,i;return void 0===r&&(r={}),(e=t.call(this)||this).nn={},e.tn=0,e.rn=new u,e.en=new u,e.on=new u,e.un=0,e.an=new Set,e.cn=function(){var n=e.fn,t=n.installing;e.tn>0||!a(t.scriptURL,e.sn.toString())||performance.now()>e.un+6e4?(e.vn=t,n.removeEventListener("updatefound",e.cn)):(e.hn=t,e.an.add(t),e.rn.resolve(t)),++e.tn,t.addEventListener("statechange",e.ln);},e.ln=function(n){var t=e.fn,r=n.target,i=r.state,o=r===e.vn,u={sw:r,isExternal:o,originalEvent:n};!o&&e.mn&&(u.isUpdate=!0),e.dispatchEvent(new c(i,u)),"installed"===i?e.wn=self.setTimeout((function(){"installed"===i&&t.waiting===r&&e.dispatchEvent(new c("waiting",u));}),200):"activating"===i&&(clearTimeout(e.wn),o||e.en.resolve(r));},e.yn=function(n){var t=e.hn,r=t!==navigator.serviceWorker.controller;e.dispatchEvent(new c("controlling",{isExternal:r,originalEvent:n,sw:t,isUpdate:e.mn})),r||e.on.resolve(t);},e.gn=(i=function(n){var t=n.data,r=n.ports,i=n.source;return f(e.getSW(),(function(){e.an.has(i)&&e.dispatchEvent(new c("message",{data:t,originalEvent:n,ports:r,sw:i}));}))},function(){for(var n=[],t=0;t<arguments.length;t++)n[t]=arguments[t];try{return Promise.resolve(i.apply(this,n))}catch(n){return Promise.reject(n)}}),e.sn=n,e.nn=r,navigator.serviceWorker.addEventListener("message",e.gn),e}var o,s;s=t,(o=i).prototype=Object.create(s.prototype),o.prototype.constructor=o,e(o,s);var l,m,y=i.prototype;return y.register=function(n){var t=(void 0===n?{}:n).immediate,r=void 0!==t&&t;try{var e=this;return f(function(n,t){var r=n();if(r&&r.then)return r.then(t);return t(r)}((function(){if(!r&&"complete"!==document.readyState)return h(new Promise((function(n){return window.addEventListener("load",n)})))}),(function(){return e.mn=Boolean(navigator.serviceWorker.controller),e.dn=e.pn(),f(e.bn(),(function(n){e.fn=n,e.dn&&(e.hn=e.dn,e.en.resolve(e.dn),e.on.resolve(e.dn),e.dn.addEventListener("statechange",e.ln,{once:!0}));var t=e.fn.waiting;return t&&a(t.scriptURL,e.sn.toString())&&(e.hn=t,Promise.resolve().then((function(){e.dispatchEvent(new c("waiting",{sw:t,wasWaitingBeforeRegister:!0}));})).then((function(){}))),e.hn&&(e.rn.resolve(e.hn),e.an.add(e.hn)),e.fn.addEventListener("updatefound",e.cn),navigator.serviceWorker.addEventListener("controllerchange",e.yn),e.fn}))})))}catch(n){return Promise.reject(n)}},y.update=function(){try{return this.fn?f(h(this.fn.update())):f()}catch(n){return Promise.reject(n)}},y.getSW=function(){return void 0!==this.hn?Promise.resolve(this.hn):this.rn.promise},y.messageSW=function(t){try{return f(this.getSW(),(function(r){return n(r,t)}))}catch(n){return Promise.reject(n)}},y.messageSkipWaiting=function(){this.fn&&this.fn.waiting&&n(this.fn.waiting,v);},y.pn=function(){var n=navigator.serviceWorker.controller;return n&&a(n.scriptURL,this.sn.toString())?n:void 0},y.bn=function(){try{var n=this;return f(function(n,t){try{var r=n();}catch(n){return t(n)}if(r&&r.then)return r.then(void 0,t);return r}((function(){return f(navigator.serviceWorker.register(n.sn,n.nn),(function(t){return n.un=performance.now(),t}))}),(function(n){throw n})))}catch(n){return Promise.reject(n)}},l=i,(m=[{key:"active",get:function(){return this.en.promise}},{key:"controlling",get:function(){return this.on.promise}}])&&r(l.prototype,m),Object.defineProperty(l,"prototype",{writable:!1}),l}(function(){function n(){this.Pn=new Map;}var t=n.prototype;return t.addEventListener=function(n,t){this.jn(n).add(t);},t.removeEventListener=function(n,t){this.jn(n).delete(t);},t.dispatchEvent=function(n){n.target=this;for(var t,r=o(this.jn(n.type));!(t=r()).done;){(0, t.value)(n);}},t.jn=function(n){return this.Pn.has(n)||this.Pn.set(n,new Set),this.Pn.get(n)},n}());

const ServiceWorker = () => {
    const { app: strings } = useStrings();
    const { serviceWorkerPath } = useContext();
    const [updateState, setUpdateState] = useState();
    const onMobile = useOnMobile();
    const workbox = useMemo(() => {
        if ('serviceWorker' in navigator && serviceWorkerPath) {
            return new l(serviceWorkerPath);
        }
    }, [serviceWorkerPath]);
    useEffect(() => {
        if (!workbox) {
            return;
        }
        const activatedListener = () => {
            setUpdateState('activated');
        };
        const waitingListener = () => {
            workbox.addEventListener('controlling', controllingListener);
            setUpdateState('waiting');
        };
        const controllingListener = () => {
            window.location.reload();
        };
        workbox.addEventListener('activated', activatedListener);
        workbox.addEventListener('waiting', waitingListener);
        workbox.register();
        return () => {
            workbox.removeEventListener('activated', activatedListener);
            workbox.removeEventListener('waiting', waitingListener);
            workbox.removeEventListener('controlling', controllingListener);
        };
    }, [workbox]);
    function doReload() {
        if (updateState === 'activated') {
            window.location.reload();
        }
        else if (updateState === 'waiting') {
            workbox === null || workbox === void 0 ? void 0 : workbox.messageSkipWaiting();
        }
        setUpdateState(undefined);
    }
    return React__default.createElement(Snackbar$1, { open: updateState !== undefined, message: strings.updateAvailable, anchorOrigin: {
            vertical: 'bottom',
            horizontal: onMobile ? 'center' : 'right'
        }, action: React__default.createElement(Button$1, { color: "secondary", onClick: doReload }, strings.updateNow) });
};

const App = () => {
    const context = useContext();
    useModuleLogOutHookInvoker();
    useModuleVehicleChangedHookInvoker();
    useLocaleOverride();
    useEnableNewLookInOldLook();
    return React__default.createElement("div", { className: "App" },
        React__default.createElement(AuthRevokedListener, null),
        React__default.createElement(Notifier, null),
        React__default.createElement(HelpDialogue, null),
        React__default.createElement(ServiceWorker, null),
        React__default.createElement(Routes, null,
            React__default.createElement(Route, { path: "auth", element: React__default.createElement(CompleteLogin, null) }),
            React__default.createElement(Route, { path: "logout", element: React__default.createElement(LogOut, null) }),
            React__default.createElement(Route, { path: "contact", element: React__default.createElement(ContactRoute, null) }),
            isNonProdEnvironment(context.itisUrl) && React__default.createElement(Route, { path: "props-info", element: React__default.createElement(PropsInfo, { context: context }) }),
            React__default.createElement(Route, { path: "*", element: React__default.createElement(Init, null,
                    React__default.createElement(AutoLogin, { force: useIsFromOldLookRedirect() },
                        React__default.createElement(OldLookRedirect, null,
                            React__default.createElement(ExternalRouteHandler, null,
                                React__default.createElement(TermsCheck, null,
                                    React__default.createElement(RelayStateHandler, null,
                                        React__default.createElement(Routes, null,
                                            React__default.createElement(Route, { path: "documents/lookup/*", element: React__default.createElement(DocumentResolverRoute, null) }),
                                            React__default.createElement(Route, { path: "*", element: React__default.createElement(React__default.Fragment, null,
                                                    React__default.createElement(NoticeDialogue, null),
                                                    React__default.createElement(DocumentInfoDialogue, null),
                                                    React__default.createElement(DocumentAttachmentsDialogue, null),
                                                    React__default.createElement(DocumentShareLinkDialogue, null),
                                                    React__default.createElement(ForceCountrySelectDialogue, null),
                                                    React__default.createElement(UserStatusUpdater, null),
                                                    React__default.createElement(CookieNotificationView, null),
                                                    React__default.createElement(VehiclePopupContainer, null),
                                                    React__default.createElement("div", { className: "App-container" },
                                                        React__default.createElement(Sidebar, null),
                                                        React__default.createElement("div", { className: "App-content" },
                                                            React__default.createElement(BrowserWarningBanner, null),
                                                            React__default.createElement(OfflineBanner, null),
                                                            React__default.createElement(Header, null),
                                                            React__default.createElement(ScreenRouter, null)))) })))))))) })));
};

class ErrorBoundary extends React__default.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    // eslint-disable-next-line class-methods-use-this
    componentDidCatch(error, info) {
        var _a;
        (_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError(error, { componentStack: info.componentStack });
    }
    render() {
        return this.state.error !== null ?
            this.props.onError(this.state.error) :
            this.props.children;
    }
}

const formatTokenMap = {
  // Year
  y: {
    sectionType: 'year',
    contentType: 'digit',
    maxLength: 4
  },
  yy: 'year',
  yyyy: {
    sectionType: 'year',
    contentType: 'digit',
    maxLength: 4
  },
  // Month
  L: {
    sectionType: 'month',
    contentType: 'digit',
    maxLength: 2
  },
  LL: 'month',
  LLL: {
    sectionType: 'month',
    contentType: 'letter'
  },
  LLLL: {
    sectionType: 'month',
    contentType: 'letter'
  },
  M: {
    sectionType: 'month',
    contentType: 'digit',
    maxLength: 2
  },
  MM: 'month',
  MMM: {
    sectionType: 'month',
    contentType: 'letter'
  },
  MMMM: {
    sectionType: 'month',
    contentType: 'letter'
  },
  // Day of the month
  d: {
    sectionType: 'day',
    contentType: 'digit',
    maxLength: 2
  },
  dd: 'day',
  // Day of the week
  c: {
    sectionType: 'weekDay',
    contentType: 'digit',
    maxLength: 1
  },
  ccc: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  cccc: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  E: {
    sectionType: 'weekDay',
    contentType: 'digit',
    maxLength: 2
  },
  EEE: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  EEEE: {
    sectionType: 'weekDay',
    contentType: 'letter'
  },
  // Meridiem
  a: 'meridiem',
  // Hours
  H: {
    sectionType: 'hours',
    contentType: 'digit',
    maxLength: 2
  },
  HH: 'hours',
  h: {
    sectionType: 'hours',
    contentType: 'digit',
    maxLength: 2
  },
  hh: 'hours',
  // Minutes
  m: {
    sectionType: 'minutes',
    contentType: 'digit',
    maxLength: 2
  },
  mm: 'minutes',
  // Seconds
  s: {
    sectionType: 'seconds',
    contentType: 'digit',
    maxLength: 2
  },
  ss: 'seconds'
};
const defaultFormats = {
  year: 'yyyy',
  month: 'LLLL',
  monthShort: 'MMM',
  dayOfMonth: 'd',
  // Full day of the month format (i.e. 3rd) is not supported
  // Falling back to regular format
  dayOfMonthFull: 'd',
  weekday: 'cccc',
  weekdayShort: 'ccccc',
  hours24h: 'HH',
  hours12h: 'hh',
  meridiem: 'a',
  minutes: 'mm',
  seconds: 'ss',
  fullDate: 'DD',
  keyboardDate: 'D',
  shortDate: 'MMM d',
  normalDate: 'd MMMM',
  normalDateWithWeekday: 'EEE, MMM d',
  fullTime: 't',
  fullTime12h: 'hh:mm a',
  fullTime24h: 'HH:mm',
  keyboardDateTime: 'D t',
  keyboardDateTime12h: 'D hh:mm a',
  keyboardDateTime24h: 'D T'
};
/**
 * Based on `@date-io/luxon`
 *
 * MIT License
 *
 * Copyright (c) 2017 Dmitriy Kovalenko
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
class AdapterLuxon {
  constructor({
    locale,
    formats
  } = {}) {
    this.isMUIAdapter = true;
    this.isTimezoneCompatible = true;
    this.lib = 'luxon';
    this.locale = void 0;
    this.formats = void 0;
    this.escapedCharacters = {
      start: "'",
      end: "'"
    };
    this.formatTokenMap = formatTokenMap;
    this.setLocaleToValue = value => {
      const expectedLocale = this.getCurrentLocaleCode();
      if (expectedLocale === value.locale) {
        return value;
      }
      return value.setLocale(expectedLocale);
    };
    this.date = (value, timezone = 'default') => {
      if (value === null) {
        return null;
      }
      if (typeof value === 'undefined') {
        // @ts-ignore
        return DateTime.fromJSDate(new Date(), {
          locale: this.locale,
          zone: timezone
        });
      }

      // @ts-ignore
      return DateTime.fromISO(value, {
        locale: this.locale,
        zone: timezone
      });
    };
    this.getInvalidDate = () => DateTime.fromJSDate(new Date('Invalid Date'));
    this.getTimezone = value => {
      // When using the system zone, we want to return "system", not something like "Europe/Paris"
      if (value.zone.type === 'system') {
        return 'system';
      }
      return value.zoneName;
    };
    this.setTimezone = (value, timezone) => {
      if (!value.zone.equals(Info.normalizeZone(timezone))) {
        return value.setZone(timezone);
      }
      return value;
    };
    this.toJsDate = value => {
      return value.toJSDate();
    };
    this.parse = (value, formatString) => {
      if (value === '') {
        return null;
      }
      return DateTime.fromFormat(value, formatString, {
        locale: this.locale
      });
    };
    this.getCurrentLocaleCode = () => {
      return this.locale;
    };
    /* istanbul ignore next */
    this.is12HourCycleInCurrentLocale = () => {
      if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat === 'undefined') {
        return true; // Luxon defaults to en-US if Intl not found
      }
      return Boolean(new Intl.DateTimeFormat(this.locale, {
        hour: 'numeric'
      })?.resolvedOptions()?.hour12);
    };
    this.expandFormat = format => {
      // Extract escaped section to avoid extending them
      const catchEscapedSectionsRegexp = /''|'(''|[^'])+('|$)|[^']*/g;

      // This RegExp tests if a string is only mad of supported tokens
      const validTokens = [...Object.keys(this.formatTokenMap), 'yyyyy'];
      const isWordComposedOfTokens = new RegExp(`^(${validTokens.join('|')})+$`);

      // Extract words to test if they are a token or a word to escape.
      const catchWordsRegexp = /(?:^|[^a-z])([a-z]+)(?:[^a-z]|$)|([a-z]+)/gi;
      return format.match(catchEscapedSectionsRegexp).map(token => {
        const firstCharacter = token[0];
        if (firstCharacter === "'") {
          return token;
        }
        const expandedToken = DateTime.expandFormat(token, {
          locale: this.locale
        });
        return expandedToken.replace(catchWordsRegexp, (substring, g1, g2) => {
          const word = g1 || g2; // words are either in group 1 or group 2

          if (isWordComposedOfTokens.test(word)) {
            return substring;
          }
          return `'${substring}'`;
        });
      }).join('')
      // The returned format can contain `yyyyy` which means year between 4 and 6 digits.
      // This value is supported by luxon parser but not luxon formatter.
      // To avoid conflicts, we replace it by 4 digits which is enough for most use-cases.
      .replace('yyyyy', 'yyyy');
    };
    this.isValid = value => {
      if (value === null) {
        return false;
      }
      return value.isValid;
    };
    this.format = (value, formatKey) => {
      return this.formatByString(value, this.formats[formatKey]);
    };
    this.formatByString = (value, format) => {
      return value.setLocale(this.locale).toFormat(format);
    };
    this.formatNumber = numberToFormat => {
      return numberToFormat;
    };
    this.isEqual = (value, comparing) => {
      if (value === null && comparing === null) {
        return true;
      }
      if (value === null || comparing === null) {
        return false;
      }
      return +value === +comparing;
    };
    this.isSameYear = (value, comparing) => {
      const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
      return value.hasSame(comparingInValueTimezone, 'year');
    };
    this.isSameMonth = (value, comparing) => {
      const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
      return value.hasSame(comparingInValueTimezone, 'month');
    };
    this.isSameDay = (value, comparing) => {
      const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
      return value.hasSame(comparingInValueTimezone, 'day');
    };
    this.isSameHour = (value, comparing) => {
      const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
      return value.hasSame(comparingInValueTimezone, 'hour');
    };
    this.isAfter = (value, comparing) => {
      return value > comparing;
    };
    this.isAfterYear = (value, comparing) => {
      const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
      const diff = value.diff(this.endOfYear(comparingInValueTimezone), 'years').toObject();
      return diff.years > 0;
    };
    this.isAfterDay = (value, comparing) => {
      const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
      const diff = value.diff(this.endOfDay(comparingInValueTimezone), 'days').toObject();
      return diff.days > 0;
    };
    this.isBefore = (value, comparing) => {
      return value < comparing;
    };
    this.isBeforeYear = (value, comparing) => {
      const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
      const diff = value.diff(this.startOfYear(comparingInValueTimezone), 'years').toObject();
      return diff.years < 0;
    };
    this.isBeforeDay = (value, comparing) => {
      const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
      const diff = value.diff(this.startOfDay(comparingInValueTimezone), 'days').toObject();
      return diff.days < 0;
    };
    this.isWithinRange = (value, [start, end]) => {
      return this.isEqual(value, start) || this.isEqual(value, end) || this.isAfter(value, start) && this.isBefore(value, end);
    };
    this.startOfYear = value => {
      return value.startOf('year');
    };
    this.startOfMonth = value => {
      return value.startOf('month');
    };
    this.startOfWeek = value => {
      return this.setLocaleToValue(value).startOf('week', {
        useLocaleWeeks: true
      });
    };
    this.startOfDay = value => {
      return value.startOf('day');
    };
    this.endOfYear = value => {
      return value.endOf('year');
    };
    this.endOfMonth = value => {
      return value.endOf('month');
    };
    this.endOfWeek = value => {
      return this.setLocaleToValue(value).endOf('week', {
        useLocaleWeeks: true
      });
    };
    this.endOfDay = value => {
      return value.endOf('day');
    };
    this.addYears = (value, amount) => {
      return value.plus({
        years: amount
      });
    };
    this.addMonths = (value, amount) => {
      return value.plus({
        months: amount
      });
    };
    this.addWeeks = (value, amount) => {
      return value.plus({
        weeks: amount
      });
    };
    this.addDays = (value, amount) => {
      return value.plus({
        days: amount
      });
    };
    this.addHours = (value, amount) => {
      return value.plus({
        hours: amount
      });
    };
    this.addMinutes = (value, amount) => {
      return value.plus({
        minutes: amount
      });
    };
    this.addSeconds = (value, amount) => {
      return value.plus({
        seconds: amount
      });
    };
    this.getYear = value => {
      return value.get('year');
    };
    this.getMonth = value => {
      // See https://github.com/moment/luxon/blob/master/docs/moment.md#major-functional-differences
      return value.get('month') - 1;
    };
    this.getDate = value => {
      return value.get('day');
    };
    this.getHours = value => {
      return value.get('hour');
    };
    this.getMinutes = value => {
      return value.get('minute');
    };
    this.getSeconds = value => {
      return value.get('second');
    };
    this.getMilliseconds = value => {
      return value.get('millisecond');
    };
    this.setYear = (value, year) => {
      return value.set({
        year
      });
    };
    this.setMonth = (value, month) => {
      return value.set({
        month: month + 1
      });
    };
    this.setDate = (value, date) => {
      return value.set({
        day: date
      });
    };
    this.setHours = (value, hours) => {
      return value.set({
        hour: hours
      });
    };
    this.setMinutes = (value, minutes) => {
      return value.set({
        minute: minutes
      });
    };
    this.setSeconds = (value, seconds) => {
      return value.set({
        second: seconds
      });
    };
    this.setMilliseconds = (value, milliseconds) => {
      return value.set({
        millisecond: milliseconds
      });
    };
    this.getDaysInMonth = value => {
      return value.daysInMonth;
    };
    this.getWeekArray = value => {
      const firstDay = this.startOfWeek(this.startOfMonth(value));
      const lastDay = this.endOfWeek(this.endOfMonth(value));
      const {
        days
      } = lastDay.diff(firstDay, 'days').toObject();
      const weeks = [];
      new Array(Math.round(days)).fill(0).map((_, i) => i).map(day => firstDay.plus({
        days: day
      })).forEach((v, i) => {
        if (i === 0 || i % 7 === 0 && i > 6) {
          weeks.push([v]);
          return;
        }
        weeks[weeks.length - 1].push(v);
      });
      return weeks;
    };
    this.getWeekNumber = value => {
      /* istanbul ignore next */
      return value.localWeekNumber ?? value.weekNumber;
    };
    this.getDayOfWeek = value => {
      return value.weekday;
    };
    this.getYearRange = ([start, end]) => {
      const startDate = this.startOfYear(start);
      const endDate = this.endOfYear(end);
      const years = [];
      let current = startDate;
      while (this.isBefore(current, endDate)) {
        years.push(current);
        current = this.addYears(current, 1);
      }
      return years;
    };
    this.locale = locale || 'en-US';
    this.formats = _extends({}, defaultFormats, formats);
  }
}

const Mui = ({ children }) => {
    const { accentColour, accentTextColour } = useContext();
    const { documentFilter: strings } = useStrings();
    const locale = useTypedSelector(selectLocale);
    const theme = createTheme({
        palette: {
            primary: {
                main: accentColour
            },
            secondary: {
                main: accentTextColour
            }
        },
        components: {
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true
                }
            }
        }
    });
    return React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(LocalizationProvider, { dateAdapter: AdapterLuxon, adapterLocale: locale, localeText: {
                nextMonth: strings.nextMonth,
                previousMonth: strings.previousMonth,
                calendarViewSwitchingButtonAriaLabel(currentView) {
                    return currentView === 'year' ? strings.showCalendar : strings.showYears;
                }
            } }, children));
};

const ErrorDialogue = () => {
    const { basePath } = useContext();
    const { exception: strings } = useStrings();
    const buttons = [React__default.createElement("a", { key: "restart", href: basePath },
            React__default.createElement(Button$2, null, strings.restartButton))];
    return React__default.createElement(Dialogue, { isOpen: true },
        React__default.createElement(Dialogue.Header, { title: strings.title }),
        React__default.createElement(Dialogue.Content, null, strings.message),
        React__default.createElement(Dialogue.Footer, { buttons: buttons }));
};

const LoadingIndicator = () => {
    const { misc: strings } = useStrings();
    const show = useGlobalLoadingIndicator(config.loadingIndicatorDelay);
    const classes = classNames('LoadingIndicator', {
        'LoadingIndicator-visible': show
    });
    return React__default.createElement("div", { className: classes },
        React__default.createElement(LinearProgress$1, { "aria-label": strings.loading }));
};

const RETRY_INTERVAL = 10000;
const StringsErrorFallback = () => {
    const { basePath, errorStrings } = useContext();
    const dispatch = useTypedDispatch();
    const language = useCurrentLanguage();
    const strings = errorStrings[language.code];
    const reload = useCallback(() => {
        window.location.reload();
    }, []);
    function restart() {
        return __awaiter(this, void 0, void 0, function* () {
            yield dispatch(updateLocale(FALLBACK_LOCALE));
            window.location.replace(basePath);
        });
    }
    useEffect(() => {
        const timeout = setTimeout(reload, RETRY_INTERVAL);
        return () => {
            clearTimeout(timeout);
        };
    }, [reload]);
    return React__default.createElement(Centred, null,
        React__default.createElement("div", { dir: language.direction, "data-testid": "StringsErrorFallback" },
            React__default.createElement(FullScreenMessage, { title: strings.title, message: strings.message, buttons: [
                    React__default.createElement(Button$2, { key: "retry", onClick: reload }, strings.retry),
                    React__default.createElement(Button$2, { key: "restart", variant: "outlined", onClick: restart }, strings.restart)
                ] })));
};

function isActivityMessage(value) {
    return isObject(value) &&
        hasProperty(value, 'type') && value.type === 'activity' &&
        hasProperty(value, 'cause') && typeof value.cause === 'string';
}
const SessionExpiryUpdater = () => {
    const isEnabled = useFeatureToggles().isFeatureToggleEnabled('IWA_LOGOUT_ON_INACTIVITY');
    return isEnabled ? React__default.createElement(SessionExpiryUpdaterWorker, null) : null;
};
const SessionExpiryUpdaterWorker = () => {
    var _a;
    const user = useTypedSelector(selectCurrentUser);
    const dispatch = useTypedDispatch();
    const updateTimeout = useRef();
    const context = useContext();
    const inactivityMaxTime = (_a = context.inactivityMaxTime) !== null && _a !== void 0 ? _a : DEFAULT_SESSION_LENGTH_MILLIS;
    const debouncedUpdateSessionExpiry = useCallback(() => {
        clearTimeout(updateTimeout.current);
        updateTimeout.current = window.setTimeout(() => updateSessionExpiry(inactivityMaxTime), 2000);
    }, [inactivityMaxTime]);
    const checkForActivityMessageEvent = useCallback(({ data }) => {
        if (isActivityMessage(data)) {
            debouncedUpdateSessionExpiry();
        }
    }, [debouncedUpdateSessionExpiry]);
    useEffect(() => {
        if (user) {
            debouncedUpdateSessionExpiry();
        }
        else {
            clearTimeout(updateTimeout.current);
        }
        return () => {
            clearTimeout(updateTimeout.current);
        };
    }, [user, debouncedUpdateSessionExpiry]);
    // Update session expiry on navigation change.
    useNavigationChangeListener(() => {
        if (user) {
            debouncedUpdateSessionExpiry();
        }
    });
    // Update session expiry on page interaction.
    useEffect(() => {
        if (!user) {
            return;
        }
        document.addEventListener('mousedown', debouncedUpdateSessionExpiry);
        document.addEventListener('keydown', debouncedUpdateSessionExpiry);
        document.addEventListener('touchstart', debouncedUpdateSessionExpiry);
        window.addEventListener('message', checkForActivityMessageEvent);
        return () => {
            document.removeEventListener('mousedown', debouncedUpdateSessionExpiry);
            document.removeEventListener('keydown', debouncedUpdateSessionExpiry);
            document.removeEventListener('touchstart', debouncedUpdateSessionExpiry);
            window.removeEventListener('message', checkForActivityMessageEvent);
        };
    }, [user, debouncedUpdateSessionExpiry, checkForActivityMessageEvent]);
    // Check for session expiry.
    useEffect(() => {
        if (!user) {
            return;
        }
        const timeout = setInterval(() => {
            if (hasSessionExpired()) {
                dispatch(revokeAuth());
            }
        }, SESSION_EXPIRY_CHECK_MILLIS);
        return () => {
            clearInterval(timeout);
        };
    }, [user, dispatch]);
    return null;
};

/**
 * Wraps a component with core dependencies.
 *
 * @param props - Component props.
 */
const ItisDependencies = ({ itisProps, children }) => {
    useEffect(() => {
        Properties.initialise({
            apiUrl: itisProps.apiUrl,
            itisUrl: itisProps.itisUrl
        });
    }, [itisProps]);
    return React__default.createElement(ItisContextProvider, { itisProps: itisProps }, context => React__default.createElement(Provider, { store: createStore(context) },
        React__default.createElement(ErrorBoundary, { onError: error => React__default.createElement(StringsErrorFallback, { error: error }) },
            React__default.createElement(StringsProvider, null,
                React__default.createElement(Mui, null,
                    React__default.createElement(BrowserRouter, { basename: context.basePath },
                        React__default.createElement(ErrorBoundary, { onError: error => React__default.createElement(ErrorDialogue, { error: error }) },
                            React__default.createElement(ExternalContextProvider, null,
                                React__default.createElement(SessionExpiryUpdater, null),
                                React__default.createElement(LoadingIndicator, null),
                                children))))))));
};

/**
 * Root component for production builds.
 *
 * @param props - Core props.
 */
const Itis = props => {
    return React__default.createElement(ItisDependencies, { itisProps: props },
        React__default.createElement(App, null));
};

function createIwa() {
    return Itis;
}

export { Badge, Button$2 as Button, ButtonLink, ConfirmDialogue, ContentHeader, DateText, DefinitionList, Dialogue, Expander, HtmlView, IconButton$2 as IconButton, Link$1 as Link, LinkButton, MobileTableCell, Pagination, Panel, PanelGrid, Screen, Select, Table, Text, TickBox, createIwa, useElementWidth, useLanguageNames, usePaginator };
